/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/apps/christmas-car-crashes/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 214);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(221);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(237)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_1__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_2__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_3__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_4__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_point__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_6__src_point__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_select__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_7__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selectAll__ = __webpack_require__(323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_8__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selection_index__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selector__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selectorAll__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selection_style__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touch__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_13__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touches__ = __webpack_require__(325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_window__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_15__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_selection_on__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_16__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_16__src_selection_on__["a"]; });



















/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkContext = exports.Mark = exports.DraggableMark = undefined;

var _Mark = __webpack_require__(148);

var _Mark2 = _interopRequireDefault(_Mark);

var _DraggableMark = __webpack_require__(424);

var _DraggableMark2 = _interopRequireDefault(_DraggableMark);

var _MarkContext = __webpack_require__(425);

var _MarkContext2 = _interopRequireDefault(_MarkContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  DraggableMark: _DraggableMark2.default,
  Mark: _Mark2.default,
  MarkContext: _MarkContext2.default
};
exports.DraggableMark = _DraggableMark2.default;
exports.Mark = _Mark2.default;
exports.MarkContext = _MarkContext2.default;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arcBuilder = exports.pathBuilder = exports.lineBuilder = undefined;

var _d3Shape = __webpack_require__(7);

var lineBuilder = exports.lineBuilder = function lineBuilder(_ref) {
  var data = _ref.data,
      _ref$curve = _ref.curve,
      curve = _ref$curve === undefined ? _d3Shape.curveLinear : _ref$curve,
      canvasContext = _ref.canvasContext,
      className = _ref.className,
      classID = _ref.classID;

  var lineGen = (0, _d3Shape.line)().curve(curve);

  var builder = {
    type: "path",
    className: className,
    classID: classID,
    data: data
  };

  if (canvasContext) {
    lineGen.context(canvasContext);
    builder.pathMethods = lineGen;
  } else {
    builder.attrs = {
      d: lineGen(data)
    };
  }

  return builder;
};

var pathBuilder = exports.pathBuilder = function pathBuilder(_ref2) {
  var d = _ref2.d,
      _ref2$curve = _ref2.curve,
      curve = _ref2$curve === undefined ? _d3Shape.curveLinear : _ref2$curve,
      canvasContext = _ref2.canvasContext,
      className = _ref2.className,
      classID = _ref2.classID;

  var lineGen = (0, _d3Shape.line)().curve(curve);

  var builder = {
    type: "path",
    className: className,
    classID: classID
  };

  if (canvasContext) {
    lineGen.context(canvasContext);
  } else {
    builder.attrs = {
      d: d
    };
  }

  return builder;
};

var arcBuilder = exports.arcBuilder = function arcBuilder(_ref3) {
  var data = _ref3.data,
      canvasContext = _ref3.canvasContext,
      className = _ref3.className,
      classID = _ref3.classID;

  var builder = {
    type: "path",
    className: className,
    classID: classID,
    data: data
  };

  var arcShape = (0, _d3Shape.arc)().innerRadius(data.innerRadius || 0).outerRadius(data.outerRadius || data.radius || 2).startAngle(data.startAngle || 0).endAngle(data.endAngle || 2 * Math.PI);

  if (canvasContext) {
    arcShape.context(canvasContext);
  } else {
    builder.attrs = {
      d: arcShape()
    };
  }

  return builder;
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(322);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(79);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(160);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(84);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(158);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(161);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(162);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(339);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(340);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(341);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(342);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(343);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(344);
/* unused harmony reexport quantize */



















/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return params.filter(function (d) {
    return d;
  }).join(" ").trim();
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* harmony export (immutable) */ __webpack_exports__["b"] = transition;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(51);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var style = props.style,
      className = props.className,
      children = props.children;

  if (props.span) return _react2.default.createElement(
    "span",
    { className: className, style: _extends({ display: "block" }, style) },
    children
  );

  return _react2.default.createElement(
    "div",
    { className: className, style: style },
    children
  );
};

module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AnnotationLabel = __webpack_require__(116);

var _AnnotationLabel2 = _interopRequireDefault(_AnnotationLabel);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SemioticAnnotation = function (_React$Component) {
  _inherits(SemioticAnnotation, _React$Component);

  function SemioticAnnotation() {
    _classCallCheck(this, SemioticAnnotation);

    return _possibleConstructorReturn(this, (SemioticAnnotation.__proto__ || Object.getPrototypeOf(SemioticAnnotation)).apply(this, arguments));
  }

  _createClass(SemioticAnnotation, [{
    key: "render",
    value: function render() {
      var noteData = this.props.noteData;
      var screenCoordinates = noteData.screenCoordinates;


      noteData.type = typeof noteData.type === "function" ? noteData.type : _AnnotationLabel2.default;

      var eventListeners = noteData.eventListeners || {};

      if (noteData.coordinates && screenCoordinates) {
        //Multisubject annotation
        var setNX = noteData.nx || screenCoordinates[0][0] + noteData.dx;
        var setNY = noteData.ny || screenCoordinates[0][1] + noteData.dy;
        var notes = screenCoordinates.map(function (d, i) {
          var subjectNote = _extends({}, noteData, {
            note: i === 0 ? noteData.note : { label: "" },
            x: d[0],
            y: d[1],
            nx: setNX,
            ny: setNY
          });

          return _react2.default.createElement(noteData.type, _extends({ key: "multi-annotation-" + i }, subjectNote));
        });

        return _react2.default.createElement(
          "g",
          { events: eventListeners },
          notes
        );
      }

      return _react2.default.createElement(noteData.type, _extends({ events: eventListeners }, noteData));
    }
  }]);

  return SemioticAnnotation;
}(_react2.default.Component);

SemioticAnnotation.propTypes = {
  noteData: _propTypes2.default.object
};

exports.default = SemioticAnnotation;
module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props, Connector) {
  var NoteDefaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Subject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Subject2.default;
  var SubjectDefaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var NoteType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _Note2.default;
  var _props$disable = props.disable,
      disable = _props$disable === undefined ? [] : _props$disable,
      connector = props.connector,
      note = props.note,
      subject = props.subject,
      x = props.x,
      y = props.y,
      dx = props.dx,
      dy = props.dy,
      nx = props.nx,
      ny = props.ny,
      color = props.color,
      className = props.className,
      onDrag = props.onDrag,
      onDragStart = props.onDragStart,
      onDragEnd = props.onDragEnd,
      editMode = props.editMode,
      events = props.events;

  var CONNECTORS = {
    type: {
      curve: _ConnectorCurve2.default,
      line: _ConnectorLine2.default,
      elbow: _ConnectorElbow2.default
    },
    end: {
      dot: _ConnectorEndDot2.default,
      arrow: _ConnectorEndArrow2.default
    }
  };

  var ConnectorType = void 0,
      ConnectorEndType = void 0;
  if (disable.indexOf("connector") === -1) {
    ConnectorType = connector && CONNECTORS.type[connector.type] || Connector;
    ConnectorEndType = connector && CONNECTORS.end[connector.end];
  }

  var AnnotationType = getAnnotationType(props.editMode);
  return _react2.default.createElement(
    AnnotationType,
    _extends({
      x: x,
      y: y,
      dx: dx,
      dy: dy,
      nx: nx,
      ny: ny,
      color: color,
      className: className,
      onDrag: onDrag,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      editMode: editMode
    }, SubjectDefaultProps, subject, {
      events: events
    }),
    ConnectorType && _react2.default.createElement(
      ConnectorType,
      connector,
      ConnectorEndType && _react2.default.createElement(ConnectorEndType, null)
    ),
    Subject && disable.indexOf("subject") === -1 && _react2.default.createElement(Subject, null),
    note && disable.indexOf("note") === -1 && _react2.default.createElement(NoteType, _extends({}, NoteDefaultProps, note))
  );
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(117);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _EditableAnnotation = __webpack_require__(239);

var _EditableAnnotation2 = _interopRequireDefault(_EditableAnnotation);

var _ConnectorLine = __webpack_require__(64);

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

var _ConnectorElbow = __webpack_require__(45);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _ConnectorCurve = __webpack_require__(266);

var _ConnectorCurve2 = _interopRequireDefault(_ConnectorCurve);

var _ConnectorEndDot = __webpack_require__(268);

var _ConnectorEndDot2 = _interopRequireDefault(_ConnectorEndDot);

var _ConnectorEndArrow = __webpack_require__(270);

var _ConnectorEndArrow2 = _interopRequireDefault(_ConnectorEndArrow);

var _Subject = __webpack_require__(28);

var _Subject2 = _interopRequireDefault(_Subject);

var _Note = __webpack_require__(135);

var _Note2 = _interopRequireDefault(_Note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAnnotationType = function getAnnotationType(editMode) {
  return editMode ? _EditableAnnotation2.default : _Annotation2.default;
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Handle = __webpack_require__(134);

var _Handle2 = _interopRequireDefault(_Handle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Subject = function (_React$Component) {
  _inherits(Subject, _React$Component);

  function Subject() {
    _classCallCheck(this, Subject);

    return _possibleConstructorReturn(this, (Subject.__proto__ || Object.getPrototypeOf(Subject)).apply(this, arguments));
  }

  _createClass(Subject, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          editMode = _props.editMode,
          color = _props.color;


      var d = this.getComponents(this.props) || {};

      var handles = void 0;
      if (editMode) {
        handles = [_react2.default.createElement(_Handle2.default, {
          key: "subject-handle",
          handleStart: this.props.dragStart,
          handleStop: this.props.dragEnd,
          handleDrag: this.props.dragSubject
        })];

        if (d.handles) {
          handles = handles.concat(d.handles.map(function (h, i) {
            return _react2.default.createElement(_Handle2.default, {
              key: "subjecthandle-" + i,
              handleStart: _this2.props.dragStart,
              handleStop: _this2.props.dragEnd,
              x: h.x,
              y: h.y,
              offsetParent: h.offsetParent && _this2.subject,
              handleDrag: function handleDrag(e, data) {
                _this2.props.dragSubjectSettings(e, d.handleFunction(h, data));
              }
            });
          }));
        }
      }

      return _react2.default.createElement(
        "g",
        _extends({
          className: "annotation-subject"
        }, this.props.gAttrs, {
          ref: function ref(subject) {
            _this2.subject = subject;
          }
        }),
        d.components && d.components.map(function (c, i) {
          var attrs = {};
          if (!c) return null;
          Object.keys(c.attrs).forEach(function (k) {
            if (c.attrs[k] && k !== "text") {
              attrs[k.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              })] = c.attrs[k];
            }
          });
          return _react2.default.createElement(
            c.type,
            _extends({
              key: i,
              className: c.className,
              fill: "none",
              stroke: color
            }, attrs),
            c.attrs.text
          );
        }),
        handles
      );
    }
  }]);

  return Subject;
}(_react2.default.Component);

exports.default = Subject;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(159);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(380);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// components

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Scale = __webpack_require__(18);

var _axis = __webpack_require__(90);

var _Axis = __webpack_require__(54);

var _Axis2 = _interopRequireDefault(_Axis);

var _DownloadButton = __webpack_require__(91);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _Frame = __webpack_require__(92);

var _Frame2 = _interopRequireDefault(_Frame);

var _xyframeRules = __webpack_require__(463);

var _general = __webpack_require__(491);

var _lineDrawing = __webpack_require__(46);

var _AnnotationCallout = __webpack_require__(492);

var _AnnotationCallout2 = _interopRequireDefault(_AnnotationCallout);

var _frameFunctions = __webpack_require__(36);

var _downloadDataMapping = __webpack_require__(102);

var _coordinateNames = __webpack_require__(199);

var _dataFunctions = __webpack_require__(58);

var _jsx = __webpack_require__(103);

var _frame_props = __webpack_require__(104);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var naturalLanguageLineType = {
  line: { items: "line", chart: "line chart" },
  stackedarea: { items: "stacked area", chart: "stacked area chart" },
  bumparea: { items: "ranked area", chart: "ranked area chart" },
  bumpline: { items: "ranked line", chart: "ranked line chart" }
};

var emptyObjectReturnFunction = function emptyObjectReturnFunction() {
  return {};
};
var emptyStringReturnFunction = function emptyStringReturnFunction() {
  return "";
};

var xyframeKey = "";
var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
for (var i = 32; i > 0; --i) {
  xyframeKey += chars[Math.floor(Math.random() * chars.length)];
}var xyframeSettings = ["margin"];

var projectedCoordinateNames = {
  y: _coordinateNames.projectedY,
  x: _coordinateNames.projectedX,
  yMiddle: _coordinateNames.projectedYMiddle,
  yTop: _coordinateNames.projectedYTop,
  yBottom: _coordinateNames.projectedYBottom
};

function mapParentsToPoints(fullDataset) {
  return fullDataset.map(function (d) {
    if (d.parentLine) {
      return _extends({}, d.parentLine, d);
    }
    if (d.parentArea) {
      return _extends({}, d.parentArea, d);
    }
    return d;
  });
}

var XYFrame = (_temp = _class = function (_React$Component) {
  _inherits(XYFrame, _React$Component);

  function XYFrame(props) {
    _classCallCheck(this, XYFrame);

    var _this = _possibleConstructorReturn(this, (XYFrame.__proto__ || Object.getPrototypeOf(XYFrame)).call(this, props));

    _this.calculateXYFrame = _this.calculateXYFrame.bind(_this);

    _this.state = {
      lineData: null,
      pointData: null,
      areaData: null,
      projectedLines: null,
      projectedPoints: null,
      projectedAreas: null,
      fullDataset: null,
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      axesData: null,
      axes: null,
      renderNumber: 0,
      margin: { top: 0, bottom: 0, left: 0, right: 0 }
    };

    _this.xAccessor = null;
    _this.yAccessor = null;
    _this.xScale = null;
    _this.yScale = null;

    _this.settingsMap = new Map();
    xyframeSettings.forEach(function (d) {
      _this.settingsMap.set(d, new Map());
    });
    return _this;
  }

  _createClass(XYFrame, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object.keys(this.props).forEach(function (d) {
        if (!_frame_props.xyframeproptypes[d]) {
          if (_frame_props.ordinalframeproptypes[d]) {
            console.error(d + " is an OrdinalFrame prop are you sure you're using the right frame?");
          } else if (_frame_props.networkframeproptypes[d]) {
            console.error(d + " is a NetworkFrame prop are you sure you're using the right frame?");
          } else {
            console.error(d + " is not a valid XYFrame prop");
          }
        }
      });
      this.calculateXYFrame(this.props, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.fullDataset) {
        this.calculateXYFrame(nextProps, true);
      } else if (this.state.size[0] !== nextProps.size[0] || this.state.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.xyFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        var dataChanged = _frame_props.xyFrameDataProps.find(function (d) {
          return _this2.props[d] !== nextProps[d];
        });

        this.calculateXYFrame(nextProps, dataChanged);
      }
    }
  }, {
    key: "screenScales",
    value: function screenScales(_ref) {
      var xExtent = _ref.xExtent,
          yExtent = _ref.yExtent,
          adjustedSize = _ref.adjustedSize,
          xScaleType = _ref.xScaleType,
          yScaleType = _ref.yScaleType;

      var xDomain = [0, adjustedSize[0]];
      var yDomain = [adjustedSize[1], 0];

      var xScale = xScaleType;
      var yScale = yScaleType;

      if (xScaleType.domain) {
        xScaleType.domain(xExtent);
      }
      if (yScaleType.domain) {
        yScaleType.domain(yExtent);
      }
      xScaleType.range(xDomain);
      yScaleType.range(yDomain);

      return { xScale: xScale, yScale: yScale };
    }
  }, {
    key: "calculateXYFrame",
    value: function calculateXYFrame(currentProps, updateData) {
      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var legend = currentProps.legend,
          lines = currentProps.lines,
          lineClass = currentProps.lineClass,
          pointStyle = currentProps.pointStyle,
          pointRenderMode = currentProps.pointRenderMode,
          pointClass = currentProps.pointClass,
          areaClass = currentProps.areaClass,
          canvasLines = currentProps.canvasLines,
          canvasPoints = currentProps.canvasPoints,
          canvasAreas = currentProps.canvasAreas,
          defined = currentProps.defined,
          size = currentProps.size,
          renderKey = currentProps.renderKey,
          lineType = currentProps.lineType,
          customLineMark = currentProps.customLineMark,
          customPointMark = currentProps.customPointMark,
          customAreaMark = currentProps.customAreaMark,
          areaStyle = currentProps.areaStyle,
          areaRenderMode = currentProps.areaRenderMode,
          lineStyle = currentProps.lineStyle,
          lineRenderMode = currentProps.lineRenderMode,
          baseXExtent = currentProps.xExtent,
          baseYExtent = currentProps.yExtent,
          title = currentProps.title,
          _currentProps$xScaleT = currentProps.xScaleType,
          xScaleType = _currentProps$xScaleT === undefined ? (0, _d3Scale.scaleLinear)() : _currentProps$xScaleT,
          _currentProps$yScaleT = currentProps.yScaleType,
          yScaleType = _currentProps$yScaleT === undefined ? (0, _d3Scale.scaleLinear)() : _currentProps$yScaleT;
      var projectedLines = currentProps.projectedLines,
          projectedPoints = currentProps.projectedPoints,
          projectedAreas = currentProps.projectedAreas,
          fullDataset = currentProps.fullDataset;


      var xExtentSettings = baseXExtent === undefined || Array.isArray(baseXExtent) ? { extent: baseXExtent } : baseXExtent;
      var yExtentSettings = baseYExtent === undefined || Array.isArray(baseYExtent) ? { extent: baseYExtent } : baseYExtent;

      var xExtent = xExtentSettings.extent;
      var yExtent = yExtentSettings.extent;

      var calculatedXExtent = void 0,
          calculatedYExtent = void 0;

      var xAccessor = (0, _dataFunctions.stringToFn)(currentProps.xAccessor);
      var yAccessor = (0, _dataFunctions.stringToFn)(currentProps.yAccessor);
      var lineIDAccessor = (0, _dataFunctions.stringToFn)(currentProps.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });

      if (updateData || !currentProps.dataVersion || currentProps.dataVersion && currentProps.dataVersion !== this.state.dataVersion) {
        if (!xExtent || !yExtent || !fullDataset || !projectedLines && !projectedPoints && !projectedAreas) {
          ;
          var _calculateDataExtent = (0, _dataFunctions.calculateDataExtent)(_extends({}, currentProps, {
            xExtent: xExtent,
            yExtent: yExtent,
            adjustedSize: adjustedSize,
            xScaleType: xScaleType,
            yScaleType: yScaleType
          }));

          xExtent = _calculateDataExtent.xExtent;
          yExtent = _calculateDataExtent.yExtent;
          projectedLines = _calculateDataExtent.projectedLines;
          projectedPoints = _calculateDataExtent.projectedPoints;
          projectedAreas = _calculateDataExtent.projectedAreas;
          fullDataset = _calculateDataExtent.fullDataset;
          calculatedXExtent = _calculateDataExtent.calculatedXExtent;
          calculatedYExtent = _calculateDataExtent.calculatedYExtent;
        }
      } else {
        ;var _state = this.state;
        xExtent = _state.xExtent;
        yExtent = _state.yExtent;
        projectedLines = _state.projectedLines;
        projectedPoints = _state.projectedPoints;
        projectedAreas = _state.projectedAreas;
        fullDataset = _state.fullDataset;
        calculatedXExtent = _state.calculatedXExtent;
        calculatedYExtent = _state.calculatedYExtent;
      }

      var _screenScales = this.screenScales({
        xExtent: xExtent,
        yExtent: yExtent,
        currentProps: currentProps,
        margin: margin,
        adjustedSize: adjustedSize,
        xScaleType: xScaleType,
        yScaleType: yScaleType
      }),
          xScale = _screenScales.xScale,
          yScale = _screenScales.yScale;

      var canvasDrawing = [];

      //TODO: blow this shit up
      this.xScale = xScale;
      this.yScale = yScale;
      this.xAccessor = xAccessor;
      this.yAccessor = yAccessor;

      var axes = null;
      var axesTickLines = null;

      var existingBaselines = {};

      if (currentProps.axes) {
        axesTickLines = [];
        axes = currentProps.axes.map(function (d, i) {
          var axisClassname = d.className || "";
          axisClassname += " axis";
          var axisScale = yScale;
          if (existingBaselines[d.orient]) {
            d.baseline = d.baseline || false;
          }
          existingBaselines[d.orient] = true;
          if (d.orient === "top" || d.orient === "bottom") {
            axisClassname += " x";
            axisScale = xScale;
          } else {
            axisClassname += " y";
          }
          axisClassname += " " + d.orient;

          var tickValues = void 0;
          if (d.tickValues && Array.isArray(d.tickValues)) {
            tickValues = d.tickValues;
          } else if (d.tickValues) {
            //otherwise assume a function
            tickValues = d.tickValues(fullDataset, currentProps.size, axisScale);
          }
          var axisSize = [adjustedSize[0], adjustedSize[1]];

          var axisParts = (0, _axis.axisPieces)({
            padding: d.padding,
            tickValues: tickValues,
            scale: axisScale,
            ticks: d.ticks,
            orient: d.orient,
            size: axisSize,
            margin: margin,
            footer: d.footer,
            tickSize: d.tickSize
          });
          var axisTickLines = _react2.default.createElement(
            "g",
            { key: "axes-tick-lines-" + i, className: "axis " + axisClassname },
            (0, _axis.axisLines)({
              axisParts: axisParts,
              orient: d.orient,
              tickLineGenerator: d.tickLineGenerator
            })
          );
          axesTickLines.push(axisTickLines);
          return _react2.default.createElement(_Axis2.default, {
            label: d.label,
            axisParts: axisParts,
            key: d.key || "axis-" + i,
            orient: d.orient,
            size: axisSize,
            margin: margin,
            ticks: d.ticks,
            tickSize: d.tickSize,
            tickFormat: d.tickFormat,
            tickValues: tickValues,
            format: d.format,
            scale: axisScale,
            className: axisClassname,
            name: d.name,
            padding: d.padding,
            rotate: d.rotate,
            annotationFunction: d.axisAnnotationFunction,
            glyphFunction: d.glyphFunction,
            baseline: d.baseline
          });
        });
      }

      var marginGraphic = void 0;
      if (currentProps.matte) {
        marginGraphic = _react2.default.createElement("path", {
          fill: "white",
          transform: "translate(" + -margin.left + "," + -margin.top + ")",
          d: (0, _frameFunctions.drawMarginPath)({
            margin: margin,
            size: size,
            inset: currentProps.matte.inset
          }),
          className: "xyframe-matte"
        });
      }

      var legendSettings = void 0;

      if (legend) {
        legendSettings = legend === true ? {} : legend;
        if (lines && !legendSettings.legendGroups) {
          var typeString = lineType && lineType.type ? lineType.type : lineType;
          var type = ["stackedarea", "stackedpercent", "bumparea"].indexOf(typeString) === -1 ? "line" : "fill";
          var legendGroups = [{
            styleFn: currentProps.lineStyle,
            type: type,
            items: currentProps.lines.map(function (d) {
              return _extends({ label: lineIDAccessor(d) }, d);
            })
          }];
          legendSettings.legendGroups = legendGroups;
        }
      }
      var areaAnnotations = [];
      var areaType = currentProps.areaType;
      if (areaType && areaType.label && projectedAreas) {
        projectedAreas.forEach(function (d, i) {
          if (d.bounds) {
            var bounds = Array.isArray(d.bounds) ? d.bounds : [d.bounds];
            bounds.forEach(function (labelBounds) {
              var label = typeof areaType.label === "function" ? areaType.label(d) : areaType.label;
              if (label && label !== null) {
                var labelPosition = label.position || "center";
                var labelCenter = [xScale(labelBounds[labelPosition][0]), yScale(labelBounds[labelPosition][1])] || [xScale(d._xyfCoordinates[0]), yScale(d._xyfCoordinates[1])];
                var labelContent = label.content || function (p) {
                  return p.value || p.id || i;
                };

                areaAnnotations.push({
                  x: labelCenter[0],
                  y: labelCenter[1],
                  dx: label.dx,
                  dy: label.dy,
                  className: label.className,
                  type: label.type || _AnnotationCallout2.default,
                  note: label.note || { title: labelContent(d) },
                  subject: label.subject || { text: labelContent(d) },
                  connector: label.connector
                });
              }
            });
          }
        });
      }

      var lineAriaLabel = naturalLanguageLineType[lineType.type] || {
        items: "line",
        chart: "line chart"
      };

      var xyFrameRender = {
        lines: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({}, data[i].data[data[i].data.length - 1], {
              type: "frame-hover"
            });
          },
          data: projectedLines,
          styleFn: (0, _dataFunctions.stringToFn)(lineStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(lineClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(lineRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasLines, undefined, true),
          customMark: customLineMark,
          type: lineType,
          defined: defined,
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "line-" + i;
          }, true),
          ariaLabel: lineAriaLabel,
          axesData: currentProps.axes,
          behavior: _general.createLines
        },
        areas: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({}, data[i], { type: "frame-hover" });
          },
          data: projectedAreas,
          styleFn: (0, _dataFunctions.stringToFn)(areaStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(areaClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(areaRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasAreas, undefined, true),
          customMark: customAreaMark,
          type: areaType,
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "area-" + i;
          }, true),
          behavior: _general.createAreas
        },
        points: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({
              type: "frame-hover"
            }, data[i].data || data[i]);
          },
          data: projectedPoints,
          styleFn: (0, _dataFunctions.stringToFn)(pointStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(pointClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(pointRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasPoints, undefined, true),
          customMark: (0, _dataFunctions.stringToFn)(customPointMark, undefined, true),
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "point-" + i;
          }, true),
          behavior: _general.createPoints
        }
      };

      if (xExtentSettings.onChange && (this.state.calculatedXExtent || []).join(",") !== (calculatedXExtent || []).join(",")) {
        xExtentSettings.onChange(calculatedXExtent);
      }
      if (yExtentSettings.onChange && (this.state.calculatedYExtent || []).join(",") !== (calculatedYExtent || []).join(",")) {
        yExtentSettings.onChange(calculatedYExtent);
      }

      this.setState({
        lineData: currentProps.lines,
        pointData: currentProps.points,
        areaData: currentProps.areas,
        dataVersion: currentProps.dataVersion,
        projectedLines: projectedLines,
        projectedPoints: projectedPoints,
        projectedAreas: projectedAreas,
        canvasDrawing: canvasDrawing,
        fullDataset: fullDataset,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        axesData: currentProps.axes,
        axes: axes,
        axesTickLines: axesTickLines,
        title: title,
        updatedFrame: undefined,
        renderNumber: this.state.renderNumber + 1,
        xScale: xScale,
        yScale: yScale,
        xExtent: xExtent,
        yExtent: yExtent,
        calculatedXExtent: calculatedXExtent,
        calculatedYExtent: calculatedYExtent,
        margin: margin,
        legendSettings: legendSettings,
        matte: marginGraphic,
        areaAnnotations: areaAnnotations,
        xyFrameRender: xyFrameRender,
        size: size
      });
    }
  }, {
    key: "defaultXYSVGRule",
    value: function defaultXYSVGRule(_ref2) {
      var d = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer,
          lines = _ref2.lines,
          areas = _ref2.areas,
          points = _ref2.points;

      var xAccessor = this.xAccessor;
      var yAccessor = this.yAccessor;

      var xScale = this.xScale;
      var yScale = this.yScale;

      var screenCoordinates = [];
      var idAccessor = (0, _dataFunctions.stringToFn)(this.props.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });

      var _adjustedPositionSize2 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize2.adjustedPosition,
          adjustedSize = _adjustedPositionSize2.adjustedSize;

      if (!d.coordinates) {
        var xCoord = d[_coordinateNames.projectedX] || xAccessor(d);
        screenCoordinates = [xScale(xCoord), (0, _lineDrawing.relativeY)({
          point: d,
          lines: lines,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          projectedX: _coordinateNames.projectedX,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          yScale: yScale,
          xScale: xScale,
          idAccessor: idAccessor
        })];

        if (d.type !== "highlight" && (screenCoordinates[0] === undefined || screenCoordinates[1] === undefined || screenCoordinates[0] === null || screenCoordinates[1] === null)) {
          //NO ANNOTATION IF INVALID SCREEN COORDINATES
          return null;
        }
      } else if (!d.bounds) {
        screenCoordinates = d.coordinates.map(function (p) {
          return [xScale(xAccessor(p)) + adjustedPosition[0], (0, _lineDrawing.relativeY)({
            point: p,
            lines: lines,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            yScale: yScale,
            xScale: xScale,
            idAccessor: idAccessor
          }) + adjustedPosition[1]];
        });
      }

      var margin = (0, _frameFunctions.calculateMargin)(this.props);

      //point xy
      //y
      //area

      //TODO: Process your rules first
      var customSVG = this.props.svgAnnotationRules && this.props.svgAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: this.props,
        xyFrameState: this.state,
        areas: areas,
        points: points,
        lines: lines
      });
      if (this.props.svgAnnotationRules !== undefined && customSVG !== null) {
        return customSVG;
      } else if (d.type === "xy" || d.type === "frame-hover") {
        return (0, _xyframeRules.svgXYAnnotation)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "highlight") {
        return (0, _xyframeRules.svgHighlight)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          idAccessor: idAccessor,
          lines: lines,
          areas: areas,
          points: points,
          xScale: xScale,
          yScale: yScale
        });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _xyframeRules.basicReactAnnotation)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "enclose") {
        return (0, _xyframeRules.svgEncloseAnnotation)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "enclose-rect") {
        return (0, _xyframeRules.svgRectEncloseRule)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "x") {
        return (0, _xyframeRules.svgXAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          annotationLayer: annotationLayer,
          adjustedSize: adjustedSize,
          margin: margin
        });
      } else if (d.type === "y") {
        return (0, _xyframeRules.svgYAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          annotationLayer: annotationLayer,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition,
          margin: margin
        });
      } else if (d.type === "bounds") {
        return (0, _xyframeRules.svgBoundsAnnotation)({
          screenCoordinates: screenCoordinates,
          d: d,
          i: i,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xScale: xScale,
          yScale: yScale,
          margin: margin
        });
      } else if (d.type === "line") {
        return (0, _xyframeRules.svgLineAnnotation)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "area") {
        return (0, _xyframeRules.svgAreaAnnotation)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          xScale: xScale,
          xAccessor: xAccessor,
          yScale: yScale,
          yAccessor: yAccessor,
          annotationLayer: annotationLayer
        });
      } else if (d.type === "horizontal-points") {
        return (0, _xyframeRules.svgHorizontalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      } else if (d.type === "vertical-points") {
        return (0, _xyframeRules.svgVerticalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      }
      return null;
    }
  }, {
    key: "defaultXYHTMLRule",
    value: function defaultXYHTMLRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i,
          lines = _ref3.lines,
          areas = _ref3.areas,
          points = _ref3.points;

      var xAccessor = this.xAccessor;
      var yAccessor = this.yAccessor;

      var xScale = this.xScale;
      var yScale = this.yScale;

      var screenCoordinates = [];

      var _props = this.props,
          size = _props.size,
          useSpans = _props.useSpans;


      var idAccessor = (0, _dataFunctions.stringToFn)(this.props.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });
      var xCoord = d[_coordinateNames.projectedX] || xAccessor(d);
      var yCoord = d[_coordinateNames.projectedY] || yAccessor(d);

      var xString = xCoord && xCoord.toString ? xCoord.toString() : xCoord;
      var yString = yCoord && yCoord.toString ? yCoord.toString() : yCoord;

      var _adjustedPositionSize3 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize3.adjustedPosition;

      if (!d.coordinates) {
        screenCoordinates = [xScale(xCoord), (0, _lineDrawing.relativeY)({
          point: d,
          lines: lines,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          projectedX: _coordinateNames.projectedX,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          yScale: yScale,
          xScale: xScale,
          idAccessor: idAccessor
        })];
        if (screenCoordinates[0] === undefined || screenCoordinates[1] === undefined || screenCoordinates[0] === null || screenCoordinates[1] === null) {
          //NO ANNOTATION IF INVALID SCREEN COORDINATES
          return null;
        }
      } else {
        screenCoordinates = d.coordinates.map(function (p) {
          return [xScale(xAccessor(p)) + adjustedPosition[0], (0, _lineDrawing.relativeY)({
            point: p,
            lines: lines,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            yScale: yScale,
            xScale: xScale,
            idAccessor: idAccessor
          }) + adjustedPosition[1]];
        });
      }

      if (this.props.htmlAnnotationRules && this.props.htmlAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: this.props,
        xyFrameState: this.state,
        areas: areas,
        points: points,
        lines: lines
      }) !== null) {
        return this.props.htmlAnnotationRules({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          xScale: xScale,
          yScale: yScale,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xyFrameProps: this.props,
          xyFrameState: this.state,
          areas: areas,
          points: points,
          lines: lines
        });
      }
      if (d.type === "frame-hover") {
        var content = _react2.default.createElement(
          _SpanOrDiv2.default,
          { span: useSpans, className: "tooltip-content" },
          _react2.default.createElement(
            "p",
            { key: "html-annotation-content-1" },
            xString
          ),
          _react2.default.createElement(
            "p",
            { key: "html-annotation-content-2" },
            yString
          ),
          d.percent ? _react2.default.createElement(
            "p",
            { key: "html-annotation-content-3" },
            parseInt(d.percent * 1000, 10) / 10,
            "%"
          ) : null
        );

        if (d.type === "frame-hover" && this.props.tooltipContent) {
          content = this.props.tooltipContent(d);
        }
        return (0, _xyframeRules.htmlTooltipAnnotation)({
          content: content,
          screenCoordinates: screenCoordinates,
          size: size,
          i: i,
          d: d,
          useSpans: useSpans
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          downloadFields = _props2.downloadFields,
          xAccessor = _props2.xAccessor,
          yAccessor = _props2.yAccessor,
          lines = _props2.lines,
          points = _props2.points,
          areas = _props2.areas,
          name = _props2.name,
          download = _props2.download,
          size = _props2.size,
          className = _props2.className,
          annotationSettings = _props2.annotationSettings,
          annotations = _props2.annotations,
          additionalDefs = _props2.additionalDefs,
          hoverAnnotation = _props2.hoverAnnotation,
          interaction = _props2.interaction,
          customClickBehavior = _props2.customClickBehavior,
          customHoverBehavior = _props2.customHoverBehavior,
          customDoubleClickBehavior = _props2.customDoubleClickBehavior,
          canvasPostProcess = _props2.canvasPostProcess,
          baseMarkProps = _props2.baseMarkProps,
          useSpans = _props2.useSpans,
          canvasAreas = _props2.canvasAreas,
          canvasPoints = _props2.canvasPoints,
          canvasLines = _props2.canvasLines,
          afterElements = _props2.afterElements,
          beforeElements = _props2.beforeElements;
      var _state2 = this.state,
          title = _state2.title,
          backgroundGraphics = _state2.backgroundGraphics,
          foregroundGraphics = _state2.foregroundGraphics,
          adjustedPosition = _state2.adjustedPosition,
          adjustedSize = _state2.adjustedSize,
          margin = _state2.margin,
          matte = _state2.matte,
          axes = _state2.axes,
          axesTickLines = _state2.axesTickLines,
          extent = _state2.extent,
          xScale = _state2.xScale,
          yScale = _state2.yScale,
          dataVersion = _state2.dataVersion,
          fullDataset = _state2.fullDataset,
          areaAnnotations = _state2.areaAnnotations,
          legendSettings = _state2.legendSettings,
          xyFrameRender = _state2.xyFrameRender;


      var downloadButton = void 0;
      if (download && (points || lines)) {
        var downloadData = download === "points" ? mapParentsToPoints(fullDataset) : points || lines || areas;
        downloadButton = _react2.default.createElement(_DownloadButton2.default, {
          csvName: name + "-" + new Date().toJSON(),
          width: parseInt(size[0], 10),
          data: (0, _downloadDataMapping.xyDownloadMapping)({
            data: downloadData,
            xAccessor: download === "points" || points ? (0, _dataFunctions.stringToFn)(xAccessor) : undefined,
            yAccessor: download === "points" || points ? (0, _dataFunctions.stringToFn)(yAccessor) : undefined,
            fields: downloadFields
          })
        });
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        matte: matte,
        key: matte && (this.props.frameKey || xyframeKey),
        additionalDefs: additionalDefs
      });

      // foreground and background graphics should handle either JSX or a function that passes size & margin and returns JSX

      return _react2.default.createElement(_Frame2.default, {
        name: "xyframe",
        renderPipeline: xyFrameRender,
        adjustedPosition: adjustedPosition,
        size: size,
        extent: extent,
        projectedCoordinateNames: projectedCoordinateNames,
        xScale: xScale,
        yScale: yScale,
        axes: axes,
        axesTickLines: axesTickLines,
        title: title,
        dataVersion: dataVersion,
        matte: matte,
        className: className,
        adjustedSize: adjustedSize,
        finalFilterDefs: finalFilterDefs,
        frameKey: xyframeKey,
        hoverAnnotation: hoverAnnotation,
        defaultSVGRule: this.defaultXYSVGRule.bind(this),
        defaultHTMLRule: this.defaultXYHTMLRule.bind(this),
        annotations: areaAnnotations.length > 0 ? [].concat(_toConsumableArray(annotations), _toConsumableArray(areaAnnotations)) : annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        projectedYMiddle: _coordinateNames.projectedYMiddle,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: fullDataset,
        margin: margin,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        disableContext: this.props.disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: useSpans,
        canvasRendering: canvasAreas || canvasPoints || canvasLines
      });
    }
  }]);

  return XYFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: undefined,
  size: [500, 500],
  className: "",
  lineType: "line",
  name: "xyframe"
}, _temp);


XYFrame.propTypes = _extends({}, _frame_props.xyframeproptypes);

exports.default = XYFrame;
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(93);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orFrameAxisGenerator = exports.calculateMargin = exports.trueAxis = exports.drawMarginPath = exports.circlePath = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.objectifyType = objectifyType;
exports.generateOrdinalFrameEventListeners = generateOrdinalFrameEventListeners;
exports.keyAndObjectifyBarData = keyAndObjectifyBarData;
exports.adjustedPositionSize = adjustedPositionSize;
exports.generateFrameTitle = generateFrameTitle;
exports.orFrameConnectionRenderer = orFrameConnectionRenderer;
exports.orFrameSummaryRenderer = orFrameSummaryRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgHelper = __webpack_require__(95);

var _semioticMark = __webpack_require__(6);

var _Axis = __webpack_require__(54);

var _Axis2 = _interopRequireDefault(_Axis);

var _summaryLayouts = __webpack_require__(189);

var _axis = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function roundToTenth(number) {
  return Math.round(number * 10) / 10;
}

var circlePath = exports.circlePath = function circlePath(cx, cy, r) {
  return ["M", roundToTenth(cx - r), roundToTenth(cy), "a", r, r, 0, 1, 0, r * 2, 0, "a", r, r, 0, 1, 0, -(r * 2), 0].join(" ") + "Z";
};

var drawMarginPath = exports.drawMarginPath = function drawMarginPath(_ref) {
  var margin = _ref.margin,
      size = _ref.size,
      _ref$inset = _ref.inset,
      inset = _ref$inset === undefined ? 5 : _ref$inset;

  var iSize = [size[0] - inset, size[1] - inset];
  return "M0,0 h" + size[0] + " v" + size[1] + " h-" + size[0] + "Z M" + (margin.left - inset) + "," + (margin.top - inset) + " v" + (size[1] + inset * 2 - margin.top - margin.bottom) + " h" + (iSize[0] + inset * 3 - margin.left - margin.right) + " v-" + (iSize[1] + inset * 3 - margin.top - margin.bottom) + "Z";
};

var trueAxis = exports.trueAxis = function trueAxis(orient, projection) {
  if (projection === "horizontal" && ["top", "bottom"].indexOf(orient) === -1) {
    return "bottom";
  } else if ((!projection || projection === "vertical") && ["left", "right"].indexOf(orient) === -1) {
    return "left";
  } else if (!orient && projection === "horizontal") {
    return "bottom";
  } else if (!orient) {
    return "left";
  }
  return orient;
};

var calculateMargin = exports.calculateMargin = function calculateMargin(_ref2) {
  var margin = _ref2.margin,
      axis = _ref2.axis,
      axes = _ref2.axes,
      title = _ref2.title,
      oLabel = _ref2.oLabel,
      projection = _ref2.projection;

  if (margin !== undefined) {
    var tempMargin = margin;
    if ((typeof margin === "undefined" ? "undefined" : _typeof(margin)) !== "object") {
      tempMargin = { top: margin, bottom: margin, left: margin, right: margin };
    }
    return _extends({ top: 0, bottom: 0, left: 0, right: 0 }, tempMargin);
  }
  var finalMargin = { top: 0, bottom: 0, left: 0, right: 0 };
  if (title && !(typeof title === "string" && title.length === 0)) {
    var _title$orient = title.orient,
        _orient = _title$orient === undefined ? "top" : _title$orient;

    finalMargin[_orient] += 40;
  }
  var orient = trueAxis(null, projection);
  if (axis && projection !== "radial") {
    var additionalMargin = axis.label ? 60 : 50;
    orient = trueAxis(axis.orient, projection);
    finalMargin[orient] += additionalMargin;
  }

  if (axes) {
    axes.forEach(function (axisObj) {
      var axisObjAdditionMargin = axisObj.label ? 60 : 50;
      orient = axisObj.orient;
      finalMargin[orient] += axisObjAdditionMargin;
    });
  }
  if (oLabel && projection !== "radial") {
    if (orient === "bottom" || orient === "top") {
      finalMargin.left += 50;
    } else {
      finalMargin.bottom += 50;
    }
  }
  return finalMargin;
};

function objectifyType(type) {
  return (typeof type === "undefined" ? "undefined" : _typeof(type)) === "object" && type !== null ? type : { type: type };
}

function generateOrdinalFrameEventListeners(customHoverBehavior, customClickBehavior) {
  var eventListenersGenerator = function eventListenersGenerator() {
    return {};
  };

  if (customHoverBehavior || customClickBehavior) {
    eventListenersGenerator = function eventListenersGenerator(d, i) {
      return {
        onMouseEnter: customHoverBehavior ? function () {
          return customHoverBehavior(d, i);
        } : undefined,
        onMouseLeave: customHoverBehavior ? function () {
          return customHoverBehavior(undefined);
        } : undefined,
        onClick: customClickBehavior ? function () {
          return customClickBehavior(d, i);
        } : undefined
      };
    };
  }
  return eventListenersGenerator;
}

function keyAndObjectifyBarData(_ref3) {
  var data = _ref3.data,
      _ref3$renderKey = _ref3.renderKey,
      renderKey = _ref3$renderKey === undefined ? function (d, i) {
    return i;
  } : _ref3$renderKey;

  return data ? data.map(function (d, i) {
    var appliedKey = renderKey(d, i);
    if ((typeof d === "undefined" ? "undefined" : _typeof(d)) !== "object") {
      return {
        data: { value: d, renderKey: appliedKey },
        value: d,
        renderKey: appliedKey
      };
    }
    return { renderKey: appliedKey, data: d };
  }) : [];
}

function adjustedPositionSize(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === undefined ? [500, 500] : _ref4$size,
      _ref4$position = _ref4.position,
      position = _ref4$position === undefined ? [0, 0] : _ref4$position,
      margin = _ref4.margin,
      axis = _ref4.axis,
      axes = _ref4.axes,
      title = _ref4.title,
      oLabel = _ref4.oLabel,
      projection = _ref4.projection;

  var finalMargin = calculateMargin({
    margin: margin,
    axis: axis,
    axes: axes,
    title: title,
    oLabel: oLabel,
    projection: projection
  });

  var heightAdjust = finalMargin.top + finalMargin.bottom;
  var widthAdjust = finalMargin.left + finalMargin.right;

  var adjustedPosition = [position[0], position[1]];
  var adjustedSize = [size[0] - widthAdjust, size[1] - heightAdjust];
  if (projection === "radial") {
    var minSize = Math.min(adjustedSize[0], adjustedSize[1]);
    adjustedSize = [minSize, minSize];
  }

  return { adjustedPosition: adjustedPosition, adjustedSize: adjustedSize };
}

function generateFrameTitle(_ref5) {
  var _ref5$title = _ref5.title,
      rawTitle = _ref5$title === undefined ? "" : _ref5$title,
      size = _ref5.size;

  var finalTitle = null;
  var _rawTitle$title = rawTitle.title,
      title = _rawTitle$title === undefined ? rawTitle : _rawTitle$title,
      _rawTitle$orient = rawTitle.orient,
      orient = _rawTitle$orient === undefined ? "top" : _rawTitle$orient;

  var x = 0,
      y = 0,
      transform = void 0;
  switch (orient) {
    case "top":
      x = size[0] / 2;
      y = 25;
      break;
    case "bottom":
      x = size[0] / 2;
      y = size[1] - 25;
      break;
    case "left":
      x = 25;
      y = size[1] / 2;
      transform = "rotate(-90)";
      break;
    case "right":
      x = size[0] - 25;
      y = size[1] / 2;
      transform = "rotate(90)";

      break;
  }
  var gTransform = "translate(" + x + "," + y + ")";
  if (typeof title === "string" && title.length > 0) {
    finalTitle = _react2.default.createElement(
      "g",
      { transform: gTransform },
      _react2.default.createElement(
        "text",
        {
          className: "frame-title",
          transform: transform,
          style: { textAnchor: "middle", pointerEvents: "none" }
        },
        title
      )
    );
  } else if (title) {
    //assume if defined then its an svg mark of some sort
    finalTitle = _react2.default.createElement(
      "g",
      { transform: gTransform },
      title
    );
  }
  return finalTitle;
}

function orFrameConnectionRenderer(_ref6) {
  var type = _ref6.type,
      data = _ref6.data,
      renderMode = _ref6.renderMode,
      eventListenersGenerator = _ref6.eventListenersGenerator,
      styleFn = _ref6.styleFn,
      classFn = _ref6.classFn,
      projection = _ref6.projection,
      canvasRender = _ref6.canvasRender,
      canvasDrawing = _ref6.canvasDrawing,
      baseMarkProps = _ref6.baseMarkProps;

  if (!type.type) {
    return null;
  }
  var renderedConnectorMarks = [];
  if (typeof type.type === "function") {
    var connectionRule = type.type;
    var keys = Object.keys(data);

    keys.forEach(function (key, pieceArrayI) {
      var pieceArray = data[key];
      var nextColumn = data[keys[pieceArrayI + 1]];
      if (nextColumn) {
        var matchArray = nextColumn.map(function (d, i) {
          return connectionRule(d.piece.data, i);
        });
        pieceArray.forEach(function (piece, pieceI) {
          var thisConnectionPiece = connectionRule(piece.piece.data, pieceI);
          var matchingPieceIndex = matchArray.indexOf(connectionRule(piece.piece.data, pieceI));
          if (thisConnectionPiece !== undefined && thisConnectionPiece !== null && matchingPieceIndex !== -1) {
            var matchingPiece = nextColumn[matchingPieceIndex];
            var markD = void 0;
            var xy = piece.xy;
            var mxy = matchingPiece.xy;
            var x = xy.x,
                y = xy.y,
                _xy$height = xy.height,
                height = _xy$height === undefined ? 1 : _xy$height,
                _xy$width = xy.width,
                width = _xy$width === undefined ? 1 : _xy$width;
            var mx = mxy.x,
                my = mxy.y,
                _mxy$height = mxy.height,
                mheight = _mxy$height === undefined ? 1 : _mxy$height,
                _mxy$width = mxy.width,
                mwidth = _mxy$width === undefined ? 1 : _mxy$width;

            if (projection === "vertical") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x + width,
                x2: mx,
                y1: y,
                y2: my,
                sizeX1: 0,
                sizeX2: 0,
                sizeY1: height,
                sizeY2: mheight
              });
            } else if (projection === "horizontal") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x,
                x2: mx,
                y1: y + height,
                y2: my,
                sizeX1: width,
                sizeX2: mwidth,
                sizeY1: 0,
                sizeY2: 0
              });
            } else if (projection === "radial") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x,
                x2: mx,
                y1: y + height,
                y2: my,
                sizeX1: width,
                sizeX2: mwidth,
                sizeY1: 0,
                sizeY2: 0
              });
            }
            var renderValue = renderMode && renderMode(piece.piece, pieceI);

            var calculatedStyle = styleFn({
              source: piece.piece.data,
              target: matchingPiece.piece
            });

            var eventListeners = eventListenersGenerator({ source: piece.piece.data, target: matchingPiece.piece.data }, pieceI);
            if (canvasRender && canvasRender(piece.piece) === true) {
              var canvasConnector = {
                baseClass: "xyframe-line",
                tx: 0,
                ty: 0,
                d: { source: piece.piece.data, target: matchingPiece.piece.data },
                markProps: { d: markD, markType: "path" },
                styleFn: styleFn,
                renderFn: renderMode,
                classFn: classFn
              };
              canvasDrawing.push(canvasConnector);
            } else {
              renderedConnectorMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, eventListeners, {
                renderMode: renderValue,
                markType: "path",
                d: markD,
                className: classFn ? classFn(piece.piece.data, pieceI) : "",
                key: "connector" + piece.piece.renderKey,
                style: calculatedStyle
              })));
            }
          }
        });
      }
    });
  } else if (type.type) {
    console.error("Invalid connectorType - Must be a function that takes a data point and determines if it is connected to a data point in the next column");
  }
  return renderedConnectorMarks;
}

var summaryRenderHash = {
  contour: _summaryLayouts.contourRenderFn,
  boxplot: _summaryLayouts.boxplotRenderFn,
  violin: _summaryLayouts.bucketizedRenderingFn,
  heatmap: _summaryLayouts.bucketizedRenderingFn,
  joy: _summaryLayouts.bucketizedRenderingFn,
  histogram: _summaryLayouts.bucketizedRenderingFn
};

function orFrameSummaryRenderer(_ref7) {
  var data = _ref7.data,
      type = _ref7.type,
      renderMode = _ref7.renderMode,
      eventListenersGenerator = _ref7.eventListenersGenerator,
      styleFn = _ref7.styleFn,
      classFn = _ref7.classFn,
      positionFn = _ref7.positionFn,
      projection = _ref7.projection,
      adjustedSize = _ref7.adjustedSize,
      chartSize = _ref7.chartSize,
      baseMarkProps = _ref7.baseMarkProps;

  var summaryRenderFn = void 0;
  if (typeof type.type === "function") {
    summaryRenderFn = type.type;
  } else if (summaryRenderHash[type.type]) {
    summaryRenderFn = summaryRenderHash[type.type];
  } else {
    console.error("Invalid summary type: " + type.type + " - Must be a function or one of the following strings: " + Object.keys(summaryRenderHash));
    return;
  }
  return summaryRenderFn({
    data: data,
    type: type,
    renderMode: renderMode,
    eventListenersGenerator: eventListenersGenerator,
    styleFn: styleFn,
    classFn: classFn,
    positionFn: positionFn,
    projection: projection,
    adjustedSize: adjustedSize,
    chartSize: chartSize,
    baseMarkProps: baseMarkProps
  });
}

var orFrameAxisGenerator = exports.orFrameAxisGenerator = function orFrameAxisGenerator(_ref8) {
  var projection = _ref8.projection,
      axis = _ref8.axis,
      adjustedSize = _ref8.adjustedSize,
      size = _ref8.size,
      rScale = _ref8.rScale,
      rScaleType = _ref8.rScaleType,
      pieceType = _ref8.pieceType,
      rExtent = _ref8.rExtent,
      data = _ref8.data;

  if (!axis) return { axis: null, axesTickLines: null };
  var generatedAxis = void 0,
      axesTickLines = void 0;
  if (projection !== "radial" && axis) {
    axesTickLines = [];
    var axisPosition = [0, 0];
    var axes = Array.isArray(axis) ? axis : [axis];
    var axisBaseline = false;
    generatedAxis = axes.map(function (d, i) {
      if (axisBaseline) {
        d.axis = d.axis || false;
      }
      axisBaseline = true;

      var axisClassname = d.className || "";
      var tickValues = void 0;
      var axisScale = rScaleType().domain(rScale.domain());

      var orient = trueAxis(d.orient, projection);

      if (orient === "right") {
        axisScale.range([rScale.range()[1], rScale.range()[0]]);
        axisClassname += " right y";
      } else if (orient === "left") {
        axisClassname += " left y";
        axisScale.range([rScale.range()[1], rScale.range()[0]]);
      } else if (orient === "top") {
        axisClassname += " top x";
        axisScale.range(rScale.range());
      } else if (orient === "bottom") {
        axisClassname += " bottom x";
        axisScale.range(rScale.range());
      }

      if (d.tickValues && Array.isArray(d.tickValues)) {
        tickValues = d.tickValues;
      } else if (d.tickValues) {
        //otherwise assume a function
        tickValues = d.tickValues(data, size, rScale);
      }

      var axisParts = (0, _axis.axisPieces)({
        padding: d.padding,
        tickValues: tickValues,
        scale: axisScale,
        ticks: d.ticks,
        orient: orient,
        size: adjustedSize,
        footer: d.footer,
        tickSize: d.tickSize
      });
      var axisTickLines = (0, _axis.axisLines)({
        axisParts: axisParts,
        orient: orient,
        tickLineGenerator: d.tickLineGenerator
      });
      axesTickLines.push(axisTickLines);

      return _react2.default.createElement(_Axis2.default, {
        label: d.label,
        axisParts: axisParts,
        key: d.key || "orframe-axis-" + i,
        orient: orient,
        size: adjustedSize,
        position: axisPosition,
        ticks: d.ticks,
        tickSize: d.tickSize,
        tickFormat: d.tickFormat,
        tickValues: tickValues,
        format: d.format,
        rotate: d.rotate,
        scale: axisScale,
        className: axisClassname,
        name: d.name,
        baseline: d.baseline
      });
    });
  } else if (projection === "radial" && axis) {
    var _pieceType$innerRadiu = pieceType.innerRadius,
        innerRadius = _pieceType$innerRadiu === undefined ? 0 : _pieceType$innerRadiu;
    var _axis$tickValues = axis.tickValues,
        tickValues = _axis$tickValues === undefined ? rScale.ticks(Math.max(2, (adjustedSize[0] / 2 - innerRadius) / 50)) : _axis$tickValues,
        label = axis.label,
        _axis$tickFormat = axis.tickFormat,
        tickFormat = _axis$tickFormat === undefined ? function (d) {
      return d;
    } : _axis$tickFormat;


    var tickScale = rScaleType().domain(rExtent).range([innerRadius, adjustedSize[0] / 2]);
    var ticks = tickValues.map(function (t, i) {
      var tickSize = tickScale(t);
      if (!(innerRadius === 0 && t === 0)) {
        var axisLabel = void 0;
        var ref = "";
        if (label && i === tickValues.length - 1) {
          var labelSettings = typeof label === "string" ? { name: label } : label;
          var _labelSettings$locati = labelSettings.locationDistance,
              locationDistance = _labelSettings$locati === undefined ? 15 : _labelSettings$locati;

          ref = Math.random().toString() + " ";
          axisLabel = _react2.default.createElement(
            "g",
            {
              className: "axis-label radial",
              transform: "translate(0," + locationDistance + ")"
            },
            _react2.default.createElement(
              "text",
              { textAnchor: "middle" },
              _react2.default.createElement(
                "textPath",
                {
                  startOffset: tickSize * Math.PI * 0.5,
                  xlinkHref: "#" + ref
                },
                label.name
              )
            )
          );
        }
        return _react2.default.createElement(
          "g",
          {
            key: "orframe-radial-axis-element-" + t,
            className: "axis axis-label axis-tick radial",
            transform: "translate(0,0)"
          },
          _react2.default.createElement("path", {
            id: ref,
            d: circlePath(0, 0, tickSize),
            r: tickSize,
            stroke: "gray",
            fill: "none"
          }),
          _react2.default.createElement(
            "text",
            { y: -tickSize + 5, textAnchor: "middle" },
            tickFormat(t)
          ),
          axisLabel
        );
      }
      return null;
    });
    generatedAxis = _react2.default.createElement(
      "g",
      {
        key: axis.key || "orframe-radial-axis-container",
        transform: "translate(" + adjustedSize[0] / 2 + "," + adjustedSize[1] / 2 + ")"
      },
      ticks
    );
  }
  return { axis: generatedAxis, axesTickLines: axesTickLines };
};

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(207);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeElbow = __webpack_require__(265);

var _typeElbow2 = _interopRequireDefault(_typeElbow);

var _Connector2 = __webpack_require__(69);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorElbow = function (_Connector) {
  _inherits(ConnectorElbow, _Connector);

  function ConnectorElbow() {
    _classCallCheck(this, ConnectorElbow);

    return _possibleConstructorReturn(this, (ConnectorElbow.__proto__ || Object.getPrototypeOf(ConnectorElbow)).apply(this, arguments));
  }

  _createClass(ConnectorElbow, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          radius = _ref.radius,
          radiusPadding = _ref.radiusPadding,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeElbow2.default)({
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        radius: radius,
        radiusPadding: radiusPadding,
        outerRadius: outerRadius,
        width: width,
        height: height
      });
    }
  }]);

  return ConnectorElbow;
}(_Connector3.default);

exports.default = ConnectorElbow;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dividedLine = exports.bumpChart = exports.lineChart = exports.stackedArea = exports.differenceLine = exports.projectLineData = exports.projectAreaData = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.funnelize = funnelize;
exports.relativeY = relativeY;

var _d3Array = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var datesForUnique = function datesForUnique(d) {
  return d instanceof Date ? d.toString() : d;
};

var projectAreaData = exports.projectAreaData = function projectAreaData(_ref) {
  var data = _ref.data,
      areaDataAccessor = _ref.areaDataAccessor,
      projection = _ref.projection,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor;

  projection = projection ? projection : function (d) {
    return areaDataAccessor(d).map(function (p, q) {
      return [xAccessor(p, q), yAccessor(p, q)];
    });
  };
  data.forEach(function (d) {
    d._xyfCoordinates = projection(d);
  });
  return data;
};

var projectLineData = exports.projectLineData = function projectLineData(_ref2) {
  var data = _ref2.data,
      lineDataAccessor = _ref2.lineDataAccessor,
      xProp = _ref2.xProp,
      yProp = _ref2.yProp,
      yPropTop = _ref2.yPropTop,
      yPropBottom = _ref2.yPropBottom,
      xAccessor = _ref2.xAccessor,
      yAccessor = _ref2.yAccessor;

  if (!Array.isArray(data)) {
    data = [data];
  }
  return data.map(function (d, i) {
    var originalLineData = _extends({}, d);
    originalLineData.data = lineDataAccessor(d).map(function (p, q) {
      var originalCoords = {};

      originalCoords[xProp] = xAccessor(p, q);
      originalCoords[yProp] = yAccessor(p, q);
      originalCoords[yPropTop] = originalCoords[yProp];
      originalCoords[yPropBottom] = originalCoords[yProp];
      originalCoords.data = p;

      return originalCoords;
    });
    originalLineData.key = originalLineData.key || i;
    return originalLineData;
  });
};

var differenceLine = exports.differenceLine = function differenceLine(_ref3) {
  var data = _ref3.data,
      yProp = _ref3.yProp,
      yPropTop = _ref3.yPropTop,
      yPropBottom = _ref3.yPropBottom;

  data.forEach(function (l, i) {
    l.data.forEach(function (point, q) {
      var otherLine = i === 0 ? 1 : 0;
      if (point[yProp] > data[otherLine].data[q][yProp]) {
        point[yPropBottom] = data[otherLine].data[q][yProp];
        point[yPropTop] = point[yProp];
      } else {
        point[yPropTop] = point[yProp];
        point[yPropBottom] = point[yProp];
      }
    });
  });

  return data;
};

var stackedArea = exports.stackedArea = function stackedArea(_ref4) {
  var _ref4$type = _ref4.type,
      type = _ref4$type === undefined ? "stackedarea" : _ref4$type,
      data = _ref4.data,
      xProp = _ref4.xProp,
      yProp = _ref4.yProp,
      yPropMiddle = _ref4.yPropMiddle,
      sort = _ref4.sort,
      yPropTop = _ref4.yPropTop,
      yPropBottom = _ref4.yPropBottom;

  /* Object.keys(allData.map((d,i) => oAccessor(d,i)).reduce((p,c) => {
      p[c] = true
      return p
    }, {})) */

  var uniqXValues = [].concat(_toConsumableArray(new Set(data.map(function (d) {
    return d.data.map(function (p) {
      return datesForUnique(p[xProp]);
    });
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []))));
  var stackSort = function stackSort(a, b) {
    return (0, _d3Array.sum)(b.data.map(function (p) {
      return p[yProp];
    })) - (0, _d3Array.sum)(a.data.map(function (p) {
      return p[yProp];
    }));
  };
  if (type === "stackedpercent-invert" || type === "stackedarea-invert") {
    stackSort = function stackSort(a, b) {
      return (0, _d3Array.sum)(a.data.map(function (p) {
        return p[yProp];
      })) - (0, _d3Array.sum)(b.data.map(function (p) {
        return p[yProp];
      }));
    };
  }
  sort = sort === undefined ? stackSort : sort;

  if (sort !== null) {
    data = data.sort(sort);
  }

  uniqXValues.forEach(function (xValue) {
    var negativeOffset = 0;
    var positiveOffset = 0;
    var stepValues = data.map(function (d) {
      return d.data.filter(function (p) {
        return datesForUnique(p[xProp]) === xValue;
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);

    var positiveStepTotal = (0, _d3Array.sum)(stepValues.map(function (d) {
      return d[yProp] > 0 ? d[yProp] : 0;
    }));
    var negativeStepTotal = (0, _d3Array.sum)(stepValues.map(function (d) {
      return d[yProp] < 0 ? d[yProp] : 0;
    }));

    stepValues.forEach(function (l) {
      if (l[yProp] < 0) {
        if (type === "linepercent" || type === "stackedpercent" || type === "stackedpercent-invert") {
          var percent = l[yProp] / negativeStepTotal;
          l.percent = percent;
          if (type === "linepercent") {
            l[yPropBottom] = l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = percent;
          } else {
            var adjustment = negativeStepTotal >= 0 ? 0 : percent;
            l[yPropBottom] = negativeStepTotal === 0 ? 0 : -(negativeOffset / negativeStepTotal);
            l[yPropTop] = l[yPropBottom] - adjustment;
            l[yPropMiddle] = l[yPropBottom] - adjustment / 2;
          }
        } else {
          l[yPropBottom] = negativeOffset;
          l[yPropTop] = negativeOffset + l[yProp];
          l[yPropMiddle] = negativeOffset + l[yProp] / 2;
        }
        negativeOffset += l[yProp];
      } else {
        if (type === "linepercent" || type === "stackedpercent" || type === "stackedpercent-invert") {
          var _percent = l[yProp] / positiveStepTotal;
          l.percent = _percent;

          if (type === "linepercent") {
            l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = _percent;
          } else {
            var _adjustment = positiveStepTotal <= 0 ? 0 : _percent;
            l[yPropBottom] = positiveStepTotal === 0 ? 0 : positiveOffset / positiveStepTotal;
            l[yPropTop] = l[yPropBottom] + _adjustment;
            l[yPropMiddle] = l[yPropBottom] + _adjustment / 2;
          }
        } else {
          l[yPropBottom] = positiveOffset;
          l[yPropTop] = positiveOffset + l[yProp];
          l[yPropMiddle] = positiveOffset + l[yProp] / 2;
        }
        positiveOffset += l[yProp];
      }
    });
  });

  return data;
};

var lineChart = exports.lineChart = function lineChart(_ref5) {
  var data = _ref5.data,
      y1 = _ref5.y1,
      yPropTop = _ref5.yPropTop,
      yPropMiddle = _ref5.yPropMiddle,
      yPropBottom = _ref5.yPropBottom;

  if (y1) {
    data.forEach(function (d) {
      d.data.forEach(function (p) {
        p[yPropBottom] = y1(p);
        p[yPropMiddle] = p[yPropBottom] + p[yPropTop] / 2;
      });
    });
  }

  return data;
};

var bumpChart = exports.bumpChart = function bumpChart(_ref6) {
  var _ref6$type = _ref6.type,
      type = _ref6$type === undefined ? "bumpline" : _ref6$type,
      data = _ref6.data,
      xProp = _ref6.xProp,
      yProp = _ref6.yProp,
      yPropMiddle = _ref6.yPropMiddle,
      yPropTop = _ref6.yPropTop,
      yPropBottom = _ref6.yPropBottom;

  var uniqXValues = [].concat(_toConsumableArray(new Set(data.map(function (d) {
    return d.data.map(function (p) {
      return datesForUnique(p[xProp]);
    });
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []))));

  var bumpSort = function bumpSort(a, b) {
    if (a[yProp] > b[yProp]) {
      return 1;
    }
    if (a[yProp] < b[yProp]) {
      return -1;
    }
    return -1;
  };
  if (type === "bumparea-invert" || type === "bumpline-invert") {
    bumpSort = function bumpSort(a, b) {
      if (a[yProp] < b[yProp]) {
        return 1;
      }
      if (a[yProp] > b[yProp]) {
        return -1;
      }
      return -1;
    };
  }

  uniqXValues.forEach(function (xValue) {
    var negativeOffset = 0;
    var positiveOffset = 0;

    data.map(function (d) {
      return d.data.filter(function (p) {
        return datesForUnique(p[xProp]) === xValue;
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []).sort(bumpSort).forEach(function (l, rank) {
      //determine ranking and offset by the number of less than this one at each step
      l._XYFrameRank = rank;
      if (type === "bumparea" || type === "bumparea-invert") {
        if (l[yProp] < 0) {
          l[yPropTop] = negativeOffset + l[yProp];
          l[yPropMiddle] = negativeOffset + l[yProp] / 2;
          l[yPropBottom] = negativeOffset;
          negativeOffset += l[yProp];
        } else {
          l[yPropTop] = positiveOffset + l[yProp];
          l[yPropMiddle] = positiveOffset + l[yProp] / 2;
          l[yPropBottom] = positiveOffset;
          positiveOffset += l[yProp];
        }
      } else {
        l[yProp] = rank;
        l[yPropTop] = rank;
        l[yPropBottom] = rank;
      }
    });
  });

  return data;
};

var dividedLine = exports.dividedLine = function dividedLine(parameters, points) {
  var searchIterations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  var currentParameters = parameters(points[0], 0);
  var currentPointsArray = [];
  var dividedLinesData = [{ key: currentParameters, points: currentPointsArray }];
  points.forEach(function (point, pointI) {
    var newParameters = parameters(point, pointI);

    var matchingParams = newParameters === currentParameters;
    var stringNewParams = JSON.stringify(newParameters);
    var stringCurrentParams = JSON.stringify(currentParameters);

    if ((typeof currentParameters === "undefined" ? "undefined" : _typeof(currentParameters)) === "object") {
      matchingParams = stringNewParams === stringCurrentParams;
    }

    if (matchingParams) {
      currentPointsArray.push(point);
    } else {
      var lastPoint = currentPointsArray[currentPointsArray.length - 1];
      var pointA = lastPoint;
      var pointB = point;
      var stringBParams = stringNewParams;

      var x = 0;
      while (x < searchIterations && stringNewParams === stringBParams) {
        var keys = Object.keys(pointA);
        var findPoints = simpleSearchFunction({
          pointA: pointA,
          pointB: pointB,
          currentParameters: currentParameters,
          parameters: parameters,
          keys: keys
        });
        pointA = findPoints[0];
        pointB = findPoints[1];
        stringBParams = JSON.stringify(parameters(pointB));
        x++;
      }
      currentPointsArray.push(pointB);
      currentPointsArray = [pointB, point];
      dividedLinesData.push({ key: newParameters, points: currentPointsArray });
      currentParameters = newParameters;
    }
  });
  return dividedLinesData;
};

function simpleSearchFunction(_ref7) {
  var pointA = _ref7.pointA,
      pointB = _ref7.pointB,
      currentParameters = _ref7.currentParameters,
      parameters = _ref7.parameters,
      keys = _ref7.keys;

  var betweenPoint = {};
  keys.forEach(function (key) {
    betweenPoint[key] = typeof pointA[key] === "number" ? (pointA[key] + pointB[key]) / 2 : undefined;
  });
  var stringBetween = JSON.stringify(parameters(betweenPoint));
  var stringCurrent = JSON.stringify(currentParameters);

  if (stringBetween === stringCurrent) {
    return [betweenPoint, pointB];
  }
  return [pointA, betweenPoint];
}

function funnelize(_ref8) {
  var data = _ref8.data,
      steps = _ref8.steps,
      key = _ref8.key;

  var funnelData = [];
  if (!Array.isArray(data)) {
    data = [data];
  }
  if (!steps) {
    steps = data.map(function (d) {
      return Object.keys(d);
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);
  }

  data.forEach(function (datum, i) {
    var datumKey = key ? datum[key] : i;
    steps.forEach(function (step) {
      var funnelDatum = { funnelKey: datumKey };
      funnelDatum.stepName = step;
      funnelDatum.stepValue = datum[step] ? datum[step] : 0;
      funnelData.push(funnelDatum);
    });
  });

  return funnelData;
}

function relativeY(_ref9) {
  var point = _ref9.point,
      lines = _ref9.lines,
      projectedYMiddle = _ref9.projectedYMiddle,
      projectedY = _ref9.projectedY,
      projectedX = _ref9.projectedX,
      xAccessor = _ref9.xAccessor,
      yAccessor = _ref9.yAccessor,
      yScale = _ref9.yScale,
      xScale = _ref9.xScale,
      idAccessor = _ref9.idAccessor;

  if (idAccessor(point)) {
    var thisLine = lines.data.find(function (l) {
      return idAccessor(l) === idAccessor(point);
    });
    if (!thisLine) {
      return null;
    }
    var thisPoint = thisLine.data.find(function (p) {
      return xScale(p[projectedX]) === xScale(xAccessor(point));
    });

    if (!thisPoint) {
      return null;
    }
    point = thisPoint;
  }
  return yScale(point[projectedYMiddle] || point[projectedY] || yAccessor(point) || 0);
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(292);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(10);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(166);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(87);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _axis = __webpack_require__(90);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

function formatValue(value, props) {
  if (props.tickFormat) {
    return props.tickFormat(value);
  }
  if (value.toString) {
    return value.toString();
  }
  return value;
}

var Axis = function (_React$Component) {
  _inherits(Axis, _React$Component);

  function Axis(props) {
    _classCallCheck(this, Axis);

    var _this = _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, props));

    _this.state = { hoverAnnotation: 0 };
    return _this;
  }

  _createClass(Axis, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var position = this.props.position || [0, 0];
      var _props = this.props,
          rotate = _props.rotate,
          label = _props.label,
          _props$orient = _props.orient,
          orient = _props$orient === undefined ? "left" : _props$orient,
          _props$tickFormat = _props.tickFormat,
          tickFormat = _props$tickFormat === undefined ? function (d) {
        return d;
      } : _props$tickFormat,
          size = _props.size,
          _props$width = _props.width,
          width = _props$width === undefined ? size && size[0] || 0 : _props$width,
          _props$height = _props.height,
          height = _props$height === undefined ? size && size[1] || 0 : _props$height,
          className = _props.className,
          padding = _props.padding,
          tickValues = _props.tickValues,
          scale = _props.scale,
          ticks = _props.ticks,
          footer = _props.footer,
          tickSize = _props.tickSize,
          tickLineGenerator = _props.tickLineGenerator,
          _props$baseline = _props.baseline,
          baseline = _props$baseline === undefined ? true : _props$baseline,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$margin;


      if (this.props.format) {
        console.error("axis `format` has been deprecated use `tickFormat`");
      }

      var axisTickLines = void 0;
      var axisParts = this.props.axisParts;

      if (!axisParts) {
        axisParts = (0, _axis.axisPieces)({
          padding: padding,
          tickValues: tickValues,
          scale: scale,
          ticks: ticks,
          orient: orient,
          size: [width, height],
          footer: footer,
          tickSize: tickSize
        });
        axisTickLines = _react2.default.createElement(
          "g",
          { className: "axis " + className },
          (0, _axis.axisLines)({ axisParts: axisParts, orient: orient, tickLineGenerator: tickLineGenerator })
        );
      }
      if (axisParts.length === 0) {
        return null;
      }

      var hoverWidth = 50;
      var hoverHeight = height;
      var hoverX = -50;
      var hoverY = 0;
      var baselineX = 0;
      var baselineY = 0;
      var baselineX2 = 0;
      var baselineY2 = height;

      var hoverFunction = function hoverFunction(e) {
        return _this2.setState({ hoverAnnotation: e.nativeEvent.offsetY });
      };
      var circleX = 25;
      var textX = -25;
      var textY = 18;
      var lineWidth = width + 25;
      var lineHeight = 0;
      var circleY = this.state.hoverAnnotation;
      var annotationOffset = 0;
      var annotationType = "y";

      switch (orient) {
        case "right":
          position = [position[0], position[1]];
          hoverX = width;
          baselineX2 = baselineX = width;
          annotationOffset = margin.top;
          lineWidth = -width - 25;
          textX = 5;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetY - annotationOffset
            });
          };
          break;
        case "top":
          position = [position[0], 0];
          hoverWidth = width;
          hoverHeight = 50;
          hoverY = -50;
          hoverX = 0;
          annotationOffset = margin.left;
          annotationType = "x";
          baselineX2 = width;
          baselineY2 = 0;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetX - annotationOffset
            });
          };
          circleX = this.state.hoverAnnotation;
          circleY = 25;
          textX = 0;
          textY = -10;
          lineWidth = 0;
          lineHeight = height + 25;
          break;
        case "bottom":
          position = [position[0], position[1]];
          position = [position[0], 0];
          hoverWidth = width;
          hoverHeight = 50;
          baselineY = baselineY2 = hoverY = height;
          baselineX = hoverX = 0;
          baselineX2 = width;
          annotationOffset = margin.left;

          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetX - annotationOffset
            });
          };
          circleX = this.state.hoverAnnotation;
          circleY = 25;
          textX = 0;
          textY = 15;
          lineWidth = 0;
          lineHeight = -height - 25;
          annotationType = "x";
          break;
        default:
          position = [position[0], position[1]];
          annotationOffset = margin.top;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetY - annotationOffset
            });
          };
      }

      var annotationBrush = void 0;

      if (this.props.annotationFunction) {
        var formattedValue = formatValue(this.props.scale.invert(this.state.hoverAnnotation), this.props);
        var hoverGlyph = this.props.glyphFunction ? this.props.glyphFunction({
          lineHeight: lineHeight,
          lineWidth: lineWidth,
          value: this.props.scale.invert(this.state.hoverAnnotation)
        }) : _react2.default.createElement(
          "g",
          null,
          _react2.default.isValidElement(formattedValue) ? _react2.default.createElement(
            "g",
            { transform: "translate(" + textX + "," + textY + ")" },
            formattedValue
          ) : _react2.default.createElement(
            "text",
            { x: textX, y: textY },
            formattedValue
          ),
          _react2.default.createElement("circle", { r: 5 }),
          _react2.default.createElement("line", { x1: lineWidth, y1: lineHeight, style: { stroke: "black" } })
        );
        var annotationSymbol = this.state.hoverAnnotation ? _react2.default.createElement(
          "g",
          {
            style: { pointerEvents: "none" },
            transform: "translate(" + circleX + "," + circleY + ")"
          },
          hoverGlyph
        ) : null;

        annotationBrush = _react2.default.createElement(
          "g",
          {
            className: "annotation-brush",
            transform: "translate(" + hoverX + "," + hoverY + ")"
          },
          _react2.default.createElement("rect", {
            style: { fillOpacity: 0 },
            height: hoverHeight,
            width: hoverWidth,
            onMouseMove: hoverFunction,
            onClick: function onClick() {
              return _this2.props.annotationFunction({
                className: "dynamic-axis-annotation",
                type: annotationType,
                value: _this2.props.scale.invert(_this2.state.hoverAnnotation)
              });
            },
            onMouseOut: function onMouseOut() {
              return _this2.setState({ hoverAnnotation: undefined });
            }
          }),
          annotationSymbol
        );
      }

      var axisTitle = void 0;

      var axisTickLabels = (0, _axis.axisLabels)({
        tickFormat: tickFormat,
        axisParts: axisParts,
        orient: orient,
        rotate: rotate
      });
      if (label) {
        var labelName = label.name || label;
        var labelPosition = label.position || {};
        var locationMod = labelPosition.location || "outside";
        var anchorMod = labelPosition.anchor || "middle";
        var distance = label.locationDistance;

        var rotateHash = {
          left: -90,
          right: 90,
          top: 0,
          bottom: 0
        };

        var rotation = labelPosition.rotation || rotateHash[orient];

        var positionHash = {
          left: {
            start: [0, size[1]],
            middle: [0, size[1] / 2],
            end: [0, 0],
            inside: [distance || 15, 0],
            outside: [-(distance || 45), 0]
          },
          right: {
            start: [size[0] + 0, size[1]],
            middle: [size[0] + 0, size[1] / 2],
            end: [size[0] + 0, 0],
            inside: [-(distance || 15), 0],
            outside: [distance || 45, 0]
          },
          top: {
            start: [0, 0],
            middle: [0 + size[0] / 2, 0],
            end: [0 + size[0], 0],
            inside: [0, distance || 15],
            outside: [0, -(distance || 40)]
          },
          bottom: {
            start: [0, size[1]],
            middle: [0 + size[0] / 2, size[1]],
            end: [0 + size[0], size[1]],
            inside: [0, -(distance || 5)],
            outside: [0, distance || 50]
          }
        };

        var translation = positionHash[orient][anchorMod];
        var location = positionHash[orient][locationMod];

        translation[0] = translation[0] + location[0];
        translation[1] = translation[1] + location[1];

        if (anchorMod === "start" && orient === "right") {
          anchorMod = "end";
        } else if (anchorMod === "end" && orient === "right") {
          anchorMod = "start";
        }

        axisTitle = _react2.default.createElement(
          "g",
          {
            className: "axis-title",
            transform: "translate(" + [translation[0] + position[0], translation[1] + position[1]] + ") rotate(" + rotation + ")"
          },
          _react2.default.isValidElement(labelName) ? labelName : _react2.default.createElement(
            "text",
            { textAnchor: anchorMod },
            labelName
          )
        );
      }

      var axisAriaLabel = orient + " axis " + (axisParts && axisParts.length > 0 && "from " + tickFormat(axisParts[0].value, 0) + " to " + tickFormat(axisParts[axisParts.length - 1].value, axisParts.length - 1) || "without ticks");

      return _react2.default.createElement(
        "g",
        { className: className, "aria-label": axisAriaLabel },
        annotationBrush,
        axisTickLabels,
        axisTickLines,
        baseline ? _react2.default.createElement("line", {
          key: "baseline",
          className: "axis-baseline",
          stroke: "black",
          strokeLinecap: "square",
          x1: baselineX,
          x2: baselineX2,
          y1: baselineY,
          y2: baselineY2
        }) : null,
        axisTitle
      );
    }
  }]);

  return Axis;
}(_react2.default.Component);

Axis.propTypes = {
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  orient: _propTypes2.default.string,
  position: _propTypes2.default.array,
  size: _propTypes2.default.array.isRequired,
  rotate: _propTypes2.default.number,
  scale: _propTypes2.default.func.isRequired,
  annotationFunction: _propTypes2.default.func,
  format: _propTypes2.default.string,
  tickFormat: _propTypes2.default.func,
  tickValues: _propTypes2.default.array,
  padding: _propTypes2.default.number,
  baseline: _propTypes2.default.bool,
  ticks: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number]),
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])
};

exports.default = Axis;
module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLaidOutPieces = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pointOnArcAtAngle = pointOnArcAtAngle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pointOnArcAtAngle(center, angle, distance) {
  var radians = Math.PI * (angle + 0.75) * 2;

  var xPosition = center[0] + distance * Math.cos(radians);
  var yPosition = center[1] + distance * Math.sin(radians);

  return [xPosition, yPosition];
}

var renderLaidOutPieces = exports.renderLaidOutPieces = function renderLaidOutPieces(_ref) {
  var data = _ref.data,
      shouldRender = _ref.shouldRender,
      canvasRender = _ref.canvasRender,
      canvasDrawing = _ref.canvasDrawing,
      styleFn = _ref.styleFn,
      classFn = _ref.classFn,
      baseMarkProps = _ref.baseMarkProps,
      renderKeyFn = _ref.renderKeyFn,
      ariaLabel = _ref.ariaLabel;

  if (!shouldRender) return null;
  var renderedPieces = [];
  data.forEach(function (d, i) {
    if (canvasRender && canvasRender(d) === true) {
      var canvasPiece = {
        baseClass: "orframe-piece",
        tx: d.renderElement.tx || 0,
        ty: d.renderElement.ty || 0,
        d: d.piece,
        i: i,
        markProps: d.renderElement || d,
        styleFn: styleFn,
        classFn: classFn
      };
      canvasDrawing.push(canvasPiece);
    } else {
      if (_react2.default.isValidElement(d.renderElement || d)) {
        renderedPieces.push(d.renderElement || d);
      } else {
        /*ariaLabel.items*/
        var pieceAriaLabel = d.o + " " + ariaLabel.items + " value " + d.piece.value;
        renderedPieces.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          key: renderKeyFn ? renderKeyFn(d.piece) : d.renderKey || "piece-render-" + i
        }, d.renderElement || d, {
          "aria-label": pieceAriaLabel
        })));
      }
    }
  });

  return renderedPieces;
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cluster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_2__src_pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_5__src_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_6__src_stratify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_7__src_tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__["a"]; });

















/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDataExtent = exports.stringToFn = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lineDrawing = __webpack_require__(46);

var _coordinateNames = __webpack_require__(199);

var _areaDrawing = __webpack_require__(96);

var _d3Array = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var builtInTransformations = {
  "stackedarea": _lineDrawing.stackedArea,
  "stackedarea-invert": _lineDrawing.stackedArea,
  "stackedpercent": _lineDrawing.stackedArea,
  "stackedpercent-invert": _lineDrawing.stackedArea,
  "linepercent": _lineDrawing.stackedArea,
  "difference": _lineDrawing.differenceLine,
  "bumparea": _lineDrawing.bumpChart,
  "bumpline": _lineDrawing.bumpChart,
  "bumparea-invert": _lineDrawing.bumpChart,
  "line": _lineDrawing.lineChart
};

var stringToFn = exports.stringToFn = function stringToFn(accessor, defaultAccessor, raw) {
  if (!accessor) {
    return defaultAccessor;
  } else if (typeof accessor !== "function" && raw) {
    return function () {
      return accessor;
    };
  }
  return typeof accessor !== "function" ? function (d) {
    return d[accessor];
  } : accessor;
};

var calculateDataExtent = exports.calculateDataExtent = function calculateDataExtent(_ref) {
  var lineDataAccessor = _ref.lineDataAccessor,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor,
      areas = _ref.areas,
      points = _ref.points,
      lines = _ref.lines,
      lineType = _ref.lineType,
      showLinePoints = _ref.showLinePoints,
      xExtent = _ref.xExtent,
      yExtent = _ref.yExtent,
      invertX = _ref.invertX,
      invertY = _ref.invertY,
      areaDataAccessor = _ref.areaDataAccessor,
      projection = _ref.projection,
      areaType = _ref.areaType,
      size = _ref.adjustedSize,
      xScaleType = _ref.xScaleType,
      yScaleType = _ref.yScaleType,
      _ref$defined = _ref.defined,
      defined = _ref$defined === undefined ? function () {
    return true;
  } : _ref$defined;

  lineDataAccessor = stringToFn(lineDataAccessor, function (d) {
    return Array.isArray(d) ? d : d.coordinates;
  });

  xAccessor = stringToFn(xAccessor, function (d) {
    return d[0];
  });
  yAccessor = stringToFn(yAccessor, function (d) {
    return d[1];
  });
  areaDataAccessor = stringToFn(areaDataAccessor, function (d) {
    return Array.isArray(d) ? d : d.coordinates;
  });

  var fullDataset = [];
  var initialProjectedLines = [];

  var projectedPoints = [],
      projectedLines = [],
      projectedAreas = [];
  if (points) {
    projectedPoints = points.map(function (d, i) {
      var _ref2;

      var x = xAccessor(d, i);
      var y = yAccessor(d, i);
      return _ref2 = {}, _defineProperty(_ref2, _coordinateNames.projectedX, x), _defineProperty(_ref2, _coordinateNames.projectedY, y), _defineProperty(_ref2, "data", d), _ref2;
    });
    fullDataset = projectedPoints;
  }
  if (lines) {
    initialProjectedLines = (0, _lineDrawing.projectLineData)({
      data: lines,
      lineDataAccessor: lineDataAccessor,
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom,
      xAccessor: xAccessor,
      yAccessor: yAccessor
    });

    var optionsObject = {
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropMiddle: _coordinateNames.projectedYMiddle,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom
    };

    projectedLines = lineTransformation(lineType, optionsObject)(initialProjectedLines);

    projectedLines.forEach(function (d) {
      fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(d.data.filter(function (p, q) {
        return defined(_extends({}, p.data, p), q);
      }).map(function (p) {
        var _mappedP;

        var mappedP = (_mappedP = {
          parentLine: d
        }, _defineProperty(_mappedP, _coordinateNames.projectedY, p[_coordinateNames.projectedY]), _defineProperty(_mappedP, _coordinateNames.projectedX, p[_coordinateNames.projectedX]), _defineProperty(_mappedP, _coordinateNames.projectedYTop, p[_coordinateNames.projectedYTop]), _defineProperty(_mappedP, _coordinateNames.projectedYMiddle, p[_coordinateNames.projectedYMiddle]), _defineProperty(_mappedP, _coordinateNames.projectedYBottom, p[_coordinateNames.projectedYBottom]), _defineProperty(_mappedP, "data", p.data), _mappedP);
        if (p.percent) {
          mappedP.percent = p.percent;
        }
        return mappedP;
      })));
    });
  }

  if (areas) {
    projectedAreas = (0, _lineDrawing.projectAreaData)({
      data: areas,
      areaDataAccessor: areaDataAccessor,
      projection: projection,
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom,
      xAccessor: xAccessor,
      yAccessor: yAccessor
    });
    projectedAreas.forEach(function (d) {
      var baseData = areaDataAccessor(d);
      if (d._xyfCoordinates[0][0][0]) {
        d._xyfCoordinates[0].forEach(function (multi) {
          fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(multi.map(function (p, q) {
            var _extends2;

            return _extends({ parentArea: d }, baseData[q], (_extends2 = {}, _defineProperty(_extends2, _coordinateNames.projectedX, p[0]), _defineProperty(_extends2, _coordinateNames.projectedY, p[1]), _extends2));
          })));
        });
      } else {
        fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(d._xyfCoordinates.map(function (p, q) {
          var _extends3;

          return _extends({ parentArea: d }, baseData[q], (_extends3 = {}, _defineProperty(_extends3, _coordinateNames.projectedX, p[0]), _defineProperty(_extends3, _coordinateNames.projectedY, p[1]), _extends3));
        })));
      }
    });
  }

  if (showLinePoints) {
    projectedPoints = fullDataset.map(function (d) {
      return _extends({}, d, _defineProperty({}, _coordinateNames.projectedY, d[_coordinateNames.projectedYTop] || d[_coordinateNames.projectedYBottom] || d.y));
    });
  }

  var calculatedXExtent = (0, _d3Array.extent)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedX];
  }));
  var calculatedYExtent = [(0, _d3Array.min)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedYBottom] === undefined ? d[_coordinateNames.projectedY] : Math.min(d[_coordinateNames.projectedYTop], d[_coordinateNames.projectedYBottom]);
  })), (0, _d3Array.max)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedYTop] === undefined ? d[_coordinateNames.projectedY] : Math.max(d[_coordinateNames.projectedYBottom], d[_coordinateNames.projectedYTop]);
  }))];

  var xMin = xExtent && xExtent[0] !== undefined ? xExtent[0] : calculatedXExtent[0];
  var xMax = xExtent && xExtent[1] !== undefined ? xExtent[1] : calculatedXExtent[1];

  var yMin = yExtent && yExtent[0] !== undefined ? yExtent[0] : calculatedYExtent[0];
  var yMax = yExtent && yExtent[1] !== undefined ? yExtent[1] : calculatedYExtent[1];

  var finalYExtent = [yMin, yMax];
  var finalXExtent = [xMin, xMax];

  if (invertX) {
    finalXExtent = [finalXExtent[1], finalXExtent[0]];
  }
  if (invertY) {
    finalYExtent = [finalYExtent[1], finalYExtent[0]];
  }

  if (areaType && (areaType === "contour" || areaType.type && areaType.type === "contour")) {
    projectedAreas = (0, _areaDrawing.contouring)({
      areaType: areaType,
      data: projectedAreas,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      finalXExtent: finalXExtent,
      finalYExtent: finalYExtent
    });
  } else if (areaType && (areaType === "hexbin" || areaType.type && areaType.type === "hexbin")) {
    projectedAreas = (0, _areaDrawing.hexbinning)({
      areaType: areaType,
      data: projectedAreas,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      finalXExtent: finalXExtent,
      finalYExtent: finalYExtent,
      size: size,
      xScaleType: xScaleType,
      yScaleType: yScaleType
    });
    fullDataset = [].concat(_toConsumableArray(projectedAreas.map(function (d) {
      return d.data;
    })), _toConsumableArray(fullDataset.filter(function (d) {
      return !d.parentArea;
    })));
  } else if (areaType && (areaType === "heatmap" || areaType.type && areaType.type === "heatmap")) {
    projectedAreas = (0, _areaDrawing.heatmapping)({
      areaType: areaType,
      data: projectedAreas,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      finalXExtent: finalXExtent,
      finalYExtent: finalYExtent,
      size: size,
      xScaleType: xScaleType,
      yScaleType: yScaleType
    });

    fullDataset = [].concat(_toConsumableArray(projectedAreas.map(function (d) {
      return _extends({}, d);
    })), _toConsumableArray(fullDataset.filter(function (d) {
      return !d.parentArea;
    })));
  } else if (typeof areaType === "function" || areaType && areaType.type && typeof areaType.type === "function") {
    var areaFunction = areaType.type || areaType;

    projectedAreas = areaFunction({
      xExtent: finalXExtent,
      yExtent: finalYExtent,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      fullDataset: fullDataset,
      projectedAreas: projectedAreas
    });
  }

  return {
    xExtent: finalXExtent,
    yExtent: finalYExtent,
    projectedLines: projectedLines,
    projectedPoints: projectedPoints,
    projectedAreas: projectedAreas,
    fullDataset: fullDataset,
    calculatedXExtent: calculatedXExtent,
    calculatedYExtent: calculatedYExtent
  };
};

function lineTransformation() {
  var lineType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: "line" };
  var options = arguments[1];

  var differenceCatch = function differenceCatch(olineType, data) {
    return (lineType === "difference" || lineType.type && lineType.type === "difference") && data.length !== 2 ? "line" : olineType;
  };
  if (builtInTransformations[lineType]) {
    return function (data) {
      return builtInTransformations[differenceCatch(lineType, data)](_extends({
        type: lineType
      }, options, {
        data: data
      }));
    };
  }

  if (builtInTransformations[lineType.type]) {
    return function (data) {
      return builtInTransformations[differenceCatch(lineType.type, data)](_extends({}, lineType, options, {
        data: data
      }));
    };
  }

  //otherwise assume a function
  return function (data) {
    return lineType(_extends({}, options, { data: data }));
  };
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Force = __webpack_require__(200);

var _d3BboxCollide = __webpack_require__(531);

var _d3Scale = __webpack_require__(18);

var _d3Array = __webpack_require__(2);

var _jsx = __webpack_require__(103);

var _AnnotationLabel = __webpack_require__(116);

var _AnnotationLabel2 = _interopRequireDefault(_AnnotationLabel);

var _Frame = __webpack_require__(92);

var _Frame2 = _interopRequireDefault(_Frame);

var _DownloadButton = __webpack_require__(91);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _frameFunctions = __webpack_require__(36);

var _pieceDrawing = __webpack_require__(55);

var _networkDrawing = __webpack_require__(546);

var _dataFunctions = __webpack_require__(58);

var _downloadDataMapping = __webpack_require__(102);

var _d3SankeyCircular = __webpack_require__(560);

var _d3Chord = __webpack_require__(563);

var _d3Shape = __webpack_require__(7);

var _d3Hierarchy = __webpack_require__(56);

var _frame_props = __webpack_require__(104);

var _networkframeRules = __webpack_require__(568);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var basicMiddle = function basicMiddle(d) {
  return {
    edge: d,
    x: (d.source.x + d.target.x) / 2,
    y: (d.source.y + d.target.y) / 2
  };
};

var edgePointHash = {
  sankey: function sankey(d) {
    return {
      edge: d,
      x: (d.source.x1 + d.target.x0) / 2,
      y: d.circularPathData ? d.circularPathData.verticalFullExtent : ((d.y0 + d.y1) / 2 + (d.y0 + d.y1) / 2) / 2
    };
  },
  force: basicMiddle,
  tree: basicMiddle,
  cluster: basicMiddle
};

var hierarchicalTypeHash = {
  dendrogram: _d3Hierarchy.tree,
  tree: _d3Hierarchy.tree,
  circlepack: _d3Hierarchy.pack,
  cluster: _d3Hierarchy.cluster,
  treemap: _d3Hierarchy.treemap,
  partition: _d3Hierarchy.partition
};

var hierarchicalCustomNodeHash = {
  partition: _networkDrawing.hierarchicalRectNodeGenerator,
  treemap: _networkDrawing.hierarchicalRectNodeGenerator,
  circlepack: _networkDrawing.circleNodeGenerator
};

var hierarchicalProjectable = {
  partition: true,
  cluster: true,
  tree: true,
  dendrogram: true
};

var radialProjectable = {
  partition: true,
  cluster: true,
  tree: true,
  dendrogram: true

  /*
  const customEdgeHashProject = {
    offset: glyphProject.offset,
    parallel: glyphProject.parallel
  }
  
  const customEdgeHashMutate = {
    particle: glyphMutate.particle
  }
  */

};function breadthFirstCompontents(baseNodes, hash) {
  var componentHash = {
    "0": { componentNodes: [], componentEdges: [] }
  };
  var components = [componentHash["0"]];

  var componentID = 0;

  traverseNodesBF(baseNodes, true);

  function traverseNodesBF(nodes, top) {
    nodes.forEach(function (node) {
      var hashNode = hash.get(node);
      if (!hashNode) {
        componentHash["0"].componentNodes.push(node);
      } else if (hashNode.component === null) {
        var _componentHash$compon;

        if (top === true) {
          componentID++;
          componentHash[componentID] = {
            componentNodes: [],
            componentEdges: []
          };
          components.push(componentHash[componentID]);
        }

        hashNode.component = componentID;
        componentHash[componentID].componentNodes.push(node);
        (_componentHash$compon = componentHash[componentID].componentEdges).push.apply(_componentHash$compon, _toConsumableArray(hashNode.edges));
        var traversibleNodes = [].concat(_toConsumableArray(hashNode.connectedNodes));
        traverseNodesBF(traversibleNodes);
      }
    });
  }

  return components.sort(function (a, b) {
    return b.componentNodes.length - a.componentNodes.length;
  });
}

var projectedCoordinateNames = { y: "y", x: "x" };

function recursiveIDAccessor(idAccessor, node, accessorString) {
  if (node.parent) {
    accessorString = accessorString + "-" + recursiveIDAccessor(idAccessor, node.parent, accessorString);
  }
  return accessorString + "-" + idAccessor(node.data);
}

var sankeyOrientHash = {
  left: _d3SankeyCircular.sankeyLeft,
  right: _d3SankeyCircular.sankeyRight,
  center: _d3SankeyCircular.sankeyCenter,
  justify: _d3SankeyCircular.sankeyJustify
};

var xScale = (0, _d3Scale.scaleIdentity)();
var yScale = (0, _d3Scale.scaleIdentity)();

var matrixify = function matrixify(_ref) {
  var edgeHash = _ref.edgeHash,
      nodes = _ref.nodes,
      edgeWidthAccessor = _ref.edgeWidthAccessor,
      nodeIDAccessor = _ref.nodeIDAccessor;

  var matrix = [];
  nodes.forEach(function (nodeSource) {
    var nodeSourceID = nodeIDAccessor(nodeSource);
    var sourceRow = [];
    matrix.push(sourceRow);
    nodes.forEach(function (nodeTarget) {
      var nodeTargetID = nodeIDAccessor(nodeTarget);
      var theEdge = edgeHash.get(nodeSourceID + "|" + nodeTargetID);
      if (theEdge) {
        sourceRow.push(edgeWidthAccessor(theEdge));
      } else {
        sourceRow.push(0);
      }
    });
  });
  return matrix;
};

var NetworkFrame = (_temp = _class = function (_React$Component) {
  _inherits(NetworkFrame, _React$Component);

  function NetworkFrame(props) {
    _classCallCheck(this, NetworkFrame);

    var _this = _possibleConstructorReturn(this, (NetworkFrame.__proto__ || Object.getPrototypeOf(NetworkFrame)).call(this, props));

    _this.calculateNetworkFrame = _this.calculateNetworkFrame.bind(_this);
    _this.defaultNetworkHTMLRule = _this.defaultNetworkHTMLRule.bind(_this);
    _this.defaultNetworkSVGRule = _this.defaultNetworkSVGRule.bind(_this);

    _this.graphSettings = {
      numberOfNodes: 0,
      numberOfEdges: 0,
      type: "empty-start"
    };
    _this.state = {
      nodeData: null,
      edgeData: null,
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      projectedNodes: undefined,
      projectedEdges: undefined,
      renderNumber: 0,
      voronoiHover: null,
      nodeLabelAnnotations: []
    };

    _this.oAccessor = null;
    _this.rAccessor = null;
    _this.oScale = null;
    _this.rScale = null;
    return _this;
  }

  _createClass(NetworkFrame, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object.keys(this.props).forEach(function (d) {
        if (!_frame_props.networkframeproptypes[d]) {
          if (_frame_props.xyframeproptypes[d]) {
            console.error(d + " is an XYFrame prop are you sure you're using the right frame?");
          } else if (_frame_props.ordinalframeproptypes[d]) {
            console.error(d + " is an OrdinalFrame prop are you sure you're using the right frame?");
          } else {
            console.error(d + " is not a valid NetworkFrame prop");
          }
        }
      });
      this.calculateNetworkFrame(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.projectedNodes && !this.state.projectedEdges) {
        this.calculateNetworkFrame(nextProps);
      } else if (this.props.size[0] !== nextProps.size[0] || this.props.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.networkFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        this.calculateNetworkFrame(nextProps);
      }
    }
  }, {
    key: "onNodeClick",
    value: function onNodeClick(d, i) {
      if (this.props.onNodeClick) {
        this.props.onNodeClick(d, i);
      }
    }
  }, {
    key: "onNodeEnter",
    value: function onNodeEnter(d, i) {
      if (this.props.onNodeEnter) {
        this.props.onNodeEnter(d, i);
      }
    }
  }, {
    key: "onNodeOut",
    value: function onNodeOut(d, i) {
      if (this.props.onNodeOut) {
        this.props.onNodeOut(d, i);
      }
    }
  }, {
    key: "calculateNetworkFrame",
    value: function calculateNetworkFrame(currentProps) {
      var _this3 = this;

      var graph = currentProps.graph,
          _currentProps$nodes = currentProps.nodes,
          nodes = _currentProps$nodes === undefined ? graph && graph.nodes || [] : _currentProps$nodes,
          _currentProps$edges = currentProps.edges,
          edges = _currentProps$edges === undefined ? graph && graph.edges || graph || [] : _currentProps$edges,
          networkType = currentProps.networkType,
          size = currentProps.size,
          nodeStyle = currentProps.nodeStyle,
          nodeClass = currentProps.nodeClass,
          canvasNodes = currentProps.canvasNodes,
          edgeStyle = currentProps.edgeStyle,
          edgeClass = currentProps.edgeClass,
          canvasEdges = currentProps.canvasEdges,
          nodeRenderMode = currentProps.nodeRenderMode,
          edgeRenderMode = currentProps.edgeRenderMode,
          nodeLabels = currentProps.nodeLabels,
          title = currentProps.title;
      //    const eventListenersGenerator = generatenetworkFrameEventListeners(customHoverBehavior, customClickBehavior)

      var _edgeType = currentProps.edgeType,
          customNodeIcon = currentProps.customNodeIcon,
          customEdgeIcon = currentProps.customEdgeIcon;
      var hoverAnnotation = currentProps.hoverAnnotation;


      var networkSettings = void 0;

      var nodeHierarchicalIDFill = {};

      if (typeof networkType === "string") {
        networkSettings = { type: networkType, iterations: 500 };
      } else {
        networkSettings = networkType;
      }

      var nodeIDAccessor = (0, _dataFunctions.stringToFn)(currentProps.nodeIDAccessor, function (d) {
        return d.id;
      });
      var sourceAccessor = (0, _dataFunctions.stringToFn)(currentProps.sourceAccessor, function (d) {
        return d.source;
      });
      var targetAccessor = (0, _dataFunctions.stringToFn)(currentProps.targetAccessor, function (d) {
        return d.target;
      });
      var nodeSizeAccessor = typeof currentProps.nodeSizeAccessor === "number" ? function () {
        return currentProps.nodeSizeAccessor;
      } : (0, _dataFunctions.stringToFn)(currentProps.nodeSizeAccessor, function (d) {
        return d.r || 5;
      });
      var edgeWidthAccessor = (0, _dataFunctions.stringToFn)(currentProps.edgeWidthAccessor, function (d) {
        return d.weight || 1;
      });
      var nodeStyleFn = (0, _dataFunctions.stringToFn)(nodeStyle, function () {
        return {};
      }, true);
      var nodeClassFn = (0, _dataFunctions.stringToFn)(nodeClass, function () {
        return "";
      }, true);
      var nodeRenderModeFn = (0, _dataFunctions.stringToFn)(nodeRenderMode, undefined, true);
      var nodeCanvasRenderFn = (0, _dataFunctions.stringToFn)(canvasNodes, undefined, true);

      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var _state = this.state,
          projectedNodes = _state.projectedNodes,
          projectedEdges = _state.projectedEdges;


      var changedData = !this.state.projectedNodes || !this.state.projectedEdges || this.graphSettings.nodes !== currentProps.nodes || this.graphSettings.edges !== currentProps.edges || hierarchicalTypeHash[networkSettings.type];

      if (changedData) {
        this.edgeHash = new Map();
        this.nodeHash = new Map();
        projectedNodes = [];
        projectedEdges = [];
        nodes.forEach(function (node) {
          var id = nodeIDAccessor(node);
          _this3.nodeHash.set(id, node);
          _this3.nodeHash.set(node, node);
          projectedNodes.push(node);
          node.id = id;
          node.inDegree = 0;
          node.outDegree = 0;
          node.degree = 0;
        });

        var operationalEdges = edges;

        if (!Array.isArray(edges)) {
          this.hierarchicalNetwork = true;
          var rootNode = (0, _d3Hierarchy.hierarchy)(edges, networkSettings.hierarchyChildren);

          rootNode.sum(networkSettings.hierarchySum || function (d) {
            return d.value;
          });

          if (hierarchicalTypeHash[networkSettings.type]) {
            var layout = networkSettings.layout || hierarchicalTypeHash[networkSettings.type];
            var hierarchicalLayout = layout();
            var networkSettingKeys = Object.keys(networkSettings);

            networkSettingKeys.forEach(function (key) {
              if (hierarchicalLayout[key]) {
                hierarchicalLayout[key](networkSettings[key]);
              }
            });
            var layoutSize = networkSettings.projection === "horizontal" && hierarchicalProjectable[networkSettings.type] ? [adjustedSize[1], adjustedSize[0]] : adjustedSize;
            if (!networkSettings.nodeSize) {
              hierarchicalLayout.size(layoutSize);
            }
            hierarchicalLayout(rootNode);
          }

          operationalEdges = rootNode.descendants().filter(function (d) {
            return d.parent !== null;
          }).map(function (d) {
            return {
              source: _extends(d.parent, d.parent.data),
              target: _extends(d, d.data),
              depth: d.depth,
              weight: 1,
              value: 1,
              _NWFEdgeKey: nodeIDAccessor(d.data) + "-" + recursiveIDAccessor(nodeIDAccessor, d.parent, "")
            };
          });
        }
        operationalEdges.forEach(function (edge) {
          var source = sourceAccessor(edge);
          var target = targetAccessor(edge);
          var sourceTarget = [source, target];
          sourceTarget.forEach(function (nodeDirection) {
            if (!_this3.nodeHash.get(nodeDirection)) {
              var nodeObject = (typeof nodeDirection === "undefined" ? "undefined" : _typeof(nodeDirection)) === "object" ? _extends(nodeDirection, {
                degree: 0,
                inDegree: 0,
                outDegree: 0
              }) : {
                id: nodeDirection,
                inDegree: 0,
                outDegree: 0,
                degree: 0,
                createdByFrame: true
              };
              var nodeIDValue = nodeObject.id || nodeIDAccessor(nodeObject);
              nodeHierarchicalIDFill[nodeIDValue] ? nodeHierarchicalIDFill[nodeIDValue] += 1 : nodeHierarchicalIDFill[nodeIDValue] = 1;
              if (!nodeObject.id) {
                var nodeSuffix = nodeHierarchicalIDFill[nodeIDValue] === 1 ? "" : "-" + nodeHierarchicalIDFill[nodeIDValue];
                nodeObject.id = "" + nodeIDValue + nodeSuffix;
              }

              _this3.nodeHash.set(nodeDirection, nodeObject);
              projectedNodes.push(nodeObject);
            }
          });

          var edgeWeight = edge.weight || 1;
          _this3.nodeHash.get(target).inDegree += edgeWeight;
          _this3.nodeHash.get(source).outDegree += edgeWeight;
          _this3.nodeHash.get(target).degree += edgeWeight;
          _this3.nodeHash.get(source).degree += edgeWeight;

          var edgeKey = (nodeIDAccessor(source) || source) + "|" + (nodeIDAccessor(target) || target);
          var newEdge = _extends({}, edge, {
            source: _this3.nodeHash.get(source),
            target: _this3.nodeHash.get(target)
          });
          _this3.edgeHash.set(edgeKey, newEdge);
          projectedEdges.push(newEdge);
        });
      } else {
        this.edgeHash = new Map();
        projectedEdges.forEach(function (edge) {
          var edgeKey = (nodeIDAccessor(edge.source) || edge.source) + "|" + (nodeIDAccessor(edge.target) || edge.target);
          _this3.edgeHash.set(edgeKey, edge);
        });
      }

      if ((networkSettings.type === "sankey" || networkSettings.type === "flowchart") && (0, _networkDrawing.topologicalSort)(projectedNodes, projectedEdges) === null) {
        networkSettings.customSankey = _d3SankeyCircular.sankeyCircular;
      }
      networkSettings.width = size[0];
      networkSettings.height = size[1];

      var networkSettingsKeys = Object.keys(networkSettings);
      var networkSettingsChanged = false;

      networkSettingsKeys.forEach(function (key) {
        if (key !== "edgeType" && networkSettings[key] !== _this3.graphSettings[key]) {
          networkSettingsChanged = true;
        }
      });

      //Support bubble chart with circle pack and with force
      if (networkSettings.type === "sankey") {
        _edgeType = function edgeType(d) {
          return d.circular ? (0, _networkDrawing.circularAreaLink)(d) : _edgeType === "angled" ? (0, _networkDrawing.ribbonLink)(d) : (0, _networkDrawing.areaLink)(d);
        };

        customNodeIcon = customNodeIcon ? customNodeIcon : _networkDrawing.sankeyNodeGenerator;
      } else if (networkSettings.type === "chord") {
        customNodeIcon = (0, _networkDrawing.chordNodeGenerator)(size);
        customEdgeIcon = (0, _networkDrawing.chordEdgeGenerator)(size);
      } else if (networkSettings.type === "wordcloud") {
        customNodeIcon = customNodeIcon ? customNodeIcon : _networkDrawing.wordcloudNodeGenerator;
      } else if (hierarchicalTypeHash[networkSettings.type]) {
        if (hierarchicalCustomNodeHash[networkSettings.type]) {
          customNodeIcon = hierarchicalCustomNodeHash[networkSettings.type];
          customEdgeIcon = function customEdgeIcon() {
            return null;
          };
        }
        var radialSize = adjustedSize;
        var radialCenter = [radialSize[0] / 2, radialSize[1] / 2];
        if ((networkSettings.type === "partition" || networkSettings.type === "treemap") && networkSettings.projection === "radial") {
          customNodeIcon = (0, _networkDrawing.radialRectNodeGenerator)(radialSize, radialCenter);
        }

        projectedNodes.forEach(function (node) {
          if (node.x0 !== undefined) {
            node.x = (node.x0 + node.x1) / 2;
            node.y = (node.y0 + node.y1) / 2;
          }
          if (hierarchicalProjectable[networkSettings.type] && networkSettings.projection === "horizontal") {
            var ox = node.x;
            node.x = node.y;
            node.y = ox;

            if (node.x0 !== undefined) {
              var ox0 = node.x0;
              var ox1 = node.x1;
              node.x0 = node.y0;
              node.x1 = node.y1;
              node.y0 = ox0;
              node.y1 = ox1;
            }
          } else if (radialProjectable[networkSettings.type] && networkSettings.projection === "radial") {
            var radialPoint = (0, _pieceDrawing.pointOnArcAtAngle)(radialCenter, node.x / radialSize[0], node.y / 2);
            node.x = radialPoint[0];
            node.y = radialPoint[1];
          } else {
            node.x = node.x;
            node.y = node.y;
            if (node.x0 !== undefined) {
              node.x0 = node.x0;
              node.x1 = node.x1;
              node.y0 = node.y0;
              node.y1 = node.y1;
            }
          }
        });
      }

      if (changedData || networkSettingsChanged) {
        var components = [{
          componentNodes: projectedNodes,
          componentEdges: projectedEdges
        }];

        if (networkSettings.type === "chord") {
          var radius = size[1] / 2;
          var _networkSettings = networkSettings,
              _networkSettings$grou = _networkSettings.groupWidth,
              groupWidth = _networkSettings$grou === undefined ? 20 : _networkSettings$grou,
              _networkSettings$padA = _networkSettings.padAngle,
              padAngle = _networkSettings$padA === undefined ? 0.01 : _networkSettings$padA;

          var arcGenerator = (0, _d3Shape.arc)().innerRadius(radius - groupWidth).outerRadius(radius);

          var ribbonGenerator = (0, _d3Chord.ribbon)().radius(radius - groupWidth);

          var matrixifiedNetwork = matrixify({
            edgeHash: this.edgeHash,
            nodes: projectedNodes,
            edges: projectedEdges,
            edgeWidthAccessor: edgeWidthAccessor,
            nodeIDAccessor: nodeIDAccessor
          });

          var chordLayout = (0, _d3Chord.chord)().padAngle(padAngle);

          var chords = chordLayout(matrixifiedNetwork);
          var groups = chords.groups;

          groups.forEach(function (group) {
            var groupCentroid = arcGenerator.centroid(group);
            var groupD = arcGenerator(group);
            var groupNode = projectedNodes[group.index];
            groupNode.d = groupD;
            groupNode.index = group.index;
            groupNode.x = groupCentroid[0] + size[0] / 2;
            groupNode.y = groupCentroid[1] + size[1] / 2;
          });

          chords.forEach(function (generatedChord) {
            var chordD = ribbonGenerator(generatedChord);
            //this is incorrect should use edgeHash
            var nodeSourceID = nodeIDAccessor(projectedNodes[generatedChord.source.index]);
            var nodeTargetID = nodeIDAccessor(projectedNodes[generatedChord.target.index]);
            var chordEdge = _this3.edgeHash.get(nodeSourceID + "|" + nodeTargetID);
            chordEdge.d = chordD;
          });
        } else if (networkSettings.type === "sankey" || networkSettings.type === "flowchart") {
          var _networkSettings2 = networkSettings,
              _networkSettings2$ori = _networkSettings2.orient,
              orient = _networkSettings2$ori === undefined ? "center" : _networkSettings2$ori,
              _networkSettings2$ite = _networkSettings2.iterations,
              iterations = _networkSettings2$ite === undefined ? 100 : _networkSettings2$ite,
              nodePadding = _networkSettings2.nodePadding,
              _networkSettings2$nod = _networkSettings2.nodePaddingRatio,
              nodePaddingRatio = _networkSettings2$nod === undefined ? nodePadding ? undefined : 0.5 : _networkSettings2$nod,
              _networkSettings2$nod2 = _networkSettings2.nodeWidth,
              nodeWidth = _networkSettings2$nod2 === undefined ? networkSettings.type === "flowchart" ? 2 : 24 : _networkSettings2$nod2,
              customSankey = _networkSettings2.customSankey,
              _networkSettings2$dir = _networkSettings2.direction,
              direction = _networkSettings2$dir === undefined ? "right" : _networkSettings2$dir;

          var sankeyOrient = sankeyOrientHash[orient];

          var actualSankey = customSankey || _d3SankeyCircular.sankeyCircular;

          var frameExtent = [[0, 0], adjustedSize];

          if (networkSettings.direction === "up" || networkSettings.direction === "down") {
            frameExtent = [[0, 0], [adjustedSize[1], adjustedSize[0]]];
          }

          //Temporary fix for when sankey-circular sets the size incorrectly
          var initialSettings = actualSankey().extent(frameExtent).links(projectedEdges).nodes(projectedNodes).nodeAlign(sankeyOrient).nodeId(nodeIDAccessor).nodePadding(nodePadding).nodeWidth(nodeWidth).iterations(1);

          if (nodePaddingRatio) {
            initialSettings.nodePaddingRatio(nodePaddingRatio);
          }

          initialSettings();

          var circularEdges = projectedEdges.filter(function (d) {
            return d.circular === true;
          });

          if (circularEdges.length === 0) {
            frameExtent = [[0, -frameExtent[1][1]], [frameExtent[1][0], frameExtent[1][1]]];
          } else if (!circularEdges.find(function (d) {
            return d.circularLinkType === "top";
          })) {
            var bottomEdges = circularEdges.filter(function (d) {
              return d.circularLinkType === "bottom";
            });

            var offset = bottomEdges.map(function (d) {
              return d.circularPathData.leftLargeArcRadius;
            }).reduce(function (p, c) {
              return p + c;
            });
            frameExtent = [[0, -frameExtent[1][1]], [frameExtent[1][0], frameExtent[1][1] - offset]];
          }
          //End temporary

          var frameSankey = actualSankey().extent(frameExtent).links(projectedEdges).nodes(projectedNodes).nodeAlign(sankeyOrient).nodeId(nodeIDAccessor).nodePadding(nodePadding).nodeWidth(nodeWidth).iterations(iterations);
          if (nodePaddingRatio) {
            frameSankey.nodePaddingRatio(nodePaddingRatio);
          }

          frameSankey();

          projectedNodes.forEach(function (d) {
            d.height = d.y1 - d.y0;
            d.width = d.x1 - d.x0;
            d.x = d.x0 + d.width / 2;
            d.y = d.y0 + d.height / 2;
            d.radius = d.height / 2;
            d.direction = direction;
          });

          projectedEdges.forEach(function (d) {
            d.sankeyWidth = d.width;
            d.direction = direction;
            d.width = undefined;
          });
        } else if (networkSettings.type === "wordcloud") {
          var _networkSettings3 = networkSettings,
              _networkSettings3$ite = _networkSettings3.iterations,
              _iterations = _networkSettings3$ite === undefined ? 500 : _networkSettings3$ite,
              _networkSettings3$fon = _networkSettings3.fontSize,
              fontSize = _networkSettings3$fon === undefined ? 18 : _networkSettings3$fon,
              rotate = _networkSettings3.rotate,
              _networkSettings3$fon2 = _networkSettings3.fontWeight,
              fontWeight = _networkSettings3$fon2 === undefined ? 300 : _networkSettings3$fon2,
              _networkSettings3$tex = _networkSettings3.textAccessor,
              textAccessor = _networkSettings3$tex === undefined ? function (d) {
            return d.text;
          } : _networkSettings3$tex;

          var fontWeightMod = (fontWeight / 300 - 1) / 5 + 1;
          var fontWidth = fontSize / 1.5 * fontWeightMod;

          nodes.forEach(function (d, i) {
            var calcualatedNodeSize = nodeSizeAccessor(d);
            d._NWFText = textAccessor(d);
            var textWidth = fontWidth * d._NWFText.length * calcualatedNodeSize * 1.4;
            var textHeight = fontSize * calcualatedNodeSize;

            d.textHeight = textHeight + 4;
            d.textWidth = textWidth + 4;
            d.rotate = rotate ? rotate(d, i) : 0;
            d.fontSize = fontSize * calcualatedNodeSize;
            d.fontWeight = fontWeight;
            d.radius = d.r = textWidth / 2;
          });

          nodes.sort(function (a, b) {
            return b.textWidth - a.textWidth;
          });

          //bubblepack for initial position
          (0, _d3Hierarchy.packSiblings)(nodes);

          //        if (rotate) {
          var collide = (0, _d3BboxCollide.bboxCollide)(function (d) {
            if (d.rotate) {
              return [[-d.textHeight / 2, -d.textWidth / 2], [d.textHeight / 2, d.textWidth / 2]];
            }
            return [[-d.textWidth / 2, -d.textHeight / 2], [d.textWidth / 2, d.textHeight / 2]];
          }).iterations(1);

          var xCenter = size[0] / 2;
          var yCenter = size[1] / 2;

          var simulation = (0, _d3Force.forceSimulation)(nodes).velocityDecay(0.6).force("x", (0, _d3Force.forceX)(xCenter).strength(1.2)).force("y", (0, _d3Force.forceY)(yCenter).strength(1.2)).force("collide", collide);

          simulation.stop();

          for (var i = 0; i < _iterations; ++i) {
            simulation.tick();
          } //      }

          var xMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
            return p.x - (p.rotate ? p.textHeight / 2 : p.textWidth / 2);
          }));
          var xMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
            return p.x + (p.rotate ? p.textHeight / 2 : p.textWidth / 2);
          }));
          var yMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
            return p.y - (p.rotate ? p.textWidth / 2 : p.textHeight / 2);
          }));
          var yMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
            return p.y + (p.rotate ? p.textWidth / 2 : p.textHeight / 2);
          }));
          var projectionScaleX = (0, _d3Scale.scaleLinear)().domain([xMin, xMax]).range([0, adjustedSize[0]]);
          var projectionScaleY = (0, _d3Scale.scaleLinear)().domain([yMin, yMax]).range([0, adjustedSize[1]]);
          var xMod = adjustedSize[0] / xMax;
          var yMod = adjustedSize[1] / yMax;

          var sizeMod = Math.min(xMod, yMod) * 1.2;
          projectedNodes.forEach(function (node) {
            node.x = projectionScaleX(node.x);
            node.y = projectionScaleY(node.y);
            node.fontSize = node.fontSize * sizeMod;
            node.scale = 1;
            node.radius = node.r = Math.max(node.textHeight / 4 * yMod, node.textWidth / 4 * xMod);
            //      node.textHeight = projectionScaleY(node.textHeight)
            //      node.textWidth = projectionScaleY(node.textWidth)
          });
        } else if (networkSettings.type === "force") {
          var _networkSettings4 = networkSettings,
              _networkSettings4$ite = _networkSettings4.iterations,
              _iterations2 = _networkSettings4$ite === undefined ? 500 : _networkSettings4$ite,
              _networkSettings4$edg = _networkSettings4.edgeStrength,
              edgeStrength = _networkSettings4$edg === undefined ? 0.1 : _networkSettings4$edg,
              _networkSettings4$dis = _networkSettings4.distanceMax,
              distanceMax = _networkSettings4$dis === undefined ? Infinity : _networkSettings4$dis,
              edgeDistance = _networkSettings4.edgeDistance;

          var linkForce = (0, _d3Force.forceLink)().strength(function (d) {
            return d.weight ? d.weight * edgeStrength : edgeStrength;
          });

          if (edgeDistance) {
            linkForce.distance(edgeDistance);
          }

          var _simulation = networkSettings.simulation || (0, _d3Force.forceSimulation)().force("charge", (0, _d3Force.forceManyBody)().distanceMax(distanceMax).strength(networkSettings.forceManyBody || function (d) {
            return -25 * nodeSizeAccessor(d);
          }));

          //        simulation.force("link", linkForce).nodes(projectedNodes)

          _simulation.nodes(projectedNodes);

          if (!_simulation.force("x")) {
            _simulation.force("x", (0, _d3Force.forceX)(size[0] / 2));
          }
          if (!_simulation.force("y")) {
            _simulation.force("y", (0, _d3Force.forceY)(size[1] / 2));
          }

          if (projectedEdges.length !== 0 && !_simulation.force("link")) {
            _simulation.force("link", linkForce);
            _simulation.force("link").links(projectedEdges);
          }

          //reset alpha if it's too cold
          if (_simulation.alpha() < 0.1) {
            _simulation.alpha(1);
          }

          _simulation.stop();

          for (var _i = 0; _i < _iterations2; ++_i) {
            _simulation.tick();
          }
        } else if (networkSettings.type === "motifs") {
          var componentHash = new Map();
          projectedEdges.forEach(function (edge) {
            ;[edge.source, edge.target].forEach(function (node) {
              if (!componentHash.get(node)) {
                componentHash.set(node, {
                  node: node,
                  component: null,
                  connectedNodes: [],
                  edges: []
                });
              }
            });
            componentHash.get(edge.source).connectedNodes.push(edge.target);
            componentHash.get(edge.target).connectedNodes.push(edge.source);
            componentHash.get(edge.source).edges.push(edge);
          });

          components = breadthFirstCompontents(projectedNodes, componentHash);

          var largestComponent = Math.max(projectedNodes.length / 3, components[0].componentNodes.length);

          var _layoutSize = size[0] > size[1] ? size[1] : size[0];
          var layoutDirection = size[0] > size[1] ? "horizontal" : "vertical";

          //        louvain.assign(graph)

          var _networkSettings5 = networkSettings,
              _networkSettings5$ite = _networkSettings5.iterations,
              _iterations3 = _networkSettings5$ite === undefined ? 500 : _networkSettings5$ite,
              _networkSettings5$edg = _networkSettings5.edgeStrength,
              _edgeStrength = _networkSettings5$edg === undefined ? 0.1 : _networkSettings5$edg,
              _edgeDistance = _networkSettings5.edgeDistance;

          var currentX = 0;
          var currentY = 0;

          components.forEach(function (_ref2) {
            var componentNodes = _ref2.componentNodes,
                componentEdges = _ref2.componentEdges;

            var linkForce = (0, _d3Force.forceLink)().strength(function (d) {
              return d.weight ? d.weight * _edgeStrength : _edgeStrength;
            });

            if (_edgeDistance) {
              linkForce.distance(_edgeDistance);
            }

            var componentLayoutSize = Math.max(componentNodes.length / largestComponent, 0.2) * _layoutSize;

            var xBound = componentLayoutSize + currentX;
            var yBound = componentLayoutSize + currentY;

            if (layoutDirection === "horizontal") {
              if (yBound > size[1]) {
                currentX = componentLayoutSize + currentX;
                currentY = componentLayoutSize;
              } else {
                currentY = componentLayoutSize + currentY;
              }
            } else {
              if (xBound > size[0]) {
                currentY = componentLayoutSize + currentY;
                currentX = componentLayoutSize;
              } else {
                currentX = componentLayoutSize + currentX;
              }
            }

            var xCenter = currentX - componentLayoutSize / 2;
            var yCenter = currentY - componentLayoutSize / 2;

            var simulation = (0, _d3Force.forceSimulation)().force("charge", (0, _d3Force.forceManyBody)().strength(networkSettings.forceManyBody || function (d) {
              return -25 * nodeSizeAccessor(d);
            })).force("link", linkForce);

            simulation.force("x", (0, _d3Force.forceX)(xCenter)).force("y", (0, _d3Force.forceY)(yCenter)).nodes(componentNodes);

            simulation.force("link").links(componentEdges);

            simulation.stop();

            for (var _i2 = 0; _i2 < _iterations3; ++_i2) {
              simulation.tick();
            }var maxX = (0, _d3Array.max)(componentNodes.map(function (d) {
              return d.x;
            }));
            var maxY = (0, _d3Array.max)(componentNodes.map(function (d) {
              return d.y;
            }));
            var minX = (0, _d3Array.min)(componentNodes.map(function (d) {
              return d.x;
            }));
            var minY = (0, _d3Array.min)(componentNodes.map(function (d) {
              return d.y;
            }));

            var resetX = (0, _d3Scale.scaleLinear)().domain([minX, maxX]).range([currentX - componentLayoutSize, currentX - 20]);
            var resetY = (0, _d3Scale.scaleLinear)().domain([minY, maxY]).range([currentY - componentLayoutSize, currentY - 20]);

            componentNodes.forEach(function (node) {
              node.x = resetX(node.x);
              node.y = resetY(node.y);
            });
          });
        } else if (typeof networkSettings.type === "function") {
          networkSettings.type({
            nodes: projectedNodes,
            edges: projectedEdges
          });
        } else {
          projectedNodes.forEach(function (node) {
            node.x = node.x === undefined ? (node.x0 + node.x1) / 2 : node.x;
            node.y = node.y === undefined ? node.y0 : node.y;
          });
        }

        this.graphSettings = networkSettings;
        this.graphSettings.nodes = currentProps.nodes;
        this.graphSettings.edges = currentProps.edges;
      }

      if (networkSettings.direction === "flip") {
        projectedNodes.forEach(function (node) {
          // const ox = node.x
          // const oy = node.y
          node.x = adjustedSize[0] - node.x;
          node.y = adjustedSize[1] - node.y;
        });
      } else if (networkSettings.direction === "up") {
        projectedNodes.forEach(function (node) {
          var ox = node.x;
          node.x = node.y;
          node.y = adjustedSize[1] - ox;
        });
      } else if (networkSettings.direction === "down") {
        projectedNodes.forEach(function (node) {
          var ox = node.x;
          var ox0 = node.x0;
          var ox1 = node.x1;
          node.x = node.y;
          node.x0 = node.y0;
          node.x1 = node.y1;
          node.y = ox;
          node.y0 = ox0;
          node.y1 = ox1;
        });
      } else if (networkSettings.direction === "left") {
        projectedNodes.forEach(function (node) {
          node.x = adjustedSize[0] - node.x;
        });
      }
      if (networkSettings.zoom !== false && networkSettings.type !== "wordcloud" && networkSettings.type !== "chord" && networkSettings.type !== "sankey" && (hierarchicalTypeHash[networkSettings.type] === undefined || networkSettings.nodeSize)) {
        var _xMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
          return p.x - nodeSizeAccessor(p);
        }));
        var _xMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
          return p.x + nodeSizeAccessor(p);
        }));
        var _yMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
          return p.y - nodeSizeAccessor(p);
        }));
        var _yMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
          return p.y + nodeSizeAccessor(p);
        }));

        var _projectionScaleX = (0, _d3Scale.scaleLinear)().domain([_xMin, _xMax]).range([0, adjustedSize[0]]);
        var _projectionScaleY = (0, _d3Scale.scaleLinear)().domain([_yMin, _yMax]).range([0, adjustedSize[1]]);
        projectedNodes.forEach(function (node) {
          node.x = _projectionScaleX(node.x);
          node.y = _projectionScaleY(node.y);
        });
      }

      projectedNodes.forEach(function (node) {
        node.nodeSize = nodeSizeAccessor(node);
      });

      projectedEdges.forEach(function (edge) {
        edge.width = edgeWidthAccessor(edge);
      });

      var legendSettings = void 0;

      if (currentProps.legend) {
        legendSettings = currentProps.legend === true ? {} : currentProps.legend;
        if (!legendSettings.legendGroups) {
          ///Something auto for networks
          var legendGroups = [{
            styleFn: currentProps.nodeStyle,
            type: "fill",
            items: []
          }];
          legendSettings.legendGroups = legendGroups;
        }
      }

      customNodeIcon = customNodeIcon || _networkDrawing.circleNodeGenerator;

      var networkFrameRender = {
        edges: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({ type: "frame-hover" }, data[i]);
          },
          data: projectedEdges,
          styleFn: (0, _dataFunctions.stringToFn)(edgeStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(edgeClass, function () {
            return "";
          }, true),
          renderMode: (0, _dataFunctions.stringToFn)(edgeRenderMode, undefined, true),
          canvasRenderFn: (0, _dataFunctions.stringToFn)(canvasEdges, undefined, true),
          renderKeyFn: currentProps.edgeRenderKey ? currentProps.edgeRenderKey : function (d) {
            return d._NWFEdgeKey || d.source.id + "-" + d.target.id;
          },
          behavior: _networkDrawing.drawEdges,
          type: _edgeType,
          customMark: customEdgeIcon,
          networkType: networkSettings.type,
          direction: networkSettings.direction
        },
        nodes: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({ type: "frame-hover" }, data[i]);
          },
          data: projectedNodes,
          styleFn: nodeStyleFn,
          classFn: nodeClassFn,
          renderMode: nodeRenderModeFn,
          canvasRenderFn: nodeCanvasRenderFn,
          customMark: customNodeIcon,
          behavior: _networkDrawing.drawNodes,
          renderKeyFn: currentProps.nodeRenderKey
        }
      };

      var nodeLabelAnnotations = [];
      if (this.props.nodeLabels && projectedNodes) {
        projectedNodes.forEach(function (node, nodei) {
          if (nodeLabels === true || nodeLabels && nodeLabels(node, nodei)) {
            var actualLabel = nodeLabels === true ? nodeIDAccessor(node, nodei) : nodeLabels(node, nodei);

            var nodeLabel = void 0;

            if (_react2.default.isValidElement(actualLabel)) {
              nodeLabel = {
                key: "node-label-" + nodei,
                type: "basic-node-label",
                x: node.x,
                y: node.y,
                element: actualLabel
              };
            } else {
              nodeLabel = {
                key: "node-label-" + nodei,
                className: "node-label",
                dx: 0,
                dy: 0,
                x: node.x,
                y: node.y,
                note: { label: actualLabel },
                connector: { end: "none" },
                type: _AnnotationLabel2.default,
                subject: { radius: nodeSizeAccessor(node) + 2 }
              };
            }

            nodeLabelAnnotations.push(nodeLabel);
          }
        });
      }

      var projectedXYPoints = void 0;
      var overlay = [];
      var areaBasedTypes = ["circlepack", "treemap", "partition"];
      if (hoverAnnotation && areaBasedTypes.find(function (d) {
        return d === networkType.type;
      }) || hoverAnnotation === "area") {
        var renderedNodeOverlays = projectedNodes.map(function (d, i) {
          return _extends({
            overlayData: d
          }, customNodeIcon({ d: d, i: i, transform: "translate(" + d.x + "," + d.y + ")", styleFn: function styleFn() {
              return { fill: "pink", stroke: "pink", opacity: 0 };
            } }).props);
        });

        overlay.push.apply(overlay, _toConsumableArray(renderedNodeOverlays));
      } else if (hoverAnnotation === "edge" && edgePointHash[networkSettings.type]) {
        projectedXYPoints = projectedEdges.map(edgePointHash[networkSettings.type]);
      } else if (hoverAnnotation === true || hoverAnnotation === "node") {
        projectedXYPoints = projectedNodes;
      } else if (hoverAnnotation === "all") {
        projectedXYPoints = [].concat(_toConsumableArray(projectedEdges.map(edgePointHash[networkSettings.type])), _toConsumableArray(projectedNodes));
      }

      this.setState({
        voronoiHover: null,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        title: title,
        renderNumber: this.state.renderNumber + 1,
        nodeData: null,
        edgeData: null,
        projectedNodes: projectedNodes,
        projectedEdges: projectedEdges,
        projectedXYPoints: projectedXYPoints,
        overlay: overlay,
        nodeIDAccessor: nodeIDAccessor,
        sourceAccessor: sourceAccessor,
        targetAccessor: targetAccessor,
        nodeSizeAccessor: nodeSizeAccessor,
        edgeWidthAccessor: edgeWidthAccessor,
        margin: margin,
        legendSettings: legendSettings,
        networkFrameRender: networkFrameRender,
        nodeLabelAnnotations: nodeLabelAnnotations
      });
    }
  }, {
    key: "defaultNetworkSVGRule",
    value: function defaultNetworkSVGRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i;
      var _state2 = this.state,
          projectedNodes = _state2.projectedNodes,
          nodeIDAccessor = _state2.nodeIDAccessor,
          nodeSizeAccessor = _state2.nodeSizeAccessor;
      var svgAnnotationRules = this.props.svgAnnotationRules;


      if (svgAnnotationRules) {
        var customAnnotation = svgAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: this.props,
          networkFrameState: this.state,
          nodes: this.state.projectedNodes,
          edges: this.state.projectedEdges
        });
        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }
      if (d.type === "node") {
        return (0, _networkframeRules.svgNodeRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "basic-node-label") {
        return _react2.default.createElement(
          "g",
          { transform: "translate(" + d.x + "," + d.y + ")" },
          d.element
        );
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _networkframeRules.svgReactAnnotationRule)({
          d: d,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor
        });
      } else if (d.type === "enclose") {
        return (0, _networkframeRules.svgEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "enclose-rect") {
        return (0, _networkframeRules.svgRectEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      }
      return null;
    }
  }, {
    key: "defaultNetworkHTMLRule",
    value: function defaultNetworkHTMLRule(_ref4) {
      var d = _ref4.d,
          i = _ref4.i;
      var _props = this.props,
          tooltipContent = _props.tooltipContent,
          size = _props.size,
          useSpans = _props.useSpans;

      if (this.props.htmlAnnotationRules) {
        var customAnnotation = this.props.htmlAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: this.props,
          networkFrameState: this.state,
          nodes: this.state.projectedNodes,
          edges: this.state.projectedEdges
        });
        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }
      if (d.type === "frame-hover") {
        return (0, _networkframeRules.htmlFrameHoverRule)({ d: d, i: i, tooltipContent: tooltipContent, size: size, useSpans: useSpans });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          annotations = _props2.annotations,
          annotationSettings = _props2.annotationSettings,
          className = _props2.className,
          customClickBehavior = _props2.customClickBehavior,
          customDoubleClickBehavior = _props2.customDoubleClickBehavior,
          customHoverBehavior = _props2.customHoverBehavior,
          size = _props2.size,
          matte = _props2.matte,
          renderKey = _props2.renderKey,
          hoverAnnotation = _props2.hoverAnnotation,
          beforeElements = _props2.beforeElements,
          afterElements = _props2.afterElements,
          interaction = _props2.interaction,
          title = _props2.title,
          disableContext = _props2.disableContext,
          canvasPostProcess = _props2.canvasPostProcess,
          baseMarkProps = _props2.baseMarkProps,
          useSpans = _props2.useSpans,
          canvasNodes = _props2.canvasNodes,
          canvasEdges = _props2.canvasEdges;
      var _state3 = this.state,
          backgroundGraphics = _state3.backgroundGraphics,
          foregroundGraphics = _state3.foregroundGraphics,
          projectedXYPoints = _state3.projectedXYPoints,
          margin = _state3.margin,
          legendSettings = _state3.legendSettings,
          adjustedPosition = _state3.adjustedPosition,
          adjustedSize = _state3.adjustedSize,
          networkFrameRender = _state3.networkFrameRender,
          nodeLabelAnnotations = _state3.nodeLabelAnnotations,
          overlay = _state3.overlay;


      var downloadButton = [];

      if (this.props.download && this.state.projectedNodes.length > 0) {
        downloadButton.push(_react2.default.createElement(_DownloadButton2.default, {
          key: "network-download-nodes",
          csvName: (this.props.name || "networkframe") + "-" + new Date().toJSON(),
          width: this.props.size[0],
          label: "Download Node List",
          data: (0, _downloadDataMapping.networkNodeDownloadMapping)({
            data: this.state.projectedNodes,
            fields: this.props.downloadFields
          })
        }));
      }
      if (this.props.download && this.state.projectedEdges.length > 0) {
        downloadButton.push(_react2.default.createElement(_DownloadButton2.default, {
          key: "network-download-edges",
          csvName: (this.props.name || "networkframe") + "-" + new Date().toJSON(),
          width: this.props.size[0],
          label: "Download Edge List",
          data: (0, _downloadDataMapping.networkEdgeDownloadMapping)({
            data: this.state.projectedEdges,
            fields: this.props.downloadFields
          })
        }));
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        key: "networkFrame",
        additionalDefs: this.props.additionalDefs
      });

      return _react2.default.createElement(_Frame2.default, {
        name: "networkframe",
        renderPipeline: networkFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        title: title,
        matte: matte,
        className: className,
        finalFilterDefs: finalFilterDefs,
        frameKey: "none",
        renderKeyFn: renderKey,
        projectedCoordinateNames: projectedCoordinateNames,
        defaultSVGRule: this.defaultNetworkSVGRule.bind(this),
        defaultHTMLRule: this.defaultNetworkHTMLRule.bind(this),
        hoverAnnotation: !!hoverAnnotation,
        annotations: [].concat(_toConsumableArray(annotations), _toConsumableArray(nodeLabelAnnotations)),
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: projectedXYPoints,
        margin: margin,
        overlay: overlay,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        disableContext: disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: useSpans,
        canvasRendering: canvasNodes || canvasEdges
      });
    }
  }]);

  return NetworkFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  size: [500, 500],
  className: "",
  name: "networkframe",
  networkType: { type: "force", iterations: 500 }
}, _temp);


NetworkFrame.propTypes = _extends({}, _frame_props.networkframeproptypes);

exports.default = NetworkFrame;
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementResizeEvent = __webpack_require__(570);

var _elementResizeEvent2 = _interopRequireDefault(_elementResizeEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createResponsiveFrame = function createResponsiveFrame(Frame) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(ResponsiveFrame, _React$Component);

    function ResponsiveFrame(props) {
      _classCallCheck(this, ResponsiveFrame);

      var _this = _possibleConstructorReturn(this, (ResponsiveFrame.__proto__ || Object.getPrototypeOf(ResponsiveFrame)).call(this, props));

      _this._onResize = function (width, height) {
        _this.setState({ containerHeight: height, containerWidth: width });
      };

      _this.state = {
        containerHeight: undefined,
        containerWidth: undefined
      };
      return _this;
    }

    _createClass(ResponsiveFrame, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var element = this.node;
        (0, _elementResizeEvent2.default)(element, function () {
          _this2.setState({
            containerHeight: element.offsetHeight,
            containerWidth: element.offsetWidth
          });
        });
        this.setState({
          containerHeight: element.offsetHeight,
          containerWidth: element.offsetWidth
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            responsiveWidth = _props.responsiveWidth,
            responsiveHeight = _props.responsiveHeight,
            size = _props.size,
            dataVersion = _props.dataVersion,
            rest = _objectWithoutProperties(_props, ["responsiveWidth", "responsiveHeight", "size", "dataVersion"]);

        var _state = this.state,
            containerHeight = _state.containerHeight,
            containerWidth = _state.containerWidth;


        var actualSize = [].concat(_toConsumableArray(size));

        var returnEmpty = false;

        if (responsiveWidth) {
          if (!containerWidth) returnEmpty = true;
          actualSize[0] = containerWidth;
        }

        if (responsiveHeight) {
          if (!containerHeight) returnEmpty = true;
          actualSize[1] = containerHeight;
        }

        var dataVersionWithSize = dataVersion + actualSize.toString();

        return _react2.default.createElement(
          "div",
          {
            className: "responsive-container",
            style: { height: "100%", width: "100%" },
            ref: function ref(node) {
              return _this3.node = node;
            }
          },
          !returnEmpty && _react2.default.createElement(Frame, _extends({}, rest, {
            size: actualSize,
            dataVersion: dataVersion ? dataVersionWithSize : undefined
          }))
        );
      }
    }]);

    return ResponsiveFrame;
  }(_react2.default.Component), _class.propTypes = {
    size: _propTypes2.default.array
  }, _class.defaultProps = {
    size: [500, 500]
  }, _temp;
};

exports.default = createResponsiveFrame;
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeLine = __webpack_require__(118);

var _typeLine2 = _interopRequireDefault(_typeLine);

var _Connector2 = __webpack_require__(69);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorLine = function (_Connector) {
  _inherits(ConnectorLine, _Connector);

  function ConnectorLine() {
    _classCallCheck(this, ConnectorLine);

    return _possibleConstructorReturn(this, (ConnectorLine.__proto__ || Object.getPrototypeOf(ConnectorLine)).apply(this, arguments));
  }

  _createClass(ConnectorLine, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          radius = _ref.radius,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeLine2.default)({ x: x, y: y, dx: dx, dy: dy, radius: radius, outerRadius: outerRadius, width: width, height: height });
    }
  }]);

  return ConnectorLine;
}(_Connector3.default);

exports.default = ConnectorLine;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(66);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(44);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Connector = function (_React$Component) {
  _inherits(Connector, _React$Component);

  function Connector() {
    _classCallCheck(this, Connector);

    return _possibleConstructorReturn(this, (Connector.__proto__ || Object.getPrototypeOf(Connector)).apply(this, arguments));
  }

  _createClass(Connector, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          color = _props.color,
          dx = _props.dx,
          dy = _props.dy,
          customID = _props.customID;


      if (dx === 0 && dy === 0) {
        return _react2.default.createElement("g", { className: "annotation-connector" });
      }

      var d = this.getComponents(this.props) || [];
      var cleanedProps = Object.assign({}, this.props);
      delete cleanedProps.children;

      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, _extends({}, cleanedProps, child.props, {
          scale: cleanedProps.endScale || child.props.endScale,
          lineData: d.components[0].data
        }));
      });

      return _react2.default.createElement(
        "g",
        _extends({ className: "annotation-connector" }, this.props.gAttrs),
        d.components && d.components.map(function (c, i) {
          var attrs = {};
          if (!c) return null;
          Object.keys(c.attrs).forEach(function (k) {
            if (c.attrs[k] && k !== "text") {
              attrs[k.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              })] = c.attrs[k];
            }
          });
          return _react2.default.createElement(
            c.type,
            _extends({
              mask: customID ? "url(#" + customID + ")" : undefined,
              key: i,
              className: c.className,
              fill: "none",
              stroke: color
            }, attrs),
            c.attrs.text
          );
        }),
        childrenWithProps
      );
    }
  }]);

  return Connector;
}(_react2.default.Component);

exports.default = Connector;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var leftRightDynamic = exports.leftRightDynamic = function leftRightDynamic(align, y) {
  if (!align || align === "dynamic" || align === "left" || align === "right") {
    if (y < 0) {
      align = "top";
    } else {
      align = "bottom";
    }
  }
  return align;
};

var topBottomDynamic = exports.topBottomDynamic = function topBottomDynamic(align, x) {
  if (!align || align === "dynamic" || align === "top" || align === "bottom") {
    if (x < 0) {
      align = "right";
    } else {
      align = "left";
    }
  }
  return align;
};

var orientationTopBottom = ["topBottom", "top", "bottom"];
var orientationLeftRight = ["leftRight", "left", "right"];

exports.default = function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === undefined ? 0 : _ref$padding,
      _ref$bbox = _ref.bbox,
      bbox = _ref$bbox === undefined ? { x: 0, y: 0, width: 0, height: 0 } : _ref$bbox,
      align = _ref.align,
      orientation = _ref.orientation,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? { x: 0, y: 0 } : _ref$offset;

  var x = -bbox.x;
  var y = -bbox.y;
  if (orientationTopBottom.indexOf(orientation) !== -1) {
    align = topBottomDynamic(align, offset.x);
    if (offset.y < 0 && orientation === "topBottom" || orientation === "top") {
      y -= bbox.height + padding;
    } else {
      y += padding;
    }

    if (align === "middle") {
      x -= bbox.width / 2;
    } else if (align === "right") {
      x -= bbox.width;
    }
  } else if (orientationLeftRight.indexOf(orientation) !== -1) {
    align = leftRightDynamic(align, offset.y);
    if (offset.x < 0 && orientation === "leftRight" || orientation === "left") {
      x -= bbox.width + padding;
    } else {
      x += padding;
    }

    if (align === "middle") {
      y -= bbox.height / 2;
    } else if (align === "top") {
      y -= bbox.height;
    }
  }

  return { x: x, y: y };
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(29);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(74);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(74);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(76);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(330);
/* unused harmony reexport interval */







/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(159);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(83);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(5);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(175);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axisLines = exports.axisLabels = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.axisPieces = axisPieces;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultTickLineGenerator = function defaultTickLineGenerator(_ref) {
  var xy = _ref.xy,
      orient = _ref.orient,
      i = _ref.i;
  return _react2.default.createElement(_semioticMark.Mark, {
    key: i,
    markType: "path",
    renderMode: xy.renderMode,
    stroke: "black",
    strokeWidth: "1px",
    simpleInterpolate: true,
    d: "M" + xy.x1 + "," + xy.y1 + "L" + xy.x2 + "," + xy.y2,
    className: "tick-line tick " + orient
  });
};

function axisPieces(_ref2) {
  var _ref2$renderMode = _ref2.renderMode,
      renderMode = _ref2$renderMode === undefined ? function () {
    return undefined;
  } : _ref2$renderMode,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === undefined ? 5 : _ref2$padding,
      tickValues = _ref2.tickValues,
      scale = _ref2.scale,
      ticks = _ref2.ticks,
      _ref2$orient = _ref2.orient,
      orient = _ref2$orient === undefined ? "left" : _ref2$orient,
      size = _ref2.size,
      _ref2$footer = _ref2.footer,
      footer = _ref2$footer === undefined ? false : _ref2$footer,
      _ref2$tickSize = _ref2.tickSize,
      tickSize = _ref2$tickSize === undefined ? footer ? -10 : ["top", "bottom"].find(function (d) {
    return d === orient;
  }) ? size[1] : size[0] : _ref2$tickSize;

  //returns x1 (start of line), x2 (end of line) associated with the value of the tick
  var axisDomain = [],
      position1 = void 0,
      position2 = void 0,
      domain1 = void 0,
      domain2 = void 0,
      tposition1 = void 0,
      tposition2 = void 0,
      textPositionMod = 0,
      textPositionMod2 = 0,
      defaultAnchor = "middle";

  switch (orient) {
    case "top":
      position1 = "x1";
      position2 = "x2";
      domain1 = "y1";
      domain2 = "y2";
      axisDomain = [0, tickSize];
      tposition1 = "tx";
      tposition2 = "ty";
      textPositionMod -= 20 - padding;
      break;
    case "bottom":
      position1 = "x1";
      position2 = "x2";
      domain1 = "y2";
      domain2 = "y1";
      axisDomain = [size[1], size[1] - tickSize];
      tposition1 = "tx";
      tposition2 = "ty";
      textPositionMod += 20 + padding;
      break;
    case "right":
      position1 = "y2";
      position2 = "y1";
      domain1 = "x2";
      domain2 = "x1";
      axisDomain = [size[0], size[0] - tickSize];
      tposition1 = "ty";
      tposition2 = "tx";
      textPositionMod += 5 + padding;
      textPositionMod2 += 5;
      defaultAnchor = "start";
      break;
    //left
    default:
      position1 = "y1";
      position2 = "y2";
      domain1 = "x1";
      domain2 = "x2";
      axisDomain = [0, tickSize];
      tposition1 = "ty";
      tposition2 = "tx";
      textPositionMod -= 5 + padding;
      textPositionMod2 += 5;
      defaultAnchor = "end";
      break;
  }

  var axisSize = Math.abs(scale.range()[1] - scale.range()[0]);

  if (!tickValues) {
    if (!ticks) {
      ticks = Math.max(1, parseInt(axisSize / 40, 10));
    }
    tickValues = scale.ticks(ticks);
  }

  return tickValues.map(function (tick, i) {
    var _ref3;

    var tickPosition = scale(tick);
    return _ref3 = {}, _defineProperty(_ref3, position1, tickPosition), _defineProperty(_ref3, position2, tickPosition), _defineProperty(_ref3, domain1, axisDomain[0]), _defineProperty(_ref3, domain2, axisDomain[1]), _defineProperty(_ref3, tposition1, tickPosition + textPositionMod2), _defineProperty(_ref3, tposition2, axisDomain[0] + textPositionMod), _defineProperty(_ref3, "defaultAnchor", defaultAnchor), _defineProperty(_ref3, "renderMode", renderMode(tick, i)), _defineProperty(_ref3, "value", tick), _ref3;
  });
}

var axisLabels = exports.axisLabels = function axisLabels(_ref4) {
  var axisParts = _ref4.axisParts,
      tickFormat = _ref4.tickFormat,
      _ref4$rotate = _ref4.rotate,
      rotate = _ref4$rotate === undefined ? 0 : _ref4$rotate;

  return axisParts.map(function (axisPart, i) {
    var renderedValue = tickFormat(axisPart.value, i);
    if ((typeof renderedValue === "undefined" ? "undefined" : _typeof(renderedValue)) !== "object" || renderedValue instanceof Date) {
      renderedValue = _react2.default.createElement(
        "text",
        { textAnchor: axisPart.defaultAnchor },
        renderedValue.toString ? renderedValue.toString() : renderedValue
      );
    }

    return _react2.default.createElement(
      "g",
      {
        key: i,
        pointerEvents: "none",
        transform: "translate(" + axisPart.tx + "," + axisPart.ty + ")rotate(" + rotate + ")"
      },
      renderedValue
    );
  });
};

var axisLines = exports.axisLines = function axisLines(_ref5) {
  var axisParts = _ref5.axisParts,
      orient = _ref5.orient,
      _ref5$tickLineGenerat = _ref5.tickLineGenerator,
      tickLineGenerator = _ref5$tickLineGenerat === undefined ? defaultTickLineGenerator : _ref5$tickLineGenerat;

  return axisParts.map(function (axisPart, i) {
    return tickLineGenerator({ xy: axisPart, orient: orient, i: i });
  });
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadCSV = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _json2csv = __webpack_require__(426);

var _json2csv2 = _interopRequireDefault(_json2csv);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var downloadCSV = exports.downloadCSV = function downloadCSV(csvName, data) {
  (0, _json2csv2.default)(_extends({}, { data: data }), function (err, csv) {
    var blob = new Blob([csv], { type: "text/csv" });

    var dlink = document.createElement("a");
    dlink.download = csvName ? csvName.replace(/ /g, "_") + ".csv" : "vis.csv";
    dlink.href = window.URL.createObjectURL(blob);
    dlink.onclick = function () {
      // revokeObjectURL needs a delay to work properly
      var revokeFn = function revokeFn() {
        window.URL.revokeObjectURL(undefined.href);
      };
      setTimeout(revokeFn.bind(undefined), 1500);
    };

    dlink.click();
    dlink.remove();
  });
};

var DownloadButton = function (_React$Component) {
  _inherits(DownloadButton, _React$Component);

  function DownloadButton() {
    _classCallCheck(this, DownloadButton);

    return _possibleConstructorReturn(this, (DownloadButton.__proto__ || Object.getPrototypeOf(DownloadButton)).apply(this, arguments));
  }

  _createClass(DownloadButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          csvName = _props.csvName,
          data = _props.data,
          width = _props.width,
          _props$label = _props.label,
          label = _props$label === undefined ? "Download" : _props$label;

      return _react2.default.createElement(
        "div",
        { className: "download-div", style: { width: width } },
        _react2.default.createElement(
          "button",
          {
            alt: "download",
            onClick: downloadCSV.bind(this, csvName, data),
            className: "download-data-button"
          },
          _react2.default.createElement(
            "a",
            null,
            label
          )
        )
      );
    }
  }]);

  return DownloadButton;
}(_react2.default.Component);

DownloadButton.propTypes = {
  csvName: _propTypes2.default.string,
  data: _propTypes2.default.array,
  width: _propTypes2.default.number
};

exports.default = DownloadButton;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AnnotationLayer = __webpack_require__(114);

var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);

var _InteractionLayer = __webpack_require__(181);

var _InteractionLayer2 = _interopRequireDefault(_InteractionLayer);

var _VisualizationLayer = __webpack_require__(187);

var _VisualizationLayer2 = _interopRequireDefault(_VisualizationLayer);

var _frameFunctions = __webpack_require__(36);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultZeroMargin = { top: 0, bottom: 0, left: 0, right: 0 };

var Frame = (_temp = _class = function (_React$Component) {
  _inherits(Frame, _React$Component);

  function Frame(props) {
    _classCallCheck(this, Frame);

    var _this = _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).call(this, props));

    _this.setVoronoi = _this.setVoronoi.bind(_this);

    _this.state = {
      canvasContext: null,
      voronoiHover: undefined
    };
    return _this;
  }

  _createClass(Frame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ canvasContext: this.canvasContext });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.canvasContext !== this.state.canvasContext) this.setState({ canvasContext: this.canvasContext });
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return { canvas: this.canvasContext };
    }
  }, {
    key: "setVoronoi",
    value: function setVoronoi(d) {
      this.setState({ voronoiHover: d });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          axes = _props.axes,
          axesTickLines = _props.axesTickLines,
          className = _props.className,
          extent = _props.extent,
          matte = _props.matte,
          name = _props.name,
          projectedCoordinateNames = _props.projectedCoordinateNames,
          renderPipeline = _props.renderPipeline,
          size = _props.size,
          _props$adjustedSize = _props.adjustedSize,
          adjustedSize = _props$adjustedSize === undefined ? size : _props$adjustedSize,
          title = _props.title,
          xScale = _props.xScale,
          yScale = _props.yScale,
          finalFilterDefs = _props.finalFilterDefs,
          frameKey = _props.frameKey,
          dataVersion = _props.dataVersion,
          annotations = _props.annotations,
          hoverAnnotation = _props.hoverAnnotation,
          projectedYMiddle = _props.projectedYMiddle,
          interaction = _props.interaction,
          customClickBehavior = _props.customClickBehavior,
          customHoverBehavior = _props.customHoverBehavior,
          customDoubleClickBehavior = _props.customDoubleClickBehavior,
          points = _props.points,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? defaultZeroMargin : _props$margin,
          backgroundGraphics = _props.backgroundGraphics,
          foregroundGraphics = _props.foregroundGraphics,
          beforeElements = _props.beforeElements,
          afterElements = _props.afterElements,
          downloadButton = _props.downloadButton,
          defaultSVGRule = _props.defaultSVGRule,
          defaultHTMLRule = _props.defaultHTMLRule,
          adjustedPosition = _props.adjustedPosition,
          legendSettings = _props.legendSettings,
          annotationSettings = _props.annotationSettings,
          overlay = _props.overlay,
          columns = _props.columns,
          rScale = _props.rScale,
          projection = _props.projection,
          interactionOverflow = _props.interactionOverflow,
          canvasPostProcess = _props.canvasPostProcess,
          baseMarkProps = _props.baseMarkProps,
          useSpans = _props.useSpans,
          canvasRendering = _props.canvasRendering;
      var voronoiHover = this.state.voronoiHover;


      var areaAnnotations = [];

      var totalAnnotations = annotations ? [].concat(_toConsumableArray(annotations), areaAnnotations) : areaAnnotations;

      if (voronoiHover) {
        if (Array.isArray(voronoiHover)) {
          totalAnnotations.push.apply(totalAnnotations, _toConsumableArray(voronoiHover));
        } else {
          totalAnnotations.push(voronoiHover);
        }
      }

      var annotationLayer = (totalAnnotations && totalAnnotations.length > 0 || legendSettings) && _react2.default.createElement(_AnnotationLayer2.default, {
        legendSettings: legendSettings,
        margin: margin,
        axes: axes,
        annotationHandling: annotationSettings.layout,
        pointSizeFunction: annotationSettings.pointSizeFunction,
        labelSizeFunction: annotationSettings.labelSizeFunction,
        annotations: totalAnnotations,
        svgAnnotationRule: function svgAnnotationRule(d, i, thisALayer) {
          return defaultSVGRule(_extends({
            d: d,
            i: i,
            annotationLayer: thisALayer
          }, renderPipeline));
        },
        htmlAnnotationRule: function htmlAnnotationRule(d, i, thisALayer) {
          return defaultHTMLRule(_extends({
            d: d,
            i: i,
            annotationLayer: thisALayer
          }, renderPipeline));
        },
        useSpans: useSpans,
        size: adjustedSize,
        position: [adjustedPosition[0] + margin.left, adjustedPosition[1] + margin.top]
      });
      var generatedTitle = (0, _frameFunctions.generateFrameTitle)({ title: title, size: size });

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: className + " frame " + name,
          style: {
            background: "none"
          }
        },
        beforeElements && _react2.default.createElement(
          _SpanOrDiv2.default,
          {
            span: useSpans,
            className: name + " frame-before-elements"
          },
          beforeElements
        ),
        _react2.default.createElement(
          _SpanOrDiv2.default,
          {
            span: useSpans,
            className: "frame-elements",
            style: { height: size[1] + "px" }
          },
          _react2.default.createElement(
            _SpanOrDiv2.default,
            {
              span: useSpans,
              className: "visualization-layer",
              style: { position: "absolute" }
            },
            (axesTickLines || backgroundGraphics) && _react2.default.createElement(
              "svg",
              {
                className: "background-graphics",
                style: { position: "absolute" },
                width: size[0],
                height: size[1]
              },
              backgroundGraphics && _react2.default.createElement(
                "g",
                { "aria-hidden": true, className: "background-graphics" },
                backgroundGraphics
              ),
              axesTickLines && _react2.default.createElement(
                "g",
                {
                  transform: "translate(" + margin.left + "," + margin.top + ")",
                  key: "visualization-tick-lines",
                  className: "axis axis-tick-lines",
                  "aria-hidden": true
                },
                axesTickLines
              )
            ),
            canvasRendering && _react2.default.createElement("canvas", {
              className: "frame-canvas",
              ref: function ref(canvasContext) {
                return _this2.canvasContext = canvasContext;
              },
              style: {
                position: "absolute",
                left: "0px",
                top: "0px"
              },
              width: size[0],
              height: size[1]
            }),
            _react2.default.createElement(
              "svg",
              {
                className: "visualization-layer",
                style: { position: "absolute" },
                width: size[0],
                height: size[1]
              },
              finalFilterDefs,
              _react2.default.createElement(_VisualizationLayer2.default, {
                disableContext: this.props.disableContext,
                renderPipeline: renderPipeline,
                position: adjustedPosition,
                size: adjustedSize,
                extent: extent,
                projectedCoordinateNames: projectedCoordinateNames,
                xScale: xScale,
                yScale: yScale,
                axes: axes,
                title: generatedTitle,
                frameKey: frameKey,
                canvasContext: this.state.canvasContext,
                dataVersion: dataVersion,
                matte: matte,
                margin: margin,
                canvasPostProcess: canvasPostProcess,
                baseMarkProps: baseMarkProps,
                voronoiHover: this.setVoronoi
              }),
              generatedTitle && _react2.default.createElement(
                "g",
                { className: "frame-title" },
                generatedTitle
              ),
              foregroundGraphics && _react2.default.createElement(
                "g",
                { "aria-hidden": true, className: "foreground-graphics" },
                foregroundGraphics
              )
            )
          ),
          _react2.default.createElement(_InteractionLayer2.default, {
            useSpans: useSpans,
            hoverAnnotation: hoverAnnotation,
            projectedX: projectedCoordinateNames.x,
            projectedY: projectedCoordinateNames.y,
            projectedYMiddle: projectedYMiddle,
            interaction: interaction,
            voronoiHover: this.setVoronoi,
            customClickBehavior: customClickBehavior,
            customHoverBehavior: customHoverBehavior,
            customDoubleClickBehavior: customDoubleClickBehavior,
            points: points,
            position: adjustedPosition,
            margin: margin,
            size: adjustedSize,
            svgSize: size,
            xScale: xScale,
            yScale: yScale,
            enabled: true,
            overlay: overlay,
            oColumns: columns,
            rScale: rScale,
            projection: projection,
            interactionOverflow: interactionOverflow
          }),
          annotationLayer
        ),
        (downloadButton || afterElements) && _react2.default.createElement(
          _SpanOrDiv2.default,
          { span: useSpans, className: name + " frame-after-elements" },
          downloadButton,
          afterElements
        )
      );
    }
  }]);

  return Frame;
}(_react2.default.Component), _class.defaultProps = {
  annotationSettings: {},
  adjustedPosition: [0, 0],
  projectedCoordinateNames: { x: "x", y: "y" }
}, _temp);


Frame.propTypes = {
  name: _propTypes2.default.string,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  size: _propTypes2.default.array.isRequired,
  annotationSettings: _propTypes2.default.object,
  position: _propTypes2.default.array,
  annotations: _propTypes2.default.array,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleClickBehavior: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.func,
  className: _propTypes2.default.string,
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  interaction: _propTypes2.default.object,
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  backgroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  foregroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  interactionOverflow: _propTypes2.default.object
};

Frame.childContextTypes = {
  canvas: _propTypes2.default.object
};

exports.default = Frame;
module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(35);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupBarMark = exports.hexToRgb = exports.wrap = exports.drawAreaConnector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.linearRibbon = linearRibbon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(3);

var _d3Shape = __webpack_require__(7);

var _semioticMark = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var twoPI = Math.PI * 2;

var drawAreaConnector = exports.drawAreaConnector = function drawAreaConnector(_ref) {
  var x1 = _ref.x1,
      x2 = _ref.x2,
      y1 = _ref.y1,
      y2 = _ref.y2,
      sizeX1 = _ref.sizeX1,
      sizeY1 = _ref.sizeY1,
      sizeX2 = _ref.sizeX2,
      sizeY2 = _ref.sizeY2;

  return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "L" + (x2 + sizeX2) + "," + (y2 + sizeY2) + "L" + (x1 + sizeX1) + "," + (y1 + sizeY1) + "Z";
};

var wrap = exports.wrap = function wrap(text, width) {
  text.each(function () {
    var textNode = (0, _d3Selection.select)(this),
        words = textNode.text().split(/\s+/).reverse(),
        lineHeight = 1.1,
        // ems
    y = textNode.attr("y"),
        dy = parseFloat(textNode.attr("dy"));

    var word = void 0,
        wordline = [],
        lineNumber = 0,
        tspan = textNode.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");

    while (words.length > 0) {
      word = words.pop();
      wordline.push(word);
      tspan.text(wordline.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        wordline.pop();
        tspan.text(wordline.join(" "));
        wordline = [word];

        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
};

var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
  if (hex.substr(0, 2).toLowerCase() === "rg") {
    return hex.split("(")[1].split(")")[0].split(",");
  }
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
};

var groupBarMark = exports.groupBarMark = function groupBarMark(_ref2) {
  var bins = _ref2.bins,
      binMax = _ref2.binMax,
      relativeBuckets = _ref2.relativeBuckets,
      columnWidth = _ref2.columnWidth,
      projection = _ref2.projection,
      adjustedSize = _ref2.adjustedSize,
      summaryI = _ref2.summaryI,
      summary = _ref2.summary,
      renderValue = _ref2.renderValue,
      summaryStyle = _ref2.summaryStyle,
      type = _ref2.type,
      baseMarkProps = _ref2.baseMarkProps;

  var xProp = -columnWidth / 2;

  var mappedBins = [];
  var mappedPoints = [];
  var actualMax = relativeBuckets && relativeBuckets[summary.name] || binMax;

  bins.forEach(function (d, i) {
    var opacity = d.value / actualMax;
    var finalStyle = type.type === "heatmap" ? { opacity: opacity, fill: summaryStyle.fill } : summaryStyle;
    var finalColumnWidth = type.type === "heatmap" ? columnWidth : columnWidth * opacity;
    var yProp = d.y;
    var height = d.y1;
    var width = finalColumnWidth;
    var xOffset = type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
    var yOffset = d.y1 / 2;

    if (projection === "horizontal") {
      yProp = type.type === "heatmap" ? -columnWidth / 2 : columnWidth / 2 - finalColumnWidth;
      xProp = d.y - d.y1;
      height = finalColumnWidth;
      width = d.y1;
      yOffset = type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
      xOffset = d.y1 / 2;
    } else if (projection === "radial") {
      var arcGenerator = (0, _d3Shape.arc)().innerRadius(d.y / 2).outerRadius((d.y + d.y1) / 2);

      var angle = summary.pct - summary.pct_padding;
      var startAngle = summary.pct_middle - summary.pct_padding;

      var endAngle = type.type === "heatmap" ? startAngle + angle : startAngle + angle * opacity;
      startAngle *= twoPI;
      endAngle *= twoPI;

      var arcAdjustX = adjustedSize[0] / 2;
      var arcAdjustY = adjustedSize[1] / 2;

      var arcTranslate = "translate(" + arcAdjustX + "," + arcAdjustY + ")";
      var arcCenter = arcGenerator.centroid({ startAngle: startAngle, endAngle: endAngle });
      mappedPoints.push({
        key: summary.name,
        value: d.value,
        pieces: d.pieces.map(function (p) {
          return p.piece;
        }),
        label: "Heatmap",
        x: arcCenter[0] + arcAdjustX,
        y: arcCenter[1] + arcAdjustY
      });
      mappedBins.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        markType: "path",
        transform: arcTranslate,
        renderMode: renderValue,
        key: "groupIcon-" + summaryI + "-" + i,
        d: arcGenerator({ startAngle: startAngle, endAngle: endAngle }),
        style: finalStyle
      })));
    }
    if (projection !== "radial") {
      mappedPoints.push({
        key: summary.name,
        value: d.value,
        pieces: d.pieces.map(function (p) {
          return p.piece;
        }),
        label: "Heatmap",
        x: xProp + xOffset,
        y: yProp + yOffset
      });

      mappedBins.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        markType: "rect",
        renderMode: renderValue,
        key: "groupIcon-" + summaryI + "-" + i,
        x: xProp,
        y: yProp,
        height: height,
        width: width,
        style: finalStyle
      })));
    }
  });

  return { marks: mappedBins, points: mappedPoints };
};

// FROM d3-svg-ribbon
function linearRibbon() {
  var _lineConstructor = (0, _d3Shape.line)();
  var _xAccessor = function _xAccessor(d) {
    return d.x;
  };
  var _yAccessor = function _yAccessor(d) {
    return d.y;
  };
  var _rAccessor = function _rAccessor(d) {
    return d.r;
  };
  var _interpolator = _d3Shape.curveLinearClosed;

  function _ribbon(pathData) {
    var bothPoints = buildRibbon(pathData);

    return _lineConstructor.x(_xAccessor).y(_yAccessor).curve(_interpolator)(bothPoints);
  }

  _ribbon.x = function (_value) {
    if (!arguments.length) return _xAccessor;

    _xAccessor = _value;
    return _ribbon;
  };

  _ribbon.y = function (_value) {
    if (!arguments.length) return _yAccessor;

    _yAccessor = _value;
    return _ribbon;
  };

  _ribbon.r = function (_value) {
    if (!arguments.length) return _rAccessor;

    _rAccessor = _value;
    return _ribbon;
  };

  _ribbon.interpolate = function (_value) {
    if (!arguments.length) return _interpolator;

    _interpolator = _value;
    return _ribbon;
  };

  return _ribbon;

  function offsetEdge(d) {
    var diffX = _yAccessor(d.target) - _yAccessor(d.source);
    var diffY = _xAccessor(d.target) - _xAccessor(d.source);

    var angle0 = Math.atan2(diffY, diffX) + Math.PI / 2;
    var angle1 = angle0 + Math.PI * 0.5;
    var angle2 = angle0 + Math.PI * 0.5;

    var x1 = _xAccessor(d.source) + _rAccessor(d.source) * Math.cos(angle1);
    var y1 = _yAccessor(d.source) - _rAccessor(d.source) * Math.sin(angle1);
    var x2 = _xAccessor(d.target) + _rAccessor(d.target) * Math.cos(angle2);
    var y2 = _yAccessor(d.target) - _rAccessor(d.target) * Math.sin(angle2);

    return { x1: x1, y1: y1, x2: x2, y2: y2 };
  }

  function buildRibbon(points) {
    var bothCode = [];
    var x = 0;
    var transformedPoints = {};

    while (x < points.length) {
      if (x !== points.length - 1) {
        transformedPoints = offsetEdge({
          source: points[x],
          target: points[x + 1]
        });
        var p1 = { x: transformedPoints.x1, y: transformedPoints.y1 };
        var p2 = { x: transformedPoints.x2, y: transformedPoints.y2 };
        bothCode.push(p1, p2);
        if (bothCode.length > 3) {
          var l = bothCode.length - 1;
          var lineA = { a: bothCode[l - 3], b: bothCode[l - 2] };
          var lineB = { a: bothCode[l - 1], b: bothCode[l] };
          var intersect = findIntersect(lineA.a.x, lineA.a.y, lineA.b.x, lineA.b.y, lineB.a.x, lineB.a.y, lineB.b.x, lineB.b.y);
          if (intersect.found === true) {
            lineA.b.x = intersect.x;
            lineA.b.y = intersect.y;
            lineB.a.x = intersect.x;
            lineB.a.y = intersect.y;
          }
        }
      }

      x++;
    }
    x--;
    //Back
    while (x >= 0) {
      if (x !== 0) {
        transformedPoints = offsetEdge({
          source: points[x],
          target: points[x - 1]
        });
        var _p = { x: transformedPoints.x1, y: transformedPoints.y1 };
        var _p2 = { x: transformedPoints.x2, y: transformedPoints.y2 };
        bothCode.push(_p, _p2);
        if (bothCode.length > 3) {
          var _l = bothCode.length - 1;
          var _lineA = { a: bothCode[_l - 3], b: bothCode[_l - 2] };
          var _lineB = { a: bothCode[_l - 1], b: bothCode[_l] };
          var _intersect = findIntersect(_lineA.a.x, _lineA.a.y, _lineA.b.x, _lineA.b.y, _lineB.a.x, _lineB.a.y, _lineB.b.x, _lineB.b.y);
          if (_intersect.found === true) {
            _lineA.b.x = _intersect.x;
            _lineA.b.y = _intersect.y;
            _lineB.a.x = _intersect.x;
            _lineB.a.y = _intersect.y;
          }
        }
      }

      x--;
    }

    return bothCode;
  }

  function findIntersect(l1x1, l1y1, l1x2, l1y2, l2x1, l2y1, l2x2, l2y2) {
    var a = void 0,
        b = void 0;

    var result = {
      x: null,
      y: null,
      found: false
    };

    var d = (l2y2 - l2y1) * (l1x2 - l1x1) - (l2x2 - l2x1) * (l1y2 - l1y1);
    if (d === 0) {
      return result;
    }
    a = l1y1 - l2y1;
    b = l1x1 - l2x1;
    var n1 = (l2x2 - l2x1) * a - (l2y2 - l2y1) * b;
    var n2 = (l1x2 - l1x1) * a - (l1y2 - l1y1) * b;
    a = n1 / d;
    b = n2 / d;

    result.x = l1x1 + a * (l1x2 - l1x1);
    result.y = l1y1 + a * (l1y2 - l1y1);

    if (a > 0 && a < 1 && b > 0 && b < 1) {
      result.found = true;
    }

    return result;
  }
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.contouring = contouring;
exports.hexbinning = hexbinning;
exports.heatmapping = heatmapping;
exports.shapeBounds = shapeBounds;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Contour = __webpack_require__(452);

var _d3Scale = __webpack_require__(18);

var _polylabel = __webpack_require__(459);

var _polylabel2 = _interopRequireDefault(_polylabel);

var _d3Hexbin = __webpack_require__(461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function contouring(_ref) {
  var areaType = _ref.areaType,
      data = _ref.data,
      finalXExtent = _ref.finalXExtent,
      finalYExtent = _ref.finalYExtent;

  var projectedAreas = [];
  if (!areaType.type) {
    areaType = { type: areaType };
  }

  var _areaType = areaType,
      _areaType$resolution = _areaType.resolution,
      resolution = _areaType$resolution === undefined ? 500 : _areaType$resolution,
      _areaType$thresholds = _areaType.thresholds,
      thresholds = _areaType$thresholds === undefined ? 10 : _areaType$thresholds,
      _areaType$bandwidth = _areaType.bandwidth,
      bandwidth = _areaType$bandwidth === undefined ? 20 : _areaType$bandwidth,
      neighborhood = _areaType.neighborhood;


  var xScale = (0, _d3Scale.scaleLinear)().domain(finalXExtent).rangeRound([0, resolution]).nice();
  var yScale = (0, _d3Scale.scaleLinear)().domain(finalYExtent).rangeRound([resolution, 0]).nice();

  data.forEach(function (contourData) {
    var contourProjectedAreas = (0, _d3Contour.contourDensity)().size([resolution, resolution]).x(function (d) {
      return xScale(d[0]);
    }).y(function (d) {
      return yScale(d[1]);
    }).thresholds(thresholds).bandwidth(bandwidth)(contourData._xyfCoordinates);

    if (neighborhood) {
      contourProjectedAreas = [contourProjectedAreas[0]];
    }

    contourProjectedAreas.forEach(function (area) {
      area.parentArea = contourData;
      area.bounds = [];
      area.coordinates.forEach(function (poly) {
        poly.forEach(function (subpoly, i) {
          poly[i] = subpoly.map(function (coordpair) {
            coordpair = [xScale.invert(coordpair[0]), yScale.invert(coordpair[1])];
            return coordpair;
          });
          //Only push bounds for the main poly, not its interior rings, otherwise you end up labeling interior cutouts
          if (i === 0) {
            area.bounds.push(shapeBounds(poly[i]));
          }
        });
      });
    });
    projectedAreas = [].concat(_toConsumableArray(projectedAreas), _toConsumableArray(contourProjectedAreas));
  });

  return projectedAreas;
}

function hexbinning(_ref2) {
  var areaType = _ref2.areaType,
      data = _ref2.data,
      finalXExtent = _ref2.finalXExtent,
      finalYExtent = _ref2.finalYExtent,
      size = _ref2.size,
      xScaleType = _ref2.xScaleType,
      yScaleType = _ref2.yScaleType;

  var projectedAreas = [];
  if (!areaType.type) {
    areaType = { type: areaType };
  }

  var _areaType2 = areaType,
      _areaType2$bins = _areaType2.bins,
      bins = _areaType2$bins === undefined ? 0.05 : _areaType2$bins,
      cellPx = _areaType2.cellPx,
      _areaType2$binValue = _areaType2.binValue,
      binValue = _areaType2$binValue === undefined ? function (d) {
    return d.length;
  } : _areaType2$binValue;


  var hexBinXScale = xScaleType.domain(finalXExtent).range([0, size[0]]);
  var hexBinYScale = yScaleType.domain(finalYExtent).range([0, size[1]]);

  var actualResolution = cellPx && cellPx / 2 || (bins > 1 ? 1 / bins : bins) * size[0] / 2;

  var hexbinner = (0, _d3Hexbin.hexbin)().x(function (d) {
    return hexBinXScale(d._xyfPoint[0]);
  }).y(function (d) {
    return hexBinYScale(d._xyfPoint[1]);
  }).radius(actualResolution).size(size);

  data.forEach(function (hexbinData) {
    var hexes = hexbinner(hexbinData._xyfCoordinates.map(function (d, i) {
      return _extends({
        _xyfPoint: d
      }, hexbinData.coordinates[i]);
    }));

    var hexMax = Math.max.apply(Math, _toConsumableArray(hexes.map(function (d) {
      return binValue(d);
    })));

    //Option for blank hexe
    var hexBase = [[0, -1], [0.866, -0.5], [0.866, 0.5], [0, 1], [-0.866, 0.5], [-0.866, -0.5]];

    var hexWidth = hexBinXScale.invert(actualResolution) - finalXExtent[0];
    var hexHeight = hexBinYScale.invert(actualResolution) - finalYExtent[0];

    var hexacoordinates = hexBase.map(function (d) {
      return [d[0] * hexWidth, d[1] * hexHeight];
    });

    var hexbinProjectedAreas = hexes.map(function (d) {
      var hexValue = binValue(d);
      var gx = d.x;
      var gy = d.y;
      d.x = hexBinXScale.invert(d.x);
      d.y = hexBinYScale.invert(d.y);
      d.binItems = d;
      var percent = hexValue / hexMax;
      return {
        customMark: areaType.customMark && _react2.default.createElement(
          "g",
          { transform: "translate(" + gx + "," + (size[1] - gy) + ")" },
          areaType.customMark(_extends({}, d, {
            percent: percent,
            value: hexValue,
            radius: actualResolution,
            hexCoordinates: hexBase.map(function (d) {
              return [d[0] * actualResolution, d[1] * actualResolution];
            })
          }))
        ),
        _xyfCoordinates: hexacoordinates.map(function (p) {
          return [p[0] + d.x, p[1] + d.y];
        }),
        value: hexValue,
        percent: percent,
        data: d,
        parentArea: hexbinData,
        centroid: true
      };
    });
    projectedAreas = [].concat(_toConsumableArray(projectedAreas), _toConsumableArray(hexbinProjectedAreas));
  });

  return projectedAreas;
}

function heatmapping(_ref3) {
  var areaType = _ref3.areaType,
      data = _ref3.data,
      finalXExtent = _ref3.finalXExtent,
      finalYExtent = _ref3.finalYExtent,
      size = _ref3.size,
      xScaleType = _ref3.xScaleType,
      yScaleType = _ref3.yScaleType;

  var projectedAreas = [];
  if (!areaType.type) {
    areaType = { type: areaType };
  }

  var _areaType3 = areaType,
      _areaType3$binValue = _areaType3.binValue,
      binValue = _areaType3$binValue === undefined ? function (d) {
    return d.length;
  } : _areaType3$binValue,
      _areaType3$xBins = _areaType3.xBins,
      xBins = _areaType3$xBins === undefined ? areaType.yBins || 0.05 : _areaType3$xBins,
      _areaType3$yBins = _areaType3.yBins,
      yBins = _areaType3$yBins === undefined ? xBins : _areaType3$yBins,
      _areaType3$xCellPx = _areaType3.xCellPx,
      xCellPx = _areaType3$xCellPx === undefined ? !areaType.xBins && areaType.yCellPx : _areaType3$xCellPx,
      _areaType3$yCellPx = _areaType3.yCellPx,
      yCellPx = _areaType3$yCellPx === undefined ? !areaType.yBins && xCellPx : _areaType3$yCellPx;

  var xBinPercent = xBins < 1 ? xBins : 1 / xBins;
  var yBinPercent = yBins < 1 ? yBins : 1 / yBins;

  var heatmapBinXScale = xScaleType.domain(finalXExtent).range([0, size[0]]);
  var heatmapBinYScale = yScaleType.domain(finalYExtent).range([size[1], 0]);

  var actualResolution = [(xCellPx && xCellPx / size[0] || xBinPercent) * size[0], (yCellPx && yCellPx / size[1] || yBinPercent) * size[1]];

  // const halfResolution = [actualResolution[0] / 2, actualResolution[1] / 2]

  data.forEach(function (heatmapData) {
    var grid = [];
    var flatGrid = [];

    var cell = void 0;
    var gridColumn = void 0;

    for (var i = 0; i < size[0]; i += actualResolution[0]) {
      var x = heatmapBinXScale.invert(i);
      var x1 = heatmapBinXScale.invert(i + actualResolution[0]);

      gridColumn = [];
      grid.push(gridColumn);
      for (var j = 0; j < size[1]; j += actualResolution[1]) {
        var y = heatmapBinYScale.invert(j);
        var y1 = heatmapBinYScale.invert(j + actualResolution[1]);
        cell = {
          gx: i,
          gy: j,
          gw: actualResolution[0],
          gh: actualResolution[1],
          x: (x + x1) / 2,
          y: (y + y1) / 2,
          binItems: [],
          value: 0,
          _xyfCoordinates: [[x, y], [x1, y], [x1, y1], [x, y1]],
          parentArea: heatmapData
        };
        gridColumn.push(cell);
        flatGrid.push(cell);
      }
      gridColumn.push(cell);
    }
    grid.push(gridColumn);

    heatmapData._xyfCoordinates.forEach(function (d, di) {
      var xCoordinate = parseInt(heatmapBinXScale(d[0]) / actualResolution[0]);
      var yCoordinate = parseInt(heatmapBinYScale(d[1]) / actualResolution[1]);
      grid[xCoordinate][yCoordinate].binItems.push(heatmapData.coordinates[di]);
    });

    var maxValue = -Infinity;

    flatGrid.forEach(function (d) {
      d.value = binValue(d.binItems);
      maxValue = Math.max(maxValue, d.value);
    });

    flatGrid.forEach(function (d) {
      d.percent = d.value / maxValue;
      d.customMark = areaType.customMark && _react2.default.createElement(
        "g",
        { transform: "translate(" + d.gx + "," + d.gy + ")" },
        areaType.customMark(d)
      );
    });

    projectedAreas = [].concat(_toConsumableArray(projectedAreas), flatGrid);
  });

  return projectedAreas;
}

function shapeBounds(coordinates) {
  var left = [Infinity, 0];
  var right = [-Infinity, 0];
  var top = [0, Infinity];
  var bottom = [0, -Infinity];
  coordinates.forEach(function (d) {
    left = d[0] < left[0] ? d : left;
    right = d[0] > right[0] ? d : right;
    bottom = d[1] > bottom[1] ? d : bottom;
    top = d[1] < top[1] ? d : top;
  });

  return { center: (0, _polylabel2.default)([coordinates]), top: top, left: left, right: right, bottom: bottom };
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(479);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(57);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rectangleEnclosure = exports.circleEnclosure = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AnnotationCalloutCircle = __webpack_require__(101);

var _AnnotationCalloutCircle2 = _interopRequireDefault(_AnnotationCalloutCircle);

var _AnnotationCalloutRect = __webpack_require__(193);

var _AnnotationCalloutRect2 = _interopRequireDefault(_AnnotationCalloutRect);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var circleEnclosure = exports.circleEnclosure = function circleEnclosure(_ref) {
  var d = _ref.d,
      i = _ref.i,
      circle = _ref.circle;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    coordinates: undefined,
    x: circle.x,
    y: circle.y,
    type: _AnnotationCalloutCircle2.default,
    subject: {
      radius: circle.r,
      radiusPadding: d.radiusPadding || 2
    }
  });

  if (noteData.rp) {
    switch (noteData.rp) {
      case "top":
        noteData.dx = 0;
        noteData.dy = -circle.r - noteData.rd;
        break;
      case "bottom":
        noteData.dx = 0;
        noteData.dy = circle.r + noteData.rd;
        break;
      case "left":
        noteData.dx = -circle.r - noteData.rd;
        noteData.dy = 0;
        break;
      default:
        noteData.dx = circle.r + noteData.rd;
        noteData.dy = 0;
    }
  }
  //TODO: Support .ra (setting angle)

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var rectangleEnclosure = exports.rectangleEnclosure = function rectangleEnclosure(_ref2) {
  var bboxNodes = _ref2.bboxNodes,
      d = _ref2.d,
      i = _ref2.i;
  var _d$padding = d.padding,
      padding = _d$padding === undefined ? 0 : _d$padding;

  var bbox = [[Math.min.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.x0;
  }))) - padding, Math.min.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.y0;
  }))) - padding], [Math.max.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.x1;
  }))) + padding, Math.max.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.y1;
  }))) + padding]];

  var noteData = _extends({
    dx: d.dx || -25,
    dy: d.dy || -25,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationCalloutRect2.default,
    x: bbox[0][0],
    y: bbox[0][1],
    subject: {
      width: bbox[1][0] - bbox[0][0],
      height: bbox[1][1] - bbox[0][1]
    }
  });

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationCalloutCircle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubjectCircle = __webpack_require__(489);

var _SubjectCircle2 = _interopRequireDefault(_SubjectCircle);

var _ConnectorElbow = __webpack_require__(45);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationCalloutCircle(props) {
  var className = (0, _classnames2.default)("callout circle", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectCircle2.default, { radius: 20 });
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cleanDates = function cleanDates(value) {
  if (value && value.toJSON) {
    return value.toJSON();
  }
  return value;
};

var xyDownloadMapping = exports.xyDownloadMapping = function xyDownloadMapping(_ref) {
  var data = _ref.data,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields;

  var csvData = [];

  data.forEach(function (datum) {
    if (Array.isArray(datum)) {
      datum.forEach(function (a) {
        var row = {};
        if (xAccessor) {
          row.x = cleanDates(xAccessor(a));
        } else if (a.x) {
          row.x = a.x;
        }

        if (yAccessor) {
          row.y = cleanDates(yAccessor(a));
        } else if (a.y) {
          row.y = a.y;
        }

        if (datum.id !== undefined) row.id = datum.id;

        if (fields && Array.isArray(fields)) {
          fields.forEach(function (f) {
            row[f] = cleanDates(a[f]);
          });
        }

        csvData.push(row);
      });
    } else {
      var row = {};
      if (xAccessor) {
        row.x = cleanDates(xAccessor(datum.data));
      } else if (datum.x) {
        row.x = datum.x;
      }

      if (yAccessor) {
        row.y = cleanDates(yAccessor(datum.data));
      } else if (datum.y) {
        row.y = datum.y;
      }

      if (datum.id !== undefined) {
        row.id = datum.id;
      }

      if (xAccessor || yAccessor) {
        fields.forEach(function (f) {
          row[f] = datum.data[f];
        });
      } else {
        fields.forEach(function (f) {
          row[f] = datum[f];
        });
      }
      csvData.push(row);
    }
  });
  return csvData;
};

var orDownloadMapping = exports.orDownloadMapping = function orDownloadMapping(_ref2) {
  var data = _ref2.data,
      oAccessor = _ref2.oAccessor,
      rAccessor = _ref2.rAccessor,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === undefined ? [] : _ref2$fields;

  var dataKeys = Object.keys(data);
  var csvData = [];

  dataKeys.forEach(function (key) {
    data[key].pieceData.forEach(function (piece) {
      var row = {};
      if (oAccessor) {
        row.column = oAccessor(piece.data);
      } else if (piece.x) {
        row.column = piece.x;
      }

      if (rAccessor) {
        row.value = rAccessor(piece.data);
      } else if (piece.renderKey) {
        row.value = piece.renderKey;
      }

      if (piece.id !== undefined) row.id = piece.id;

      fields.forEach(function (f) {
        row[f] = cleanDates(piece.data[f]);
      });

      csvData.push(row);
    });
  });

  return csvData;
};

var networkNodeDownloadMapping = exports.networkNodeDownloadMapping = function networkNodeDownloadMapping(_ref3) {
  var data = _ref3.data,
      _ref3$fields = _ref3.fields,
      fields = _ref3$fields === undefined ? [] : _ref3$fields;

  var csvData = [];
  data.forEach(function (d) {
    var row = {};
    row.id = d.id;
    fields.forEach(function (f) {
      row[f] = d[f];
    });
    csvData.push(row);
  });
  return csvData;
};

var networkEdgeDownloadMapping = exports.networkEdgeDownloadMapping = function networkEdgeDownloadMapping(_ref4) {
  var data = _ref4.data,
      _ref4$fields = _ref4.fields,
      fields = _ref4$fields === undefined ? [] : _ref4$fields;

  var csvData = [];
  data.forEach(function (d) {
    var row = {};
    row.source = d.source.id;
    row.target = d.target.id;
    fields.forEach(function (f) {
      row[f] = d[f];
    });
    csvData.push(row);
  });

  return csvData;
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterDefs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterDefs = exports.filterDefs = function filterDefs(_ref) {
  var matte = _ref.matte,
      key = _ref.key,
      additionalDefs = _ref.additionalDefs;
  return _react2.default.createElement(
    "defs",
    null,
    _react2.default.createElement(
      "filter",
      { id: "paintyFilterHeavy" },
      _react2.default.createElement("feGaussianBlur", {
        id: "gaussblurrer",
        "in": "SourceGraphic",
        stdDeviation: 4,
        colorInterpolationFilters: "sRGB",
        result: "blur"
      }),
      _react2.default.createElement("feColorMatrix", {
        "in": "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7",
        result: "gooey"
      })
    ),
    _react2.default.createElement(
      "filter",
      { id: "paintyFilterLight" },
      _react2.default.createElement("feGaussianBlur", {
        id: "gaussblurrer",
        "in": "SourceGraphic",
        stdDeviation: 2,
        colorInterpolationFilters: "sRGB",
        result: "blur"
      }),
      _react2.default.createElement("feColorMatrix", {
        "in": "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7",
        result: "gooey"
      })
    ),
    _react2.default.createElement(
      "clipPath",
      { id: "matte-clip-" + key },
      matte
    ),
    additionalDefs
  );
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.networkframeproptypes = exports.ordinalframeproptypes = exports.xyframeproptypes = exports.networkFrameChangeProps = exports.orFrameChangeProps = exports.xyFrameChangeProps = exports.xyFrameDataProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sharedframeproptypes, _extends2;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //size is a special case and handled checking the actual values in the size array


var xyFrameDataProps = exports.xyFrameDataProps = ["lines", "points", "areas", "xScaleType", "yScaleType", "xAccessor", "yAccessor", "lineDataAccessor", "areaDataAccessor", "lineType", "showLinePoints", "defined"];

var xyFrameChangeProps = exports.xyFrameChangeProps = [].concat(xyFrameDataProps, ["name", "title", "margin", "axes", "position", "xExtent", "yExtent", "invertX", "invertY", "hoverAnnotation", "additionalDefs", "defined", "lineStyle", "pointStyle", "areaStyle", "lineClass", "pointClass", "areaClass", "canvasPoints", "customPointMark", "customLineMark", "lineIDAccessor"]);

var orFrameChangeProps = exports.orFrameChangeProps = ["data", "name", "orient", "title", "margin", "format", "position", "oScaleType", "rScaleType", "oExtent", "rExtent", "invertO", "invertR", "oAccessor", "rAccessor", "oPadding", "projection", "type", "summaryType", "connectorType", "className", "additionalDefs", "renderKey", "dataAccessor", "rBaseline", "sortO", "dynamicColumnWidth", "renderFn", "style", "connectorStyle", "summaryStyle", "summaryPosition", "oLabel", "axis"];

var networkFrameChangeProps = exports.networkFrameChangeProps = ["name", "graph", "nodes", "edges", "title", "margin", "position", "nodeIDAccessor", "sourceAccessor", "targetAccessor", "nodeSizeAccessor", "customNodeIcon", "nodeLabels", "edgeWidthAccessor", "networkType", "className", "additionalDefs", "renderFn", "nodeStyle", "edgeStyle", "edgeType"];

/*
const xyFrameOtherProps = [
  "matte",
  "tooltipContent",
  "interaction",
  "annotations",
  "svgAnnotationRules",
  "htmlAnnotationRules",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleClickBehavior",
  "backgroundGraphics",
  "foregroundGraphics",
  "download",
  "downloadFields"
]

const orFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]

const networkFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]
*/

var sharedframeproptypes = (_sharedframeproptypes = {
  useSpans: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  name: _propTypes2.default.string,
  dataVersion: _propTypes2.default.string,
  frameKey: _propTypes2.default.string,
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  canvasPostProcess: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.string,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleClickBehavior: _propTypes2.default.func,
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool, _propTypes2.default.string]),
  interaction: _propTypes2.default.object,
  svgAnnotationRules: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.func,
  annotations: _propTypes2.default.array
}, _defineProperty(_sharedframeproptypes, "interaction", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "baseMarkProps", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "backgroundGraphics", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "foregroundGraphics", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "beforeElements", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "afterElements", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "download", _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])), _defineProperty(_sharedframeproptypes, "downloadFields", _propTypes2.default.array), _defineProperty(_sharedframeproptypes, "annotationSettings", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "renderKey", _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])), _defineProperty(_sharedframeproptypes, "legend", _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool])), _sharedframeproptypes);

var xyframeproptypes = exports.xyframeproptypes = _extends({}, sharedframeproptypes, {
  lines: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  points: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  areas: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  axes: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  matte: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  xScaleType: _propTypes2.default.func,
  yScaleType: _propTypes2.default.func,
  xExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  yExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertX: _propTypes2.default.bool,
  invertY: _propTypes2.default.bool,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  areaType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  lineRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  pointRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  areaRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  showLinePoints: _propTypes2.default.bool,
  defined: _propTypes2.default.func,
  lineStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  pointStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  areaStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  lineClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  pointClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  canvasPoints: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  canvasLines: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  canvasAreas: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  customPointMark: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  customLineMark: _propTypes2.default.func,
  customAreaMark: _propTypes2.default.func,
  lineIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  minimap: _propTypes2.default.object
});

var ordinalframeproptypes = exports.ordinalframeproptypes = _extends({}, sharedframeproptypes, {
  data: _propTypes2.default.array,
  oScaleType: _propTypes2.default.func,
  rScaleType: _propTypes2.default.func,
  oExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  rExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertO: _propTypes2.default.bool,
  invertR: _propTypes2.default.bool,
  oAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  rAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  oPadding: _propTypes2.default.number,
  projection: _propTypes2.default.oneOf(["vertical", "horizontal", "radial"]),
  type: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  summaryType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  connectorType: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  baseMarkProps: _propTypes2.default.object,
  dataAccessor: _propTypes2.default.func,
  rBaseline: _propTypes2.default.number,
  sortO: _propTypes2.default.func,
  pixelColumnWidth: _propTypes2.default.number,
  dynamicColumnWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  renderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  summaryRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  connectorRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  connectorStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  summaryStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  canvasPieces: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasConnectors: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasSummaries: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  summaryPosition: _propTypes2.default.func,
  oLabel: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object]),
  pieceIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  pieceHoverAnnotation: sharedframeproptypes.hoverAnnotation,
  summaryHoverAnnotation: sharedframeproptypes.hoverAnnotation,
  axis: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  ordinalAlign: _propTypes2.default.string
});

var networkframeproptypes = exports.networkframeproptypes = _extends({}, sharedframeproptypes, (_extends2 = {
  nodes: _propTypes2.default.array,
  edges: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  graph: _propTypes2.default.object,
  nodeIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  sourceAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  targetAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeSizeAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
  customNodeIcon: _propTypes2.default.func,
  customEdgeIcon: _propTypes2.default.func,
  nodeRenderKey: _propTypes2.default.func,
  edgeRenderKey: _propTypes2.default.func,
  edgeRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  canvasEdges: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasNodes: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  nodeLabels: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  edgeWidthAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  networkType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  edgeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
}, _defineProperty(_extends2, "customNodeIcon", _propTypes2.default.func), _defineProperty(_extends2, "zoomToFit", _propTypes2.default.bool), _defineProperty(_extends2, "edgeType", _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])), _extends2));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Collection = __webpack_require__(31);

var _d3Scale = __webpack_require__(18);

var _d3Array = __webpack_require__(2);

var _d3Shape = __webpack_require__(7);

var _jsx = __webpack_require__(103);

var _frame_props = __webpack_require__(104);

var _orframeRules = __webpack_require__(493);

var _Frame = __webpack_require__(92);

var _Frame2 = _interopRequireDefault(_Frame);

var _semioticMark = __webpack_require__(6);

var _DownloadButton = __webpack_require__(91);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _downloadDataMapping = __webpack_require__(102);

var _frameFunctions = __webpack_require__(36);

var _pieceDrawing = __webpack_require__(55);

var _pieceLayouts = __webpack_require__(498);

var _summaryLayouts = __webpack_require__(189);

var _dataFunctions = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var xScale = (0, _d3Scale.scaleIdentity)();
var yScale = (0, _d3Scale.scaleIdentity)();

var midMod = function midMod(d) {
  return d.middle ? d.middle : 0;
};
var zeroFunction = function zeroFunction() {
  return 0;
};
var twoPI = Math.PI * 2;

var naturalLanguageTypes = {
  bar: { items: "bar", chart: "bar chart" },
  clusterbar: { items: "bar", chart: "grouped bar chart" },
  swarm: { items: "point", chart: "swarm plot" },
  point: { items: "point", chart: "point plot" },
  timeline: { items: "bar", chart: "timeline" }
};

var projectedCoordinatesObject = { y: "y", x: "x" };

var defaultOverflow = { top: 0, bottom: 0, left: 0, right: 0 };

var layoutHash = {
  clusterbar: _pieceLayouts.clusterBarLayout,
  bar: _pieceLayouts.barLayout,
  point: _pieceLayouts.pointLayout,
  swarm: _pieceLayouts.swarmLayout,
  timeline: _pieceLayouts.timelineLayout
};

var OrdinalFrame = (_temp = _class = function (_React$Component) {
  _inherits(OrdinalFrame, _React$Component);

  function OrdinalFrame(props) {
    _classCallCheck(this, OrdinalFrame);

    var _this = _possibleConstructorReturn(this, (OrdinalFrame.__proto__ || Object.getPrototypeOf(OrdinalFrame)).call(this, props));

    _this.calculateOrdinalFrame = _this.calculateOrdinalFrame.bind(_this);
    _this.defaultORHTMLRule = _this.defaultORHTMLRule.bind(_this);
    _this.defaultORSVGRule = _this.defaultORSVGRule.bind(_this);

    _this.state = {
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      axisData: null,
      axis: null,
      renderNumber: 0,
      oLabels: []
    };

    _this.oAccessor = null;
    _this.rAccessor = null;
    _this.oScale = null;
    _this.rScale = null;
    return _this;
  }

  _createClass(OrdinalFrame, [{
    key: "calculateOrdinalFrame",
    value: function calculateOrdinalFrame(currentProps) {
      var oLabels = void 0;
      var projectedColumns = {};

      var padding = currentProps.oPadding ? currentProps.oPadding : 0;

      var summaryType = (0, _frameFunctions.objectifyType)(currentProps.summaryType);
      var pieceType = (0, _frameFunctions.objectifyType)(currentProps.type);
      var connectorType = (0, _frameFunctions.objectifyType)(currentProps.connectorType);

      var projection = currentProps.projection,
          customHoverBehavior = currentProps.customHoverBehavior,
          customClickBehavior = currentProps.customClickBehavior,
          customDoubleClickBehavior = currentProps.customDoubleClickBehavior,
          size = currentProps.size,
          pixelColumnWidth = currentProps.pixelColumnWidth,
          title = currentProps.title;

      /*    const eventListenersGenerator = generateOrdinalFrameEventListeners(
        customHoverBehavior,
        customClickBehavior,
        customDoubleClickBehavior
      ) */

      var eventListenersGenerator = function eventListenersGenerator() {
        return {};
      };

      var oAccessor = (0, _dataFunctions.stringToFn)(currentProps.oAccessor, function (d) {
        return d.renderKey;
      });
      var rAccessor = (0, _dataFunctions.stringToFn)(currentProps.rAccessor, function (d) {
        return d.value || 1;
      });

      var connectorStyle = (0, _dataFunctions.stringToFn)(currentProps.connectorStyle, function () {
        return {};
      }, true);
      var summaryStyle = (0, _dataFunctions.stringToFn)(currentProps.summaryStyle, function () {
        return {};
      }, true);
      var pieceStyle = (0, _dataFunctions.stringToFn)(currentProps.style, function () {
        return {};
      }, true);
      var pieceClass = (0, _dataFunctions.stringToFn)(currentProps.pieceClass, function () {
        return "";
      }, true);
      var summaryClass = (0, _dataFunctions.stringToFn)(currentProps.summaryClass, function () {
        return "";
      }, true);
      var summaryPosition = currentProps.summaryPosition || function (position) {
        return position;
      };

      var barData = (0, _frameFunctions.keyAndObjectifyBarData)(currentProps);

      var allData = barData.map(function (d) {
        return d.data;
      });

      //      const dataAccessor = currentProps.dataAccessor || function (d) {return d}
      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var baseOExtent = currentProps.oExtent;
      var oExtentSettings = baseOExtent === undefined || Array.isArray(baseOExtent) ? { extent: baseOExtent } : baseOExtent;

      var calculatedOExtent = [].concat(_toConsumableArray(new Set(allData.map(function (d, i) {
        return oAccessor(d, i);
      }))));

      var oExtent = oExtentSettings.extent || calculatedOExtent;

      if (pixelColumnWidth) {
        if (projection === "radial") {
          console.error("pixelColumnWidth is not honored in radial mode");
        } else if (projection === "vertical") {
          var sizeOffset = size[0] - adjustedSize[0];
          adjustedSize[0] = oExtent.length * pixelColumnWidth;
          size[0] = adjustedSize[0] + sizeOffset;
        } else {
          var _sizeOffset = size[1] - adjustedSize[1];
          adjustedSize[1] = oExtent.length * pixelColumnWidth;
          size[1] = adjustedSize[1] + _sizeOffset;
        }
      }

      var cwHash = void 0;
      var oScale = void 0;
      var oScaleType = currentProps.oScaleType || _d3Scale.scaleBand;
      var oDomain = projection === "vertical" && [0, adjustedSize[0]] || [0, adjustedSize[1]];
      if (currentProps.sortO) {
        oExtent = oExtent.sort(currentProps.sortO);
      }

      if (currentProps.dynamicColumnWidth) {
        var columnValueCreator = void 0;
        if (typeof currentProps.dynamicColumnWidth === "string") {
          columnValueCreator = function columnValueCreator(d) {
            return (0, _d3Array.sum)(d.map(function (p) {
              return p.data[currentProps.dynamicColumnWidth];
            }));
          };
        } else {
          columnValueCreator = function columnValueCreator(d) {
            return currentProps.dynamicColumnWidth(d.map(function (p) {
              return p.data;
            }));
          };
        }
        var thresholdDomain = [0];
        var maxColumnValues = 0;
        var columnValues = [];

        oExtent.forEach(function (d) {
          var oValues = barData.filter(function (p, q) {
            return oAccessor(p.data, q) === d;
          });
          var columnValue = columnValueCreator(oValues);

          columnValues.push(columnValue);
          maxColumnValues += columnValue;
        });

        cwHash = { total: 0 };
        oExtent.forEach(function (d, i) {
          var oValue = columnValues[i];
          var stepValue = oValue / maxColumnValues * (oDomain[1] - oDomain[0]);
          cwHash[d] = stepValue;
          cwHash.total += stepValue;
          if (i !== oExtent.length - 1) {
            thresholdDomain.push(stepValue + thresholdDomain[i]);
          }
        });

        oScale = (0, _d3Scale.scaleOrdinal)().domain(oExtent).range(thresholdDomain);
      } else {
        oScale = oScaleType().domain(oExtent).range(oDomain);
      }

      var baseRExtent = currentProps.rExtent;
      var rExtentSettings = baseRExtent === undefined || Array.isArray(baseRExtent) ? { extent: baseRExtent } : baseRExtent;

      var rExtent = rExtentSettings.extent;
      var subZeroRExtent = [0, 0];

      if (pieceType.type === "bar" && summaryType.type && summaryType.type !== "none") {
        pieceType.type = undefined;
      }

      if (pieceType.type === "timeline") {
        var rData = allData.map(rAccessor);
        var leftExtent = (0, _d3Array.extent)(rData.map(function (d) {
          return d[0];
        }));
        var rightExtent = (0, _d3Array.extent)(rData.map(function (d) {
          return d[1];
        }));
        rExtent = (0, _d3Array.extent)([].concat(_toConsumableArray(leftExtent), _toConsumableArray(rightExtent)));
      } else if (pieceType.type !== "bar") {
        rExtent = (0, _d3Array.extent)(allData, rAccessor);
      } else {
        var positiveData = allData.filter(function (d) {
          return rAccessor(d) >= 0;
        });
        var negativeData = allData.filter(function (d) {
          return rAccessor(d) <= 0;
        });

        var nestedPositiveData = (0, _d3Collection.nest)().key(oAccessor).rollup(function (leaves) {
          return (0, _d3Array.sum)(leaves.map(rAccessor));
        }).entries(positiveData);

        var nestedNegativeData = (0, _d3Collection.nest)().key(oAccessor).rollup(function (leaves) {
          return (0, _d3Array.sum)(leaves.map(rAccessor));
        }).entries(negativeData);

        rExtent = [0, nestedPositiveData.length === 0 ? 0 : Math.max((0, _d3Array.max)(nestedPositiveData, function (d) {
          return d.value;
        }), 0)];

        subZeroRExtent = [0, nestedNegativeData.length === 0 ? 0 : Math.min((0, _d3Array.min)(nestedNegativeData, function (d) {
          return d.value;
        }), 0)];
        rExtent = [subZeroRExtent[1], rExtent[1]];
      }

      if (pieceType.type === "clusterbar") {
        rExtent[0] = 0;
      }

      var calculatedRExtent = rExtent;

      if (rExtentSettings.extent && rExtentSettings.extent[0] !== undefined && rExtentSettings.extent[1] !== undefined) {
        rExtent = rExtentSettings.extent;
      } else {
        if (rExtentSettings.extent && rExtentSettings.extent[1] !== undefined && rExtentSettings.extent[0] === undefined) {
          rExtent[1] = rExtentSettings.extent[1];
        }

        if (rExtentSettings.extent && rExtentSettings.extent[0] !== undefined && rExtentSettings.extent[1] === undefined) {
          rExtent[0] = rExtentSettings.extent[0];
        }
      }

      if (currentProps.invertR || rExtentSettings.extent && rExtentSettings.extent[0] > rExtentSettings.extent[1]) {
        rExtent = [rExtent[1], rExtent[0]];
      }

      var rDomain = projection === "vertical" && [0, adjustedSize[1]] || [0, adjustedSize[0]];

      /*    const rScaleType =
        (currentProps.rScaleType && currentProps.rScaleType()) || scaleLinear() */
      var rScaleType = currentProps.rScaleType && currentProps.rScaleType || _d3Scale.scaleLinear;

      var rScale = rScaleType().domain(rExtent).range(rDomain);

      var rScaleReverse = rScaleType().domain(rDomain).range(rDomain.reverse());

      var rScaleVertical = rScaleType().domain(rExtent).range(rDomain);

      this.oScale = oScale;
      this.rScale = rScale;

      this.oAccessor = oAccessor;
      this.rAccessor = rAccessor;

      var columnWidth = cwHash ? 0 : oScale.bandwidth();

      var pieceData = [];

      var mappedMiddleSize = adjustedSize[1];
      if (projection === "vertical") {
        mappedMiddleSize = adjustedSize[0];
      }
      var mappedMiddles = this.mappedMiddles(oScale, mappedMiddleSize, padding);

      var nestedPieces = {};
      (0, _d3Collection.nest)().key(function (d, i) {
        return oAccessor(d.data, i);
      }).entries(barData).forEach(function (d) {
        nestedPieces[d.key] = d.values;
      });
      pieceData = oExtent.map(function (d) {
        return nestedPieces[d] ? nestedPieces[d] : [];
      });

      var zeroValue = projection === "vertical" ? rScaleReverse(rScale(0)) : rScale(0);

      oExtent.forEach(function (o, i) {
        projectedColumns[o] = { name: o, padding: padding, pieceData: pieceData[i] };
        projectedColumns[o].x = oScale(o) + padding / 2;
        projectedColumns[o].y = 0;
        projectedColumns[o].middle = mappedMiddles[o] + padding / 2;

        var negativeOffset = zeroValue;
        var positiveOffset = zeroValue;

        projectedColumns[o].pieceData.forEach(function (piece) {
          var valPosition = void 0;
          piece.value = rAccessor(piece.data);

          if (pieceType.type === "timeline") {
            piece.scaledValue = rScale(piece.value[0]);
            piece.scaledEndValue = rScale(piece.value[1]);
            piece.scaledVerticalValue = rScaleVertical(piece.value[0]);
            piece.scaledZeroOffset = rScaleVertical(0) - piece.scaledVerticalValue;
          } else if (pieceType.type !== "bar" && pieceType.type !== "clusterbar") {
            piece.scaledValue = rScale(piece.value);
            piece.scaledVerticalValue = rScaleVertical(piece.value);
            piece.scaledZeroOffset = piece.scaledValue - zeroValue;
          } else {
            valPosition = projection === "vertical" ? rScaleReverse(rScale(piece.value)) : rScale(piece.value);
            piece.scaledValue = Math.abs(zeroValue - valPosition);
            piece.scaledZeroOffset = valPosition - zeroValue;
          }

          piece.x = projectedColumns[o].x;
          if (piece.value >= 0) {
            piece.base = zeroValue;
            piece.bottom = positiveOffset;
            piece.middle = piece.scaledValue / 2 + positiveOffset;
            positiveOffset = projection === "vertical" ? positiveOffset - piece.scaledValue : positiveOffset + piece.scaledValue;
            piece.negative = false;
          } else {
            piece.base = zeroValue;
            piece.bottom = negativeOffset;
            piece.middle = positiveOffset - piece.scaledValue / 2;
            negativeOffset = projection === "vertical" ? negativeOffset + piece.scaledValue : negativeOffset - piece.scaledValue;
            piece.negative = true;
          }
        });

        if (cwHash) {
          projectedColumns[o].width = cwHash[o] - padding;

          if (currentProps.ordinalAlign === "center") {
            if (i === 0) {
              projectedColumns[o].x = projectedColumns[o].x - projectedColumns[o].width / 2;
              projectedColumns[o].middle = projectedColumns[o].middle - projectedColumns[o].width / 2;
            } else {
              projectedColumns[o].x = projectedColumns[oExtent[i - 1]].x + projectedColumns[oExtent[i - 1]].width;
              projectedColumns[o].middle = projectedColumns[o].x + projectedColumns[o].width / 2;
            }
          }

          projectedColumns[o].pct = cwHash[o] / cwHash.total;
          projectedColumns[o].pct_start = (projectedColumns[o].x - oDomain[0]) / cwHash.total;
          projectedColumns[o].pct_padding = padding / cwHash.total;
          projectedColumns[o].pct_middle = (projectedColumns[o].middle - oDomain[0]) / cwHash.total;
        } else {
          projectedColumns[o].width = columnWidth - padding;
          if (currentProps.ordinalAlign === "center") {
            projectedColumns[o].x = projectedColumns[o].x - projectedColumns[o].width / 2;
            projectedColumns[o].middle = projectedColumns[o].middle - projectedColumns[o].width / 2;
          }

          projectedColumns[o].pct = columnWidth / adjustedSize[1];
          projectedColumns[o].pct_start = (projectedColumns[o].x - oDomain[0]) / adjustedSize[1];
          projectedColumns[o].pct_padding = padding / adjustedSize[1];
          projectedColumns[o].pct_middle = (projectedColumns[o].middle - oDomain[0]) / adjustedSize[1];
        }
      });

      var labelArray = [];

      var pieArcs = [];

      var labelSettings = _typeof(currentProps.oLabel) === "object" ? _extends({ label: true, padding: 5 }, currentProps.oLabel) : { orient: "default", label: currentProps.oLabel, padding: 5 };

      if (currentProps.oLabel || currentProps.hoverAnnotation) {
        var offsetPct = pieceType.offsetAngle && pieceType.offsetAngle / 360 || 0;

        var rangePct = pieceType.angleRange && pieceType.angleRange.map(function (d) {
          return d / 360;
        }) || [0, 1];
        var rangeMod = rangePct[1] - rangePct[0];

        var adjustedPct = rangeMod < 1 ? (0, _d3Scale.scaleLinear)().domain([0, 1]).range(rangePct) : function (d) {
          return d;
        };

        oExtent.forEach(function (d) {
          var arcGenerator = (0, _d3Shape.arc)().innerRadius(0).outerRadius(rScale.range()[1] / 2);

          var angle = projectedColumns[d].pct * rangeMod;
          var startAngle = adjustedPct(projectedColumns[d].pct_start + offsetPct);

          var endAngle = startAngle + angle;
          var midAngle = startAngle + angle / 2;

          var markD = arcGenerator({
            startAngle: startAngle * twoPI,
            endAngle: endAngle * twoPI
          });
          var translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
          var centroid = arcGenerator.centroid({
            startAngle: startAngle * twoPI,
            endAngle: endAngle * twoPI
          });

          var addedPadding = centroid[1] > 0 && (!labelSettings.orient || labelSettings.orient === "default" || labelSettings.orient === "edge") ? 8 : 0;

          var outerPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, rScale.range()[1] / 2 + labelSettings.padding + addedPadding);

          pieArcs.push({
            startAngle: startAngle,
            endAngle: endAngle,
            midAngle: midAngle,
            markD: markD,
            translate: translate,
            centroid: centroid,
            outerPoint: outerPoint
          });
        });
      }

      if (currentProps.oLabel) {
        var labelingFn = void 0;
        if (labelSettings.label === true) {
          var labelStyle = {
            textAnchor: "middle"
          };
          if (projection === "horizontal" && labelSettings.orient === "right") {
            labelStyle.textAnchor = "start";
          } else if (projection === "horizontal") {
            labelStyle.textAnchor = "end";
          }

          labelingFn = function labelingFn(d, p, i) {
            var additionalStyle = {};
            var transformRotate = void 0;

            if (projection === "radial" && labelSettings.orient === "stem") {
              transformRotate = "rotate(" + (pieArcs[i].outerPoint[0] < 0 ? pieArcs[i].midAngle * 360 + 90 : pieArcs[i].midAngle * 360 - 90) + ")";
            } else if (projection === "radial" && labelSettings.orient !== "center") {
              transformRotate = "rotate(" + (pieArcs[i].outerPoint[1] < 0 ? pieArcs[i].midAngle * 360 : pieArcs[i].midAngle * 360 + 180) + ")";
            }
            if (projection === "radial" && labelSettings.orient === "stem" && (pieArcs[i].outerPoint[0] > 0 && labelSettings.padding < 0 || pieArcs[i].outerPoint[0] < 0 && labelSettings.padding >= 0)) {
              additionalStyle.textAnchor = "end";
            } else if (projection === "radial" && labelSettings.orient === "stem") {
              additionalStyle.textAnchor = "start";
            }
            return _react2.default.createElement(
              "text",
              {
                transform: transformRotate,
                style: _extends({}, labelStyle, additionalStyle)
              },
              d
            );
          };
        } else if (typeof labelSettings.label === "function") {
          labelingFn = labelSettings.label;
        }

        oExtent.forEach(function (d, i) {
          var xPosition = projectedColumns[d].middle;
          var yPosition = 0;

          if (projection === "horizontal") {
            yPosition = projectedColumns[d].middle;
            if (labelSettings.orient === "right") {
              xPosition = adjustedSize[0] + 3;
            } else {
              xPosition = -3;
            }
          } else if (projection === "radial") {
            if (labelSettings.orient === "center") {
              xPosition = pieArcs[i].centroid[0] + pieArcs[i].translate[0];
              yPosition = pieArcs[i].centroid[1] + pieArcs[i].translate[1];
            } else {
              xPosition = pieArcs[i].outerPoint[0] + pieArcs[i].translate[0];
              yPosition = pieArcs[i].outerPoint[1] + pieArcs[i].translate[1];
            }
          }
          var label = labelingFn(d, currentProps.data ? currentProps.data.filter(function (p, q) {
            return oAccessor(p, q) === d;
          }) : undefined, i, { arc: pieArcs[i], data: projectedColumns[d] });
          labelArray.push(_react2.default.createElement(
            "g",
            {
              key: "olabel-" + i,
              transform: "translate(" + xPosition + "," + yPosition + ")"
            },
            label
          ));
        });

        if (projection === "vertical") {
          var labelY = void 0;
          if (labelSettings.orient === "top") {
            labelY = -15;
          } else {
            labelY = 15 + rScale.range()[1];
          }
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              className: "ordinal-labels",
              transform: "translate(" + margin.left + "," + (labelY + margin.top) + ")"
            },
            labelArray
          );
        } else if (projection === "horizontal") {
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              className: "ordinal-labels",
              transform: "translate(" + margin.left + "," + margin.top + ")"
            },
            labelArray
          );
        } else if (projection === "radial") {
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              className: "ordinal-labels",
              transform: "translate(" + margin.left + "," + margin.top + ")"
            },
            labelArray
          );
        }
      }

      var columnOverlays = void 0;

      if (currentProps.hoverAnnotation) {
        columnOverlays = oExtent.map(function (d, i) {
          var barColumnWidth = projectedColumns[d].width;
          var xPosition = projectedColumns[d].x;
          var yPosition = 0;
          var height = rScale.range()[1];
          var width = barColumnWidth + padding;
          if (projection === "horizontal") {
            yPosition = projectedColumns[d].x;
            xPosition = 0;
            width = rScale.range()[1];
            height = barColumnWidth;
          }

          if (projection === "radial") {
            var _pieArcs$i = pieArcs[i],
                markD = _pieArcs$i.markD,
                centroid = _pieArcs$i.centroid,
                translate = _pieArcs$i.translate,
                midAngle = _pieArcs$i.midAngle;

            var radialMousePackage = {
              type: "column-hover",
              pieces: projectedColumns[d].pieceData,
              summary: projectedColumns[d].pieceData,
              arcAngles: {
                centroid: centroid,
                translate: translate,
                midAngle: midAngle,
                length: rScale.range()[1] / 2
              }
            };
            return {
              markType: "path",
              key: "hover" + d,
              d: markD,
              transform: "translate(" + translate + ")",
              style: { opacity: 0, fill: "pink" },
              overlayData: radialMousePackage,
              onDoubleClick: customDoubleClickBehavior && function () {
                customDoubleClickBehavior(radialMousePackage);
              },
              onClick: customClickBehavior && function () {
                customClickBehavior(radialMousePackage);
              },
              onMouseEnter: customHoverBehavior && function () {
                customHoverBehavior(radialMousePackage);
              },
              onMouseLeave: customHoverBehavior && function () {
                customHoverBehavior();
              }
            };
          }

          var baseMousePackage = {
            type: "column-hover",
            pieces: projectedColumns[d].pieceData,
            summary: projectedColumns[d].pieceData
          };
          return {
            markType: "rect",
            key: "hover-" + d,
            x: xPosition,
            y: yPosition,
            height: height,
            width: width,
            style: { opacity: 0, stroke: "black", fill: "pink" },
            onDoubleClick: customDoubleClickBehavior && function () {
              customDoubleClickBehavior(baseMousePackage);
            },
            onClick: customClickBehavior && function () {
              customClickBehavior(baseMousePackage);
            },
            onMouseEnter: customHoverBehavior && function () {
              customHoverBehavior(baseMousePackage);
            },
            onMouseLeave: function onMouseLeave() {
              return {};
            },
            overlayData: baseMousePackage
          };
        });
      }

      var _orFrameAxisGenerator = (0, _frameFunctions.orFrameAxisGenerator)({
        axis: currentProps.axis,
        data: currentProps.data,
        projection: projection,
        adjustedSize: adjustedSize,
        size: size,
        rScale: rScale,
        rScaleType: rScaleType,
        pieceType: pieceType,
        rExtent: rExtent
      }),
          axis = _orFrameAxisGenerator.axis,
          axesTickLines = _orFrameAxisGenerator.axesTickLines;

      var renderMode = currentProps.renderMode,
          canvasSummaries = currentProps.canvasSummaries,
          summaryRenderMode = currentProps.summaryRenderMode,
          connectorClass = currentProps.connectorClass,
          connectorRenderMode = currentProps.connectorRenderMode,
          canvasConnectors = currentProps.canvasConnectors,
          canvasPieces = currentProps.canvasPieces;


      var pieceDataXY = void 0;
      var pieceRenderMode = (0, _dataFunctions.stringToFn)(renderMode, undefined, true);
      var pieceCanvasRender = (0, _dataFunctions.stringToFn)(canvasPieces, undefined, true);
      var summaryCanvasRender = (0, _dataFunctions.stringToFn)(canvasSummaries, undefined, true);
      var connectorCanvasRender = (0, _dataFunctions.stringToFn)(canvasConnectors, undefined, true);

      var pieceTypeForXY = pieceType.type && pieceType.type !== "none" ? pieceType.type : "point";
      var pieceTypeLayout = typeof pieceTypeForXY === "function" ? pieceTypeForXY : layoutHash[pieceTypeForXY];
      var calculatedPieceData = pieceTypeLayout({
        type: pieceType,
        data: projectedColumns,
        renderMode: pieceRenderMode,
        eventListenersGenerator: eventListenersGenerator,
        styleFn: pieceStyle,
        projection: projection,
        classFn: pieceClass,
        adjustedSize: adjustedSize,
        rScale: rScale
      });

      var keyedData = calculatedPieceData.reduce(function (p, c) {
        if (!p[c.o]) {
          p[c.o] = [];
        }
        p[c.o].push(c);
        return p;
      }, {});

      Object.keys(projectedColumns).forEach(function (d) {
        projectedColumns[d].xyData = keyedData[d] || [];
      });
      var calculatedSummaries = {};

      if (summaryType.type) {
        calculatedSummaries = (0, _summaryLayouts.drawSummaries)({
          data: projectedColumns,
          type: summaryType,
          renderMode: (0, _dataFunctions.stringToFn)(summaryRenderMode, undefined, true),
          styleFn: (0, _dataFunctions.stringToFn)(summaryStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(summaryClass, function () {
            return "";
          }, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasSummaries, undefined, true),
          positionFn: summaryPosition,
          projection: projection,
          eventListenersGenerator: eventListenersGenerator,
          adjustedSize: adjustedSize,
          baseMarkProps: currentProps.baseMarkProps || {}
        });
        calculatedSummaries.originalData = projectedColumns;
      }

      if (currentProps.pieceHoverAnnotation && ["bar", "clusterbar", "timeline"].indexOf(pieceType.type) === -1 || currentProps.summaryHoverAnnotation) {
        var yMod = projection === "horizontal" ? midMod : zeroFunction;
        var xMod = projection === "vertical" ? midMod : zeroFunction;

        if (currentProps.summaryHoverAnnotation && calculatedSummaries.xyPoints) {
          pieceDataXY = calculatedSummaries.xyPoints.map(function (d) {
            return _extends({}, d, {
              type: "frame-hover",
              isSummaryData: true,
              x: d.x,
              y: d.y
            });
          });
        } else if (currentProps.pieceHoverAnnotation && calculatedPieceData) {
          pieceDataXY = calculatedPieceData.map(function (d) {
            return _extends({}, d.piece, {
              type: "frame-hover",
              x: d.xy.x + xMod(d.xy),
              y: d.xy.y + yMod(d.xy)
            });
          });
        }
      }

      if (currentProps.pieceHoverAnnotation && ["bar", "clusterbar", "timeline"].indexOf(pieceType.type) !== -1) {
        var _yMod = projection === "horizontal" ? midMod : zeroFunction;
        var _xMod = projection === "vertical" ? midMod : zeroFunction;

        columnOverlays = calculatedPieceData.map(function (d, i) {
          var mousePackage = _extends({}, d.piece, {
            x: d.xy.x + _xMod(d.xy),
            y: d.xy.y + _yMod(d.xy)
          });
          return _extends({}, d.renderElement, {
            key: "hover-" + i,
            type: "frame-hover",
            style: { opacity: 0, stroke: "black", fill: "pink" },
            overlayData: mousePackage,
            onClick: customClickBehavior && function () {
              customClickBehavior(mousePackage.data);
            },
            onDoubleClick: customDoubleClickBehavior && function () {
              customDoubleClickBehavior(mousePackage.data);
            },
            onMouseEnter: customHoverBehavior && function () {
              customHoverBehavior(mousePackage.data);
            },
            onMouseLeave: customHoverBehavior && function () {
              customHoverBehavior();
            }
          });
        });
      }

      var typeAriaLabel = naturalLanguageTypes[pieceType.type] || {
        items: "piece",
        chart: "ordinal chart"
      };

      var orFrameRender = {
        connectors: {
          accessibleTransform: function accessibleTransform(data, i) {
            return data[i];
          },
          projection: projection,
          data: keyedData,
          styleFn: (0, _dataFunctions.stringToFn)(connectorStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(connectorClass, function () {
            return "";
          }, true),
          renderMode: (0, _dataFunctions.stringToFn)(connectorRenderMode, undefined, true),
          canvasRender: connectorCanvasRender,
          behavior: _frameFunctions.orFrameConnectionRenderer,
          type: connectorType,
          eventListenersGenerator: eventListenersGenerator
        },
        summaries: {
          accessibleTransform: function accessibleTransform(data, i, node) {
            var d = data.originalData[node.dataset && node.dataset.o || node.firstChild.dataset.o];
            return _extends({}, d, { pieces: d.pieceData, type: "column-hover" });
          },
          data: calculatedSummaries,
          behavior: _summaryLayouts.renderLaidOutSummaries,
          canvasRender: summaryCanvasRender,
          styleFn: (0, _dataFunctions.stringToFn)(summaryStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(summaryClass, function () {
            return "";
          }, true)
        },
        pieces: {
          accessibleTransform: function accessibleTransform(data, i) {
            return _extends({}, data[i].piece ? _extends({}, data[i].piece, data[i].xy) : data[i], {
              type: "frame-hover"
            });
          },
          shouldRender: pieceType.type && pieceType.type !== "none",
          data: calculatedPieceData,
          behavior: _pieceDrawing.renderLaidOutPieces,
          canvasRender: pieceCanvasRender,
          styleFn: (0, _dataFunctions.stringToFn)(pieceStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(pieceClass, function () {
            return "";
          }, true),
          ariaLabel: typeAriaLabel
        }
      };

      if (rExtentSettings.onChange && (this.state.calculatedRExtent || []).join(",") !== (calculatedRExtent || []).join(",")) {
        rExtentSettings.onChange(calculatedRExtent);
      }

      if (oExtentSettings.onChange && (this.state.calculatedOExtent || []).join(",") !== (calculatedOExtent || []).join(",")) {
        oExtentSettings.onChange(calculatedOExtent);
      }

      this.setState({
        pieceDataXY: pieceDataXY,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        axisData: currentProps.axis,
        axes: axis && _react2.default.createElement(
          "g",
          { key: "ordinalframe-axis", className: "axis-labels" },
          axis
        ),
        axesTickLines: axesTickLines,
        oLabels: oLabels,
        title: title,
        columnOverlays: columnOverlays,
        renderNumber: this.state.renderNumber + 1,
        oAccessor: currentProps.oAccessor,
        rAccessor: currentProps.rAccessor,
        oScaleType: currentProps.oScaleType,
        rScaleType: currentProps.rScaleType,
        oExtent: oExtent,
        rExtent: rExtent,
        calculatedOExtent: calculatedOExtent,
        calculatedRExtent: calculatedRExtent,
        projectedColumns: projectedColumns,
        margin: margin,
        legendSettings: currentProps.legend,
        orFrameRender: orFrameRender
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      Object.keys(this.props).forEach(function (d) {
        if (!_frame_props.ordinalframeproptypes[d]) {
          if (_frame_props.xyframeproptypes[d]) {
            console.error(d + " is an XYFrame prop are you sure you're using the right frame?");
          } else if (_frame_props.networkframeproptypes[d]) {
            console.error(d + " is a NetworkFrame prop are you sure you're using the right frame?");
          } else {
            console.error(d + " is not a valid OrdinalFrame prop");
          }
        }
      });

      this.calculateOrdinalFrame(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.projectedColumns) {
        this.calculateOrdinalFrame(nextProps);
      } else if (this.props.size[0] !== nextProps.size[0] || this.props.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.orFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        this.calculateOrdinalFrame(nextProps);
      }
    }
  }, {
    key: "clonedAppliedElement",
    value: function clonedAppliedElement(_ref) {
      var tx = _ref.tx,
          ty = _ref.ty,
          d = _ref.d,
          i = _ref.i,
          markProps = _ref.markProps,
          styleFn = _ref.styleFn,
          renderFn = _ref.renderFn,
          classFn = _ref.classFn,
          baseClass = _ref.baseClass;

      markProps.style = styleFn ? styleFn(d, i) : {};
      markProps.renderMode = renderFn ? renderFn(d, i) : undefined;

      if (tx || ty) {
        markProps.transform = "translate(" + (tx || 0) + "," + (ty || 0) + ")";
      }

      markProps.className = baseClass;

      markProps.key = baseClass + "-" + i;

      if (classFn) {
        markProps.className = baseClass + " " + classFn(d, i);
      }

      return _react2.default.createElement(_semioticMark.Mark, markProps);
    }
  }, {
    key: "defaultORSVGRule",
    value: function defaultORSVGRule(_ref2) {
      var d = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer;

      var oAccessor = this.oAccessor;
      var rAccessor = this.rAccessor;
      var oScale = this.oScale;
      var rScale = this.rScale;

      var projection = this.props.projection;
      var _state = this.state,
          projectedColumns = _state.projectedColumns,
          orFrameRender = _state.orFrameRender;


      var pieceIDAccessor = (0, _dataFunctions.stringToFn)(this.props.pieceIDAccessor, function (p) {
        return p.semioticPieceID;
      });

      var _adjustedPositionSize2 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize2.adjustedPosition,
          adjustedSize = _adjustedPositionSize2.adjustedSize;

      var screenProject = function screenProject(p) {
        var oColumn = projectedColumns[oAccessor(p)];
        var o = void 0;
        if (oColumn) {
          o = oColumn.middle;
        } else {
          o = 0;
        }
        var idPiece = pieceIDAccessor(d) && oColumn && oColumn.pieceData.find(function (r) {
          return pieceIDAccessor(r.data) === pieceIDAccessor(d);
        });

        if (oColumn && projection === "radial") {
          return (0, _pieceDrawing.pointOnArcAtAngle)([adjustedSize[0] / 2, adjustedSize[1] / 2], oColumn.pct_middle, idPiece ? (idPiece.bottom + idPiece.scaledValue / 2) / 2 : rScale(rAccessor(p)) / 2);
        }
        if (projection === "horizontal") {
          return [idPiece ? idPiece.bottom + idPiece.scaledValue / 2 : rScale(rAccessor(p)), o];
        }
        var newScale = (0, _d3Scale.scaleLinear)().domain(rScale.domain()).range(rScale.range().reverse());

        return [o, idPiece ? idPiece.bottom - idPiece.scaledValue / 2 : newScale(rAccessor(p))];
      };

      var screenCoordinates = [0, 0];

      //TODO: Support radial??
      if (d.coordinates || d.type === "enclose" && d.neighbors) {
        screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
          return screenProject(p);
        });
      } else {
        screenCoordinates = screenProject(d);
      }

      //TODO: Process your rules first
      var customAnnotation = this.props.svgAnnotationRules && this.props.svgAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: rScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: this.props,
        screenCoordinates: screenCoordinates,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer,
        orFrameState: this.state,
        categories: this.state.projectedColumns
      });
      if (this.props.svgAnnotationRules && customAnnotation !== null) {
        return customAnnotation;
      } else if (d.type === "or") {
        return (0, _orframeRules.svgORRule)({ d: d, i: i, screenCoordinates: screenCoordinates, projection: projection });
      } else if (d.type === "highlight") {
        return (0, _orframeRules.svgHighlightRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          projection: projection,
          categories: projectedColumns,
          pieceIDAccessor: pieceIDAccessor,
          orFrameRender: orFrameRender,
          oAccessor: oAccessor
        });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _orframeRules.basicReactAnnotationRule)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "enclose") {
        return (0, _orframeRules.svgEncloseRule)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "enclose-rect") {
        return (0, _orframeRules.svgRectEncloseRule)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "r") {
        return (0, _orframeRules.svgRRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          rScale: rScale,
          rAccessor: rAccessor,
          projection: projection,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition
        });
      } else if (d.type === "category") {
        return (0, _orframeRules.svgCategoryRule)({
          projection: projection,
          d: d,
          i: i,
          categories: this.state.projectedColumns,
          adjustedSize: adjustedSize
        });
      }
      return null;
    }
  }, {
    key: "defaultORHTMLRule",
    value: function defaultORHTMLRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i;

      var oAccessor = this.oAccessor;
      var rAccessor = this.rAccessor;
      var oScale = this.oScale;
      var rScale = this.rScale;

      var _props = this.props,
          htmlAnnotationRules = _props.htmlAnnotationRules,
          tooltipContent = _props.tooltipContent,
          projection = _props.projection,
          size = _props.size,
          useSpans = _props.useSpans;
      var projectedColumns = this.state.projectedColumns;


      var type = _typeof(this.props.type) === "object" ? this.props.type : { type: this.props.type };
      var summaryType = _typeof(this.props.summaryType) === "object" ? this.props.summaryType : { type: this.props.summaryType };

      var _adjustedPositionSize3 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize3.adjustedPosition,
          adjustedSize = _adjustedPositionSize3.adjustedSize;

      //TODO: Process your rules first


      if (htmlAnnotationRules && htmlAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: rScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: this.props,
        orFrameState: this.state,
        categories: this.state.projectedColumns,
        useSpans: useSpans
      }) !== null) {
        return htmlAnnotationRules({
          d: d,
          i: i,
          oScale: oScale,
          rScale: rScale,
          oAccessor: oAccessor,
          rAccessor: rAccessor,
          orFrameProps: this.props,
          categories: this.state.projectedColumns,
          useSpans: useSpans
        });
      }

      if (d.type === "frame-hover") {
        return (0, _orframeRules.htmlFrameHoverRule)({
          d: d,
          i: i,
          rAccessor: rAccessor,
          oAccessor: oAccessor,
          size: size,
          projection: projection,
          tooltipContent: tooltipContent,
          projectedColumns: projectedColumns,
          useSpans: useSpans
        });
      } else if (d.type === "column-hover") {
        return (0, _orframeRules.htmlColumnHoverRule)({
          d: d,
          i: i,
          summaryType: summaryType,
          oAccessor: oAccessor,
          rAccessor: rAccessor,
          projectedColumns: projectedColumns,
          type: type,
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize,
          projection: projection,
          tooltipContent: tooltipContent,
          useSpans: useSpans
        });
      }
      return null;
    }
  }, {
    key: "mappedMiddles",
    value: function mappedMiddles(oScale, middleMax, padding) {
      var oScaleDomainValues = oScale.domain();

      var mappedMiddles = {};
      oScaleDomainValues.forEach(function (p, q) {
        var base = oScale(p) - padding;
        var next = oScaleDomainValues[q + 1] ? oScale(oScaleDomainValues[q + 1]) : middleMax;
        var diff = (next - base) / 2;
        mappedMiddles[p] = base + diff;
      });

      return mappedMiddles;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          annotationSettings = _props2.annotationSettings,
          size = _props2.size,
          downloadFields = _props2.downloadFields,
          rAccessor = _props2.rAccessor,
          oAccessor = _props2.oAccessor,
          name = _props2.name,
          download = _props2.download,
          annotations = _props2.annotations,
          matte = _props2.matte,
          renderKey = _props2.renderKey,
          interaction = _props2.interaction,
          customClickBehavior = _props2.customClickBehavior,
          customHoverBehavior = _props2.customHoverBehavior,
          customDoubleClickBehavior = _props2.customDoubleClickBehavior,
          projection = _props2.projection,
          backgroundGraphics = _props2.backgroundGraphics,
          foregroundGraphics = _props2.foregroundGraphics,
          afterElements = _props2.afterElements,
          beforeElements = _props2.beforeElements,
          disableContext = _props2.disableContext,
          summaryType = _props2.summaryType,
          summaryHoverAnnotation = _props2.summaryHoverAnnotation,
          pieceHoverAnnotation = _props2.pieceHoverAnnotation,
          hoverAnnotation = _props2.hoverAnnotation,
          canvasPostProcess = _props2.canvasPostProcess,
          baseMarkProps = _props2.baseMarkProps,
          useSpans = _props2.useSpans,
          canvasPieces = _props2.canvasPieces,
          canvasSummaries = _props2.canvasSummaries;
      var _state2 = this.state,
          orFrameRender = _state2.orFrameRender,
          projectedColumns = _state2.projectedColumns,
          adjustedPosition = _state2.adjustedPosition,
          adjustedSize = _state2.adjustedSize,
          legendSettings = _state2.legendSettings,
          columnOverlays = _state2.columnOverlays,
          axesTickLines = _state2.axesTickLines,
          axes = _state2.axes,
          margin = _state2.margin,
          pieceDataXY = _state2.pieceDataXY,
          oLabels = _state2.oLabels,
          title = _state2.title;


      var downloadButton = void 0;

      if (download) {
        downloadButton = _react2.default.createElement(_DownloadButton2.default, {
          csvName: (name || "orframe") + "-" + new Date().toJSON(),
          width: size[0],
          data: (0, _downloadDataMapping.orDownloadMapping)({
            data: projectedColumns,
            rAccessor: (0, _dataFunctions.stringToFn)(rAccessor),
            oAccessor: (0, _dataFunctions.stringToFn)(oAccessor),
            fields: downloadFields
          })
        });
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        key: "orframe",
        additionalDefs: this.props.additionalDefs
      });

      var interactionOverflow = void 0;

      if (summaryType && summaryType.amplitude) {
        if (projection === "horizontal") {
          interactionOverflow = {
            top: summaryType.amplitude,
            bottom: 0,
            left: 0,
            right: 0
          };
        } else if (projection === "radial") {
          interactionOverflow = defaultOverflow;
        } else {
          interactionOverflow = {
            top: 0,
            bottom: 0,
            left: summaryType.amplitude,
            right: 0
          };
        }
      }

      return _react2.default.createElement(_Frame2.default, {
        name: "ordinalframe",
        renderPipeline: orFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        axes: axes && [axes],
        useSpans: useSpans,
        axesTickLines: axesTickLines,
        title: title,
        matte: matte,
        className: className,
        finalFilterDefs: finalFilterDefs,
        frameKey: "none",
        renderKeyFn: renderKey,
        projectedCoordinateNames: projectedCoordinatesObject,
        defaultSVGRule: this.defaultORSVGRule.bind(this),
        defaultHTMLRule: this.defaultORHTMLRule.bind(this),
        hoverAnnotation: summaryHoverAnnotation || pieceHoverAnnotation || hoverAnnotation,
        annotations: annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: pieceDataXY,
        margin: margin,
        columns: projectedColumns,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: [foregroundGraphics, oLabels],
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        overlay: columnOverlays,
        rScale: this.rScale,
        projection: projection,
        disableContext: disableContext,
        interactionOverflow: interactionOverflow,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        canvasRendering: canvasPieces || canvasSummaries
      });
    }
  }]);

  return OrdinalFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  projection: "vertical",
  size: [500, 500],
  className: ""
}, _temp);


OrdinalFrame.propTypes = _extends({}, _frame_props.ordinalframeproptypes);

exports.default = OrdinalFrame;
module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _XYFrame = __webpack_require__(34);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// components

var MiniMap = function MiniMap(props) {
  var brushStart = props.brushStart,
      brush = props.brush,
      brushEnd = props.brushEnd,
      xBrushable = props.xBrushable,
      yBrushable = props.yBrushable,
      yBrushExtent = props.yBrushExtent,
      xBrushExtent = props.xBrushExtent,
      rest = _objectWithoutProperties(props, ["brushStart", "brush", "brushEnd", "xBrushable", "yBrushable", "yBrushExtent", "xBrushExtent"]);

  var interactivity = {
    start: brushStart,
    during: brush,
    end: brushEnd
  };

  if (xBrushable && yBrushable) {
    interactivity.brush = "xyBrush";

    if (xBrushExtent || yBrushExtent) {
      interactivity.extent = [[0, 0], [].concat(_toConsumableArray(props.size))];
    }
    if (xBrushExtent) {
      interactivity.extent[0] = xBrushExtent;
    }
    if (yBrushExtent) {
      interactivity.extent[1] = yBrushExtent;
    }
  } else if (xBrushable) {
    interactivity.brush = "xBrush";
    if (xBrushExtent) {
      interactivity.extent = xBrushExtent;
    }
  } else if (yBrushable) {
    interactivity.brush = "yBrush";
    if (yBrushExtent) {
      interactivity.extent = yBrushExtent;
    }
  }

  return _react2.default.createElement(_XYFrame2.default, _extends({}, rest, { interaction: interactivity }));
};

MiniMap.propTypes = {
  brushStart: _propTypes2.default.func,
  brush: _propTypes2.default.func,
  brushEnd: _propTypes2.default.func,
  xBrushExtent: _propTypes2.default.array,
  yBrushExtent: _propTypes2.default.array,
  xBrushable: _propTypes2.default.bool,
  yBrushable: _propTypes2.default.bool
};

exports.default = MiniMap;
module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(207);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.networkFrameDefaults = exports.ordinalFrameDefaults = exports.xyFrameDefaults = exports.axisDefaults = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var allFrameDefaults = {
  margin: 0
};

function sparkNetworkSettings() {
  var originalSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "force";

  var finalSettings = {};
  if (originalSettings) {
    finalSettings = originalSettings;
    if (originalSettings === "force") finalSettings = { type: "force" };

    return _extends({
      edgeStrength: 2,
      edgeDistance: 5,
      nodePadding: 1,
      nodeWidth: 5,
      groupWidth: 4
    }, finalSettings);
  }
  return originalSettings;
}

var createSparkFrame = function createSparkFrame(Frame, defaults) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(SparkFrame, _React$Component);

    function SparkFrame(props) {
      _classCallCheck(this, SparkFrame);

      var _this = _possibleConstructorReturn(this, (SparkFrame.__proto__ || Object.getPrototypeOf(SparkFrame)).call(this, props));

      _this._onResize = function (width, height) {
        _this.setState({ containerHeight: height, containerWidth: width });
      };

      _this.state = {
        containerHeight: props.size[1],
        containerWidth: props.size[0]
      };
      return _this;
    }

    _createClass(SparkFrame, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var element = this.node;
        var lineHeight = +window.getComputedStyle(element).lineHeight.split("px")[0] - 5;

        this.setState({
          containerHeight: isNaN(lineHeight) ? element.offsetHeight : lineHeight,
          containerWidth: element.offsetWidth
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            size = _props.size,
            _props$style = _props.style,
            style = _props$style === undefined ? {} : _props$style;
        var _state$containerHeigh = this.state.containerHeight,
            containerHeight = _state$containerHeigh === undefined ? 30 : _state$containerHeigh;


        var actualSize = [];

        actualSize[0] = typeof size === "number" ? size : size[0] ? size[0] : containerHeight;
        actualSize[1] = containerHeight;

        return _react2.default.createElement(
          "span",
          {
            style: _extends({
              width: actualSize[0] + "px",
              height: actualSize[1] + "px",
              display: "inline-block",
              marginLeft: "5px",
              marginRight: "5px"
            }, style),
            ref: function ref(node) {
              return _this2.node = node;
            }
          },
          _react2.default.createElement(Frame, _extends({}, defaults(this.props), { size: actualSize, useSpans: true }))
        );
      }
    }]);

    return SparkFrame;
  }(_react2.default.Component), _class.propTypes = {
    size: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number])
  }, _class.defaultProps = {
    size: []
  }, _temp;
};

var axisDefaults = exports.axisDefaults = {
  tickFormat: function tickFormat() {
    return "";
  },
  baseline: false
};

var xyFrameDefaults = exports.xyFrameDefaults = function xyFrameDefaults(props) {
  return _extends({}, allFrameDefaults, props, {
    hoverAnnotation: props.hoverAnnotation,
    axes: props.axes ? props.axes.map(function (a) {
      return _extends({}, axisDefaults, a);
    }) : props.axes
  });
};

var ordinalFrameDefaults = exports.ordinalFrameDefaults = function ordinalFrameDefaults(props) {
  return _extends({}, allFrameDefaults, props, {
    hoverAnnotation: props.hoverAnnotation,
    axis: props.axis ? _extends({ axisDefaults: axisDefaults }, props.axis) : props.axis
  });
};

var networkFrameDefaults = exports.networkFrameDefaults = function networkFrameDefaults(props) {
  return _extends({}, allFrameDefaults, {
    nodeSizeAccessor: 2
  }, props, {
    networkType: sparkNetworkSettings(props.networkType)
    //  hoverAnnotation: props.hoverAnnotation === true ? [{ type: "react-annotation"}] : props.hoverAnnotation,
  });
};

exports.default = createSparkFrame;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(217);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _annotationHandling = __webpack_require__(235);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Legend = __webpack_require__(115);

var _Legend2 = _interopRequireDefault(_Legend);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _labella = __webpack_require__(274);

var _labella2 = _interopRequireDefault(_labella);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // modules

//import { load } from 'opentype.js'


function adjustedAnnotationKeyMapper(d) {
  return d.props.noteData.id || d.props.noteData.x + "-" + d.props.noteData.y;
}

function noteDataWidth(noteData) {
  var charWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

  var wrap = noteData.note && noteData.note.wrap || 120;
  var noteText = noteData.note.label || noteData.note.label || "";
  return Math.min(wrap, noteText.length * charWidth);
}

function noteDataHeight(noteData) {
  var charWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var lineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  var wrap = noteData.note && noteData.note.wrap || 120;
  var text = noteData.note.label || noteData.note.title || "";
  return Math.ceil(text.length * charWidth / wrap) * lineHeight + (noteData.note.label && noteData.note.title ? lineHeight : 0);
}

function objectStringKey(object) {
  var finalKey = "";
  Object.keys(object).forEach(function (key) {
    finalKey += !object[key] || !object[key].toString ? object[key] : object[key].toString();
  });

  return finalKey;
}

var AnnotationLayer = function (_React$Component) {
  _inherits(AnnotationLayer, _React$Component);

  function AnnotationLayer(props) {
    _classCallCheck(this, AnnotationLayer);

    var _this = _possibleConstructorReturn(this, (AnnotationLayer.__proto__ || Object.getPrototypeOf(AnnotationLayer)).call(this, props));

    _this.generateSVGAnnotations = _this.generateSVGAnnotations.bind(_this);
    _this.generateHTMLAnnotations = _this.generateHTMLAnnotations.bind(_this);

    _this.state = {
      font: undefined,
      svgAnnotations: [],
      htmlAnnotations: [],
      adjustedAnnotations: 0,
      adjustedAnnotationsKey: "",
      adjustedAnnotationsDataVersion: ""
    };
    return _this;
  }

  /*    componentWillMount() {
      const fontLocation = this.props.fontLocation
       if (fontLocation) {
        load(fontLocation, function(err, font) {
            if (err) {
                return null
            } else {
                this.setState({ font });
            }
        });
      }
    } */

  _createClass(AnnotationLayer, [{
    key: "generateSVGAnnotations",
    value: function generateSVGAnnotations(props, annotations) {
      var renderedAnnotations = annotations.map(function (d, i) {
        return props.svgAnnotationRule(d, i, props);
      }).filter(function (d) {
        return d !== null && d !== undefined;
      });

      return renderedAnnotations;
    }
  }, {
    key: "generateHTMLAnnotations",
    value: function generateHTMLAnnotations(props, annotations) {
      var renderedAnnotations = annotations.map(function (d, i) {
        return props.htmlAnnotationRule(d, i, props);
      }).filter(function (d) {
        return d !== null && d !== undefined;
      });

      return renderedAnnotations;
    }
  }, {
    key: "processAnnotations",
    value: function processAnnotations(adjustableAnnotations, annotationProcessor, props) {

      if (annotationProcessor.type === false) {
        return adjustableAnnotations;
      }

      var _props$margin = props.margin,
          margin = _props$margin === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$margin;
      var size = props.size,
          _props$axes = props.axes,
          axes = _props$axes === undefined ? [] : _props$axes;


      margin = typeof margin === "number" ? { top: margin, left: margin, right: margin, bottom: margin } : margin;

      var _annotationProcessor$ = annotationProcessor.padding,
          padding = _annotationProcessor$ === undefined ? 2 : _annotationProcessor$;


      if (annotationProcessor.type === "bump") {
        var adjustedAnnotations = (0, _annotationHandling.bumpAnnotations)(adjustableAnnotations, props, annotationProcessor);
        return adjustedAnnotations;
      } else if (annotationProcessor.type === "marginalia") {
        var marginOffset = annotationProcessor.marginOffset;

        var finalOrientation = !annotationProcessor.orient || annotationProcessor.orient === "nearest" ? ["left", "right", "top", "bottom"] : Array.isArray(annotationProcessor.orient) ? annotationProcessor.orient : [annotationProcessor.orient];
        var marginOffsetFn = function marginOffsetFn(orient, axisSettings) {
          if (axisSettings && axisSettings.find(function (d) {
            return d.props.orient === orient;
          })) {
            return 50;
          }
          return 10;
        };
        if (typeof marginOffset === "number") {
          marginOffsetFn = function marginOffsetFn() {
            return marginOffset;
          };
        }

        var leftOn = finalOrientation.find(function (d) {
          return d === "left";
        });
        var rightOn = finalOrientation.find(function (d) {
          return d === "right";
        });
        var topOn = finalOrientation.find(function (d) {
          return d === "top";
        });
        var bottomOn = finalOrientation.find(function (d) {
          return d === "bottom";
        });

        var leftNodes = [];
        var rightNodes = [];
        var topNodes = [];
        var bottomNodes = [];

        adjustableAnnotations.forEach(function (aNote) {
          var noteData = aNote.props.noteData;
          var noteX = noteData.x[0] || noteData.x;
          var noteY = noteData.y[0] || noteData.y;

          var leftDist = leftOn ? noteX : Infinity;
          var rightDist = rightOn ? size[0] - noteX : Infinity;
          var topDist = topOn ? noteY : Infinity;
          var bottomDist = bottomOn ? size[1] - noteY : Infinity;

          var minDist = Math.min(leftDist, rightDist, topDist, bottomDist);

          if (leftDist === minDist) {
            leftNodes.push(aNote);
          } else if (rightDist === minDist) {
            rightNodes.push(aNote);
          } else if (topDist === minDist) {
            topNodes.push(aNote);
          } else {
            bottomNodes.push(aNote);
          }
        });

        //Adjust the margins based on which regions are active

        var leftForce = new _labella2.default.Force({
          minPos: 0 - margin.top,
          maxPos: bottomOn ? size[1] : size[1] + margin.bottom
        }).nodes(leftNodes.map(function (d) {
          var noteY = d.props.noteData.y[0] || d.props.noteData.y;
          return new _labella2.default.Node(noteY, noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding);
        })).compute();

        var rightForce = new _labella2.default.Force({
          minPos: topOn ? 0 : 0 - margin.top,
          maxPos: size[1] + margin.bottom
        }).nodes(rightNodes.map(function (d) {
          var noteY = d.props.noteData.y[0] || d.props.noteData.y;
          return new _labella2.default.Node(noteY, noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding);
        })).compute();

        var topForce = new _labella2.default.Force({
          minPos: leftOn ? 0 : 0 - margin.left,
          maxPos: size[0] + margin.right
        }).nodes(topNodes.map(function (d) {
          var noteX = d.props.noteData.x[0] || d.props.noteData.x;
          return new _labella2.default.Node(noteX, noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding);
        })).compute();

        var bottomForce = new _labella2.default.Force({
          minPos: 0 - margin.left,
          maxPos: rightOn ? size[0] : size[0] + margin.right
        }).nodes(bottomNodes.map(function (d) {
          var noteX = d.props.noteData.x[0] || d.props.noteData.x;
          return new _labella2.default.Node(noteX, noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding);
        })).compute();

        var bottomOffset = Math.max.apply(Math, _toConsumableArray(bottomNodes.map(function (d) {
          return noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding;
        })));
        var topOffset = Math.max.apply(Math, _toConsumableArray(topNodes.map(function (d) {
          return noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding;
        })));
        var leftOffset = Math.max.apply(Math, _toConsumableArray(leftNodes.map(function (d) {
          return noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding;
        })));
        var rightOffset = Math.max.apply(Math, _toConsumableArray(rightNodes.map(function (d) {
          return noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding;
        })));

        //      const nodeOffsetHeight = Math.max()

        var leftSortedNodes = leftForce.nodes();
        var rightSortedNodes = rightForce.nodes();
        var topSortedNodes = topForce.nodes();
        var bottomSortedNodes = bottomForce.nodes();

        leftNodes.forEach(function (note, i) {
          note.props.noteData.ny = leftSortedNodes[i].currentPos;
          note.props.noteData.nx = 0 - leftSortedNodes[i].layerIndex * leftOffset - marginOffsetFn("left", axes);
          if (note.props.noteData.note) {
            note.props.noteData.note.orientation = note.props.noteData.note.orientation || "leftRight";
            note.props.noteData.note.align = note.props.noteData.note.align || "right";
          }
        });

        rightNodes.forEach(function (note, i) {
          note.props.noteData.ny = rightSortedNodes[i].currentPos;
          note.props.noteData.nx = size[0] + rightSortedNodes[i].layerIndex * rightOffset + marginOffsetFn("right", axes);
          if (note.props.noteData.note) {
            note.props.noteData.note.orientation = note.props.noteData.note.orientation || "leftRight";
            note.props.noteData.note.align = note.props.noteData.note.align || "left";
          }
        });

        topNodes.forEach(function (note, i) {
          note.props.noteData.nx = topSortedNodes[i].currentPos;
          note.props.noteData.ny = 0 - topSortedNodes[i].layerIndex * topOffset - marginOffsetFn("top", axes);
        });

        bottomNodes.forEach(function (note, i) {
          note.props.noteData.nx = bottomSortedNodes[i].currentPos;
          note.props.noteData.ny = size[1] + bottomSortedNodes[i].layerIndex * bottomOffset + marginOffsetFn("bottom", axes);
        });
        return adjustableAnnotations;
      }
      return adjustableAnnotations;
    }
  }, {
    key: "createAnnotations",
    value: function createAnnotations(props) {
      var renderedSVGAnnotations = this.state.svgAnnotations,
          renderedHTMLAnnotations = [],
          adjustedAnnotations = this.state.adjustedAnnotations,
          adjustableAnnotationsKey = this.state.adjustedAnnotationsKey;

      var adjustedAnnotationsKey = this.state.adjustedAnnotationsKey,
          adjustedAnnotationsDataVersion = this.state.adjustedAnnotationsDataVersion;

      var annotations = props.annotations,
          _props$annotationHand = props.annotationHandling,
          annotationHandling = _props$annotationHand === undefined ? false : _props$annotationHand;

      var annotationProcessor = (typeof annotationHandling === "undefined" ? "undefined" : _typeof(annotationHandling)) !== "object" ? { type: annotationHandling } : annotationHandling;

      var _annotationProcessor$2 = annotationProcessor.dataVersion,
          dataVersion = _annotationProcessor$2 === undefined ? "" : _annotationProcessor$2;


      if (this.props.svgAnnotationRule) {
        var initialSVGAnnotations = this.generateSVGAnnotations(props, annotations);
        var adjustableAnnotations = initialSVGAnnotations.filter(function (d) {
          return d.props && d.props.noteData && !d.props.noteData.fixedPosition;
        });
        var fixedAnnotations = initialSVGAnnotations.filter(function (d) {
          return !d.props || !d.props.noteData || d.props.noteData.fixedPosition;
        });
        adjustableAnnotationsKey = "" + adjustableAnnotations.map(adjustedAnnotationKeyMapper).join(",") + objectStringKey(_extends(annotationProcessor, {
          point: props.pointSizeFunction,
          label: props.labelSizeFunction
        })) + props.size;

        if (annotationProcessor.type === false) {
          adjustedAnnotations = adjustableAnnotations;
        }

        if (adjustedAnnotations.length !== adjustableAnnotations.length || adjustedAnnotationsKey !== adjustableAnnotationsKey || adjustedAnnotationsDataVersion !== dataVersion) {
          adjustedAnnotations = this.processAnnotations(adjustableAnnotations, annotationProcessor, props);
        } else {
          //Handle when style or other attributes change
          adjustedAnnotations = adjustedAnnotations.map(function (d, i) {
            var newNoteData = _extends(adjustableAnnotations[i].props.noteData, {
              nx: d.props.noteData.nx,
              ny: d.props.noteData.ny,
              note: d.props.noteData.note
            });
            return _react2.default.createElement(_Annotation2.default, { key: d.key, noteData: newNoteData });
          });
        }

        renderedSVGAnnotations = [].concat(_toConsumableArray(adjustedAnnotations), _toConsumableArray(fixedAnnotations));
      }

      if (this.props.htmlAnnotationRule) {
        renderedHTMLAnnotations = this.generateHTMLAnnotations(props, annotations);
      }

      this.setState({
        svgAnnotations: renderedSVGAnnotations,
        htmlAnnotations: renderedHTMLAnnotations,
        adjustedAnnotations: adjustedAnnotations,
        adjustedAnnotationsKey: adjustableAnnotationsKey,
        adjustedAnnotationsDataVersion: dataVersion
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.createAnnotations(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.createAnnotations(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          svgAnnotations = _state.svgAnnotations,
          htmlAnnotations = _state.htmlAnnotations;
      var _props = this.props,
          useSpans = _props.useSpans,
          legendSettings = _props.legendSettings,
          margin = _props.margin;


      var renderedLegend = void 0;
      if (legendSettings) {
        var positionHash = {
          left: [15, 15],
          right: [this.props.size[0] + 15, 15]
        };
        var _legendSettings$posit = legendSettings.position,
            position = _legendSettings$posit === undefined ? "right" : _legendSettings$posit,
            _legendSettings$title = legendSettings.title,
            title = _legendSettings$title === undefined ? "Legend" : _legendSettings$title;

        var legendPosition = positionHash[position] || position;
        renderedLegend = _react2.default.createElement(
          "g",
          { transform: "translate(" + legendPosition + ")" },
          _react2.default.createElement(_Legend2.default, _extends({}, legendSettings, { title: title, position: position }))
        );
      }
      var svgStyle = {
        background: "none",
        pointerEvents: "none",
        position: "absolute",
        left: margin.left + "px",
        top: margin.top + "px"
        //    if (useSpans) {
      };svgStyle.overflow = "visible";
      //    }

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: "annotation-layer",
          style: {
            position: "absolute",
            pointerEvents: "none",
            background: "none"
          }
        },
        _react2.default.createElement(
          "svg",
          {
            className: "annotation-layer-svg",
            height: this.props.size[1],
            width: this.props.size[0],
            style: svgStyle
          },
          _react2.default.createElement(
            "g",
            null,
            renderedLegend,
            svgAnnotations
          )
        ),
        _react2.default.createElement(
          _SpanOrDiv2.default,
          {
            span: useSpans,
            className: "annotation-layer-html",
            style: {
              background: "none",
              pointerEvents: "none",
              position: "absolute",
              height: this.props.size[1] + "px",
              width: this.props.size[0] + "px",
              left: margin.left + "px",
              top: margin.top + "px"
            }
          },
          htmlAnnotations
        )
      );
    }
  }]);

  return AnnotationLayer;
}(_react2.default.Component);

AnnotationLayer.propTypes = {
  scale: _propTypes2.default.func,
  orient: _propTypes2.default.string,
  title: _propTypes2.default.string,
  format: _propTypes2.default.string,
  values: _propTypes2.default.array,
  properties: _propTypes2.default.object,
  position: _propTypes2.default.array
};

exports.default = AnnotationLayer;
module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var typeHash = {
  fill: function fill(style) {
    return _react2.default.createElement("rect", { style: style, width: 20, height: 20 });
  },
  line: function line(style) {
    return _react2.default.createElement("line", { style: style, x1: 0, y1: 0, x2: 20, y2: 20 });
  }
};

var Legend = function (_React$Component) {
  _inherits(Legend, _React$Component);

  function Legend() {
    _classCallCheck(this, Legend);

    return _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).apply(this, arguments));
  }

  _createClass(Legend, [{
    key: "renderLegendGroup",
    value: function renderLegendGroup(legendGroup) {
      var _legendGroup$type = legendGroup.type,
          type = _legendGroup$type === undefined ? "fill" : _legendGroup$type,
          styleFn = legendGroup.styleFn,
          items = legendGroup.items;

      var renderedItems = [];
      var itemOffset = 0;
      items.forEach(function (item, i) {
        var Type = typeHash[type];
        var renderedType = void 0;
        if (Type) {
          var style = styleFn(item, i);
          renderedType = Type(style);
        } else {
          renderedType = type(item);
        }
        renderedItems.push(_react2.default.createElement(
          "g",
          { key: "legend-item-" + i, transform: "translate(0," + itemOffset + ")" },
          renderedType,
          _react2.default.createElement(
            "text",
            { y: 15, x: 30 },
            item.label
          )
        ));
        itemOffset += 25;
      });
      return renderedItems;
    }
  }, {
    key: "renderLegendGroupHorizontal",
    value: function renderLegendGroupHorizontal(legendGroup) {
      var _legendGroup$type2 = legendGroup.type,
          type = _legendGroup$type2 === undefined ? "fill" : _legendGroup$type2,
          styleFn = legendGroup.styleFn,
          items = legendGroup.items;

      var renderedItems = [];
      var itemOffset = 0;
      items.forEach(function (item, i) {
        var Type = typeHash[type];
        var renderedType = void 0;
        if (Type) {
          var style = styleFn(item, i);
          renderedType = Type(style);
        } else {
          renderedType = type(item);
        }
        renderedItems.push(_react2.default.createElement(
          "g",
          { key: "legend-item-" + i, transform: "translate(" + itemOffset + ",0)" },
          renderedType,
          _react2.default.createElement(
            "text",
            { y: 15, x: 25 },
            item.label
          )
        ));
        itemOffset += 35;
        itemOffset += item.label.length * 8;
      });
      return { items: renderedItems, offset: itemOffset };
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(_ref) {
      var _this2 = this;

      var legendGroups = _ref.legendGroups,
          width = _ref.width;

      var offset = 30;

      var renderedGroups = [];

      legendGroups.forEach(function (l, i) {
        offset += 5;
        renderedGroups.push(_react2.default.createElement("line", {
          key: "legend-top-line legend-symbol-" + i,
          stroke: "gray",
          x1: 0,
          y1: offset,
          x2: width,
          y2: offset
        }));
        offset += 10;
        if (l.label) {
          offset += 20;
          renderedGroups.push(_react2.default.createElement(
            "text",
            {
              key: "legend-text-" + i,
              y: offset,
              className: "legend-group-label"
            },
            l.label
          ));
          offset += 10;
        }

        renderedGroups.push(_react2.default.createElement(
          "g",
          {
            key: "legend-group-" + i,
            className: "legend-item",
            transform: "translate(0," + offset + ")"
          },
          _this2.renderLegendGroup(l)
        ));
        offset += l.items.length * 25 + 10;
      });

      return renderedGroups;
    }
  }, {
    key: "renderHorizontalGroup",
    value: function renderHorizontalGroup(_ref2) {
      var _this3 = this;

      var legendGroups = _ref2.legendGroups,
          title = _ref2.title,
          height = _ref2.height;

      var offset = 0;

      var renderedGroups = [];

      var verticalOffset = title === false ? 10 : 40;

      legendGroups.forEach(function (l, i) {
        if (l.label) {
          renderedGroups.push(_react2.default.createElement(
            "text",
            {
              key: "legend-text-" + i,
              transform: "translate(" + offset + "," + verticalOffset + ") rotate(90)",
              textAnchor: "start",
              className: "legend-group-label"
            },
            l.label
          ));
          offset += 20;
        }

        var renderedItems = _this3.renderLegendGroupHorizontal(l);

        renderedGroups.push(_react2.default.createElement(
          "g",
          {
            key: "legend-group-" + i,
            className: "legend-item",
            transform: "translate(" + offset + "," + verticalOffset + ")"
          },
          renderedItems.items
        ));
        offset += renderedItems.offset + 5;

        if (legendGroups[i + 1]) {
          renderedGroups.push(_react2.default.createElement("line", {
            key: "legend-top-line legend-symbol-" + i,
            stroke: "gray",
            x1: offset,
            y1: verticalOffset - 10,
            x2: offset,
            y2: height + verticalOffset + 10
          }));
        }
        offset += 15;
      });

      return _react2.default.createElement(
        "g",
        null,
        title !== false && _react2.default.createElement("line", {
          x1: 0,
          x2: offset + 10,
          y1: verticalOffset - 10,
          y2: verticalOffset - 10,
          stroke: "gray",
          className: "title-neatline"
        }),
        renderedGroups
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          legendGroups = _props.legendGroups,
          _props$title = _props.title,
          title = _props$title === undefined ? "Legend" : _props$title,
          _props$width = _props.width,
          width = _props$width === undefined ? 100 : _props$width,
          _props$height = _props.height,
          height = _props$height === undefined ? 20 : _props$height,
          _props$orientation = _props.orientation,
          orientation = _props$orientation === undefined ? "vertical" : _props$orientation;

      var renderedGroups = orientation === "vertical" ? this.renderGroup({
        legendGroups: legendGroups,
        title: title,
        width: width,
        orientation: orientation
      }) : this.renderHorizontalGroup(_defineProperty({
        legendGroups: legendGroups,
        title: title,
        height: height,
        orientation: orientation
      }, "title", title));

      return _react2.default.createElement(
        "g",
        null,
        title !== false && _react2.default.createElement(
          "text",
          {
            className: "legend-title",
            y: 20,
            x: orientation === "horizontal" ? 0 : width / 2,
            textAnchor: orientation === "horizontal" ? "start" : "middle"
          },
          title
        ),
        renderedGroups
      );
    }
  }]);

  return Legend;
}(_react2.default.Component);

Legend.propTypes = {
  title: _propTypes2.default.string,
  width: _propTypes2.default.number,
  legendGroups: _propTypes2.default.array
};

exports.default = Legend;
module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationLabel;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

var _ConnectorLine = __webpack_require__(64);

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationLabel(props) {
  var className = (0, _classnames2.default)("label", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorLine2.default, {
    align: "middle"
  });
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Annotation = function (_React$Component) {
  _inherits(Annotation, _React$Component);

  function Annotation() {
    _classCallCheck(this, Annotation);

    return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
  }

  _createClass(Annotation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          x = _props.x,
          y = _props.y,
          nx = _props.nx,
          ny = _props.ny,
          events = _props.events;


      var cleanedProps = Object.assign({}, this.props);
      delete cleanedProps.children;

      if (nx !== undefined) cleanedProps.dx = nx - x;
      if (ny !== undefined) cleanedProps.dy = ny - y;

      var childrenWithProps = _react2.default.Children.toArray(this.props.children).map(function (child) {
        return _react2.default.cloneElement(child, _extends({}, cleanedProps, child.props));
      });

      Object.keys(events).forEach(function (k) {
        events[k] = events[k].bind(_this2, _this2.props, _this2.state);
      });

      return _react2.default.createElement(
        "g",
        _extends({
          className: (0, _classnames2.default)("annotation", this.props.className),
          transform: "translate(" + x + ", " + y + ")"
        }, events),
        childrenWithProps
      );
    }
  }]);

  return Annotation;
}(_react2.default.Component);

exports.default = Annotation;


Annotation.defaultProps = {
  x: 0,
  y: 0,
  dx: 0,
  dy: 0,
  color: "grey",
  events: {}
};

Annotation.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  color: _propTypes2.default.string,
  editMode: _propTypes2.default.bool,
  events: _propTypes2.default.object
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineSetup = undefined;

var _Builder = __webpack_require__(8);

var lineSetup = exports.lineSetup = function lineSetup(_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      radiusPadding = _ref.radiusPadding,
      width = _ref.width,
      height = _ref.height;

  var x1 = 0,
      x2 = dx,
      y1 = 0,
      y2 = dy;

  if (outerRadius || radius) {
    var h = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    var angle = Math.asin(-y2 / h);
    var r = (outerRadius || radius) + (radiusPadding || 0);

    x1 = Math.abs(Math.cos(angle) * r) * (x2 < 0 ? -1 : 1);
    y1 = Math.abs(Math.sin(angle) * r) * (y2 < 0 ? -1 : 1);
  }

  if (width && height) {
    if (width > 0 && dx > 0 || width < 0 && dx < 0) {
      if (Math.abs(width) > Math.abs(dx)) x1 = width / 2;else x1 = width;
    }
    if (height > 0 && dy > 0 || height < 0 && dy < 0) {
      if (Math.abs(height) > Math.abs(dy)) y1 = height / 2;else y1 = height;
    }
    if (x1 === width / 2 && y1 === height / 2) {
      x1 = x2;
      y1 = y2;
    }
  }

  return [[x1, y1], [x2, y2]];
};

exports.default = function (connectorData) {
  var data = lineSetup(connectorData);
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "connector" })] };
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(66);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(41);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(65);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(25);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(25);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(44);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(44);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectorEnd = function (_React$Component) {
  _inherits(ConnectorEnd, _React$Component);

  function ConnectorEnd() {
    _classCallCheck(this, ConnectorEnd);

    return _possibleConstructorReturn(this, (ConnectorEnd.__proto__ || Object.getPrototypeOf(ConnectorEnd)).apply(this, arguments));
  }

  _createClass(ConnectorEnd, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var color = this.props.color;

      var d = this.getComponents(this.props) || [];
      var c = d.components[0];

      return _react2.default.createElement(c.type, _extends({ className: c.className }, c.attrs, { fill: color }));
    }
  }]);

  return ConnectorEnd;
}(_react2.default.Component);

exports.default = ConnectorEnd;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = {
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  },
  touch: {
    start: "touchstart",
    move: "touchemove",
    stop: "touchend"
  }
};

var Handle = function (_React$Component) {
  _inherits(Handle, _React$Component);

  function Handle() {
    _classCallCheck(this, Handle);

    return _possibleConstructorReturn(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  _createClass(Handle, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$x = _props.x,
          x = _props$x === undefined ? 0 : _props$x,
          _props$y = _props.y,
          y = _props$y === undefined ? 0 : _props$y,
          _props$r = _props.r,
          r = _props$r === undefined ? 10 : _props$r,
          handleStart = _props.handleStart,
          handleDrag = _props.handleDrag,
          handleStop = _props.handleStop;


      var makeHandler = function makeHandler(type) {
        return function (e) {
          e.preventDefault();

          var xDim = "clientX";
          var yDim = "clientY";
          var oX = e.nativeEvent[xDim];
          var oY = e.nativeEvent[yDim];
          var x = oX;
          var y = oY;

          handleStart();

          var move = function move(d) {
            d.preventDefault();
            handleDrag(d, {
              deltaX: d[xDim] - x,
              deltaY: d[yDim] - y,
              oDeltaX: d[xDim] - oX,
              oDeltaY: d[yDim] - oY
            });

            x = d[xDim];
            y = d[yDim];
          };

          document.addEventListener(events[type].move, move);
          document.addEventListener(events[type].stop, function (e) {
            e.preventDefault();
            document.removeEventListener(events[type].move, move);
            document.removeEventListener(events[type].stop, move);
            handleStop();
          });
        };
      };

      return _react2.default.createElement("circle", {
        className: "handle",
        cx: x,
        cy: y,
        r: r,
        onMouseDown: makeHandler("mouse"),
        strokeDasharray: "5",
        stroke: "grey",
        fill: "white",
        ref: function ref(handle) {
          _this2.handle = handle;
        },
        fillOpacity: 0
      });
    }
  }]);

  return Handle;
}(_react2.default.Component);

exports.default = Handle;


Handle.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  r: _propTypes2.default.number,
  handleStart: _propTypes2.default.func,
  handleStop: _propTypes2.default.func,
  handleDrag: _propTypes2.default.func
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _alignment4 = __webpack_require__(70);

var _alignment5 = _interopRequireDefault(_alignment4);

var _Handle = __webpack_require__(134);

var _Handle2 = _interopRequireDefault(_Handle);

var _lineTypeVertical = __webpack_require__(272);

var _lineTypeVertical2 = _interopRequireDefault(_lineTypeVertical);

var _lineTypeHorizontal = __webpack_require__(273);

var _lineTypeHorizontal2 = _interopRequireDefault(_lineTypeHorizontal);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getOuterBBox = function getOuterBBox() {
  for (var _len = arguments.length, domNodes = Array(_len), _key = 0; _key < _len; _key++) {
    domNodes[_key] = arguments[_key];
  }

  return [].concat(domNodes).reduce(function (p, c) {
    if (c) {
      var bbox = c.getBBox();
      p.x = Math.min(p.x, bbox.x);
      p.y = Math.min(p.y, bbox.y);
      p.width = Math.max(p.width, bbox.width);

      var yOffset = c && c.attributes && c.attributes.y;
      p.height = Math.max(p.height, (yOffset && parseFloat(yOffset.value) || 0) + bbox.height);
    }
    return p;
  }, { x: 0, y: 0, width: 0, height: 0 });
};

var Note = function (_React$Component) {
  _inherits(Note, _React$Component);

  function Note(props) {
    _classCallCheck(this, Note);

    var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this, props));

    _this.state = {
      translateX: 0,
      translateY: 0,
      labelOffset: 0,
      changed: 0,
      bbox: { width: 0, height: 0, x: 0, y: 0 }
    };


    _this.updateText = _this.updateText.bind(_this);
    return _this;
  }

  _createClass(Note, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateText(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.title !== this.props.title || nextProps.label !== this.props.label || nextProps.wrap !== this.props.wrap) {
        this.updateText(nextProps);
      }
      if (nextProps.editMode && (nextProps.align === "dynamic" || !nextProps.align)) {
        this.updateText(nextProps);
      }
    }
  }, {
    key: "updateText",
    value: function updateText(_ref) {
      var _this2 = this;

      var orientation = _ref.orientation,
          padding = _ref.padding,
          align = _ref.align,
          lineType = _ref.lineType,
          label = _ref.label,
          title = _ref.title,
          wrap = _ref.wrap,
          wrapSplitter = _ref.wrapSplitter,
          dx = _ref.dx,
          dy = _ref.dy;

      var newState = {
        titleWrapped: null,
        labelWrapped: null
      };
      newState.changed = this.state.changed + 1;

      if (title) {
        newState.titleWrapped = this.refs.title && this.wrapText(this.refs.title, newState.changed, title, wrap, wrapSplitter);
      }
      if (label) newState.labelWrapped = this.refs.label && this.wrapText(this.refs.label, newState.changed, label, wrap, wrapSplitter);

      this.setState(newState, function () {
        var setLabel = function setLabel() {
          var bbox = getOuterBBox(_this2.refs.title, _this2.refs.label);
          var noteParams = {
            padding: padding,
            bbox: bbox,
            offset: { x: dx, y: dy },
            orientation: orientation,
            align: align
          };
          if (lineType === "vertical") noteParams.orientation = "leftRight";else if (lineType === "horizontal") noteParams.orientation = "topBottom";

          var _alignment = (0, _alignment5.default)(noteParams),
              x = _alignment.x,
              y = _alignment.y;

          _this2.setState({
            translateX: x,
            translateY: y,
            bbox: bbox
          });
        };

        _this2.setState({
          labelOffset: title && _this2.refs.title.getBBox().height || 0
        }, setLabel);
      });
    }
  }, {
    key: "wrapText",
    value: function wrapText(textRef, key, text, width, wrapSplitter) {
      var initialAttrs = {
        x: 0,
        dy: "1.2em"
      };

      var words = text.split(wrapSplitter || /[ \t\r\n]+/).reverse().filter(function (w) {
        return w !== "";
      });

      var word = void 0,
          line = [];

      var tspans = [];

      while (word = words.pop()) {
        line.push(word);
        textRef.lastChild.textContent = line.join(" ");

        var length = textRef.lastChild.getComputedTextLength();

        textRef.lastChild.textContent = "";

        if (length > width && line.length > 1) {
          line.pop();
          tspans.push(_react2.default.createElement(
            "tspan",
            _extends({ key: tspans.length + text }, initialAttrs),
            line.join(" ")
          ));
          line = [word];
        }
      }

      if (line.length !== 0) {
        tspans.push(_react2.default.createElement(
          "tspan",
          _extends({ key: tspans.length + text }, initialAttrs),
          line.join(" ")
        ));
      }

      return _react2.default.createElement(
        "tspan",
        _extends({}, initialAttrs, { key: key + text }),
        tspans
      );
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          orientation = _props.orientation,
          padding = _props.padding,
          align = _props.align,
          dx = _props.dx,
          dy = _props.dy,
          lineType = _props.lineType;


      if (this.state.bbox.width && (prevProps.dx !== this.props.dx || prevProps.dy !== this.props.dy) && (this.refs.title || this.refs.label)) {
        var bbox = getOuterBBox(this.refs.title, this.refs.label);
        var noteParams = {
          padding: padding,
          bbox: bbox,
          offset: { x: dx, y: dy },
          orientation: orientation,
          align: align
        };

        if (lineType === "vertical") noteParams.orientation = "leftRight";else if (lineType === "horizontal") noteParams.orientation = "topBottom";

        var _alignment2 = (0, _alignment5.default)(noteParams),
            x = _alignment2.x,
            y = _alignment2.y;

        var updates = { bbox: bbox };
        if (this.state.translateX !== x) updates.translateX = x;
        if (this.state.translateY !== y) updates.translateY = y;
        if (updates.translateX !== undefined || updates.translateY !== undefined) {
          this.setState(updates);
        }
      } else if (this.state.align !== prevProps.align || this.props.orientation !== prevProps.orientation || this.props.padding !== prevProps.padding) {
        var _noteParams = {
          padding: padding,
          bbox: this.state.bbox,
          offset: { x: dx, y: dy },
          orientation: orientation,
          align: align
        };

        if (lineType === "vertical") _noteParams.orientation = "leftRight";else if (lineType === "horizontal") _noteParams.orientation = "topBottom";

        var _alignment3 = (0, _alignment5.default)(_noteParams),
            _x = _alignment3.x,
            _y = _alignment3.y;

        var _updates = {};
        if (this.state.translateX !== _x) _updates.translateX = _x;
        if (this.state.translateY !== _y) _updates.translateY = _y;
        if (_updates.translateX !== undefined || _updates.translateY !== undefined) {
          this.setState(_updates);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          dx = _props2.dx,
          dy = _props2.dy,
          title = _props2.title,
          label = _props2.label,
          align = _props2.align,
          editMode = _props2.editMode,
          lineType = _props2.lineType,
          color = _props2.color,
          titleColor = _props2.titleColor,
          labelColor = _props2.labelColor;


      var noteTitle = void 0,
          noteText = void 0,
          noteLineType = void 0;
      if (title) {
        noteTitle = _react2.default.createElement(
          "text",
          {
            ref: "title",
            className: "annotation-note-title",
            fontWeight: "bold",
            key: "title",
            fill: titleColor || color
          },
          this.state.titleWrapped || _react2.default.createElement(
            "tspan",
            { x: 0, dy: ".8em" },
            title
          )
        );
      }

      if (label) {
        noteText = _react2.default.createElement(
          "text",
          {
            ref: "label",
            className: "annotation-note-label",
            y: this.state.labelOffset * 1.1,
            key: "label",
            fill: labelColor || color
          },
          this.state.labelWrapped || _react2.default.createElement(
            "tspan",
            { x: 0, dy: ".8em" },
            label
          )
        );
      }

      if (lineType && this.state.bbox.width) {
        var noteParams = {
          bbox: this.state.bbox,
          align: align,
          offset: { x: dx, y: dy }
        };

        var noteComponent = (lineType === "vertical" && (0, _lineTypeVertical2.default)(noteParams) || lineType === "horizontal" && (0, _lineTypeHorizontal2.default)(noteParams)).components[0];

        noteLineType = _react2.default.createElement(noteComponent.type, _extends({
          className: noteComponent.className
        }, noteComponent.attrs, {
          stroke: color
        }));
      }

      var handle = void 0;

      if (editMode) {
        handle = _react2.default.createElement(_Handle2.default, {
          handleStart: this.props.dragStart,
          handleStop: this.props.dragEnd,
          handleDrag: this.props.dragNote
        });
      }

      return _react2.default.createElement(
        "g",
        _extends({
          transform: "translate(" + dx + ", " + dy + ")",
          className: "annotation-note"
        }, this.props.gProps),
        _react2.default.createElement(
          "g",
          {
            className: "annotation-note-content",
            transform: "translate(" + this.state.translateX + ",\n          " + this.state.translateY + ")",
            ref: "note"
          },
          _react2.default.createElement("rect", {
            className: "annotation-note-bg",
            width: this.state.bbox.width,
            height: this.state.bbox.height,
            stroke: "none",
            fill: "white",
            fillOpacity: "0"
          }),
          noteTitle,
          noteText
        ),
        noteLineType,
        handle
      );
    }
  }]);

  return Note;
}(_react2.default.Component);

exports.default = Note;


Note.defaultProps = {
  wrap: 120,
  align: "dynamic",
  orientation: "topBottom",
  padding: 3
};

Note.propTypes = {
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  title: _propTypes2.default.string,
  label: _propTypes2.default.string,
  orientation: _propTypes2.default.oneOf(["leftRight", "topBottom"]),
  padding: _propTypes2.default.number,
  align: _propTypes2.default.oneOf(["left", "right", "middle", "top", "bottom", "dynamic"]),
  editMode: _propTypes2.default.bool,
  lineType: _propTypes2.default.oneOf(["vertical", "horizontal"]),
  color: _propTypes2.default.string,
  titleColor: _propTypes2.default.string,
  labelColor: _propTypes2.default.string
};

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(137);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(140);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(29);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(146);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(47);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(3);

__webpack_require__(154);

var _drawing = __webpack_require__(372);

var _generator = __webpack_require__(177);

var _markTransition = __webpack_require__(423);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function generateSketchyHash(props) {
  var _props$style = props.style,
      style = _props$style === undefined ? {} : _props$style;

  var sketchyHash = "";
  _markTransition.redrawSketchyList.forEach(function (d) {
    sketchyHash += "-" + (style[d] || props[d]);
  });
  return sketchyHash;
}

var Mark = function (_React$Component) {
  _inherits(Mark, _React$Component);

  function Mark(props) {
    _classCallCheck(this, Mark);

    var _this = _possibleConstructorReturn(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).call(this, props));

    _this._mouseup = _this._mouseup.bind(_this);
    _this._mousedown = _this._mousedown.bind(_this);
    _this._mousemove = _this._mousemove.bind(_this);

    _this.state = {
      translate: [0, 0],
      mouseOrigin: [],
      translateOrigin: [0, 0],
      dragging: false,
      uiUpdate: false,
      sketchyFill: undefined,
      sketchyHash: ""
    };
    return _this;
  }

  _createClass(Mark, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.updateSketchy(nextProps);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updateSketchy(this.props);
    }
  }, {
    key: "updateSketchy",
    value: function updateSketchy(nextProps) {
      var renderOptions = nextProps.renderMode !== null && _typeof(nextProps.renderMode) === "object" ? nextProps.renderMode : { renderMode: nextProps.renderMode };

      var sketchyHash = renderOptions.renderMode === "sketchy" && generateSketchyHash(nextProps);
      if (sketchyHash && sketchyHash !== this.state.sketchyHash) {
        var _nextProps$style = nextProps.style,
            style = _nextProps$style === undefined ? {} : _nextProps$style;
        var _renderOptions$simpli = renderOptions.simplification,
            simplification = _renderOptions$simpli === undefined ? 0 : _renderOptions$simpli,
            _renderOptions$curveS = renderOptions.curveStepCount,
            curveStepCount = _renderOptions$curveS === undefined ? 9 : _renderOptions$curveS,
            _renderOptions$fillSt = renderOptions.fillStyle,
            fillStyle = _renderOptions$fillSt === undefined ? "hachure" : _renderOptions$fillSt,
            _renderOptions$roughn = renderOptions.roughness,
            roughness = _renderOptions$roughn === undefined ? 1 : _renderOptions$roughn,
            _renderOptions$bowing = renderOptions.bowing,
            bowing = _renderOptions$bowing === undefined ? 1 : _renderOptions$bowing,
            _renderOptions$fillWe = renderOptions.fillWeight,
            fillWeight = _renderOptions$fillWe === undefined ? 1 : _renderOptions$fillWe,
            _renderOptions$hachur = renderOptions.hachureAngle,
            hachureAngle = _renderOptions$hachur === undefined ? -41 : _renderOptions$hachur;


        var roughGenerator = new _generator.RoughGenerator({}, { width: 1000, height: 1000 });
        var drawingInstructions = void 0;
        var roughOptions = {
          fill: style.fill || nextProps.fill,
          stroke: style.stroke || nextProps.stroke,
          strokeWidth: style.strokeWidth || nextProps.strokeWidth,
          fillStyle: fillStyle,
          roughness: roughness,
          bowing: bowing,
          fillWeight: fillWeight,
          hachureAngle: hachureAngle,
          hachureGap: renderOptions.hachureGap || style.fillOpacity && (5 - style.fillOpacity * 5) * fillWeight || fillWeight * 2,
          curveStepCount: curveStepCount,
          simplification: simplification
        };

        switch (nextProps.markType) {
          case "line":
            drawingInstructions = roughGenerator.line(nextProps.x1 || 0, nextProps.y1 || 0, nextProps.x2 || 0, nextProps.y2 || 0, roughOptions);
            break;
          case "rect":
            if (nextProps.rx || nextProps.ry) {
              drawingInstructions = roughGenerator.circle((nextProps.x || 0) + nextProps.width / 2, (nextProps.y || 0) + nextProps.width / 2, nextProps.width, roughOptions);
            } else {
              drawingInstructions = roughGenerator.rectangle(nextProps.x || 0, nextProps.y || 0, nextProps.width, nextProps.height, roughOptions);
            }
            break;
          case "circle":
            drawingInstructions = roughGenerator.circle(nextProps.cx || 0, nextProps.cy || 0, nextProps.r * 2, roughOptions);
            break;
          case "ellipse":
            drawingInstructions = roughGenerator.ellipse(nextProps.x || 0, nextProps.y || 0, nextProps.width, nextProps.height, roughOptions);
            break;
          case "polygon":
            drawingInstructions = roughGenerator.polygon(nextProps.points, roughOptions);
            break;
          case "path":
            drawingInstructions = roughGenerator.path(nextProps.d, roughOptions);
            break;
        }

        var roughPieces = [];
        roughGenerator.toPaths(drawingInstructions).forEach(function (_ref, i) {
          var d = _ref.d,
              fill = _ref.fill,
              stroke = _ref.stroke,
              strokeWidth = _ref.strokeWidth,
              pattern = _ref.pattern;

          if (pattern) {
            var roughRandomID = "rough-" + Math.random();
            roughPieces.push(_react2.default.createElement(
              "pattern",
              {
                key: "pattern-" + i,
                id: roughRandomID,
                x: pattern.x,
                y: pattern.y,
                height: pattern.height,
                width: pattern.width,
                viewBox: pattern.viewBox
              },
              _react2.default.createElement("path", {
                key: "pattern-path-" + i,
                d: pattern.path.d,
                style: {
                  fill: pattern.path.fill,
                  stroke: pattern.path.stroke,
                  strokeWidth: pattern.path.strokeWidth
                }
              })
            ));
            fill = "url(#" + roughRandomID + ")";
          }
          roughPieces.push(_react2.default.createElement("path", {
            key: "path-" + i,
            d: d,
            style: {
              fill: fill,
              stroke: stroke,
              strokeWidth: strokeWidth
            },
            transform: nextProps.transform
          }));
        });

        this.setState({
          sketchyHash: sketchyHash,
          sketchyFill: roughPieces
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      //data-driven transition time?
      if (nextProps.renderMode || this.props.renderMode || this.props.markType !== nextProps.markType || this.state.dragging || this.props.forceUpdate || nextProps.forceUpdate || this.props.className !== nextProps.className || this.props.children !== nextProps.children) {
        return true;
      }

      var canvas = this.props.canvas !== true && this.props.canvas || this.context && this.context.canvas;

      var node = this.node;

      var actualSVG = (0, _drawing.generateSVG)(nextProps, nextProps.className);
      var cloneProps = actualSVG.props;

      if (!cloneProps) {
        return true;
      }

      var _nextProps$transition = nextProps.transitionDuration,
          transitionDuration = _nextProps$transition === undefined ? {} : _nextProps$transition;

      var isDefault = typeof transitionDuration === "number";
      var defaultDuration = isDefault ? transitionDuration : 1000;
      transitionDuration = isDefault ? { default: defaultDuration } : _extends({ default: defaultDuration }, transitionDuration);

      var newProps = Object.keys(cloneProps).filter(function (d) {
        return d !== "style";
      });
      var oldProps = Object.keys(this.props).filter(function (d) {
        return d !== "style" && !newProps.find(function (p) {
          return p === d;
        });
      });

      var hasTransition = (0, _d3Selection.select)(node).select("*").transition;

      function adjustedPropName(propname) {
        return _markTransition.reactCSSNameStyleHash[propname] || propname;
      }

      oldProps.forEach(function (oldProp) {
        if (oldProp !== "style") {
          (0, _d3Selection.select)(node).select("*").attr(adjustedPropName(oldProp), undefined);
        }
      });

      newProps.forEach(function (newProp) {
        if (!hasTransition || !_markTransition.attributeTransitionWhitelist.find(function (d) {
          return d === newProp;
        }) || newProp === "d" && (0, _markTransition.differentD)(cloneProps.d, _this2.props.d)) {
          (0, _d3Selection.select)(node).select("*").attr(adjustedPropName(newProp), cloneProps[newProp]);
        } else {
          var _transitionDuration = transitionDuration,
              defaultDur = _transitionDuration.default,
              _transitionDuration$n = _transitionDuration[newProp],
              appliedDuration = _transitionDuration$n === undefined ? defaultDur : _transitionDuration$n;


          (0, _d3Selection.select)(node).select("*").transition(adjustedPropName(newProp)).duration(appliedDuration).attr(adjustedPropName(newProp), cloneProps[newProp]);
        }
      });

      var newStyleProps = Object.keys(cloneProps.style || {});
      var oldStyleProps = Object.keys(this.props.style || {}).filter(function (d) {
        return !newStyleProps.find(function (p) {
          return p === d;
        });
      });

      oldStyleProps.forEach(function (oldProp) {
        (0, _d3Selection.select)(node).select("*").style(adjustedPropName(oldProp), undefined);
      });

      newStyleProps.forEach(function (newProp) {
        if (!hasTransition) {
          (0, _d3Selection.select)(node).select("*").style(adjustedPropName(newProp), cloneProps.style[newProp]);
        } else {
          var _transitionDuration2 = transitionDuration,
              defaultDur = _transitionDuration2.default,
              _transitionDuration2$ = _transitionDuration2[newProp],
              appliedDuration = _transitionDuration2$ === undefined ? defaultDur : _transitionDuration2$;


          (0, _d3Selection.select)(node).select("*").transition(adjustedPropName(newProp)).duration(appliedDuration).style(adjustedPropName(newProp), cloneProps.style[newProp]);
        }
      });

      return false;
    }
  }, {
    key: "_mouseup",
    value: function _mouseup() {
      document.onmousemove = null;

      var finalTranslate = [0, 0];
      if (!this.props.resetAfter) finalTranslate = this.state.translate;

      this.setState({
        dragging: false,
        translate: finalTranslate,
        uiUpdate: false
      });
      if (this.props.dropFunction && this.props.context && this.props.context.dragSource) {
        this.props.dropFunction(this.props.context.dragSource.props, this.props);
        this.props.updateContext("dragSource", undefined);
      }
    }
  }, {
    key: "_mousedown",
    value: function _mousedown(event) {
      this.setState({
        mouseOrigin: [event.pageX, event.pageY],
        translateOrigin: this.state.translate,
        dragging: true
      });
      document.onmouseup = this._mouseup;
      document.onmousemove = this._mousemove;
    }
  }, {
    key: "_mousemove",
    value: function _mousemove(event) {
      var xAdjust = this.props.freezeX ? 0 : 1;
      var yAdjust = this.props.freezeY ? 0 : 1;

      var adjustedPosition = [event.pageX - this.state.mouseOrigin[0], event.pageY - this.state.mouseOrigin[1]];
      var adjustedTranslate = [(adjustedPosition[0] + this.state.translateOrigin[0]) * xAdjust, (adjustedPosition[1] + this.state.translateOrigin[1]) * yAdjust];
      if (this.props.dropFunction && this.state.uiUpdate === false) {
        this.props.updateContext("dragSource", this);
        this.setState({
          translate: adjustedTranslate,
          uiUpdate: true,
          dragging: true
        });
      } else {
        this.setState({ translate: adjustedTranslate });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var className = this.props.className || "";

      var mouseIn = null;
      var mouseOut = null;

      var actualSVG = (this.props.renderMode === "sketchy" || this.props.renderMode && this.props.renderMode.renderMode === "sketchy") && this.state.sketchyFill || (0, _drawing.generateSVG)(this.props, className);

      if (this.props.draggable) {
        return _react2.default.createElement(
          "g",
          {
            ref: function ref(node) {
              return _this3.node = node;
            },
            className: className,
            onMouseEnter: mouseIn,
            onMouseOut: mouseOut,
            onDoubleClick: this._doubleclick,
            style: {
              pointerEvents: this.props.dropFunction && this.state.dragging ? "none" : "all"
            },
            onMouseDown: this._mousedown,
            onMouseUp: this._mouseup,
            transform: "translate(" + this.state.translate + ")"
          },
          actualSVG
        );
      } else {
        return _react2.default.createElement(
          "g",
          {
            ref: function ref(node) {
              return _this3.node = node;
            },
            className: className,
            onMouseEnter: mouseIn,
            onMouseOut: mouseOut
          },
          actualSVG
        );
      }
    }
  }]);

  return Mark;
}(_react2.default.Component);

Mark.propTypes = {
  markType: _propTypes2.default.string.isRequired,
  forceUpdate: _propTypes2.default.bool,
  renderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  draggable: _propTypes2.default.bool,
  dropFunction: _propTypes2.default.func,
  resetAfter: _propTypes2.default.bool,
  freezeX: _propTypes2.default.bool,
  freezeY: _propTypes2.default.bool,
  context: _propTypes2.default.object,
  updateContext: _propTypes2.default.func,
  className: _propTypes2.default.string
};

Mark.contextTypes = {
  canvas: _propTypes2.default.object
};

exports.default = Mark;
module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(78);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transition_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_2__src_active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(30);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(50);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateString */])(a, b);
});


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(19);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(381);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(168);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(386);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(170);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(385);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(87);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(172);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(89);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(175);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(176);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(409);
/* unused harmony reexport isoParse */






/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(88);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(89);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoughGeneratorAsync = exports.RoughGenerator = undefined;

var _regenerator = __webpack_require__(178);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _renderer = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

self._roughScript = self.document && self.document.currentScript && self.document.currentScript.src;

var RoughGenerator = exports.RoughGenerator = function () {
  function RoughGenerator(config, canvas) {
    _classCallCheck(this, RoughGenerator);

    this.config = config || {};
    this.canvas = canvas;
    this.defaultOptions = {
      maxRandomnessOffset: 2,
      roughness: 1,
      bowing: 1,
      stroke: '#000',
      strokeWidth: 1,
      curveTightness: 0,
      curveStepCount: 9,
      fill: null,
      fillStyle: 'hachure',
      fillWeight: -1,
      hachureAngle: -41,
      hachureGap: -1
    };
    if (this.config.options) {
      this.defaultOptions = this._options(this.config.options);
    }
  }

  _createClass(RoughGenerator, [{
    key: '_options',
    value: function _options(options) {
      return options ? Object.assign({}, this.defaultOptions, options) : this.defaultOptions;
    }
  }, {
    key: '_drawable',
    value: function _drawable(shape, sets, options) {
      return { shape: shape, sets: sets || [], options: options || this.defaultOptions };
    }
  }, {
    key: 'line',
    value: function line(x1, y1, x2, y2, options) {
      var o = this._options(options);
      return this._drawable('line', [this.lib.line(x1, y1, x2, y2, o)], o);
    }
  }, {
    key: 'rectangle',
    value: function rectangle(x, y, width, height, options) {
      var o = this._options(options);
      var paths = [];
      if (o.fill) {
        var xc = [x, x + width, x + width, x];
        var yc = [y, y, y + height, y + height];
        if (o.fillStyle === 'solid') {
          paths.push(this.lib.solidFillShape(xc, yc, o));
        } else {
          paths.push(this.lib.hachureFillShape(xc, yc, o));
        }
      }
      paths.push(this.lib.rectangle(x, y, width, height, o));
      return this._drawable('rectangle', paths, o);
    }
  }, {
    key: 'ellipse',
    value: function ellipse(x, y, width, height, options) {
      var o = this._options(options);
      var paths = [];
      if (o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = this.lib.ellipse(x, y, width, height, o);
          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(this.lib.hachureFillEllipse(x, y, width, height, o));
        }
      }
      paths.push(this.lib.ellipse(x, y, width, height, o));
      return this._drawable('ellipse', paths, o);
    }
  }, {
    key: 'circle',
    value: function circle(x, y, diameter, options) {
      var ret = this.ellipse(x, y, diameter, diameter, options);
      ret.shape = 'circle';
      return ret;
    }
  }, {
    key: 'linearPath',
    value: function linearPath(points, options) {
      var o = this._options(options);
      return this._drawable('linearPath', [this.lib.linearPath(points, false, o)], o);
    }
  }, {
    key: 'polygon',
    value: function polygon(points, options) {
      var o = this._options(options);
      var paths = [];
      if (o.fill) {
        var xc = [],
            yc = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            xc.push(p[0]);
            yc.push(p[1]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (o.fillStyle === 'solid') {
          paths.push(this.lib.solidFillShape(xc, yc, o));
        } else {
          paths.push(this.lib.hachureFillShape(xc, yc, o));
        }
      }
      paths.push(this.lib.linearPath(points, true, o));
      return this._drawable('polygon', paths, o);
    }
  }, {
    key: 'arc',
    value: function arc(x, y, width, height, start, stop, closed, options) {
      var o = this._options(options);
      var paths = [];
      if (closed && o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = this.lib.arc(x, y, width, height, start, stop, true, false, o);
          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(this.lib.hachureFillArc(x, y, width, height, start, stop, o));
        }
      }
      paths.push(this.lib.arc(x, y, width, height, start, stop, closed, true, o));
      return this._drawable('arc', paths, o);
    }
  }, {
    key: 'curve',
    value: function curve(points, options) {
      var o = this._options(options);
      return this._drawable('curve', [this.lib.curve(points, o)], o);
    }
  }, {
    key: 'path',
    value: function path(d, options) {
      var o = this._options(options);
      var paths = [];
      if (!d) {
        return this._drawable('path', paths, o);
      }
      if (o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = { type: 'path2Dfill', path: d };
          paths.push(shape);
        } else {
          var size = this._computePathSize(d);
          var xc = [0, size[0], size[0], 0];
          var yc = [0, 0, size[1], size[1]];
          var _shape = this.lib.hachureFillShape(xc, yc, o);
          _shape.type = 'path2Dpattern';
          _shape.size = size;
          _shape.path = d;
          paths.push(_shape);
        }
      }
      paths.push(this.lib.svgPath(d, o));
      return this._drawable('path', paths, o);
    }
  }, {
    key: 'toPaths',
    value: function toPaths(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.defaultOptions;
      var paths = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = sets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var drawing = _step2.value;

          var path = null;
          switch (drawing.type) {
            case 'path':
              path = {
                d: this.opsToPath(drawing),
                stroke: o.stroke,
                strokeWidth: o.strokeWidth,
                fill: 'none'
              };
              break;
            case 'fillPath':
              path = {
                d: this.opsToPath(drawing),
                stroke: 'none',
                strokeWidth: 0,
                fill: o.fill
              };
              break;
            case 'fillSketch':
              path = this._fillSketch(drawing, o);
              break;
            case 'path2Dfill':
              path = {
                d: drawing.path,
                stroke: 'none',
                strokeWidth: 0,
                fill: o.fill
              };
              break;
            case 'path2Dpattern':
              {
                var size = drawing.size;
                var pattern = {
                  x: 0, y: 0, width: 1, height: 1,
                  viewBox: '0 0 ' + Math.round(size[0]) + ' ' + Math.round(size[1]),
                  patternUnits: 'objectBoundingBox',
                  path: this._fillSketch(drawing, o)
                };
                path = {
                  d: drawing.path,
                  stroke: 'none',
                  strokeWidth: 0,
                  pattern: pattern
                };
                break;
              }
          }
          if (path) {
            paths.push(path);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return paths;
    }
  }, {
    key: '_fillSketch',
    value: function _fillSketch(drawing, o) {
      var fweight = o.fillWeight;
      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }
      return {
        d: this.opsToPath(drawing),
        stroke: o.fill,
        strokeWidth: fweight,
        fill: 'none'
      };
    }
  }, {
    key: 'opsToPath',
    value: function opsToPath(drawing) {
      var path = '';
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = drawing.ops[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          var data = item.data;
          switch (item.op) {
            case 'move':
              path += 'M' + data[0] + ' ' + data[1] + ' ';
              break;
            case 'bcurveTo':
              path += 'C' + data[0] + ' ' + data[1] + ', ' + data[2] + ' ' + data[3] + ', ' + data[4] + ' ' + data[5] + ' ';
              break;
            case 'qcurveTo':
              path += 'Q' + data[0] + ' ' + data[1] + ', ' + data[2] + ' ' + data[3] + ' ';
              break;
            case 'lineTo':
              path += 'L' + data[0] + ' ' + data[1] + ' ';
              break;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return path.trim();
    }
  }, {
    key: '_computePathSize',
    value: function _computePathSize(d) {
      var size = [0, 0];
      if (self.document) {
        try {
          var ns = "http://www.w3.org/2000/svg";
          var svg = self.document.createElementNS(ns, "svg");
          svg.setAttribute("width", "0");
          svg.setAttribute("height", "0");
          var pathNode = self.document.createElementNS(ns, "path");
          pathNode.setAttribute('d', d);
          svg.appendChild(pathNode);
          self.document.body.appendChild(svg);
          var bb = pathNode.getBBox();
          if (bb) {
            size[0] = bb.width || 0;
            size[1] = bb.height || 0;
          }
          self.document.body.removeChild(svg);
        } catch (err) {}
      }
      var canvasSize = this._canvasSize();
      if (!(size[0] * size[1])) {
        size = canvasSize;
      }
      size[0] = Math.min(size[0], canvasSize[0]);
      size[1] = Math.min(size[1], canvasSize[1]);
      return size;
    }
  }, {
    key: '_canvasSize',
    value: function _canvasSize() {
      var val = function val(w) {
        if (w) {
          if ((typeof w === 'undefined' ? 'undefined' : _typeof(w)) === 'object') {
            if (w.baseVal && w.baseVal.value) {
              return w.baseVal.value;
            }
          }
        }
        return w || 100;
      };
      return this.canvas ? [val(this.canvas.width), val(this.canvas.height)] : [100, 100];
    }
  }, {
    key: 'lib',
    get: function get() {
      if (!this._renderer) {
        if (self && self.workly && this.config.async && !this.config.noWorker) {
          var tos = Function.prototype.toString;
          var worklySource = this.config.worklyURL || 'https://cdn.jsdelivr.net/gh/pshihn/workly/dist/workly.min.js';
          var rendererSource = this.config.roughURL || self._roughScript;
          if (rendererSource && worklySource) {
            var code = 'importScripts(\'' + worklySource + '\', \'' + rendererSource + '\');\nworkly.expose(self.rough.createRenderer());';
            var ourl = URL.createObjectURL(new Blob([code]));
            this._renderer = workly.proxy(ourl);
          } else {
            this._renderer = new _renderer.RoughRenderer();
          }
        } else {
          this._renderer = new _renderer.RoughRenderer();
        }
      }
      return this._renderer;
    }
  }]);

  return RoughGenerator;
}();

var RoughGeneratorAsync = exports.RoughGeneratorAsync = function (_RoughGenerator) {
  _inherits(RoughGeneratorAsync, _RoughGenerator);

  function RoughGeneratorAsync() {
    _classCallCheck(this, RoughGeneratorAsync);

    return _possibleConstructorReturn(this, (RoughGeneratorAsync.__proto__ || Object.getPrototypeOf(RoughGeneratorAsync)).apply(this, arguments));
  }

  _createClass(RoughGeneratorAsync, [{
    key: 'line',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(x1, y1, x2, y2, options) {
        var o;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                o = this._options(options);
                _context.t0 = this;
                _context.next = 4;
                return this.lib.line(x1, y1, x2, y2, o);

              case 4:
                _context.t1 = _context.sent;
                _context.t2 = [_context.t1];
                _context.t3 = o;
                return _context.abrupt('return', _context.t0._drawable.call(_context.t0, 'line', _context.t2, _context.t3));

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function line(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return line;
    }()
  }, {
    key: 'rectangle',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(x, y, width, height, options) {
        var o, paths, xc, yc;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                o = this._options(options);
                paths = [];

                if (!o.fill) {
                  _context2.next = 18;
                  break;
                }

                xc = [x, x + width, x + width, x];
                yc = [y, y, y + height, y + height];

                if (!(o.fillStyle === 'solid')) {
                  _context2.next = 13;
                  break;
                }

                _context2.t0 = paths;
                _context2.next = 9;
                return this.lib.solidFillShape(xc, yc, o);

              case 9:
                _context2.t1 = _context2.sent;

                _context2.t0.push.call(_context2.t0, _context2.t1);

                _context2.next = 18;
                break;

              case 13:
                _context2.t2 = paths;
                _context2.next = 16;
                return this.lib.hachureFillShape(xc, yc, o);

              case 16:
                _context2.t3 = _context2.sent;

                _context2.t2.push.call(_context2.t2, _context2.t3);

              case 18:
                _context2.t4 = paths;
                _context2.next = 21;
                return this.lib.rectangle(x, y, width, height, o);

              case 21:
                _context2.t5 = _context2.sent;

                _context2.t4.push.call(_context2.t4, _context2.t5);

                return _context2.abrupt('return', this._drawable('rectangle', paths, o));

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function rectangle(_x6, _x7, _x8, _x9, _x10) {
        return _ref2.apply(this, arguments);
      }

      return rectangle;
    }()
  }, {
    key: 'ellipse',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(x, y, width, height, options) {
        var o, paths, shape;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                o = this._options(options);
                paths = [];

                if (!o.fill) {
                  _context3.next = 16;
                  break;
                }

                if (!(o.fillStyle === 'solid')) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 6;
                return this.lib.ellipse(x, y, width, height, o);

              case 6:
                shape = _context3.sent;

                shape.type = 'fillPath';
                paths.push(shape);
                _context3.next = 16;
                break;

              case 11:
                _context3.t0 = paths;
                _context3.next = 14;
                return this.lib.hachureFillEllipse(x, y, width, height, o);

              case 14:
                _context3.t1 = _context3.sent;

                _context3.t0.push.call(_context3.t0, _context3.t1);

              case 16:
                _context3.t2 = paths;
                _context3.next = 19;
                return this.lib.ellipse(x, y, width, height, o);

              case 19:
                _context3.t3 = _context3.sent;

                _context3.t2.push.call(_context3.t2, _context3.t3);

                return _context3.abrupt('return', this._drawable('ellipse', paths, o));

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ellipse(_x11, _x12, _x13, _x14, _x15) {
        return _ref3.apply(this, arguments);
      }

      return ellipse;
    }()
  }, {
    key: 'circle',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4(x, y, diameter, options) {
        var ret;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.ellipse(x, y, diameter, diameter, options);

              case 2:
                ret = _context4.sent;

                ret.shape = 'circle';
                return _context4.abrupt('return', ret);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function circle(_x16, _x17, _x18, _x19) {
        return _ref4.apply(this, arguments);
      }

      return circle;
    }()
  }, {
    key: 'linearPath',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee5(points, options) {
        var o;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                o = this._options(options);
                _context5.t0 = this;
                _context5.next = 4;
                return this.lib.linearPath(points, false, o);

              case 4:
                _context5.t1 = _context5.sent;
                _context5.t2 = [_context5.t1];
                _context5.t3 = o;
                return _context5.abrupt('return', _context5.t0._drawable.call(_context5.t0, 'linearPath', _context5.t2, _context5.t3));

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function linearPath(_x20, _x21) {
        return _ref5.apply(this, arguments);
      }

      return linearPath;
    }()
  }, {
    key: 'polygon',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee6(points, options) {
        var o, paths, xc, yc, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, p;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                o = this._options(options);
                paths = [];

                if (!o.fill) {
                  _context6.next = 36;
                  break;
                }

                xc = [], yc = [];
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context6.prev = 7;

                for (_iterator4 = points[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  p = _step4.value;

                  xc.push(p[0]);
                  yc.push(p[1]);
                }
                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](7);
                _didIteratorError4 = true;
                _iteratorError4 = _context6.t0;

              case 15:
                _context6.prev = 15;
                _context6.prev = 16;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 18:
                _context6.prev = 18;

                if (!_didIteratorError4) {
                  _context6.next = 21;
                  break;
                }

                throw _iteratorError4;

              case 21:
                return _context6.finish(18);

              case 22:
                return _context6.finish(15);

              case 23:
                if (!(o.fillStyle === 'solid')) {
                  _context6.next = 31;
                  break;
                }

                _context6.t1 = paths;
                _context6.next = 27;
                return this.lib.solidFillShape(xc, yc, o);

              case 27:
                _context6.t2 = _context6.sent;

                _context6.t1.push.call(_context6.t1, _context6.t2);

                _context6.next = 36;
                break;

              case 31:
                _context6.t3 = paths;
                _context6.next = 34;
                return this.lib.hachureFillShape(xc, yc, o);

              case 34:
                _context6.t4 = _context6.sent;

                _context6.t3.push.call(_context6.t3, _context6.t4);

              case 36:
                _context6.t5 = paths;
                _context6.next = 39;
                return this.lib.linearPath(points, true, o);

              case 39:
                _context6.t6 = _context6.sent;

                _context6.t5.push.call(_context6.t5, _context6.t6);

                return _context6.abrupt('return', this._drawable('polygon', paths, o));

              case 42:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      function polygon(_x22, _x23) {
        return _ref6.apply(this, arguments);
      }

      return polygon;
    }()
  }, {
    key: 'arc',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee7(x, y, width, height, start, stop, closed, options) {
        var o, paths, shape;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                o = this._options(options);
                paths = [];

                if (!(closed && o.fill)) {
                  _context7.next = 16;
                  break;
                }

                if (!(o.fillStyle === 'solid')) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 6;
                return this.lib.arc(x, y, width, height, start, stop, true, false, o);

              case 6:
                shape = _context7.sent;

                shape.type = 'fillPath';
                paths.push(shape);
                _context7.next = 16;
                break;

              case 11:
                _context7.t0 = paths;
                _context7.next = 14;
                return this.lib.hachureFillArc(x, y, width, height, start, stop, o);

              case 14:
                _context7.t1 = _context7.sent;

                _context7.t0.push.call(_context7.t0, _context7.t1);

              case 16:
                _context7.t2 = paths;
                _context7.next = 19;
                return this.lib.arc(x, y, width, height, start, stop, closed, true, o);

              case 19:
                _context7.t3 = _context7.sent;

                _context7.t2.push.call(_context7.t2, _context7.t3);

                return _context7.abrupt('return', this._drawable('arc', paths, o));

              case 22:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function arc(_x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31) {
        return _ref7.apply(this, arguments);
      }

      return arc;
    }()
  }, {
    key: 'curve',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee8(points, options) {
        var o;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                o = this._options(options);
                _context8.t0 = this;
                _context8.next = 4;
                return this.lib.curve(points, o);

              case 4:
                _context8.t1 = _context8.sent;
                _context8.t2 = [_context8.t1];
                _context8.t3 = o;
                return _context8.abrupt('return', _context8.t0._drawable.call(_context8.t0, 'curve', _context8.t2, _context8.t3));

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function curve(_x32, _x33) {
        return _ref8.apply(this, arguments);
      }

      return curve;
    }()
  }, {
    key: 'path',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee9(d, options) {
        var o, paths, shape, size, xc, yc, _shape2;

        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                o = this._options(options);
                paths = [];

                if (d) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt('return', this._drawable('path', paths, o));

              case 4:
                if (!o.fill) {
                  _context9.next = 20;
                  break;
                }

                if (!(o.fillStyle === 'solid')) {
                  _context9.next = 10;
                  break;
                }

                shape = { type: 'path2Dfill', path: d };

                paths.push(shape);
                _context9.next = 20;
                break;

              case 10:
                size = this._computePathSize(d);
                xc = [0, size[0], size[0], 0];
                yc = [0, 0, size[1], size[1]];
                _context9.next = 15;
                return this.lib.hachureFillShape(xc, yc, o);

              case 15:
                _shape2 = _context9.sent;

                _shape2.type = 'path2Dpattern';
                _shape2.size = size;
                _shape2.path = d;
                paths.push(_shape2);

              case 20:
                _context9.t0 = paths;
                _context9.next = 23;
                return this.lib.svgPath(d, o);

              case 23:
                _context9.t1 = _context9.sent;

                _context9.t0.push.call(_context9.t0, _context9.t1);

                return _context9.abrupt('return', this._drawable('path', paths, o));

              case 26:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function path(_x34, _x35) {
        return _ref9.apply(this, arguments);
      }

      return path;
    }()
  }]);

  return RoughGeneratorAsync;
}(RoughGenerator);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(419);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoughRenderer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hachure = __webpack_require__(421);

var _segment = __webpack_require__(180);

var _path = __webpack_require__(422);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoughRenderer = exports.RoughRenderer = function () {
  function RoughRenderer() {
    _classCallCheck(this, RoughRenderer);
  }

  _createClass(RoughRenderer, [{
    key: "line",
    value: function line(x1, y1, x2, y2, o) {
      var ops = this._doubleLine(x1, y1, x2, y2, o);
      return { type: "path", ops: ops };
    }
  }, {
    key: "linearPath",
    value: function linearPath(points, close, o) {
      var len = (points || []).length;
      if (len > 2) {
        var ops = [];
        for (var i = 0; i < len - 1; i++) {
          ops = ops.concat(this._doubleLine(points[i][0], points[i][1], points[i + 1][0], points[i + 1][1], o));
        }
        if (close) {
          ops = ops.concat(this._doubleLine(points[len - 1][0], points[len - 1][1], points[0][0], points[0][1], o));
        }
        return { type: "path", ops: ops };
      } else if (len === 2) {
        return this.line(points[0][0], points[0][1], points[1][0], points[1][1], o);
      }
    }
  }, {
    key: "polygon",
    value: function polygon(points, o) {
      return this.linearPath(points, true, o);
    }
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height, o) {
      var points = [[x, y], [x + width, y], [x + width, y + height], [x, y + height]];
      return this.polygon(points, o);
    }
  }, {
    key: "curve",
    value: function curve(points, o) {
      var o1 = this._curveWithOffset(points, 1 * (1 + o.roughness * 0.2), o);
      var o2 = this._curveWithOffset(points, 1.5 * (1 + o.roughness * 0.22), o);
      return { type: "path", ops: o1.concat(o2) };
    }
  }, {
    key: "ellipse",
    value: function ellipse(x, y, width, height, o) {
      var increment = Math.PI * 2 / o.curveStepCount;
      var rx = Math.abs(width / 2);
      var ry = Math.abs(height / 2);
      rx += this._getOffset(-rx * 0.05, rx * 0.05, o);
      ry += this._getOffset(-ry * 0.05, ry * 0.05, o);
      var o1 = this._ellipse(increment, x, y, rx, ry, 1, increment * this._getOffset(0.1, this._getOffset(0.4, 1, o), o), o);
      var o2 = this._ellipse(increment, x, y, rx, ry, 1.5, 0, o);
      return { type: "path", ops: o1.concat(o2) };
    }
  }, {
    key: "arc",
    value: function arc(x, y, width, height, start, stop, closed, roughClosure, o) {
      var cx = x;
      var cy = y;
      var rx = Math.abs(width / 2);
      var ry = Math.abs(height / 2);
      rx += this._getOffset(-rx * 0.01, rx * 0.01, o);
      ry += this._getOffset(-ry * 0.01, ry * 0.01, o);
      var strt = start;
      var stp = stop;
      while (strt < 0) {
        strt += Math.PI * 2;
        stp += Math.PI * 2;
      }
      if (stp - strt > Math.PI * 2) {
        strt = 0;
        stp = Math.PI * 2;
      }
      var ellipseInc = Math.PI * 2 / o.curveStepCount;
      var arcInc = Math.min(ellipseInc / 2, (stp - strt) / 2);
      var o1 = this._arc(arcInc, cx, cy, rx, ry, strt, stp, 1, o);
      var o2 = this._arc(arcInc, cx, cy, rx, ry, strt, stp, 1.5, o);
      var ops = o1.concat(o2);
      if (closed) {
        if (roughClosure) {
          ops = ops.concat(this._doubleLine(cx, cy, cx + rx * Math.cos(strt), cy + ry * Math.sin(strt), o));
          ops = ops.concat(this._doubleLine(cx, cy, cx + rx * Math.cos(stp), cy + ry * Math.sin(stp), o));
        } else {
          ops.push({ op: "lineTo", data: [cx, cy] });
          ops.push({
            op: "lineTo",
            data: [cx + rx * Math.cos(strt), cy + ry * Math.sin(strt)]
          });
        }
      }
      return { type: "path", ops: ops };
    }
  }, {
    key: "hachureFillArc",
    value: function hachureFillArc(x, y, width, height, start, stop, o) {
      var cx = x;
      var cy = y;
      var rx = Math.abs(width / 2);
      var ry = Math.abs(height / 2);
      rx += this._getOffset(-rx * 0.01, rx * 0.01, o);
      ry += this._getOffset(-ry * 0.01, ry * 0.01, o);
      var strt = start;
      var stp = stop;
      while (strt < 0) {
        strt += Math.PI * 2;
        stp += Math.PI * 2;
      }
      if (stp - strt > Math.PI * 2) {
        strt = 0;
        stp = Math.PI * 2;
      }
      var increment = (stp - strt) / o.curveStepCount;
      var offset = 1;
      var xc = [],
          yc = [];
      for (var angle = strt; angle <= stp; angle = angle + increment) {
        xc.push(cx + rx * Math.cos(angle));
        yc.push(cy + ry * Math.sin(angle));
      }
      xc.push(cx + rx * Math.cos(stp));
      yc.push(cy + ry * Math.sin(stp));
      xc.push(cx);
      yc.push(cy);
      return this.hachureFillShape(xc, yc, o);
    }
  }, {
    key: "solidFillShape",
    value: function solidFillShape(xCoords, yCoords, o) {
      var ops = [];
      if (xCoords && yCoords && xCoords.length && yCoords.length && xCoords.length === yCoords.length) {
        var offset = o.maxRandomnessOffset || 0;
        var len = xCoords.length;
        if (len > 2) {
          ops.push({
            op: "move",
            data: [xCoords[0] + this._getOffset(-offset, offset, o), yCoords[0] + this._getOffset(-offset, offset, o)]
          });
          for (var i = 1; i < len; i++) {
            ops.push({
              op: "lineTo",
              data: [xCoords[i] + this._getOffset(-offset, offset, o), yCoords[i] + this._getOffset(-offset, offset, o)]
            });
          }
        }
      }
      return { type: "fillPath", ops: ops };
    }
  }, {
    key: "hachureFillShape",
    value: function hachureFillShape(xCoords, yCoords, o) {
      var ops = [];
      if (xCoords && yCoords && xCoords.length && yCoords.length) {
        var left = xCoords[0];
        var right = xCoords[0];
        var top = yCoords[0];
        var bottom = yCoords[0];
        for (var i = 1; i < xCoords.length; i++) {
          left = Math.min(left, xCoords[i]);
          right = Math.max(right, xCoords[i]);
          top = Math.min(top, yCoords[i]);
          bottom = Math.max(bottom, yCoords[i]);
        }
        var angle = o.hachureAngle;
        var gap = o.hachureGap;
        if (gap < 0) {
          gap = o.strokeWidth * 4;
        }
        gap = Math.max(gap, 0.1);

        var radPerDeg = Math.PI / 180;
        var hachureAngle = angle % 180 * radPerDeg;
        var cosAngle = Math.cos(hachureAngle);
        var sinAngle = Math.sin(hachureAngle);
        var tanAngle = Math.tan(hachureAngle);

        var it = new _hachure.RoughHachureIterator(top - 1, bottom + 1, left - 1, right + 1, gap, sinAngle, cosAngle, tanAngle);
        var rectCoords = void 0;
        while ((rectCoords = it.getNextLine()) != null) {
          var lines = this._getIntersectingLines(rectCoords, xCoords, yCoords);
          for (var _i = 0; _i < lines.length; _i++) {
            if (_i < lines.length - 1) {
              var p1 = lines[_i];
              var p2 = lines[_i + 1];
              ops = ops.concat(this._doubleLine(p1[0], p1[1], p2[0], p2[1], o));
            }
          }
        }
      }
      return { type: "fillSketch", ops: ops };
    }
  }, {
    key: "hachureFillEllipse",
    value: function hachureFillEllipse(cx, cy, width, height, o) {
      var ops = [];
      var rx = Math.abs(width / 2);
      var ry = Math.abs(height / 2);
      rx += this._getOffset(-rx * 0.05, rx * 0.05, o);
      ry += this._getOffset(-ry * 0.05, ry * 0.05, o);
      var angle = o.hachureAngle;
      var gap = o.hachureGap;
      if (gap <= 0) {
        gap = o.strokeWidth * 4;
      }
      var fweight = o.fillWeight;
      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }
      var radPerDeg = Math.PI / 180;
      var hachureAngle = angle % 180 * radPerDeg;
      var tanAngle = Math.tan(hachureAngle);
      var aspectRatio = ry / rx;
      var hyp = Math.sqrt(aspectRatio * tanAngle * aspectRatio * tanAngle + 1);
      var sinAnglePrime = aspectRatio * tanAngle / hyp;
      var cosAnglePrime = 1 / hyp;
      var gapPrime = gap / (rx * ry / Math.sqrt(ry * cosAnglePrime * (ry * cosAnglePrime) + rx * sinAnglePrime * (rx * sinAnglePrime)) / rx);
      var halfLen = Math.sqrt(rx * rx - (cx - rx + gapPrime) * (cx - rx + gapPrime));
      for (var xPos = cx - rx + gapPrime; xPos < cx + rx; xPos += gapPrime) {
        halfLen = Math.sqrt(rx * rx - (cx - xPos) * (cx - xPos));
        var p1 = this._affine(xPos, cy - halfLen, cx, cy, sinAnglePrime, cosAnglePrime, aspectRatio);
        var p2 = this._affine(xPos, cy + halfLen, cx, cy, sinAnglePrime, cosAnglePrime, aspectRatio);
        ops = ops.concat(this._doubleLine(p1[0], p1[1], p2[0], p2[1], o));
      }
      return { type: "fillSketch", ops: ops };
    }
  }, {
    key: "svgPath",
    value: function svgPath(path, o) {
      path = (path || "").replace(/\n/g, " ").replace(/(-\s)/g, "-").replace("/(ss)/g", " ");
      var p = new _path.RoughPath(path);
      if (o.simplification) {
        var fitter = new _path.PathFitter(p.linearPoints, p.closed);
        var d = fitter.fit(o.simplification);
        p = new _path.RoughPath(d);
      }
      var ops = [];
      var segments = p.segments || [];
      for (var i = 0; i < segments.length; i++) {
        var s = segments[i];
        var prev = i > 0 ? segments[i - 1] : null;
        var opList = this._processSegment(p, s, prev, o);
        if (opList && opList.length) {
          ops = ops.concat(opList);
        }
      }
      return { type: "path", ops: ops };
    }

    // privates

  }, {
    key: "_bezierTo",
    value: function _bezierTo(x1, y1, x2, y2, x, y, path, o) {
      var ops = [];
      var ros = [o.maxRandomnessOffset || 1, (o.maxRandomnessOffset || 1) + 0.5];
      var f = null;
      for (var i = 0; i < 2; i++) {
        if (i === 0) {
          ops.push({ op: "move", data: [path.x, path.y] });
        } else {
          ops.push({
            op: "move",
            data: [path.x + this._getOffset(-ros[0], ros[0], o), path.y + this._getOffset(-ros[0], ros[0], o)]
          });
        }
        f = [x + this._getOffset(-ros[i], ros[i], o), y + this._getOffset(-ros[i], ros[i], o)];
        ops.push({
          op: "bcurveTo",
          data: [x1 + this._getOffset(-ros[i], ros[i], o), y1 + this._getOffset(-ros[i], ros[i], o), x2 + this._getOffset(-ros[i], ros[i], o), y2 + this._getOffset(-ros[i], ros[i], o), f[0], f[1]]
        });
      }
      path.setPosition(f[0], f[1]);
      return ops;
    }
  }, {
    key: "_processSegment",
    value: function _processSegment(path, seg, prevSeg, o) {
      var ops = [];
      switch (seg.key) {
        case "M":
        case "m":
          {
            var delta = seg.key === "m";
            if (seg.data.length >= 2) {
              var x = +seg.data[0];
              var y = +seg.data[1];
              if (delta) {
                x += path.x;
                y += path.y;
              }
              var ro = 1 * (o.maxRandomnessOffset || 0);
              x = x + this._getOffset(-ro, ro, o);
              y = y + this._getOffset(-ro, ro, o);
              path.setPosition(x, y);
              ops.push({ op: "move", data: [x, y] });
            }
            break;
          }
        case "L":
        case "l":
          {
            var _delta = seg.key === "l";
            if (seg.data.length >= 2) {
              var _x = +seg.data[0];
              var _y = +seg.data[1];
              if (_delta) {
                _x += path.x;
                _y += path.y;
              }
              ops = ops.concat(this._doubleLine(path.x, path.y, _x, _y, o));
              path.setPosition(_x, _y);
            }
            break;
          }
        case "H":
        case "h":
          {
            var _delta2 = seg.key === "h";
            if (seg.data.length) {
              var _x2 = +seg.data[0];
              if (_delta2) {
                _x2 += path.x;
              }
              ops = ops.concat(this._doubleLine(path.x, path.y, _x2, path.y, o));
              path.setPosition(_x2, path.y);
            }
            break;
          }
        case "V":
        case "v":
          {
            var _delta3 = seg.key === "v";
            if (seg.data.length) {
              var _y2 = +seg.data[0];
              if (_delta3) {
                _y2 += path.y;
              }
              ops = ops.concat(this._doubleLine(path.x, path.y, path.x, _y2, o));
              path.setPosition(path.x, _y2);
            }
            break;
          }
        case "Z":
        case "z":
          {
            if (path.first) {
              ops = ops.concat(this._doubleLine(path.x, path.y, path.first[0], path.first[1], o));
              path.setPosition(path.first[0], path.first[1]);
              path.first = null;
            }
            break;
          }
        case "C":
        case "c":
          {
            var _delta4 = seg.key === "c";
            if (seg.data.length >= 6) {
              var x1 = +seg.data[0];
              var y1 = +seg.data[1];
              var x2 = +seg.data[2];
              var y2 = +seg.data[3];
              var _x3 = +seg.data[4];
              var _y3 = +seg.data[5];
              if (_delta4) {
                x1 += path.x;
                x2 += path.x;
                _x3 += path.x;
                y1 += path.y;
                y2 += path.y;
                _y3 += path.y;
              }
              var ob = this._bezierTo(x1, y1, x2, y2, _x3, _y3, path, o);
              ops = ops.concat(ob);
              path.bezierReflectionPoint = [_x3 + (_x3 - x2), _y3 + (_y3 - y2)];
            }
            break;
          }
        case "S":
        case "s":
          {
            var _delta5 = seg.key === "s";
            if (seg.data.length >= 4) {
              var _x4 = +seg.data[0];
              var _y4 = +seg.data[1];
              var _x5 = +seg.data[2];
              var _y5 = +seg.data[3];
              if (_delta5) {
                _x4 += path.x;
                _x5 += path.x;
                _y4 += path.y;
                _y5 += path.y;
              }
              var _x6 = _x4;
              var _y6 = _y4;
              var prevKey = prevSeg ? prevSeg.key : "";
              var ref = null;
              if (prevKey == "c" || prevKey == "C" || prevKey == "s" || prevKey == "S") {
                ref = path.bezierReflectionPoint;
              }
              if (ref) {
                _x6 = ref[0];
                _y6 = ref[1];
              }
              var _ob = this._bezierTo(_x6, _y6, _x4, _y4, _x5, _y5, path, o);
              ops = ops.concat(_ob);
              path.bezierReflectionPoint = [_x5 + (_x5 - _x4), _y5 + (_y5 - _y4)];
            }
            break;
          }
        case "Q":
        case "q":
          {
            var _delta6 = seg.key === "q";
            if (seg.data.length >= 4) {
              var _x7 = +seg.data[0];
              var _y7 = +seg.data[1];
              var _x8 = +seg.data[2];
              var _y8 = +seg.data[3];
              if (_delta6) {
                _x7 += path.x;
                _x8 += path.x;
                _y7 += path.y;
                _y8 += path.y;
              }
              var offset1 = 1 * (1 + o.roughness * 0.2);
              var offset2 = 1.5 * (1 + o.roughness * 0.22);
              ops.push({
                op: "move",
                data: [path.x + this._getOffset(-offset1, offset1, o), path.y + this._getOffset(-offset1, offset1, o)]
              });
              var f = [_x8 + this._getOffset(-offset1, offset1, o), _y8 + this._getOffset(-offset1, offset1, o)];
              ops.push({
                op: "qcurveTo",
                data: [_x7 + this._getOffset(-offset1, offset1, o), _y7 + this._getOffset(-offset1, offset1, o), f[0], f[1]]
              });
              ops.push({
                op: "move",
                data: [path.x + this._getOffset(-offset2, offset2, o), path.y + this._getOffset(-offset2, offset2, o)]
              });
              f = [_x8 + this._getOffset(-offset2, offset2, o), _y8 + this._getOffset(-offset2, offset2, o)];
              ops.push({
                op: "qcurveTo",
                data: [_x7 + this._getOffset(-offset2, offset2, o), _y7 + this._getOffset(-offset2, offset2, o), f[0], f[1]]
              });
              path.setPosition(f[0], f[1]);
              path.quadReflectionPoint = [_x8 + (_x8 - _x7), _y8 + (_y8 - _y7)];
            }
            break;
          }
        case "T":
        case "t":
          {
            var _delta7 = seg.key === "t";
            if (seg.data.length >= 2) {
              var _x9 = +seg.data[0];
              var _y9 = +seg.data[1];
              if (_delta7) {
                _x9 += path.x;
                _y9 += path.y;
              }
              var _x10 = _x9;
              var _y10 = _y9;
              var _prevKey = prevSeg ? prevSeg.key : "";
              var ref = null;
              if (_prevKey == "q" || _prevKey == "Q" || _prevKey == "t" || _prevKey == "T") {
                ref = path.quadReflectionPoint;
              }
              if (ref) {
                _x10 = ref[0];
                _y10 = ref[1];
              }
              var _offset = 1 * (1 + o.roughness * 0.2);
              var _offset2 = 1.5 * (1 + o.roughness * 0.22);
              ops.push({
                op: "move",
                data: [path.x + this._getOffset(-_offset, _offset, o), path.y + this._getOffset(-_offset, _offset, o)]
              });
              var _f = [_x9 + this._getOffset(-_offset, _offset, o), _y9 + this._getOffset(-_offset, _offset, o)];
              ops.push({
                op: "qcurveTo",
                data: [_x10 + this._getOffset(-_offset, _offset, o), _y10 + this._getOffset(-_offset, _offset, o), _f[0], _f[1]]
              });
              ops.push({
                op: "move",
                data: [path.x + this._getOffset(-_offset2, _offset2, o), path.y + this._getOffset(-_offset2, _offset2, o)]
              });
              _f = [_x9 + this._getOffset(-_offset2, _offset2, o), _y9 + this._getOffset(-_offset2, _offset2, o)];
              ops.push({
                op: "qcurveTo",
                data: [_x10 + this._getOffset(-_offset2, _offset2, o), _y10 + this._getOffset(-_offset2, _offset2, o), _f[0], _f[1]]
              });
              path.setPosition(_f[0], _f[1]);
              path.quadReflectionPoint = [_x9 + (_x9 - _x10), _y9 + (_y9 - _y10)];
            }
            break;
          }
        case "A":
        case "a":
          {
            var _delta8 = seg.key === "a";
            if (seg.data.length >= 7) {
              var rx = +seg.data[0];
              var ry = +seg.data[1];
              var angle = +seg.data[2];
              var largeArcFlag = +seg.data[3];
              var sweepFlag = +seg.data[4];
              var _x11 = +seg.data[5];
              var _y11 = +seg.data[6];
              if (_delta8) {
                _x11 += path.x;
                _y11 += path.y;
              }
              if (_x11 == path.x && _y11 == path.y) {
                break;
              }
              if (rx == 0 || ry == 0) {
                ops = ops.concat(this._doubleLine(path.x, path.y, _x11, _y11, o));
                path.setPosition(_x11, _y11);
              } else {
                var final = null;
                var _ro = o.maxRandomnessOffset || 0;
                for (var i = 0; i < 1; i++) {
                  var arcConverter = new _path.RoughArcConverter([path.x, path.y], [_x11, _y11], [rx, ry], angle, largeArcFlag ? true : false, sweepFlag ? true : false);
                  var segment = arcConverter.getNextSegment();
                  while (segment) {
                    var _ob2 = this._bezierTo(segment.cp1[0], segment.cp1[1], segment.cp2[0], segment.cp2[1], segment.to[0], segment.to[1], path, o);
                    ops = ops.concat(_ob2);
                    segment = arcConverter.getNextSegment();
                  }
                }
              }
            }
            break;
          }
        default:
          break;
      }
      return ops;
    }
  }, {
    key: "_getOffset",
    value: function _getOffset(min, max, ops) {
      return ops.roughness * (Math.random() * (max - min) + min);
    }
  }, {
    key: "_affine",
    value: function _affine(x, y, cx, cy, sinAnglePrime, cosAnglePrime, R) {
      var A = -cx * cosAnglePrime - cy * sinAnglePrime + cx;
      var B = R * (cx * sinAnglePrime - cy * cosAnglePrime) + cy;
      var C = cosAnglePrime;
      var D = sinAnglePrime;
      var E = -R * sinAnglePrime;
      var F = R * cosAnglePrime;
      return [A + C * x + D * y, B + E * x + F * y];
    }
  }, {
    key: "_doubleLine",
    value: function _doubleLine(x1, y1, x2, y2, o) {
      var o1 = this._line(x1, y1, x2, y2, o, true, false);
      var o2 = this._line(x1, y1, x2, y2, o, true, true);
      return o1.concat(o2);
    }
  }, {
    key: "_line",
    value: function _line(x1, y1, x2, y2, o, move, overlay) {
      var lengthSq = Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
      var offset = o.maxRandomnessOffset || 0;
      if (offset * offset * 100 > lengthSq) {
        offset = Math.sqrt(lengthSq) / 10;
      }
      var halfOffset = offset / 2;
      var divergePoint = 0.2 + Math.random() * 0.2;
      var midDispX = o.bowing * o.maxRandomnessOffset * (y2 - y1) / 200;
      var midDispY = o.bowing * o.maxRandomnessOffset * (x1 - x2) / 200;
      midDispX = this._getOffset(-midDispX, midDispX, o);
      midDispY = this._getOffset(-midDispY, midDispY, o);
      var ops = [];
      if (move) {
        if (overlay) {
          ops.push({
            op: "move",
            data: [x1 + this._getOffset(-halfOffset, halfOffset, o), y1 + this._getOffset(-halfOffset, halfOffset, o)]
          });
        } else {
          ops.push({
            op: "move",
            data: [x1 + this._getOffset(-offset, offset, o), y1 + this._getOffset(-offset, offset, o)]
          });
        }
      }
      if (overlay) {
        ops.push({
          op: "bcurveTo",
          data: [midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset, o), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset, o), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset, o), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset, o), x2 + this._getOffset(-halfOffset, halfOffset, o), y2 + this._getOffset(-halfOffset, halfOffset, o)]
        });
      } else {
        ops.push({
          op: "bcurveTo",
          data: [midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-offset, offset, o), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-offset, offset, o), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-offset, offset, o), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-offset, offset, o), x2 + this._getOffset(-offset, offset, o), y2 + this._getOffset(-offset, offset, o)]
        });
      }
      return ops;
    }
  }, {
    key: "_curve",
    value: function _curve(points, closePoint, o) {
      var len = points.length;
      var ops = [];
      if (len > 3) {
        var b = [];
        var s = 1 - o.curveTightness;
        ops.push({ op: "move", data: [points[1][0], points[1][1]] });
        for (var i = 1; i + 2 < len; i++) {
          var cachedVertArray = points[i];
          b[0] = [cachedVertArray[0], cachedVertArray[1]];
          b[1] = [cachedVertArray[0] + (s * points[i + 1][0] - s * points[i - 1][0]) / 6, cachedVertArray[1] + (s * points[i + 1][1] - s * points[i - 1][1]) / 6];
          b[2] = [points[i + 1][0] + (s * points[i][0] - s * points[i + 2][0]) / 6, points[i + 1][1] + (s * points[i][1] - s * points[i + 2][1]) / 6];
          b[3] = [points[i + 1][0], points[i + 1][1]];
          ops.push({
            op: "bcurveTo",
            data: [b[1][0], b[1][1], b[2][0], b[2][1], b[3][0], b[3][1]]
          });
        }
        if (closePoint && closePoint.length === 2) {
          var ro = o.maxRandomnessOffset;
          // TODO: more roughness here?
          ops.push({
            ops: "lineTo",
            data: [closePoint[0] + this._getOffset(-ro, ro, o), closePoint[1] + +this._getOffset(-ro, ro, o)]
          });
        }
      } else if (len === 3) {
        ops.push({ op: "move", data: [points[1][0], points[1][1]] });
        ops.push({
          op: "bcurveTo",
          data: [points[1][0], points[1][1], points[2][0], points[2][1], points[2][0], points[2][1]]
        });
      } else if (len === 2) {
        ops = ops.concat(this._doubleLine(points[0][0], points[0][1], points[1][0], points[1][1], o));
      }
      return ops;
    }
  }, {
    key: "_ellipse",
    value: function _ellipse(increment, cx, cy, rx, ry, offset, overlap, o) {
      var radOffset = this._getOffset(-0.5, 0.5, o) - Math.PI / 2;
      var points = [];
      points.push([this._getOffset(-offset, offset, o) + cx + 0.9 * rx * Math.cos(radOffset - increment), this._getOffset(-offset, offset, o) + cy + 0.9 * ry * Math.sin(radOffset - increment)]);
      for (var angle = radOffset; angle < Math.PI * 2 + radOffset - 0.01; angle = angle + increment) {
        points.push([this._getOffset(-offset, offset, o) + cx + rx * Math.cos(angle), this._getOffset(-offset, offset, o) + cy + ry * Math.sin(angle)]);
      }
      points.push([this._getOffset(-offset, offset, o) + cx + rx * Math.cos(radOffset + Math.PI * 2 + overlap * 0.5), this._getOffset(-offset, offset, o) + cy + ry * Math.sin(radOffset + Math.PI * 2 + overlap * 0.5)]);
      points.push([this._getOffset(-offset, offset, o) + cx + 0.98 * rx * Math.cos(radOffset + overlap), this._getOffset(-offset, offset, o) + cy + 0.98 * ry * Math.sin(radOffset + overlap)]);
      points.push([this._getOffset(-offset, offset, o) + cx + 0.9 * rx * Math.cos(radOffset + overlap * 0.5), this._getOffset(-offset, offset, o) + cy + 0.9 * ry * Math.sin(radOffset + overlap * 0.5)]);
      return this._curve(points, null, o);
    }
  }, {
    key: "_curveWithOffset",
    value: function _curveWithOffset(points, offset, o) {
      var ps = [];
      ps.push([points[0][0] + this._getOffset(-offset, offset, o), points[0][1] + this._getOffset(-offset, offset, o)]);
      ps.push([points[0][0] + this._getOffset(-offset, offset, o), points[0][1] + this._getOffset(-offset, offset, o)]);
      for (var i = 1; i < points.length; i++) {
        ps.push([points[i][0] + this._getOffset(-offset, offset, o), points[i][1] + this._getOffset(-offset, offset, o)]);
        if (i === points.length - 1) {
          ps.push([points[i][0] + this._getOffset(-offset, offset, o), points[i][1] + this._getOffset(-offset, offset, o)]);
        }
      }
      return this._curve(ps, null, o);
    }
  }, {
    key: "_arc",
    value: function _arc(increment, cx, cy, rx, ry, strt, stp, offset, o) {
      var radOffset = strt + this._getOffset(-0.1, 0.1, o);
      var points = [];
      points.push([this._getOffset(-offset, offset, o) + cx + 0.9 * rx * Math.cos(radOffset - increment), this._getOffset(-offset, offset, o) + cy + 0.9 * ry * Math.sin(radOffset - increment)]);
      for (var angle = radOffset; angle <= stp; angle = angle + increment) {
        points.push([this._getOffset(-offset, offset, o) + cx + rx * Math.cos(angle), this._getOffset(-offset, offset, o) + cy + ry * Math.sin(angle)]);
      }
      points.push([cx + rx * Math.cos(stp), cy + ry * Math.sin(stp)]);
      points.push([cx + rx * Math.cos(stp), cy + ry * Math.sin(stp)]);
      return this._curve(points, null, o);
    }
  }, {
    key: "_getIntersectingLines",
    value: function _getIntersectingLines(lineCoords, xCoords, yCoords) {
      var intersections = [];
      var s1 = new _segment.RoughSegment(lineCoords[0], lineCoords[1], lineCoords[2], lineCoords[3]);
      for (var i = 0; i < xCoords.length; i++) {
        var s2 = new _segment.RoughSegment(xCoords[i], yCoords[i], xCoords[(i + 1) % xCoords.length], yCoords[(i + 1) % xCoords.length]);
        if (s1.compare(s2) == (0, _segment.RoughSegmentRelation)().INTERSECTS) {
          intersections.push([s1.xi, s1.yi]);
        }
      }
      return intersections;
    }
  }]);

  return RoughRenderer;
}();

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.RoughSegmentRelation = RoughSegmentRelation;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RoughSegmentRelation() {
  return {
    LEFT: 0,
    RIGHT: 1,
    INTERSECTS: 2,
    AHEAD: 3,
    BEHIND: 4,
    SEPARATE: 5,
    UNDEFINED: 6
  };
}

var RoughSegment = exports.RoughSegment = function () {
  function RoughSegment(px1, py1, px2, py2) {
    _classCallCheck(this, RoughSegment);

    this.RoughSegmentRelationConst = RoughSegmentRelation();
    this.px1 = px1;
    this.py1 = py1;
    this.px2 = px2;
    this.py2 = py2;
    this.xi = Number.MAX_VALUE;
    this.yi = Number.MAX_VALUE;
    this.a = py2 - py1;
    this.b = px1 - px2;
    this.c = px2 * py1 - px1 * py2;
    this._undefined = this.a == 0 && this.b == 0 && this.c == 0;
  }

  _createClass(RoughSegment, [{
    key: "isUndefined",
    value: function isUndefined() {
      return this._undefined;
    }
  }, {
    key: "compare",
    value: function compare(otherSegment) {
      if (this.isUndefined() || otherSegment.isUndefined()) {
        return this.RoughSegmentRelationConst.UNDEFINED;
      }
      var grad1 = Number.MAX_VALUE;
      var grad2 = Number.MAX_VALUE;
      var int1 = 0,
          int2 = 0;
      var a = this.a,
          b = this.b,
          c = this.c;

      if (Math.abs(b) > 0.00001) {
        grad1 = -a / b;
        int1 = -c / b;
      }
      if (Math.abs(otherSegment.b) > 0.00001) {
        grad2 = -otherSegment.a / otherSegment.b;
        int2 = -otherSegment.c / otherSegment.b;
      }

      if (grad1 == Number.MAX_VALUE) {
        if (grad2 == Number.MAX_VALUE) {
          if (-c / a != -otherSegment.c / otherSegment.a) {
            return this.RoughSegmentRelationConst.SEPARATE;
          }
          if (this.py1 >= Math.min(otherSegment.py1, otherSegment.py2) && this.py1 <= Math.max(otherSegment.py1, otherSegment.py2)) {
            this.xi = this.px1;
            this.yi = this.py1;
            return this.RoughSegmentRelationConst.INTERSECTS;
          }
          if (this.py2 >= Math.min(otherSegment.py1, otherSegment.py2) && this.py2 <= Math.max(otherSegment.py1, otherSegment.py2)) {
            this.xi = this.px2;
            this.yi = this.py2;
            return this.RoughSegmentRelationConst.INTERSECTS;
          }
          return this.RoughSegmentRelationConst.SEPARATE;
        }
        this.xi = this.px1;
        this.yi = grad2 * this.xi + int2;
        if ((this.py1 - this.yi) * (this.yi - this.py2) < -0.00001 || (otherSegment.py1 - this.yi) * (this.yi - otherSegment.py2) < -0.00001) {
          return this.RoughSegmentRelationConst.SEPARATE;
        }
        if (Math.abs(otherSegment.a) < 0.00001) {
          if ((otherSegment.px1 - this.xi) * (this.xi - otherSegment.px2) < -0.00001) {
            return this.RoughSegmentRelationConst.SEPARATE;
          }
          return this.RoughSegmentRelationConst.INTERSECTS;
        }
        return this.RoughSegmentRelationConst.INTERSECTS;
      }

      if (grad2 == Number.MAX_VALUE) {
        this.xi = otherSegment.px1;
        this.yi = grad1 * this.xi + int1;
        if ((otherSegment.py1 - this.yi) * (this.yi - otherSegment.py2) < -0.00001 || (this.py1 - this.yi) * (this.yi - this.py2) < -0.00001) {
          return this.RoughSegmentRelationConst.SEPARATE;
        }
        if (Math.abs(a) < 0.00001) {
          if ((this.px1 - this.xi) * (this.xi - this.px2) < -0.00001) {
            return this.RoughSegmentRelationConst.SEPARATE;
          }
          return this.RoughSegmentRelationConst.INTERSECTS;
        }
        return this.RoughSegmentRelationConst.INTERSECTS;
      }

      if (grad1 == grad2) {
        if (int1 != int2) {
          return this.RoughSegmentRelationConst.SEPARATE;
        }
        if (this.px1 >= Math.min(otherSegment.px1, otherSegment.px2) && this.px1 <= Math.max(otherSegment.py1, otherSegment.py2)) {
          this.xi = this.px1;
          this.yi = this.py1;
          return this.RoughSegmentRelationConst.INTERSECTS;
        }
        if (this.px2 >= Math.min(otherSegment.px1, otherSegment.px2) && this.px2 <= Math.max(otherSegment.px1, otherSegment.px2)) {
          this.xi = this.px2;
          this.yi = this.py2;
          return this.RoughSegmentRelationConst.INTERSECTS;
        }
        return this.RoughSegmentRelationConst.SEPARATE;
      }

      this.xi = (int2 - int1) / (grad1 - grad2);
      this.yi = grad1 * this.xi + int1;

      if ((this.px1 - this.xi) * (this.xi - this.px2) < -0.00001 || (otherSegment.px1 - this.xi) * (this.xi - otherSegment.px2) < -0.00001) {
        return this.RoughSegmentRelationConst.SEPARATE;
      }
      return this.RoughSegmentRelationConst.INTERSECTS;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this._getLength(this.px1, this.py1, this.px2, this.py2);
    }
  }, {
    key: "_getLength",
    value: function _getLength(x1, y1, x2, y2) {
      var dx = x2 - x1;
      var dy = y2 - y1;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }]);

  return RoughSegment;
}();

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Brush = __webpack_require__(437);

var _d3Array = __webpack_require__(2);

var _d3Selection = __webpack_require__(3);

var _d3Voronoi = __webpack_require__(446);

var _semioticMark = __webpack_require__(6);

var _Brush = __webpack_require__(186);

var _Brush2 = _interopRequireDefault(_Brush);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var InteractionLayer = function (_React$Component) {
  _inherits(InteractionLayer, _React$Component);

  function InteractionLayer(props) {
    _classCallCheck(this, InteractionLayer);

    var _this = _possibleConstructorReturn(this, (InteractionLayer.__proto__ || Object.getPrototypeOf(InteractionLayer)).call(this, props));

    _this.createBrush = _this.createBrush.bind(_this);
    _this.createColumnsBrush = _this.createColumnsBrush.bind(_this);
    _this.brushStart = _this.brushStart.bind(_this);
    _this.brush = _this.brush.bind(_this);
    _this.brushEnd = _this.brushEnd.bind(_this);
    _this.changeVoronoi = _this.changeVoronoi.bind(_this);
    _this.doubleclickVoronoi = _this.doubleclickVoronoi.bind(_this);
    _this.clickVoronoi = _this.clickVoronoi.bind(_this);
    _this.calculateOverlay = _this.calculateOverlay.bind(_this);

    var initialOverlay = _this.calculateOverlay(props);

    _this.state = {
      overlayRegions: initialOverlay
    };
    return _this;
  }

  _createClass(InteractionLayer, [{
    key: "changeVoronoi",
    value: function changeVoronoi(d, customHoverTypes) {
      //Until semiotic 2
      var dataObject = d && d.data ? _extends({}, d.data, d) : d;
      if (this.props.customHoverBehavior) this.props.customHoverBehavior(dataObject);

      if (!d) this.props.voronoiHover(null);else if (customHoverTypes === true) {
        var vorD = _extends({}, dataObject);
        vorD.type = vorD.type === "column-hover" ? "column-hover" : "frame-hover";
        this.props.voronoiHover(vorD);
      } else {
        var arrayWrappedHoverTypes = Array.isArray(customHoverTypes) ? customHoverTypes : [customHoverTypes];
        var mappedHoverTypes = arrayWrappedHoverTypes.map(function (c) {
          var finalC = typeof c === "function" ? c(dataObject) : c;
          return _extends({}, dataObject, finalC);
        });
        this.props.voronoiHover(mappedHoverTypes);
      }
    }
  }, {
    key: "clickVoronoi",
    value: function clickVoronoi(d) {
      //Until semiotic 2
      var dataObject = d.data ? _extends({}, d.data, d) : d;

      if (this.props.customClickBehavior) this.props.customClickBehavior(dataObject);
    }
  }, {
    key: "doubleclickVoronoi",
    value: function doubleclickVoronoi(d) {
      //Until semiotic 2
      var dataObject = d.data ? _extends({}, d.data, d) : d;

      if (this.props.customDoubleClickBehavior) this.props.customDoubleClickBehavior(dataObject);
    }
  }, {
    key: "brushStart",
    value: function brushStart(e, c) {
      if (this.props.interaction.start) this.props.interaction.start(e, c);
    }
  }, {
    key: "brush",
    value: function brush(e, c) {
      if (this.props.interaction.during) this.props.interaction.during(e, c);
    }
  }, {
    key: "brushEnd",
    value: function brushEnd(e, c) {
      if (this.props.interaction.end) this.props.interaction.end(e, c);
    }
  }, {
    key: "createBrush",
    value: function createBrush() {
      var _this2 = this;

      var semioticBrush = void 0,
          mappingFn = void 0,
          selectedExtent = void 0;

      var _props = this.props,
          interaction = _props.interaction,
          xScale = _props.xScale,
          yScale = _props.yScale,
          size = _props.size;
      var _interaction$extent = interaction.extent,
          extent = _interaction$extent === undefined ? interaction.brush === "xyBrush" ? [[xScale.invert(0), yScale.invert(0)], [xScale.invert(size[0]), yScale.invert(size[1])]] : interaction.brush === "xBrush" ? [xScale.invert(0), xScale.invert(size[0])] : [yScale.invert(0), yScale.invert(size[1])] : _interaction$extent;


      if (extent.indexOf(undefined) !== -1) {
        return _react2.default.createElement("g", null);
      }

      if (interaction.brush === "xBrush") {
        if (extent.indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        mappingFn = function mappingFn(d) {
          return !d ? null : [xScale.invert(d[0]), xScale.invert(d[1])];
        };
        semioticBrush = (0, _d3Brush.brushX)();
        selectedExtent = extent.map(function (d) {
          return xScale(d);
        });
      } else if (interaction.brush === "yBrush") {
        if (extent.indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        mappingFn = function mappingFn(d) {
          return !d ? null : [yScale.invert(d[0]), yScale.invert(d[1])];
        };
        semioticBrush = (0, _d3Brush.brushY)();
        selectedExtent = extent.map(function (d) {
          return yScale(d);
        });
      } else {
        if (extent.indexOf(undefined) !== -1 || extent[0].indexOf(undefined) !== -1 || extent[1].indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        semioticBrush = (0, _d3Brush.brush)();
        mappingFn = function mappingFn(d) {
          return !d ? null : [[xScale.invert(d[0][0]), yScale.invert(d[0][1])], [xScale.invert(d[1][0]), yScale.invert(d[1][1])]];
        };
        selectedExtent = extent.map(function (d) {
          return [xScale(d[0]), yScale(d[1])];
        });
      }

      semioticBrush.extent([[0, 0], [this.props.size[0], this.props.size[1]]]).on("start", function () {
        _this2.brushStart(mappingFn(_d3Selection.event.selection));
      }).on("brush", function () {
        _this2.brush(mappingFn(_d3Selection.event.selection));
      }).on("end", function () {
        _this2.brushEnd(mappingFn(_d3Selection.event.selection));
      });

      return _react2.default.createElement(
        "g",
        { className: "brush" },
        _react2.default.createElement(_Brush2.default, {
          type: interaction.brush,
          selectedExtent: selectedExtent,
          extent: extent,
          svgBrush: semioticBrush,
          size: size
        })
      );
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ overlayRegions: this.calculateOverlay(nextProps) });
    }
  }, {
    key: "calculateOverlay",
    value: function calculateOverlay(props) {
      var _this3 = this;

      var voronoiPaths = [];
      var xScale = props.xScale,
          yScale = props.yScale,
          points = props.points,
          projectedX = props.projectedX,
          projectedY = props.projectedY,
          projectedYMiddle = props.projectedYMiddle,
          size = props.size,
          overlay = props.overlay,
          _props$interactionOve = props.interactionOverflow,
          interactionOverflow = _props$interactionOve === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$interactionOve;


      if (points && props.hoverAnnotation && !overlay) {
        var voronoiDataset = [];
        var voronoiUniqueHash = {};

        points.forEach(function (d) {
          var xValue = parseInt(xScale(d[projectedX]), 10);
          var yValue = parseInt(yScale(d[projectedYMiddle] || d[projectedY]), 10);
          if (xValue >= 0 && xValue <= size[0] && yValue >= 0 && yValue <= size[1] && xValue !== undefined && yValue !== undefined && isNaN(xValue) === false && isNaN(yValue) === false) {
            var pointKey = xValue + "," + yValue;
            if (!voronoiUniqueHash[pointKey]) {
              var voronoiPoint = _extends({}, d, {
                coincidentPoints: [d],
                voronoiX: xValue,
                voronoiY: yValue
              });
              voronoiDataset.push(voronoiPoint);
              voronoiUniqueHash[pointKey] = voronoiPoint;
            } else voronoiUniqueHash[pointKey].coincidentPoints.push(d);
          }
        });

        var voronoiXExtent = (0, _d3Array.extent)(voronoiDataset.map(function (d) {
          return d.voronoiX;
        }));
        var voronoiYExtent = (0, _d3Array.extent)(voronoiDataset.map(function (d) {
          return d.voronoiY;
        }));

        var voronoiExtent = [[Math.min(voronoiXExtent[0], -interactionOverflow.left), Math.min(voronoiYExtent[0], -interactionOverflow.top)], [Math.max(voronoiXExtent[1], size[0] + interactionOverflow.right), Math.max(voronoiYExtent[1], size[1] + interactionOverflow.bottom)]];

        var voronoiDiagram = (0, _d3Voronoi.voronoi)().extent(voronoiExtent).x(function (d) {
          return d.voronoiX;
        }).y(function (d) {
          return d.voronoiY;
        });

        var voronoiData = voronoiDiagram.polygons(voronoiDataset);
        var voronoiLinks = voronoiDiagram.links(voronoiDataset);

        //create neighbors
        voronoiLinks.forEach(function (v) {
          if (!v.source.neighbors) v.source.neighbors = [];

          v.source.neighbors.push(v.target);
        });

        voronoiPaths = voronoiData.map(function (d, i) {
          return _react2.default.createElement("path", {
            onClick: function onClick() {
              _this3.clickVoronoi(voronoiDataset[i]);
            },
            onDoubleClick: function onDoubleClick() {
              _this3.doubleclickVoronoi(voronoiDataset[i]);
            },
            onMouseEnter: function onMouseEnter() {
              _this3.changeVoronoi(voronoiDataset[i], props.hoverAnnotation);
            },
            onMouseLeave: function onMouseLeave() {
              _this3.changeVoronoi();
            },
            key: "interactionVoronoi" + i,
            d: "M" + d.join("L") + "Z",
            style: { fillOpacity: 0 }
          });
        }, this);
        return voronoiPaths;
      } else if (overlay) {
        var renderedOverlay = overlay.map(function (overlayRegion, i) {
          var overlayData = overlayRegion.overlayData,
              rest = _objectWithoutProperties(overlayRegion, ["overlayData"]);

          return _react2.default.createElement(_semioticMark.Mark, _extends({
            key: "overlay-" + i,
            forceUpdate: true
          }, rest, {
            onMouseEnter: function onMouseEnter() {
              overlayRegion.onMouseEnter && overlayRegion.onMouseEnter();
              _this3.changeVoronoi(overlayData, props.hoverAnnotation);
            },
            onMouseLeave: function onMouseLeave() {
              overlayRegion.onMouseLeave && overlayRegion.onMouseLeave();
              _this3.changeVoronoi();
            }
          }));
        });

        return renderedOverlay;
      }
    }
  }, {
    key: "createColumnsBrush",
    value: function createColumnsBrush() {
      var _this4 = this;

      var _props2 = this.props,
          projection = _props2.projection,
          rScale = _props2.rScale,
          interaction = _props2.interaction,
          size = _props2.size,
          oColumns = _props2.oColumns;


      var semioticBrush = void 0,
          mappingFn = void 0;

      var max = rScale.domain()[1];

      var type = "yBrush";

      if (projection && projection === "horizontal") {
        type = "xBrush";
        mappingFn = function mappingFn(d) {
          return !d ? null : [rScale.invert(d[0]), rScale.invert(d[1])];
        };
      } else mappingFn = function mappingFn(d) {
        return !d ? null : [Math.abs(rScale.invert(d[1]) - max), Math.abs(rScale.invert(d[0]) - max)];
      };

      var rRange = rScale.range();

      var columnHash = oColumns;
      var brushPosition = void 0,
          selectedExtent = void 0;
      var brushes = Object.keys(columnHash).map(function (c) {
        if (projection && projection === "horizontal") {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rScale(d);
          }) : rRange;
          brushPosition = [0, columnHash[c].x];
          semioticBrush = (0, _d3Brush.brushX)();
          semioticBrush.extent([[rRange[0], 0], [rRange[1], columnHash[c].width]]).on("start", function () {
            _this4.brushStart(mappingFn(_d3Selection.event.selection), c);
          }).on("brush", function () {
            _this4.brush(mappingFn(_d3Selection.event.selection), c);
          }).on("end", function () {
            _this4.brushEnd(mappingFn(_d3Selection.event.selection), c);
          });
        } else {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rRange[1] - rScale(d);
          }).reverse() : rRange;
          brushPosition = [columnHash[c].x, 0];
          semioticBrush = (0, _d3Brush.brushY)();
          semioticBrush.extent([[0, rRange[0]], [columnHash[c].width, rRange[1]]]).on("start", function () {
            _this4.brushStart(mappingFn(_d3Selection.event.selection), c);
          }).on("brush", function () {
            _this4.brush(mappingFn(_d3Selection.event.selection), c);
          }).on("end", function () {
            _this4.brushEnd(mappingFn(_d3Selection.event.selection), c);
          });
        }

        return _react2.default.createElement(
          "g",
          { key: "column-brush-" + c, className: "brush" },
          _react2.default.createElement(_Brush2.default, {
            type: type,
            position: brushPosition,
            key: "orbrush" + c,
            selectedExtent: selectedExtent,
            svgBrush: semioticBrush,
            size: size
          })
        );
      });
      return brushes;
    }
  }, {
    key: "render",
    value: function render() {
      var semioticBrush = null;
      var _props3 = this.props,
          interaction = _props3.interaction,
          svgSize = _props3.svgSize,
          margin = _props3.margin,
          useSpans = _props3.useSpans;
      var overlayRegions = this.state.overlayRegions;
      var enabled = this.props.enabled;


      if (interaction && interaction.brush) {
        enabled = true;
        semioticBrush = this.createBrush();
      }
      if (interaction && interaction.columnsBrush) {
        enabled = true;
        semioticBrush = this.createColumnsBrush();
      }

      if (!overlayRegions && !semioticBrush) {
        return null;
      }

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: "interaction-layer",
          style: {
            position: "absolute",
            background: "none",
            pointerEvents: "none"
          }
        },
        _react2.default.createElement(
          "svg",
          {
            height: svgSize[1],
            width: svgSize[0],
            style: { background: "none", pointerEvents: "none" }
          },
          _react2.default.createElement(
            "g",
            {
              className: "interaction-overlay",
              transform: "translate(" + margin.left + "," + margin.top + ")",
              style: { pointerEvents: enabled ? "all" : "none" }
            },
            _react2.default.createElement(
              "g",
              { className: "interaction-regions" },
              overlayRegions
            ),
            semioticBrush
          )
        )
      );
    }
  }]);

  return InteractionLayer;
}(_react2.default.Component);

InteractionLayer.propTypes = {
  name: _propTypes2.default.string,
  interaction: _propTypes2.default.object,
  overlay: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  oColumns: _propTypes2.default.object,
  xScale: _propTypes2.default.func,
  yScale: _propTypes2.default.func,
  rScale: _propTypes2.default.func,
  svgSize: _propTypes2.default.array
};

exports.default = InteractionLayer;
module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(183);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(35);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(35);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var flatten = function flatten(list) {
  return list.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};

function flatShortArray(array) {
  if (!Array.isArray(array)) return "not-array";
  var flat = flatten(array);
  var stringifiedFlattened = flat.map(function (d) {
    return d instanceof Date && d.toString() || d && d.toFixed && d.toFixed(2) || "empty";
  }).toString();
  return stringifiedFlattened;
}

var Brush = function (_React$Component) {
  _inherits(Brush, _React$Component);

  function Brush(props) {
    _classCallCheck(this, Brush);

    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));

    _this.createBrush = _this.createBrush.bind(_this);
    return _this;
  }

  _createClass(Brush, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createBrush();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(lastProps) {
      if (lastProps.extent && this.props.extent && flatShortArray(lastProps.extent) !== flatShortArray(this.props.extent) || lastProps.selectedExtent && this.props.selectedExtent && flatShortArray(lastProps.selectedExtent) !== flatShortArray(this.props.selectedExtent) || !lastProps.selectedExtent && this.props.selectedExtent || lastProps.selectedExtent && !this.props.selectedExtent) {
        this.createBrush();
      }
    }
  }, {
    key: "createBrush",
    value: function createBrush() {
      var node = this.node;
      var brush = this.props.svgBrush;
      (0, _d3Selection.select)(node).call(brush);
      if (this.props.selectedExtent) {
        (0, _d3Selection.select)(node).call(brush.move, this.props.selectedExtent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("g", {
        ref: function ref(node) {
          return _this2.node = node;
        },
        transform: "translate(" + (this.props.position || [0, 0]) + ")",
        className: "xybrush"
      });
    }
  }]);

  return Brush;
}(_react2.default.Component);

Brush.propTypes = {
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  selectedExtent: _propTypes2.default.array,
  svgBrush: _propTypes2.default.func
};

exports.default = Brush;
module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _canvas = __webpack_require__(451);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _basicCanvasEffects = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualizationLayer = (_temp = _class = function (_React$PureComponent) {
  _inherits(VisualizationLayer, _React$PureComponent);

  function VisualizationLayer(props) {
    _classCallCheck(this, VisualizationLayer);

    var _this = _possibleConstructorReturn(this, (VisualizationLayer.__proto__ || Object.getPrototypeOf(VisualizationLayer)).call(this, props));

    _this.piecesGroup = {};
    _this.state = {
      canvasDrawing: [],
      dataVersion: "",
      renderedElements: [],
      focusedPieceIndex: null,
      focusedVisualizationGroup: null
    };

    _this.updateVisualizationLayer = _this.updateVisualizationLayer.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(VisualizationLayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.disableContext || !this.props.canvasContext || !this.canvasDrawing) return;

      var size = [this.props.size[0] + this.props.margin.left + this.props.margin.right, this.props.size[1] + this.props.margin.top + this.props.margin.bottom];
      var rc = void 0;
      var context = this.props.canvasContext.getContext("2d");
      context.setTransform(1, 0, 0, 1, this.props.margin.left, this.props.margin.top);
      context.clearRect(-this.props.margin.left, -this.props.margin.top, size[0], size[1]);

      this.canvasDrawing.forEach(function (piece) {

        var style = piece.styleFn ? piece.styleFn(_extends({}, piece.d, piece.d.data), piece.i) || {} : { fill: "black", stroke: "black" };

        var fill = style.fill ? style.fill : "black";
        var stroke = style.stroke ? style.stroke : "black";
        context.setTransform(1, 0, 0, 1, _this2.props.margin.left, _this2.props.margin.top);
        context.translate.apply(context, _toConsumableArray(_this2.props.position));
        context.translate(piece.tx, piece.ty);
        context.fillStyle = fill;
        context.strokeStyle = stroke;
        context.lineWidth = style.strokeWidth ? style.strokeWidth : 0;

        var rcSettings = {};
        var renderObject = piece.markProps.renderMode || piece.renderFn && piece.renderFn(_extends({}, piece.d, piece.d.data), piece.i);
        var actualRenderMode = renderObject && renderObject.renderMode || renderObject;

        if (actualRenderMode) {
          rc = rc || new _canvas.RoughCanvas(_this2.props.canvasContext);
          var rcExtension = (typeof renderObject === "undefined" ? "undefined" : _typeof(renderObject)) === "object" && renderObject || {};
          rcSettings = _extends({
            fill: fill,
            stroke: stroke,
            strokeWidth: context.lineWidth
          }, rcExtension);
        }

        if (piece.markProps.markType === "circle" || piece.markProps.markType === "rect" && piece.markProps.rx > 0) {
          var vizX = 0,
              vizY = 0,
              r = piece.markProps.r;
          if (piece.markProps.width) {
            var halfWidth = piece.markProps.width / 2;
            vizX = piece.markProps.x + halfWidth;
            vizY = piece.markProps.y + halfWidth;
            r = halfWidth;
          }
          if (actualRenderMode === "sketchy") {
            if (context.globalAlpha !== 0) rc.circle(vizX, vizY, r, rcSettings);
          } else {
            context.beginPath();
            context.arc(vizX, vizY, r, 0, 2 * Math.PI);
            context.globalAlpha = style.fillOpacity || style.opacity || 1;
            if (style.fill && style.fill !== "none" && context.globalAlpha !== 0) context.fill();
            context.globalAlpha = style.strokeOpacity || style.opacity || 1;
            if (style.stroke && style.stroke !== "none" && context.globalAlpha !== 0) context.stroke();
          }
        } else if (piece.markProps.markType === "rect") {
          if (actualRenderMode === "sketchy") {
            context.globalAlpha = style.opacity || 1;
            if (context.globalAlpha !== 0) rc.rectangle(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height, rcSettings);
          } else {
            context.globalAlpha = style.fillOpacity || style.opacity || 1;
            if (style.fill && style.fill !== "none" && context.globalAlpha !== 0) context.fillRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
            context.globalAlpha = style.strokeOpacity || style.opacity || 1;
            if (style.stroke && style.stroke !== "none" && context.globalAlpha !== 0) context.strokeRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
          }
        } else if (piece.markProps.markType === "path") {
          if (actualRenderMode === "sketchy") {
            context.globalAlpha = style.opacity || 1;
            rc.path(piece.markProps.d, rcSettings);
          } else {
            var p = new Path2D(piece.markProps.d);
            context.globalAlpha = style.strokeOpacity || style.opacity || 1;
            if (style.stroke && style.stroke !== "none" && context.globalAlpha !== 0) context.stroke(p);
            context.globalAlpha = style.fillOpacity || style.opacity || 1;
            if (style.fill && style.fill !== "none" && context.globalAlpha !== 0) context.fill(p);
          }
        } else {
          console.error("CURRENTLY UNSUPPORTED MARKTYPE FOR CANVAS RENDERING");
        }
      });
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.globalAlpha = 1;

      if (this.props.canvasPostProcess === "chuckClose") {
        (0, _basicCanvasEffects.chuckCloseCanvasTransform)(this.props.canvasContext, context, size);
      } else if (typeof this.props.canvasPostProcess === "function") {
        this.props.canvasPostProcess(this.props.canvasContext, context, size);
      }

      if (this.piecesGroup[this.state.focusedVisualizationGroup] && this.state.focusedPieceIndex !== null) {
        var focusElParent = this.piecesGroup[this.state.focusedVisualizationGroup][this.state.focusedPieceIndex];

        var focusEl = focusElParent && [].concat(_toConsumableArray(focusElParent.childNodes)).find(function (child) {
          return child.getAttribute("aria-label");
        }) || focusElParent;

        focusEl && focusEl.focus && focusEl.focus();
      }
    }
  }, {
    key: "updateVisualizationLayer",
    value: function updateVisualizationLayer(props) {
      var _this3 = this;

      var xScale = props.xScale,
          yScale = props.yScale,
          dataVersion = props.dataVersion,
          projectedCoordinateNames = props.projectedCoordinateNames,
          renderKeyFn = props.renderKeyFn,
          _props$renderPipeline = props.renderPipeline,
          renderPipeline = _props$renderPipeline === undefined ? {} : _props$renderPipeline,
          _props$baseMarkProps = props.baseMarkProps,
          baseMarkProps = _props$baseMarkProps === undefined ? {} : _props$baseMarkProps;

      this.canvasDrawing = [];
      var canvasDrawing = this.canvasDrawing;

      var renderedElements = [];
      Object.keys(renderPipeline).forEach(function (k) {
        var pipe = renderPipeline[k];
        if (pipe.data && _typeof(pipe.data) === "object" && !Array.isArray(pipe.data) || pipe.data && pipe.data.length > 0) {
          var renderedPipe = pipe.behavior(_extends({
            xScale: xScale,
            yScale: yScale,
            canvasDrawing: canvasDrawing,
            projectedCoordinateNames: projectedCoordinateNames,
            renderKeyFn: renderKeyFn,
            baseMarkProps: _extends(baseMarkProps, {
              "aria-label": pipe.ariaLabel && pipe.ariaLabel.items || "dataviz-element",
              "role": "img",
              "tabIndex": -1
            })
          }, pipe));

          if (renderedPipe && renderedPipe.length > 0) {
            renderedElements.push(_react2.default.createElement(
              "g",
              {
                key: k,
                className: k,
                role: "group",
                tabIndex: 0,
                "aria-label": pipe.ariaLabel && renderedPipe.length + " " + pipe.ariaLabel.items + "s in a " + pipe.ariaLabel.chart || k,
                onKeyDown: function onKeyDown(e) {
                  return _this3.handleKeyDown(e, k);
                },
                onBlur: function onBlur() {
                  _this3.props.voronoiHover(undefined);
                },
                ref: function ref(thisNode) {
                  return thisNode && (_this3.piecesGroup[k] = thisNode.childNodes);
                }
              },
              renderedPipe
            ));
          }
        }
      });

      this.setState({
        renderedElements: renderedElements,
        dataVersion: dataVersion
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updateVisualizationLayer(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(np) {
      var lp = this.props;
      var propKeys = Object.keys(np);

      var update = false;
      propKeys.forEach(function (key) {
        if (lp[key] !== np[key]) {
          update = true;
        }
      });

      if (update === true || np.dataVersion && np.dataVersion !== this.state.dataVersion) {
        this.updateVisualizationLayer(np);
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e, vizgroup) {
      // If enter, focus on the first element
      var pushed = e.keyCode;
      if (pushed !== 37 && pushed !== 39 && pushed !== 13) return;

      var newPieceIndex = void 0;
      var vizGroupSetting = {};

      // If a user pressed enter, highlight the first one
      // Let a user move up and down in stacked bar by getting keys of bars?
      if (this.state.focusedPieceIndex === null || pushed === 13) {
        newPieceIndex = 0;
        vizGroupSetting.focusedVisualizationGroup = vizgroup;
      } else if (pushed === 37) {
        newPieceIndex = this.state.focusedPieceIndex - 1;
      } else if (pushed === 39) {
        newPieceIndex = this.state.focusedPieceIndex + 1;
      }

      newPieceIndex = newPieceIndex < 0 ? this.piecesGroup[vizgroup].length + newPieceIndex : newPieceIndex % this.piecesGroup[vizgroup].length;

      /*
      const piece = this.props.renderPipeline[vizgroup].accessibleTransform(
        this.props.renderPipeline[vizgroup].data[newPieceIndex]
      )
      */

      var piece = this.props.renderPipeline[vizgroup].accessibleTransform(this.props.renderPipeline[vizgroup].data, newPieceIndex, this.piecesGroup[vizgroup][newPieceIndex]);

      this.props.voronoiHover(piece);

      this.setState(_extends({
        focusedPieceIndex: newPieceIndex
      }, vizGroupSetting));
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var matte = props.matte,
          matteClip = props.matteClip,
          axes = props.axes,
          frameKey = props.frameKey,
          margin = props.margin;
      var renderedElements = this.state.renderedElements;


      var renderedAxes = axes && _react2.default.createElement(
        "g",
        { key: "visualization-axis-labels", className: "axis axis-labels" },
        axes
      );

      var ariaLabel = "";

      var title = this.props.title && this.props.ariaTitle || this.props.title ? this.props.title.props && typeof this.props.title.props.children === "string" ? "titled " + this.props.title.props.children : "with a complex title" : "with no title";
      ariaLabel = "Visualization " + title + ". Use arrow keys to navigate elements.";

      var renderedDataVisualization = (renderedAxes || renderedElements && renderedElements.length > 0) && _react2.default.createElement(
        "g",
        {
          className: "data-visualization",
          key: "visualization-clip-path",
          "aria-label": ariaLabel,
          role: "group",
          clipPath: matteClip && matte ? "url(#matte-clip" + frameKey + ")" : undefined,
          transform: "translate(" + margin.left + "," + margin.top + ")"
        },
        renderedElements,
        matte,
        renderedAxes
      ) || null;

      return renderedDataVisualization;
    }
  }]);

  return VisualizationLayer;
}(_react2.default.PureComponent), _class.defaultProps = {
  position: [0, 0],
  margin: { left: 0, top: 0, right: 0, bottom: 0 }
}, _temp);


VisualizationLayer.propTypes = {
  axes: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  frameKey: _propTypes2.default.string,
  xScale: _propTypes2.default.func,
  yScale: _propTypes2.default.func,
  pointData: _propTypes2.default.array,
  lineData: _propTypes2.default.array,
  areaData: _propTypes2.default.array,
  dataVersion: _propTypes2.default.string,
  canvasContext: _propTypes2.default.object,
  size: _propTypes2.default.array.isRequired,
  margin: _propTypes2.default.object
};

exports.default = VisualizationLayer;
module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var chuckCloseCanvasTransform = exports.chuckCloseCanvasTransform = function chuckCloseCanvasTransform(canvas, context, size) {
  var pixelSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

  var _size = _slicedToArray(size, 2),
      baseWidth = _size[0],
      baseHeight = _size[1];

  var height = baseHeight + (baseHeight % pixelSize === 0 ? 0 : pixelSize - baseHeight % pixelSize);

  var width = baseWidth + (baseWidth % pixelSize === 0 ? 0 : pixelSize - baseWidth % pixelSize);

  var rgbStep = 4 * pixelSize;

  var imageData = context.getImageData(0, 0, width, height);
  var rgbaArray = [];
  var imageArray = imageData.data;

  var rgbWidth = width * 4;
  var halfPixelSize = pixelSize / 2;

  for (var i = 0; i < imageArray.length; i += rgbStep) {
    var pixelPoint = {};
    if (pixelSize === 1) {
      pixelPoint = {
        r: imageArray[i],
        g: imageArray[i + 1],
        b: imageArray[i + 2],
        a: imageArray[i + 3],
        x: i / 4 % width,
        y: Math.floor(i / 4 / width)
      };
    } else {
      var rgbHash = {};
      var totalHash = 0;

      for (var p = 0; p < pixelSize * 4; p += pixelSize * 4) {
        for (var q = 0; q < pixelSize * rgbWidth; q += rgbWidth) {
          if (imageArray[p + i + q + 3] !== -1) {
            var hashVal = "rgba(" + imageArray[p + i + q] + "," + imageArray[p + i + q + 1] + "," + imageArray[p + i + q + 2] + "," + imageArray[p + i + q + 3] + ")";
            rgbHash[hashVal] = rgbHash[hashVal] ? rgbHash[hashVal] + 1 : 1;
            totalHash += 1;
          }
        }
      }
      pixelPoint = {
        rgbEntries: Object.entries(rgbHash).sort(function (a, b) {
          return b[1] - a[1];
        }),
        totalEntries: totalHash,
        x: i / 4 % width,
        y: Math.floor(i / 4 / width),
        rmod: pixelSize
      };
    }

    rgbaArray.push(pixelPoint);
    if (pixelSize !== 1 && (i + rgbStep) % rgbWidth === 0) {
      i += rgbWidth * (pixelSize - 1);
    }
  }

  var scale = 1;
  var r = scale / 2;
  context.clearRect(0, 0, width, height);
  var circleArc = 2 * Math.PI;
  rgbaArray.forEach(function (point) {
    var currentR = r * pixelSize;
    var rStep = currentR / point.totalEntries;
    var baseX = point.x * scale + halfPixelSize;
    var baseY = point.y * scale + halfPixelSize;
    point.rgbEntries.forEach(function (e) {
      context.fillStyle = e[0];
      context.beginPath();
      context.arc(baseX, baseY, currentR, 0, circleArc);
      context.fill();
      currentR -= e[1] * rStep;
    });
  });
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLaidOutSummaries = exports.drawSummaries = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.boxplotRenderFn = boxplotRenderFn;
exports.contourRenderFn = contourRenderFn;
exports.bucketizedRenderingFn = bucketizedRenderingFn;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Axis = __webpack_require__(54);

var _Axis2 = _interopRequireDefault(_Axis);

var _semioticMark = __webpack_require__(6);

var _areaDrawing = __webpack_require__(96);

var _d3Array = __webpack_require__(2);

var _SvgHelper = __webpack_require__(95);

var _d3Shape = __webpack_require__(7);

var _pieceDrawing = __webpack_require__(55);

var _frameFunctions = __webpack_require__(36);

var _d3Scale = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var contourMap = function contourMap(d) {
  return [d.xy.x, d.xy.y];
};

var verticalXYSorting = function verticalXYSorting(a, b) {
  return a.xy.y - b.xy.y;
};
var horizontalXYSorting = function horizontalXYSorting(a, b) {
  return b.xy.x - a.xy.x;
};
var emptyObjectReturnFn = function emptyObjectReturnFn() {
  return {};
};

function boxplotRenderFn(_ref) {
  var data = _ref.data,
      type = _ref.type,
      renderMode = _ref.renderMode,
      eventListenersGenerator = _ref.eventListenersGenerator,
      styleFn = _ref.styleFn,
      classFn = _ref.classFn,
      _ref$positionFn = _ref.positionFn,
      positionFn = _ref$positionFn === undefined ? function (position) {
    return position;
  } : _ref$positionFn,
      projection = _ref.projection,
      adjustedSize = _ref.adjustedSize,
      baseMarkProps = _ref.baseMarkProps;

  var summaryElementStylingFn = type.elementStyleFn || emptyObjectReturnFn;

  var keys = Object.keys(data);
  var renderedSummaryMarks = [];
  var summaryXYCoords = [];
  keys.forEach(function (key, summaryI) {
    var summary = data[key];
    var eventListeners = eventListenersGenerator(summary, summaryI);

    var columnWidth = summary.width;

    var thisSummaryData = summary.pieceData;

    var calculatedSummaryStyle = styleFn(thisSummaryData[0].data, summaryI);
    var calculatedSummaryClass = classFn(thisSummaryData[0].data, summaryI);

    var summaryPositionNest = void 0,
        summaryValueNest = void 0,
        translate = void 0,
        extentlineX1 = void 0,
        extentlineX2 = void 0,
        extentlineY1 = void 0,
        extentlineY2 = void 0,
        topLineX1 = void 0,
        topLineX2 = void 0,
        midLineX1 = void 0,
        midLineX2 = void 0,
        bottomLineX1 = void 0,
        bottomLineX2 = void 0,
        rectTopWidth = void 0,
        rectTopHeight = void 0,
        rectTopY = void 0,
        rectTopX = void 0,
        rectBottomWidth = void 0,
        rectBottomHeight = void 0,
        rectBottomY = void 0,
        rectBottomX = void 0,
        rectWholeWidth = void 0,
        rectWholeHeight = void 0,
        rectWholeY = void 0,
        rectWholeX = void 0,
        topLineY1 = void 0,
        topLineY2 = void 0,
        bottomLineY1 = void 0,
        bottomLineY2 = void 0,
        midLineY1 = void 0,
        midLineY2 = void 0;

    var renderValue = renderMode ? renderMode(summary, summaryI) : undefined;

    summaryValueNest = thisSummaryData.map(function (p) {
      return p.value;
    }).sort(function (a, b) {
      return a - b;
    });

    summaryValueNest = [(0, _d3Array.quantile)(summaryValueNest, 0.0), (0, _d3Array.quantile)(summaryValueNest, 0.25), (0, _d3Array.quantile)(summaryValueNest, 0.5), (0, _d3Array.quantile)(summaryValueNest, 0.75), (0, _d3Array.quantile)(summaryValueNest, 1.0)];

    if (projection === "vertical") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledVerticalValue;
      }).sort(function (a, b) {
        return b - a;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      var xPosition = positionFn(summary.middle, key, summaryI);

      translate = "translate(" + xPosition + ",0)";
      extentlineX1 = 0;
      extentlineX2 = 0;
      extentlineY1 = summaryPositionNest[0];
      extentlineY2 = summaryPositionNest[4];
      topLineX1 = -columnWidth / 2;
      topLineX2 = columnWidth / 2;
      midLineX1 = -columnWidth / 2;
      midLineX2 = columnWidth / 2;
      bottomLineX1 = -columnWidth / 2;
      bottomLineX2 = columnWidth / 2;
      rectBottomWidth = columnWidth;
      rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[2];
      rectBottomY = summaryPositionNest[2];
      rectBottomX = -columnWidth / 2;
      rectTopWidth = columnWidth;
      rectTopHeight = summaryPositionNest[2] - summaryPositionNest[3];
      rectWholeWidth = columnWidth;
      rectWholeHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectWholeY = summaryPositionNest[3];
      rectWholeX = -columnWidth / 2;
      rectTopY = summaryPositionNest[3];
      rectTopX = -columnWidth / 2;
      topLineY1 = summaryPositionNest[0];
      topLineY2 = summaryPositionNest[0];
      bottomLineY1 = summaryPositionNest[4];
      bottomLineY2 = summaryPositionNest[4];
      midLineY1 = summaryPositionNest[2];
      midLineY2 = summaryPositionNest[2];

      summaryXYCoords.push({
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: xPosition,
        y: summaryPositionNest[4],
        value: summaryValueNest[4]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: xPosition,
        y: summaryPositionNest[3],
        value: summaryValueNest[3]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: xPosition,
        y: summaryPositionNest[2],
        value: summaryValueNest[2]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: xPosition,
        y: summaryPositionNest[1],
        value: summaryValueNest[1]
      }, {
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: xPosition,
        y: summaryPositionNest[0],
        value: summaryValueNest[0]
      });
    } else if (projection === "horizontal") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledValue;
      }).sort(function (a, b) {
        return a - b;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      var yPosition = positionFn(summary.middle, key, summaryI);

      translate = "translate(0," + yPosition + ")";
      extentlineY1 = 0;
      extentlineY2 = 0;
      extentlineX1 = summaryPositionNest[0];
      extentlineX2 = summaryPositionNest[4];
      topLineY1 = -columnWidth / 2;
      topLineY2 = columnWidth / 2;
      midLineY1 = -columnWidth / 2;
      midLineY2 = columnWidth / 2;
      bottomLineY1 = -columnWidth / 2;
      bottomLineY2 = columnWidth / 2;
      rectTopHeight = columnWidth;
      rectTopWidth = summaryPositionNest[3] - summaryPositionNest[2];
      rectTopX = summaryPositionNest[2];
      rectTopY = -columnWidth / 2;
      rectBottomHeight = columnWidth;
      rectBottomWidth = summaryPositionNest[2] - summaryPositionNest[1];
      rectBottomX = summaryPositionNest[1];
      rectBottomY = -columnWidth / 2;
      rectWholeHeight = columnWidth;
      rectWholeWidth = summaryPositionNest[3] - summaryPositionNest[1];
      rectWholeX = summaryPositionNest[1];
      rectWholeY = -columnWidth / 2;
      topLineX1 = summaryPositionNest[0];
      topLineX2 = summaryPositionNest[0];
      bottomLineX1 = summaryPositionNest[4];
      bottomLineX2 = summaryPositionNest[4];
      midLineX1 = summaryPositionNest[2];
      midLineX2 = summaryPositionNest[2];

      summaryXYCoords.push({
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: summaryPositionNest[4],
        y: yPosition,
        value: summaryValueNest[4]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: summaryPositionNest[3],
        y: yPosition,
        value: summaryValueNest[3]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: summaryPositionNest[2],
        y: yPosition,
        value: summaryValueNest[2]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: summaryPositionNest[1],
        y: yPosition,
        value: summaryValueNest[1]
      }, {
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: summaryPositionNest[0],
        y: yPosition,
        value: summaryValueNest[0]
      });
    }

    if (projection === "radial") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledValue;
      }).sort(function (a, b) {
        return a - b;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      extentlineX1 = 0;
      extentlineX2 = 0;
      extentlineY1 = summaryPositionNest[0];
      extentlineY2 = summaryPositionNest[4];
      topLineX1 = -columnWidth / 2;
      topLineX2 = columnWidth / 2;
      midLineX1 = -columnWidth / 2;
      midLineX2 = columnWidth / 2;
      bottomLineX1 = -columnWidth / 2;
      bottomLineX2 = columnWidth / 2;
      rectTopWidth = columnWidth;
      rectTopHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectTopY = summaryPositionNest[3];
      rectTopX = -columnWidth / 2;
      rectBottomWidth = columnWidth;
      rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectBottomY = summaryPositionNest[3];
      rectBottomX = -columnWidth / 2;
      topLineY1 = summaryPositionNest[0];
      topLineY2 = summaryPositionNest[0];
      bottomLineY1 = summaryPositionNest[4];
      bottomLineY2 = summaryPositionNest[4];
      midLineY1 = summaryPositionNest[2];
      midLineY2 = summaryPositionNest[2];

      var twoPI = Math.PI * 2;

      var bottomLineArcGenerator = (0, _d3Shape.arc)().innerRadius(bottomLineY1 / 2).outerRadius(bottomLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var topLineArcGenerator = (0, _d3Shape.arc)().innerRadius(topLineY1 / 2).outerRadius(topLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var midLineArcGenerator = (0, _d3Shape.arc)().innerRadius(midLineY1 / 2).outerRadius(midLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcTopGenerator = (0, _d3Shape.arc)().innerRadius(summaryPositionNest[1] / 2).outerRadius(midLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcBottomGenerator = (0, _d3Shape.arc)().innerRadius(midLineY1 / 2).outerRadius(summaryPositionNest[3] / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcWholeGenerator = (0, _d3Shape.arc)().innerRadius(summaryPositionNest[1] / 2).outerRadius(summaryPositionNest[3] / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var startAngle = summary.pct_start + summary.pct_padding / 2;
      var endAngle = summary.pct + summary.pct_start - summary.pct_padding / 2;
      var midAngle = summary.pct / 2 + summary.pct_start;
      startAngle *= twoPI;
      endAngle *= twoPI;

      var radialAdjustX = adjustedSize[0] / 2;

      var radialAdjustY = adjustedSize[1] / 2;

      //        const bottomPoint = bottomLineArcGenerator.centroid({ startAngle, endAngle })
      //        const topPoint = topLineArcGenerator.centroid({ startAngle, endAngle })
      var bottomPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[4] / 2);
      var topPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[0] / 2);
      var thirdPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[3] / 2);
      var midPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[2] / 2);
      var firstPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[1] / 2);

      summaryXYCoords.push({
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: topPoint[0] + radialAdjustX,
        y: topPoint[1] + radialAdjustY,
        value: summaryValueNest[0]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: firstPoint[0] + radialAdjustX,
        y: firstPoint[1] + radialAdjustY,
        value: summaryValueNest[1]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: midPoint[0] + radialAdjustX,
        y: midPoint[1] + radialAdjustY,
        value: summaryValueNest[2]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: thirdPoint[0] + radialAdjustX,
        y: thirdPoint[1] + radialAdjustY,
        value: summaryValueNest[3]
      }, {
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: bottomPoint[0] + radialAdjustX,
        y: bottomPoint[1] + radialAdjustY,
        value: summaryValueNest[4]
      });
      translate = "translate(" + radialAdjustX + "," + radialAdjustY + ")";

      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          className: calculatedSummaryClass,
          transform: translate,
          key: "summaryPiece-" + summaryI,
          role: "img",
          tabIndex: -1,
          "data-o": key,
          "aria-label": key + " boxplot showing " + summaryXYCoords.filter(function (d) {
            return d.key === key;
          }).map(function (d) {
            return d.label + " " + d.value;
          })
        }),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: bottomPoint[0],
          x2: topPoint[0],
          y1: bottomPoint[1],
          y2: topPoint[1],
          style: _extends({ strokeWidth: 2 }, calculatedSummaryStyle, summaryElementStylingFn("whisker"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: topLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("max"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: midLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("median"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bottomLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("min"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcWholeGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcTopGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcBottomGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area"))
        }))
      ));
    } else {
      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          className: calculatedSummaryClass,
          transform: translate,
          key: "summaryPiece-" + summaryI,
          role: "img",
          tabIndex: -1,
          "data-o": key,
          "aria-label": key + " boxplot showing " + summaryXYCoords.filter(function (d) {
            return d.key === key;
          }).map(function (d) {
            return d.label + " " + d.value;
          }).join(", ")
        }),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: extentlineX1,
          x2: extentlineX2,
          y1: extentlineY1,
          y2: extentlineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("whisker"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: topLineX1,
          x2: topLineX2,
          y1: topLineY1,
          y2: topLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("min"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: bottomLineX1,
          x2: bottomLineX2,
          y1: bottomLineY1,
          y2: bottomLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("max"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectWholeX,
          width: rectWholeWidth,
          y: rectWholeY,
          height: rectWholeHeight,
          style: _extends({ strokeWidth: "1px" }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectTopX,
          width: rectTopWidth,
          y: rectTopY,
          height: rectTopHeight,
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectBottomX,
          width: rectBottomWidth,
          y: rectBottomY,
          height: rectBottomHeight,
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: midLineX1,
          x2: midLineX2,
          y1: midLineY1,
          y2: midLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("median"))
        }))
      ));
    }
  });

  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

function contourRenderFn(_ref2) {
  var data = _ref2.data,
      type = _ref2.type,
      renderMode = _ref2.renderMode,
      eventListenersGenerator = _ref2.eventListenersGenerator,
      styleFn = _ref2.styleFn,
      classFn = _ref2.classFn,
      adjustedSize = _ref2.adjustedSize,
      baseMarkProps = _ref2.baseMarkProps;

  var keys = Object.keys(data);
  var renderedSummaryMarks = [];
  var summaryXYCoords = [];

  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var renderValue = renderMode && renderMode(ordset, ordsetI);
    type.thresholds = type.thresholds || 8;
    type.bandwidth = type.bandwidth || 12;
    type.resolution = type.resolution || 1000;

    var projectedOrd = [{ id: ordset, _xyfCoordinates: ordset.xyData.map(contourMap) }];

    var oContours = (0, _areaDrawing.contouring)({
      areaType: type,
      data: projectedOrd,
      projectedX: "x",
      projectedY: "y",
      finalXExtent: [0, adjustedSize[0]],
      finalYExtent: [0, adjustedSize[1]]
    });
    var contourMarks = [];
    oContours.forEach(function (d, i) {
      d.coordinates.forEach(function (coords, ii) {
        var eventListeners = eventListenersGenerator(d, i);
        contourMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, eventListeners, {
          renderMode: renderValue,
          simpleInterpolate: true,
          key: i + "-" + ii,
          style: styleFn(ordset.pieceData[0].data, ordsetI),
          className: classFn(ordset.pieceData[0].data, ordsetI),
          markType: "path",
          d: "M" + d.coordinates[0].map(function (p) {
            return p.join(",");
          }).join("L") + "Z"
        })));
      });
    });

    renderedSummaryMarks.push(_react2.default.createElement(
      "g",
      {
        key: "contour-container-" + ordsetI,
        role: "img",
        tabIndex: -1,
        "data-o": key,
        "aria-label": key + " Contour plot"
      },
      contourMarks
    ));
  });
  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

function axisGenerator(axisProps, i, axisScale) {
  return _react2.default.createElement(_Axis2.default, {
    label: axisProps.label,
    key: axisProps.key || "orframe-summary-axis-" + i,
    orient: axisProps.orient,
    size: axisProps.size,
    ticks: axisProps.ticks,
    tickSize: axisProps.tickSize,
    tickFormat: axisProps.tickFormat,
    tickValues: axisProps.tickValues,
    format: axisProps.format,
    rotate: axisProps.rotate,
    scale: axisScale,
    className: axisProps.className,
    name: axisProps.name
  });
}

function bucketizedRenderingFn(_ref3) {
  var data = _ref3.data,
      type = _ref3.type,
      renderMode = _ref3.renderMode,
      eventListenersGenerator = _ref3.eventListenersGenerator,
      styleFn = _ref3.styleFn,
      classFn = _ref3.classFn,
      projection = _ref3.projection,
      adjustedSize = _ref3.adjustedSize,
      chartSize = _ref3.chartSize,
      baseMarkProps = _ref3.baseMarkProps;

  var renderedSummaryMarks = [];
  var summaryXYCoords = [];

  var buckets = type.bins || 25;
  var relativeBuckets = type.relative ? {} : false;
  var summaryValueAccessor = type.binValue || function (d) {
    return d.length;
  };
  var axisCreator = void 0;
  if (type.axis) {
    type.axis.orient = projection === "horizontal" && ["left", "right"].indexOf(type.axis.orient) === -1 ? "left" : type.axis.orient;
    type.axis.orient = projection === "vertical" && ["bottom", "top"].indexOf(type.axis.orient) === -1 ? "bottom" : type.axis.orient;
    axisCreator = axisGenerator;
    if (projection === "radial") {
      console.error("Summary axes cannot be drawn for radial histograms");
      axisCreator = function axisCreator() {
        return null;
      };
    }
  }

  var bucketSize = chartSize / buckets;

  var keys = Object.keys(data);
  var binMax = 0;
  var calculatedBins = keys.map(function (key, summaryI) {
    var summary = data[key];

    var thisSummaryData = summary.xyData;

    var xySorting = projection === "vertical" ? verticalXYSorting : horizontalXYSorting;

    var summaryPositionNest = thisSummaryData.sort(xySorting);

    var violinHist = (0, _d3Array.histogram)();
    var binDomain = projection === "vertical" ? [0, chartSize] : [0, chartSize];

    var binOffset = 0;
    var binBuckets = [];

    for (var x = 0; x < buckets; x++) {
      binBuckets.push(binDomain[0] + x / buckets * (chartSize - binOffset));
    }
    //    binBuckets.push(binDomain[1]);

    var xyValue = projection === "vertical" ? function (p) {
      return p.piece.scaledVerticalValue;
    } : function (p) {
      return p.piece.scaledValue;
    };

    var keyBins = void 0;
    if (type.useBins === false) {
      var calculatedValues = summaryPositionNest.map(function (value) {
        return xyValue(value);
      });
      keyBins = summaryPositionNest.map(function (value, i) {
        var bucketArray = [];
        bucketArray.x0 = calculatedValues[i] - 1;
        bucketArray.x1 = calculatedValues[i] + 1;
        bucketArray.push(value);
        return bucketArray;
      }).sort(function (a, b) {
        return a.x0 - b.x0;
      });
      bucketSize = 2;
    } else {
      keyBins = violinHist.domain(binDomain).thresholds(binBuckets).value(xyValue)(summaryPositionNest);
    }

    keyBins = keyBins.map(function (d) {
      return {
        y: d.x0,
        y1: d.x1 - d.x0,
        pieces: d,
        value: summaryValueAccessor(d.map(function (p) {
          return p.piece.data;
        }))
      };
    });

    if (type.type === "histogram" || type.type === "heatmap") {
      keyBins = keyBins.filter(function (d) {
        return d.value !== 0;
      });
    }

    var relativeMax = keyBins.length === 0 ? 0 : (0, _d3Array.max)(keyBins.map(function (d) {
      return d.value;
    }));
    if (relativeBuckets) {
      relativeBuckets[key] = relativeMax;
    }

    binMax = Math.max(binMax, relativeMax);

    return { bins: keyBins, summary: summary, summaryI: summaryI, thisSummaryData: thisSummaryData };
  });
  calculatedBins.forEach(function (_ref4) {
    var bins = _ref4.bins,
        summary = _ref4.summary,
        summaryI = _ref4.summaryI,
        thisSummaryData = _ref4.thisSummaryData;

    var eventListeners = eventListenersGenerator(summary, summaryI);
    var columnWidth = summary.width;
    var renderValue = renderMode && renderMode(summary, summaryI);

    var calculatedSummaryStyle = thisSummaryData[0] ? styleFn(thisSummaryData[0].piece.data, summaryI) : {};
    var calculatedSummaryClass = thisSummaryData[0] ? classFn(thisSummaryData[0].piece.data, summaryI) : "";

    var translate = [summary.middle, 0];
    if (projection === "horizontal") {
      translate = [bucketSize, summary.middle];
    } else if (projection === "radial") {
      translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
    }

    var actualMax = relativeBuckets && relativeBuckets[summary.name] || binMax;

    if (type.type === "heatmap" || type.type === "histogram") {
      var mappedBars = (0, _SvgHelper.groupBarMark)({
        bins: bins,
        binMax: binMax,
        relativeBuckets: relativeBuckets,
        columnWidth: columnWidth,
        bucketSize: bucketSize,
        projection: projection,
        adjustedSize: adjustedSize,
        chartSize: chartSize,
        summaryI: summaryI,
        data: data,
        summary: summary,
        renderValue: renderValue,
        summaryStyle: calculatedSummaryStyle,
        type: type,
        baseMarkProps: baseMarkProps
      });
      var tiles = mappedBars.marks;
      if (projection === "radial") {
        translate = [0, 0];
      }

      if (type.axis && type.type === "histogram") {
        var axisTranslate = "translate(" + summary.x + ",0)";
        var axisDomain = [0, actualMax];
        if (projection === "horizontal") {
          axisTranslate = "translate(" + bucketSize + "," + summary.x + ")";
          axisDomain = [actualMax, 0];
        } else if (projection === "radial") {
          axisTranslate = translate(0, 0);
        }

        var axisWidth = projection === "horizontal" ? adjustedSize[0] : columnWidth;
        var axisHeight = projection === "vertical" ? adjustedSize[1] : columnWidth;
        type.axis.size = [axisWidth, axisHeight];
        var axisScale = (0, _d3Scale.scaleLinear)().domain(axisDomain).range([0, columnWidth]);
        var renderedSummaryAxis = axisCreator(type.axis, summaryI, axisScale);

        renderedSummaryMarks.push(_react2.default.createElement(
          "g",
          {
            className: "summary-axis",
            key: "summaryPiece-axis-" + summaryI,
            transform: axisTranslate
          },
          renderedSummaryAxis
        ));
      }
      mappedBars.points.forEach(function (d) {
        d.x += translate[0];
        d.y += translate[1];
      });

      summaryXYCoords.push.apply(summaryXYCoords, _toConsumableArray(mappedBars.points));
      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          transform: "translate(" + translate + ")",
          key: "summaryPiece-" + summaryI,
          role: "img",
          tabIndex: -1,
          "data-o": summary.name,
          "aria-label": summary.name + " " + type.type
        }),
        tiles
      ));
    } else if (type.type === "violin") {
      bins[0].y = bins[0].y - bucketSize / 2;
      bins[bins.length - 1].y = bins[bins.length - 1].y + bucketSize / 2;
      var violinArea = (0, _d3Shape.area)().curve(type.curve || _d3Shape.curveCatmullRom);

      var violinPoints = [];

      if (projection === "horizontal") {
        bins.forEach(function (summaryPoint) {
          var xValue = summaryPoint.y - bucketSize / 2;
          var yValue = summaryPoint.value / actualMax * columnWidth / 2;

          violinPoints.push({
            x: xValue,
            y0: -yValue,
            y1: yValue
          });
          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
        violinArea.x(function (d) {
          return d.x;
        }).y0(function (d) {
          return d.y0;
        }).y1(function (d) {
          return d.y1;
        }).defined(function (d, i) {
          return d.y0 !== 0 || violinPoints[i - 1] && violinPoints[i - 1].y0 !== 0 || violinPoints[i + 1] && violinPoints[i + 1].y0 !== 0;
        });
      } else if (projection === "vertical") {
        bins.forEach(function (summaryPoint) {
          var yValue = summaryPoint.y + bucketSize / 2;
          var xValue = summaryPoint.value / actualMax * columnWidth / 2;

          violinPoints.push({
            y: yValue,
            x0: -xValue,
            x1: xValue
          });

          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
        violinArea.y(function (d) {
          return d.y;
        }).x0(function (d) {
          return d.x0;
        }).x1(function (d) {
          return d.x1;
        }).defined(function (d, i) {
          return d.x0 !== 0 || violinPoints[i - 1] && violinPoints[i - 1].x0 !== 0 || violinPoints[i + 1] && violinPoints[i + 1].x0 !== 0;
        });
      } else if (projection === "radial") {
        var angle = summary.pct - summary.pct_padding / 2;
        var midAngle = summary.pct_middle;
        violinPoints = bins;
        violinArea = function violinArea(inbins) {
          var forward = [];
          var backward = [];
          inbins.forEach(function (bin) {
            var outsidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle + angle * bin.value / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);
            var insidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle - angle * bin.value / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);

            //Ugh a terrible side effect has appeared
            summaryXYCoords.push({
              key: summary.name,
              x: insidePoint[0] + translate[0],
              y: insidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });
            summaryXYCoords.push({
              key: summary.name,
              x: outsidePoint[0] + translate[0],
              y: outsidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });

            forward.push(outsidePoint);
            backward.push(insidePoint);
          });
          return "M" + forward.map(function (d) {
            return d.join(",");
          }).join("L") + "L" + backward.reverse().map(function (d) {
            return d.join(",");
          }).join("L") + "Z";
        };
      }

      renderedSummaryMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        transform: "translate(" + translate + ")",
        key: "summaryPiece-" + summaryI
      }, eventListeners, {
        renderMode: renderValue,
        markType: "path",
        className: calculatedSummaryClass,
        style: calculatedSummaryStyle,
        d: violinArea(violinPoints),
        role: "img",
        tabIndex: -1,
        "data-o": summary.name,
        "aria-label": summary.name + " distribution"
      })));
    } else if (type.type === "joy") {
      var zeroedStart = _extends({}, bins[0], { value: 0 });
      var zeroedEnd = _extends({}, bins[bins.length - 1], { value: 0 });
      //Joy plots need to visually signify the zero baseline with their start and end position

      zeroedStart.y = zeroedStart.y - bucketSize / 2;
      zeroedEnd.y = zeroedEnd.y + bucketSize / 2;

      var joyBins = [zeroedStart].concat(_toConsumableArray(bins), [zeroedEnd]);
      var joyPoints = [];

      var joyArea = (0, _d3Shape.line)().curve(type.curve || _d3Shape.curveCatmullRom).x(function (d) {
        return d.x;
      }).y(function (d) {
        return d.y;
      });

      var joyHeight = type.amplitude || 0;

      if (projection === "horizontal") {
        joyBins.forEach(function (summaryPoint, i) {
          var xValue = summaryPoint.y - bucketSize / 2;
          var yValue = -summaryPoint.value / actualMax * (columnWidth + joyHeight) + columnWidth / 2;

          joyPoints.push({
            y: yValue,
            x: xValue
          });

          //Don't make an interaction point for the first or last
          if (i !== 0 && i !== joyBins.length - 1) {
            summaryXYCoords.push({
              key: summary.name,
              x: xValue + translate[0],
              y: yValue + translate[1],
              pieces: summaryPoint.pieces.map(function (d) {
                return d.piece;
              }),
              value: summaryPoint.value
            });
          }
        });
      } else if (projection === "vertical") {
        joyBins.forEach(function (summaryPoint) {
          var yValue = summaryPoint.y + bucketSize / 2;
          var xValue = -summaryPoint.value / actualMax * (columnWidth + joyHeight) + columnWidth / 2;

          joyPoints.push({
            y: yValue,
            x: xValue
          });

          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
      } else if (projection === "radial") {
        var _angle = summary.pct - summary.pct_padding / 2;
        var _midAngle = summary.pct_start + summary.pct_padding / 2;

        translate = [0, 0];
        joyPoints = joyBins;
        joyArea = function joyArea(inbins) {
          var forward = [];
          inbins.forEach(function (bin) {
            var outsidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([adjustedSize[0] / 2, adjustedSize[1] / 2], _midAngle + _angle * bin.value / actualMax, (bin.y + bin.y1 - bucketSize / 2) / 2);
            //Ugh a terrible side effect has appeared
            summaryXYCoords.push({
              key: summary.name,
              x: outsidePoint[0] + translate[0],
              y: outsidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });

            forward.push(outsidePoint);
          });
          return "M" + forward.map(function (d) {
            return d.join(",");
          }).join("L") + "Z";
        };
      }

      renderedSummaryMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        transform: "translate(" + translate + ")",
        key: "summaryPiece-" + summaryI
      }, eventListeners, {
        renderMode: renderValue,
        markType: "path",
        className: calculatedSummaryClass,
        style: calculatedSummaryStyle,
        d: joyArea(joyPoints),
        role: "img",
        tabIndex: -1,
        "data-o": summary.name,
        "aria-label": summary.name + " distribution"
      })));
    }
  });

  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

var drawSummaries = exports.drawSummaries = function drawSummaries(_ref5) {
  var data = _ref5.data,
      type = _ref5.type,
      renderMode = _ref5.renderMode,
      eventListenersGenerator = _ref5.eventListenersGenerator,
      styleFn = _ref5.styleFn,
      classFn = _ref5.classFn,
      positionFn = _ref5.positionFn,
      projection = _ref5.projection,
      adjustedSize = _ref5.adjustedSize,
      canvasRender = _ref5.canvasRender,
      canvasDrawing = _ref5.canvasDrawing,
      baseMarkProps = _ref5.baseMarkProps;

  if (!type || !type.type) return;
  type = typeof type === "string" ? { type: type } : type;
  var chartSize = projection === "vertical" ? adjustedSize[1] : adjustedSize[0];

  return (0, _frameFunctions.orFrameSummaryRenderer)({
    data: data,
    type: type,
    renderMode: renderMode,
    eventListenersGenerator: eventListenersGenerator,
    styleFn: styleFn,
    classFn: classFn,
    positionFn: positionFn,
    projection: projection,
    adjustedSize: adjustedSize,
    chartSize: chartSize,
    canvasRender: canvasRender,
    canvasDrawing: canvasDrawing,
    baseMarkProps: baseMarkProps
  });
};

var renderLaidOutSummaries = exports.renderLaidOutSummaries = function renderLaidOutSummaries(_ref6) {
  var data = _ref6.data;
  return data.marks;
};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascending__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__area__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noop__ = __webpack_require__(456);








var cases = [
  [],
  [[[1.0, 1.5], [0.5, 1.0]]],
  [[[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [0.5, 1.0]]],
  [[[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 0.5], [1.0, 1.5]]],
  [[[1.0, 0.5], [0.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 0.5]]],
  [[[1.0, 1.5], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.5, 1.0]]],
  [[[1.0, 1.5], [1.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 1.5]]],
  []
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      threshold = __WEBPACK_IMPORTED_MODULE_0_d3_array__["thresholdSturges"],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["extent"])(values), start = domain[0], stop = domain[1];
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(__WEBPACK_IMPORTED_MODULE_2__ascending__["a" /* default */]);
    }

    return tz.map(function(value) {
      return contour(values, value);
    });
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
        holes = [];

    isorings(values, value, function(ring) {
      smooth(ring, values, value);
      if (Object(__WEBPACK_IMPORTED_MODULE_3__area__["a" /* default */])(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__contains__["a" /* default */])((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });

    return {
      type: "MultiPolygon",
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.contour = contour;

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : __WEBPACK_IMPORTED_MODULE_6__noop__["a" /* default */], contours) : smooth === smoothLinear;
  };

  return contours;
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var array = Array.prototype;

var slice = array.slice;


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationCalloutRect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubjectRect = __webpack_require__(464);

var _SubjectRect2 = _interopRequireDefault(_SubjectRect);

var _ConnectorElbow = __webpack_require__(45);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationCalloutRect(props) {
  var className = (0, _classnames2.default)("callout rect", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectRect2.default, { width: 100, height: 100 });
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationXYThreshold;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubjectThreshold = __webpack_require__(466);

var _SubjectThreshold2 = _interopRequireDefault(_SubjectThreshold);

var _ConnectorElbow = __webpack_require__(45);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationXYThreshold(props) {
  var className = (0, _classnames2.default)("callout xythreshold", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectThreshold2.default);
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(196);


function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(481);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var projectedX = exports.projectedX = "x";
var projectedY = exports.projectedY = "y";
var projectedYMiddle = exports.projectedYMiddle = "yMiddle";
var projectedYTop = exports.projectedYTop = "yTop";
var projectedYBottom = exports.projectedYBottom = "yBottom";

/*
Use symbols for x/y/offset to avoid conflicts when projecting the dataset
But how to expose those for custom hover rules?
*/

/*
const projectedX = Symbol('x');
const projectedY = Symbol('y');
const projectedYMiddle = Symbol('y-middle');
const projectedOffset = Symbol('offset');
*/

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceCenter", function() { return __WEBPACK_IMPORTED_MODULE_0__src_center__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceCollide", function() { return __WEBPACK_IMPORTED_MODULE_1__src_collide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceLink", function() { return __WEBPACK_IMPORTED_MODULE_2__src_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return __WEBPACK_IMPORTED_MODULE_3__src_manyBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__src_radial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_simulation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceX", function() { return __WEBPACK_IMPORTED_MODULE_6__src_x__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceY", function() { return __WEBPACK_IMPORTED_MODULE_7__src_y__["a"]; });










/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = x;
/* harmony export (immutable) */ __webpack_exports__["c"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(79);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ __webpack_exports__["a"] = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["map"])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["c" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// combine 2 matrixes
// m1, m2 - [a, b, c, d, e, g]
//
function combine(m1, m2) {
  return [
    m1[0] * m2[0] + m1[2] * m2[1],
    m1[1] * m2[0] + m1[3] * m2[1],
    m1[0] * m2[2] + m1[2] * m2[3],
    m1[1] * m2[2] + m1[3] * m2[3],
    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
  ];
}


function Matrix() {
  if (!(this instanceof Matrix)) { return new Matrix(); }
  this.queue = [];   // list of matrixes to apply
  this.cache = null; // combined matrix cache
}


Matrix.prototype.matrix = function (m) {
  if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0) {
    return this;
  }
  this.cache = null;
  this.queue.push(m);
  return this;
};


Matrix.prototype.translate = function (tx, ty) {
  if (tx !== 0 || ty !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, 0, 1, tx, ty ]);
  }
  return this;
};


Matrix.prototype.scale = function (sx, sy) {
  if (sx !== 1 || sy !== 1) {
    this.cache = null;
    this.queue.push([ sx, 0, 0, sy, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.rotate = function (angle, rx, ry) {
  var rad, cos, sin;

  if (angle !== 0) {
    this.translate(rx, ry);

    rad = angle * Math.PI / 180;
    cos = Math.cos(rad);
    sin = Math.sin(rad);

    this.queue.push([ cos, sin, -sin, cos, 0, 0 ]);
    this.cache = null;

    this.translate(-rx, -ry);
  }
  return this;
};


Matrix.prototype.skewX = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, Math.tan(angle * Math.PI / 180), 1, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.skewY = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, Math.tan(angle * Math.PI / 180), 0, 1, 0, 0 ]);
  }
  return this;
};


// Flatten queue
//
Matrix.prototype.toArray = function () {
  if (this.cache) {
    return this.cache;
  }

  if (!this.queue.length) {
    this.cache = [ 1, 0, 0, 1, 0, 0 ];
    return this.cache;
  }

  this.cache = this.queue[0];

  if (this.queue.length === 1) {
    return this.cache;
  }

  for (var i = 1; i < this.queue.length; i++) {
    this.cache = combine(this.cache, this.queue[i]);
  }

  return this.cache;
};


// Apply list of matrixes to (x,y) point.
// If `isRelative` set, `translate` component of matrix will be skipped
//
Matrix.prototype.calc = function (x, y, isRelative) {
  var m;

  // Don't change point on empty transforms queue
  if (!this.queue.length) { return [ x, y ]; }

  // Calculate final matrix, if not exists
  //
  // NB. if you deside to apply transforms to point one-by-one,
  // they should be taken in reverse order

  if (!this.cache) {
    this.cache = this.toArray();
  }

  m = this.cache;

  // Apply matrix to point
  return [
    x * m[0] + y * m[2] + (isRelative ? 0 : m[4]),
    x * m[1] + y * m[3] + (isRelative ? 0 : m[5])
  ];
};


module.exports = Matrix;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _XYFrame = __webpack_require__(34);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _MiniMap = __webpack_require__(108);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var MinimapXYFrame = function (_React$Component) {
  _inherits(MinimapXYFrame, _React$Component);

  function MinimapXYFrame(props) {
    _classCallCheck(this, MinimapXYFrame);

    var _this = _possibleConstructorReturn(this, (MinimapXYFrame.__proto__ || Object.getPrototypeOf(MinimapXYFrame)).call(this, props));

    _this.generateMinimap = _this.generateMinimap.bind(_this);
    return _this;
  }

  _createClass(MinimapXYFrame, [{
    key: "generateMinimap",
    value: function generateMinimap() {
      var miniDefaults = {
        title: "",
        position: [0, 0],
        size: [this.props.size[0], this.props.size[1] * 0.25],
        xAccessor: this.props.xAccessor,
        yAccessor: this.props.yAccessor,
        points: this.props.points,
        lines: this.props.lines,
        areas: this.props.areas,
        lineDataAccessor: this.props.lineDataAccessor,
        xBrushable: true,
        yBrushable: true,
        brushStart: function brushStart() {},
        brush: function brush() {},
        brushEnd: function brushEnd() {},
        lineType: this.props.lineType
      };

      var combinedOptions = _extends(miniDefaults, this.props.minimap);

      combinedOptions.hoverAnnotation = false;

      return _react2.default.createElement(_MiniMap2.default, combinedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var miniMap = this.generateMinimap();
      var options = {};

      var _props = this.props,
          minimap = _props.minimap,
          renderBefore = _props.renderBefore,
          rest = _objectWithoutProperties(_props, ["minimap", "renderBefore"]);

      if (renderBefore) {
        options.beforeElements = miniMap;
      } else {
        options.afterElements = miniMap;
      }

      return _react2.default.createElement(_XYFrame2.default, _extends({}, rest, options));
    }
  }]);

  return MinimapXYFrame;
}(_react2.default.Component);

MinimapXYFrame.propTypes = {
  size: _propTypes2.default.array,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  points: _propTypes2.default.array,
  lines: _propTypes2.default.array,
  areas: _propTypes2.default.array,
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minimap: _propTypes2.default.object,
  renderBefore: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = MinimapXYFrame;
module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(38);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(111);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(60);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.left = left;
exports.right = right;
exports.justify = justify;
exports.center = center;

var _d3Array = __webpack_require__(2);

// For a given link, return the target node's depth
function targetDepth(d) {
  return d.target.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'left'
function left(node) {
  return node.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'right'
function right(node, n) {
  return n - 1 - node.height;
}

// The depth of a node when the nodeAlign (align) is set to 'justify'
function justify(node, n) {
  return node.sourceLinks.length ? node.depth : n - 1;
}

// The depth of a node when the nodeAlign (align) is set to 'center'
function center(node) {
  return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, _d3Array.min)(node.sourceLinks, targetDepth) - 1 : 0;
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(215);
module.exports = __webpack_require__(220);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(216).enable();
  window.Promise = __webpack_require__(218);
}

// fetch() polyfill for making API calls.
__webpack_require__(219);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(39);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(113);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(113);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(231);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(39),n=__webpack_require__(62),p=__webpack_require__(63),q=__webpack_require__(40),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(223);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(62),ca=__webpack_require__(0),m=__webpack_require__(224),p=__webpack_require__(39),v=__webpack_require__(40),da=__webpack_require__(225),ea=__webpack_require__(226),fa=__webpack_require__(227),ha=__webpack_require__(63);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(228);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(229);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Crashes__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resize_detector__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pym_js__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pym_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pym_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pymChild=new __WEBPACK_IMPORTED_MODULE_4_pym_js___default.a.Child();var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'_onResize',value:function _onResize(){pymChild.sendHeight();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Crashes__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_resize_detector___default.a,{handleWidth:true,handleHeight:true,onResize:this._onResize}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_xmas_locations_json__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_xmas_locations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_xmas_locations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semiotic__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_semiotic__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const fatal = data.filter(({severity}) => severity === "Fatal")
// const serious = data.filter(({severity}) => severity === "Serious Injury")
// const minor = data.filter(({severity}) => severity === "Minor Injury")
// const noninjury = data.filter(({severity}) => severity === "Non-injury")
var StepChart=function(_Component){_inherits(StepChart,_Component);function StepChart(){_classCallCheck(this,StepChart);return _possibleConstructorReturn(this,(StepChart.__proto__||Object.getPrototypeOf(StepChart)).apply(this,arguments));}_createClass(StepChart,[{key:"render",value:function render(){var width=Math.min(window.innerWidth-20,400);var height=1.25*width;var common={xExtent:[0,924876],yExtent:[0,1426115],size:[width,height],xAccessor:function xAccessor(d){return d.x;},yAccessor:function yAccessor(d){return d.y;},hoverAnnotation:true,tooltipContent:function tooltipContent(d){var extra={};if(d.voronoiX<100){extra={left:-d.voronoiX-10+"px"};}else if(d.voronoiX>width-100){extra={left:-180+width-d.voronoiX+"px"};}if(d.voronoiY<100){extra['top']='100px';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tooltip-content",style:Object.assign({},extra,{backgroundColor:d.color,color:d.severity==='Fatal'?'white':'#111'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"100%",display:"flex",justifyContent:"space-between",paddingBottom:"6px",marginBottom:"6px",borderBottom:"1px solid "+(d.severity==='Fatal'?'white':'#111')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Severity"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{whiteSpace:"nowrap",marginLeft:"1em"}}," ",d.severity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"100%",display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Year")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," ",d.year)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"100%",display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{whiteSpace:"nowrap",marginLeft:"1em"}}," ",d.vehicles))));},pointStyle:function pointStyle(d){return{fill:d.color};}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semiotic__["XYFrame"],Object.assign({},common,{points:__WEBPACK_IMPORTED_MODULE_1__store_xmas_locations_json___default.a,legend:{position:'left',title:'Crash Severity',legendGroups:[{styleFn:function styleFn(d){return{fill:d.color};},items:[{label:"Fatal",color:"#8b0000"},{label:"Serious injury",color:"#de3f53"},{label:"Minor Injury",color:"#ffa500"},{label:"Non-injury",color:"lightgrey"}]}]}})));}}]);return StepChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StepChart);/*
 *false ?
      <div style={{position: 'relative'}}>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={noninjury}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={minor}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={serious}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={fatal}
          />
        </div>
      </div>
      :
      */

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = [{"x":594806,"y":1134384,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589626,"y":1134379,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590395,"y":1128609,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581592,"y":1130623,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721908,"y":989705,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516867,"y":619631,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689045,"y":981102,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565068,"y":1222959,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688600,"y":994929,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517320,"y":620947,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715133,"y":1034573,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787664,"y":997508,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688480,"y":905029,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786479,"y":1007051,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714539,"y":1036825,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596187,"y":1136559,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680464,"y":1102022,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598409,"y":1189025,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704186,"y":929566,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":605319,"y":1123770,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719551,"y":1043516,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517588,"y":1327154,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786441,"y":1007064,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584886,"y":1155122,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704654,"y":929504,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602008,"y":1121796,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730121,"y":1028916,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731174,"y":967191,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688361,"y":980158,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793802,"y":1000633,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520372,"y":1339229,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":422079,"y":681369,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657003,"y":744520,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518225,"y":619783,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524612,"y":632932,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":791081,"y":1006658,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643015,"y":898462,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":442783,"y":654692,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630335,"y":716425,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":427965,"y":679689,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762255,"y":824030,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585912,"y":643159,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630390,"y":662977,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460432,"y":646699,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720611,"y":1040156,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632096,"y":661730,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420870,"y":624505,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586167,"y":642845,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768578,"y":788716,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873621,"y":924829,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873369,"y":926832,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596896,"y":652409,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660432,"y":678821,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591633,"y":661033,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631098,"y":715381,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606077,"y":1121891,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719362,"y":990903,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595954,"y":642488,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713773,"y":1029805,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656203,"y":759489,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770519,"y":834657,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596791,"y":649860,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650832,"y":734774,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673088,"y":861249,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":809091,"y":883174,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722163,"y":989696,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593275,"y":1129134,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485365,"y":648301,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460415,"y":647575,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674241,"y":1075976,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668050,"y":1119756,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686398,"y":1071360,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641475,"y":1042690,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664941,"y":1097384,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650410,"y":1010499,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634820,"y":1004546,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654053,"y":1019623,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686142,"y":902623,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625699,"y":972723,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719951,"y":992331,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681038,"y":1000803,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705759,"y":1019396,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703132,"y":1043124,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744747,"y":1030242,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730827,"y":1028489,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694625,"y":1054847,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680556,"y":986719,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":732280,"y":987148,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722154,"y":990041,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":735122,"y":904096,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682233,"y":1018727,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637959,"y":1089545,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689548,"y":1075824,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631723,"y":1024552,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686142,"y":902623,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593911,"y":1136114,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589404,"y":1141263,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603189,"y":1134189,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596305,"y":1142074,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581110,"y":1132942,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607335,"y":1130681,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580576,"y":1136815,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605804,"y":1122102,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592459,"y":1137704,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595595,"y":1133672,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604052,"y":1119871,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592474,"y":1091981,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583700,"y":1132490,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582768,"y":1132457,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583813,"y":1133943,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591178,"y":1141574,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592455,"y":1137774,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592556,"y":1138011,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586970,"y":1149890,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605224,"y":1117404,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602776,"y":1117565,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536328,"y":1311066,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553086,"y":1281858,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608825,"y":1110895,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607504,"y":1114576,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604917,"y":1117596,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588919,"y":1142778,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609211,"y":1114196,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595834,"y":1134617,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596838,"y":1129016,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602919,"y":1136189,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605112,"y":1115273,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609723,"y":1106538,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594481,"y":1136227,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532543,"y":1218254,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":465037,"y":1338628,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597983,"y":1129934,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600566,"y":1121289,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594651,"y":1136795,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588938,"y":1151837,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589765,"y":1128427,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706941,"y":930766,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595507,"y":1134423,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687471,"y":1073335,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630363,"y":1026507,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698144,"y":1047222,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560970,"y":1257556,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590565,"y":1130777,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712868,"y":1040553,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714067,"y":1012554,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719843,"y":1043512,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627502,"y":1069550,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641703,"y":1006820,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637525,"y":1037330,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686231,"y":1124741,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672361,"y":1101790,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657681,"y":1124083,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645799,"y":1035870,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640809,"y":1082301,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637548,"y":1031868,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637347,"y":1031741,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722306,"y":988675,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721826,"y":989813,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":785612,"y":1008021,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":792107,"y":1004519,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786313,"y":1007082,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692559,"y":1092210,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690403,"y":1091606,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665327,"y":1097655,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692396,"y":1094864,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":818009,"y":969320,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640812,"y":1012700,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642291,"y":1006848,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722339,"y":989578,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669521,"y":1100310,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687202,"y":1020511,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629264,"y":979770,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624023,"y":978630,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628119,"y":969921,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628249,"y":1003112,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662873,"y":1140192,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673594,"y":1018456,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646631,"y":1024484,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684400,"y":1127917,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629073,"y":996342,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675432,"y":1130945,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636619,"y":1040641,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603735,"y":1029336,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692800,"y":1067048,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629803,"y":987318,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682040,"y":1013489,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704163,"y":930375,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687799,"y":980152,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704328,"y":929631,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705444,"y":928346,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711932,"y":939878,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678986,"y":1010147,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688458,"y":983631,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717666,"y":1041999,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725481,"y":1036192,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687379,"y":987820,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":804864,"y":1000016,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813711,"y":997100,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678634,"y":952693,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721908,"y":989705,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721765,"y":990046,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726307,"y":990405,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725365,"y":1037756,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713109,"y":1038160,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718406,"y":1044979,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700503,"y":1024983,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716424,"y":1041420,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718575,"y":1044536,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721626,"y":1040406,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721339,"y":1041223,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640095,"y":1030159,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635975,"y":1034234,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718973,"y":989498,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647208,"y":1024063,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624924,"y":1074123,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633908,"y":1035960,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717405,"y":1036618,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713140,"y":1040623,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639061,"y":1030801,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594847,"y":1136741,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699521,"y":1002475,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642655,"y":1049480,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659872,"y":1045005,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661212,"y":1120300,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580882,"y":1139585,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604626,"y":1120954,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":594591,"y":1128375,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603133,"y":1121612,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601127,"y":1121401,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583814,"y":1133963,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580157,"y":1138329,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605063,"y":1127936,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595907,"y":1134846,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598298,"y":1132672,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595156,"y":1133186,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626500,"y":1094519,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604758,"y":1120652,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595587,"y":1134034,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600486,"y":1126274,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585667,"y":1177020,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592371,"y":1130407,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594811,"y":1129597,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588717,"y":1131851,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592206,"y":1146071,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593016,"y":1132713,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589824,"y":1130078,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593249,"y":1136343,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603354,"y":1121168,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601008,"y":1122644,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606670,"y":1115827,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604015,"y":1117906,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595993,"y":1128192,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584859,"y":1138850,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604235,"y":1126554,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585936,"y":1186203,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582547,"y":1132899,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590997,"y":1134267,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512195,"y":1315226,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529446,"y":1310235,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599888,"y":1133277,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606140,"y":1127633,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573221,"y":1200266,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609224,"y":1123457,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595435,"y":1143675,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573962,"y":1198200,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581712,"y":1125388,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586736,"y":1132890,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524094,"y":1302991,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556458,"y":1261494,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557570,"y":1261732,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536119,"y":1302095,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555867,"y":1264979,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603555,"y":1124672,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602301,"y":1124187,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597335,"y":1124863,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602543,"y":1132733,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596377,"y":1131543,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591009,"y":1134377,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594099,"y":1136606,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594987,"y":1134546,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531548,"y":1311241,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502792,"y":1310789,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533924,"y":1300326,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536837,"y":1310850,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557102,"y":1262463,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556338,"y":1268868,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604623,"y":1121805,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596426,"y":1132688,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601150,"y":1128520,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582234,"y":1133771,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591097,"y":1147636,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596857,"y":1132248,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593046,"y":1151829,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599323,"y":1129719,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590083,"y":1151110,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617857,"y":1132763,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585160,"y":1135342,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594568,"y":1134803,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583531,"y":1125659,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605510,"y":1122023,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564814,"y":1225920,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555590,"y":1261127,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542498,"y":1287292,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609745,"y":1117447,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591877,"y":1161005,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596187,"y":1136559,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592903,"y":1133971,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586091,"y":1186758,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607921,"y":1113245,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617700,"y":1142752,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633547,"y":1031730,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588894,"y":1133232,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593255,"y":1135390,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608762,"y":1125665,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601599,"y":1130918,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611370,"y":1125520,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596999,"y":1128280,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607879,"y":1131635,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596705,"y":1126273,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589673,"y":1149344,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611949,"y":1103776,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595937,"y":1127787,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593799,"y":1134505,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590444,"y":1143029,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590391,"y":1162637,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595483,"y":1142114,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589488,"y":1146376,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589720,"y":1149625,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590582,"y":1130173,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586645,"y":1134087,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592699,"y":1140691,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600352,"y":1136340,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594497,"y":1159817,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607102,"y":1125867,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611860,"y":1107473,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605794,"y":1125769,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610202,"y":1107490,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614194,"y":1108792,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611949,"y":1103776,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592476,"y":1137770,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601064,"y":1128569,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592562,"y":1129309,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596488,"y":1122668,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601107,"y":1126074,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579210,"y":1146739,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593350,"y":1133901,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595580,"y":1144502,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599002,"y":1136044,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592405,"y":1148874,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581033,"y":1163593,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596469,"y":1132634,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613076,"y":1098260,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595503,"y":1134211,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607076,"y":1116517,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606208,"y":1127541,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600091,"y":1128956,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568665,"y":1135773,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593714,"y":1136555,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583233,"y":1136354,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607241,"y":1130468,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714738,"y":1037848,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556016,"y":1264564,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519782,"y":1304367,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556719,"y":1268493,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599090,"y":1124557,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601451,"y":1125001,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594160,"y":1136358,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523375,"y":1246595,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586689,"y":1161834,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560382,"y":1260019,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593357,"y":1140138,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602647,"y":1133056,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616525,"y":1131241,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542586,"y":1287172,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585975,"y":1128454,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584700,"y":1130799,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610411,"y":1115629,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":538835,"y":1307476,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605542,"y":1122319,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593226,"y":1136550,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603453,"y":1115873,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1135190,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594902,"y":1136535,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604528,"y":1123322,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589353,"y":1129852,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590594,"y":1129173,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594460,"y":1136479,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592779,"y":1135977,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566784,"y":1156007,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593657,"y":1134391,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":463272,"y":1305905,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":507581,"y":1331791,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768696,"y":821877,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774030,"y":812186,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770486,"y":824493,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873016,"y":926765,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452378,"y":639876,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526119,"y":635269,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872735,"y":925768,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768292,"y":834973,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622683,"y":663516,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643086,"y":660498,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437830,"y":667249,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":869276,"y":932027,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593226,"y":660631,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769041,"y":823150,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585740,"y":643236,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590544,"y":639785,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590142,"y":640992,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516996,"y":619986,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459074,"y":646690,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772462,"y":850035,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":796093,"y":919087,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":472592,"y":657039,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":784614,"y":883057,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433999,"y":671439,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762705,"y":819226,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533785,"y":893455,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594056,"y":663844,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516831,"y":620109,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606208,"y":684703,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680630,"y":815590,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669969,"y":751888,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554335,"y":884801,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651828,"y":748877,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641639,"y":724341,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619285,"y":701611,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768209,"y":822064,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":436739,"y":663510,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599922,"y":670459,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597663,"y":650670,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592994,"y":807279,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593921,"y":650450,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593004,"y":660598,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460942,"y":646663,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638168,"y":745141,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586468,"y":643431,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558949,"y":899471,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":884753,"y":925929,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":879384,"y":922865,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":879718,"y":923149,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594052,"y":665400,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523851,"y":646446,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594703,"y":651514,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595299,"y":650659,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597663,"y":650670,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598155,"y":663504,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":882765,"y":925284,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875554,"y":923586,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452355,"y":639857,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461868,"y":647632,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611539,"y":661826,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610075,"y":661284,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762572,"y":823209,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819700,"y":886415,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765088,"y":817792,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661368,"y":678375,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660735,"y":679211,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773291,"y":837144,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517503,"y":624324,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517536,"y":619826,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457426,"y":643643,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452555,"y":639045,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662254,"y":680648,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":850951,"y":881542,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":905435,"y":994689,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772069,"y":838259,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":783309,"y":876839,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597261,"y":652256,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602814,"y":657937,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606115,"y":683670,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680971,"y":680578,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":739897,"y":781922,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459571,"y":645439,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":782747,"y":878063,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":782747,"y":878063,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460335,"y":647627,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591553,"y":663873,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454170,"y":640454,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":436939,"y":663503,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459332,"y":645820,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374243,"y":551650,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460713,"y":646676,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457458,"y":645662,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874431,"y":924508,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875029,"y":923855,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875490,"y":923885,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":884753,"y":925929,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864708,"y":940092,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873649,"y":925166,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":879391,"y":922871,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592315,"y":659743,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514947,"y":621426,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502614,"y":627418,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515498,"y":620117,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517389,"y":629335,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768782,"y":832344,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483287,"y":658912,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774212,"y":837226,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597796,"y":653536,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595251,"y":662931,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594341,"y":660260,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438315,"y":672537,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457291,"y":643943,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600772,"y":655131,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602738,"y":661114,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658602,"y":746018,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630936,"y":716515,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649797,"y":768375,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514046,"y":844701,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548286,"y":861092,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660272,"y":747029,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656645,"y":791955,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617618,"y":699409,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611415,"y":794577,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630582,"y":716728,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639247,"y":727186,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530899,"y":892363,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675069,"y":752316,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614703,"y":792817,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630196,"y":716257,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630226,"y":716294,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546845,"y":839475,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565718,"y":815266,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633307,"y":832298,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644129,"y":867132,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543766,"y":898866,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640152,"y":906064,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658909,"y":745005,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660626,"y":745920,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768988,"y":835014,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457693,"y":644323,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":538917,"y":881750,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660486,"y":747245,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678170,"y":733982,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619283,"y":701606,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594008,"y":806873,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660929,"y":752954,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671678,"y":755643,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655478,"y":761466,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659472,"y":747632,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":815597,"y":886930,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613027,"y":662624,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543807,"y":898798,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":534420,"y":893862,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577470,"y":930064,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654712,"y":843383,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671274,"y":752120,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655082,"y":760486,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660763,"y":746272,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770290,"y":835047,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594307,"y":660239,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586090,"y":642358,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773877,"y":836621,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":775641,"y":810707,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770156,"y":845658,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661816,"y":678379,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517185,"y":619806,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661355,"y":744358,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872909,"y":925093,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":746410,"y":791057,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588170,"y":650887,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":110287,"y":78876,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":496083,"y":519000,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242981,"y":130721,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":189405,"y":83173,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":65599,"y":10000,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":55159,"y":87660,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404911,"y":399075,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410854,"y":420902,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":385949,"y":396820,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":377541,"y":364449,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399250,"y":391002,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412489,"y":397240,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80960,"y":64928,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336396,"y":355675,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131418,"y":259757,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130917,"y":259681,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":108712,"y":226884,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":88976,"y":217325,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":70521,"y":86166,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409541,"y":403529,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297094,"y":300490,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":145878,"y":48105,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":284019,"y":261753,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79042,"y":65849,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244085,"y":131044,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":143541,"y":322020,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":133092,"y":219329,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":303199,"y":518030,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":171349,"y":273846,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135380,"y":219832,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278773,"y":222163,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":104725,"y":191551,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290548,"y":514896,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289770,"y":514097,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243216,"y":133270,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243522,"y":130109,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":253460,"y":161599,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405103,"y":421571,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411701,"y":393252,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":186216,"y":282388,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":229062,"y":129205,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242840,"y":131738,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242062,"y":130082,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":128675,"y":108069,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137701,"y":42118,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243405,"y":132470,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95050,"y":220153,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":97837,"y":226277,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80849,"y":63092,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89936,"y":166649,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":66047,"y":10655,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408288,"y":397914,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405453,"y":392381,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320676,"y":592448,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":270283,"y":484617,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95274,"y":220857,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":197460,"y":286986,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95441,"y":220651,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149564,"y":192867,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404213,"y":395864,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":340014,"y":354175,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":134123,"y":259581,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131083,"y":259205,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":308206,"y":375708,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336749,"y":354233,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403975,"y":398582,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408763,"y":384001,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404326,"y":395876,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408557,"y":397756,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":107432,"y":226062,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243180,"y":129892,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79577,"y":66065,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":386610,"y":388717,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409065,"y":413538,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403457,"y":399793,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413698,"y":393145,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387427,"y":389604,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":34496,"y":199504,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493243,"y":521524,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407123,"y":404379,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405579,"y":399715,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407803,"y":397291,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243373,"y":133115,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268129,"y":214379,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":74625,"y":60856,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79827,"y":66724,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82443,"y":153995,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296870,"y":300011,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":118542,"y":222214,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296819,"y":303567,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242931,"y":131511,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95397,"y":220872,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407803,"y":397291,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400994,"y":395162,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":140108,"y":224923,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":140108,"y":224923,"year":"2011","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402495,"y":394810,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434124,"y":370007,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413262,"y":398359,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407713,"y":406302,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406091,"y":392182,"year":"2011","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460299,"y":645627,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457648,"y":644866,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793745,"y":1000674,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438181,"y":667061,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515003,"y":620309,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450431,"y":638258,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459621,"y":647120,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659641,"y":747726,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769064,"y":832274,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767139,"y":820332,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661326,"y":746724,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":780482,"y":809494,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657287,"y":743683,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659079,"y":745249,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659262,"y":744363,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772334,"y":834784,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671350,"y":752528,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650741,"y":742868,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772930,"y":834718,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771768,"y":838080,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771089,"y":835138,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659117,"y":755633,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670969,"y":751715,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793856,"y":1000608,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773954,"y":835399,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770715,"y":835336,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773311,"y":837149,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659456,"y":744457,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765212,"y":823016,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767204,"y":821255,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766755,"y":816711,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612410,"y":795044,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":612369,"y":794265,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773952,"y":838407,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596758,"y":663772,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600578,"y":646866,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600099,"y":646355,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555991,"y":1267083,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772369,"y":835376,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716018,"y":1035101,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603917,"y":687164,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657898,"y":744743,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640267,"y":765765,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585502,"y":643319,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588839,"y":650168,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676839,"y":732572,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586094,"y":644542,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650874,"y":672740,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656397,"y":761115,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":545473,"y":898394,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520142,"y":886460,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597321,"y":650769,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660250,"y":746187,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524259,"y":646813,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643110,"y":664407,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":443715,"y":643686,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730333,"y":996661,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626505,"y":710740,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461287,"y":646955,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588631,"y":649757,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700667,"y":760538,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716669,"y":1040362,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597511,"y":649465,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593646,"y":659904,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588803,"y":639561,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586364,"y":640948,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":385137,"y":589059,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":424010,"y":673277,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434081,"y":671292,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770689,"y":839377,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":380188,"y":588308,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594018,"y":651984,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597254,"y":652616,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600535,"y":653570,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593998,"y":663828,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716310,"y":1036182,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658267,"y":678154,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596167,"y":1119375,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607336,"y":793063,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715794,"y":1009610,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600196,"y":675001,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277397,"y":219859,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493149,"y":521823,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709968,"y":1039084,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610439,"y":792913,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460386,"y":646938,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":552293,"y":1313433,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337483,"y":354916,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595648,"y":806313,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":798606,"y":910428,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402043,"y":598235,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387936,"y":597101,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577811,"y":1127305,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872608,"y":925313,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640236,"y":766163,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590658,"y":658247,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594069,"y":650386,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660695,"y":680148,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593107,"y":1135283,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666687,"y":842878,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607828,"y":660930,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597170,"y":652688,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589827,"y":657210,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517232,"y":620436,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586854,"y":646589,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612792,"y":793468,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590626,"y":654174,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655698,"y":1161798,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585779,"y":643218,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871620,"y":926215,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674409,"y":749573,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661148,"y":679557,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539779,"y":892141,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704589,"y":765260,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589097,"y":648224,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532195,"y":892735,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601652,"y":662315,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589754,"y":1149612,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614639,"y":680717,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588935,"y":651379,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":563500,"y":814469,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585888,"y":641169,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596734,"y":652297,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609341,"y":791910,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515578,"y":620339,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585324,"y":1130140,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628097,"y":713647,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456376,"y":472202,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407318,"y":396780,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411084,"y":399025,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404576,"y":395430,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409417,"y":398938,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409137,"y":397979,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603394,"y":1132542,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567212,"y":1245604,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596166,"y":1128541,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":238976,"y":435845,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408296,"y":396302,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153871,"y":198275,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677399,"y":819554,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":109885,"y":227171,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243371,"y":132757,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634160,"y":1032201,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":31616,"y":74101,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":274875,"y":231376,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320382,"y":341603,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130635,"y":260560,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82605,"y":67548,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672287,"y":1101547,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410331,"y":394788,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407814,"y":395572,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":395189,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408540,"y":396182,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407101,"y":396052,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408538,"y":396425,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401944,"y":390681,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":169864,"y":274093,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":395256,"y":395011,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405824,"y":395568,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408051,"y":396664,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403886,"y":398773,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411803,"y":396586,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397164,"y":397389,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404385,"y":421634,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409636,"y":400192,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404899,"y":401295,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483880,"y":656426,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399570,"y":397456,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401683,"y":378125,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397930,"y":499924,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407924,"y":397292,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":736432,"y":1026861,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":91491,"y":70530,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412653,"y":397369,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400454,"y":394748,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290327,"y":514919,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":271405,"y":484367,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226496,"y":420233,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":209129,"y":410501,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405721,"y":400374,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729054,"y":1000283,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605832,"y":1121332,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294490,"y":330020,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765674,"y":822063,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687826,"y":985786,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297116,"y":304049,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769342,"y":819340,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337278,"y":354713,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208864,"y":125817,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704214,"y":930164,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297696,"y":298223,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707810,"y":927437,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592753,"y":1129260,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79652,"y":65020,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79462,"y":65918,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408778,"y":394088,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660033,"y":746998,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607049,"y":1115417,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727832,"y":1034713,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242151,"y":133789,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":230578,"y":129878,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715711,"y":1038973,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721339,"y":1041223,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243678,"y":132762,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242461,"y":133743,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243306,"y":133047,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243547,"y":130032,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399168,"y":394782,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483311,"y":658847,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297478,"y":298579,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298199,"y":298595,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":296380,"y":299989,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452378,"y":639876,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296658,"y":304027,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80654,"y":66351,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243584,"y":132874,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625893,"y":1071066,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":27899,"y":184058,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406039,"y":392626,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412862,"y":398119,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602855,"y":677414,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":105931,"y":225140,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594030,"y":663809,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":270855,"y":207645,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":436178,"y":366800,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406856,"y":370973,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149409,"y":166492,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":280204,"y":229868,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":345217,"y":417737,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689073,"y":1074017,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":369810,"y":528969,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612349,"y":793824,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590795,"y":1144084,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320842,"y":592879,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412032,"y":400476,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409556,"y":395703,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202342,"y":103539,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240998,"y":128946,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123377,"y":103179,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412058,"y":388239,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243291,"y":131015,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296796,"y":300888,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":393860,"y":388765,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412543,"y":397275,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":350417,"y":401261,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":148830,"y":175252,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241914,"y":131452,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":116936,"y":225991,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":439780,"y":375300,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586763,"y":646302,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630931,"y":1091493,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630219,"y":1022593,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660035,"y":678664,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669378,"y":1100298,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641508,"y":1042784,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661702,"y":1013119,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628273,"y":974787,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687274,"y":1110983,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707014,"y":936511,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714484,"y":1039795,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682904,"y":899264,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720561,"y":990894,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813579,"y":999941,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705870,"y":1030016,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725248,"y":1018940,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716396,"y":1041496,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625999,"y":971275,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653202,"y":1042182,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627305,"y":1055105,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644893,"y":1087932,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713042,"y":1036682,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718181,"y":1005725,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578603,"y":1134912,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590391,"y":1162637,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603323,"y":1122201,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593969,"y":1135491,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586283,"y":1128647,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574311,"y":1272759,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543608,"y":1217602,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617903,"y":1132606,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604997,"y":1119920,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592668,"y":1160902,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604608,"y":1120946,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581888,"y":1124901,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598154,"y":1135883,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596391,"y":1119455,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595008,"y":1128147,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607295,"y":1124991,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593330,"y":1143687,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591503,"y":1145231,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595480,"y":1143148,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603622,"y":1129274,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603048,"y":1119260,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557204,"y":1264148,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598185,"y":1123340,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601239,"y":1131037,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594196,"y":1135462,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578622,"y":1217350,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584404,"y":1129633,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591593,"y":1133773,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580787,"y":1125855,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591470,"y":1149961,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":496960,"y":1292094,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555349,"y":1267680,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515598,"y":1238164,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594159,"y":1136119,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590147,"y":1131315,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605282,"y":1116854,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595313,"y":1136602,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602543,"y":1132746,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582716,"y":1136821,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590789,"y":1129880,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":583166,"y":1128595,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594811,"y":1129597,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592695,"y":1193934,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583406,"y":1130038,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596110,"y":1123277,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539777,"y":1288500,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590816,"y":1148166,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131980,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601450,"y":1124999,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591228,"y":1146027,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566471,"y":1243183,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566381,"y":1217556,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597025,"y":1127820,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600405,"y":1129691,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600246,"y":1122675,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601476,"y":1130957,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594782,"y":1134420,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593089,"y":1135736,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603095,"y":1123861,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598920,"y":1122586,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572808,"y":1125857,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591309,"y":1091158,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606695,"y":1105654,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600866,"y":1124912,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606486,"y":1123482,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1143268,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592746,"y":1145055,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602201,"y":1120704,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601050,"y":1123082,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605832,"y":1121332,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612461,"y":1090204,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587010,"y":1128759,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581439,"y":1139554,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555484,"y":1259922,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593115,"y":1142782,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556743,"y":1261593,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556855,"y":1268353,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596672,"y":1123389,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600980,"y":1129008,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594389,"y":1136994,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694847,"y":1055578,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596857,"y":1140919,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590511,"y":1130273,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597448,"y":1138348,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590575,"y":1149269,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554624,"y":1259558,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720412,"y":991423,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585634,"y":1184800,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594351,"y":1135878,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605341,"y":1123885,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582622,"y":1125415,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592364,"y":1144798,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":738709,"y":901931,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745364,"y":1010214,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":760954,"y":993777,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718320,"y":1045074,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716399,"y":1035815,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636385,"y":1029311,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641374,"y":1087167,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642796,"y":1003851,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638846,"y":1033362,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640219,"y":1030192,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637487,"y":1037664,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637765,"y":1031129,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626360,"y":1070963,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654272,"y":1031603,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651674,"y":1036755,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664245,"y":1099549,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683159,"y":1071482,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690403,"y":1091606,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629767,"y":950800,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682583,"y":1002697,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626775,"y":1042492,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595296,"y":1019320,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659943,"y":1045481,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730284,"y":1028839,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641783,"y":1108237,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694853,"y":1056039,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675715,"y":875626,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":737751,"y":902880,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716623,"y":1040496,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673402,"y":1075784,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730812,"y":1036543,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592476,"y":1137770,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576151,"y":1144795,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568405,"y":1142752,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584141,"y":1133616,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582862,"y":1133009,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583138,"y":1131568,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583709,"y":1142074,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787201,"y":1007096,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603818,"y":1095288,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605360,"y":1118450,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692658,"y":1093247,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588728,"y":1131545,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593372,"y":1098312,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581426,"y":1131827,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593818,"y":1148430,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590927,"y":1152848,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694698,"y":1019906,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722344,"y":989705,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715870,"y":1037848,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601118,"y":1128301,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592162,"y":1129772,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603762,"y":1124690,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604364,"y":1120573,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595973,"y":1128436,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603951,"y":1120030,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601521,"y":1129611,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608276,"y":1124199,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610330,"y":1096978,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617224,"y":1085942,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603151,"y":1121955,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602299,"y":1126299,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509209,"y":1297093,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598435,"y":1134734,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591571,"y":1132663,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589461,"y":1154696,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590743,"y":1130974,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602347,"y":1130524,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604399,"y":1104109,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604901,"y":1128011,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630272,"y":941536,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590287,"y":1146281,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607232,"y":1093470,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601450,"y":1124999,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625893,"y":1071066,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629075,"y":996383,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635266,"y":1030733,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678126,"y":1136002,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675480,"y":1018782,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694452,"y":1019566,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640809,"y":1087651,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674507,"y":1076715,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683063,"y":1071719,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691181,"y":1069832,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651059,"y":1079218,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628307,"y":1064162,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639167,"y":1032945,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694098,"y":1019371,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694660,"y":1020054,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713736,"y":1036854,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716403,"y":1036169,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565109,"y":1223062,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592282,"y":1145010,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525479,"y":1305198,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592138,"y":1128066,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601570,"y":1128251,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589767,"y":1150578,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596905,"y":1132233,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606467,"y":1121592,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583165,"y":1134222,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520069,"y":1321563,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":513032,"y":1287369,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":503052,"y":1252730,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597102,"y":1127785,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694787,"y":1055253,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714423,"y":1039297,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722211,"y":987288,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721550,"y":986802,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582232,"y":1133790,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579575,"y":1135145,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585748,"y":1130593,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594660,"y":1142234,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589613,"y":1149273,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674578,"y":1135026,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607119,"y":1125884,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722354,"y":990015,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":733327,"y":1009201,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598859,"y":1134997,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594372,"y":1135409,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594575,"y":1136498,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594321,"y":1135589,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594159,"y":1136119,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598502,"y":1130846,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594677,"y":1136363,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594141,"y":1134815,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581444,"y":1190655,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590185,"y":1144843,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615475,"y":1094184,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651223,"y":1078492,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638444,"y":1028985,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693657,"y":1081482,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664024,"y":1047224,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722149,"y":990022,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584936,"y":1135431,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600616,"y":1128787,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592193,"y":1129774,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597053,"y":1131783,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604531,"y":1124495,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599769,"y":1122797,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609863,"y":1113184,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600091,"y":1128956,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564943,"y":1158172,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589165,"y":1141950,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566253,"y":1255627,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502768,"y":1333404,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602637,"y":1124930,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591428,"y":1162015,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595142,"y":1134002,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537458,"y":1306186,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565118,"y":1231619,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589574,"y":1132590,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589580,"y":1152125,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517028,"y":1232204,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529071,"y":1216783,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593834,"y":1129781,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688382,"y":982890,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597300,"y":1131932,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612035,"y":1125411,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599681,"y":1123310,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612035,"y":1125411,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604492,"y":1122715,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580841,"y":1135403,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588768,"y":1130211,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602290,"y":1125990,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608221,"y":1119891,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608229,"y":1119885,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603546,"y":1121245,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603528,"y":1121237,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592233,"y":1161469,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592388,"y":1129412,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599578,"y":1129271,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711742,"y":1038579,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813418,"y":972368,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510002,"y":1297323,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597906,"y":1132260,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602239,"y":1136176,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602320,"y":1126232,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706078,"y":935398,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595937,"y":1127787,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606440,"y":1117688,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638692,"y":1032057,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579970,"y":1220316,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602090,"y":1124316,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587429,"y":1131285,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606324,"y":953008,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588151,"y":1142752,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495481,"y":1309032,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554883,"y":1266560,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556217,"y":1262759,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535152,"y":1311119,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447041,"y":1358894,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523617,"y":646503,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650011,"y":672128,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876854,"y":923205,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772441,"y":838583,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771912,"y":863860,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630311,"y":663031,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774311,"y":838020,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603147,"y":659100,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":903949,"y":1044740,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876261,"y":923304,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600861,"y":653943,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":421287,"y":637072,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587433,"y":639971,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529186,"y":891190,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598288,"y":654736,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600693,"y":654704,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871790,"y":926163,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542863,"y":899507,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641308,"y":724730,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668973,"y":832864,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680280,"y":785214,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670451,"y":800862,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549107,"y":854725,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":506996,"y":869531,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587274,"y":641071,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656964,"y":743162,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612961,"y":796520,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610760,"y":688121,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603381,"y":656778,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675288,"y":804994,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525920,"y":890663,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598245,"y":651262,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547697,"y":839814,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658584,"y":793624,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530927,"y":658290,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605764,"y":660032,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653233,"y":742677,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588647,"y":650524,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511054,"y":848249,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665757,"y":713105,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":550991,"y":861224,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485043,"y":644021,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611260,"y":688944,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874922,"y":924298,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873992,"y":925473,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541537,"y":898751,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658236,"y":744927,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637171,"y":661555,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586055,"y":645575,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587790,"y":641759,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546617,"y":839043,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575445,"y":919850,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677162,"y":820390,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874107,"y":924201,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565658,"y":815267,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599233,"y":651997,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770530,"y":840360,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587246,"y":643366,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669091,"y":833756,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643105,"y":753062,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625055,"y":662216,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768691,"y":821315,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":749044,"y":802185,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766771,"y":831275,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606268,"y":687354,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643719,"y":665092,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":474072,"y":652623,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764753,"y":823412,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773253,"y":862012,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656581,"y":742953,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872060,"y":924209,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874280,"y":924539,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643632,"y":870416,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":755413,"y":866481,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676428,"y":805929,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":779581,"y":875288,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663441,"y":680369,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606310,"y":793331,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613123,"y":793517,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611719,"y":793467,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594356,"y":664065,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":828276,"y":886454,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661912,"y":673609,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613404,"y":665130,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535925,"y":891225,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769059,"y":816793,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772426,"y":838526,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630335,"y":712870,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593593,"y":659542,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591976,"y":660248,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530519,"y":892328,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454898,"y":641614,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":862396,"y":903251,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874458,"y":923834,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686577,"y":749391,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611723,"y":794329,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420861,"y":692595,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374366,"y":563912,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":747605,"y":797799,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":899108,"y":1003927,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864463,"y":919716,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553363,"y":861085,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677876,"y":819373,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608699,"y":662725,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874737,"y":924051,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586070,"y":643871,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585911,"y":643943,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765141,"y":819276,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627325,"y":734578,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":826361,"y":962546,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130700,"y":222408,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":152624,"y":244260,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289464,"y":517023,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406283,"y":403285,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208513,"y":373622,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":219559,"y":420063,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242404,"y":128617,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82893,"y":140779,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":117546,"y":63163,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277415,"y":219874,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80823,"y":63518,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409735,"y":394977,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409735,"y":394977,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407646,"y":392125,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412415,"y":392235,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208921,"y":408094,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82207,"y":64646,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297182,"y":299588,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405818,"y":399416,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":175066,"y":59674,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101123,"y":222601,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":106676,"y":225394,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243056,"y":132529,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243172,"y":132450,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241758,"y":132041,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243206,"y":130605,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":230633,"y":129903,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241961,"y":128563,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":53407,"y":75153,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":160871,"y":255168,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":114103,"y":223783,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387706,"y":521497,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387427,"y":389604,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407514,"y":392216,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":274354,"y":214872,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298049,"y":337468,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461864,"y":488450,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":432844,"y":489068,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404782,"y":398804,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410104,"y":394201,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405530,"y":397259,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405552,"y":400131,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401178,"y":395191,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403002,"y":400077,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415165,"y":439637,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153965,"y":198280,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278432,"y":222222,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434599,"y":366045,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404204,"y":401681,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80049,"y":64541,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81155,"y":63493,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83866,"y":62428,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80767,"y":63938,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":76059,"y":70229,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":339471,"y":356777,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397141,"y":397392,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411103,"y":367090,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408551,"y":398393,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208007,"y":319371,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78550,"y":219321,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137535,"y":368058,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406701,"y":394582,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":440527,"y":376364,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405853,"y":395146,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":309977,"y":503601,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401071,"y":401087,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403112,"y":401158,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408300,"y":399877,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":487819,"y":522970,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":513721,"y":548587,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":93583,"y":219447,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297697,"y":298172,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":196892,"y":289760,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":221001,"y":206763,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400030,"y":397691,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":328166,"y":347365,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95741,"y":220254,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":291801,"y":280181,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243230,"y":131952,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":309418,"y":337197,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208356,"y":101223,"year":"2012","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524493,"y":570103,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580837,"y":1135399,"year":"2012","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582449,"y":1135519,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627942,"y":1059644,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406153,"y":401619,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725483,"y":1039428,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596385,"y":1131443,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581589,"y":1138575,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772228,"y":834543,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704554,"y":1027624,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730498,"y":1028770,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787017,"y":1007883,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":328080,"y":396872,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582213,"y":1129081,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582472,"y":1135692,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403051,"y":394265,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593156,"y":1150455,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580736,"y":812026,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":667128,"y":839728,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592249,"y":1144938,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590706,"y":1143099,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592060,"y":1142374,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578958,"y":1218482,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587992,"y":1142244,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578613,"y":1205789,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592785,"y":1141747,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589834,"y":1143578,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592868,"y":1142545,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642969,"y":1003642,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593537,"y":1140729,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678420,"y":1136690,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583701,"y":1132420,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609323,"y":1118568,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623353,"y":1076687,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588217,"y":808043,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663155,"y":1102219,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589769,"y":1170600,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296487,"y":330725,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":481870,"y":1343796,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":538180,"y":1306860,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554191,"y":1265997,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":225707,"y":332963,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564246,"y":1158936,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627140,"y":1045448,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560312,"y":1234960,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565580,"y":1225084,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":255046,"y":462955,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601388,"y":1133463,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553759,"y":1275199,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566761,"y":1270817,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556164,"y":1264260,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601570,"y":1128251,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420854,"y":370258,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585823,"y":1160349,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611708,"y":1113391,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601164,"y":1120276,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593474,"y":1193013,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609814,"y":1112893,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":587707,"y":1146966,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603482,"y":1115745,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":582855,"y":1133017,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594362,"y":1136834,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590511,"y":1130273,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636129,"y":1033651,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600166,"y":1135039,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588338,"y":1131093,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586453,"y":1129624,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590687,"y":1133331,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568838,"y":1207451,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243761,"y":133126,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536053,"y":1304077,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595362,"y":1143715,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408541,"y":397308,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707036,"y":936460,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706971,"y":936675,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294048,"y":285169,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555508,"y":1266283,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599466,"y":1135013,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590051,"y":1132632,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592887,"y":1132248,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592744,"y":1131739,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408454,"y":409846,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593390,"y":1134042,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138234,"y":129234,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595123,"y":1129512,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603615,"y":1123691,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588986,"y":1129901,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602435,"y":1133063,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596436,"y":1122567,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602604,"y":1131029,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583700,"y":1132484,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587634,"y":1130522,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586870,"y":1129898,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587110,"y":1129783,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589359,"y":1129610,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593666,"y":1142988,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591529,"y":663608,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588330,"y":1131907,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587593,"y":1131899,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588787,"y":1132791,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101782,"y":221440,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590976,"y":1133628,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589986,"y":1132556,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592469,"y":1130756,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580916,"y":1133076,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581268,"y":1135672,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569370,"y":1145761,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590750,"y":1128012,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525817,"y":1320427,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592693,"y":1191804,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594140,"y":1134811,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593023,"y":1135554,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590435,"y":1135729,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594309,"y":1135767,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593850,"y":1135928,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594282,"y":1135892,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591452,"y":660469,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594560,"y":1136440,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594551,"y":1136208,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590232,"y":1192641,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579659,"y":1213867,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591073,"y":1150329,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606946,"y":1117906,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594588,"y":1137010,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601221,"y":1136087,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592474,"y":1131362,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605360,"y":1118450,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612528,"y":1125756,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601218,"y":1120297,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710828,"y":939540,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673700,"y":864319,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677969,"y":897570,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":257744,"y":143928,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687007,"y":979938,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687406,"y":987948,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594903,"y":1131610,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599345,"y":1129715,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536229,"y":854188,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681869,"y":1002403,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629701,"y":1005124,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596932,"y":652083,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":670252,"y":1050607,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643724,"y":1005113,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585745,"y":643579,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596951,"y":1125018,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605282,"y":1116854,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607669,"y":1117982,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605951,"y":1114737,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":785913,"y":1007911,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605063,"y":1127936,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602733,"y":1123014,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603517,"y":1123581,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605350,"y":1120867,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606282,"y":1117994,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406937,"y":404649,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":716717,"y":1040816,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":413694,"y":398225,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657477,"y":744662,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607560,"y":1127623,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873314,"y":925385,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607565,"y":1128149,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767975,"y":835708,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602936,"y":1129178,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594254,"y":660611,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438181,"y":667061,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593345,"y":894013,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661229,"y":746700,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568187,"y":1125296,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610793,"y":1130785,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640236,"y":766163,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601267,"y":1125852,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596706,"y":1126273,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524428,"y":1309118,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688100,"y":981968,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568038,"y":1213453,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601211,"y":1130163,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603796,"y":1134275,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590905,"y":1133069,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597053,"y":1131783,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597850,"y":1132343,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596944,"y":1131886,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598245,"y":1134401,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622879,"y":1142636,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596011,"y":1129254,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592574,"y":1131128,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599484,"y":1132956,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589445,"y":1131337,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600978,"y":1135056,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603701,"y":1129299,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583294,"y":1133026,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592399,"y":1130503,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592176,"y":1141903,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581758,"y":1136891,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594398,"y":1136502,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595106,"y":1136804,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594880,"y":1134307,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594560,"y":1136440,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594470,"y":1137150,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594000,"y":1135707,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399418,"y":392508,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594191,"y":1136848,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584854,"y":1178563,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594686,"y":1136922,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595751,"y":1135987,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595479,"y":1134795,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593985,"y":1134831,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588410,"y":1141262,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679989,"y":895340,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591152,"y":1145383,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720155,"y":1042544,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590853,"y":1145308,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593698,"y":1134925,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585291,"y":1129889,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586733,"y":1129012,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578522,"y":1134898,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635080,"y":1030566,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638613,"y":1029429,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592785,"y":1141747,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597478,"y":1122843,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596427,"y":1122550,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593415,"y":1152170,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584442,"y":1135606,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594207,"y":1132733,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645852,"y":781596,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643546,"y":896646,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606498,"y":1123479,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":216749,"y":119670,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":45135,"y":98986,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718293,"y":1042539,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731141,"y":965346,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708419,"y":937428,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724561,"y":1039271,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719754,"y":992250,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714429,"y":1042618,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636819,"y":1033167,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607101,"y":1003836,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639999,"y":1030132,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655762,"y":1073765,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640045,"y":1024129,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646214,"y":1088961,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709578,"y":1033587,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639581,"y":1088291,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689073,"y":1074017,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585959,"y":1186050,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590730,"y":1143949,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":559631,"y":1247655,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":491263,"y":1288024,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590581,"y":1144793,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592113,"y":1152233,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594886,"y":1136853,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626837,"y":1048090,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706237,"y":1039501,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600982,"y":1128998,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597105,"y":1132105,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592359,"y":1145977,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595311,"y":1133864,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610027,"y":1107979,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597614,"y":1131717,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609452,"y":1113545,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607482,"y":1125775,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584564,"y":1127203,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603582,"y":1124701,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595930,"y":1142561,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579646,"y":1142490,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592956,"y":1159530,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595035,"y":1135915,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598353,"y":1122141,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603514,"y":1131460,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625747,"y":1071262,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539083,"y":1308646,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591496,"y":1147099,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599858,"y":1128947,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594081,"y":1128740,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589381,"y":1128591,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590922,"y":1135329,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592102,"y":1140768,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603220,"y":1122584,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589357,"y":1131820,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570972,"y":1206297,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592818,"y":1144794,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594886,"y":1160623,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593250,"y":1136520,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":843103,"y":884092,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873665,"y":925165,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586070,"y":643871,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586055,"y":645575,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769777,"y":822218,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876724,"y":923269,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555335,"y":827791,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586130,"y":645591,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589613,"y":652815,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600777,"y":647651,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654872,"y":759709,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662344,"y":748455,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655292,"y":761985,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612432,"y":795034,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":903765,"y":983334,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634752,"y":849022,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":324282,"y":399317,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":249680,"y":454727,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705182,"y":931462,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600421,"y":646079,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586222,"y":643493,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":738493,"y":998301,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493131,"y":521659,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289875,"y":514348,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660745,"y":753681,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653086,"y":668912,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":702806,"y":1026235,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875171,"y":923807,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872850,"y":924669,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":491823,"y":522620,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658519,"y":746169,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598408,"y":647881,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288844,"y":513285,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774238,"y":837461,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773619,"y":838804,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761689,"y":819940,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624558,"y":662109,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":740886,"y":782923,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766789,"y":831282,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585251,"y":637598,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95066,"y":220564,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584971,"y":641902,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707786,"y":927362,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690689,"y":1117266,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640045,"y":1025374,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773524,"y":838187,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656919,"y":744353,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":305605,"y":566884,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729065,"y":995540,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704147,"y":929440,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703537,"y":932549,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703767,"y":931937,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714776,"y":1039144,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722056,"y":1040981,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":185256,"y":90089,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89936,"y":217413,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244098,"y":141122,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80364,"y":66335,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137721,"y":221660,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595126,"y":1130749,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590051,"y":1132632,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606955,"y":1117434,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596377,"y":1119450,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592746,"y":1145055,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594635,"y":1136736,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605199,"y":1118330,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589103,"y":1133691,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581093,"y":1140023,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581631,"y":1138177,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578813,"y":1134481,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":257338,"y":172782,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639370,"y":662637,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592826,"y":662186,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583920,"y":644526,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612054,"y":662408,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612596,"y":793487,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":888688,"y":932491,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536276,"y":890095,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516323,"y":881480,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":897396,"y":971552,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":897027,"y":969788,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593418,"y":1135278,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243419,"y":132508,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153434,"y":199176,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603282,"y":1122230,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584836,"y":1187586,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581289,"y":1190801,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591052,"y":1131528,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600488,"y":1136404,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243908,"y":134611,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":175018,"y":59687,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320636,"y":592661,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":190185,"y":283697,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":122536,"y":240136,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96917,"y":220229,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202209,"y":104011,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239028,"y":129726,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":115944,"y":225460,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":97975,"y":229044,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268408,"y":214874,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578698,"y":1138141,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":104735,"y":224666,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95302,"y":220438,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242499,"y":131381,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82572,"y":140765,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587915,"y":1128056,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595646,"y":1133720,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529551,"y":892385,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452986,"y":639479,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591089,"y":1140816,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243406,"y":132851,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647393,"y":1086200,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523942,"y":1246782,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718610,"y":1044768,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711522,"y":1039444,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591807,"y":1129168,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593796,"y":1133365,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591281,"y":1147375,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584008,"y":1138909,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591672,"y":1136756,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578674,"y":1138140,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590472,"y":1132858,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594434,"y":1135548,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596377,"y":1119450,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597016,"y":1131817,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":800257,"y":991317,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594071,"y":1136158,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593183,"y":1134646,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597498,"y":1131351,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80826,"y":63473,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590979,"y":1134379,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581494,"y":1131729,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767512,"y":820842,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581138,"y":1140148,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587248,"y":1134022,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578647,"y":1126192,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582599,"y":1133290,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620264,"y":1123728,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597324,"y":1132007,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595044,"y":1134760,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619662,"y":1116506,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606122,"y":1097368,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604829,"y":1121775,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593582,"y":1153575,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605225,"y":1123394,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641178,"y":1030591,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584140,"y":1126233,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718207,"y":1005373,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704021,"y":1044258,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711096,"y":1035026,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715435,"y":1042349,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727407,"y":1030015,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722544,"y":1036757,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603320,"y":1131797,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593934,"y":1136176,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606708,"y":1121019,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589236,"y":1146701,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591138,"y":1142876,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588348,"y":1131065,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592708,"y":1131614,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721671,"y":990581,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693639,"y":1019299,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720722,"y":990076,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627263,"y":1055886,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620381,"y":1084892,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671782,"y":1121969,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680545,"y":1027761,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679760,"y":1032625,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720138,"y":992165,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":235185,"y":129374,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131904,"y":43681,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80996,"y":66776,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":37567,"y":249386,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493138,"y":521188,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":474269,"y":506028,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242737,"y":133513,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95197,"y":220580,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241097,"y":131042,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243839,"y":135918,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123706,"y":102873,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688714,"y":1073788,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688417,"y":982693,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407028,"y":410048,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226590,"y":334659,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":342247,"y":353466,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408932,"y":397312,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409378,"y":397668,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645688,"y":851349,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598695,"y":647345,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586375,"y":647095,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585327,"y":642745,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587044,"y":641104,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626666,"y":1044996,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584933,"y":1130492,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594110,"y":1136634,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604945,"y":1120315,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664294,"y":749120,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590386,"y":1162439,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585660,"y":1187082,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585706,"y":1154719,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654417,"y":759336,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594192,"y":1147916,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81408,"y":64098,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619762,"y":701985,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596430,"y":1128722,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598409,"y":1132204,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574104,"y":1197469,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603922,"y":1115609,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593576,"y":1148646,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591544,"y":1152016,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591689,"y":1144496,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582477,"y":1135772,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566621,"y":1243028,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593250,"y":1136520,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637879,"y":1031511,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517325,"y":619303,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588728,"y":1131545,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517416,"y":621216,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515330,"y":613048,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509963,"y":621182,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876175,"y":923388,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598762,"y":1135041,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528055,"y":1249159,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720606,"y":1036154,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586353,"y":1134262,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607866,"y":1122290,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618161,"y":1094311,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584463,"y":1135602,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584868,"y":1129877,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577990,"y":1127697,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594139,"y":665100,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536995,"y":894875,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135723,"y":220548,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":38612,"y":247398,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":75597,"y":97412,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":115418,"y":225704,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402428,"y":392470,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598997,"y":1123912,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596933,"y":1124460,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704209,"y":929537,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719517,"y":1044112,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685610,"y":902361,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659890,"y":1139794,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515624,"y":1238905,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534631,"y":1296820,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406150,"y":401369,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609846,"y":1112449,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601366,"y":1126066,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603139,"y":1124359,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404154,"y":396219,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410265,"y":400129,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408364,"y":393962,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585215,"y":642952,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":117523,"y":222868,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":267969,"y":334972,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297458,"y":299249,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297906,"y":298056,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297691,"y":296508,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289052,"y":263642,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873340,"y":924933,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":366753,"y":591483,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":870126,"y":928114,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528640,"y":838145,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677276,"y":820165,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":103826,"y":92157,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730859,"y":1028438,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628015,"y":1056853,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532028,"y":889748,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408303,"y":395176,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594929,"y":669841,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407979,"y":395186,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297089,"y":335282,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772827,"y":836509,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387958,"y":514582,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512681,"y":548455,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410701,"y":406261,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639768,"y":1034066,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556307,"y":1261205,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568472,"y":1238275,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411788,"y":428391,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579495,"y":1137638,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704242,"y":929410,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728612,"y":1037813,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471116,"y":651878,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589722,"y":1170575,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594726,"y":662016,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581765,"y":1135471,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769762,"y":835574,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769818,"y":817693,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586888,"y":646494,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":232131,"y":131363,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635072,"y":1035985,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659186,"y":678023,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641490,"y":1029380,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":634810,"y":1032869,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606088,"y":1121883,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625042,"y":782655,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618125,"y":665070,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684990,"y":982144,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622849,"y":663194,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660675,"y":753622,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655588,"y":789929,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583912,"y":644531,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631202,"y":717461,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646998,"y":751393,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543877,"y":851400,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":279880,"y":328808,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403118,"y":394241,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398273,"y":395235,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657477,"y":744662,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546948,"y":834233,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575649,"y":909912,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617986,"y":1090621,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540249,"y":1308923,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537160,"y":1308935,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613305,"y":796193,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613133,"y":793521,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613798,"y":794203,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636212,"y":1030549,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554450,"y":1269975,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604764,"y":1124809,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":390984,"y":391262,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405793,"y":393971,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592763,"y":1131810,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776653,"y":1003031,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637177,"y":1032031,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631681,"y":1024129,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641917,"y":1031029,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584652,"y":1130735,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485043,"y":644021,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596914,"y":1138622,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":504205,"y":1309747,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554846,"y":1265772,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":559705,"y":1263807,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460741,"y":1331236,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565589,"y":1224976,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590590,"y":1153267,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730914,"y":966721,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":842963,"y":884072,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":822309,"y":900446,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776969,"y":1011949,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793729,"y":1000699,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679519,"y":897075,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455829,"y":642033,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":842520,"y":883970,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610083,"y":1107717,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":358818,"y":371021,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":356258,"y":368575,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641374,"y":1024957,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864682,"y":943763,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666016,"y":711777,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720229,"y":1042634,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659186,"y":678023,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622963,"y":662851,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520329,"y":646348,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765706,"y":822087,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397499,"y":397157,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398574,"y":394713,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602264,"y":656471,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613571,"y":1103474,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511178,"y":1302448,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603352,"y":1116158,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":148991,"y":191400,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654198,"y":1019360,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651817,"y":1026181,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415410,"y":397519,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713689,"y":1042584,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621020,"y":1127880,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525407,"y":1319263,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604897,"y":1109591,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581038,"y":1140282,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":66127,"y":10664,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":286582,"y":237255,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406360,"y":399446,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":467533,"y":520735,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242085,"y":132231,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405032,"y":398602,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290235,"y":276357,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408556,"y":397876,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96110,"y":220140,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268674,"y":336231,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":331616,"y":396014,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":360088,"y":586554,"year":"2013","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":234635,"y":340712,"year":"2013","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82132,"y":67018,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601331,"y":1130400,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607938,"y":1114539,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579403,"y":1129181,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581947,"y":1133959,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401457,"y":396505,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591888,"y":1131751,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592266,"y":1150957,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1120303,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598977,"y":1119382,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554080,"y":1273121,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693639,"y":1019299,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604451,"y":1120297,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688622,"y":1073603,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":759626,"y":953243,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681784,"y":1002045,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674504,"y":1147507,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681182,"y":1027779,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724891,"y":916002,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594731,"y":1142281,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607049,"y":1115039,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608787,"y":1112989,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704213,"y":956048,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731810,"y":1036294,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534122,"y":841985,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582244,"y":1140412,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604742,"y":951851,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680006,"y":1026939,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594838,"y":1134346,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593691,"y":1136000,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605260,"y":1119342,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595994,"y":1128192,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593011,"y":1135538,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659641,"y":747726,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589053,"y":1133955,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584926,"y":1178480,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589232,"y":1134077,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588934,"y":1133965,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590349,"y":1135029,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587395,"y":1162369,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533402,"y":1311244,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606577,"y":1115774,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761756,"y":994031,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606658,"y":1130652,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":559313,"y":1267236,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589760,"y":1149624,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589730,"y":1149612,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565580,"y":1225084,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638429,"y":1029107,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588692,"y":1167343,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594346,"y":1159673,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674919,"y":1135748,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639201,"y":1035413,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":449240,"y":1323198,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659976,"y":1118812,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638423,"y":1030062,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633694,"y":1034836,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602180,"y":1126445,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590385,"y":1130663,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589076,"y":1130240,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586169,"y":638342,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597301,"y":1131932,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624456,"y":1020546,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597324,"y":1132008,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587872,"y":1131546,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689461,"y":1074375,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639152,"y":1029220,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588124,"y":1171516,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591473,"y":1152045,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603223,"y":1124263,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672313,"y":1101473,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591476,"y":1152004,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608965,"y":1089840,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600203,"y":1128842,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592409,"y":1143595,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640150,"y":1029648,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595984,"y":1135433,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670600,"y":1078683,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633687,"y":1030363,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526183,"y":1306075,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556222,"y":1261152,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591682,"y":1134447,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595554,"y":1129031,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601314,"y":1128822,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600940,"y":1129640,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595638,"y":1134220,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673636,"y":1075061,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641541,"y":1042879,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597473,"y":1128758,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675894,"y":1100896,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611622,"y":1112502,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599442,"y":1123081,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603906,"y":1120692,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875567,"y":923838,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587142,"y":1130087,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603093,"y":1121641,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639138,"y":1029208,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602721,"y":1123013,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638358,"y":1029115,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603726,"y":1124145,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596611,"y":1123387,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605292,"y":1120385,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638102,"y":1028044,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635147,"y":1036013,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635147,"y":1036013,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672828,"y":1076889,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676611,"y":1057766,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686504,"y":1124555,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603850,"y":1120301,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601522,"y":1126190,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":605278,"y":1117970,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627871,"y":733578,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698917,"y":1045126,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604427,"y":1123037,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724229,"y":951259,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564917,"y":1228486,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606974,"y":1105658,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598914,"y":1130068,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603549,"y":1135707,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596062,"y":1133165,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703418,"y":930151,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555484,"y":1289432,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601172,"y":1123265,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594512,"y":1136656,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592618,"y":1128097,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622060,"y":1142589,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726783,"y":1038607,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":732100,"y":997658,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720066,"y":991336,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596036,"y":1119326,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593675,"y":1132427,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591905,"y":1129847,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600087,"y":1129996,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409601,"y":402778,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722343,"y":989678,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722364,"y":990345,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718489,"y":1042510,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727722,"y":991650,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719492,"y":1035639,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719132,"y":1042486,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720023,"y":1000847,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592457,"y":1160595,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593014,"y":1159475,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574528,"y":1117758,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607225,"y":1127282,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592701,"y":1159110,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574459,"y":1196891,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722556,"y":987679,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590151,"y":1162929,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575977,"y":1194442,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572409,"y":1116701,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":248573,"y":142667,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584089,"y":1128919,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638428,"y":1031044,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600714,"y":1122527,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635950,"y":1036429,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604873,"y":1122794,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":463344,"y":1338262,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585969,"y":1133942,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604551,"y":1122852,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602410,"y":1123016,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590120,"y":1140602,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589457,"y":1147196,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660419,"y":1145316,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592518,"y":1150064,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690008,"y":1092654,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594472,"y":1137155,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589088,"y":1165304,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602346,"y":1130683,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539275,"y":1313262,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674917,"y":904114,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606988,"y":1115478,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593362,"y":1133942,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724853,"y":989621,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":501291,"y":1336312,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":498384,"y":1337237,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682208,"y":959817,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598591,"y":1130348,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595052,"y":1134121,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607033,"y":1130794,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602235,"y":1121793,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592488,"y":1130828,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590927,"y":1147942,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591088,"y":1140600,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603939,"y":1123040,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607495,"y":1127328,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605316,"y":1123861,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589203,"y":1146726,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584630,"y":1129369,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620594,"y":1095340,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592506,"y":1137647,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687835,"y":986409,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716556,"y":1036004,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607073,"y":1116260,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608004,"y":1128450,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601074,"y":1129896,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589194,"y":640556,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723819,"y":1040521,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586652,"y":1129932,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787741,"y":1007296,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544401,"y":1285575,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554394,"y":1269410,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605939,"y":1116994,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554585,"y":1248972,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510015,"y":1297608,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741976,"y":1030168,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594272,"y":1136656,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":333561,"y":596551,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872598,"y":925808,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89676,"y":69905,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95471,"y":220892,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873000,"y":925027,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619270,"y":701592,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":866701,"y":934101,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":322115,"y":454120,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":334850,"y":598699,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278458,"y":222264,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277192,"y":219502,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596991,"y":1123488,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602758,"y":1124317,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":794151,"y":1004303,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569809,"y":1247370,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680079,"y":1071298,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691398,"y":1089220,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722298,"y":1041689,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719275,"y":1043844,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":166812,"y":55606,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595312,"y":1131751,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153764,"y":198782,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":230532,"y":129858,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517916,"y":856479,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659034,"y":745994,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408970,"y":400805,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595756,"y":1134673,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402608,"y":397527,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242821,"y":330899,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673445,"y":1075869,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":821361,"y":887055,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528761,"y":890030,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731157,"y":967092,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242568,"y":132031,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":26929,"y":177633,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585786,"y":643038,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771351,"y":823220,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582308,"y":1134388,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594635,"y":1128570,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573896,"y":1255898,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671019,"y":1048156,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239628,"y":134733,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589106,"y":1165095,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":338161,"y":355437,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387702,"y":521488,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402892,"y":400564,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660360,"y":1061561,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408928,"y":396064,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568211,"y":1125288,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593342,"y":1133872,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":430719,"y":462308,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597389,"y":1188499,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434175,"y":1380559,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583259,"y":1130002,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771763,"y":835310,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":48316,"y":76522,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620389,"y":703447,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721591,"y":1040400,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724793,"y":1038395,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519095,"y":619065,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517362,"y":618585,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605034,"y":688722,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761190,"y":823795,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770523,"y":818264,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":775976,"y":809475,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661843,"y":679920,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585543,"y":638575,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601441,"y":1124997,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609648,"y":1112967,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601326,"y":1126146,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608639,"y":1111253,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595203,"y":1142858,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591170,"y":1143831,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591033,"y":1141775,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592425,"y":1145423,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594612,"y":1136645,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599590,"y":1128722,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592894,"y":1132094,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601340,"y":1130418,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595560,"y":1133488,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596685,"y":1132390,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595774,"y":1134697,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592353,"y":1133824,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590511,"y":1130273,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668424,"y":1120048,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592410,"y":1152134,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592266,"y":1150957,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595452,"y":1132409,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764402,"y":1005284,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591771,"y":1132573,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510952,"y":1284996,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601182,"y":1130106,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600765,"y":1121448,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727148,"y":1025424,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722796,"y":989026,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602407,"y":1125857,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658081,"y":911195,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515220,"y":875088,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649107,"y":672181,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":522121,"y":644712,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604074,"y":1120718,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602941,"y":1117168,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603876,"y":1121870,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584709,"y":1088783,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722262,"y":1041641,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705870,"y":1030016,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601468,"y":1120402,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608841,"y":1110955,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607341,"y":1133535,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607062,"y":1115405,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594569,"y":1128319,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590414,"y":1144197,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584193,"y":1126517,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593602,"y":1143810,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560492,"y":1257106,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557563,"y":1208987,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100776,"y":222445,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568464,"y":1232302,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":451128,"y":1324007,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572961,"y":1204869,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":484993,"y":1276300,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599561,"y":1129342,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602651,"y":1124935,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593733,"y":1135097,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584172,"y":1135821,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539195,"y":1314066,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540856,"y":1311537,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455394,"y":1341866,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592543,"y":1137988,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582491,"y":1136144,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579862,"y":1120316,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610052,"y":1107408,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592400,"y":1130508,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80697,"y":65625,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608371,"y":687116,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606622,"y":685152,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600750,"y":675949,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744361,"y":790032,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659574,"y":745346,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":659819,"y":746480,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601010,"y":653207,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718903,"y":990199,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718952,"y":996348,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":721760,"y":989926,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722343,"y":989678,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719005,"y":995412,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770376,"y":818536,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":755814,"y":868896,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773707,"y":837318,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":587995,"y":1130707,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634398,"y":1035713,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243299,"y":132548,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":195249,"y":397846,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":68251,"y":77281,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":99714,"y":61593,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":187117,"y":68069,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610110,"y":661288,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601417,"y":676692,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459852,"y":647088,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592277,"y":1137388,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593304,"y":1151169,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588455,"y":1130842,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604351,"y":1129428,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600594,"y":1133672,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589096,"y":1135948,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605785,"y":1130057,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606194,"y":683641,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584742,"y":639908,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595143,"y":663622,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588047,"y":1131615,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584330,"y":643731,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409049,"y":393464,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":350970,"y":401166,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407803,"y":397291,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399091,"y":395750,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409371,"y":395224,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402635,"y":397282,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":418884,"y":500687,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598535,"y":1130279,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592702,"y":1138273,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592884,"y":1137231,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593387,"y":1140233,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611907,"y":1103867,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589108,"y":1186359,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585734,"y":1161397,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586237,"y":1143782,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585911,"y":1186138,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608182,"y":1111149,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100917,"y":221721,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80119,"y":64545,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208121,"y":112350,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":212311,"y":115257,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":252041,"y":163952,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":116467,"y":225721,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":116475,"y":225728,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":190985,"y":71381,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":140701,"y":229603,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226627,"y":268263,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":66018,"y":10405,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80790,"y":64040,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80161,"y":69758,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595757,"y":1128613,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651376,"y":1016191,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680620,"y":896531,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":740956,"y":1021860,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547131,"y":833143,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629331,"y":721924,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637960,"y":719742,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632359,"y":1026495,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666462,"y":1118988,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639216,"y":1035388,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637908,"y":1029042,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405090,"y":417339,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387427,"y":389604,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237362,"y":343187,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402920,"y":422019,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337439,"y":354875,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297928,"y":297290,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":301788,"y":319490,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403346,"y":420412,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":205961,"y":310690,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401376,"y":398185,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374696,"y":382881,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401177,"y":395215,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690051,"y":1115284,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671873,"y":750286,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678324,"y":734455,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665791,"y":752786,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528719,"y":891763,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691282,"y":970366,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585471,"y":642967,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":324588,"y":479443,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591298,"y":659145,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588453,"y":1134037,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612749,"y":795103,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876671,"y":923783,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511812,"y":848019,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":273365,"y":245604,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553605,"y":1260697,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533777,"y":1300559,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512749,"y":1282752,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408303,"y":394339,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404756,"y":390026,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434670,"y":366627,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526782,"y":891885,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530383,"y":891504,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605063,"y":1127936,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576069,"y":915236,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568215,"y":1125286,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":333232,"y":421783,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242858,"y":130523,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601643,"y":1133881,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634898,"y":1032332,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639408,"y":1034627,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611189,"y":1124306,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597053,"y":1131783,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592888,"y":1133966,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585841,"y":1158484,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593435,"y":1140321,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607878,"y":1131904,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604676,"y":1128665,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592663,"y":1145022,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603615,"y":1123640,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603555,"y":1123233,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604608,"y":1123337,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601304,"y":1120335,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593035,"y":1138874,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581092,"y":1130999,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591524,"y":1140818,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590021,"y":1151776,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591043,"y":1149620,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602212,"y":1121812,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613462,"y":1111263,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601954,"y":1119725,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596224,"y":1127875,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601958,"y":1119734,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600947,"y":1128916,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603589,"y":1117733,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605620,"y":1117444,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605043,"y":1086420,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584200,"y":1129700,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":592074,"y":1132480,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595261,"y":1131407,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579400,"y":1131387,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":393902,"y":599997,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644272,"y":1052418,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874533,"y":924263,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874415,"y":924387,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587776,"y":1128379,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641220,"y":1005985,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":784800,"y":1008214,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622769,"y":1077465,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597261,"y":652256,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592561,"y":1150131,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530567,"y":892341,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580876,"y":1135383,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406805,"y":397876,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591464,"y":660472,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636451,"y":1036706,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654411,"y":1017384,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622003,"y":960423,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680572,"y":1146453,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634372,"y":1033463,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594351,"y":1135878,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226357,"y":130301,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689987,"y":1119182,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717812,"y":1035831,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710190,"y":1034622,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":736529,"y":1022986,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662519,"y":1103630,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242769,"y":130101,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583918,"y":1133410,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609294,"y":792917,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":394467,"y":383795,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":345804,"y":341244,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773606,"y":837187,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592640,"y":1138163,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593520,"y":1143330,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399193,"y":395293,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595606,"y":1143616,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599075,"y":1128510,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":464378,"y":495498,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":279203,"y":243063,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592539,"y":1137940,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602414,"y":1122378,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587998,"y":1131606,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407550,"y":390639,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":269421,"y":304651,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399332,"y":396603,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":431041,"y":371672,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410549,"y":410514,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565282,"y":1222621,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":867779,"y":925641,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874711,"y":924077,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":458448,"y":1338824,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":505938,"y":1334505,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566703,"y":1233741,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":112804,"y":227700,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243735,"y":130748,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708260,"y":1033024,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588482,"y":650253,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585597,"y":642216,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588311,"y":649945,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":312677,"y":501689,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288844,"y":513285,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298971,"y":515801,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548515,"y":1268451,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459298,"y":644810,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630335,"y":716424,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640256,"y":765914,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631295,"y":734227,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675113,"y":804751,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677271,"y":820174,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613775,"y":795488,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641425,"y":762738,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664688,"y":748619,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658231,"y":744925,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642134,"y":1029926,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703894,"y":929588,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586354,"y":642348,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719569,"y":1044349,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694259,"y":1054129,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517224,"y":1231727,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523864,"y":1317819,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557549,"y":1261373,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471087,"y":1313582,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288637,"y":513983,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":76398,"y":94944,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79475,"y":65676,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536189,"y":1301690,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601080,"y":1029921,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413164,"y":607408,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509656,"y":1297387,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625275,"y":1073378,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614720,"y":1095160,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":504779,"y":1335280,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135256,"y":261456,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601121,"y":1128291,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630132,"y":1051009,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557383,"y":1266553,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517753,"y":1231063,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409586,"y":412821,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730670,"y":1036839,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387001,"y":384681,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":392695,"y":384445,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413394,"y":399158,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586273,"y":644624,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":122119,"y":43198,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":267885,"y":190587,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648430,"y":1029737,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514993,"y":1238793,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639514,"y":1007247,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689073,"y":1074017,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643504,"y":1087662,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684578,"y":1109113,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593596,"y":1136153,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589051,"y":650963,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585882,"y":640871,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586891,"y":641035,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585870,"y":643177,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":383185,"y":384019,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408059,"y":395187,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434553,"y":365946,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410036,"y":397355,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632772,"y":1037897,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587154,"y":641483,"year":"2014","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588756,"y":1076108,"year":"2014","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594813,"y":1160597,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":561081,"y":1247448,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668202,"y":1042878,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":538955,"y":856908,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":785636,"y":1008027,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":789055,"y":1008261,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618434,"y":1119953,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601599,"y":1130918,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601400,"y":1122255,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548191,"y":859769,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582477,"y":1135772,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602221,"y":1126331,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604943,"y":1116696,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597836,"y":1122623,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597287,"y":1124850,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604489,"y":1118974,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603691,"y":1129290,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607048,"y":1130789,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603371,"y":1116052,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576387,"y":1127231,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590739,"y":1143966,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598531,"y":1130356,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604764,"y":1124189,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607578,"y":1128397,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598130,"y":1122106,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596201,"y":1132645,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606392,"y":1116324,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718144,"y":1045596,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612805,"y":1110946,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608726,"y":1113788,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588441,"y":1163693,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557107,"y":1261524,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540038,"y":1287757,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553083,"y":1281849,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":183976,"y":64556,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636303,"y":1029338,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637787,"y":1031738,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632559,"y":1026822,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716639,"y":1036091,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523708,"y":1311851,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589509,"y":1152664,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556640,"y":1261853,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568003,"y":1240953,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557113,"y":1262492,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589505,"y":1163010,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573976,"y":1198254,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589675,"y":1170547,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588357,"y":1167103,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583655,"y":1207951,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578087,"y":1192740,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576290,"y":1194080,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576067,"y":1194322,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":492030,"y":1303750,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461268,"y":1330216,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":712402,"y":1035004,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723759,"y":1040556,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240330,"y":130304,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726673,"y":1035874,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721677,"y":1040491,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719718,"y":1042469,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721687,"y":988205,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600139,"y":654413,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722357,"y":990125,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722248,"y":989797,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787480,"y":1007887,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695914,"y":908534,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705911,"y":928882,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705747,"y":927087,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722148,"y":989810,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722298,"y":988431,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595026,"y":650010,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707807,"y":1032333,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715336,"y":1038531,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721387,"y":1041352,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722263,"y":1041641,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594571,"y":662083,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697646,"y":1048189,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721768,"y":1040428,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589320,"y":652182,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694736,"y":1058247,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703668,"y":1026847,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721394,"y":1041232,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138802,"y":221223,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605654,"y":1100612,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585236,"y":642516,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813748,"y":1000155,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637908,"y":1029043,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635039,"y":1034726,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640426,"y":1030965,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626998,"y":1070394,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599443,"y":1029470,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691601,"y":1104255,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627822,"y":1055468,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624688,"y":1054977,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705730,"y":927186,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627992,"y":979857,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625366,"y":971982,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587713,"y":649167,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705896,"y":933596,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704521,"y":929863,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706240,"y":930134,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720366,"y":1042242,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627834,"y":1056081,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691548,"y":1093553,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594153,"y":1136340,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590935,"y":663408,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692147,"y":1094550,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597178,"y":652282,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692478,"y":1093471,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606354,"y":1118491,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610031,"y":661279,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642809,"y":1003843,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627782,"y":970287,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582363,"y":1134824,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813580,"y":999941,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720972,"y":992746,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588359,"y":650267,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704147,"y":929440,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704641,"y":928834,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587217,"y":1130197,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610033,"y":1107930,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660799,"y":1108350,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608733,"y":1128258,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661045,"y":1106025,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665262,"y":1097647,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688470,"y":983827,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654053,"y":1019623,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632245,"y":1007723,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705443,"y":928346,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610357,"y":1111116,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626297,"y":1000829,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691531,"y":1092971,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642168,"y":1086864,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660159,"y":1144972,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634184,"y":1029903,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647492,"y":1086202,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602906,"y":1122755,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595781,"y":1028222,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585998,"y":1133561,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594071,"y":1136159,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580980,"y":934932,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705677,"y":927500,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646590,"y":952095,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681885,"y":1002429,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639203,"y":1029818,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671819,"y":1013027,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731548,"y":1027176,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625419,"y":1072905,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588631,"y":1186385,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585916,"y":1161397,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770958,"y":848178,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704213,"y":929651,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660464,"y":1058152,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646672,"y":1024454,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635878,"y":1033343,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639370,"y":1029960,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608259,"y":1127774,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605099,"y":1120074,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590233,"y":1132808,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730122,"y":996551,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607840,"y":1114635,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685698,"y":1126243,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685486,"y":1110260,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638814,"y":1079359,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593528,"y":1143168,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555628,"y":1258600,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705904,"y":938316,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598598,"y":1125392,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602664,"y":1133082,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589659,"y":1130266,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597415,"y":637877,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590121,"y":1129542,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593984,"y":1135489,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722287,"y":988170,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520565,"y":1325553,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712970,"y":990713,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723793,"y":981194,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598275,"y":1125091,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399777,"y":394001,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638628,"y":1030766,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585990,"y":1186343,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595056,"y":1134117,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399711,"y":393940,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":212115,"y":115080,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589708,"y":1149574,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704103,"y":929300,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677497,"y":1025749,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672925,"y":1011756,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661211,"y":1105715,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692291,"y":1093736,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660698,"y":1087950,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606107,"y":1097043,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571990,"y":1271458,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":432656,"y":662930,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599165,"y":654508,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579281,"y":1209467,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595046,"y":1134150,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638136,"y":1028551,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672905,"y":962042,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517169,"y":857384,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706994,"y":936578,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":106262,"y":224997,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682709,"y":947371,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581339,"y":1131942,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596281,"y":1132904,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594362,"y":1135109,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585573,"y":1134975,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588335,"y":1131517,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242615,"y":128854,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594382,"y":1136947,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606968,"y":1130571,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606263,"y":1119786,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95275,"y":220528,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607061,"y":1115386,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607062,"y":1115405,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584668,"y":1135562,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581616,"y":1138141,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95513,"y":220460,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596341,"y":1132825,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581326,"y":1139588,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587264,"y":1130531,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101237,"y":221762,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582230,"y":1133773,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582014,"y":1133915,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600463,"y":1129966,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601006,"y":1129763,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268588,"y":215123,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601303,"y":1129631,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604097,"y":1133297,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584438,"y":1129793,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583736,"y":1132130,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579579,"y":1133262,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582297,"y":1140429,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583349,"y":1125427,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582660,"y":1132885,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594801,"y":1136882,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600508,"y":1136410,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588896,"y":1133237,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594612,"y":1128473,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589419,"y":1134484,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595727,"y":1134545,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595379,"y":1129445,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596049,"y":1129242,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593230,"y":1153508,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593585,"y":659917,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600625,"y":653379,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596814,"y":644177,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676707,"y":647176,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593763,"y":1152918,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597413,"y":1138675,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":585294,"y":646331,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586439,"y":643368,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599601,"y":652209,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595313,"y":1136602,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630906,"y":717113,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405665,"y":395935,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649339,"y":740556,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455886,"y":641686,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89119,"y":217367,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95001,"y":220216,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412222,"y":393630,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":280128,"y":257887,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411766,"y":391827,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534511,"y":1300227,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629759,"y":715678,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":370900,"y":380890,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412050,"y":398037,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408290,"y":397407,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402069,"y":389827,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658513,"y":745229,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402169,"y":376911,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":273385,"y":480503,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556513,"y":1261795,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":550524,"y":1282182,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536402,"y":1311153,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593715,"y":1149559,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565158,"y":1223514,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460666,"y":1351476,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606639,"y":1122300,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604069,"y":1123521,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600822,"y":1124888,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592025,"y":659228,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611170,"y":688794,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536122,"y":1302114,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762134,"y":823503,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771230,"y":835937,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":820492,"y":968811,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597111,"y":672679,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813374,"y":1000395,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":167664,"y":93002,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":94405,"y":219686,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528824,"y":882122,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819748,"y":886644,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":902502,"y":961879,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":143606,"y":123145,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80669,"y":66111,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":126565,"y":163760,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241800,"y":134551,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":285880,"y":246187,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705485,"y":930113,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592278,"y":1130076,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584652,"y":1130735,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297195,"y":299685,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627118,"y":977119,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602241,"y":1118871,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587851,"y":1162681,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592896,"y":1086225,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585884,"y":1131107,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532451,"y":892821,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684777,"y":1129160,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693815,"y":1075866,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641042,"y":757881,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530751,"y":891848,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700534,"y":760335,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565448,"y":1151048,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599048,"y":1136063,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605451,"y":1128946,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101098,"y":221336,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":587280,"y":1143124,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596729,"y":1141276,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607227,"y":1093478,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598641,"y":1123536,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609805,"y":1110359,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597062,"y":1124784,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603448,"y":1122126,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592938,"y":1138700,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589867,"y":1134093,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589573,"y":1132072,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581397,"y":1131868,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596090,"y":1136002,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607334,"y":1118064,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":748679,"y":879460,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597558,"y":1122851,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590328,"y":1144784,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592556,"y":1138011,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611074,"y":1113886,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611515,"y":794966,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703146,"y":1043057,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712707,"y":1042996,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405693,"y":400334,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771633,"y":838564,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584030,"y":1208503,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":230931,"y":132510,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585551,"y":643122,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592771,"y":1143175,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607081,"y":1115386,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602905,"y":1122755,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592911,"y":1130595,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592181,"y":1129767,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618718,"y":1141502,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598684,"y":1131243,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595523,"y":1134298,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600130,"y":1132056,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581100,"y":1135051,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593079,"y":1138918,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619893,"y":1141814,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607060,"y":1129382,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600539,"y":1128795,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569891,"y":1164146,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642087,"y":1030976,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583874,"y":1212994,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625630,"y":1071708,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290548,"y":514896,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673399,"y":1076135,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":263328,"y":331075,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595313,"y":1136602,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":286650,"y":507765,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588376,"y":1131114,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639669,"y":1031013,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602792,"y":1030185,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713281,"y":1035974,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610898,"y":794209,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767728,"y":822943,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766906,"y":822397,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704708,"y":929680,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705444,"y":928346,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713515,"y":1037273,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721525,"y":1040753,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694855,"y":1055627,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676546,"y":1126911,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772024,"y":837057,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769978,"y":836991,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605490,"y":1119635,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604300,"y":1119930,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657541,"y":747711,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662912,"y":1046175,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578053,"y":1216589,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":158852,"y":261511,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590577,"y":1149232,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593318,"y":1146375,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773815,"y":837295,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716005,"y":780685,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611093,"y":688475,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":375280,"y":590438,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541545,"y":881226,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288958,"y":504623,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582252,"y":1137126,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618480,"y":1100325,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611207,"y":1118868,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605327,"y":1123871,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":755677,"y":864868,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608085,"y":1115685,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724652,"y":988486,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":118152,"y":92112,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138531,"y":221486,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":126404,"y":104930,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517474,"y":619658,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595560,"y":1133498,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592887,"y":1132247,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696911,"y":1003504,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681198,"y":1000831,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586184,"y":1129447,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592815,"y":1143127,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580697,"y":1139816,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592124,"y":1129528,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718181,"y":942231,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606763,"y":1117833,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606654,"y":1118062,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596325,"y":1127231,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661320,"y":1141712,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154157,"y":198267,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":235266,"y":126990,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":914876,"y":1016602,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717078,"y":1041531,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":67642,"y":131088,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787451,"y":1005722,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725506,"y":989686,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546209,"y":1257943,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556130,"y":1260881,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147674,"y":205834,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718654,"y":1035873,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":773175,"y":835075,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725136,"y":988121,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718995,"y":995414,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719675,"y":993834,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713961,"y":1001593,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676860,"y":1008294,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769452,"y":817334,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571783,"y":1274026,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":551827,"y":1282446,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599204,"y":1125215,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555515,"y":1258908,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586201,"y":638271,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241315,"y":131676,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79034,"y":69350,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":257014,"y":337374,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639731,"y":1032077,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639183,"y":1029265,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411708,"y":400526,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606667,"y":1130657,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524659,"y":1308904,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":492778,"y":529361,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601294,"y":1134712,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601570,"y":1030824,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603797,"y":657296,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409449,"y":404235,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588149,"y":1092376,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603916,"y":687164,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244024,"y":135964,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589836,"y":651541,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609312,"y":1128127,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611305,"y":689009,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609702,"y":687711,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641670,"y":1029739,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607102,"y":1125867,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593432,"y":1134834,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511746,"y":1299151,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406978,"y":401451,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656675,"y":744222,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657355,"y":744592,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597123,"y":652293,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590678,"y":1130417,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726198,"y":1030614,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731776,"y":1002923,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682541,"y":960004,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712751,"y":1039431,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715028,"y":1037320,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714780,"y":1034711,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591905,"y":1128744,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583603,"y":1129777,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524669,"y":1308967,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":799393,"y":906986,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707601,"y":936751,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637811,"y":1032046,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636149,"y":1031204,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727776,"y":1031826,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634492,"y":1033285,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138624,"y":221157,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677249,"y":820219,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647393,"y":1086200,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606138,"y":1097362,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643186,"y":1022153,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575829,"y":1134349,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600747,"y":1122429,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594164,"y":1136368,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515836,"y":619347,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768964,"y":820392,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765057,"y":822798,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658397,"y":748297,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684633,"y":971606,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542142,"y":1253796,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562517,"y":1257680,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516012,"y":618129,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721360,"y":1041255,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81411,"y":63986,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634970,"y":1030566,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600448,"y":1131461,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602833,"y":1117427,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591137,"y":1130374,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604924,"y":1122179,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602439,"y":1133043,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594407,"y":1136499,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874453,"y":924179,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873730,"y":923838,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558587,"y":1261037,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":480604,"y":1341907,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585759,"y":643334,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585912,"y":641266,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606698,"y":1097652,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721424,"y":1041236,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716602,"y":1041076,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713177,"y":1035168,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716097,"y":1039635,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718258,"y":1044981,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604957,"y":1119174,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608646,"y":1131291,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":789793,"y":884585,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590641,"y":650472,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516937,"y":617542,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597290,"y":652363,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602843,"y":1115516,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131391,"y":259768,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":112267,"y":270994,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130516,"y":259036,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":184484,"y":89113,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202668,"y":104195,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80785,"y":64120,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604079,"y":1123754,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610879,"y":661373,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243642,"y":133513,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697715,"y":909003,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706519,"y":929511,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704371,"y":916942,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704994,"y":928503,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660833,"y":680577,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672724,"y":860762,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721378,"y":1041202,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711576,"y":1035179,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536838,"y":895042,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":522993,"y":887754,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658111,"y":772248,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610991,"y":793198,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596179,"y":1128372,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605116,"y":1099450,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590720,"y":1130402,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593924,"y":1135500,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647140,"y":1018413,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717657,"y":1041863,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514701,"y":1335184,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409059,"y":409081,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408120,"y":412239,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411631,"y":395736,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":372507,"y":381733,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404667,"y":418954,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594643,"y":1136765,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597247,"y":652260,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":389682,"y":377253,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":302951,"y":318354,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406779,"y":395563,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398855,"y":394748,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400732,"y":381663,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":299557,"y":315964,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298528,"y":337772,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78382,"y":78665,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243328,"y":132260,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583801,"y":644138,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611191,"y":1112340,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596960,"y":652336,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598400,"y":1130624,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874905,"y":923894,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609300,"y":687413,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633710,"y":1038529,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587631,"y":643487,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662943,"y":707689,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628746,"y":717822,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":489528,"y":637521,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530917,"y":892402,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455901,"y":641699,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770509,"y":985180,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713471,"y":777286,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585900,"y":1186110,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593514,"y":1135089,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592746,"y":1145055,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591620,"y":1135308,"year":"2015","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586307,"y":643159,"year":"2015","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587551,"y":1130072,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605919,"y":1122013,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705669,"y":927550,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594007,"y":1137833,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626881,"y":1070585,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663654,"y":1096129,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528172,"y":1310123,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722264,"y":987535,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721550,"y":986802,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688387,"y":1121189,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":732193,"y":997761,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677919,"y":1138458,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714918,"y":1038403,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603764,"y":1129291,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598912,"y":1135126,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592171,"y":1136185,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601678,"y":1120487,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695829,"y":1020800,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590392,"y":1162637,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576954,"y":1255288,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654970,"y":1074640,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630727,"y":1051067,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568030,"y":1124878,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":429133,"y":1379798,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601916,"y":1124467,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603917,"y":1003377,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593855,"y":1145601,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602286,"y":1133776,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557993,"y":1264531,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":777001,"y":1003905,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691131,"y":1006302,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":667766,"y":1095391,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674349,"y":1082464,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636451,"y":952799,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520105,"y":1227862,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":449793,"y":1323519,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567965,"y":1241614,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589775,"y":1132563,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591820,"y":1146357,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730397,"y":972655,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597449,"y":1131379,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680955,"y":1025953,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608850,"y":1128998,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598918,"y":1123898,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680375,"y":1145948,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657639,"y":1145762,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595043,"y":1143212,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653110,"y":1075442,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529302,"y":1310258,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548771,"y":1266160,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407885,"y":1406115,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586827,"y":1131520,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603809,"y":1116328,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626896,"y":1041405,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594787,"y":1136887,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681171,"y":1000877,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593945,"y":1136204,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596178,"y":1123610,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590006,"y":1134336,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557116,"y":1261246,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659435,"y":1204220,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658707,"y":1209374,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591624,"y":1131162,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548049,"y":1218324,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592629,"y":1136535,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729444,"y":783048,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873458,"y":926396,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659615,"y":737075,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607483,"y":685818,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459007,"y":647111,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585359,"y":641040,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589527,"y":650049,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526012,"y":890899,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":480655,"y":512373,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874408,"y":924394,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618273,"y":633573,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594918,"y":665920,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517376,"y":621105,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460606,"y":646069,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640005,"y":777919,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661478,"y":674938,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540979,"y":881327,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644815,"y":733398,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774173,"y":838241,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594317,"y":650650,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658353,"y":745919,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625827,"y":718316,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611619,"y":794434,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603924,"y":678705,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874477,"y":924321,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":500952,"y":646490,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509581,"y":646826,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595671,"y":652831,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":465381,"y":653798,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":892202,"y":936309,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614652,"y":681401,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452786,"y":639669,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591535,"y":660786,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601711,"y":655349,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598272,"y":648558,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":426347,"y":695189,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":431934,"y":695459,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627640,"y":713092,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631064,"y":715402,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591160,"y":658103,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420766,"y":694290,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657370,"y":792809,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656664,"y":791593,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662807,"y":789583,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772140,"y":837782,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773625,"y":838095,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773619,"y":837252,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":757128,"y":844287,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603396,"y":677586,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607461,"y":792685,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600333,"y":647023,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414156,"y":729420,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516625,"y":620392,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528813,"y":891798,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588622,"y":640480,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596762,"y":649518,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768605,"y":828953,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768210,"y":821584,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771340,"y":816694,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764090,"y":823939,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773866,"y":832626,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612292,"y":795585,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612785,"y":796279,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610552,"y":793662,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660776,"y":749984,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657433,"y":744637,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660431,"y":746273,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652474,"y":787863,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597033,"y":650839,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874460,"y":924186,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773695,"y":837276,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605241,"y":682791,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514303,"y":646354,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510086,"y":623672,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":759142,"y":857029,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660653,"y":746413,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772488,"y":834565,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657389,"y":702287,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412504,"y":703262,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593797,"y":659927,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711917,"y":775782,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770253,"y":845026,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591610,"y":650165,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819658,"y":886158,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590143,"y":655399,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460695,"y":646878,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587123,"y":646675,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765320,"y":822912,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662454,"y":679708,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767616,"y":822395,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588647,"y":650524,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592854,"y":650689,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662593,"y":679652,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604446,"y":658735,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745211,"y":788308,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597291,"y":652363,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":465076,"y":653428,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517388,"y":618206,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":903258,"y":1004278,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593388,"y":662072,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774630,"y":824625,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471247,"y":652008,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745073,"y":891631,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745676,"y":890827,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603314,"y":655999,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592621,"y":654250,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873422,"y":925331,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":812477,"y":888633,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":463897,"y":651522,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457266,"y":643946,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680461,"y":746144,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549320,"y":835117,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874555,"y":924014,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456695,"y":642437,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767285,"y":821147,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602901,"y":655305,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585044,"y":642936,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":877003,"y":922880,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874252,"y":924536,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454921,"y":470358,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404073,"y":400246,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337278,"y":354713,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337349,"y":353742,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402617,"y":395226,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294156,"y":288121,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237083,"y":334849,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290964,"y":515401,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320095,"y":586755,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411831,"y":397003,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80846,"y":63953,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241712,"y":128924,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":251896,"y":146779,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":33944,"y":161945,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":394315,"y":500291,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":358968,"y":430225,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":104662,"y":281521,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101095,"y":221813,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95207,"y":220400,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":117049,"y":225924,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149258,"y":239851,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403957,"y":403187,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":351108,"y":365440,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414478,"y":398528,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405884,"y":393268,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406136,"y":401322,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402493,"y":398863,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408060,"y":395188,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408541,"y":397308,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411411,"y":396835,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407814,"y":395572,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408047,"y":397305,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408817,"y":407139,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404575,"y":395443,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409338,"y":383474,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413947,"y":388060,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":445097,"y":466481,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410364,"y":395277,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406018,"y":400797,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402213,"y":396000,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409760,"y":400768,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400897,"y":380149,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399001,"y":394717,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400515,"y":399690,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296913,"y":292953,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297925,"y":298644,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289746,"y":272562,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407437,"y":392254,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79593,"y":65804,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":141336,"y":45139,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243997,"y":134507,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244050,"y":133933,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242797,"y":133072,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242002,"y":135130,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80707,"y":63630,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":75227,"y":50433,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149258,"y":239851,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336858,"y":354334,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80207,"y":66013,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244648,"y":135061,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":117414,"y":92147,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278618,"y":222520,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278618,"y":222520,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130814,"y":259586,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409917,"y":412866,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297228,"y":297716,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":405314,"y":393578,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":245798,"y":136036,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":134800,"y":262039,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243922,"y":130438,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83097,"y":66540,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":361863,"y":663565,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":361844,"y":663880,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289718,"y":514667,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288513,"y":512894,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":385921,"y":524560,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226427,"y":420224,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":229817,"y":430836,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":145162,"y":363830,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412015,"y":387860,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100722,"y":222437,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":110377,"y":226718,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402348,"y":395614,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131068,"y":259506,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243223,"y":131965,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408523,"y":403533,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387040,"y":389421,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410262,"y":502635,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403042,"y":421356,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410549,"y":422304,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":217421,"y":184781,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":270211,"y":238159,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":235000,"y":340458,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":431295,"y":370726,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":255484,"y":164270,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268670,"y":215219,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244753,"y":136776,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413003,"y":399584,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154859,"y":246007,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":220011,"y":128078,"year":"2003","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79720,"y":66837,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":317440,"y":592994,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411816,"y":393786,"year":"2003","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638129,"y":1031606,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603464,"y":1115877,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600956,"y":1129135,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772321,"y":836137,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626325,"y":956505,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683720,"y":1149866,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665950,"y":1085945,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633343,"y":988117,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546400,"y":834776,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":527749,"y":891398,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698613,"y":1046390,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606710,"y":1117964,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704561,"y":928898,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571642,"y":1256791,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616834,"y":1143270,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608542,"y":1111637,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603225,"y":1133097,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594196,"y":1135462,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593796,"y":1128822,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590475,"y":1129328,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592848,"y":1135295,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594503,"y":1136283,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556725,"y":1261324,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":733502,"y":1009292,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687473,"y":1122498,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621917,"y":1141244,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640743,"y":1007203,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555604,"y":1260997,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556985,"y":1261586,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495945,"y":1291560,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555487,"y":1258897,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":791238,"y":993104,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":545111,"y":1285029,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705703,"y":927343,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532436,"y":1311320,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594099,"y":1136606,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707905,"y":927433,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":466616,"y":1329767,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776966,"y":1011954,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599670,"y":1099368,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599670,"y":1099368,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593154,"y":1142333,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592432,"y":1140940,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585963,"y":642937,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460740,"y":1330894,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611763,"y":1125542,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604846,"y":1122466,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604831,"y":1122480,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601215,"y":1120298,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593634,"y":1129820,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623722,"y":1075719,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603967,"y":1129207,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601414,"y":1130564,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601147,"y":1129483,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607198,"y":1133644,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601586,"y":1136158,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606502,"y":1129243,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602781,"y":1122913,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720135,"y":1042557,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722286,"y":1041622,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693771,"y":1079967,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694223,"y":1051251,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583928,"y":1134310,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410454,"y":1403003,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":418668,"y":1397937,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684679,"y":1006352,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693110,"y":1005732,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665177,"y":1097010,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591498,"y":1135396,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593448,"y":1134219,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578879,"y":1216934,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604297,"y":1120088,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620218,"y":1082889,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628615,"y":1062240,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693958,"y":1019442,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592074,"y":1132480,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587232,"y":1172730,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596217,"y":1119802,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720752,"y":1043092,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":563206,"y":1269560,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588698,"y":1132425,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722248,"y":989797,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":563206,"y":1269560,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599378,"y":1121985,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641372,"y":1029764,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595029,"y":1136138,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722377,"y":990125,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590504,"y":1144126,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718008,"y":1045778,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601294,"y":1134712,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600196,"y":1131223,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695990,"y":1004378,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":498918,"y":1290712,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728472,"y":975381,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556598,"y":1298966,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582513,"y":1133415,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461221,"y":647347,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630053,"y":1051317,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591794,"y":1191986,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598401,"y":1136064,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596366,"y":1132794,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593381,"y":1140216,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594782,"y":1136889,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632666,"y":1049874,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705589,"y":928825,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605883,"y":1117020,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721987,"y":989437,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515723,"y":620528,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604985,"y":1097778,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131973,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602065,"y":1130874,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602761,"y":1120927,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606106,"y":1097112,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632366,"y":1037535,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600581,"y":1121479,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597483,"y":1138643,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590172,"y":1151077,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776069,"y":824838,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767270,"y":838137,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773407,"y":835609,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772509,"y":825404,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435628,"y":668237,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709370,"y":773748,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641347,"y":762800,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":429439,"y":623937,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420051,"y":621084,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647150,"y":1052799,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516350,"y":618834,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":886112,"y":927110,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450280,"y":640024,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521378,"y":644507,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":496132,"y":530523,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649355,"y":783371,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601217,"y":655775,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641954,"y":858320,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554592,"y":1271273,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548350,"y":850969,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594030,"y":663809,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744065,"y":757747,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":781734,"y":876122,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591741,"y":660679,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541152,"y":881298,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611170,"y":688794,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874827,"y":924422,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716175,"y":1041756,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819900,"y":886236,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":789985,"y":884445,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616270,"y":792827,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":466744,"y":654339,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594387,"y":660287,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595030,"y":661529,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658712,"y":745818,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456261,"y":642757,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455891,"y":641690,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456639,"y":642318,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581791,"y":1139979,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586814,"y":646346,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591468,"y":660488,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594521,"y":660320,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593706,"y":659949,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531183,"y":892686,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594037,"y":665831,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611907,"y":791330,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591969,"y":663605,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593606,"y":660563,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654849,"y":1017847,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585505,"y":643213,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607114,"y":1125864,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658317,"y":739754,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873380,"y":924067,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":436986,"y":664481,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447882,"y":642899,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":157102,"y":204917,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602268,"y":656127,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":444121,"y":652686,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530215,"y":891090,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768020,"y":832529,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773872,"y":852546,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641211,"y":723903,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537570,"y":895080,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592938,"y":650746,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530134,"y":890083,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517086,"y":637708,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":319289,"y":481081,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723985,"y":989060,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585601,"y":643820,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611175,"y":688964,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518350,"y":620731,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406616,"y":395165,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584152,"y":638964,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":798002,"y":919334,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483644,"y":655960,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585542,"y":643127,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586412,"y":640714,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771515,"y":836130,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":854376,"y":948897,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629061,"y":711422,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630486,"y":716785,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617286,"y":789414,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":373963,"y":552668,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517764,"y":623465,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519105,"y":619037,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408291,"y":397295,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608954,"y":906224,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661517,"y":679515,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602934,"y":1119780,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644128,"y":867132,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407899,"y":394017,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644702,"y":876869,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521599,"y":854427,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594476,"y":666076,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594819,"y":665924,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583890,"y":1133238,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613126,"y":1097984,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612451,"y":794367,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657540,"y":744549,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659290,"y":745294,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874277,"y":925150,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819348,"y":886967,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765649,"y":767447,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591878,"y":1130733,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731444,"y":779997,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657539,"y":746577,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586945,"y":640962,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586167,"y":642845,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586422,"y":643222,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660882,"y":743036,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":430846,"y":374828,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585987,"y":642990,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594690,"y":651654,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591692,"y":660259,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460704,"y":647125,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457787,"y":644334,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656953,"y":744947,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658955,"y":745586,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660792,"y":744691,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660120,"y":745950,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601252,"y":676774,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605883,"y":684657,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595252,"y":662931,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604314,"y":688042,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530605,"y":889943,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533290,"y":892346,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571917,"y":908177,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547861,"y":860885,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575596,"y":910208,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587703,"y":1129872,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564524,"y":814344,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530417,"y":891968,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80758,"y":64583,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631829,"y":1037481,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528941,"y":891847,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532560,"y":893523,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607064,"y":1115567,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597488,"y":650527,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610220,"y":660977,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531556,"y":892825,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530368,"y":892380,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590448,"y":1149089,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599558,"y":646950,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596848,"y":652257,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599184,"y":655015,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599439,"y":653369,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585527,"y":642746,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585963,"y":642937,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585617,"y":643292,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547545,"y":832426,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583519,"y":644222,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594110,"y":650384,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606490,"y":685104,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588813,"y":648912,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586391,"y":642743,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586083,"y":643767,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766308,"y":821835,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588746,"y":647931,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586069,"y":643881,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":638553,"y":1029006,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582469,"y":644127,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774176,"y":837338,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611049,"y":661516,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661040,"y":679450,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658056,"y":678190,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635562,"y":1031940,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644103,"y":665703,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613683,"y":665467,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603897,"y":678651,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594690,"y":1128863,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593720,"y":1130940,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596856,"y":663758,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585952,"y":644035,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594199,"y":650728,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787850,"y":1007852,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":785673,"y":988158,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695457,"y":663036,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614572,"y":664315,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630907,"y":733157,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787036,"y":1006779,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773392,"y":836982,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678046,"y":734071,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700827,"y":760269,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695634,"y":756749,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773974,"y":837012,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709971,"y":774309,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710020,"y":774302,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700937,"y":760469,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697465,"y":763393,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450020,"y":637915,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594219,"y":1136515,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413736,"y":607376,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420147,"y":618085,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518491,"y":622596,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510038,"y":544620,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517759,"y":628598,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420830,"y":692632,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437636,"y":661842,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592956,"y":1134395,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":375178,"y":581192,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":381034,"y":588219,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630234,"y":716634,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604426,"y":1095746,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628349,"y":713957,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624164,"y":706107,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594577,"y":1134796,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590916,"y":1144525,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680683,"y":746903,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773000,"y":1012330,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713254,"y":715554,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606399,"y":1118454,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634484,"y":745316,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":276944,"y":232606,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":380531,"y":588220,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819739,"y":886168,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594839,"y":1134324,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":388217,"y":597823,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766357,"y":849207,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460815,"y":646973,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772718,"y":836210,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773709,"y":837484,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653850,"y":762527,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647409,"y":766327,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":366589,"y":591479,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769919,"y":835302,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598957,"y":1188849,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722498,"y":989788,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723374,"y":988493,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599442,"y":1123081,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":788629,"y":1007972,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725904,"y":1039220,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726414,"y":1036872,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727609,"y":1033685,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596979,"y":1130226,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600004,"y":1123823,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658858,"y":1068556,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605917,"y":1097366,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607206,"y":1126263,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606229,"y":1117998,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607150,"y":1133631,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588124,"y":1171516,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618425,"y":961127,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587502,"y":1171561,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570042,"y":1164076,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556070,"y":1262090,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691983,"y":1095188,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690627,"y":1118339,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680690,"y":1069532,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590087,"y":1129439,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715534,"y":1042301,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718452,"y":1045723,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708291,"y":1039521,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704439,"y":928985,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707385,"y":1039442,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699971,"y":967560,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684152,"y":1127279,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593224,"y":1133453,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592929,"y":1135354,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590588,"y":1131410,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590183,"y":1151061,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602198,"y":1126110,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592277,"y":1137388,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625240,"y":1094906,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587376,"y":1172185,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584124,"y":1135101,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588251,"y":1131505,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592465,"y":1137824,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580660,"y":1135609,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582321,"y":1140436,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580920,"y":1139844,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600982,"y":1128998,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585671,"y":1129085,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585853,"y":1129888,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585849,"y":1127108,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595485,"y":1133121,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594847,"y":1136740,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594839,"y":1136183,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592919,"y":1134007,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593071,"y":1136179,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590368,"y":1135941,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602118,"y":1124274,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612239,"y":1124865,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582234,"y":1133770,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584539,"y":1126909,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729123,"y":1029332,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686234,"y":902673,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581091,"y":1135080,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588337,"y":1131507,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690732,"y":1118312,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607289,"y":1095136,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660453,"y":1117761,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672331,"y":1101333,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567525,"y":1283860,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557114,"y":1265014,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604547,"y":1122764,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687480,"y":1007249,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691353,"y":1068601,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553232,"y":1276249,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612146,"y":1125357,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613115,"y":1099781,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643841,"y":1087738,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704217,"y":929862,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612165,"y":1112142,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598872,"y":1122541,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704184,"y":930257,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569937,"y":1285607,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713934,"y":1036724,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704159,"y":929478,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727537,"y":1033952,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718648,"y":1045391,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638867,"y":1030935,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638057,"y":1031569,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719847,"y":1044073,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704103,"y":929300,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684323,"y":994801,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693503,"y":1085756,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658063,"y":1059111,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716635,"y":1035667,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594543,"y":1131768,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612927,"y":1126038,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590769,"y":1162550,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730916,"y":965723,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":561780,"y":1268614,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599957,"y":1029471,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591103,"y":1131507,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680696,"y":1029505,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1135190,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539908,"y":1308648,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594303,"y":1136737,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593627,"y":1140386,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590491,"y":1149273,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599661,"y":1121920,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593540,"y":1140469,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599350,"y":1129677,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610040,"y":1107875,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608359,"y":1112213,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591646,"y":1134378,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593805,"y":1128818,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593748,"y":1135367,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597691,"y":1132231,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588728,"y":1131545,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602756,"y":1133507,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598958,"y":1130716,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599791,"y":1134995,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587042,"y":1129148,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580868,"y":1135374,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596189,"y":1119941,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592266,"y":1150957,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595894,"y":1142147,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592693,"y":1150407,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591984,"y":1145292,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591494,"y":1152012,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590817,"y":1145965,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594602,"y":1136164,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620663,"y":1141538,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595242,"y":1133561,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597601,"y":1132001,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596201,"y":1132645,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602942,"y":1115355,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602925,"y":1117464,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606514,"y":1117037,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596436,"y":1122568,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607095,"y":1124146,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607547,"y":1130163,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606667,"y":1130657,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600616,"y":1100309,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601495,"y":1132961,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590041,"y":1132621,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603354,"y":1132373,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602233,"y":1118891,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594686,"y":1134631,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593462,"y":1136889,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591341,"y":1130661,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590285,"y":1130668,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592278,"y":1137378,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599805,"y":1134946,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595224,"y":1136419,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592538,"y":1128001,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602522,"y":1128411,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588446,"y":1130032,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591100,"y":1129445,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592626,"y":1134921,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593602,"y":1143810,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593133,"y":1142799,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600984,"y":1135048,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599225,"y":1130781,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598179,"y":1128413,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601848,"y":1119711,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640783,"y":1030577,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637136,"y":1031068,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637113,"y":1032463,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593079,"y":1137131,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607076,"y":1116517,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588591,"y":1132533,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589486,"y":1129822,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589136,"y":1147317,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592536,"y":1150088,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592789,"y":1144439,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592699,"y":1140691,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592844,"y":1142178,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580900,"y":1135336,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592181,"y":1129767,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693657,"y":1081482,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":506186,"y":1334397,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537032,"y":1309863,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495044,"y":1309694,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461814,"y":1329519,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460737,"y":1330503,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576968,"y":1193399,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598495,"y":1136137,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594805,"y":1131260,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602146,"y":1131712,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594323,"y":1136297,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597053,"y":1131783,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601097,"y":1129941,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588324,"y":1130485,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594161,"y":1136358,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584351,"y":1129814,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582913,"y":1133243,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582380,"y":1133890,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612954,"y":1111400,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598558,"y":1083814,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607825,"y":1120148,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607427,"y":1125554,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597501,"y":1122236,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598719,"y":1123716,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598821,"y":1130116,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600524,"y":1121743,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605783,"y":1116736,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608243,"y":1119871,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603374,"y":1115843,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602010,"y":1121801,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604945,"y":1120315,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605916,"y":1121390,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587373,"y":1130219,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581604,"y":1138818,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586537,"y":1129224,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581704,"y":1135386,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569703,"y":1123688,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581743,"y":1135896,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581139,"y":1134858,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584553,"y":1127007,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605759,"y":1118719,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606264,"y":1094801,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587041,"y":1129628,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582855,"y":1133017,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586470,"y":1130276,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582717,"y":1133046,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581095,"y":1135065,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712296,"y":1024664,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713876,"y":1034780,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634117,"y":1032164,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638379,"y":1032747,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638008,"y":1031196,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718628,"y":997269,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720437,"y":991388,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712425,"y":1035011,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602894,"y":1124294,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598591,"y":1130348,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588948,"y":1133936,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593872,"y":1140896,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606282,"y":1095945,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629745,"y":950896,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645593,"y":1036143,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630057,"y":1023681,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690969,"y":1094317,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681441,"y":1135256,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677896,"y":1137417,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674545,"y":1134976,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688526,"y":1033508,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711285,"y":939681,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675219,"y":873237,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596861,"y":1125296,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581107,"y":1140039,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575182,"y":1145273,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585755,"y":1176214,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586313,"y":1162543,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573275,"y":1200181,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586649,"y":1173512,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583034,"y":1189856,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576399,"y":1193836,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581005,"y":1147304,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566519,"y":1147199,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614670,"y":1095353,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607182,"y":1093825,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627867,"y":1059150,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638011,"y":1030144,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581584,"y":1160621,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556512,"y":1261481,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562820,"y":1246604,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555110,"y":1267166,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555845,"y":1261151,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554793,"y":1259872,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556832,"y":1262844,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562790,"y":1269479,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555968,"y":1267128,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557224,"y":1265362,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556787,"y":1265448,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584508,"y":1151707,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586545,"y":1186450,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590404,"y":1186500,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588614,"y":1166317,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570955,"y":1205844,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691001,"y":1095679,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604604,"y":1120455,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":468777,"y":1328658,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634205,"y":1091195,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624845,"y":1055063,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631718,"y":1049888,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629894,"y":1049507,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576548,"y":1193649,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575734,"y":1194760,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571479,"y":1161744,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603058,"y":1094562,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713930,"y":1035173,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713544,"y":1039343,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715218,"y":1038394,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716561,"y":1036056,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604861,"y":1121925,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710276,"y":1039271,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694276,"y":1052196,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":735465,"y":1020189,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719182,"y":1042484,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713073,"y":1038976,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713647,"y":1035935,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716334,"y":1040219,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":721617,"y":1040575,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717859,"y":1046173,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713637,"y":1035696,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714305,"y":1037300,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723078,"y":1039548,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708105,"y":1039502,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718264,"y":1045144,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716261,"y":1041270,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709554,"y":1033544,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713275,"y":1042370,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687855,"y":985452,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682255,"y":997976,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598123,"y":1005744,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634467,"y":988466,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631383,"y":986057,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642627,"y":994966,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642241,"y":1008014,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716421,"y":1040976,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772769,"y":1004151,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715881,"y":1037839,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726414,"y":1036872,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677598,"y":1071504,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673069,"y":1076488,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690489,"y":1092263,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690073,"y":1119400,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691847,"y":1094072,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692288,"y":1093740,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687065,"y":1072976,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660058,"y":1087838,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660732,"y":1106844,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658073,"y":1147557,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686890,"y":1110583,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691803,"y":1067611,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741996,"y":1024855,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705932,"y":1033175,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726520,"y":1038748,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568493,"y":1244874,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568315,"y":1256282,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":754044,"y":1022341,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722271,"y":1041505,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":702352,"y":945288,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741299,"y":998512,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641186,"y":1029657,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690732,"y":1117544,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671072,"y":1100362,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685042,"y":1106711,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720237,"y":991439,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676274,"y":875681,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704420,"y":918501,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719861,"y":989157,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627154,"y":1094871,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586291,"y":1098066,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586447,"y":1159700,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590458,"y":1160192,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596335,"y":1162747,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637107,"y":1031620,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600724,"y":1129375,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593729,"y":1135563,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576338,"y":1225203,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592193,"y":1129773,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602316,"y":1135450,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521954,"y":1314432,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525672,"y":1218745,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514989,"y":1237138,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411121,"y":1402437,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473022,"y":1359246,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":488067,"y":1344696,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471702,"y":1357192,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471693,"y":1357348,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":480096,"y":1343135,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536504,"y":1305084,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":522455,"y":1313569,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598971,"y":1133449,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625418,"y":1072865,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608243,"y":1119871,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576522,"y":1225001,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665916,"y":1145197,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598583,"y":1122810,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607063,"y":1115487,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637695,"y":1034819,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640485,"y":1032029,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596428,"y":1122514,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635260,"y":1032168,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602344,"y":1129398,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602344,"y":1129398,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518714,"y":1324043,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589109,"y":1132420,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595486,"y":1143912,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585944,"y":1176870,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597364,"y":1131985,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548797,"y":1221971,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609963,"y":1112280,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605439,"y":1129010,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535588,"y":1311562,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594899,"y":1136891,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680838,"y":1027958,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593475,"y":1135167,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619346,"y":1121993,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591100,"y":1129445,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683019,"y":1071863,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687389,"y":987869,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607491,"y":1132585,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706233,"y":928491,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592877,"y":1130104,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606535,"y":1122947,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596255,"y":1119877,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689619,"y":1099994,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594561,"y":1136445,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":472032,"y":1283230,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719445,"y":1043683,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601067,"y":1123249,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556485,"y":1260180,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590672,"y":1140669,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770462,"y":833176,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773597,"y":837190,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657195,"y":742906,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658950,"y":745319,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433427,"y":662689,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595046,"y":661555,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767006,"y":820947,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658451,"y":747850,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645038,"y":728347,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658475,"y":746145,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530530,"y":892441,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":902226,"y":991214,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773961,"y":836652,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652091,"y":753946,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651990,"y":774322,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766166,"y":822540,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459140,"y":647257,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633902,"y":909592,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520072,"y":642871,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447557,"y":634180,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636674,"y":909073,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438080,"y":664284,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":451332,"y":634409,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642814,"y":739035,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649387,"y":669843,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764904,"y":822060,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767505,"y":823289,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434735,"y":628336,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608012,"y":797754,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447756,"y":643042,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452378,"y":639876,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456287,"y":641953,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460978,"y":646967,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590075,"y":653344,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585896,"y":643686,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589552,"y":650194,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640236,"y":766163,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632243,"y":661682,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613278,"y":663082,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590815,"y":661442,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611118,"y":688674,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596762,"y":649518,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460925,"y":646207,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589579,"y":638798,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874670,"y":923124,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650247,"y":907830,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680113,"y":895837,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408047,"y":712107,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452835,"y":639453,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595654,"y":671387,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459926,"y":645949,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776299,"y":810427,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592617,"y":659995,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611361,"y":661411,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594055,"y":663828,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639260,"y":777261,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406498,"y":709499,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529519,"y":889728,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546979,"y":832071,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773735,"y":836853,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":522469,"y":645116,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593966,"y":651070,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590799,"y":654829,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700513,"y":760328,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874054,"y":924696,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415392,"y":607936,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434096,"y":671382,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414231,"y":607452,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":551362,"y":851654,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632618,"y":909231,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589327,"y":639116,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599481,"y":654861,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771761,"y":838052,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":550198,"y":843001,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":865036,"y":947815,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456279,"y":644075,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874844,"y":923643,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460757,"y":646869,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":746196,"y":890692,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599473,"y":653382,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597528,"y":652766,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770631,"y":835465,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771584,"y":835528,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768782,"y":832344,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598406,"y":662734,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657001,"y":760933,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613322,"y":664851,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590046,"y":653281,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874435,"y":924365,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595331,"y":649898,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640315,"y":765322,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656632,"y":763590,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516814,"y":619810,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701418,"y":764617,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700967,"y":760410,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":596978,"y":652961,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":760888,"y":823320,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657683,"y":744310,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767261,"y":821178,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517390,"y":618023,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542591,"y":899521,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874406,"y":925712,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524641,"y":611026,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457935,"y":645835,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586528,"y":637805,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590853,"y":642733,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586850,"y":641008,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587428,"y":639846,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590388,"y":654272,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589007,"y":650729,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662026,"y":680866,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":513795,"y":845536,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539146,"y":856928,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459923,"y":647958,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454909,"y":643421,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459103,"y":646421,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586043,"y":643113,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615707,"y":790710,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612374,"y":791954,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770711,"y":847564,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643998,"y":882556,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533079,"y":871613,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517075,"y":618184,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517372,"y":620429,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658141,"y":746903,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663171,"y":743894,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603150,"y":655902,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597224,"y":649196,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771576,"y":835538,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673820,"y":736116,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644128,"y":882287,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659907,"y":746152,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640253,"y":766173,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512878,"y":617969,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585400,"y":642804,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625875,"y":734416,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766347,"y":821785,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819949,"y":886227,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433191,"y":672384,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546597,"y":834734,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":772219,"y":836056,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599728,"y":653938,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413368,"y":607442,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762287,"y":823020,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654844,"y":758981,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768555,"y":821795,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767022,"y":821295,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773963,"y":828740,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774063,"y":853443,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773961,"y":837411,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642706,"y":786916,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524318,"y":646932,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483951,"y":658870,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773963,"y":830556,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589131,"y":648121,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611927,"y":663230,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589131,"y":648121,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649595,"y":671384,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603688,"y":683317,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594181,"y":650359,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770844,"y":834938,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626469,"y":710213,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594079,"y":665912,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460344,"y":645693,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585857,"y":643508,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585963,"y":642937,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595656,"y":652403,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611856,"y":794690,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768684,"y":820850,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591618,"y":660798,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874907,"y":922788,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761944,"y":822503,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639470,"y":908540,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654648,"y":876399,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":442879,"y":649434,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874503,"y":924250,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587359,"y":641543,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585704,"y":643252,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651239,"y":669958,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585542,"y":643127,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741595,"y":784244,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519741,"y":642738,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":747183,"y":880516,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652074,"y":786841,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":393650,"y":599911,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":870777,"y":927055,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875295,"y":924215,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603452,"y":656931,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607109,"y":792666,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":833629,"y":960694,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406622,"y":394337,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407812,"y":395814,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":334854,"y":361161,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":207895,"y":319412,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413814,"y":397437,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402871,"y":396075,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410631,"y":395735,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237724,"y":344325,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":295272,"y":298951,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411145,"y":399031,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":252716,"y":134995,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80682,"y":64064,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":139153,"y":221984,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":182434,"y":282209,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":283182,"y":260445,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409404,"y":397143,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408055,"y":396058,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83097,"y":66540,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":292829,"y":520088,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":375327,"y":526435,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":321332,"y":592254,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":385163,"y":369570,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":293152,"y":485705,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":279003,"y":479534,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":333477,"y":428430,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408496,"y":413446,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433861,"y":375382,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400822,"y":400462,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415023,"y":388589,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208267,"y":112454,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241976,"y":129610,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240109,"y":133702,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288305,"y":313605,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407924,"y":397304,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414232,"y":398388,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":133123,"y":259561,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":72397,"y":239461,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406072,"y":394958,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243718,"y":129801,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407325,"y":396894,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409188,"y":394414,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399107,"y":396573,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":335277,"y":356562,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336849,"y":348270,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337713,"y":354620,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":328069,"y":387093,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":308518,"y":336650,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296881,"y":299972,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":292510,"y":281917,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409460,"y":396310,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":295209,"y":299859,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":358604,"y":370520,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":321689,"y":592637,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":350678,"y":581602,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":368901,"y":529041,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411563,"y":394151,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":401850,"y":389073,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408920,"y":397304,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410760,"y":395904,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408302,"y":394891,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":409513,"y":394234,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405314,"y":393578,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406132,"y":401002,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408298,"y":396059,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":33689,"y":166768,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":143291,"y":230537,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412877,"y":398106,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410752,"y":395911,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":133079,"y":261456,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95652,"y":220613,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243089,"y":130789,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":254261,"y":163773,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459918,"y":481004,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83302,"y":67881,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243695,"y":131499,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":186244,"y":70303,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402495,"y":394810,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":133831,"y":259625,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242257,"y":131135,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80744,"y":64824,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":77559,"y":120834,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":49057,"y":242041,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123368,"y":102004,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":132902,"y":103484,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399168,"y":394782,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241680,"y":130738,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":353399,"y":400959,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401520,"y":386322,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147887,"y":368154,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":299532,"y":481191,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":304440,"y":564152,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288847,"y":513342,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78515,"y":68563,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":23543,"y":173322,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":43832,"y":219941,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135926,"y":103849,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153828,"y":198705,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131107,"y":259461,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243228,"y":131629,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":177113,"y":224144,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":63023,"y":253536,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243296,"y":130121,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243502,"y":133419,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154044,"y":198114,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135256,"y":261456,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242889,"y":131395,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240798,"y":134728,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402291,"y":394647,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413329,"y":425642,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":391610,"y":420736,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":236997,"y":337388,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243152,"y":130871,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406788,"y":391883,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101081,"y":221827,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130140,"y":44337,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101048,"y":175767,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402121,"y":396351,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240085,"y":128623,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79655,"y":65007,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":365074,"y":400468,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401195,"y":384084,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":395189,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":444828,"y":463828,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231916,"y":130776,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131014,"y":259763,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":273350,"y":220907,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241999,"y":128577,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80782,"y":64170,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401768,"y":399034,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138648,"y":221401,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336625,"y":354008,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460057,"y":473031,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243228,"y":131629,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154049,"y":138166,"year":"2004","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402636,"y":399807,"year":"2004","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602769,"y":1127510,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557258,"y":1261825,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521899,"y":1307815,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":341841,"y":552387,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576529,"y":1144660,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639669,"y":1031013,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":67159,"y":246290,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589634,"y":1143396,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705222,"y":930147,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":151870,"y":198568,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587119,"y":1162108,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637732,"y":1035807,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773619,"y":837332,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768322,"y":829518,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656863,"y":742808,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607064,"y":1115581,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457224,"y":643876,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437199,"y":654944,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":370472,"y":571954,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433547,"y":626814,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400030,"y":598192,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603613,"y":1123652,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457625,"y":644128,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595374,"y":650837,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461631,"y":647644,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592203,"y":1140759,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521040,"y":643974,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662185,"y":780270,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871799,"y":925508,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768666,"y":862815,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771878,"y":859990,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761929,"y":823844,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407558,"y":420966,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765590,"y":849830,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691087,"y":1117512,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":443993,"y":1373799,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762619,"y":842239,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374252,"y":551718,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766781,"y":822316,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768184,"y":821568,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":441910,"y":1368684,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767681,"y":820614,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766635,"y":821205,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762196,"y":822282,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":442334,"y":1373562,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762492,"y":815588,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400998,"y":397472,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529027,"y":892190,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405808,"y":401509,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":757512,"y":823817,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769655,"y":817855,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873694,"y":924009,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591434,"y":660536,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719763,"y":1035647,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767434,"y":821108,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515663,"y":616987,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657080,"y":746042,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625895,"y":781584,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715588,"y":1042238,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627125,"y":778221,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585609,"y":647780,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604512,"y":657961,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588064,"y":647379,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437227,"y":696707,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597261,"y":652256,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580993,"y":648739,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":893236,"y":939889,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588522,"y":649590,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":439712,"y":646317,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661813,"y":679894,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680078,"y":812321,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586368,"y":642754,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":892512,"y":1047018,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":798027,"y":910231,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670417,"y":831522,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632883,"y":849445,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640141,"y":907821,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632603,"y":912267,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612372,"y":796073,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600436,"y":654120,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617014,"y":798865,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609096,"y":793028,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607607,"y":800473,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587800,"y":649668,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773853,"y":837010,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":900636,"y":956173,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":248423,"y":454783,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":900748,"y":956318,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588822,"y":648875,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584967,"y":646756,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630335,"y":716425,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592387,"y":650511,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":828411,"y":938649,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":449349,"y":641142,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409637,"y":394169,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402707,"y":394603,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649057,"y":775427,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400796,"y":400358,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407577,"y":394347,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407321,"y":396418,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405012,"y":396353,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407808,"y":396420,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411667,"y":395719,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404304,"y":393523,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407570,"y":395570,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410476,"y":395099,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":388176,"y":516558,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434589,"y":367167,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297680,"y":326942,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411281,"y":401404,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402562,"y":398190,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282486,"y":260754,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296411,"y":332378,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411209,"y":394978,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407814,"y":395572,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":386493,"y":501369,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634487,"y":773903,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":418884,"y":500702,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":425019,"y":365513,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410715,"y":367000,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":143131,"y":216897,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96050,"y":220252,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":429597,"y":456876,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":306639,"y":335385,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591933,"y":659370,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408174,"y":393776,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409512,"y":404254,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337732,"y":355039,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101064,"y":76987,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":148008,"y":171858,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243299,"y":132548,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872667,"y":925183,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131892,"y":260011,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":169400,"y":216219,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78992,"y":68640,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770275,"y":836981,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587285,"y":1130215,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":214261,"y":273313,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":119935,"y":221912,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244170,"y":134626,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79855,"y":65018,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":254301,"y":137249,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398255,"y":396626,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":132032,"y":220327,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":132032,"y":220327,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677343,"y":1071872,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713722,"y":1039203,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":190374,"y":111607,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":232088,"y":130698,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":145194,"y":118592,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":102193,"y":186606,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720364,"y":1042226,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686998,"y":1007359,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718241,"y":1045172,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722874,"y":1041293,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243535,"y":133210,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244011,"y":130335,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101022,"y":221022,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611816,"y":794996,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596837,"y":1140974,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596857,"y":1140919,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592052,"y":1147968,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242105,"y":132232,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729970,"y":1029034,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137798,"y":220857,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":119935,"y":221912,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":124469,"y":103775,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":10000,"y":94595,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407074,"y":404941,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290548,"y":514896,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":236464,"y":129948,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":293489,"y":521184,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":293343,"y":513087,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407909,"y":400024,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412791,"y":389689,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336379,"y":353888,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414665,"y":398634,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718299,"y":1044672,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405845,"y":396415,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":346440,"y":583229,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399033,"y":395300,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408940,"y":396063,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409461,"y":396061,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414115,"y":392602,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411247,"y":394377,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":409021,"y":395943,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407813,"y":395592,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407812,"y":395795,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":672557,"y":1073409,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404743,"y":393892,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414681,"y":398624,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410528,"y":401178,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415153,"y":391312,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767428,"y":820954,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405032,"y":398601,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519285,"y":1320672,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414392,"y":397930,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408051,"y":396664,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411112,"y":395726,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408419,"y":399305,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408057,"y":395573,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411970,"y":394908,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718178,"y":1045250,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594754,"y":1131003,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":378439,"y":396080,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":386450,"y":388756,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":389813,"y":377386,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665762,"y":713090,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":394747,"y":393408,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543498,"y":898704,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242636,"y":129163,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460551,"y":472554,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412169,"y":394766,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523102,"y":1302621,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401136,"y":395168,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407919,"y":398123,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":357874,"y":588454,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":307627,"y":572408,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":371498,"y":531618,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688769,"y":1074031,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":371498,"y":531618,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130571,"y":258925,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290104,"y":514416,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290237,"y":515424,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627798,"y":1055554,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":292406,"y":513546,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642972,"y":1002743,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282980,"y":500350,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":265707,"y":472562,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":308537,"y":482909,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402165,"y":376431,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":358902,"y":410351,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628986,"y":1064500,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605492,"y":1099963,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":391482,"y":396448,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294667,"y":300936,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708452,"y":1041202,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":310541,"y":337927,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":332955,"y":351095,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":225346,"y":328637,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":321397,"y":591908,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297751,"y":299012,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716403,"y":1041478,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":394352,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680704,"y":897600,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408633,"y":407839,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408291,"y":396908,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406661,"y":407695,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":111052,"y":87557,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130361,"y":259221,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135501,"y":216804,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":71231,"y":96456,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":389753,"y":499912,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460550,"y":1337801,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":210139,"y":217593,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544341,"y":898388,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":75722,"y":58955,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":245361,"y":135433,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":132404,"y":259920,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704370,"y":918071,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":185884,"y":87608,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":176893,"y":127580,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":214786,"y":117911,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243108,"y":132020,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243535,"y":133210,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241601,"y":130429,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413068,"y":391167,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242336,"y":133637,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78630,"y":68779,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278492,"y":222319,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79452,"y":68198,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81360,"y":64925,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243278,"y":133187,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240156,"y":133850,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":186580,"y":91303,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":145675,"y":113941,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":190132,"y":223986,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":238433,"y":135157,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":253945,"y":136717,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":254908,"y":137132,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":376408,"y":383741,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95446,"y":220374,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149796,"y":193296,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95155,"y":220304,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243545,"y":132508,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244806,"y":141877,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":40722,"y":99757,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231728,"y":131955,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604639,"y":1122068,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231728,"y":131955,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":276386,"y":219658,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402129,"y":398502,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407808,"y":396420,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567574,"y":1235110,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403597,"y":402021,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661297,"y":652966,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400605,"y":395458,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408239,"y":397553,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400819,"y":397222,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402772,"y":396063,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":24100,"y":174218,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594599,"y":1134776,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406439,"y":391780,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149333,"y":199877,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":196012,"y":105730,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":136756,"y":42114,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659261,"y":745799,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":492982,"y":520530,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297698,"y":298173,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296574,"y":300719,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434687,"y":366089,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297985,"y":298768,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644130,"y":665732,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":23707,"y":173450,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":257347,"y":172931,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147522,"y":121494,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278636,"y":222548,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601450,"y":1133620,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594398,"y":1136502,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600996,"y":1121022,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592904,"y":1127715,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597608,"y":1134287,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597050,"y":1131819,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607137,"y":1114444,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704526,"y":929671,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681210,"y":889190,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":739369,"y":901335,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577505,"y":927842,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600978,"y":1120670,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590348,"y":1144779,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591028,"y":1144226,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593831,"y":1135882,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600547,"y":1124456,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594598,"y":1128457,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591521,"y":1133660,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592983,"y":1130036,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598112,"y":1133128,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600948,"y":1129736,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594239,"y":1135102,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595500,"y":1134399,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590511,"y":1130273,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591054,"y":1141701,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591761,"y":1134741,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596785,"y":1136527,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594094,"y":1135194,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594518,"y":1134862,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612395,"y":1102777,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715205,"y":1038379,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717689,"y":1042318,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787875,"y":1006639,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787501,"y":1006837,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716433,"y":1041391,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604075,"y":1123665,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606311,"y":1127538,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603375,"y":1122718,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605921,"y":1120566,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603718,"y":1124116,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604378,"y":1128334,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596091,"y":1119169,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576037,"y":1128372,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581827,"y":1138222,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584622,"y":1130761,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582905,"y":1133305,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580260,"y":1135079,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582991,"y":1127079,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588105,"y":1143423,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639355,"y":1029965,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634163,"y":1031065,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639972,"y":1033700,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664882,"y":1051924,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658080,"y":1053119,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675712,"y":1061048,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715562,"y":1035378,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625772,"y":1058466,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716762,"y":1035670,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718855,"y":1044488,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713858,"y":1036893,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716581,"y":1040476,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716427,"y":1041410,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628012,"y":1059428,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713042,"y":1036682,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729533,"y":1037386,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714048,"y":1037549,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705783,"y":1045996,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718293,"y":1042539,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717861,"y":1035828,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714034,"y":1039431,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728934,"y":961739,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676709,"y":879688,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703779,"y":939766,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705194,"y":926290,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705544,"y":928911,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699996,"y":1002462,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730267,"y":964409,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715788,"y":1009739,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730335,"y":964445,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703613,"y":1001812,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722352,"y":989905,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694929,"y":1055849,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717984,"y":1045849,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716737,"y":1041597,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585676,"y":1177488,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569825,"y":1145681,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582330,"y":1187365,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":507025,"y":1237948,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":481977,"y":1343773,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":470323,"y":1356292,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517337,"y":1327411,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495920,"y":1291543,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554753,"y":1251330,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555855,"y":1261793,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556053,"y":1262043,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639399,"y":1034655,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598136,"y":1135977,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592781,"y":1138378,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560141,"y":1259111,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610885,"y":1112890,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594479,"y":1136222,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611982,"y":1111703,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641220,"y":1005985,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664115,"y":1101524,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691683,"y":1114611,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664327,"y":1084070,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604233,"y":1128471,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705382,"y":928140,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594266,"y":1192883,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666871,"y":1119083,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628606,"y":1043051,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628903,"y":952528,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594614,"y":1128482,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592558,"y":1133806,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601596,"y":1136156,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598788,"y":1128480,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605162,"y":1122639,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603503,"y":1117677,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604245,"y":1116093,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544955,"y":1285154,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622403,"y":960405,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629285,"y":964596,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661218,"y":1057092,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661976,"y":1051030,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655184,"y":1043905,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721715,"y":989178,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722265,"y":987570,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722344,"y":989705,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719060,"y":995436,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714743,"y":997151,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718667,"y":990794,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":759710,"y":993496,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787854,"y":1007780,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787478,"y":1007847,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":777629,"y":1003645,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714983,"y":1038092,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721358,"y":1041259,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700356,"y":1066741,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659905,"y":1144795,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690050,"y":1111588,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655497,"y":1018357,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654348,"y":1019967,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715525,"y":1037887,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718357,"y":1045031,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711415,"y":1039430,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700572,"y":1043397,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672779,"y":1101878,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671502,"y":1100533,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678302,"y":1135875,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646875,"y":1024310,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650819,"y":1041855,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592784,"y":1140657,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587338,"y":1130189,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585024,"y":1130414,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592653,"y":1140710,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591787,"y":1088786,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608752,"y":1110869,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614984,"y":1084925,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607747,"y":1113582,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609391,"y":1089708,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":549948,"y":1256414,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564988,"y":1228859,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555605,"y":1260212,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556791,"y":1263139,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553999,"y":1253903,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556969,"y":1261829,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617692,"y":1094139,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593597,"y":1135089,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603219,"y":1123750,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602523,"y":1125214,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592822,"y":1137281,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593313,"y":1140105,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585348,"y":1130836,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580878,"y":1138328,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577943,"y":1127551,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592938,"y":1138664,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1135190,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607061,"y":1115356,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593329,"y":1140011,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604153,"y":1122830,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590649,"y":1148833,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609646,"y":1109347,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592207,"y":1146259,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593036,"y":1138838,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1135190,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593427,"y":1136848,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603148,"y":1123820,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595164,"y":1128061,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582791,"y":1140677,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586601,"y":1129936,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584985,"y":1129508,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":587832,"y":1128844,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596091,"y":1136082,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593576,"y":1135743,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601346,"y":1126151,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593602,"y":1143810,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592574,"y":1146935,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580407,"y":1129129,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582154,"y":1126802,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582482,"y":1135892,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":451128,"y":1324007,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606208,"y":1097522,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609941,"y":1108806,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521083,"y":1314001,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517355,"y":1327403,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":486141,"y":1342806,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592215,"y":1145226,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638118,"y":1033397,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586645,"y":1148370,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595205,"y":1143338,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591326,"y":1150698,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604890,"y":1121068,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588441,"y":1143108,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596109,"y":1142485,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593169,"y":1145191,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688950,"y":1073223,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590345,"y":1140736,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593644,"y":1149336,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575986,"y":1194431,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585037,"y":1182850,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591283,"y":1191556,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585087,"y":1181740,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585998,"y":1158041,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596450,"y":1141188,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590208,"y":1140583,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595779,"y":1141903,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591536,"y":1141669,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590080,"y":1143099,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602821,"y":1120951,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605897,"y":1116781,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605773,"y":1116740,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604954,"y":1119904,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604467,"y":1120889,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":596454,"y":1122562,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597819,"y":1121800,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598069,"y":1123525,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597557,"y":1123061,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604651,"y":1122511,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617903,"y":1132606,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603500,"y":1123589,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582652,"y":1133508,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600327,"y":1123444,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607274,"y":1133776,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608485,"y":1122937,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609383,"y":1129978,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582557,"y":1132899,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589026,"y":1092973,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576832,"y":1159906,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585918,"y":1186157,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":595987,"y":1141190,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591810,"y":1147470,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":590645,"y":1139746,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593512,"y":1130793,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589066,"y":1128985,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597029,"y":1131765,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594419,"y":1134706,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594602,"y":1136164,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594582,"y":1136524,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594236,"y":1136562,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589516,"y":1135096,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588411,"y":1130011,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605752,"y":1121403,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607283,"y":1126716,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704217,"y":929862,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704589,"y":929303,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677955,"y":897584,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680234,"y":1008259,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704480,"y":928956,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713902,"y":1035500,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726778,"y":1038416,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595029,"y":1128151,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593267,"y":1139420,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600984,"y":1123410,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606559,"y":1096768,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1120303,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495481,"y":1309061,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461221,"y":1330298,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594201,"y":1135462,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585590,"y":1129970,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":506563,"y":1336786,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557034,"y":1263540,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565589,"y":1225006,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604282,"y":1121545,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604608,"y":1120946,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591576,"y":1134531,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596202,"y":1129196,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601646,"y":1128971,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601476,"y":1130957,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601544,"y":1130812,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628379,"y":1094833,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601737,"y":1122672,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593495,"y":1135127,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639641,"y":1032476,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460737,"y":1330640,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643852,"y":1044201,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638675,"y":1034161,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637470,"y":1032450,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641821,"y":1030005,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716305,"y":1040225,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718330,"y":990892,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722361,"y":990250,"year":"2005","vehicles":"Vehicle(s)+multiple other types","severity":"Non-injury","color":"lightgrey"},{"x":670197,"y":1012757,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653365,"y":1087338,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648937,"y":1039150,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638323,"y":1030972,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635260,"y":1032169,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636867,"y":1027805,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640160,"y":1024741,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635080,"y":1030561,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623223,"y":1076900,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634427,"y":1033275,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637206,"y":1033170,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635786,"y":1030543,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594570,"y":1136437,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594406,"y":1135657,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590189,"y":1134388,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591520,"y":1129334,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595311,"y":1136873,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598409,"y":1132204,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595561,"y":1133488,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596730,"y":1129037,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598101,"y":1123440,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588087,"y":1130969,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598958,"y":1130716,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602214,"y":1135691,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597856,"y":1132335,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594655,"y":1136794,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":602291,"y":1125888,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594561,"y":1144962,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592746,"y":1145055,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574812,"y":1129835,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580598,"y":1139753,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590705,"y":1145456,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605015,"y":1086391,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637871,"y":1030947,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637873,"y":1031355,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":561527,"y":1292673,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588805,"y":1147897,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595761,"y":1134682,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592940,"y":1141634,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604337,"y":1114189,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460595,"y":1329317,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595740,"y":1133965,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594484,"y":1136232,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594811,"y":1129598,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604063,"y":1133910,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596233,"y":1128213,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591485,"y":1135405,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603045,"y":1132089,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588000,"y":1130230,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606394,"y":1116344,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605327,"y":1123871,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590770,"y":1144828,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591529,"y":1132778,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595561,"y":1144537,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590418,"y":1130881,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699697,"y":937406,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628907,"y":1030852,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554537,"y":1271775,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676077,"y":1056484,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636082,"y":1036951,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634241,"y":1035577,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654717,"y":1018480,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650977,"y":1015819,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688797,"y":981535,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626746,"y":1030455,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724219,"y":1040267,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592484,"y":1130814,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654347,"y":1019336,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594168,"y":1193511,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620559,"y":1073299,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620484,"y":1044557,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688712,"y":1073792,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591491,"y":1131129,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594466,"y":1136433,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560850,"y":1258450,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614711,"y":1095208,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678054,"y":1135286,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634511,"y":1049196,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681381,"y":897059,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679626,"y":1139622,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473299,"y":1332134,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":483946,"y":1343893,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603389,"y":1115744,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593321,"y":1192884,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594432,"y":1136101,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607734,"y":1122323,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591058,"y":1131536,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601088,"y":1125928,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616626,"y":1093935,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591624,"y":1131162,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641943,"y":1028128,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606276,"y":1121913,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637633,"y":655703,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":448963,"y":641610,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460650,"y":648715,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700797,"y":760282,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542610,"y":896985,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546982,"y":833492,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596971,"y":647310,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770365,"y":822528,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517148,"y":632303,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632671,"y":717491,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":870127,"y":928064,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773284,"y":836123,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772126,"y":838387,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461132,"y":646555,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634370,"y":835967,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528105,"y":891532,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585501,"y":643258,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772953,"y":835702,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773578,"y":837773,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460476,"y":646729,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587210,"y":641081,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873882,"y":924941,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586393,"y":643291,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644743,"y":729262,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652026,"y":673432,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594667,"y":650470,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590564,"y":655514,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659250,"y":747986,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659262,"y":745651,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632333,"y":661654,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773971,"y":834385,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598330,"y":653886,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":755947,"y":846694,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594135,"y":650958,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766004,"y":822261,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438818,"y":673402,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585478,"y":646321,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434004,"y":671431,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874560,"y":924457,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558895,"y":840379,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630919,"y":720644,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598010,"y":652694,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765424,"y":823039,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767656,"y":822425,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769904,"y":824085,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623316,"y":662438,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657477,"y":744662,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633675,"y":909791,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":422549,"y":680948,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597573,"y":663921,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594847,"y":669258,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659480,"y":745295,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611785,"y":794279,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530785,"y":892754,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596403,"y":651901,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597359,"y":652234,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731632,"y":783044,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744313,"y":789738,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741091,"y":782615,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528013,"y":891497,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629816,"y":715746,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631983,"y":717233,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658101,"y":678150,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874071,"y":924166,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530600,"y":892251,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592633,"y":660091,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450312,"y":639985,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660976,"y":679092,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":865874,"y":937829,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549454,"y":852759,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677117,"y":820187,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586412,"y":647066,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871739,"y":924932,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874568,"y":924424,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601655,"y":655252,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591695,"y":664124,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518464,"y":626234,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435914,"y":669320,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547192,"y":861015,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515005,"y":620259,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648698,"y":735933,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581467,"y":643767,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517424,"y":619656,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874477,"y":924321,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773376,"y":837199,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438088,"y":664553,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771351,"y":823220,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768076,"y":835024,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":772427,"y":869415,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591730,"y":660350,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459967,"y":645158,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461311,"y":647656,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":474638,"y":652991,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766081,"y":849275,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601706,"y":677290,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767658,"y":833291,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600087,"y":646486,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":867865,"y":928012,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608123,"y":793217,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640243,"y":766078,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609009,"y":662158,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655167,"y":743410,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661308,"y":746443,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547086,"y":833459,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591210,"y":657012,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609629,"y":661235,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":782747,"y":878063,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608084,"y":686643,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":797191,"y":918832,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650711,"y":784524,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517087,"y":619798,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580810,"y":648444,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591045,"y":660991,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770323,"y":841838,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528545,"y":890857,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528760,"y":888147,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532773,"y":891938,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666514,"y":799055,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773083,"y":866285,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819879,"y":886117,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595072,"y":661676,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613114,"y":662674,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612346,"y":791991,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530213,"y":892214,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656931,"y":744963,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517208,"y":620018,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598222,"y":652013,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598409,"y":647868,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516938,"y":620418,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819671,"y":886278,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766828,"y":821149,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638309,"y":764939,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613536,"y":795274,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594949,"y":651020,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640166,"y":907772,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767932,"y":820278,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773612,"y":837356,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514793,"y":875509,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493381,"y":527376,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644997,"y":780045,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657851,"y":678143,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586177,"y":642304,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601527,"y":662394,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520917,"y":644529,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773919,"y":811044,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611354,"y":688725,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591914,"y":660260,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587590,"y":643418,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587044,"y":641104,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587044,"y":641104,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774329,"y":838107,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745694,"y":890802,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674718,"y":824601,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594449,"y":651075,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604906,"y":685029,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767249,"y":821185,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645142,"y":657720,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628289,"y":848883,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638955,"y":778168,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770275,"y":836981,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874689,"y":924056,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772146,"y":835988,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701052,"y":760508,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679407,"y":817997,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587959,"y":650426,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547277,"y":833081,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658712,"y":745818,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397589,"y":599347,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626492,"y":779281,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584817,"y":637746,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532533,"y":888644,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650526,"y":732193,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585767,"y":643878,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588286,"y":648065,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":340597,"y":355887,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404055,"y":395728,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412171,"y":397094,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410307,"y":396318,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243761,"y":133126,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435787,"y":459407,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":103854,"y":208824,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147936,"y":205581,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":335143,"y":352752,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242892,"y":131403,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401673,"y":394555,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243217,"y":133159,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407570,"y":395183,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":121140,"y":347205,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":271901,"y":483921,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":270588,"y":484706,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80131,"y":65035,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95514,"y":220460,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241758,"y":132020,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":234903,"y":208057,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434922,"y":365592,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":182203,"y":89262,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405178,"y":395208,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79404,"y":65762,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":381830,"y":371072,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153745,"y":198805,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130205,"y":110606,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":474269,"y":506028,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406921,"y":392840,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":136986,"y":264015,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401753,"y":397223,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406689,"y":398095,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":417469,"y":391939,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241640,"y":132079,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420604,"y":364612,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297945,"y":298002,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":331721,"y":350130,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296408,"y":291623,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297696,"y":298223,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297601,"y":298999,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297471,"y":298801,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298328,"y":298068,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":375234,"y":418731,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":380618,"y":420948,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405832,"y":396400,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407564,"y":396524,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407254,"y":399674,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409934,"y":394592,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409967,"y":398821,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404837,"y":393969,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408700,"y":393179,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407517,"y":392095,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410998,"y":396153,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412752,"y":397706,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412191,"y":397103,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400255,"y":394757,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408536,"y":396908,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410851,"y":397599,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":168537,"y":215570,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123652,"y":103111,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409441,"y":396188,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406602,"y":394348,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407660,"y":391201,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":316123,"y":488225,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":248197,"y":454636,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":129127,"y":365224,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297228,"y":297333,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296805,"y":300829,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297991,"y":298760,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":188656,"y":95092,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":216609,"y":112904,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154220,"y":198059,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":122494,"y":101209,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123567,"y":102864,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":189547,"y":91842,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95853,"y":220152,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95532,"y":220444,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123037,"y":103027,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":94926,"y":72897,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":52655,"y":68624,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79631,"y":65548,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":16816,"y":156328,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":188117,"y":92374,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240649,"y":130206,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244165,"y":133216,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243522,"y":130109,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242938,"y":129896,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241106,"y":129387,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242468,"y":128862,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241518,"y":130376,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237688,"y":129647,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":76802,"y":50874,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80049,"y":65710,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81907,"y":63250,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83452,"y":57974,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":28694,"y":186629,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78247,"y":64495,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95334,"y":221004,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80512,"y":62972,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95276,"y":220530,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":128849,"y":166362,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80117,"y":64908,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89023,"y":217344,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":247301,"y":137389,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231327,"y":132558,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":170164,"y":92563,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78109,"y":83119,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408926,"y":396306,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337833,"y":346910,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296960,"y":299756,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":261786,"y":184273,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":430007,"y":370610,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":335894,"y":355114,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":103968,"y":224345,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402560,"y":391628,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407559,"y":397220,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408930,"y":395693,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":124889,"y":104039,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277357,"y":219720,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414198,"y":392359,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407507,"y":395939,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79374,"y":69723,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":280203,"y":272240,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95430,"y":220254,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401647,"y":391986,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297803,"y":297048,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433840,"y":369457,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":417794,"y":507076,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404577,"y":419348,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80930,"y":66144,"year":"2005","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":424896,"y":371558,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89022,"y":217344,"year":"2005","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457819,"y":645733,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80808,"y":63762,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774280,"y":813446,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766828,"y":821350,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627421,"y":1043805,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":187702,"y":399694,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539793,"y":1288463,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":65975,"y":10460,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79443,"y":66379,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":222505,"y":125579,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":44117,"y":220853,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600866,"y":1124912,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403976,"y":397368,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408937,"y":396670,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282187,"y":260387,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410105,"y":392706,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413699,"y":399250,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296792,"y":298932,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402284,"y":401724,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":20339,"y":156871,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715654,"y":1038030,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95937,"y":166756,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408047,"y":397293,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411255,"y":396996,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288986,"y":493345,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":372730,"y":545177,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":426317,"y":486549,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407577,"y":394646,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82034,"y":66688,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585812,"y":1185087,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":197519,"y":287997,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590206,"y":1131221,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633552,"y":1031712,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604265,"y":1128699,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662488,"y":747410,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621878,"y":972938,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588426,"y":1132073,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592577,"y":1133814,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601442,"y":1136207,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590850,"y":1155666,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592654,"y":1145018,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594333,"y":1145010,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95608,"y":220334,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610163,"y":1091400,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655414,"y":759907,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":93655,"y":89343,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402772,"y":396064,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540147,"y":891211,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81470,"y":144243,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656672,"y":743868,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871774,"y":925015,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597274,"y":1124164,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600577,"y":1124365,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570965,"y":1256897,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":743755,"y":788440,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637802,"y":820677,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636129,"y":1029424,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682981,"y":1000236,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678037,"y":1136107,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624169,"y":662185,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595620,"y":1133435,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645119,"y":1052237,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517000,"y":619828,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585471,"y":642967,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624815,"y":662114,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635905,"y":657850,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":109090,"y":230483,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408825,"y":403464,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601551,"y":1119972,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298391,"y":337689,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597338,"y":1119745,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608103,"y":660317,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716733,"y":996249,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633808,"y":841277,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610533,"y":662221,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":421493,"y":645346,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":432636,"y":672892,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":90152,"y":132898,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659589,"y":755070,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591979,"y":664623,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406290,"y":395159,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717487,"y":1046254,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660961,"y":750303,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589289,"y":641300,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409640,"y":396310,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608317,"y":660870,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767957,"y":832782,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408679,"y":398128,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612746,"y":1114411,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596190,"y":1122827,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719855,"y":989058,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594424,"y":1134983,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606873,"y":1117185,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641955,"y":1030982,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631691,"y":1049858,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556720,"y":1263641,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602424,"y":1115343,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595442,"y":1120177,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875712,"y":926026,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581102,"y":1140035,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":339630,"y":393411,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131921,"y":43080,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656316,"y":759907,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602162,"y":1121808,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611427,"y":1104922,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611769,"y":661276,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243377,"y":130490,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601199,"y":1134837,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":799740,"y":995801,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400001,"y":598201,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577113,"y":1136253,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706964,"y":936702,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":12503,"y":132295,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657189,"y":750721,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243592,"y":133582,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244368,"y":134982,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595914,"y":1133369,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772715,"y":827168,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596415,"y":1127986,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591415,"y":1131875,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":185900,"y":87619,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595625,"y":1133656,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604489,"y":1118975,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":373278,"y":586703,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408457,"y":388131,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609711,"y":1117536,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587596,"y":1127764,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":97541,"y":221222,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516443,"y":881600,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597628,"y":1128662,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713732,"y":1030058,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536813,"y":895362,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696097,"y":1066315,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604669,"y":659249,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643855,"y":1087741,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586022,"y":644004,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592854,"y":650689,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630425,"y":716533,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585475,"y":643490,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593320,"y":1153873,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639669,"y":1031013,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605661,"y":1121354,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774015,"y":835194,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":128858,"y":166445,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":426933,"y":380768,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":760427,"y":953012,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":37567,"y":249386,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243223,"y":131334,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696518,"y":1064229,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580543,"y":1139641,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694321,"y":1056655,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405207,"y":399996,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":903661,"y":1010094,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581387,"y":1137942,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":58731,"y":76759,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600550,"y":1125255,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639318,"y":1029439,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581675,"y":1138558,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409410,"y":396430,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599606,"y":1129264,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650309,"y":672286,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602494,"y":1116841,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595504,"y":1132029,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604356,"y":1117537,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594386,"y":1134969,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599431,"y":1129568,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":158797,"y":97135,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598062,"y":1131355,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611370,"y":1125520,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296293,"y":332299,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":331508,"y":349965,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578480,"y":1132365,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605339,"y":683085,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594323,"y":1136297,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410808,"y":387617,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558600,"y":1261076,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610044,"y":1116639,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569992,"y":1143921,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457877,"y":645317,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147793,"y":211289,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599394,"y":1101592,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601936,"y":1121790,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518321,"y":620724,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614750,"y":1127447,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471074,"y":651857,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412616,"y":402992,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606104,"y":684474,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673703,"y":864322,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767417,"y":1016010,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712295,"y":1024542,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683920,"y":747165,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":307079,"y":523873,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617555,"y":1094089,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719182,"y":1042484,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597098,"y":1124245,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567339,"y":1232817,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":430302,"y":369830,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593260,"y":1139479,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566173,"y":1220140,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624757,"y":662109,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575226,"y":1260928,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676101,"y":878211,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517802,"y":619290,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242283,"y":129358,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689461,"y":1074375,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716892,"y":1036104,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":139436,"y":221872,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595192,"y":1136491,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297289,"y":299515,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555336,"y":1217884,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":790326,"y":884330,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677779,"y":1036927,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627861,"y":1059031,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718593,"y":1044847,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625952,"y":1071036,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":376758,"y":383929,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591400,"y":1147445,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622898,"y":638502,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":852431,"y":892836,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":788184,"y":1007547,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575160,"y":1142016,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547627,"y":1283913,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408893,"y":386321,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615844,"y":1123734,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404816,"y":399367,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714898,"y":1034725,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404591,"y":392061,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720772,"y":1043077,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603867,"y":1117846,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716300,"y":1037535,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658519,"y":746169,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592362,"y":1134279,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607066,"y":1117053,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591667,"y":1132591,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601094,"y":1130498,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80381,"y":65048,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603027,"y":1132098,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588777,"y":1130215,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655155,"y":1083301,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510579,"y":1298040,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":126199,"y":120604,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81530,"y":64304,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595445,"y":1136218,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600444,"y":1131030,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586686,"y":1134072,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586613,"y":1134102,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721701,"y":1040486,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602479,"y":1130422,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703156,"y":1043176,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716737,"y":1041597,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607064,"y":1115631,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720170,"y":1042548,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717868,"y":1046170,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595924,"y":1119131,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713680,"y":1030439,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654793,"y":1019386,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404385,"y":421184,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633007,"y":1015671,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610009,"y":792443,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652752,"y":1018235,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649116,"y":1021369,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574154,"y":1133804,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654793,"y":1019386,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635631,"y":1029562,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620993,"y":1141058,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591933,"y":1144797,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716258,"y":1037413,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590800,"y":1144095,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591509,"y":1143985,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574987,"y":1160644,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581102,"y":1140035,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533849,"y":1300405,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592164,"y":1143852,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615949,"y":1093784,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626846,"y":1035337,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602046,"y":1119347,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602204,"y":1126514,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609888,"y":1112797,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602368,"y":1122230,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600874,"y":1128648,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605981,"y":1120098,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597642,"y":1129086,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594990,"y":1128155,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672608,"y":1077258,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588784,"y":1129692,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604358,"y":1120588,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762537,"y":822218,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668411,"y":1099369,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590006,"y":1134335,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593364,"y":1140169,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666428,"y":1098056,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716178,"y":1036774,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669477,"y":1100289,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706964,"y":936702,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681104,"y":1027875,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656644,"y":1094147,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602150,"y":1119062,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597732,"y":1124607,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604824,"y":1121784,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605101,"y":1122893,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699897,"y":1024767,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604065,"y":1123677,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587814,"y":1131668,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639670,"y":1030301,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762140,"y":994840,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642936,"y":1029958,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584226,"y":1129866,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720988,"y":1042887,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728910,"y":996172,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678617,"y":1070800,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601536,"y":1134490,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":367966,"y":400143,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678617,"y":1070800,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686156,"y":1040317,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596431,"y":1123597,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677905,"y":1033560,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658356,"y":1058422,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663595,"y":1062543,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629350,"y":979896,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673182,"y":1011267,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657502,"y":1139228,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":739561,"y":901257,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682164,"y":1104700,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665509,"y":1097223,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698312,"y":1070449,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460740,"y":1330894,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":140352,"y":256425,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":195188,"y":397767,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630736,"y":716911,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597245,"y":1139846,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585297,"y":1129575,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600524,"y":1121743,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580711,"y":1128900,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597287,"y":1124850,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597856,"y":1124182,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571292,"y":1149899,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636150,"y":1031205,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":503857,"y":1251235,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":107296,"y":225946,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603116,"y":1115628,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599260,"y":1136425,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624383,"y":1141693,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578387,"y":1192104,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612959,"y":1098948,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610288,"y":1114423,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586651,"y":1129932,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580026,"y":1140194,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603250,"y":1123700,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602224,"y":1126382,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594360,"y":1135113,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595091,"y":1128111,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593729,"y":1143671,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639580,"y":1030628,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637341,"y":1032347,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637994,"y":1031418,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502997,"y":1253099,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565977,"y":1221602,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591880,"y":1140788,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592746,"y":1145055,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591220,"y":1147384,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572868,"y":1156843,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600291,"y":1124042,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601836,"y":1122787,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601582,"y":1120910,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603496,"y":1117695,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557710,"y":1265871,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568427,"y":1282918,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645454,"y":1004793,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629805,"y":1013193,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676121,"y":1059567,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718171,"y":1005389,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726521,"y":1000978,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659210,"y":1067045,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625769,"y":977224,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764561,"y":1017377,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624539,"y":1029855,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635560,"y":1031916,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587559,"y":1131304,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651059,"y":1079218,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651323,"y":1078506,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647393,"y":1086200,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673391,"y":1075997,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690598,"y":1116885,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691730,"y":1095048,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686468,"y":1123695,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666117,"y":1097735,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714114,"y":1034855,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712493,"y":1039579,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726753,"y":1038736,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728885,"y":1037434,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716725,"y":1040516,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715780,"y":1038175,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722498,"y":989788,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680514,"y":896663,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724340,"y":988721,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716475,"y":980621,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595500,"y":1134399,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594386,"y":1135402,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601759,"y":1134184,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601189,"y":1132829,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598157,"y":1135933,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590675,"y":1132369,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595549,"y":1127796,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603064,"y":1132573,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593918,"y":1135344,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592414,"y":1133636,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576802,"y":1216437,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607325,"y":1117372,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606087,"y":1128355,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707874,"y":936988,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593740,"y":1148606,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590907,"y":1144339,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637829,"y":1034685,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635299,"y":1034914,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691680,"y":1067968,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683430,"y":1106804,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712459,"y":1042172,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581391,"y":1133565,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719861,"y":988152,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638253,"y":1033070,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633960,"y":1035901,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509252,"y":1297453,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599818,"y":1122892,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589326,"y":1130255,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594403,"y":1136500,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589733,"y":1170159,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608865,"y":1110859,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590393,"y":1134414,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605664,"y":1097493,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605882,"y":1098427,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560867,"y":1258294,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523179,"y":1322462,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606174,"y":1129193,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607296,"y":1124992,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597914,"y":1123256,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544972,"y":1301106,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593183,"y":1149052,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589394,"y":1142679,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592047,"y":1147799,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722539,"y":982441,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582861,"y":1209796,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548912,"y":1268261,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558692,"y":1265021,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605841,"y":1118053,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602833,"y":1117427,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605214,"y":1115475,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604945,"y":1120315,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604951,"y":1119884,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604282,"y":1121544,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634140,"y":1035688,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546214,"y":1259831,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535434,"y":1204458,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535375,"y":1313057,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531976,"y":1251432,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450823,"y":1323951,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516457,"y":1304419,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":451863,"y":1322619,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605429,"y":1129307,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603502,"y":1119455,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607507,"y":1127326,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605155,"y":1117272,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615429,"y":1115744,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602626,"y":1123145,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601481,"y":1125573,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606392,"y":1116324,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608229,"y":1119886,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604282,"y":1121545,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594945,"y":1143178,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584578,"y":1129710,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568648,"y":1124015,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587195,"y":1130133,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586799,"y":1129909,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607041,"y":1117254,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598160,"y":1123083,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562173,"y":1258149,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639194,"y":1032970,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608443,"y":1114092,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601620,"y":1121328,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608334,"y":1114881,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588788,"y":1163832,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587839,"y":1128761,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574813,"y":1136391,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598553,"y":1130237,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589150,"y":1133926,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601070,"y":1128462,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592649,"y":1138178,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593126,"y":1137115,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592600,"y":1138091,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612976,"y":1098952,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593169,"y":1134630,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601150,"y":1128520,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592801,"y":1137317,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593762,"y":1128654,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592088,"y":1132476,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599201,"y":1130786,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594970,"y":1136510,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593255,"y":1135390,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588767,"y":1130271,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":478271,"y":1322395,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":458929,"y":1340145,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579467,"y":1216157,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539617,"y":1313522,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607177,"y":1120698,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586195,"y":1151913,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582886,"y":1129958,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586845,"y":1129902,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601720,"y":1124919,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594801,"y":1136882,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619704,"y":1141849,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628456,"y":1144676,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1120303,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582513,"y":1133415,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592477,"y":1137862,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519999,"y":1304953,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706493,"y":929496,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722324,"y":989153,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673368,"y":1043273,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602409,"y":1020182,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594650,"y":1134716,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457183,"y":1325463,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524290,"y":1316595,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516442,"y":1307724,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603900,"y":1129348,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591008,"y":1133091,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592631,"y":1144838,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597814,"y":1132811,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565259,"y":1223668,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606122,"y":1097192,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601813,"y":1130853,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776969,"y":1011949,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673936,"y":1075324,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813582,"y":995490,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":791614,"y":1006552,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":792262,"y":1006240,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":785172,"y":1007148,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582342,"y":1149795,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607471,"y":1115001,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635440,"y":1037100,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761319,"y":994422,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":751356,"y":996921,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786371,"y":1005735,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":794678,"y":1004826,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787832,"y":1007302,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":733438,"y":1011484,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633053,"y":1037956,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638644,"y":1030778,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636157,"y":1031125,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723893,"y":1039022,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721018,"y":1041620,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718293,"y":1042539,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715654,"y":1038030,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716461,"y":1035763,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714183,"y":1037365,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714197,"y":1037377,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728055,"y":1032586,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713740,"y":1041178,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715593,"y":1038823,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697391,"y":1071523,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727554,"y":1035321,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639583,"y":1032106,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639871,"y":1030608,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638081,"y":1028647,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728557,"y":955382,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719362,"y":991872,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721223,"y":989982,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":731351,"y":967580,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719420,"y":990957,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722334,"y":989426,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720913,"y":989208,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720153,"y":992125,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609992,"y":1112114,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583715,"y":1132527,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623152,"y":1095036,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618255,"y":1094346,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627642,"y":1094900,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619638,"y":1095152,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617780,"y":1087242,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596940,"y":1119416,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604639,"y":1116619,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604729,"y":1130433,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603687,"y":1124146,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596237,"y":1125966,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603135,"y":1122433,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604779,"y":1123213,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603613,"y":1123652,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602114,"y":1123701,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607495,"y":1127328,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606665,"y":1115804,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612492,"y":1111701,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593417,"y":1134903,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602016,"y":1127102,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593171,"y":1137092,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602348,"y":1125696,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593721,"y":1142876,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602141,"y":1126622,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593445,"y":1135481,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605601,"y":1116656,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591561,"y":1132645,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593697,"y":1149765,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594784,"y":1134604,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579295,"y":1135444,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586601,"y":1129936,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556607,"y":1262158,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537013,"y":1309093,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592544,"y":1144963,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586866,"y":1149589,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584018,"y":1128248,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593129,"y":1142802,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554252,"y":1268973,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566041,"y":1232735,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565597,"y":1224887,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568879,"y":1256651,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579672,"y":1141368,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588775,"y":1130229,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582680,"y":1132888,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569624,"y":1164675,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572764,"y":1203173,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607170,"y":1124460,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638078,"y":1028015,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720722,"y":990076,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720245,"y":991887,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718870,"y":996276,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639133,"y":1046259,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622540,"y":1077872,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676980,"y":1126219,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691122,"y":1092703,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776892,"y":1003209,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771626,"y":1002841,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643335,"y":1007008,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677428,"y":886438,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653882,"y":1019346,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627817,"y":1056003,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627813,"y":1055983,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687258,"y":1135402,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644893,"y":1087932,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697847,"y":1070923,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697246,"y":1072763,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673201,"y":1076273,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655890,"y":1094042,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688715,"y":1073788,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630590,"y":986741,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596174,"y":1134859,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591822,"y":1132552,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593009,"y":1135415,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587771,"y":1131691,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591388,"y":1130750,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592453,"y":1130698,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591485,"y":1127370,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594387,"y":1136961,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594771,"y":1134589,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597691,"y":1132231,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595496,"y":1129489,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596778,"y":1131589,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601587,"y":1128255,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600948,"y":1129736,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601055,"y":1128618,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591697,"y":1145136,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590818,"y":1147153,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591267,"y":1151396,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589203,"y":1146726,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585177,"y":1149085,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595645,"y":1142515,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592788,"y":1141598,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594662,"y":1143003,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593889,"y":1143503,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592818,"y":1144466,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618724,"y":1094889,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592179,"y":1160786,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589234,"y":1163625,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574034,"y":1198743,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584905,"y":1182478,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618114,"y":1094293,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607170,"y":1124460,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606171,"y":1102246,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716222,"y":1038675,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721339,"y":1041331,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639513,"y":1002763,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711437,"y":1036720,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726774,"y":1038322,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717629,"y":1036890,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675495,"y":1130059,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639015,"y":1030979,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609583,"y":1110976,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589898,"y":1169620,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596396,"y":1128227,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606259,"y":1127539,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604254,"y":1121533,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602148,"y":1130746,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591404,"y":1134325,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604549,"y":1116318,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594820,"y":1129893,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582574,"y":1133063,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592566,"y":1138030,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595318,"y":1133810,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592976,"y":1137163,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607081,"y":1115386,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591971,"y":1135652,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594682,"y":1136720,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594571,"y":1136963,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595561,"y":1133488,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":484746,"y":1338885,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654836,"y":1019020,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637681,"y":1032115,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717910,"y":1042539,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717910,"y":1042539,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689477,"y":980397,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721908,"y":989705,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586140,"y":1187065,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509530,"y":1315581,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662562,"y":999432,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603334,"y":1124236,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584041,"y":1199415,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608259,"y":1127774,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594525,"y":1136372,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602104,"y":1133920,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580313,"y":1221847,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688617,"y":1073933,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637923,"y":1031541,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637621,"y":1032515,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638256,"y":1027790,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635560,"y":1031916,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705680,"y":933438,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600226,"y":1123974,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602354,"y":1130691,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606098,"y":1097379,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584343,"y":1135391,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582130,"y":1131417,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604163,"y":1124743,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694688,"y":1054998,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638347,"y":1031850,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589493,"y":1142683,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597474,"y":1131814,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604282,"y":1121544,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594801,"y":1136882,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603604,"y":1121267,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592338,"y":1130292,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595580,"y":1128966,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591459,"y":1130826,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592830,"y":1132012,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593612,"y":1136393,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553184,"y":1260270,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638820,"y":1031046,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606395,"y":1130484,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605579,"y":1118960,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596376,"y":1128225,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600072,"y":1135851,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635045,"y":1034672,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583368,"y":1130029,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601209,"y":1126749,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599494,"y":1124033,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591368,"y":1145655,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713131,"y":1035792,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600549,"y":1124460,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595085,"y":1142943,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718316,"y":990219,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713262,"y":1038896,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635560,"y":1031916,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676693,"y":1059091,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722174,"y":990639,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594134,"y":1134771,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677005,"y":1057776,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675493,"y":1145714,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606395,"y":1130484,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641460,"y":1009179,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577718,"y":1127348,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609992,"y":1112114,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566441,"y":1159297,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639015,"y":1030979,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874219,"y":925982,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529869,"y":890566,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594135,"y":650958,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611432,"y":795155,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773513,"y":838193,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":835255,"y":956987,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658918,"y":744987,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594056,"y":663836,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517241,"y":620134,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680870,"y":744325,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":428048,"y":678876,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516632,"y":646831,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":667209,"y":844441,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643112,"y":773727,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575054,"y":908881,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632027,"y":911162,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":667209,"y":844441,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":446673,"y":635161,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657744,"y":747346,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460572,"y":647179,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519709,"y":642699,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657243,"y":678124,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659666,"y":745855,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617577,"y":702581,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767299,"y":822980,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581196,"y":644184,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767366,"y":833364,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622963,"y":662851,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614725,"y":844400,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659550,"y":755116,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628321,"y":777091,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":892934,"y":933887,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745711,"y":890778,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":867797,"y":925650,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":905497,"y":1008734,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438154,"y":660998,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435585,"y":667239,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632930,"y":909814,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640066,"y":777099,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874744,"y":924044,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456727,"y":642439,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587419,"y":640442,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598448,"y":651963,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601273,"y":654498,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":430998,"y":674465,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633704,"y":660448,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461609,"y":647333,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":463647,"y":646845,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":454648,"y":640863,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":645846,"y":851474,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643133,"y":664788,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435585,"y":667239,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438921,"y":664682,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603609,"y":657154,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529877,"y":892425,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529674,"y":891905,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532316,"y":893271,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541545,"y":881227,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658604,"y":745355,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769515,"y":832998,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773330,"y":837155,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659536,"y":688470,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773981,"y":837346,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596791,"y":652216,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602049,"y":657166,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589740,"y":640434,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":424414,"y":693251,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659922,"y":743055,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771509,"y":834269,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547427,"y":862335,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634638,"y":909918,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741102,"y":783628,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":428131,"y":656309,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774119,"y":836985,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764831,"y":823386,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587111,"y":646651,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530394,"y":892320,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533752,"y":893402,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437949,"y":663464,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546397,"y":833157,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546942,"y":833203,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632275,"y":715782,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663145,"y":685089,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660547,"y":677730,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590894,"y":661368,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873955,"y":924921,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517424,"y":619656,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460275,"y":647618,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594928,"y":669544,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660500,"y":678022,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640269,"y":906221,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542951,"y":834611,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542831,"y":840256,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598137,"y":663496,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591690,"y":662636,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":501641,"y":644503,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517557,"y":621498,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773231,"y":837843,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876519,"y":922729,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658148,"y":744880,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":869432,"y":926480,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596878,"y":652135,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772353,"y":834569,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630514,"y":733842,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773836,"y":835888,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515003,"y":620309,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532554,"y":893192,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541897,"y":851423,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636481,"y":909751,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":527264,"y":890585,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533005,"y":887698,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653492,"y":846388,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635028,"y":843613,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653465,"y":742794,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610521,"y":662219,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626223,"y":662688,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773159,"y":834748,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611539,"y":661826,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542566,"y":896802,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657858,"y":744840,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595105,"y":650190,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589675,"y":651823,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875991,"y":923576,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457415,"y":644022,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642973,"y":650154,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620052,"y":702837,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591565,"y":662669,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768087,"y":829564,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872978,"y":925229,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876477,"y":923087,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766635,"y":821205,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588265,"y":651854,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768821,"y":824475,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873368,"y":924922,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":862405,"y":903271,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585736,"y":642652,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586168,"y":642770,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587720,"y":640042,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460327,"y":645668,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459611,"y":647068,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608128,"y":690405,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603866,"y":685852,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609861,"y":689131,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606241,"y":684713,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767372,"y":821063,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609933,"y":687846,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771533,"y":835487,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630716,"y":716934,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660967,"y":669627,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564400,"y":814813,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605577,"y":684348,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613685,"y":795856,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526068,"y":655422,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457601,"y":646129,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435103,"y":695548,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701781,"y":762616,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461548,"y":645594,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658715,"y":745497,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656812,"y":764159,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772553,"y":817329,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701924,"y":760067,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596895,"y":652582,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406450,"y":709795,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652824,"y":789053,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585573,"y":643447,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671823,"y":857914,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585623,"y":645110,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584767,"y":641738,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658812,"y":745422,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761929,"y":823843,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584826,"y":640470,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588690,"y":650810,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586811,"y":643338,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586472,"y":643441,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625355,"y":708424,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531077,"y":889730,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":443174,"y":646930,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":820139,"y":885724,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584877,"y":646853,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460826,"y":647170,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459923,"y":647958,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641814,"y":848909,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576153,"y":913104,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457836,"y":645897,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600766,"y":647665,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599601,"y":652703,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598656,"y":647398,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617967,"y":800865,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651342,"y":785193,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608726,"y":792847,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459554,"y":644793,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611179,"y":792227,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":749494,"y":802763,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620119,"y":788262,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":498722,"y":648147,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590277,"y":641425,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585814,"y":643405,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":809116,"y":882789,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650366,"y":733031,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530563,"y":892237,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871376,"y":926288,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459947,"y":647768,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600058,"y":648188,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872134,"y":925567,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529891,"y":581762,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584259,"y":643870,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656359,"y":758683,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585615,"y":643093,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640194,"y":655222,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585825,"y":642612,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587517,"y":642119,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592808,"y":650670,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606739,"y":684798,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596785,"y":650501,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633648,"y":911750,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409434,"y":599148,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609472,"y":661193,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876754,"y":923599,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604441,"y":684353,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457261,"y":643960,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613766,"y":795824,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584789,"y":641914,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588597,"y":640474,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700586,"y":760183,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594542,"y":662589,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587437,"y":640507,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":835014,"y":957973,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630474,"y":715627,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585918,"y":644154,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588809,"y":649937,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591506,"y":650048,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656893,"y":744856,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296842,"y":300115,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":382641,"y":523784,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415221,"y":437894,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420482,"y":369987,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":265673,"y":208924,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":390984,"y":391262,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":209129,"y":410501,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409873,"y":396359,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405030,"y":396317,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409460,"y":396260,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406511,"y":397178,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409526,"y":403729,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413786,"y":400173,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153657,"y":198960,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":382735,"y":523813,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":302300,"y":346883,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":286593,"y":243039,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":229822,"y":430868,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242277,"y":129234,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243500,"y":130072,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":186209,"y":90647,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243217,"y":133159,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135256,"y":261456,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96121,"y":220492,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131068,"y":259506,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":217019,"y":216223,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":148184,"y":206027,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400506,"y":394140,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410777,"y":398980,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404272,"y":393512,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":413437,"y":397485,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244540,"y":135897,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":334803,"y":452933,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":319731,"y":474000,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":238807,"y":129668,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135256,"y":261456,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413001,"y":425238,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95448,"y":221203,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":201263,"y":105511,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243506,"y":129395,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243624,"y":130654,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79816,"y":64182,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":108207,"y":231457,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":377690,"y":523955,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288909,"y":513332,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":309994,"y":503619,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407506,"y":396176,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408294,"y":396423,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407634,"y":392098,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400536,"y":400860,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397821,"y":402228,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397473,"y":398161,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404174,"y":396221,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404625,"y":395448,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409874,"y":399329,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406642,"y":399044,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374696,"y":382881,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409176,"y":413619,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":310506,"y":337908,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":302299,"y":329155,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":314373,"y":339386,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":268772,"y":336681,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":334441,"y":352246,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337089,"y":353127,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":335482,"y":353057,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":342982,"y":360004,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":266456,"y":333146,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408470,"y":410456,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409815,"y":413089,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404421,"y":420987,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":141075,"y":48776,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":111643,"y":115950,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95838,"y":220165,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137610,"y":220262,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":184886,"y":89937,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":88959,"y":163371,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":77541,"y":122512,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78644,"y":128867,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243168,"y":133023,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243356,"y":133083,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95173,"y":220582,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95853,"y":220162,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403866,"y":395301,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296223,"y":300796,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297698,"y":298173,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294925,"y":299625,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237721,"y":260409,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":139804,"y":256896,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408558,"y":397555,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398108,"y":394619,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408834,"y":392895,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408294,"y":396423,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408296,"y":396322,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408541,"y":397308,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408825,"y":407091,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409875,"y":399310,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407954,"y":393815,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":94978,"y":220294,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95230,"y":220974,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":309016,"y":483266,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409335,"y":394234,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407681,"y":392119,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290062,"y":514685,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":53492,"y":70703,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240358,"y":130329,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243229,"y":132327,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":245038,"y":131587,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79577,"y":66288,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79534,"y":66907,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79594,"y":65987,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406616,"y":395165,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406030,"y":392626,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":432732,"y":363115,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":417092,"y":447300,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135256,"y":261456,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123392,"y":103744,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399365,"y":394691,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399127,"y":392753,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410243,"y":394834,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401177,"y":395215,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405538,"y":400199,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400788,"y":400333,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409727,"y":397096,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405980,"y":394339,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405301,"y":401365,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408940,"y":395187,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":427259,"y":372625,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296257,"y":300830,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336387,"y":353895,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244551,"y":135079,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242086,"y":130128,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412613,"y":399423,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411534,"y":397372,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":432744,"y":362762,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407271,"y":396989,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":94477,"y":219944,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399828,"y":397217,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410433,"y":395821,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414146,"y":398338,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409460,"y":396431,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410740,"y":395864,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243394,"y":132955,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404447,"y":420297,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243168,"y":133023,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243601,"y":133398,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95853,"y":220152,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101931,"y":221438,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":148894,"y":166888,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231931,"y":131606,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":385489,"y":387188,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":367187,"y":527543,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":391496,"y":391570,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80921,"y":61914,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412202,"y":398542,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239503,"y":136691,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95409,"y":220555,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101518,"y":221813,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79858,"y":65699,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":58905,"y":78013,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":76141,"y":99053,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434732,"y":365670,"year":"2006","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":24536,"y":95461,"year":"2006","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":99458,"y":77806,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587883,"y":649988,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525988,"y":890985,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635206,"y":828290,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":551591,"y":1259993,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":551388,"y":895836,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565741,"y":1234512,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594140,"y":1134811,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618539,"y":1141612,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602202,"y":1120705,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":482215,"y":1320909,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722100,"y":1040209,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585853,"y":642674,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609663,"y":660752,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694982,"y":1020504,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":738610,"y":969326,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":757056,"y":860627,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731500,"y":971337,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725330,"y":979939,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713937,"y":995433,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587579,"y":1129901,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611011,"y":792861,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555948,"y":1264299,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768775,"y":832315,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593995,"y":1131921,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656665,"y":1072503,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":126579,"y":223421,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684769,"y":979591,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":489687,"y":1289049,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718478,"y":990189,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718229,"y":990389,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524083,"y":1311329,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607395,"y":1097556,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720725,"y":1043112,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718056,"y":1042552,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555828,"y":1263820,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590916,"y":1144525,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589815,"y":1131748,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555197,"y":1255292,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596229,"y":1127816,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592399,"y":1130503,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612448,"y":1125754,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585224,"y":1127373,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582173,"y":1129933,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583241,"y":1131073,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581387,"y":1137942,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602465,"y":1116319,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601004,"y":1122591,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701506,"y":1044365,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":745786,"y":1024565,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662828,"y":1102773,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671899,"y":1066256,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588709,"y":1132098,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721550,"y":986802,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604354,"y":1117251,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598862,"y":1130095,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585646,"y":1131544,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594236,"y":1136562,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567731,"y":1241547,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593534,"y":1143160,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608258,"y":1112587,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594207,"y":1132738,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583407,"y":1130038,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601165,"y":1126699,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604407,"y":1117326,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636767,"y":1032636,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679124,"y":896595,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690152,"y":1090753,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598046,"y":1133812,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602847,"y":1131407,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604171,"y":1121666,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607989,"y":1114490,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623903,"y":1095244,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":449752,"y":1323582,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":246475,"y":133770,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709039,"y":1031099,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596437,"y":1129634,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706925,"y":936870,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680620,"y":896531,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720196,"y":1042512,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595353,"y":1142463,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555728,"y":1265382,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623441,"y":1095063,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556020,"y":1264578,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555228,"y":1261548,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594071,"y":1136159,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678144,"y":910880,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":98954,"y":221816,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565588,"y":1224935,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637770,"y":1031982,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557160,"y":1263977,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529968,"y":1211247,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602239,"y":1132797,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":484782,"y":1339108,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556862,"y":1261944,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131937,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589239,"y":1131684,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595500,"y":1134399,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729484,"y":1027474,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617969,"y":1142707,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638511,"y":1035876,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593766,"y":1143392,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589571,"y":1134111,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589242,"y":1134789,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588738,"y":1131217,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600815,"y":1126704,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603150,"y":1128699,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599530,"y":1122054,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603698,"y":1129261,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603435,"y":1115920,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596229,"y":1127815,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594811,"y":1129597,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726084,"y":968689,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595142,"y":1130806,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601469,"y":1125621,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605293,"y":1128198,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593702,"y":1135983,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598660,"y":1124071,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596253,"y":1126389,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609996,"y":1112176,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604074,"y":1123645,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604352,"y":1116138,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605278,"y":1119307,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594486,"y":1136236,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595989,"y":1121592,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600665,"y":1126672,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660835,"y":744611,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604730,"y":1120748,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770511,"y":848601,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604203,"y":1120759,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581380,"y":1139320,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604973,"y":1122378,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603135,"y":1122433,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630244,"y":940166,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636058,"y":1032148,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625421,"y":1070840,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627834,"y":1056081,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771370,"y":816648,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706990,"y":936597,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707036,"y":936460,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679958,"y":895338,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556854,"y":1261708,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619838,"y":1081979,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600132,"y":1042526,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630310,"y":1006327,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591940,"y":665061,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692173,"y":1093901,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692166,"y":1094574,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684553,"y":1107758,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629195,"y":1051889,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630163,"y":1051033,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597380,"y":652686,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578368,"y":1143503,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570857,"y":1147018,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":750027,"y":998625,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572356,"y":1205526,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":112157,"y":271322,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588677,"y":1167225,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589573,"y":1171120,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593271,"y":1133622,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671659,"y":1013146,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636692,"y":1012032,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626308,"y":978092,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713391,"y":1035971,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697629,"y":1048488,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720166,"y":1042551,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716421,"y":1041429,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715493,"y":1041724,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654225,"y":1019361,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582478,"y":1135792,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676685,"y":746989,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582513,"y":1133415,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":505705,"y":1333299,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583773,"y":1136008,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583937,"y":1133612,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593561,"y":1154602,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590872,"y":1143821,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589216,"y":1146714,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595085,"y":1143038,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606069,"y":1116851,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596074,"y":1121106,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":503258,"y":1291647,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619574,"y":1115471,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603019,"y":1116495,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610797,"y":1114621,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567470,"y":1172106,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631170,"y":1122164,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600870,"y":1121672,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610152,"y":1129538,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638428,"y":1031044,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633306,"y":1032908,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639662,"y":1034381,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639684,"y":1029548,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584722,"y":1133632,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639047,"y":1034360,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":362454,"y":424172,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637764,"y":1031990,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637621,"y":1031625,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638343,"y":1031859,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582234,"y":1133771,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639576,"y":1027637,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584350,"y":1129814,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584375,"y":1129808,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544191,"y":883106,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582210,"y":1130107,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581471,"y":1131529,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604399,"y":1104109,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772675,"y":834503,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767508,"y":848650,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586361,"y":1129927,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586601,"y":1129936,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583753,"y":1142018,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585406,"y":1130006,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582723,"y":1133057,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582705,"y":1132889,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579812,"y":1132345,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603509,"y":1123590,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719349,"y":1043783,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594109,"y":1136962,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594300,"y":1135743,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591965,"y":1132027,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588429,"y":1128001,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602089,"y":1128056,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509472,"y":1297775,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":484646,"y":1277434,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643206,"y":664871,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600602,"y":655434,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720929,"y":1041699,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596219,"y":1141312,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587462,"y":1142478,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":618726,"y":1132607,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588223,"y":1149322,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610130,"y":1107281,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773057,"y":861524,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606534,"y":1131069,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594038,"y":1136097,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595664,"y":1136697,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656514,"y":760653,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594418,"y":1131740,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590525,"y":1133470,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594323,"y":1136297,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593514,"y":1135090,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602908,"y":1136192,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600865,"y":1130419,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602657,"y":1133093,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601627,"y":1130909,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604608,"y":1120946,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592907,"y":1132215,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131980,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597456,"y":1131398,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593981,"y":1129410,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594507,"y":1136293,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593210,"y":1135740,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581498,"y":1131677,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602287,"y":1130589,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592556,"y":1137558,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592697,"y":1138266,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587478,"y":1156309,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587261,"y":1134035,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81844,"y":66495,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715897,"y":1034894,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695601,"y":1060894,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704952,"y":1028118,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":702752,"y":1043376,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517308,"y":619649,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696229,"y":1066190,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725156,"y":989372,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564653,"y":1230881,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583295,"y":1133026,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":736789,"y":1026395,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720913,"y":989208,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":738395,"y":998282,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602587,"y":1122774,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603016,"y":1114794,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603625,"y":1115539,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600700,"y":1121507,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673792,"y":1075447,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692062,"y":1094057,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659997,"y":1044590,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683237,"y":1026629,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720252,"y":1035821,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":736949,"y":1026391,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":791141,"y":1006939,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582549,"y":1136398,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787044,"y":1006919,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786357,"y":1006159,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590648,"y":1144798,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593383,"y":1140678,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590693,"y":1130687,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587442,"y":1132077,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580095,"y":1140122,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594577,"y":1136630,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598609,"y":1130349,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787825,"y":1007299,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616564,"y":1143318,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591786,"y":1131240,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536398,"y":1311150,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":570967,"y":1205942,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593606,"y":1136987,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565947,"y":1221152,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680476,"y":896424,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593419,"y":1136898,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600927,"y":1135752,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585197,"y":1128364,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591465,"y":1140823,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590207,"y":1140132,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510009,"y":1337649,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612736,"y":1102045,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607075,"y":1116477,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659061,"y":1017620,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642894,"y":995128,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652843,"y":1028724,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624574,"y":1074611,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662920,"y":1095964,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617268,"y":1069336,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715437,"y":1038213,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723363,"y":1039366,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666424,"y":1098074,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":753526,"y":1022427,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597602,"y":1129083,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593697,"y":1128868,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611912,"y":1103857,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565021,"y":1222738,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638178,"y":1033254,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638936,"y":1031281,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602237,"y":1118882,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590450,"y":1170980,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611397,"y":1112021,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588602,"y":1166420,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590896,"y":1092155,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706185,"y":930476,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686600,"y":1106463,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626676,"y":1044973,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593031,"y":1137145,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638917,"y":1033515,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597273,"y":1124846,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610964,"y":1031086,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592261,"y":1148950,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602301,"y":1125713,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601760,"y":1125968,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622894,"y":1142086,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606194,"y":1125746,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596167,"y":1119375,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601413,"y":1133291,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591920,"y":1133643,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601029,"y":1125517,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461502,"y":1329962,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":552192,"y":1259226,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555480,"y":1259913,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557389,"y":1266206,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555312,"y":1258745,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565011,"y":1222740,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564902,"y":1223148,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554434,"y":1259603,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581066,"y":1136924,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591138,"y":1142876,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586678,"y":1131702,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603296,"y":1116533,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582669,"y":1133460,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585424,"y":1129928,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596241,"y":1133526,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604602,"y":1120575,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582234,"y":1133770,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605601,"y":1116656,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600549,"y":1124460,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602724,"y":1123009,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598574,"y":1123554,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605248,"y":1116511,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599347,"y":1124099,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595654,"y":1122810,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603893,"y":1120696,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601346,"y":1126151,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585879,"y":1161979,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584299,"y":1185647,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587880,"y":1171511,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594186,"y":1159564,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595598,"y":1134605,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515703,"y":1238315,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460177,"y":1330647,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":506585,"y":1333642,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515644,"y":1225210,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624022,"y":1142547,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593369,"y":1132727,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589264,"y":1141249,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593375,"y":1129960,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597525,"y":1128341,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691650,"y":1095107,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592275,"y":1147522,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590722,"y":1140753,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593817,"y":1153279,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592626,"y":1161149,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610355,"y":1111121,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595614,"y":1135416,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601003,"y":1130692,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594176,"y":1135462,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589322,"y":1134652,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596557,"y":1136546,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594734,"y":1136021,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596245,"y":1132678,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602334,"y":1129396,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592818,"y":1144466,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592176,"y":1129768,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601121,"y":1128291,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601844,"y":1121786,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603495,"y":1117695,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589143,"y":1133961,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597271,"y":1131931,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592762,"y":1078912,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601667,"y":1102963,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600026,"y":1084120,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":495973,"y":1291588,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568388,"y":1238889,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516536,"y":1239212,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510762,"y":1332904,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461234,"y":1330159,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583607,"y":1126930,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584429,"y":1135818,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582243,"y":1133753,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581811,"y":1135823,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581044,"y":1139925,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578135,"y":1128233,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595925,"y":1127943,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596730,"y":1129037,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594677,"y":1135178,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590685,"y":1145424,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594310,"y":1145310,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592175,"y":1145407,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586697,"y":1149381,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610203,"y":1107489,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589101,"y":1144872,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594140,"y":1134811,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612313,"y":1102951,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581190,"y":1140059,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600841,"y":1134273,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591548,"y":1146245,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605472,"y":1115889,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767665,"y":1015936,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705908,"y":934185,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703599,"y":961002,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712789,"y":925266,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724342,"y":988749,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722287,"y":988170,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722161,"y":990238,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721752,"y":989711,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":734485,"y":998731,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721229,"y":987444,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722138,"y":990463,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":479766,"y":1343286,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569316,"y":1287553,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569866,"y":1231549,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557279,"y":1261122,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730139,"y":1028946,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710168,"y":1039206,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713965,"y":1039453,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502646,"y":1334498,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605367,"y":1119897,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593300,"y":1139884,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607000,"y":1117345,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576738,"y":1193589,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583074,"y":1161032,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520509,"y":1316787,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651532,"y":1041492,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626994,"y":1044460,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688468,"y":1073892,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657734,"y":1134768,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641994,"y":1029262,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605811,"y":1096782,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576461,"y":1225124,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603365,"y":1115853,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604075,"y":1123665,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620692,"y":1095358,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599525,"y":1122186,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599442,"y":1123081,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606563,"y":1132277,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605027,"y":1115856,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606552,"y":1117053,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641544,"y":1098595,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596259,"y":1122207,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602237,"y":1118882,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722205,"y":1041174,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713276,"y":1035992,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713848,"y":1032130,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665480,"y":1097125,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641541,"y":1042879,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662605,"y":1103392,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726052,"y":1037103,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720725,"y":1043112,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716524,"y":1039808,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725959,"y":990094,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635446,"y":1034148,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635671,"y":1031982,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684637,"y":951198,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761308,"y":1018878,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646851,"y":1089654,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678354,"y":1136093,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689701,"y":1074461,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691650,"y":1095107,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658091,"y":1059259,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642876,"y":1001494,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655132,"y":1018989,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685775,"y":979787,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682391,"y":1150013,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604178,"y":1121659,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593354,"y":1140128,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602090,"y":1130764,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593063,"y":1137156,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726762,"y":1038731,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627813,"y":1055983,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":463444,"y":1338257,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726774,"y":1038322,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590705,"y":1145456,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715506,"y":1039094,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719894,"y":991596,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718705,"y":1045310,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598025,"y":1133687,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587928,"y":1171496,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636137,"y":1031220,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787478,"y":1007847,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638703,"y":1034099,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638200,"y":1027840,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671040,"y":1069332,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659872,"y":1045005,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":782917,"y":1008904,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681221,"y":1001420,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673063,"y":1015468,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719695,"y":1044235,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719163,"y":1042497,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716296,"y":1037634,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714069,"y":1042339,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716160,"y":1040867,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558964,"y":1292910,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589392,"y":1171324,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581104,"y":1132227,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593100,"y":1138955,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592513,"y":1137600,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592704,"y":1137439,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607767,"y":1113572,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":508878,"y":1296614,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604229,"y":1122097,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594544,"y":1134842,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598580,"y":1130289,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596316,"y":1126083,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604673,"y":1120490,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605063,"y":1127936,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601874,"y":1122481,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581342,"y":1190742,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604052,"y":1115222,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586134,"y":1188203,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593259,"y":1139660,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593347,"y":1143651,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602196,"y":1126478,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607057,"y":1116253,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606167,"y":1118644,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588919,"y":1142923,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684553,"y":1107758,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594585,"y":1136538,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605725,"y":1117263,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601175,"y":1125793,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726762,"y":1038731,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597961,"y":1139512,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608331,"y":1112356,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609808,"y":1109123,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556142,"y":1264358,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719131,"y":1044299,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720166,"y":1042551,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528993,"y":1299378,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604925,"y":1122179,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602179,"y":1120810,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603649,"y":1128859,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604178,"y":1121659,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664953,"y":1100546,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592846,"y":1132104,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704181,"y":930266,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591100,"y":1129445,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588567,"y":1128829,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584894,"y":1129483,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653629,"y":1129518,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595019,"y":1136089,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600457,"y":1127706,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603321,"y":1131819,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595355,"y":1131959,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607667,"y":1113736,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585403,"y":1184521,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599429,"y":1123088,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587374,"y":1130306,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591065,"y":1130871,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595370,"y":1129470,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695458,"y":1020552,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605162,"y":1117007,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691359,"y":1006382,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601097,"y":1125748,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589348,"y":1130256,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461184,"y":1330245,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":513085,"y":1287242,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565988,"y":1156427,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575130,"y":1178601,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593076,"y":1138911,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600834,"y":1128701,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565988,"y":1156427,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596043,"y":1123843,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602732,"y":1132592,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600227,"y":1135115,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555841,"y":1267623,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600622,"y":1123558,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595111,"y":1136802,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593959,"y":1135777,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594230,"y":1141555,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582904,"y":1133246,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593350,"y":1140111,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601028,"y":1129808,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517584,"y":1303732,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556408,"y":1266736,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594481,"y":1136227,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457800,"y":644899,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663785,"y":747904,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874578,"y":924433,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772228,"y":838533,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528383,"y":891241,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585598,"y":642783,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588654,"y":639554,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761448,"y":822784,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":865729,"y":938179,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585852,"y":643186,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":865729,"y":938179,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557525,"y":824114,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541792,"y":886999,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438594,"y":673253,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744351,"y":789973,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660862,"y":706211,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632940,"y":832588,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668764,"y":800026,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":735715,"y":785187,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":746558,"y":889654,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658960,"y":745577,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873874,"y":925534,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459855,"y":647758,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631795,"y":661701,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":827641,"y":886741,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774057,"y":837089,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658400,"y":746386,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541958,"y":834016,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595945,"y":663387,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629521,"y":776601,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529500,"y":890502,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530660,"y":892381,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595014,"y":661933,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591674,"y":660277,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600157,"y":653912,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531784,"y":892879,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597593,"y":673030,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":443173,"y":648967,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600487,"y":652986,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594702,"y":650498,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596978,"y":652961,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600140,"y":654413,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656882,"y":884691,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643370,"y":869195,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603182,"y":655797,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601544,"y":655306,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600752,"y":645550,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602050,"y":677356,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435685,"y":667235,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437394,"y":665010,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661144,"y":679505,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":448864,"y":636952,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766576,"y":821529,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518953,"y":626768,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761022,"y":825747,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874382,"y":924421,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871986,"y":924371,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875273,"y":923757,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594918,"y":651535,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595046,"y":661555,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591776,"y":660912,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774113,"y":825115,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767076,"y":821021,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521378,"y":644507,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773311,"y":837149,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761190,"y":823795,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657885,"y":744879,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660431,"y":746273,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585542,"y":643127,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611847,"y":687666,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774163,"y":837381,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613915,"y":694194,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675450,"y":746335,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770272,"y":843489,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":782316,"y":876351,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460083,"y":647347,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517251,"y":616828,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":393650,"y":599911,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528516,"y":598675,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767596,"y":820727,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765147,"y":822381,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387942,"y":596455,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819879,"y":886117,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585725,"y":639726,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":776202,"y":824282,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643703,"y":659843,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":445300,"y":642740,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873799,"y":924999,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598960,"y":651796,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":851858,"y":949223,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575290,"y":918881,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643520,"y":777849,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606049,"y":684845,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584014,"y":644182,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600533,"y":653336,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":538585,"y":881819,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":820834,"y":886823,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605319,"y":680747,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623316,"y":662438,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588946,"y":648034,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648756,"y":680560,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601199,"y":644795,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659131,"y":680459,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586002,"y":643525,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587091,"y":646824,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632540,"y":661597,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601226,"y":676898,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593842,"y":650951,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399776,"y":720241,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661858,"y":679556,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768637,"y":822320,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729906,"y":783051,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438091,"y":671691,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630576,"y":733166,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770541,"y":840312,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409276,"y":717382,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639688,"y":739876,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586124,"y":643240,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588102,"y":640512,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529560,"y":853719,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769774,"y":834916,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455676,"y":643101,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772381,"y":864917,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793151,"y":921478,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613170,"y":793536,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765500,"y":822738,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659550,"y":755116,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659551,"y":755116,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536230,"y":878534,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762946,"y":835765,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635290,"y":809978,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594255,"y":650830,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767276,"y":821186,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586250,"y":642503,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585952,"y":644035,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597319,"y":646352,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640423,"y":764748,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650122,"y":672027,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597014,"y":650852,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601271,"y":652853,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586216,"y":644707,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586734,"y":645209,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613936,"y":797940,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":585850,"y":642667,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767744,"y":832275,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588808,"y":640754,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585774,"y":643643,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631004,"y":733132,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529076,"y":890815,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531297,"y":886556,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586897,"y":638395,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586471,"y":641292,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585850,"y":642667,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589963,"y":639645,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461211,"y":646771,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662538,"y":794722,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":795389,"y":919353,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657490,"y":757493,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":836440,"y":884254,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671441,"y":750859,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548497,"y":859960,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473466,"y":503338,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413683,"y":426765,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296989,"y":300907,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":299646,"y":314843,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297458,"y":299249,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80383,"y":154887,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243603,"y":132640,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408060,"y":395188,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407736,"y":393208,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407326,"y":395690,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408055,"y":396058,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409760,"y":400768,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400637,"y":399964,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":77019,"y":47902,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434270,"y":365402,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244031,"y":132443,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242418,"y":136240,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403255,"y":400624,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":395141,"y":398234,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":92739,"y":218766,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":388305,"y":412107,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244119,"y":132457,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82190,"y":63756,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":237261,"y":129652,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123771,"y":102869,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":206677,"y":277155,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202371,"y":104225,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298389,"y":312007,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":250762,"y":135554,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241758,"y":132041,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":245582,"y":132193,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":182463,"y":282193,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":184969,"y":89994,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":120175,"y":93327,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":238613,"y":135413,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":224063,"y":322848,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337206,"y":354658,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":329572,"y":372203,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282926,"y":261260,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":306715,"y":335450,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239633,"y":130083,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239705,"y":129924,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410150,"y":394881,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401911,"y":397704,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410475,"y":395518,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398059,"y":394610,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408551,"y":398368,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411946,"y":399604,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397418,"y":394495,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407112,"y":395181,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411828,"y":399616,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411590,"y":394693,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406370,"y":393274,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410454,"y":395144,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408047,"y":397293,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405853,"y":395146,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":395189,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409313,"y":397203,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240156,"y":435428,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":299408,"y":546631,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278467,"y":465086,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403600,"y":374744,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404382,"y":422204,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404623,"y":374854,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400787,"y":400374,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":177327,"y":98377,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408053,"y":396293,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405834,"y":395141,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95740,"y":220254,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95340,"y":220274,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":98277,"y":221431,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":93196,"y":219548,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96030,"y":219986,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81113,"y":64725,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81385,"y":65221,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241942,"y":128556,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":185710,"y":90298,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":240891,"y":131901,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296407,"y":533469,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407047,"y":398413,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":259726,"y":315603,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243761,"y":133126,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":371498,"y":531618,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":162694,"y":140648,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":108217,"y":231456,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408509,"y":413595,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409116,"y":412586,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411906,"y":442002,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415179,"y":438739,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":505732,"y":538600,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410998,"y":396153,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457449,"y":473591,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411008,"y":397515,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":358902,"y":410351,"year":"2007","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154326,"y":198772,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336273,"y":354890,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":269749,"y":336457,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277556,"y":220327,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407872,"y":394336,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243207,"y":134559,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411919,"y":399453,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135219,"y":261172,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241011,"y":129491,"year":"2007","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771742,"y":849085,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659654,"y":746790,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":861161,"y":902098,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701227,"y":761927,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":117419,"y":88947,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414595,"y":396779,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":386268,"y":397916,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399033,"y":395300,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641864,"y":724639,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658138,"y":745892,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572800,"y":1202386,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715689,"y":1038502,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721441,"y":1041012,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718293,"y":1044722,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718280,"y":1044821,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697869,"y":1047809,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638019,"y":763088,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678604,"y":1126402,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665558,"y":1119080,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":688715,"y":1073788,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581822,"y":1190460,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296783,"y":299273,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579740,"y":1221090,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515574,"y":1238120,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":521954,"y":1314432,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524076,"y":1310606,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617205,"y":1090636,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591398,"y":1092516,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597521,"y":1101035,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620496,"y":1095321,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614621,"y":1095440,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593112,"y":650732,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657143,"y":701897,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586008,"y":641647,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600549,"y":1124460,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413067,"y":400343,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589459,"y":1162990,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705031,"y":1028179,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585918,"y":1186157,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704162,"y":930475,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705685,"y":927451,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707014,"y":936511,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710394,"y":931095,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409760,"y":400768,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684868,"y":1006432,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692639,"y":974285,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602665,"y":1117307,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":787431,"y":1004832,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786838,"y":1007339,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723209,"y":1040927,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554567,"y":1268291,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595926,"y":1128969,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721472,"y":1040917,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605101,"y":1122893,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601227,"y":1126666,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590038,"y":1132617,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592033,"y":1130249,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591802,"y":1135206,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502747,"y":1310788,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555333,"y":1259696,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493009,"y":1288843,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629990,"y":1051389,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630193,"y":1051005,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590554,"y":1149223,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586091,"y":1186758,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595988,"y":1136570,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530012,"y":892226,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593935,"y":1135498,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591567,"y":1129680,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690309,"y":1091645,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601339,"y":1126180,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595668,"y":1134354,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596313,"y":1127222,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604182,"y":1133459,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586956,"y":1129393,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594551,"y":1136208,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592701,"y":1134586,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586709,"y":1130109,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593180,"y":1136443,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603729,"y":1132447,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592361,"y":1134298,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587341,"y":1130193,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584423,"y":1135680,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690171,"y":1090510,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576797,"y":1258859,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650528,"y":1212414,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574027,"y":1198450,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594444,"y":1134876,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592876,"y":1132298,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594386,"y":1135402,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598246,"y":1130363,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592104,"y":1133767,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715440,"y":991054,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589723,"y":1132974,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605250,"y":1120375,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589613,"y":1134138,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588549,"y":1131274,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594949,"y":1128198,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584016,"y":1138652,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638438,"y":1030632,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639718,"y":1034213,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635858,"y":1033815,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640062,"y":1031364,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553082,"y":1281844,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557113,"y":1262001,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600948,"y":1125351,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581767,"y":1135481,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637336,"y":1032357,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589986,"y":1132556,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568586,"y":1245173,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640456,"y":1013595,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679705,"y":1139628,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555464,"y":1250653,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":797678,"y":999080,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681273,"y":1018932,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":742876,"y":1024072,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471361,"y":651971,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591385,"y":660762,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720674,"y":990364,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571450,"y":1248452,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":506585,"y":1333642,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718404,"y":1045140,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471086,"y":651859,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605305,"y":1122899,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605662,"y":1127683,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594493,"y":1135527,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588369,"y":1131057,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587760,"y":1127705,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592795,"y":1138441,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580903,"y":1138696,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640147,"y":1034487,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601966,"y":1133593,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688956,"y":1073940,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":626756,"y":1041054,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601545,"y":1121633,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":550122,"y":850701,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407569,"y":395692,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242775,"y":130975,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583654,"y":1128356,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":394800,"y":393549,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873841,"y":924984,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555624,"y":1261561,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705415,"y":928108,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716417,"y":1041412,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721687,"y":1042189,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594632,"y":1136726,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601419,"y":1121036,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586595,"y":1134111,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618224,"y":1026753,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587636,"y":643496,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536302,"y":1302290,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655299,"y":1212447,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579378,"y":1136973,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606486,"y":1116178,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594071,"y":1134129,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605450,"y":1124310,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590423,"y":1133518,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528993,"y":1299378,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594173,"y":1136134,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591812,"y":1129940,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670990,"y":1148900,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594239,"y":1135102,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704336,"y":929266,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568359,"y":1236908,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592109,"y":1140768,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582513,"y":1133415,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585776,"y":1185033,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607806,"y":1127247,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595446,"y":1143127,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589602,"y":1134327,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662870,"y":999391,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531241,"y":1311096,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519332,"y":1337723,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659186,"y":1066746,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557989,"y":1264916,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588229,"y":1166199,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598192,"y":1125260,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583941,"y":1134799,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535287,"y":1311908,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660139,"y":1017032,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473361,"y":1287170,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607463,"y":1131277,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762600,"y":815796,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":835529,"y":884715,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":822317,"y":899816,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593641,"y":1140552,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":437697,"y":647258,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79715,"y":65566,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661668,"y":679803,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570608,"y":1151138,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673246,"y":1133547,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536998,"y":894866,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":455931,"y":634877,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585691,"y":643459,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586642,"y":645093,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":426890,"y":371667,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598258,"y":649317,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596437,"y":652068,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":860970,"y":901947,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873196,"y":925484,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630598,"y":729813,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457789,"y":644840,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679481,"y":811346,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652010,"y":786507,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591484,"y":659175,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610162,"y":795746,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681273,"y":1018932,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694276,"y":1019605,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591396,"y":661870,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502960,"y":647137,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766834,"y":830927,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585426,"y":643378,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589971,"y":640452,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566151,"y":1220195,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404744,"y":396285,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617102,"y":1091473,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80666,"y":64326,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438773,"y":659641,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":860533,"y":869014,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560587,"y":820203,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644128,"y":867132,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646772,"y":737125,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603885,"y":683357,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553812,"y":1267354,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296768,"y":303168,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404940,"y":397420,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595299,"y":806195,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611082,"y":1105680,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592181,"y":1129767,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579746,"y":1135021,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643266,"y":866004,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767022,"y":821295,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873716,"y":923824,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420853,"y":693057,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873785,"y":925042,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874522,"y":924273,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":440469,"y":657814,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614073,"y":694449,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767252,"y":820585,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767271,"y":821681,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576793,"y":813073,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606484,"y":793119,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597025,"y":1127820,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493028,"y":644996,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586214,"y":640577,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":421229,"y":639122,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611604,"y":794425,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609415,"y":795346,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772219,"y":836056,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771770,"y":838075,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614564,"y":666695,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621880,"y":667629,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600072,"y":646682,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772768,"y":835684,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590841,"y":654950,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632429,"y":909128,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":835909,"y":952578,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":118278,"y":229976,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589979,"y":651308,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585778,"y":643020,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584522,"y":644758,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586153,"y":644458,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660035,"y":678663,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605472,"y":683473,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661415,"y":679436,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528615,"y":892052,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560170,"y":1259101,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511993,"y":877670,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530462,"y":892288,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596495,"y":671898,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592989,"y":660599,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597335,"y":650765,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591153,"y":654712,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874275,"y":924534,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":615571,"y":696203,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81463,"y":67112,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600086,"y":648335,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581242,"y":1139344,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599603,"y":653506,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":545726,"y":831999,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766389,"y":821729,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":686103,"y":1106250,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771768,"y":838080,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544315,"y":898372,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593259,"y":1201132,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555609,"y":1256332,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590511,"y":1130273,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592073,"y":1136335,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593606,"y":1136987,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532457,"y":1319727,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":508496,"y":1297167,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555766,"y":1265377,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601258,"y":1127584,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592167,"y":1142311,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589532,"y":1130477,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590583,"y":1130173,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602851,"y":1132654,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591783,"y":1135031,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590932,"y":1142131,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":419956,"y":1397926,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":490196,"y":1302088,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597407,"y":1139505,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584097,"y":1135084,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586995,"y":1130725,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584464,"y":1135556,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605542,"y":1122319,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605022,"y":1123356,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":496062,"y":1339837,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604814,"y":1096108,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606289,"y":1097276,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600782,"y":1122269,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601008,"y":1126207,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568719,"y":1232111,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595485,"y":1132035,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603643,"y":1123653,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589439,"y":1153230,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593435,"y":1128814,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":539026,"y":1314384,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589959,"y":1152207,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662789,"y":1140290,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638091,"y":1033462,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641346,"y":1029769,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687831,"y":985549,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661878,"y":1012397,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680621,"y":1102241,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665480,"y":1097125,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714163,"y":1037347,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685452,"y":980832,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704425,"y":918525,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":683391,"y":1132200,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688844,"y":1120571,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709816,"y":1034290,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703122,"y":1043096,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709454,"y":1033370,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716246,"y":1036418,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720549,"y":990879,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":736662,"y":999443,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594239,"y":1135932,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595206,"y":1129545,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585872,"y":1162237,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608683,"y":1113834,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694825,"y":1055399,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606209,"y":1117115,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638316,"y":1027736,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600881,"y":1135408,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604674,"y":1123689,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687137,"y":959363,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722603,"y":989898,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591939,"y":1133823,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573227,"y":1279229,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713888,"y":1035543,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":479782,"y":1343275,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606934,"y":1130456,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604025,"y":1123721,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605539,"y":1127104,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592028,"y":1149202,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586734,"y":1148857,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590582,"y":1149233,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593380,"y":1151451,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590586,"y":1145795,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596313,"y":1119886,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593207,"y":1142867,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607111,"y":1124211,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593715,"y":1144479,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589847,"y":1143929,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593275,"y":1142660,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591176,"y":1145162,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592330,"y":1145120,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598920,"y":1122586,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602896,"y":1120981,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599003,"y":1122234,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603721,"y":1129303,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676764,"y":1023239,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690192,"y":1116431,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661175,"y":1114580,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690661,"y":1117170,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682827,"y":1134632,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681646,"y":1135179,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718874,"y":999642,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626072,"y":980185,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621265,"y":952434,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652760,"y":1018261,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637614,"y":1031912,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633567,"y":1036339,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636451,"y":1036706,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637908,"y":1029043,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638097,"y":1035328,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634104,"y":1032162,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688714,"y":1073788,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664275,"y":1096847,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705433,"y":928756,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704593,"y":929701,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704203,"y":931030,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680136,"y":1007713,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675788,"y":900416,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704153,"y":929459,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":723741,"y":910274,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695322,"y":1004729,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679174,"y":1006888,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634027,"y":1042924,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726664,"y":990722,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711189,"y":1001881,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722326,"y":989211,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722037,"y":989917,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722343,"y":989668,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718798,"y":995446,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721907,"y":989693,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":732115,"y":968732,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720731,"y":990094,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721550,"y":986802,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719101,"y":995350,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722032,"y":990254,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720575,"y":990748,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592564,"y":1192554,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786962,"y":1007333,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605921,"y":1120566,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605628,"y":1116668,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603829,"y":1128937,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602906,"y":1122756,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611872,"y":1112044,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602196,"y":1120700,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607495,"y":1127328,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604828,"y":1120322,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604829,"y":1120319,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603946,"y":1120664,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606577,"y":1115773,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605063,"y":1127936,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603691,"y":1129290,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601860,"y":1121927,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602446,"y":1118341,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619324,"y":1115096,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597287,"y":1124850,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604138,"y":1119735,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606395,"y":1130484,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604758,"y":1120652,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614215,"y":1122240,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":451237,"y":1324424,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536119,"y":1302095,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566290,"y":1217428,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537050,"y":1309887,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661829,"y":1104817,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691954,"y":1019182,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585040,"y":1182751,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581237,"y":1134644,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581692,"y":1136513,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578679,"y":1143229,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601858,"y":1127649,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603905,"y":1133202,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595292,"y":1131506,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596151,"y":1128698,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593819,"y":1131865,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594158,"y":1133391,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593786,"y":1128827,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592231,"y":1128271,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588751,"y":1130795,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622327,"y":1141449,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583407,"y":1130038,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585729,"y":1130618,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584105,"y":1128298,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584017,"y":1131276,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581047,"y":1132909,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582556,"y":1132593,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582630,"y":1136897,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579857,"y":1131511,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697625,"y":1071756,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":813602,"y":1000386,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610924,"y":1112921,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610203,"y":1107489,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613010,"y":1097930,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605320,"y":1086493,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609660,"y":1106191,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609554,"y":1127457,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608598,"y":1128727,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606800,"y":1121503,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605700,"y":1118359,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604434,"y":1116629,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594418,"y":1134998,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591135,"y":1156086,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590347,"y":1149629,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568468,"y":1232224,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588742,"y":1163975,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589890,"y":1169762,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592770,"y":1151825,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598232,"y":1131053,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600659,"y":1128773,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609324,"y":1109883,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607056,"y":1116016,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604890,"y":1121068,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600299,"y":1131026,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589686,"y":1142619,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591031,"y":1149610,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594592,"y":1144951,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591766,"y":1152648,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591228,"y":1152411,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591483,"y":1153191,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600562,"y":1135300,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589573,"y":1171120,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565254,"y":1158918,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592810,"y":1160067,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592975,"y":1132562,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593324,"y":1136441,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588287,"y":1166356,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620826,"y":1143008,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588964,"y":1133953,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565141,"y":1225275,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596662,"y":1095803,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596739,"y":1128919,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591737,"y":1131786,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589359,"y":1153757,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592954,"y":1132487,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594312,"y":1136513,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594183,"y":1136830,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593982,"y":1135509,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594096,"y":1135466,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589417,"y":1131890,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599116,"y":1131680,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591271,"y":1134423,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644893,"y":1087932,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694351,"y":1085831,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707982,"y":1032745,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717240,"y":1035796,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594872,"y":1160609,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582904,"y":1133246,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596217,"y":1132959,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586601,"y":1129936,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607634,"y":1120589,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612783,"y":1109679,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595788,"y":1127778,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694775,"y":1055220,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":709296,"y":1033223,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719182,"y":1042484,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704472,"y":928962,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582801,"y":1129806,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606912,"y":1117484,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609912,"y":1095664,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612397,"y":1125749,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659784,"y":1045501,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":498959,"y":1335624,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593915,"y":1137219,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582254,"y":1133959,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556027,"y":1264607,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566336,"y":1270683,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719829,"y":1043526,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":715579,"y":1038996,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556797,"y":1262006,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555666,"y":1259680,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556929,"y":1264308,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556663,"y":1262327,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680498,"y":1146264,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770791,"y":990394,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":788483,"y":995274,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786655,"y":1007348,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692147,"y":1019136,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638776,"y":1033237,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580365,"y":1132187,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718260,"y":1044969,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681478,"y":1135598,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622603,"y":999097,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626666,"y":1032623,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724342,"y":988749,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619211,"y":1027015,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584429,"y":1135818,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718252,"y":1045021,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787995,"y":1007283,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694601,"y":1050636,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713216,"y":1042678,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715054,"y":1038237,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716025,"y":1039236,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594375,"y":1141992,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697885,"y":1047784,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721617,"y":1041315,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716222,"y":1038675,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594886,"y":1136853,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712541,"y":1035156,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705386,"y":1030599,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519423,"y":1337899,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":783503,"y":1010458,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768142,"y":965038,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719764,"y":988887,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641671,"y":1029752,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638714,"y":1032009,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601237,"y":1128471,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724250,"y":1040240,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639826,"y":1034162,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690595,"y":1116313,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593329,"y":1144114,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720149,"y":1042544,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569253,"y":1231823,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604888,"y":1124703,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582477,"y":1135772,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590064,"y":1132641,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":508634,"y":1244257,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":422636,"y":1394687,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589765,"y":1128427,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696892,"y":971713,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690908,"y":1018991,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589349,"y":1129985,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605040,"y":1120330,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612357,"y":1115113,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586660,"y":1161829,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549697,"y":1246218,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582030,"y":1190017,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606609,"y":1117910,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600503,"y":1136410,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596392,"y":1132790,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601844,"y":1121786,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":747962,"y":1027614,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600323,"y":1136468,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612825,"y":1109652,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606960,"y":1097487,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592902,"y":1135640,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648188,"y":1022900,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592056,"y":1134639,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661280,"y":679118,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658124,"y":746893,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630011,"y":715986,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519674,"y":885437,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517787,"y":622841,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600552,"y":652536,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":700243,"y":760065,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695835,"y":757023,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":742891,"y":759676,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674584,"y":829335,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601046,"y":654637,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531175,"y":888384,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603589,"y":682375,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590009,"y":655858,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594266,"y":651477,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":440571,"y":632125,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":847879,"y":947225,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586068,"y":645159,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661561,"y":679548,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774932,"y":822565,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":500483,"y":670565,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773329,"y":838891,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":373781,"y":565142,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629965,"y":728135,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597060,"y":651074,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607971,"y":661580,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774054,"y":837744,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548303,"y":833064,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587607,"y":640334,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592761,"y":650652,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874536,"y":924259,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591998,"y":665182,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658109,"y":745945,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":757981,"y":820669,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598223,"y":665369,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596193,"y":663864,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420816,"y":692705,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600832,"y":653401,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537430,"y":839679,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767193,"y":820685,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658513,"y":745229,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530872,"y":890977,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606706,"y":659160,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622247,"y":666119,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609081,"y":661593,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613688,"y":665202,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529905,"y":892208,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643684,"y":778038,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562800,"y":901566,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590820,"y":663258,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597089,"y":653030,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659915,"y":678569,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":518279,"y":841869,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517524,"y":625676,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767234,"y":818958,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587931,"y":650398,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708802,"y":683115,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616327,"y":697386,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624908,"y":662135,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485244,"y":643661,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546778,"y":833756,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640028,"y":777200,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617837,"y":699744,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438108,"y":665042,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512737,"y":621317,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634508,"y":840560,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517154,"y":620932,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":735778,"y":809595,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":500019,"y":622855,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588394,"y":650159,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598386,"y":647973,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459388,"y":647128,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680221,"y":735040,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659685,"y":747750,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588725,"y":639560,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764659,"y":823136,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600926,"y":655157,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600051,"y":648152,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399698,"y":598214,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627351,"y":713838,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":420825,"y":692784,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585710,"y":644431,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761218,"y":822977,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712606,"y":776921,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872021,"y":928063,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657477,"y":744662,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769203,"y":822191,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716924,"y":782046,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658519,"y":746169,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":761522,"y":823173,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515895,"y":859335,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447022,"y":634774,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":544405,"y":898427,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530845,"y":892451,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536401,"y":894429,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766177,"y":819770,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764804,"y":823459,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575225,"y":908965,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589888,"y":657084,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662902,"y":749514,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591384,"y":658280,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764215,"y":823872,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546766,"y":850911,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516932,"y":620523,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459464,"y":644442,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585372,"y":641048,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611108,"y":797654,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586376,"y":640889,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586219,"y":642963,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461746,"y":647638,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":469855,"y":653789,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460946,"y":646773,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586307,"y":643159,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":477973,"y":656475,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595654,"y":671387,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460415,"y":647575,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586301,"y":641258,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438116,"y":665253,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674283,"y":826950,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":735733,"y":809805,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772225,"y":869171,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471719,"y":651528,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873666,"y":925180,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874536,"y":924259,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873851,"y":924742,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864714,"y":925153,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872609,"y":923946,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":867937,"y":933527,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874235,"y":924575,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874735,"y":925690,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460954,"y":646998,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584980,"y":641049,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773896,"y":836628,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773733,"y":835413,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774027,"y":837260,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774116,"y":837702,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772435,"y":838531,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772193,"y":837034,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":759929,"y":843010,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773655,"y":836654,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773083,"y":835952,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773980,"y":837539,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624041,"y":662120,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633946,"y":661361,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":746575,"y":883609,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584440,"y":643172,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600423,"y":649526,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586329,"y":642361,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680900,"y":746820,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680652,"y":746796,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605859,"y":684632,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586813,"y":640057,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586206,"y":643506,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461578,"y":646144,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614339,"y":694872,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586716,"y":646199,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":423335,"y":653627,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":870140,"y":927614,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628295,"y":713898,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533775,"y":893438,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590610,"y":660366,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591748,"y":662717,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876572,"y":923260,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766805,"y":821782,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767995,"y":821900,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872774,"y":925713,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640713,"y":776772,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764618,"y":823180,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586212,"y":640854,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592963,"y":650748,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459694,"y":647920,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871815,"y":928279,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611170,"y":688794,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656360,"y":758682,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762428,"y":821222,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641639,"y":724341,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643144,"y":849592,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588649,"y":651000,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408201,"y":397553,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413013,"y":401434,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409461,"y":396208,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":386720,"y":414742,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411401,"y":412604,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412060,"y":424773,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81480,"y":65121,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":81624,"y":63885,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278802,"y":493796,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406818,"y":392729,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":308662,"y":333557,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404067,"y":397545,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":230386,"y":432540,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412469,"y":388112,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79444,"y":66379,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":38714,"y":253726,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":160819,"y":149301,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277556,"y":220327,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":26761,"y":105616,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":261664,"y":205314,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401298,"y":401949,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411784,"y":398225,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407667,"y":390586,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399812,"y":394200,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413276,"y":393220,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400683,"y":408962,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408337,"y":409819,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413620,"y":398544,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413416,"y":398905,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403457,"y":399793,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407347,"y":405522,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":395176,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408304,"y":395188,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405575,"y":400164,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413537,"y":397989,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":337494,"y":354871,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":320639,"y":341688,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":353842,"y":367102,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":338776,"y":373030,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":300524,"y":343202,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":285497,"y":484167,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":289055,"y":513437,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":24014,"y":173183,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":287582,"y":237282,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":222011,"y":212507,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":94943,"y":220070,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243511,"y":132610,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412321,"y":437548,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473427,"y":503116,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244642,"y":135515,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":270279,"y":484462,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":84289,"y":73174,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296286,"y":297165,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298022,"y":298722,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":113659,"y":114016,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":112579,"y":52863,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404709,"y":393065,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406753,"y":393350,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80111,"y":65507,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79593,"y":65804,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82774,"y":63739,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":365298,"y":400867,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79853,"y":65770,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80589,"y":65618,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":185418,"y":66655,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":250090,"y":159932,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153615,"y":198959,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135406,"y":219857,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":249510,"y":158835,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79625,"y":65806,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135249,"y":261383,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":85621,"y":215917,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":315119,"y":339671,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":122075,"y":95863,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":142885,"y":234392,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":213578,"y":116736,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":72037,"y":62158,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101270,"y":222714,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402494,"y":400609,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411660,"y":396835,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409326,"y":400761,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242389,"y":128604,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407836,"y":395193,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":102000,"y":223398,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243828,"y":135416,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414663,"y":398622,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402220,"y":391657,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":205118,"y":367306,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":287315,"y":239868,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297119,"y":299773,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":75760,"y":97799,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398990,"y":395185,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404856,"y":401663,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79641,"y":65002,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95236,"y":220431,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407950,"y":394709,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":276773,"y":219084,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415292,"y":398020,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401287,"y":401963,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243874,"y":133085,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":187264,"y":67975,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243089,"y":130789,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95536,"y":220441,"year":"2008","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79527,"y":67037,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80611,"y":68389,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":120135,"y":235923,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405365,"y":398504,"year":"2008","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626062,"y":662689,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":225303,"y":127574,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607804,"y":1090974,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":155019,"y":246552,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149410,"y":166492,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":390271,"y":390836,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460691,"y":646763,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460440,"y":647570,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":457568,"y":644977,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460942,"y":646664,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":386554,"y":389160,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460688,"y":646678,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772637,"y":835386,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528264,"y":606131,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515237,"y":620307,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612343,"y":795235,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631034,"y":733673,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603431,"y":1115929,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628282,"y":713883,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648078,"y":782494,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669699,"y":800489,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656659,"y":792104,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630582,"y":716728,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":881493,"y":973593,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535439,"y":837325,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":796082,"y":915517,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530213,"y":892214,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":801941,"y":905339,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586167,"y":642845,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586079,"y":645362,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":742843,"y":760877,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638649,"y":770321,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640236,"y":766163,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673939,"y":802689,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675084,"y":804709,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398592,"y":394733,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626470,"y":710221,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630703,"y":716641,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656563,"y":744427,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407326,"y":395690,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586847,"y":643206,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409691,"y":409311,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656608,"y":746610,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297709,"y":296771,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656711,"y":746063,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658950,"y":745595,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533510,"y":892525,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598051,"y":652064,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655154,"y":761453,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523114,"y":645864,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":775814,"y":876494,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599501,"y":651879,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595622,"y":652803,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653799,"y":789656,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585813,"y":1185813,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613140,"y":662689,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631433,"y":742865,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595105,"y":650190,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874085,"y":924180,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762018,"y":816762,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460701,"y":647051,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586037,"y":646619,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768156,"y":820205,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634548,"y":849046,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604992,"y":682035,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658317,"y":739754,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516814,"y":618170,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864345,"y":918336,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591674,"y":660265,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766104,"y":821485,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":526654,"y":602098,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630688,"y":717826,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":899071,"y":959855,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607184,"y":685417,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459522,"y":646585,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":790481,"y":924690,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585952,"y":644035,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611840,"y":794235,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409459,"y":396798,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404040,"y":392941,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244362,"y":138494,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407811,"y":396081,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411871,"y":397007,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405050,"y":398592,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406136,"y":401322,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130440,"y":261449,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":694721,"y":1019627,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":338127,"y":355504,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":142710,"y":342551,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387631,"y":524234,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79836,"y":66061,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243563,"y":132207,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":40745,"y":99745,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244053,"y":134667,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":125669,"y":244260,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81235,"y":67892,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":198954,"y":284990,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407376,"y":397673,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404112,"y":398995,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100851,"y":222452,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":417159,"y":447407,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":287467,"y":329289,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407803,"y":397304,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":361487,"y":586748,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691082,"y":1075929,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":382750,"y":387113,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":226615,"y":268279,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":128438,"y":107385,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":103549,"y":196709,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402716,"y":420294,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408934,"y":395193,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404492,"y":396257,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408056,"y":395877,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404533,"y":396810,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405833,"y":396235,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403435,"y":392960,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408303,"y":394329,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413694,"y":398596,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693782,"y":1080459,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534549,"y":1299763,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672990,"y":727793,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413110,"y":398354,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413737,"y":401064,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598310,"y":1130858,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411949,"y":393595,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400089,"y":393965,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412942,"y":402156,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241724,"y":134477,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":121546,"y":238336,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":141621,"y":217420,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661145,"y":744554,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404647,"y":418977,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":287130,"y":257437,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297311,"y":300501,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":146539,"y":102931,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":53379,"y":70067,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":123736,"y":102756,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153590,"y":198607,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":70811,"y":63224,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":77680,"y":77737,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704735,"y":925919,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404915,"y":394033,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410704,"y":398406,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409104,"y":396863,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403221,"y":396115,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":377373,"y":364984,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405536,"y":400220,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404720,"y":400444,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407552,"y":396781,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690213,"y":1096845,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243525,"y":133214,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":253014,"y":136353,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278453,"y":222256,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":278402,"y":222173,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":294666,"y":296495,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297214,"y":299564,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296978,"y":305965,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676723,"y":1072039,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":286478,"y":507290,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":303005,"y":512403,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":311605,"y":503376,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412886,"y":364647,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407588,"y":395951,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81029,"y":63775,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135231,"y":261552,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290964,"y":515401,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633884,"y":1033432,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402425,"y":389638,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698061,"y":1067530,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673881,"y":1075279,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630621,"y":987854,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581588,"y":1138575,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642982,"y":1002742,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625921,"y":1029697,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590686,"y":1130424,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399519,"y":397314,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590406,"y":1190354,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408538,"y":396425,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":77733,"y":153619,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":24024,"y":172390,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":50731,"y":242231,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":42947,"y":216206,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242597,"y":132405,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":125478,"y":105676,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101661,"y":220543,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":57811,"y":100741,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297203,"y":295271,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137815,"y":222164,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241930,"y":133843,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":329534,"y":348431,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":393378,"y":392845,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408077,"y":397293,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566617,"y":1214330,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400769,"y":400331,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243812,"y":133439,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587050,"y":640668,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603384,"y":1123472,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":307437,"y":568745,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407306,"y":391697,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609246,"y":1113112,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":141096,"y":48796,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100844,"y":222441,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101008,"y":222010,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95268,"y":220401,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":97377,"y":220782,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405731,"y":394700,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407768,"y":394769,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411634,"y":395973,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":412453,"y":398389,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414339,"y":388239,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":362397,"y":627090,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604053,"y":1116955,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597102,"y":1127785,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401293,"y":401958,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":252437,"y":139764,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81823,"y":62184,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415978,"y":444478,"year":"2001","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":380698,"y":370314,"year":"2001","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583877,"y":1134157,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589404,"y":1141263,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590475,"y":1100711,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":840037,"y":939603,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593005,"y":650738,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585662,"y":642762,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":281716,"y":261019,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706848,"y":937189,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541527,"y":1310753,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":541527,"y":1310753,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137809,"y":221995,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579353,"y":1216319,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594323,"y":1136297,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663075,"y":1102859,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622426,"y":1142721,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665806,"y":1096925,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589111,"y":1141859,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721424,"y":1041236,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587049,"y":1130653,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594756,"y":1134471,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615552,"y":1094120,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679330,"y":1071095,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594840,"y":1194817,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597631,"y":1124945,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678971,"y":1070948,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592397,"y":1145476,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604758,"y":1129526,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590268,"y":1150447,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598563,"y":1135520,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614093,"y":1126045,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602008,"y":1133550,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599637,"y":1131621,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583896,"y":1135942,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615949,"y":1093784,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595281,"y":1133861,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609888,"y":1112797,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607417,"y":1116668,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587191,"y":646710,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595106,"y":1136804,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687880,"y":1130829,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":436746,"y":663660,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602892,"y":1133605,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566384,"y":1277244,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577779,"y":1137154,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602498,"y":1120953,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605741,"y":1117037,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718416,"y":1044789,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589045,"y":1146892,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597219,"y":1131624,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593439,"y":1135233,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607743,"y":953625,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591436,"y":1134332,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596377,"y":1119450,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":512522,"y":1265891,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456984,"y":1325459,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598543,"y":1135435,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675485,"y":1129993,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536398,"y":1311150,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694635,"y":1020186,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663689,"y":1096177,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583392,"y":1127055,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611558,"y":1104630,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595155,"y":1095283,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721501,"y":1040398,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773308,"y":837159,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685678,"y":1126288,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685678,"y":1126288,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602834,"y":1122856,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":748136,"y":999668,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592344,"y":1130311,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594716,"y":1129068,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601346,"y":1126151,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592855,"y":1137234,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584438,"y":1129793,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582588,"y":1136456,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597673,"y":1027891,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672063,"y":1066005,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594290,"y":1135715,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594386,"y":1135402,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570191,"y":1230890,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290228,"y":514961,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589573,"y":1132072,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716639,"y":1036091,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769105,"y":833856,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":398009,"y":394998,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708724,"y":1038946,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714308,"y":1029576,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662808,"y":1015345,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577819,"y":1200099,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637761,"y":1031994,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637908,"y":1029043,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767265,"y":822773,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640174,"y":1030987,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639102,"y":1030647,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679711,"y":1071040,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643381,"y":1030942,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612404,"y":796111,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653774,"y":1042741,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638063,"y":1031561,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637890,"y":1031810,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639108,"y":1029202,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621727,"y":704129,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638280,"y":1033006,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":561135,"y":819831,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633687,"y":1034886,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556187,"y":1261432,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557087,"y":1263082,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766997,"y":817753,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708309,"y":937360,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":465092,"y":1339283,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638097,"y":1035328,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668091,"y":927119,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874568,"y":923940,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556461,"y":1266832,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554080,"y":1273121,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580004,"y":1135627,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591386,"y":1130205,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581980,"y":1137923,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585249,"y":1128070,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603139,"y":1119298,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587524,"y":1131341,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585445,"y":1125498,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592808,"y":1135892,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588338,"y":1131502,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598201,"y":1128415,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581091,"y":1135080,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582548,"y":1132606,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584350,"y":1135735,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583691,"y":1132516,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583831,"y":1128776,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584652,"y":1130735,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592671,"y":1128474,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582832,"y":1131575,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589038,"y":1133561,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594273,"y":1129745,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594490,"y":1136234,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603433,"y":1136505,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595587,"y":1134034,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554452,"y":1270062,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":466792,"y":1329760,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":482769,"y":1320662,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677928,"y":1138560,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726762,"y":1038731,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600424,"y":1124273,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566563,"y":1214863,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596454,"y":1124298,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598239,"y":1125277,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606093,"y":1120249,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604006,"y":1117902,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604061,"y":1118801,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590954,"y":1146527,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592835,"y":1151163,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607507,"y":1127326,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600159,"y":1084142,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1120303,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592546,"y":1145407,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602938,"y":1124183,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591033,"y":1141775,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570738,"y":1148741,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572942,"y":1136885,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593063,"y":1145513,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571231,"y":1136830,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565494,"y":1140281,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573322,"y":1200126,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605576,"y":1119447,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554456,"y":1270181,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593597,"y":1143168,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589843,"y":1147012,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593420,"y":1135273,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603058,"y":1123915,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591381,"y":1149149,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587004,"y":1131609,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650324,"y":1021331,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646174,"y":1088918,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643851,"y":1004821,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690301,"y":1072066,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684429,"y":983194,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689036,"y":905197,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708776,"y":937700,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728670,"y":1000102,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639224,"y":1030180,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639895,"y":1033685,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635560,"y":1031916,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635580,"y":1032529,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689073,"y":1074017,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681151,"y":1001142,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715689,"y":1038502,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694240,"y":1054082,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694785,"y":1055249,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715658,"y":1038027,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664513,"y":1144999,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682796,"y":1105459,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721934,"y":989422,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627797,"y":1043667,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619829,"y":1027359,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619829,"y":1027359,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715712,"y":1038973,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730074,"y":1037049,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703877,"y":1027001,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":702428,"y":1026105,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716620,"y":1040604,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592577,"y":1138010,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574115,"y":1197452,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573572,"y":1199814,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556239,"y":1261499,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554078,"y":1260043,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554953,"y":1266269,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604779,"y":1118215,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604284,"y":1120775,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555708,"y":1266992,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589505,"y":1163010,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703382,"y":951486,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713917,"y":1041727,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":737248,"y":1026378,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693828,"y":1019540,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716461,"y":1035763,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704449,"y":924875,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592351,"y":1130304,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596223,"y":1135367,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629600,"y":991093,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638028,"y":1031610,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726394,"y":1036877,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":727162,"y":1038357,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600333,"y":1136347,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525451,"y":1319904,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609787,"y":1112547,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586998,"y":1195772,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642492,"y":1030174,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598684,"y":1130207,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617258,"y":1085979,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595070,"y":1132815,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603440,"y":1133943,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600752,"y":1129139,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679636,"y":1033335,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719989,"y":992533,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722333,"y":989793,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681030,"y":888583,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630930,"y":1020057,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635950,"y":1036429,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637470,"y":1032450,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637316,"y":1031432,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638390,"y":1032733,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633941,"y":1035303,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":663654,"y":1096129,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626303,"y":1038617,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601895,"y":1030942,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658673,"y":1122636,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649085,"y":1021407,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680419,"y":1030466,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674538,"y":1017714,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674570,"y":1062042,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673470,"y":1075826,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638462,"y":1031694,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633941,"y":1035303,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626668,"y":1044991,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":848315,"y":1022153,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725305,"y":989505,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":720801,"y":989693,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699422,"y":924285,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723345,"y":990739,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714808,"y":977927,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705636,"y":933383,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704812,"y":929235,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704209,"y":931049,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677502,"y":1008745,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699315,"y":964139,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":743463,"y":1031206,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718265,"y":1044932,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787995,"y":1007283,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786978,"y":1007332,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716422,"y":1035810,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716398,"y":1035814,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592595,"y":1136679,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594236,"y":1136562,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595973,"y":1128436,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591672,"y":1132590,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596291,"y":1122859,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601661,"y":1134169,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":570338,"y":1145710,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595439,"y":1129332,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586024,"y":1152117,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574115,"y":1197453,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603137,"y":1116685,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602667,"y":1124857,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604660,"y":1121720,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591293,"y":1134461,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598591,"y":1130348,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597301,"y":1131932,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589693,"y":1131119,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592870,"y":1132190,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594423,"y":1136998,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607540,"y":1132798,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605097,"y":1115712,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598789,"y":1125287,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584061,"y":1129394,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583158,"y":1128589,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":578817,"y":1134592,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583443,"y":1132937,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580891,"y":1133810,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602683,"y":1124186,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604539,"y":1123360,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575642,"y":1118169,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606211,"y":1121214,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587906,"y":1128052,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601864,"y":1122490,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585696,"y":1185724,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606130,"y":1121827,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718251,"y":1045031,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591509,"y":1152015,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713262,"y":1038896,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716626,"y":1040157,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711099,"y":1039417,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714080,"y":1042398,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744872,"y":1024346,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":710173,"y":1039209,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665806,"y":1096925,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660549,"y":1117158,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664989,"y":1097012,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634755,"y":1030007,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586114,"y":1127987,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587237,"y":1130461,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":510313,"y":1306664,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566606,"y":1243042,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":508339,"y":1331558,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517600,"y":1326291,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554494,"y":1266365,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":467221,"y":1340089,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568093,"y":1236057,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554336,"y":1272803,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619327,"y":1117535,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":566596,"y":1233573,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604868,"y":1110786,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602706,"y":1108350,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601056,"y":1128657,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592239,"y":1135687,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597200,"y":1134204,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612246,"y":1112623,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603433,"y":1121395,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589150,"y":1133926,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573669,"y":1197852,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587649,"y":1165455,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714397,"y":1037557,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729606,"y":1037350,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713712,"y":1040367,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718051,"y":1042552,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717809,"y":1042530,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741295,"y":1031135,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589150,"y":1133926,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593447,"y":1140371,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607061,"y":1115317,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607061,"y":1115317,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591084,"y":1147658,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594113,"y":1135190,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131980,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706785,"y":929218,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":676434,"y":877987,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623234,"y":1108243,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582479,"y":1136888,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596335,"y":1132833,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602978,"y":1124122,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597782,"y":1131559,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591293,"y":1134461,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602801,"y":1127548,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602583,"y":1123120,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":574919,"y":1131660,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679938,"y":896102,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719346,"y":994780,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594652,"y":1142228,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729123,"y":1029332,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607499,"y":1114959,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607081,"y":1115386,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604183,"y":1117974,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605513,"y":1115649,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603895,"y":1120467,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599717,"y":1123345,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605250,"y":1120391,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607634,"y":1120589,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605482,"y":1129888,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605980,"y":1129805,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642874,"y":995091,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588307,"y":1145274,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591577,"y":1148254,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593002,"y":1151615,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594479,"y":1142863,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593162,"y":1140547,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590849,"y":1147282,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598168,"y":1123359,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605597,"y":1116659,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557086,"y":1262014,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621123,"y":1110541,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613293,"y":1084895,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604399,"y":1104109,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601097,"y":1128604,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602294,"y":1126298,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610885,"y":1112890,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594234,"y":1136916,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762593,"y":1018325,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692221,"y":1094664,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":532470,"y":1312996,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586079,"y":1169719,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608778,"y":1111249,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605241,"y":1121213,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604690,"y":1128059,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592361,"y":1093106,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630128,"y":941132,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":652773,"y":1018276,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638027,"y":1037614,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639600,"y":1032554,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716639,"y":1036091,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708252,"y":1039527,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":787936,"y":996711,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594058,"y":1142370,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600854,"y":1130396,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601795,"y":1127814,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588928,"y":1128643,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585715,"y":1134159,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660314,"y":1118092,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560762,"y":1257331,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603327,"y":1116880,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705054,"y":925838,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":793496,"y":988147,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":528907,"y":1299561,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553107,"y":1222386,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535843,"y":1311581,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695656,"y":1020678,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639055,"y":1030825,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594736,"y":1135801,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658354,"y":992453,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606988,"y":1115478,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586091,"y":1186758,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596491,"y":1134703,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601599,"y":1130918,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594066,"y":1136150,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619258,"y":1095074,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601150,"y":1129645,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581507,"y":1131726,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718279,"y":1044820,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603658,"y":1132241,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592513,"y":1137934,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602571,"y":1122762,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608124,"y":1117707,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594489,"y":1136245,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707910,"y":1032383,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594290,"y":1137065,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":508156,"y":1291767,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595717,"y":1129041,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":628692,"y":1137992,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596606,"y":1136541,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717985,"y":1035726,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":473453,"y":1344736,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600867,"y":644865,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":423210,"y":673279,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654716,"y":761920,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598247,"y":673642,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613651,"y":693773,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546106,"y":867300,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529323,"y":892301,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584326,"y":880843,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":784020,"y":880889,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":746505,"y":793473,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":546091,"y":866995,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531551,"y":594270,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608798,"y":689431,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594812,"y":640987,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605927,"y":658205,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":543224,"y":898537,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624181,"y":706149,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":866380,"y":934692,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433191,"y":672384,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767881,"y":820944,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875219,"y":924046,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662981,"y":891152,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659368,"y":740184,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602609,"y":657693,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773320,"y":815506,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609844,"y":793871,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611345,"y":795300,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600602,"y":647077,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586382,"y":640864,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598237,"y":663275,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":527772,"y":892133,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":382449,"y":588709,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616611,"y":640403,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":898120,"y":961089,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773865,"y":832332,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670935,"y":801234,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598247,"y":673642,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584830,"y":640099,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588847,"y":648875,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598247,"y":673642,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517362,"y":619772,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":458033,"y":645921,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460701,"y":647051,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630582,"y":716728,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":830539,"y":960441,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586094,"y":644542,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769439,"y":832183,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641089,"y":663473,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770543,"y":835688,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767959,"y":834535,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772756,"y":836457,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":615634,"y":676360,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":658039,"y":762026,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585952,"y":644035,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":527257,"y":637343,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":835236,"y":972557,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":509611,"y":619917,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587471,"y":641020,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766720,"y":820692,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":777366,"y":810297,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766407,"y":821908,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679886,"y":747208,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871577,"y":924865,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873814,"y":926474,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":775196,"y":823769,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583226,"y":639799,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586342,"y":643231,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":448980,"y":642532,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459575,"y":647365,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":622849,"y":662934,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":834392,"y":884488,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630509,"y":714320,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874294,"y":925654,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607990,"y":662016,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611831,"y":689832,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":632829,"y":661512,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590944,"y":663412,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641555,"y":654537,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586150,"y":640903,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586144,"y":643324,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586176,"y":642304,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606868,"y":659521,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608330,"y":661629,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610290,"y":661706,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":434924,"y":667264,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871729,"y":926168,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872756,"y":924452,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873229,"y":929626,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874107,"y":924201,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596856,"y":663758,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657664,"y":746353,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644016,"y":665606,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":830142,"y":960391,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634976,"y":665398,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605245,"y":687425,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596171,"y":651895,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594056,"y":663844,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872850,"y":924140,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873368,"y":924922,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874065,"y":923657,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":376233,"y":590191,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454723,"y":639439,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611912,"y":662381,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596940,"y":652112,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594827,"y":650460,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602609,"y":657693,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599654,"y":653535,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598963,"y":651801,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874571,"y":924223,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643609,"y":870362,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624285,"y":724514,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633433,"y":909787,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598239,"y":664175,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":429783,"y":623957,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596426,"y":651924,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616346,"y":664917,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612641,"y":794251,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611416,"y":795056,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636972,"y":855879,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":519619,"y":886081,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656024,"y":745744,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":564656,"y":902843,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532709,"y":888401,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530600,"y":892251,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662458,"y":781842,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653099,"y":758099,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":655914,"y":760683,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629770,"y":713149,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643354,"y":892832,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674590,"y":829434,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684799,"y":741541,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635103,"y":838284,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630737,"y":732746,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":450589,"y":642037,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413929,"y":607412,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":447197,"y":643395,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":461101,"y":646556,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634512,"y":909827,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":777255,"y":810670,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":759667,"y":820334,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":740838,"y":782727,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770244,"y":817671,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662403,"y":680086,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":603832,"y":684394,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607537,"y":688786,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":865950,"y":937644,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611260,"y":688944,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610531,"y":662315,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":783514,"y":880076,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603128,"y":658269,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612513,"y":690917,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452246,"y":639765,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":762016,"y":823003,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765464,"y":822652,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625046,"y":735239,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585509,"y":642882,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585723,"y":642850,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613374,"y":663507,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587316,"y":640202,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588796,"y":647903,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592287,"y":663802,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767397,"y":820387,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588467,"y":649352,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598250,"y":653047,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589505,"y":640233,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516680,"y":633038,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661008,"y":677826,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587304,"y":641992,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589992,"y":643847,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772560,"y":836314,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768125,"y":835339,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":772813,"y":834686,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771768,"y":838080,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766735,"y":848996,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774081,"y":836644,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771564,"y":835512,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767289,"y":820194,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516596,"y":617543,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659103,"y":745074,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606762,"y":688746,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459442,"y":646245,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640429,"y":764294,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599366,"y":651734,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650874,"y":672740,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603933,"y":687200,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648736,"y":670246,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":438199,"y":673800,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":540847,"y":885589,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656151,"y":677377,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":701243,"y":759952,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":796619,"y":881598,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590771,"y":655037,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599710,"y":653349,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653802,"y":744536,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765726,"y":822517,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":444582,"y":637231,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819691,"y":886275,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460945,"y":646743,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596709,"y":665401,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459967,"y":645158,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147698,"y":169578,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296891,"y":334092,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406545,"y":398343,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411694,"y":397535,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408542,"y":395818,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401567,"y":396772,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403333,"y":392732,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":417518,"y":391047,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":129822,"y":114826,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":253756,"y":133106,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241095,"y":130089,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":114292,"y":223783,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242169,"y":132011,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":422460,"y":508670,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298216,"y":337577,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":283143,"y":260399,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79361,"y":69756,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":75688,"y":66202,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":401660,"y":388443,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":276741,"y":221584,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242938,"y":133272,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242948,"y":130062,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":187830,"y":93982,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":263061,"y":178037,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277145,"y":220034,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135246,"y":261349,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411077,"y":397182,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":130361,"y":259221,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":221417,"y":127360,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":290057,"y":514875,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399338,"y":396239,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411295,"y":396505,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409760,"y":400768,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277556,"y":220327,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83368,"y":66692,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239973,"y":133305,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":66285,"y":101445,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":292780,"y":287669,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":390717,"y":375997,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":53379,"y":70067,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":70656,"y":75975,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":173351,"y":58855,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":154081,"y":198394,"year":"2009","vehicles":"Vehicle(s)+multiple other types","severity":"Non-injury","color":"lightgrey"},{"x":152792,"y":199856,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":81967,"y":63544,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":88473,"y":224061,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485897,"y":518540,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":400569,"y":396882,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95446,"y":220521,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243168,"y":130839,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407328,"y":395182,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":390860,"y":420877,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409456,"y":412697,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409972,"y":415473,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407324,"y":398658,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277470,"y":219700,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":378161,"y":396049,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":187319,"y":401111,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":421279,"y":488562,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":424675,"y":480167,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":121013,"y":76729,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80715,"y":65081,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79872,"y":67762,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":74016,"y":50844,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202054,"y":103797,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138768,"y":283563,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":113800,"y":227189,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242938,"y":133272,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244368,"y":134982,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":118018,"y":77598,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":231422,"y":131599,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":138521,"y":220682,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":96111,"y":220139,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406622,"y":394336,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407333,"y":394344,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409833,"y":399850,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402670,"y":396974,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":239322,"y":137047,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374696,"y":382881,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":298295,"y":311618,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":195210,"y":285288,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":241239,"y":133474,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":253672,"y":162498,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":109885,"y":227176,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95171,"y":220316,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":211335,"y":415880,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297683,"y":297740,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":295596,"y":290807,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411379,"y":395341,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":221098,"y":319534,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411362,"y":421440,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297079,"y":299704,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297533,"y":296437,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297458,"y":299249,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":310784,"y":521042,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":247669,"y":452643,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":421851,"y":381318,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149701,"y":170929,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":64572,"y":148698,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":160933,"y":249590,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":500608,"y":534991,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407338,"y":393832,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407286,"y":395568,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387709,"y":521547,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282529,"y":260805,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":58791,"y":76765,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242994,"y":134652,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":157385,"y":152934,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":336318,"y":353804,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404591,"y":404290,"year":"2009","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":238503,"y":135292,"year":"2009","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80861,"y":63475,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719935,"y":1039197,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675795,"y":1128861,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639138,"y":1029208,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594183,"y":1141901,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601450,"y":1124999,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581743,"y":1136894,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715780,"y":1038175,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589090,"y":1148412,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706941,"y":930767,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678130,"y":1009487,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":698654,"y":1045935,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556743,"y":1261593,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556976,"y":1261836,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403168,"y":399900,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605345,"y":1117301,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593514,"y":1135089,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722423,"y":1039976,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713867,"y":1039430,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716418,"y":1041068,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721810,"y":1042088,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715821,"y":1009293,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717626,"y":990628,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532823,"y":892983,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601450,"y":1124999,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719354,"y":1044585,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718056,"y":1045628,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654032,"y":1019622,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599500,"y":1129410,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586726,"y":1129379,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607656,"y":1120623,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604836,"y":1120336,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605004,"y":1116967,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592562,"y":1136539,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605253,"y":1116513,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605005,"y":1115629,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606828,"y":1117859,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":563206,"y":1269560,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555710,"y":1260647,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":616716,"y":884863,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591820,"y":1146357,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595111,"y":1125682,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609679,"y":1027463,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407805,"y":396854,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598452,"y":1124122,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601775,"y":1129361,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598436,"y":1122307,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607560,"y":1127623,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638493,"y":1030155,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638252,"y":1029121,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634827,"y":1032247,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729185,"y":997607,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":403398,"y":399157,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82517,"y":66164,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":729089,"y":962091,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722161,"y":990243,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720913,"y":989208,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592617,"y":1143899,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":535722,"y":857045,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593257,"y":1139310,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594206,"y":1141912,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606828,"y":1117859,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651342,"y":1016131,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":651377,"y":1016192,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640189,"y":1007042,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581584,"y":1160621,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638877,"y":1009319,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548735,"y":1259961,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720215,"y":1043632,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716261,"y":1041270,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95482,"y":220341,"year":"2017","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":774230,"y":837281,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654418,"y":1093558,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640320,"y":1041345,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636122,"y":1032546,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638726,"y":1034135,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":418047,"y":470031,"year":"2017","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593318,"y":1139964,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":748788,"y":791794,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593138,"y":1137130,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565476,"y":1222520,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588806,"y":1134073,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684894,"y":989427,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724896,"y":713366,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516271,"y":881433,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556901,"y":1263579,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593480,"y":1136570,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":525401,"y":889115,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597363,"y":1131973,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597550,"y":1131749,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602244,"y":1126204,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657477,"y":744662,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599411,"y":1129602,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605280,"y":682910,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599308,"y":1129773,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590997,"y":1134268,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596428,"y":1121246,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589182,"y":1134080,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596062,"y":1133165,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593466,"y":1136566,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592334,"y":1146458,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596062,"y":1133165,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399122,"y":392719,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581821,"y":1132262,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":567124,"y":1141517,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584667,"y":1135563,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608372,"y":1112169,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682119,"y":999638,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608219,"y":1112687,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607050,"y":1115466,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721760,"y":989926,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598580,"y":1122288,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722331,"y":989366,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":445969,"y":635944,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711585,"y":1031376,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":892904,"y":937222,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":404682,"y":402053,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682119,"y":999638,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722326,"y":989211,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598130,"y":1122557,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":115061,"y":86749,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597631,"y":1124945,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593632,"y":1140429,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721075,"y":1042795,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604758,"y":1120652,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601954,"y":1119725,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":287901,"y":264032,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":572928,"y":1133936,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555654,"y":1266879,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582462,"y":644311,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580724,"y":1139829,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590481,"y":1149266,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":561745,"y":900209,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580724,"y":1139829,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580552,"y":1138095,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582286,"y":1138478,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547147,"y":861164,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581964,"y":1133948,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584002,"y":1134862,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571377,"y":1205570,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600751,"y":1131596,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583861,"y":1134111,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582513,"y":1133415,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582412,"y":1135208,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135072,"y":287709,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582598,"y":1133257,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768209,"y":821584,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604093,"y":1117547,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592344,"y":1130311,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583890,"y":1131677,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":136801,"y":221477,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":76036,"y":106555,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588723,"y":1128373,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636992,"y":909905,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454904,"y":1343328,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582845,"y":1129950,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":505257,"y":1329160,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598256,"y":1127884,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":819529,"y":888329,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583637,"y":1126836,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587680,"y":1129754,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587830,"y":1128848,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713819,"y":1035377,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586391,"y":642743,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715615,"y":1039031,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715615,"y":1039031,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717858,"y":1045543,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713460,"y":1039260,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597078,"y":1127792,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713698,"y":1040700,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711505,"y":1039434,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714588,"y":1036682,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718297,"y":1042689,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568614,"y":1142338,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":786708,"y":1007345,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243945,"y":134001,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607152,"y":1116688,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593044,"y":1132809,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":852122,"y":892310,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726726,"y":1035790,"year":"2000","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692202,"y":1053082,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705172,"y":1028291,"year":"2000","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770649,"y":1007980,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640485,"y":1014049,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454540,"y":1351156,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584465,"y":1126704,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587743,"y":1142860,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634926,"y":1032749,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603668,"y":1124150,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600987,"y":1123522,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589576,"y":1134026,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606065,"y":1116879,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596710,"y":1126274,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":453953,"y":1323805,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589969,"y":1132839,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573059,"y":1126086,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586601,"y":1129936,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590852,"y":1130572,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592294,"y":1147956,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611360,"y":1113271,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":648819,"y":1091997,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638120,"y":1033392,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602233,"y":1121813,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594564,"y":1136944,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592388,"y":1130464,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590051,"y":1132632,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593539,"y":1128432,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593602,"y":1135498,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606609,"y":1117910,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600634,"y":1128765,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634112,"y":1043153,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517268,"y":619794,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589965,"y":1131573,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602527,"y":1132754,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583979,"y":1134847,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585671,"y":1177391,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598184,"y":1131179,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532863,"y":892982,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665232,"y":987544,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692006,"y":1094136,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654050,"y":1128871,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713298,"y":1035946,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704812,"y":929235,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715771,"y":1009848,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":42806,"y":212903,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694823,"y":1058746,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716626,"y":1040157,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600089,"y":1121802,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717300,"y":1036677,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594211,"y":1141846,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":733236,"y":1027799,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":818535,"y":991947,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596739,"y":663780,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595937,"y":1134879,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598136,"y":1135977,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560692,"y":1258664,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650774,"y":766826,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590654,"y":1148866,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697706,"y":1022737,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595901,"y":1129259,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":624431,"y":706783,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583844,"y":1132938,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660216,"y":1144657,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606906,"y":1117253,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244994,"y":130179,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593687,"y":1142300,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1119784,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587955,"y":1143023,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585955,"y":1186250,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597888,"y":1099920,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595327,"y":1135308,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591127,"y":1134238,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588698,"y":1132425,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554669,"y":1307662,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95373,"y":220515,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723244,"y":1040888,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595466,"y":1132968,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602003,"y":1127150,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585563,"y":1143350,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602237,"y":1118882,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718509,"y":1042509,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588156,"y":1130838,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605126,"y":1120455,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591087,"y":1133328,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605104,"y":1120511,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603800,"y":1120411,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601359,"y":1122516,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598914,"y":1122326,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607804,"y":1125763,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607177,"y":1134563,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608249,"y":1121988,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603240,"y":1123315,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602653,"y":1115375,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606649,"y":1117785,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581326,"y":1139588,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587393,"y":1129825,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585406,"y":1130036,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582410,"y":1135193,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582402,"y":1135209,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583140,"y":1129998,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580542,"y":1139435,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598786,"y":1122454,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602318,"y":1123628,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602517,"y":1121847,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599058,"y":1122698,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604710,"y":1117112,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592542,"y":1127489,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596824,"y":1123951,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591399,"y":1130778,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601555,"y":1128264,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593912,"y":1144862,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597073,"y":1132124,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637669,"y":1034919,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583859,"y":1133816,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":559139,"y":1267144,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557239,"y":1249127,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678485,"y":1136511,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693373,"y":1070859,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675225,"y":1074351,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693782,"y":1019501,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670495,"y":1051994,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680229,"y":1008256,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688442,"y":983522,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684868,"y":1006432,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724340,"y":988721,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718129,"y":1045064,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719835,"y":1042852,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717860,"y":1042536,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694853,"y":1056039,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722183,"y":1040077,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712898,"y":1039869,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721897,"y":989694,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":697934,"y":1068130,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603691,"y":1093696,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":699913,"y":968397,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665317,"y":1097672,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":665722,"y":1096984,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690544,"y":1091282,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680229,"y":1008256,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681867,"y":1002399,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678002,"y":1000373,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704161,"y":930425,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713540,"y":1037152,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":737748,"y":1026358,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716403,"y":1036169,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708907,"y":938127,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681063,"y":888775,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714871,"y":977720,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703796,"y":930167,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590071,"y":1144220,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586496,"y":1186566,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554838,"y":1266538,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555968,"y":1267128,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536750,"y":1310917,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":454471,"y":1319746,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585213,"y":1187379,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592826,"y":1138497,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588767,"y":1130261,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594601,"y":1128448,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591500,"y":1132748,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":589700,"y":1134422,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600002,"y":1133036,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594007,"y":1133725,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601444,"y":1126172,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584999,"y":1132065,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579857,"y":1140300,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609116,"y":1131314,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607267,"y":1130695,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600727,"y":1122432,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607073,"y":1127259,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623462,"y":1107580,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609900,"y":1111419,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605703,"y":1117081,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603610,"y":1117417,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602511,"y":1117066,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606267,"y":1116635,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603862,"y":1121885,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598879,"y":1122548,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603533,"y":1115805,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600549,"y":1124460,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610984,"y":1114125,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594402,"y":1135031,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599067,"y":1122435,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595029,"y":1128134,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666678,"y":1063420,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675677,"y":1136298,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":636784,"y":1031691,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":642367,"y":1029133,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688584,"y":1120985,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620186,"y":1141869,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593528,"y":1143168,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604947,"y":1120303,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585194,"y":1179391,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611112,"y":1125479,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588742,"y":1163975,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554573,"y":1271472,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579986,"y":1134593,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580439,"y":1130165,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606497,"y":1097109,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603055,"y":1121045,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594180,"y":1136583,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591003,"y":1135059,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587375,"y":1172235,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":814040,"y":1000171,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":644893,"y":1087932,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533682,"y":1300764,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":559024,"y":1218982,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593439,"y":1091979,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":524659,"y":1308904,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600803,"y":1128718,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592448,"y":1148051,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590586,"y":1149264,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590433,"y":1149099,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721382,"y":1041251,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696034,"y":1066377,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603545,"y":1028142,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":789101,"y":1006826,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":795621,"y":1004823,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":790556,"y":994293,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":796742,"y":1000142,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":733910,"y":1027276,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":562286,"y":1246952,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":569526,"y":1231841,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603615,"y":1123640,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595336,"y":1133976,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597064,"y":1132129,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593066,"y":1151277,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581736,"y":1133821,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516510,"y":1238938,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719718,"y":1042469,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608116,"y":1027022,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627160,"y":1056366,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":741184,"y":969505,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693756,"y":1080627,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690694,"y":1094888,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592963,"y":1151616,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587545,"y":1156211,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581505,"y":1141158,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633812,"y":1033013,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634398,"y":1035713,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641280,"y":1029819,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639015,"y":1030979,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":635542,"y":1031900,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641541,"y":1042879,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631877,"y":1025011,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671755,"y":1013319,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":695888,"y":1057048,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":670412,"y":1134103,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691927,"y":1094207,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691861,"y":1092902,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":668240,"y":1083200,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":641146,"y":1087362,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":674335,"y":1132473,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673861,"y":1075256,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673861,"y":1075256,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":682827,"y":1134632,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643247,"y":995949,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630722,"y":986962,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692818,"y":1082485,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691396,"y":1068897,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689271,"y":1110976,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662604,"y":1103392,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660563,"y":1116922,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":681273,"y":1018932,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678162,"y":1036146,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708912,"y":938095,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":669638,"y":909002,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696326,"y":939856,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706946,"y":936780,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706698,"y":927526,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":650868,"y":1014072,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":654296,"y":1019364,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":647335,"y":1020403,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":649671,"y":999572,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722265,"y":987604,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":725594,"y":989118,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703488,"y":930249,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633703,"y":1035826,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":780930,"y":1010349,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721808,"y":1040438,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":844668,"y":1015062,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":820615,"y":968742,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705668,"y":927434,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":696774,"y":1064875,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679562,"y":988359,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":771269,"y":1007507,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687363,"y":979640,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":758019,"y":997834,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":646281,"y":1089035,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721736,"y":989430,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":703670,"y":933000,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630730,"y":963466,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713034,"y":992767,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722035,"y":990357,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711555,"y":1032103,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719173,"y":1043985,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724554,"y":1039023,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716043,"y":1040354,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714539,"y":1036825,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717657,"y":1035953,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721617,"y":1041315,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718295,"y":1042639,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721394,"y":1041232,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689853,"y":1114973,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":708170,"y":929981,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684553,"y":1107758,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715654,"y":1038030,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718476,"y":1035905,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":694848,"y":1055577,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716610,"y":1036095,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704172,"y":1027173,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":758397,"y":997586,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692426,"y":1114444,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638097,"y":1035327,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653896,"y":1093386,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":684924,"y":1040538,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":687202,"y":981671,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588081,"y":1142659,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605088,"y":1116328,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":514648,"y":1239186,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593508,"y":1149577,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588240,"y":1149329,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589150,"y":1133926,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592968,"y":1135452,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598185,"y":1132578,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591180,"y":1133231,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588569,"y":1130826,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588248,"y":1131764,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588800,"y":1129161,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602105,"y":1122189,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605224,"y":1126789,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603184,"y":1123896,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582380,"y":1133890,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581387,"y":1132946,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584005,"y":1134866,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581712,"y":1131905,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582739,"y":1131812,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553764,"y":1275302,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":489278,"y":1348051,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590189,"y":1151050,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589573,"y":1171120,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601196,"y":1121077,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597638,"y":1140474,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589627,"y":1149641,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581841,"y":1190415,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598709,"y":1128472,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600959,"y":1135090,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598596,"y":1134782,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595534,"y":1135588,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607068,"y":1115917,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592461,"y":1145753,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606092,"y":1097044,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608525,"y":1111218,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606491,"y":1123502,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602976,"y":1124091,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605921,"y":1097517,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592490,"y":1137889,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597686,"y":1131636,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592548,"y":1137565,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593433,"y":1143471,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606854,"y":1117600,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593256,"y":1139245,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602837,"y":1124433,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597084,"y":1095509,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612327,"y":1090095,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601138,"y":1129646,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594863,"y":1137031,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594280,"y":1136648,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603509,"y":1123590,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597621,"y":1124942,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605280,"y":1120395,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601807,"y":1121702,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591175,"y":1150975,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606786,"y":1124531,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598218,"y":1130954,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599813,"y":1129188,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589562,"y":1134160,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599157,"y":1125185,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605975,"y":1126559,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610475,"y":1114496,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603089,"y":1122499,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596830,"y":1124719,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604957,"y":1120274,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597062,"y":1124784,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596436,"y":1123578,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600622,"y":1123557,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610192,"y":1129483,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596593,"y":1125939,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604975,"y":1120317,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598418,"y":1125319,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600733,"y":1123813,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606235,"y":1127544,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613062,"y":1098258,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607099,"y":1124162,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555896,"y":1264088,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596106,"y":1129225,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594114,"y":1136238,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585324,"y":1130140,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580868,"y":1135374,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590586,"y":1149264,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601407,"y":1125528,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610406,"y":1115634,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600873,"y":1120623,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581677,"y":1124609,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":489070,"y":1263426,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597053,"y":1131783,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":557030,"y":1261327,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":516501,"y":1238934,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560851,"y":1258142,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536383,"y":1311131,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556379,"y":1258758,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":558142,"y":1261321,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555844,"y":1259126,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":523016,"y":1316642,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":667100,"y":1119275,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":579054,"y":1192123,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606008,"y":1126699,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623573,"y":1076002,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634253,"y":1042597,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":631269,"y":1042387,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":623457,"y":1076279,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618630,"y":1026775,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618888,"y":1026744,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627868,"y":1057661,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595291,"y":1131506,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592358,"y":1078393,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602413,"y":1095502,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600866,"y":1130418,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533881,"y":1300347,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606511,"y":1123579,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":620895,"y":1124775,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":724833,"y":988349,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590179,"y":1160340,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581540,"y":1212945,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":573965,"y":1198137,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589556,"y":1132047,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":553948,"y":1273562,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592742,"y":1142428,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584887,"y":1129433,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585164,"y":1131381,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584143,"y":1138433,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582903,"y":1133422,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721550,"y":986802,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718417,"y":1044970,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659367,"y":1061270,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":610753,"y":1106188,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601469,"y":1125621,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596218,"y":1128211,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595204,"y":1136413,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594398,"y":1136502,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591452,"y":1131286,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":595156,"y":1133186,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611010,"y":1097340,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603142,"y":1114517,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605176,"y":1123196,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590082,"y":1130142,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582437,"y":1135405,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581064,"y":1132923,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639999,"y":1030132,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":502710,"y":1310783,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":568913,"y":1256795,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634962,"y":1031834,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594551,"y":1136208,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720915,"y":989213,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598684,"y":1135869,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":618651,"y":1104052,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716051,"y":1040275,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723251,"y":1034979,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596259,"y":1122207,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595721,"y":1136398,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":485752,"y":1300872,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":522213,"y":1314770,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595016,"y":1134896,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":805883,"y":1002266,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":520634,"y":1319686,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459345,"y":1326647,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598974,"y":674494,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594803,"y":660545,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593766,"y":663645,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594198,"y":664501,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874517,"y":925552,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612349,"y":662470,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":598335,"y":647646,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595899,"y":649761,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661600,"y":679028,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767506,"y":820172,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770559,"y":820926,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873932,"y":924889,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":875457,"y":923496,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":888752,"y":933406,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597880,"y":650100,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":373001,"y":566145,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591898,"y":663958,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874511,"y":924060,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":744168,"y":788893,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":611013,"y":688684,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530121,"y":889548,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":795408,"y":913650,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":612650,"y":796486,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630701,"y":733786,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585527,"y":643620,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589410,"y":651699,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630577,"y":733116,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660758,"y":793296,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":664688,"y":748619,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609670,"y":791047,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549330,"y":853341,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547696,"y":833487,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764744,"y":823462,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":638649,"y":740451,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586184,"y":643411,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765589,"y":850111,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662789,"y":680141,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874536,"y":924259,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766913,"y":830639,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770635,"y":836975,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":773587,"y":837194,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630417,"y":729347,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":910029,"y":1022411,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":869343,"y":932847,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603304,"y":659992,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586558,"y":645234,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":433775,"y":671817,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586225,"y":643195,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":888889,"y":1044924,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621935,"y":667565,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532597,"y":589749,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613968,"y":694278,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":871666,"y":923913,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591438,"y":659143,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":765149,"y":822172,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":426111,"y":655472,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873649,"y":926303,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767710,"y":821277,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770511,"y":835342,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":755854,"y":809361,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":769746,"y":824522,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874294,"y":925654,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606208,"y":684703,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872688,"y":927233,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874294,"y":925654,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595188,"y":651545,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":452294,"y":639194,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872940,"y":925577,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":864565,"y":941380,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":872489,"y":923884,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":754943,"y":869984,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":766272,"y":821882,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591477,"y":663312,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586139,"y":644439,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588970,"y":651451,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586575,"y":640797,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585951,"y":639889,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":491932,"y":617741,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517254,"y":619810,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767423,"y":833977,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":768195,"y":833025,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":866419,"y":933610,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599990,"y":672223,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599990,"y":672223,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":464257,"y":652431,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459683,"y":644978,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":756420,"y":862645,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629970,"y":715931,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":677208,"y":820300,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586391,"y":642743,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640366,"y":765023,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":515689,"y":879848,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659654,"y":746790,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":657885,"y":744879,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626819,"y":723404,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680548,"y":746981,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678291,"y":734460,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":714925,"y":779068,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":552545,"y":861880,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":548637,"y":861401,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613305,"y":796193,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":680361,"y":745793,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606088,"y":684586,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":373644,"y":565364,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585855,"y":644305,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530530,"y":892441,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":530005,"y":892245,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":666817,"y":716836,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660369,"y":705532,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":529897,"y":890537,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659182,"y":745609,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532047,"y":892330,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":532139,"y":891872,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576222,"y":923193,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542566,"y":896802,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":625889,"y":781313,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":712969,"y":777187,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606070,"y":684594,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600925,"y":655157,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770875,"y":836968,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":767762,"y":832267,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":770463,"y":834115,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640003,"y":766022,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873967,"y":924853,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":613311,"y":663075,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656755,"y":744135,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605293,"y":684364,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456775,"y":642593,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":456758,"y":642605,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":876122,"y":923173,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587294,"y":641068,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":613374,"y":663507,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408300,"y":395696,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":87352,"y":73303,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":396534,"y":500331,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277145,"y":220034,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":88427,"y":221570,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":305236,"y":517812,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244358,"y":134797,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242471,"y":134143,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":71653,"y":96317,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":160638,"y":250215,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":131834,"y":260145,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":493066,"y":522234,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":338221,"y":353963,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Non-injury","color":"lightgrey"},{"x":394823,"y":389333,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":374813,"y":382881,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":279880,"y":328808,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":206843,"y":344890,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":331461,"y":341230,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":414232,"y":398388,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":409802,"y":400231,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406487,"y":393131,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408053,"y":396300,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408926,"y":396306,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95273,"y":220856,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407570,"y":395570,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405343,"y":400010,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":317555,"y":482191,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410484,"y":395382,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":246951,"y":135586,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408545,"y":395500,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":402242,"y":397702,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":273335,"y":221407,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":206481,"y":311698,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411929,"y":399603,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":139659,"y":221786,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":265818,"y":180541,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":147811,"y":171170,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243606,"y":132934,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":192739,"y":289749,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":78168,"y":82090,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435130,"y":376021,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":388016,"y":514718,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415695,"y":436447,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":153933,"y":198580,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":406945,"y":397289,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243433,"y":131007,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244256,"y":135874,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":89444,"y":219230,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":208390,"y":149498,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243158,"y":132563,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149263,"y":125990,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":242217,"y":129755,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":100985,"y":222067,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":101682,"y":227237,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":97915,"y":221133,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":276962,"y":219593,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277513,"y":219790,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":64662,"y":104361,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80031,"y":68095,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":210762,"y":98319,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":80360,"y":63246,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":79267,"y":45155,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":277818,"y":221127,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":371747,"y":399674,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411509,"y":421814,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413042,"y":400368,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407822,"y":394335,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":405217,"y":395037,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":408047,"y":397293,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407306,"y":392147,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":415855,"y":443742,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":135094,"y":255265,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":202685,"y":104479,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":387709,"y":521547,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":407325,"y":395733,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":399519,"y":397314,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":397417,"y":394495,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":83750,"y":95146,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":245242,"y":134833,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":282427,"y":228069,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":292005,"y":280779,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":293788,"y":299533,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":297016,"y":299714,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":296160,"y":299257,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":229368,"y":136723,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244491,"y":129798,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":267869,"y":334875,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":152109,"y":201982,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":266664,"y":191703,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":244793,"y":446922,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":228953,"y":426487,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":275375,"y":478617,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":311563,"y":503366,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":316831,"y":529945,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":315179,"y":482572,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":301311,"y":516280,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":213703,"y":423249,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":288844,"y":513285,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":95402,"y":220415,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":329824,"y":539041,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":158866,"y":261699,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243758,"y":133834,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":410088,"y":394913,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411295,"y":396505,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":413282,"y":391143,"year":"2010","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":222889,"y":199335,"year":"2010","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536037,"y":1304135,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592846,"y":1144413,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608892,"y":1115067,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595201,"y":1135901,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":873368,"y":924922,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604007,"y":678542,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679104,"y":1009311,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595046,"y":1134150,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593254,"y":1137037,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594159,"y":1136119,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595311,"y":1136873,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601314,"y":1125945,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517385,"y":619819,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591059,"y":1146677,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595309,"y":1143095,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583313,"y":1134330,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874157,"y":924421,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":874930,"y":924550,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584135,"y":1129727,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592279,"y":1130370,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588710,"y":1132068,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592906,"y":1132246,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603171,"y":1133345,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595539,"y":1129514,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594739,"y":1136695,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593763,"y":1135453,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585500,"y":1130000,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722280,"y":987981,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":633570,"y":1036343,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637010,"y":1031878,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":634427,"y":1033275,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580226,"y":1107679,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":719551,"y":1043516,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":619470,"y":1100596,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":639536,"y":1030980,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597152,"y":1105612,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627276,"y":1029186,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588839,"y":1143209,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":621518,"y":1122003,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589204,"y":1143018,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590558,"y":1145814,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591201,"y":1147378,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594662,"y":1143003,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659347,"y":745536,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591499,"y":1147482,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587354,"y":1130150,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":617310,"y":1143051,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595106,"y":1136804,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594390,"y":1135399,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594099,"y":1136606,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":591909,"y":1131829,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704170,"y":930305,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":577975,"y":1144207,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556802,"y":1261538,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590665,"y":1091520,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555570,"y":1260098,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":459408,"y":1326928,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":554593,"y":1229155,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411490,"y":1401564,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":411490,"y":1401564,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556070,"y":1262090,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556496,"y":1261711,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":556662,"y":1261847,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":549147,"y":1268170,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720879,"y":992497,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720386,"y":991436,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555945,"y":1264700,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":486666,"y":1316405,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534739,"y":1300616,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":534604,"y":1299330,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":595039,"y":1132685,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":542779,"y":1287148,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704561,"y":928898,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721190,"y":987870,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":707370,"y":999980,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":608334,"y":1114881,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599263,"y":1122915,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":243660,"y":132847,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603615,"y":1123640,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605751,"y":1119150,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603525,"y":1115758,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590880,"y":1144036,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605913,"y":1097436,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605320,"y":1096966,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":614694,"y":1095151,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592495,"y":1137898,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609512,"y":1113079,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":603602,"y":1121267,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601215,"y":1120298,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605225,"y":1123394,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587199,"y":647116,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588287,"y":1129948,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":764438,"y":1000731,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":576414,"y":1193788,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596364,"y":1132767,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":555208,"y":1250829,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640575,"y":1014884,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588555,"y":1166569,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585416,"y":1184536,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586074,"y":1186783,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585085,"y":1181472,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":583015,"y":1189879,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":571429,"y":1161536,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587900,"y":1146654,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":581233,"y":1190884,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565739,"y":1140177,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":722157,"y":990133,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":723859,"y":988532,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728910,"y":996172,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716463,"y":1040394,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604759,"y":1124155,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659456,"y":744457,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588338,"y":1131502,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606576,"y":1132373,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673501,"y":997924,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653776,"y":736012,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":672956,"y":866286,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679345,"y":1003900,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596291,"y":1136442,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":640755,"y":992943,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692697,"y":1077981,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690528,"y":1118457,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":660380,"y":1144553,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602138,"y":1130780,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601021,"y":1122582,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589653,"y":1132881,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587111,"y":639079,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593669,"y":1140822,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":460560,"y":1337867,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":711893,"y":932532,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":511934,"y":1327394,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":471824,"y":1283238,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":547908,"y":1309371,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536396,"y":1311122,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":706953,"y":930815,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592974,"y":1138727,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592052,"y":1132342,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605912,"y":1116103,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593037,"y":1129999,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601008,"y":1125443,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705835,"y":929437,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585511,"y":642188,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":580093,"y":1135451,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588333,"y":1142874,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":653284,"y":950725,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585971,"y":643591,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":575127,"y":1196008,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":626666,"y":1032623,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":585024,"y":1130415,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":704361,"y":929823,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531640,"y":585532,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600416,"y":1124242,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":601954,"y":1119725,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":846162,"y":946930,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594905,"y":660602,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673686,"y":1075538,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":748233,"y":879837,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":627837,"y":1064650,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604282,"y":1121544,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":673848,"y":1075513,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":592887,"y":1132247,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":693982,"y":1084656,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692193,"y":1095031,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692234,"y":1093546,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":662717,"y":1102865,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690301,"y":1072066,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":685791,"y":1041632,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":675479,"y":1041302,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":656468,"y":1020091,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":606133,"y":1116879,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":671920,"y":995518,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":721670,"y":1040496,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":140048,"y":223231,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589180,"y":1164796,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716310,"y":1036182,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":690675,"y":1117219,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":688155,"y":1122370,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691921,"y":1092811,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":537485,"y":1306213,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":678448,"y":1136648,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":589368,"y":1149734,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720138,"y":1043734,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716168,"y":1039728,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718260,"y":997755,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":643537,"y":1005533,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":679939,"y":897030,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594543,"y":1131768,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594924,"y":1142330,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":731145,"y":967038,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":728473,"y":985511,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":730176,"y":1029001,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":705865,"y":1029996,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":637890,"y":1028519,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":800876,"y":996535,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":691595,"y":1056989,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517222,"y":620421,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":713322,"y":1036494,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718071,"y":1045584,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":107831,"y":230543,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720230,"y":1043618,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":104310,"y":230318,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717582,"y":1046319,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":716787,"y":1041618,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590233,"y":1132808,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":629101,"y":1093254,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":715311,"y":1039156,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587980,"y":1131599,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587970,"y":1129742,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":600242,"y":1136505,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596325,"y":1128713,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":149258,"y":239851,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":604758,"y":1120652,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":659874,"y":1119309,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":533217,"y":1311338,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":599164,"y":1123795,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":596171,"y":1127383,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597499,"y":1138522,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":594634,"y":1136731,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602744,"y":1132221,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":582417,"y":1135773,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":517513,"y":624132,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":560017,"y":1293795,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":726587,"y":990653,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":472454,"y":651927,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720222,"y":989784,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":435611,"y":593007,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":593194,"y":1139664,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":536753,"y":1290029,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":137462,"y":220681,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":565445,"y":1244170,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":587142,"y":1131099,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":720023,"y":990236,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":531703,"y":1311278,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":501130,"y":1344267,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":590927,"y":1152848,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":689812,"y":1006147,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":584438,"y":1129793,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":609965,"y":1112279,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607044,"y":1130791,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607510,"y":1127337,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":588007,"y":1142263,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602404,"y":1120784,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":82322,"y":66873,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":139153,"y":221984,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":661191,"y":679416,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":602836,"y":1136174,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Non-injury","color":"lightgrey"},{"x":554784,"y":1267938,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630641,"y":732782,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":692868,"y":906860,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":607584,"y":1122578,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":630718,"y":716658,"year":"2016","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":605247,"y":1126865,"year":"2016","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":597822,"y":1161732,"year":"2002","vehicles":"Single vehicle","severity":"Non-injury","color":"lightgrey"},{"x":586108,"y":1143745,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":743985,"y":1024121,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":718088,"y":1037431,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":717800,"y":1037123,"year":"2002","vehicles":"Multi vehicle","severity":"Non-injury","color":"lightgrey"},{"x":501498,"y":628667,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719202,"y":1044744,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718792,"y":1042499,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631185,"y":1040920,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638343,"y":1031160,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":639999,"y":1030132,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636970,"y":1032534,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":652816,"y":1018307,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719085,"y":1044708,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":565083,"y":1155014,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584758,"y":1135518,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593093,"y":1136199,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675928,"y":1060270,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625336,"y":979224,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606526,"y":1130567,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676901,"y":899413,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":683798,"y":1107118,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609016,"y":1110364,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536683,"y":1290217,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597053,"y":1131783,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627261,"y":1046298,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":795771,"y":1004768,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":682164,"y":1104700,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675708,"y":1128640,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":707358,"y":929437,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606407,"y":1116268,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596689,"y":1133096,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625229,"y":968264,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586537,"y":1129224,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585258,"y":1179853,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676985,"y":899203,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649714,"y":1211363,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":586308,"y":1153379,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719678,"y":1043869,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556778,"y":1263233,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":636311,"y":1029335,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637884,"y":1031382,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581528,"y":1134283,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579167,"y":1132742,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579493,"y":1138156,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585946,"y":1130499,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587136,"y":1129838,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":715606,"y":1039036,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643564,"y":1026370,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":500798,"y":1304627,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":420615,"y":1397683,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638388,"y":1028937,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592122,"y":1140766,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588493,"y":1166754,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":523740,"y":1311822,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613293,"y":1114729,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601243,"y":1029974,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666335,"y":1096356,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":663973,"y":1101803,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672556,"y":1044263,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671593,"y":1100574,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674038,"y":1076077,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635019,"y":1035737,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":787726,"y":1007296,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768356,"y":999757,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590519,"y":1144113,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":582845,"y":1129950,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600147,"y":1119864,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606679,"y":1115809,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592172,"y":1131465,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591901,"y":1141772,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636596,"y":1029244,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607177,"y":1120698,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":678520,"y":1070792,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617336,"y":1094053,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606486,"y":1123482,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605237,"y":1121607,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603493,"y":1133023,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":593194,"y":1133342,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602639,"y":1132855,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588701,"y":1128347,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":593362,"y":1140159,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578800,"y":1144729,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632962,"y":1038375,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612547,"y":955956,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715272,"y":1042184,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":675071,"y":873703,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674454,"y":900478,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":707950,"y":1032622,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591745,"y":1144042,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604886,"y":1124942,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":797546,"y":984559,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654900,"y":1018955,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":707138,"y":1000169,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696515,"y":908668,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608253,"y":1119854,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592600,"y":1138092,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676282,"y":878503,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584405,"y":1129629,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593820,"y":1148425,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586446,"y":1159700,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599831,"y":1123454,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603712,"y":1124140,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585352,"y":1184459,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":507244,"y":1307215,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602179,"y":1120810,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592316,"y":1130215,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602807,"y":1127799,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628997,"y":952555,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715250,"y":1010189,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582865,"y":1125523,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672533,"y":1085330,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589278,"y":1134074,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639580,"y":1032589,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704168,"y":957167,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672069,"y":1014163,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601520,"y":1130735,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602351,"y":1130682,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":567623,"y":1210233,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592527,"y":1147861,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":648922,"y":1024634,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692241,"y":1114855,"year":"2000","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":485425,"y":524832,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":772520,"y":825420,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586761,"y":646506,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762916,"y":835738,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774224,"y":813782,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":862971,"y":904537,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607887,"y":792916,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600768,"y":652434,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591692,"y":660259,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592367,"y":650503,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":796186,"y":877177,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658816,"y":678045,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598938,"y":674450,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":526619,"y":890175,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518004,"y":625945,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547666,"y":861529,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643168,"y":890561,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668926,"y":833006,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766639,"y":821399,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547441,"y":834938,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524950,"y":647304,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":458562,"y":646508,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600230,"y":653312,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596840,"y":651940,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598346,"y":647650,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":662847,"y":747439,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658437,"y":748797,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670289,"y":751866,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":538835,"y":844746,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":526994,"y":843710,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530923,"y":890188,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530958,"y":890094,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":543340,"y":898964,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":852304,"y":893626,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":819286,"y":883272,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":859116,"y":879796,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":853622,"y":895111,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459237,"y":644177,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595047,"y":651611,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":470211,"y":653760,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":441779,"y":650337,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":447675,"y":635976,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501380,"y":619623,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":772741,"y":837414,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":770282,"y":843410,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771984,"y":835871,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":815681,"y":886131,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536338,"y":883637,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438181,"y":667061,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650441,"y":686029,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587252,"y":639073,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597113,"y":652056,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608371,"y":687116,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591435,"y":649979,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611116,"y":662329,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670935,"y":801234,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649820,"y":671621,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585963,"y":642937,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589424,"y":652383,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774138,"y":836436,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":778667,"y":860613,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659170,"y":679863,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":372196,"y":587771,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":851384,"y":948751,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":445495,"y":636476,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767361,"y":823362,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":476304,"y":654471,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405271,"y":400386,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408536,"y":396908,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119964,"y":93539,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":239235,"y":189270,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":126695,"y":105104,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":97683,"y":91474,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":401083,"y":396669,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405540,"y":501518,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":144784,"y":238804,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":397050,"y":394466,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":393461,"y":397736,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":175579,"y":128893,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413803,"y":398376,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":430258,"y":370983,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243523,"y":134136,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130145,"y":261398,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":344394,"y":564247,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":290006,"y":514628,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":397872,"y":387457,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407919,"y":398119,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":409160,"y":396308,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407730,"y":397393,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":373533,"y":361610,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414316,"y":388225,"year":"2000","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":204936,"y":308618,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":142780,"y":256495,"year":"2000","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407903,"y":398689,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":100233,"y":228024,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":592036,"y":1149564,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580660,"y":1191675,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593462,"y":1136889,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638908,"y":994343,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719268,"y":1035568,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":691055,"y":1099465,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593978,"y":1135542,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718088,"y":1037431,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603384,"y":1123472,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602619,"y":1116382,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722153,"y":990017,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602091,"y":1130763,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598082,"y":1131084,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704091,"y":954900,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602501,"y":1132855,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":509727,"y":1297585,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":510461,"y":1241753,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530466,"y":1246335,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612456,"y":1125754,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592371,"y":1130407,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":601047,"y":1123052,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606333,"y":1129448,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580638,"y":1136709,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584434,"y":1137228,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609715,"y":1112743,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":624028,"y":1075231,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586643,"y":1157434,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":691000,"y":1070501,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661163,"y":1045789,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626190,"y":1045275,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680620,"y":896531,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":645816,"y":1035874,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594653,"y":1142855,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593466,"y":1136900,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593611,"y":1146650,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":590554,"y":1149255,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716598,"y":1040040,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":688795,"y":981933,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":621170,"y":1126916,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676440,"y":1058117,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":697643,"y":939149,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":706694,"y":929124,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565965,"y":1156441,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":693732,"y":1080252,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718655,"y":942582,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722584,"y":983144,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":732153,"y":997704,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684827,"y":991433,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604689,"y":1115082,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599993,"y":1121601,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594345,"y":1135127,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598852,"y":1130101,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598435,"y":1130573,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606364,"y":1118459,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591311,"y":1147390,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595214,"y":1136448,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594995,"y":1128985,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":813392,"y":1000778,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638480,"y":1029222,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597141,"y":1122288,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583462,"y":1132908,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612959,"y":1098919,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":745436,"y":1029687,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594345,"y":1135127,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602723,"y":1132129,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":735943,"y":1027609,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":552967,"y":1260013,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579780,"y":935985,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581489,"y":1138449,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583992,"y":1134636,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598180,"y":944868,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598478,"y":1130472,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608372,"y":1119601,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679971,"y":886057,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722503,"y":989899,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601173,"y":1125980,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589586,"y":1134026,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622396,"y":1054127,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637470,"y":1032450,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603830,"y":1128939,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639059,"y":1029215,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665806,"y":1096925,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607652,"y":1126457,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623624,"y":1095144,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626955,"y":1042194,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613156,"y":1090460,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608231,"y":1115207,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606905,"y":689226,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594310,"y":660914,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":817581,"y":885627,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677157,"y":678059,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696861,"y":683794,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438602,"y":673171,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":768106,"y":829560,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530635,"y":892158,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":893236,"y":939889,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637001,"y":909900,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629053,"y":937254,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":448517,"y":642150,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":847071,"y":953722,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635982,"y":909514,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656514,"y":760653,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767956,"y":835791,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768734,"y":818911,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630677,"y":742928,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773623,"y":836412,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555349,"y":828282,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637037,"y":750541,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":660608,"y":748261,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657833,"y":739160,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623230,"y":778963,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656784,"y":742582,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630000,"y":715971,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631757,"y":719853,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587862,"y":649581,"year":"2001","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":658780,"y":678815,"year":"2001","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":435323,"y":657951,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":452561,"y":640014,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517300,"y":881749,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530820,"y":892660,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530831,"y":892772,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628035,"y":713569,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774002,"y":832462,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":905665,"y":1012349,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":860335,"y":927406,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":876696,"y":923551,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590841,"y":654950,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586733,"y":646348,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575878,"y":918116,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600581,"y":646966,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633202,"y":667379,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":836591,"y":916212,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471140,"y":651938,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608497,"y":661730,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769019,"y":832285,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":440123,"y":460896,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":434911,"y":367240,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":26976,"y":175558,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":381207,"y":387895,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119321,"y":352363,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":424901,"y":487394,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":337713,"y":443417,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":277172,"y":219506,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":155041,"y":246566,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":284273,"y":261869,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79462,"y":65918,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":73508,"y":59819,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80117,"y":65419,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80319,"y":66333,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":118170,"y":92102,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":44243,"y":223946,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409021,"y":397665,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409146,"y":398931,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":23582,"y":172864,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":243328,"y":132635,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":292865,"y":513045,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":302208,"y":479620,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409735,"y":398171,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":267614,"y":185810,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243433,"y":131008,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":108814,"y":230884,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":109848,"y":227770,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":135525,"y":220069,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":413448,"y":390232,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":205348,"y":408513,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":407570,"y":395570,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":398135,"y":413456,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":145611,"y":184734,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":238524,"y":135327,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":65854,"y":11093,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410073,"y":387017,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244415,"y":134744,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":200824,"y":129115,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95269,"y":220329,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":251588,"y":139365,"year":"2001","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":230615,"y":130687,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":188017,"y":130713,"year":"2001","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718293,"y":1042539,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":722165,"y":1041588,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689073,"y":1074017,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":624902,"y":1029683,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609097,"y":1131128,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587334,"y":1172529,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":564657,"y":1140446,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":619647,"y":1106251,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726638,"y":991422,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581584,"y":1160621,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":790705,"y":1007361,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555720,"y":1261642,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":638023,"y":1031619,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":603252,"y":1122270,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600411,"y":1002381,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585417,"y":1127368,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589150,"y":1133926,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604601,"y":1120956,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769031,"y":1009226,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":512525,"y":1277881,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":822886,"y":1002312,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599507,"y":1131659,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581458,"y":1139109,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704634,"y":925595,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565757,"y":1156833,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581739,"y":1136845,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":460656,"y":1337365,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":594567,"y":1137129,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597115,"y":1140199,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659390,"y":1065332,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679705,"y":1139628,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630696,"y":1007587,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":572957,"y":1125991,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596660,"y":1126107,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596825,"y":1132294,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714431,"y":1036555,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":589365,"y":1129572,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690301,"y":1072066,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692532,"y":1092723,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":658245,"y":1146084,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605051,"y":952164,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594309,"y":1135767,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637009,"y":1032239,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692503,"y":906171,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639349,"y":1030681,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607562,"y":1127823,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696161,"y":1066230,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640490,"y":1044271,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":647211,"y":1086752,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659031,"y":1139662,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":523261,"y":1312413,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565162,"y":1223551,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592481,"y":1146290,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":568498,"y":1124397,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611945,"y":1097618,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":597998,"y":1123712,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700481,"y":1035775,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617634,"y":1118970,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578380,"y":1248336,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":503770,"y":1251413,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594662,"y":1143003,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":663662,"y":1103486,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716330,"y":1039753,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":548443,"y":1283334,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594701,"y":1128957,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603834,"y":1128949,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636926,"y":1030128,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654923,"y":1014958,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":500409,"y":1336289,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602458,"y":1118346,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642787,"y":1003856,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":490375,"y":1342439,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610213,"y":1092793,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":883574,"y":925660,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":541639,"y":857977,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659793,"y":844021,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773283,"y":833425,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":770285,"y":818284,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636322,"y":909046,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769368,"y":834821,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762492,"y":815588,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534219,"y":883894,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":875057,"y":924101,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":908657,"y":1037794,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615854,"y":797571,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617306,"y":698917,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":911027,"y":1037049,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576114,"y":922502,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":453248,"y":639503,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":539933,"y":835172,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575489,"y":909218,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":546625,"y":837071,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657904,"y":745833,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":528365,"y":891631,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501586,"y":631559,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660626,"y":745920,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":866367,"y":931130,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594136,"y":666097,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":740326,"y":782824,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":509359,"y":646421,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557468,"y":823631,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":686904,"y":750107,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660356,"y":678916,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610746,"y":793614,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585537,"y":643377,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585415,"y":642797,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":659276,"y":678772,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":873589,"y":925113,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611653,"y":801809,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557468,"y":823631,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461232,"y":647669,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766412,"y":821699,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":851438,"y":888916,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":548070,"y":860180,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":643333,"y":771957,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555742,"y":826582,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":482991,"y":659164,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534858,"y":894059,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":747366,"y":795025,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":826638,"y":960893,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586094,"y":644542,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":282170,"y":385003,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408825,"y":407091,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":153997,"y":198504,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137732,"y":221782,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":287650,"y":335484,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":212025,"y":115037,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":102153,"y":186561,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":153809,"y":198728,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408503,"y":395013,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404639,"y":400792,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":111678,"y":74401,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405830,"y":394784,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":408920,"y":397304,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243272,"y":132104,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241507,"y":129029,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":233129,"y":129833,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119855,"y":260200,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":277591,"y":220454,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":278920,"y":223007,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":277478,"y":220873,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":405482,"y":402380,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407117,"y":394317,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":251516,"y":142137,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":107139,"y":60548,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":212311,"y":115257,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406211,"y":394528,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":380752,"y":401507,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":400871,"y":380212,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":180379,"y":126289,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":92060,"y":62088,"year":"2002","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":101048,"y":175767,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":83414,"y":154461,"year":"2002","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593095,"y":1136535,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598078,"y":1199357,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704282,"y":929096,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":707694,"y":1032290,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":711465,"y":1039432,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716722,"y":1040607,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":533777,"y":1300559,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610841,"y":1097324,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606260,"y":1096094,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719428,"y":990943,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":508712,"y":1295858,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567611,"y":1210162,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606654,"y":1130649,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593610,"y":1134834,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":467945,"y":1329171,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692827,"y":1053340,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":621806,"y":1109900,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515526,"y":1332232,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700285,"y":1038956,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766669,"y":1016388,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587524,"y":1131341,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":540006,"y":1287781,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":540213,"y":1312741,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":719394,"y":994675,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721326,"y":989502,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721073,"y":991775,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":594734,"y":1136021,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595052,"y":1134121,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":511284,"y":1227484,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":451439,"y":1325306,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589571,"y":1134111,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597025,"y":1127820,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":706947,"y":1031576,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556920,"y":1263574,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":560868,"y":1257603,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556600,"y":1249363,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610032,"y":1107400,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":519055,"y":1323379,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515163,"y":1340900,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":443784,"y":1369807,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":504183,"y":1309791,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696166,"y":1071526,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676320,"y":877282,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676830,"y":1072618,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687771,"y":986645,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719475,"y":994492,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":707575,"y":970436,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":648267,"y":1008639,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":840507,"y":1014266,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610033,"y":1107930,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577286,"y":1134941,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":755891,"y":997241,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694437,"y":1005198,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593674,"y":1160541,"year":"2003","vehicles":"Other","severity":"Minor Injury","color":"#ffa500"},{"x":630342,"y":1042519,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":645799,"y":1035870,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591210,"y":1145519,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639349,"y":1030681,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632968,"y":1027627,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595506,"y":1134419,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":607508,"y":1118769,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591680,"y":1132980,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":590610,"y":1131062,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635885,"y":1033756,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628291,"y":1062719,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":647070,"y":1028367,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603482,"y":1132913,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594024,"y":1136410,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704211,"y":956068,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608539,"y":1111599,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":572689,"y":1257294,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622999,"y":1122482,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":528172,"y":1310123,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":725751,"y":991022,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":549328,"y":1282532,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595234,"y":1133917,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721909,"y":990844,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575000,"y":1145317,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":593629,"y":1134381,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555454,"y":1259866,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627851,"y":1054176,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661147,"y":1016616,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627830,"y":1064710,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582550,"y":1110703,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593108,"y":1135495,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532584,"y":1313469,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607062,"y":1115417,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607060,"y":1115193,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":421626,"y":1396991,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575612,"y":1273455,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415067,"y":1399711,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":673959,"y":1101870,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":487480,"y":1333449,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593644,"y":1134948,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612307,"y":1103008,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603700,"y":1132413,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438062,"y":663814,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530963,"y":892280,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672712,"y":684349,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":667474,"y":750039,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671569,"y":749785,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":856157,"y":883067,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641225,"y":777689,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":542136,"y":890995,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657083,"y":745383,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596442,"y":651909,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527283,"y":891229,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611179,"y":792227,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":609016,"y":914918,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":373259,"y":565753,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":621466,"y":669107,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":662923,"y":792363,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":888718,"y":932417,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":630853,"y":717051,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594319,"y":666072,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594096,"y":660793,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630178,"y":716969,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":422088,"y":678509,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":740179,"y":790007,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":526057,"y":891305,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774002,"y":832462,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":770734,"y":819599,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":765674,"y":822063,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656723,"y":745823,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658607,"y":745131,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773124,"y":836329,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":700724,"y":760398,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":594818,"y":660467,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606002,"y":658940,"year":"2003","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":411917,"y":705397,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773182,"y":826826,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585971,"y":640220,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532664,"y":590504,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":437785,"y":667240,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762818,"y":823025,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583389,"y":644455,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":845109,"y":947309,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588916,"y":641245,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":748707,"y":879366,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":866648,"y":925929,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":464467,"y":645102,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":524625,"y":611030,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":873647,"y":926590,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":450882,"y":638630,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627118,"y":657460,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414199,"y":399502,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":423150,"y":508577,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":121699,"y":44832,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":288259,"y":512373,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":239201,"y":127885,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":159253,"y":49942,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413676,"y":389653,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":401512,"y":402383,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415509,"y":393366,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415475,"y":398244,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":409653,"y":402121,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407814,"y":395412,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":409920,"y":398729,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":334893,"y":352597,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":393442,"y":392749,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":395714,"y":393963,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":142524,"y":130781,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243910,"y":133574,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":79930,"y":64107,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79681,"y":65551,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":138527,"y":102908,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":89903,"y":161834,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":134312,"y":219643,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409731,"y":401119,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413588,"y":389838,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":323331,"y":480714,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":240452,"y":130364,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":291033,"y":488819,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":270378,"y":245878,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":128233,"y":259167,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":232047,"y":125515,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":164604,"y":131468,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80139,"y":65031,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":120380,"y":108829,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411247,"y":410368,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":187889,"y":94239,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79994,"y":63837,"year":"2003","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":341791,"y":606886,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":99086,"y":67456,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":97084,"y":75852,"year":"2003","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642168,"y":1086864,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721764,"y":1042125,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718457,"y":1045714,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":724513,"y":1040061,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590663,"y":1148774,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592441,"y":1132381,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594386,"y":1135402,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":592436,"y":1128178,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610047,"y":1112413,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":601223,"y":1126685,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642080,"y":1029805,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607512,"y":1127347,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":604489,"y":1115112,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584040,"y":1126141,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594161,"y":1136358,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":687743,"y":1122499,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535122,"y":1311112,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644893,"y":1087932,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596884,"y":1125199,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602746,"y":1124697,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579743,"y":1140460,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626444,"y":1124602,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567405,"y":1232860,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690741,"y":1089546,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574902,"y":1273684,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":466250,"y":1339658,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579792,"y":1106465,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739720,"y":900633,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696672,"y":1071726,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600833,"y":1121379,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594705,"y":1142284,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680578,"y":1136166,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634673,"y":1029599,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":691221,"y":1074528,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":734321,"y":1013273,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":738958,"y":901735,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592822,"y":1137281,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596547,"y":1132535,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592490,"y":1137889,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607062,"y":1115467,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599301,"y":1136333,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593354,"y":1140128,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608003,"y":1113086,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607063,"y":1115547,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607063,"y":1115537,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593559,"y":1136856,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592147,"y":1130186,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582878,"y":1136587,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593226,"y":1139630,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536152,"y":1302027,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634302,"y":1091173,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626018,"y":1029714,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593339,"y":1140062,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601166,"y":1130074,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":600737,"y":1128929,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595967,"y":1133322,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595992,"y":1136570,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":725553,"y":991481,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":824238,"y":1002714,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":479343,"y":1291784,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":512117,"y":1291599,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":498137,"y":1291346,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":561856,"y":1217741,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":531491,"y":1327047,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":539824,"y":1301729,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524668,"y":1308916,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":543478,"y":1286954,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536665,"y":1310672,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":494220,"y":1341115,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518121,"y":1236142,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410407,"y":1404908,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":443153,"y":1370418,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583407,"y":1130038,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574343,"y":1146164,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586458,"y":1128788,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589159,"y":1171346,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565591,"y":1225026,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594020,"y":1143366,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":564544,"y":1158616,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602723,"y":1095058,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554365,"y":1252339,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":571292,"y":1149899,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589723,"y":1132974,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627821,"y":1056022,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625032,"y":1029712,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665480,"y":1097125,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692006,"y":1115551,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687256,"y":1106608,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692611,"y":1093285,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":672024,"y":1072444,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674570,"y":1062042,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650406,"y":1006844,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671899,"y":1066256,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":730399,"y":964480,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":618687,"y":1094823,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617215,"y":1116935,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":728698,"y":1036495,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":717190,"y":1035797,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":708301,"y":1039519,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625408,"y":1072756,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608359,"y":1112213,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591599,"y":1144335,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609263,"y":1116342,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672073,"y":1012314,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721414,"y":1041234,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":767110,"y":938375,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":787415,"y":1004893,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627248,"y":1044261,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":817801,"y":970301,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603416,"y":1115966,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556506,"y":1261498,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602083,"y":1119933,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597602,"y":1119477,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583260,"y":1211672,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592344,"y":1130311,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593939,"y":1146027,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596672,"y":1141436,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588779,"y":1132756,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585399,"y":1177127,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717991,"y":990738,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":730169,"y":964342,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":724867,"y":1038140,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590551,"y":1145832,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":507446,"y":1287854,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692432,"y":1114177,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622390,"y":1106929,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598754,"y":1132898,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574821,"y":1204958,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556784,"y":1268448,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607506,"y":1114966,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501297,"y":1291144,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575381,"y":1225904,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":566334,"y":1217469,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":797752,"y":1004224,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739716,"y":998459,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":723482,"y":1032227,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569630,"y":1285426,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":705084,"y":960631,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":732049,"y":1003089,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":702341,"y":929221,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681673,"y":948856,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596132,"y":1119330,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608902,"y":1131237,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609205,"y":1110213,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536998,"y":894866,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632159,"y":661711,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":770212,"y":840315,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611495,"y":662198,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668799,"y":800044,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":686777,"y":682231,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633843,"y":909546,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":779348,"y":820670,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631345,"y":714886,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":631225,"y":714809,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":631217,"y":714814,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":486721,"y":643915,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":464100,"y":646694,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":630522,"y":717546,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409625,"y":712629,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595300,"y":661027,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":591050,"y":659469,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":548901,"y":848720,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":443099,"y":654183,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459773,"y":646055,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":774113,"y":837712,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":501082,"y":646416,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527051,"y":890834,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":437803,"y":665270,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":773855,"y":812591,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767337,"y":820469,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767511,"y":820841,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659160,"y":745112,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":636944,"y":750309,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774026,"y":828900,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611273,"y":794692,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":460043,"y":646463,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438048,"y":663460,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":864654,"y":916689,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":648420,"y":674776,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590816,"y":656786,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":664238,"y":744602,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657885,"y":744879,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595118,"y":663820,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658649,"y":748505,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593893,"y":650859,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589167,"y":648156,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535848,"y":837262,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592126,"y":660274,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":622691,"y":663662,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":746181,"y":882597,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518364,"y":640394,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":760134,"y":854397,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527896,"y":890745,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":444121,"y":652688,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637105,"y":750711,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658376,"y":694748,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654177,"y":675743,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517054,"y":618814,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":670240,"y":756589,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":585990,"y":644708,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":481620,"y":514414,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656288,"y":745888,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459280,"y":478078,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415022,"y":429930,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403364,"y":399108,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414232,"y":398388,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":53771,"y":71014,"year":"2004","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":237038,"y":342456,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461145,"y":487320,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408049,"y":396906,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408057,"y":395573,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":208390,"y":112540,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119338,"y":262514,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":389053,"y":380709,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411086,"y":381749,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415181,"y":365855,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":431504,"y":457359,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403584,"y":389287,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":290841,"y":297039,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":296823,"y":293658,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414322,"y":399008,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":406147,"y":401319,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413059,"y":398448,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":307580,"y":572671,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":341683,"y":556521,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":285067,"y":501962,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408052,"y":396421,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":408057,"y":395695,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":108143,"y":231250,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":134291,"y":260412,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":120769,"y":261673,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":74793,"y":65264,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243433,"y":131008,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":307757,"y":319596,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243198,"y":130858,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":250915,"y":164039,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":183608,"y":93643,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":200380,"y":86184,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":266144,"y":194637,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243389,"y":132943,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":245578,"y":129253,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":78056,"y":84018,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":139580,"y":226770,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":256460,"y":138017,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80561,"y":66104,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":82047,"y":141910,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":402495,"y":394810,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":380256,"y":430372,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405824,"y":501600,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408299,"y":395837,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95195,"y":220335,"year":"2004","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":243506,"y":130134,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":170622,"y":92434,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81108,"y":61111,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":197519,"y":287997,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243528,"y":133191,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":406028,"y":394353,"year":"2004","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":359714,"y":372151,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243433,"y":131008,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95763,"y":220234,"year":"2004","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599187,"y":1136627,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591823,"y":1131476,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594166,"y":1135389,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704940,"y":925686,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657072,"y":1018837,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721552,"y":1041552,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719182,"y":1042484,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585255,"y":1138256,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600500,"y":1125563,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609124,"y":1131308,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":593884,"y":1135225,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597208,"y":1124254,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":552174,"y":1313307,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409908,"y":1405104,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525934,"y":1219552,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716395,"y":1008311,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668728,"y":1065894,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":621235,"y":1084625,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":673391,"y":906018,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766996,"y":1016071,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577392,"y":1219798,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":618778,"y":1094947,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":678520,"y":1070792,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584334,"y":1128875,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613629,"y":1104198,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689964,"y":1103783,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594531,"y":1136359,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":673441,"y":1148059,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591106,"y":1140826,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":590543,"y":1144094,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592128,"y":1151086,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591784,"y":1141122,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593769,"y":1134920,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587343,"y":1130196,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582301,"y":1134339,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598194,"y":1123367,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599305,"y":1122009,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603613,"y":1123652,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596872,"y":1125250,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593596,"y":1136153,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593198,"y":1152948,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606083,"y":1118713,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578470,"y":1192094,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569134,"y":1207491,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":477960,"y":1280987,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537632,"y":1197560,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459284,"y":1326570,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580693,"y":1134002,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585456,"y":1164423,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606609,"y":1117910,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603731,"y":1124135,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675652,"y":875574,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547298,"y":1259672,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602822,"y":1117105,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637552,"y":1036145,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638329,"y":1028946,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679109,"y":1139301,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":677908,"y":1136075,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":664331,"y":1084061,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721219,"y":990959,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717425,"y":941754,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623185,"y":964745,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681391,"y":1027662,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718162,"y":1046051,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715305,"y":978804,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639348,"y":1033062,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670207,"y":1012754,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714112,"y":1037480,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":736326,"y":1026827,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672387,"y":1044601,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606926,"y":1129772,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602435,"y":1136077,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600538,"y":1136454,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598136,"y":1135977,"year":"2005","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":595115,"y":1136781,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588375,"y":1131095,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":589643,"y":1140887,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601258,"y":1127584,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":548047,"y":1259818,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604826,"y":1124239,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604407,"y":1117326,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590574,"y":1144069,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589628,"y":1142524,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":469351,"y":1322500,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590891,"y":1185860,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597828,"y":1196731,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587395,"y":1162369,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704657,"y":929514,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594626,"y":1137109,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":661272,"y":1105610,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638078,"y":1031098,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643957,"y":1038341,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554626,"y":1267319,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604504,"y":1122291,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600507,"y":1135080,"year":"2005","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":679263,"y":882260,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719988,"y":987606,"year":"2005","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":682370,"y":966648,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676213,"y":998288,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680620,"y":896531,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729525,"y":1000085,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591770,"y":1187204,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":587434,"y":1131516,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":655425,"y":1080043,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":725296,"y":1038952,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":608747,"y":1129910,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604190,"y":1095573,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637206,"y":1033170,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606467,"y":1121592,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":601199,"y":1126855,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627786,"y":1055856,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666150,"y":1056270,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":782231,"y":1007214,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638444,"y":1028985,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603546,"y":1095036,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605169,"y":683803,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766350,"y":821179,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605259,"y":682845,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609423,"y":793099,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":657328,"y":746180,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":452563,"y":639429,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527313,"y":890259,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":614016,"y":795456,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768210,"y":821584,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774009,"y":814114,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":463085,"y":649300,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524625,"y":611030,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":695551,"y":663293,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":496701,"y":646104,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537735,"y":881825,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532293,"y":893333,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":660899,"y":741827,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438069,"y":664002,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593702,"y":807044,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":765755,"y":822122,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769823,"y":825562,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767261,"y":820977,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":658712,"y":745818,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":462042,"y":646732,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":846158,"y":946046,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771992,"y":857191,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":869096,"y":932132,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":372677,"y":587139,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594088,"y":660787,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":402899,"y":599012,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585863,"y":644084,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":606090,"y":684689,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":375178,"y":581192,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627405,"y":782407,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657540,"y":744549,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":546982,"y":833492,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598242,"y":653839,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600608,"y":644326,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":620697,"y":703610,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598254,"y":649459,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658124,"y":677038,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":761963,"y":816201,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611693,"y":794831,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640236,"y":766163,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":495721,"y":618524,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622644,"y":663524,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557548,"y":823996,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637628,"y":731089,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":624012,"y":705445,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587252,"y":641546,"year":"2005","vehicles":"Cyclist(s)+Pedestrian(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":516948,"y":620408,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":589167,"y":638857,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":885099,"y":926103,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589504,"y":639644,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":607480,"y":797351,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":508665,"y":631814,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":296896,"y":302762,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405572,"y":394572,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410659,"y":400755,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408291,"y":396908,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":417388,"y":392387,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":110799,"y":120040,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":167359,"y":136275,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":94902,"y":220042,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":153793,"y":198747,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459402,"y":477205,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":259176,"y":141530,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":400452,"y":397682,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":138545,"y":224953,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137659,"y":222799,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79668,"y":64760,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95051,"y":221129,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":381213,"y":420871,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":123714,"y":102747,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409680,"y":397938,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241619,"y":133022,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":395212,"y":362154,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":439787,"y":370757,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408928,"y":396063,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409451,"y":395198,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403379,"y":392770,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407318,"y":396780,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405018,"y":396488,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405021,"y":396576,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408921,"y":393680,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415140,"y":398710,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407323,"y":396053,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404385,"y":421184,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405208,"y":410994,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407014,"y":410053,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":306199,"y":518218,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":289472,"y":513738,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":264942,"y":473695,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":296806,"y":297694,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":336047,"y":353491,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":213805,"y":321210,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":75251,"y":144721,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411084,"y":399025,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404188,"y":396223,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406622,"y":394349,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":200767,"y":105863,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":171637,"y":77409,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":155642,"y":91065,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":109885,"y":227171,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":25825,"y":174222,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":66030,"y":11275,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":131014,"y":259763,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":245522,"y":135230,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":146205,"y":242957,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":239945,"y":133973,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411617,"y":412919,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":398052,"y":395033,"year":"2005","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":244390,"y":139756,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":140521,"y":225991,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387044,"y":417421,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":286272,"y":236599,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":149258,"y":239851,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":163255,"y":142589,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":188117,"y":92374,"year":"2005","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130516,"y":259036,"year":"2005","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715769,"y":1037933,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517547,"y":1244785,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":566381,"y":1217556,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569624,"y":1164675,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602351,"y":1120876,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569308,"y":1175413,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606669,"y":1118065,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525983,"y":1325773,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607150,"y":1133631,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588710,"y":1132089,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659415,"y":1017505,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658444,"y":1094029,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637615,"y":1033602,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625421,"y":1070840,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714433,"y":995584,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715795,"y":997294,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700694,"y":927865,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":648628,"y":1022273,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690009,"y":1119682,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739490,"y":1026144,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721720,"y":1041477,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":703539,"y":951961,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578036,"y":934290,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696776,"y":1021502,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675200,"y":1018465,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":570488,"y":1160956,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555608,"y":1260216,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681327,"y":1103208,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681400,"y":1001575,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":709385,"y":931783,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609219,"y":953073,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609259,"y":1114051,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584261,"y":1134530,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660462,"y":1061054,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595306,"y":1129464,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668260,"y":1083291,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581135,"y":1131444,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585133,"y":1129680,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":601961,"y":1127244,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594649,"y":1128340,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583553,"y":1136168,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601670,"y":1128162,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588866,"y":1128004,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532753,"y":1313614,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471963,"y":1326459,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592857,"y":1135751,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591934,"y":1134809,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602505,"y":1132851,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602377,"y":1130847,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602228,"y":1126301,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594965,"y":1128172,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581055,"y":1132908,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515515,"y":1238232,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":527841,"y":1299236,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":455929,"y":1324882,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":533835,"y":1251575,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534361,"y":1298373,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524826,"y":1246753,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608243,"y":1119871,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":787564,"y":1006761,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":629881,"y":1030870,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631633,"y":1089972,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632065,"y":1025552,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633563,"y":1036335,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631708,"y":1049989,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632284,"y":1091590,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638074,"y":1031544,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":664080,"y":1042787,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665558,"y":1119080,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":733532,"y":1011515,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722133,"y":989685,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":704361,"y":929823,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":709292,"y":926693,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":708706,"y":1033161,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718362,"y":1045027,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":689375,"y":1092508,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639355,"y":1029965,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635260,"y":1032169,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594728,"y":1137029,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":594442,"y":1146632,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606016,"y":1117014,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":603625,"y":1115539,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578882,"y":1186138,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591184,"y":1143851,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601885,"y":1127502,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606498,"y":1123479,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605601,"y":1116656,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":472597,"y":1326716,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600721,"y":1125701,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607053,"y":1115646,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593659,"y":1140444,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585840,"y":1161063,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587523,"y":1130534,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586555,"y":1132014,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594134,"y":1133083,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600551,"y":1125255,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597691,"y":1132231,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592028,"y":1134780,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":508375,"y":1295371,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604750,"y":1120641,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":605032,"y":1119535,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583294,"y":1141557,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461086,"y":1330770,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590330,"y":1143854,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714798,"y":1001604,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576024,"y":1134555,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591164,"y":1131600,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592663,"y":1145022,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625501,"y":1095136,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636534,"y":1033078,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579952,"y":1132333,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":488947,"y":1262213,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671757,"y":1071140,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547127,"y":1284262,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596339,"y":1122352,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":699971,"y":967560,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690107,"y":1092570,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":630177,"y":987164,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596011,"y":1129254,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592756,"y":1097097,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604074,"y":1124211,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555624,"y":1255986,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590211,"y":1150896,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637262,"y":1033666,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641695,"y":1112289,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596272,"y":1095753,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582451,"y":1139481,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603502,"y":1123452,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599216,"y":1136515,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592943,"y":1144235,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":469052,"y":1354330,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661066,"y":1109486,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":370672,"y":571088,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644866,"y":754912,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607393,"y":656336,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612679,"y":796452,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583469,"y":645093,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774015,"y":835184,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525196,"y":571011,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":506714,"y":867444,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":709722,"y":775602,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586222,"y":643493,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588648,"y":649886,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587966,"y":883483,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535557,"y":894471,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593992,"y":651030,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":861834,"y":946474,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625797,"y":734737,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":530077,"y":892054,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596016,"y":651773,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":773954,"y":836404,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":771132,"y":817810,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":765409,"y":821862,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547825,"y":861700,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":843006,"y":884076,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":871570,"y":923886,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":647582,"y":782258,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588945,"y":648792,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":652881,"y":752491,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604317,"y":682225,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":519647,"y":839949,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":886202,"y":927518,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666175,"y":676338,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":446687,"y":643702,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":546068,"y":881139,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629823,"y":718368,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":587453,"y":647048,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585704,"y":643252,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":677718,"y":678299,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598746,"y":916227,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":539591,"y":892522,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602686,"y":661222,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606208,"y":684703,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":767648,"y":822438,"year":"2006","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":595519,"y":651826,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":456209,"y":643723,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600008,"y":646398,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637202,"y":815836,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656632,"y":763590,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589573,"y":639648,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608371,"y":687116,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520214,"y":645859,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":819658,"y":886158,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774022,"y":831912,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517804,"y":856314,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588544,"y":649157,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":458240,"y":646232,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":892481,"y":1046137,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412267,"y":393730,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":434777,"y":365646,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405005,"y":396314,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":279477,"y":479283,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407565,"y":396297,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407807,"y":396661,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243917,"y":134278,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":290421,"y":514845,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":431324,"y":371818,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":398604,"y":419545,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403245,"y":424859,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":49915,"y":236239,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409857,"y":399547,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409726,"y":396823,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408057,"y":395573,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411082,"y":396831,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":311378,"y":482756,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":238406,"y":435768,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137093,"y":217775,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":333249,"y":397286,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":428671,"y":370248,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":274137,"y":222087,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":490341,"y":523595,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415445,"y":436817,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":420466,"y":477941,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":480627,"y":512476,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":453978,"y":469530,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241198,"y":134778,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":232316,"y":133006,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":283396,"y":230526,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":128963,"y":258897,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":147536,"y":205989,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":207089,"y":102231,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":247896,"y":149570,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80797,"y":62039,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":479885,"y":511107,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":449215,"y":496664,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410420,"y":396195,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407450,"y":405741,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":230451,"y":129821,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404279,"y":500858,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":333683,"y":434416,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":96355,"y":220092,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":73732,"y":249316,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":252107,"y":161000,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":214583,"y":122696,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":175900,"y":89886,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":393555,"y":392938,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":444828,"y":463828,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":375966,"y":383507,"year":"2006","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410039,"y":399006,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":244401,"y":130439,"year":"2006","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596282,"y":1128463,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602901,"y":1133587,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600544,"y":1122224,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584453,"y":1146776,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604282,"y":1121545,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604945,"y":1120315,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":597851,"y":1121830,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":571038,"y":1215156,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":449941,"y":1323710,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587450,"y":1165444,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611130,"y":1111577,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":495019,"y":1252582,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677086,"y":1025727,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610596,"y":1105612,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":691884,"y":1094641,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623687,"y":1095175,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607806,"y":1127247,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":733648,"y":1027836,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644415,"y":1095891,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":683125,"y":1071530,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636905,"y":1090356,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":706286,"y":930117,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":663424,"y":1096147,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607337,"y":1131964,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":472537,"y":1283971,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689076,"y":1100638,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":470703,"y":1355239,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":601316,"y":1126283,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567761,"y":1241483,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584161,"y":1131154,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592215,"y":1145226,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611149,"y":1105524,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":512514,"y":1298964,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525976,"y":1219249,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594301,"y":1142008,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596522,"y":1132593,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581190,"y":1211904,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592929,"y":1135354,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603240,"y":1123316,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581030,"y":1129146,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589186,"y":1131608,"year":"2007","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":603332,"y":1132277,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594309,"y":1141847,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593945,"y":1136204,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588357,"y":1134021,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583170,"y":1129996,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638126,"y":1120314,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587634,"y":1130522,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590169,"y":1149194,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595749,"y":1140302,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555389,"y":1259738,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":604198,"y":1115824,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722357,"y":990125,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":723766,"y":1001526,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":544518,"y":1301442,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588953,"y":1134622,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":519332,"y":1337723,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":562529,"y":1265971,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690423,"y":1097474,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689505,"y":1101584,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638467,"y":1033654,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":791238,"y":991385,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769887,"y":1008585,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":827353,"y":1003362,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665511,"y":1097136,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665511,"y":1097136,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640886,"y":1098913,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":706284,"y":1046760,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729675,"y":1037311,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":721764,"y":990256,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726178,"y":978493,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":756729,"y":1021314,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713659,"y":1039805,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629791,"y":988919,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":720607,"y":990511,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":621051,"y":1125147,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471829,"y":1340681,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608232,"y":1115208,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554810,"y":1226972,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592537,"y":1132731,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604137,"y":1124859,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630205,"y":1030752,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524023,"y":1308922,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589996,"y":1133550,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597240,"y":1132892,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598692,"y":1122709,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":451116,"y":1324193,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":717801,"y":1042516,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586690,"y":1130118,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716383,"y":1041529,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607081,"y":1115386,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":648648,"y":1042983,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608641,"y":1123622,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597521,"y":1101035,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":735047,"y":970624,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581027,"y":1131359,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660614,"y":1195751,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517669,"y":626749,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585659,"y":637553,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588885,"y":648843,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592761,"y":650652,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773956,"y":833961,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":903978,"y":1041860,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":484276,"y":654841,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595078,"y":806237,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657336,"y":745130,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658373,"y":744681,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":658936,"y":745621,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660237,"y":677327,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644613,"y":877750,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":561086,"y":817719,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555400,"y":898741,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622583,"y":664858,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661653,"y":679619,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595314,"y":662890,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555340,"y":827990,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":528941,"y":891847,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598484,"y":652905,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613114,"y":662674,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771704,"y":838065,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":669956,"y":751347,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598371,"y":647778,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599228,"y":655491,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":435323,"y":657951,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":855611,"y":948500,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657433,"y":743416,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643120,"y":773667,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771803,"y":834893,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527062,"y":647186,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672625,"y":750509,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":547637,"y":861224,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":624643,"y":662063,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600607,"y":675387,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459787,"y":647215,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630002,"y":727479,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591385,"y":660762,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":429272,"y":623519,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":872221,"y":926084,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":908967,"y":1007221,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":746936,"y":820683,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591817,"y":650278,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771411,"y":823481,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654058,"y":736786,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774190,"y":829349,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608665,"y":661993,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586020,"y":645539,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610034,"y":660412,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":448034,"y":632868,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773824,"y":814244,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":428005,"y":623217,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649671,"y":671574,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":909873,"y":1015478,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586438,"y":642846,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597700,"y":650733,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515964,"y":883343,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660799,"y":747911,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769527,"y":848011,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666797,"y":843499,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585819,"y":641289,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774001,"y":812030,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586068,"y":641319,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":898304,"y":963469,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412397,"y":402396,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406616,"y":395177,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":242418,"y":136240,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":264336,"y":202124,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":141060,"y":227166,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":243223,"y":130393,"year":"2007","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":241421,"y":134506,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":134837,"y":263581,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407081,"y":396052,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":134030,"y":259616,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":73951,"y":64116,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":242014,"y":130573,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":250765,"y":139404,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":78644,"y":128867,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407479,"y":399326,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":250167,"y":133487,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95853,"y":220152,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":102842,"y":228939,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405480,"y":394256,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409016,"y":398133,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":401960,"y":399836,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241480,"y":129880,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243172,"y":132450,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406214,"y":402532,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403808,"y":422215,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":251819,"y":160850,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408060,"y":395188,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408051,"y":396664,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403225,"y":396115,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411666,"y":397507,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":240244,"y":130212,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409011,"y":398721,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":135152,"y":261120,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":146981,"y":186211,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":293596,"y":513125,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411825,"y":367043,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":227491,"y":336535,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81109,"y":133860,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":154377,"y":199144,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":498011,"y":531314,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":310506,"y":337908,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":185152,"y":89963,"year":"2007","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":263038,"y":205164,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":185860,"y":90418,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405623,"y":400233,"year":"2007","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":54344,"y":72310,"year":"2007","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":542586,"y":1287172,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556726,"y":1264069,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594656,"y":1128336,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":503735,"y":1296979,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596111,"y":1129223,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":522049,"y":1321217,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594419,"y":1134706,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658917,"y":1044626,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":725226,"y":1039580,"year":"2008","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":710319,"y":997930,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690369,"y":1116003,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":663925,"y":1100518,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":764983,"y":1017170,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629221,"y":983326,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654356,"y":1019366,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654940,"y":1018948,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638628,"y":1030766,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":517601,"y":1242300,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534381,"y":1295572,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644608,"y":1087960,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":799974,"y":989730,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":652796,"y":1018295,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":689701,"y":1074461,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677912,"y":1137965,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":633539,"y":1036339,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637614,"y":1078903,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684152,"y":1127279,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606408,"y":1124870,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589073,"y":1165221,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":711558,"y":1022454,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":462678,"y":1337990,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694852,"y":1050449,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":786726,"y":1006395,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596475,"y":1126914,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589623,"y":1133475,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591075,"y":1130854,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607714,"y":1128734,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575500,"y":1195379,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":624817,"y":1034347,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593912,"y":1134573,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589070,"y":1129578,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596809,"y":1123978,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595586,"y":1142609,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611102,"y":1110065,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692361,"y":1055432,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680233,"y":1007850,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":725117,"y":1039653,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729089,"y":962091,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587248,"y":1134022,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598312,"y":1139098,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587434,"y":1131516,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591270,"y":1147369,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582791,"y":1132974,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580670,"y":1142834,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578873,"y":1221537,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":572964,"y":1204820,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":502997,"y":1252909,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596207,"y":1119836,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607023,"y":1125435,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":603744,"y":1129078,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600542,"y":1123481,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595023,"y":1134149,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592635,"y":1138115,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574053,"y":1198600,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595974,"y":1121595,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596662,"y":1126160,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":699884,"y":936998,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":740765,"y":1030935,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594677,"y":1136363,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601411,"y":1021914,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627836,"y":979991,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598265,"y":1135731,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596307,"y":1127533,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604531,"y":1135759,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":780614,"y":1010314,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":566596,"y":1233573,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590613,"y":1160318,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":684381,"y":1127851,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600304,"y":1136474,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":459492,"y":1327174,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":861008,"y":1036190,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":850450,"y":1029475,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589960,"y":1169131,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601324,"y":1131009,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":486392,"y":1319644,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716291,"y":1040119,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607099,"y":1124162,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":568842,"y":1256637,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583135,"y":1151336,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595304,"y":1136043,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593084,"y":1138926,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603916,"y":1115309,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601164,"y":1120276,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603415,"y":1129299,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640110,"y":1029671,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":493716,"y":1289681,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":484610,"y":1338763,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719320,"y":991827,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583344,"y":1129810,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722872,"y":1039692,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722872,"y":1039692,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":463278,"y":649423,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592948,"y":650723,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":817683,"y":885652,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613368,"y":698429,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595047,"y":651611,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611363,"y":689091,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":872061,"y":925699,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773753,"y":835416,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":568793,"y":902683,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657313,"y":745509,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632217,"y":922701,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721913,"y":849338,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587433,"y":639956,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":899745,"y":956963,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":834331,"y":959789,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582747,"y":644229,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":421128,"y":690202,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607943,"y":661430,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612609,"y":658606,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597037,"y":652881,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":531876,"y":892687,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":538803,"y":895382,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":529621,"y":883925,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":521254,"y":644106,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":634900,"y":719136,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527390,"y":573799,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":502411,"y":623935,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":546307,"y":899001,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":529186,"y":891190,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633487,"y":714518,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":457628,"y":644119,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585109,"y":643866,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":424705,"y":693540,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516753,"y":652939,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637180,"y":721261,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585335,"y":644114,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600839,"y":645154,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":658308,"y":751656,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":506703,"y":620575,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589138,"y":648179,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625839,"y":718300,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":695602,"y":682708,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":470828,"y":651762,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594890,"y":669451,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":545500,"y":833063,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874424,"y":924151,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":552577,"y":829772,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":872609,"y":923946,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":773961,"y":836652,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":758112,"y":843218,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":523212,"y":645978,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":871091,"y":923826,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597808,"y":664573,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":646059,"y":736849,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":764773,"y":837302,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584165,"y":642947,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612937,"y":662583,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555904,"y":861108,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584058,"y":644172,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762518,"y":815684,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":373557,"y":539160,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773629,"y":837263,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684119,"y":747381,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762035,"y":824827,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":234670,"y":314625,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":30066,"y":193868,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":223608,"y":192140,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130378,"y":253878,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79328,"y":70427,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403491,"y":401141,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406912,"y":394278,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411863,"y":397757,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":257580,"y":135714,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":321259,"y":594237,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":363964,"y":531639,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407928,"y":412400,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408541,"y":397308,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407837,"y":394335,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":358653,"y":370636,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":96070,"y":224648,"year":"2008","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":284301,"y":498876,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":275833,"y":489856,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":402589,"y":396043,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":18143,"y":131917,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241400,"y":130574,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":258546,"y":141370,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":140071,"y":224830,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":77861,"y":45586,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79906,"y":64896,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":181527,"y":86171,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406290,"y":395160,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79395,"y":69371,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":390747,"y":394982,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":44320,"y":215405,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":143879,"y":216527,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":273408,"y":218897,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":238980,"y":129741,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":263528,"y":331024,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":238427,"y":135155,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81684,"y":67711,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":99145,"y":128258,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":439018,"y":374874,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":147204,"y":102701,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":375344,"y":383177,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":87196,"y":68134,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":247977,"y":155200,"year":"2008","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":297337,"y":290988,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410768,"y":395896,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":352372,"y":615959,"year":"2008","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606099,"y":1119016,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599048,"y":1122709,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594514,"y":1147561,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608259,"y":1127774,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597886,"y":1133418,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589437,"y":1134024,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578650,"y":1217446,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":568680,"y":1289123,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597408,"y":1131875,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586189,"y":1187243,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438445,"y":1377740,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588442,"y":1128242,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588448,"y":1166890,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565589,"y":1224976,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535642,"y":1311659,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593687,"y":1140661,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524088,"y":1302924,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588071,"y":1130754,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591584,"y":1136197,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592147,"y":1130186,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":463140,"y":1305810,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":448727,"y":1322846,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":696267,"y":1066178,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":813255,"y":991911,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681173,"y":1007973,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":691536,"y":1094499,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":674293,"y":1075013,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714449,"y":1036603,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":731474,"y":1028161,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713331,"y":1034624,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":640395,"y":1031715,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":688936,"y":981512,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641399,"y":1006564,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":813143,"y":1000174,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625869,"y":958123,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626733,"y":1044842,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":698098,"y":1047027,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":695512,"y":1050521,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637264,"y":1031505,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":760704,"y":952778,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694590,"y":1050653,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593206,"y":1103218,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661372,"y":1113444,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588698,"y":1132424,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589977,"y":1169191,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604629,"y":1116253,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":542321,"y":1255450,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584766,"y":1088903,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666001,"y":1097361,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677343,"y":1071872,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":645032,"y":1036898,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632359,"y":1026495,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718645,"y":1038312,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721378,"y":1041202,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714331,"y":1036297,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718619,"y":991181,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":705677,"y":927500,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704273,"y":929801,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":706967,"y":1031594,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717240,"y":1035796,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687086,"y":959373,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":764522,"y":993834,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769861,"y":1000702,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":765661,"y":997858,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714434,"y":1042617,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635109,"y":1030605,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696686,"y":1056379,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716718,"y":1029451,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583223,"y":1142676,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":785659,"y":1008018,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597855,"y":1121839,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593370,"y":1140188,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596303,"y":1132846,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":620099,"y":1141846,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":616696,"y":1092345,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586414,"y":1134245,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583506,"y":1125584,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578742,"y":1138120,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583184,"y":1128804,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635260,"y":1032168,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588778,"y":1129896,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622347,"y":1142734,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":508079,"y":1245373,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636170,"y":1098372,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593635,"y":1148500,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575982,"y":1179736,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592939,"y":1192561,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":605250,"y":1120375,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608127,"y":1127318,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601620,"y":1121024,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556508,"y":1261485,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581743,"y":1136894,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":454290,"y":1348564,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593871,"y":1135815,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534587,"y":1300497,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717099,"y":1030246,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":738085,"y":1025017,"year":"2009","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":704361,"y":929823,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684936,"y":1109958,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602102,"y":1006378,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617081,"y":959100,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":648501,"y":1053122,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591648,"y":1128275,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574252,"y":1148622,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604939,"y":1099396,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555270,"y":1255491,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592780,"y":1142489,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":595715,"y":1195793,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586492,"y":1130608,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608515,"y":1127650,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":700080,"y":962586,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694354,"y":1086099,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":637781,"y":1031966,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615654,"y":1022566,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599292,"y":1029223,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677047,"y":1136474,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":717970,"y":1035729,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629312,"y":1042026,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518289,"y":1313254,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608514,"y":1114941,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":608510,"y":1123034,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581505,"y":1138869,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617692,"y":1094139,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590160,"y":1162925,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":555328,"y":1309642,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518932,"y":1320693,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520217,"y":1320949,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593440,"y":1144891,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":704240,"y":929748,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":604925,"y":1129602,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":568499,"y":1237736,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625791,"y":971467,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601268,"y":1127535,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":522086,"y":1307702,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":483560,"y":1334278,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610959,"y":1031997,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640840,"y":1116602,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":542098,"y":1312321,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":449373,"y":1323243,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627446,"y":1044109,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":529733,"y":892304,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":524755,"y":610609,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":621307,"y":703840,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623882,"y":662173,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":399016,"y":598680,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657744,"y":747346,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739357,"y":779544,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592868,"y":662131,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":900473,"y":998665,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599009,"y":652960,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640870,"y":766920,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622645,"y":723107,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":700866,"y":758707,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":770689,"y":839377,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":451029,"y":641506,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670314,"y":724116,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":549874,"y":843466,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604537,"y":798971,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626805,"y":662433,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641929,"y":661169,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584289,"y":638475,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593642,"y":650549,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597227,"y":653173,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":586734,"y":645209,"year":"2009","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":862977,"y":907773,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":870055,"y":926447,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591332,"y":661525,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589210,"y":648270,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":874155,"y":924658,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":436859,"y":664485,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604082,"y":658949,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595373,"y":650837,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602122,"y":656571,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601390,"y":653027,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661720,"y":679612,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":539970,"y":838138,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515689,"y":879848,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555376,"y":828186,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530319,"y":890422,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527281,"y":890163,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633402,"y":774244,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576145,"y":922699,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634775,"y":828574,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601812,"y":662006,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461010,"y":647163,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874364,"y":923745,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766837,"y":820292,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605405,"y":683285,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584580,"y":644161,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588203,"y":642109,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":678677,"y":705407,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":755185,"y":808805,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626369,"y":662777,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":818775,"y":886772,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611061,"y":794399,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":764501,"y":851733,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739664,"y":780155,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595662,"y":671426,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":640292,"y":907619,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":427652,"y":599424,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":818994,"y":893979,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518283,"y":601926,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700586,"y":760183,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661609,"y":745102,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":390309,"y":601020,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766100,"y":819595,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587370,"y":648853,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":407793,"y":397303,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":312946,"y":523457,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":40603,"y":159910,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":154884,"y":246100,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":165925,"y":385303,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":75792,"y":74474,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":142993,"y":234626,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244316,"y":134680,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":140787,"y":268657,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":290222,"y":515583,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":320527,"y":475974,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409344,"y":394223,"year":"2009","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":410588,"y":396614,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":335031,"y":599138,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95413,"y":221190,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387811,"y":523735,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":73061,"y":87815,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":417362,"y":392417,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":94197,"y":72287,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":411765,"y":397606,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":225102,"y":330572,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407809,"y":396246,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":505692,"y":538405,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":485468,"y":518083,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":402107,"y":420182,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":398783,"y":394570,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":240917,"y":131027,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":182619,"y":62761,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":182619,"y":62761,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":186709,"y":83148,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243044,"y":130861,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":269273,"y":226791,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":275347,"y":489610,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404575,"y":395442,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407812,"y":395815,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":404576,"y":395430,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":92966,"y":227743,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":237367,"y":129511,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410760,"y":395904,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":275870,"y":332657,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":205145,"y":312717,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405546,"y":394603,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243168,"y":133023,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":215022,"y":138979,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405778,"y":421694,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409710,"y":395108,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":234579,"y":340712,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":291611,"y":279509,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":295174,"y":288517,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405778,"y":397108,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":402888,"y":398534,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":97432,"y":220851,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":246344,"y":136502,"year":"2009","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244168,"y":132495,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408742,"y":395191,"year":"2009","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":809261,"y":1002615,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":723716,"y":1040582,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627845,"y":1054027,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":510393,"y":1237760,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587522,"y":1131864,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":596291,"y":1136035,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":470158,"y":1326631,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704176,"y":929175,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":704129,"y":954785,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704203,"y":931030,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":701553,"y":936704,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704464,"y":928968,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644893,"y":1087932,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":651446,"y":952054,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680583,"y":1021057,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":662130,"y":1046446,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637155,"y":1032010,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687486,"y":981725,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587880,"y":1162709,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535833,"y":1303413,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520990,"y":1317747,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":606816,"y":1134065,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":605812,"y":1119363,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597523,"y":1122038,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593764,"y":1136555,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594110,"y":1190910,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598483,"y":1122217,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":543186,"y":1269395,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576172,"y":1225120,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636711,"y":1120337,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606054,"y":1121910,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690053,"y":1102987,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537780,"y":1307740,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":448849,"y":1362186,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595558,"y":1133479,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":506995,"y":1237951,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637873,"y":1031835,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":662993,"y":1015156,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640074,"y":1030997,"year":"2010","vehicles":"Cyclist(s)+Pedestrian(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":691682,"y":1094801,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666541,"y":892238,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670448,"y":919548,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631732,"y":1022323,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607495,"y":1000866,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":810858,"y":1001545,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":815024,"y":1002007,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718452,"y":1044518,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634527,"y":1035298,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583701,"y":1132420,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594471,"y":1135929,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599093,"y":1136086,"year":"2010","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":614978,"y":1094633,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584767,"y":1146603,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590990,"y":1152921,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591508,"y":1143985,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692617,"y":1082293,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635455,"y":989603,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642765,"y":1061783,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625920,"y":1073210,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638038,"y":1034640,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":707071,"y":929515,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":730916,"y":965723,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":732204,"y":973438,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717393,"y":1036935,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":720111,"y":1035769,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714208,"y":1036027,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719389,"y":1044549,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":723248,"y":1039446,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612764,"y":1041782,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626734,"y":1055441,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630028,"y":1049693,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635771,"y":1029868,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670899,"y":1078667,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692147,"y":1019136,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694017,"y":1080989,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687570,"y":1106729,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":720712,"y":988665,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602546,"y":1120841,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592972,"y":1140583,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607269,"y":1131688,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":596452,"y":1122558,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583304,"y":1124093,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590770,"y":1144828,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595800,"y":1095380,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":431289,"y":1381268,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556729,"y":1265485,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615558,"y":1094131,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575339,"y":1179215,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":486045,"y":1342937,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595882,"y":1124541,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":489282,"y":1257513,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582013,"y":1199192,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596616,"y":1129737,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588527,"y":1132294,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":590387,"y":1132340,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599895,"y":1043364,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604399,"y":1104109,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525299,"y":1321591,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590705,"y":1145455,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":577465,"y":1146454,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599918,"y":1124534,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567641,"y":1210370,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":521567,"y":1315293,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600886,"y":1120627,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603548,"y":1126267,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602578,"y":1132611,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556546,"y":1164339,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":478247,"y":1343801,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690164,"y":1115446,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593769,"y":1130753,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584779,"y":1183714,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633945,"y":1035899,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":688254,"y":1020948,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501102,"y":1333877,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":400426,"y":598127,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603850,"y":686354,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":819137,"y":893778,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":669938,"y":723573,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594071,"y":665395,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460688,"y":646678,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874675,"y":924042,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":559884,"y":821995,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595490,"y":653859,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471389,"y":651972,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471731,"y":651858,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666476,"y":676790,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":660932,"y":746551,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874130,"y":924458,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":898692,"y":964373,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595144,"y":665819,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":483644,"y":655960,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773490,"y":837074,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":422011,"y":639369,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":859751,"y":901165,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517272,"y":620647,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":763864,"y":823980,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":772935,"y":834682,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":448978,"y":641591,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587294,"y":641068,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588067,"y":642855,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":658416,"y":677856,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773082,"y":861555,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602255,"y":657344,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874107,"y":924201,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":428092,"y":678727,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517254,"y":620559,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":861750,"y":947238,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530522,"y":595390,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650509,"y":672537,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412911,"y":607391,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591268,"y":659875,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516183,"y":619737,"year":"2010","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":591931,"y":663638,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461585,"y":646748,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":458273,"y":646269,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762020,"y":823429,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":616598,"y":697807,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537570,"y":895079,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520124,"y":886436,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628322,"y":713928,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634642,"y":837129,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627445,"y":712677,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":652808,"y":753022,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631368,"y":902492,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650374,"y":733049,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":545787,"y":832976,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649010,"y":670576,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":523648,"y":612964,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":653687,"y":757852,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":761705,"y":823929,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":873634,"y":926599,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588787,"y":639362,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":878233,"y":921584,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626956,"y":752320,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":362555,"y":532920,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":131929,"y":297926,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407308,"y":468056,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408926,"y":396306,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403251,"y":396117,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":286315,"y":475490,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":335923,"y":421028,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":369576,"y":380186,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":285287,"y":385276,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":131523,"y":221809,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408279,"y":389430,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":183611,"y":311150,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":225705,"y":332956,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":296804,"y":298517,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":462769,"y":492322,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":164271,"y":138191,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":248348,"y":132508,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":378435,"y":415468,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":152875,"y":131504,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":101285,"y":117587,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409021,"y":397665,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":234277,"y":133905,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":202761,"y":104788,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":185948,"y":90336,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403916,"y":404087,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":489393,"y":523291,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81592,"y":65444,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":307613,"y":336094,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":106423,"y":62663,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":127597,"y":105158,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":108143,"y":231250,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130790,"y":259551,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":523681,"y":568846,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":297803,"y":297048,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":179435,"y":89572,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":269413,"y":336570,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412863,"y":398091,"year":"2010","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":124060,"y":241887,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":76228,"y":96056,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":207244,"y":339422,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":109407,"y":78909,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":372852,"y":537295,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409671,"y":396069,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":437074,"y":374188,"year":"2010","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":416177,"y":432574,"year":"2010","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":790648,"y":1006605,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":783135,"y":1008604,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660419,"y":1145316,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726458,"y":990537,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642763,"y":1022012,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721727,"y":1040300,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":702050,"y":1025914,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687648,"y":1122517,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630626,"y":1095224,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606931,"y":1130447,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588445,"y":1167063,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579584,"y":1142404,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591744,"y":1131352,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595295,"y":1133847,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590393,"y":1134414,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556157,"y":1264320,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":652696,"y":1062399,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":614159,"y":1124669,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579787,"y":1140371,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588356,"y":1130858,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591793,"y":1143504,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596041,"y":1133224,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670082,"y":996690,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":647284,"y":1086478,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":765189,"y":1017068,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":760026,"y":993454,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582478,"y":1135802,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600889,"y":1128943,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605253,"y":1116513,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584893,"y":1132170,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588839,"y":1133011,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":588015,"y":1131843,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598555,"y":1132818,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":594566,"y":1136948,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595886,"y":1133408,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604637,"y":1120905,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590725,"y":1144947,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579635,"y":1141142,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606736,"y":1115727,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594272,"y":1142042,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597643,"y":1131694,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557034,"y":1263540,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":504763,"y":1292032,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608499,"y":1123821,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604296,"y":1122961,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":581632,"y":1137696,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582413,"y":1135208,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580390,"y":1132309,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585833,"y":1176985,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606301,"y":1128792,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588414,"y":1134023,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594398,"y":1136502,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580717,"y":1136265,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589352,"y":1186362,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593918,"y":1135874,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592746,"y":1138353,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592562,"y":1137984,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600282,"y":1136440,"year":"2011","vehicles":"Other","severity":"Minor Injury","color":"#ffa500"},{"x":594273,"y":1129744,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587771,"y":1128362,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":604789,"y":1120315,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":593687,"y":1142301,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582963,"y":1127000,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":597287,"y":1124850,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592663,"y":1145022,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591797,"y":1153232,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":566048,"y":1180556,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605370,"y":1116561,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534604,"y":1299330,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607607,"y":1127313,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604423,"y":1123047,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":635301,"y":1030570,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":669629,"y":1103853,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638733,"y":1031969,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":731989,"y":997618,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":720994,"y":987419,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":788260,"y":1007733,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":794033,"y":1004106,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687083,"y":1106529,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644893,"y":1087932,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675541,"y":1074112,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590935,"y":941087,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":691224,"y":1118498,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":651874,"y":1092901,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644898,"y":1087946,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630035,"y":1051353,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690819,"y":1071977,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681292,"y":1000677,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":704170,"y":930305,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":698264,"y":1046731,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716767,"y":1041387,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":698495,"y":969915,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719953,"y":1039452,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609366,"y":1027358,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":728309,"y":1031016,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718156,"y":1042548,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":721508,"y":1041265,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627349,"y":1054593,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":703609,"y":1042586,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689318,"y":1110992,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604608,"y":1120946,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":558992,"y":1167609,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602098,"y":1119789,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595950,"y":1128680,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606486,"y":1123482,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":592616,"y":1145108,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":580959,"y":1135248,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607293,"y":1133022,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594802,"y":1136586,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581444,"y":1190655,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591178,"y":1141574,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606200,"y":1121144,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592785,"y":1079008,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593930,"y":1135894,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597365,"y":1124301,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":600982,"y":1128998,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":619053,"y":1121409,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438095,"y":664726,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":769646,"y":835114,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":685053,"y":652355,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604060,"y":686978,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":623459,"y":662547,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":447014,"y":634783,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773234,"y":862378,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586008,"y":638673,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586272,"y":643174,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":523880,"y":614877,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585691,"y":643459,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656312,"y":746333,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":531183,"y":892686,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":770104,"y":822391,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":853684,"y":948943,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602631,"y":656944,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":452378,"y":639876,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":616640,"y":664966,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":517392,"y":617983,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596971,"y":652971,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603449,"y":656111,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874266,"y":924542,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773866,"y":832626,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773433,"y":827954,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":421406,"y":644104,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586263,"y":643350,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":587236,"y":640784,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588820,"y":638607,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774229,"y":837271,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":751016,"y":872807,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":709090,"y":686959,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":773490,"y":837074,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635293,"y":666472,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608807,"y":662012,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460692,"y":646783,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659830,"y":678494,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":420921,"y":693629,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615356,"y":670930,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595352,"y":663480,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771475,"y":836270,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532499,"y":589418,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766329,"y":821808,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":675066,"y":804685,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677399,"y":819554,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":553053,"y":860031,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536754,"y":895521,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":669636,"y":738083,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":531718,"y":892885,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633705,"y":797315,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670023,"y":737619,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656706,"y":746072,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":617889,"y":699829,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612068,"y":794051,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":588567,"y":649625,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532553,"y":893192,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610999,"y":689053,"year":"2011","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":669808,"y":751927,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":655629,"y":755914,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609343,"y":792722,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650401,"y":784201,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":540880,"y":889765,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":652712,"y":752908,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":563393,"y":901631,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596552,"y":643978,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":602713,"y":802778,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":544546,"y":891998,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591674,"y":660277,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639778,"y":856935,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":228863,"y":123498,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":44125,"y":222550,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137228,"y":222244,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":122359,"y":101877,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407326,"y":395569,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408056,"y":395695,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404548,"y":394901,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":361017,"y":356014,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":125813,"y":245152,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":224200,"y":323530,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243585,"y":331121,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":110241,"y":92703,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":235609,"y":262170,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409012,"y":398661,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119925,"y":348459,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":67106,"y":247209,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244770,"y":135310,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":93108,"y":219324,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130773,"y":259548,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":395245,"y":423755,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":226902,"y":128457,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387709,"y":521547,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408291,"y":397307,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405493,"y":400046,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":411942,"y":424500,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":419612,"y":449937,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":401726,"y":423055,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407034,"y":402483,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":247726,"y":452550,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406935,"y":397297,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414701,"y":388109,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119243,"y":233154,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":327784,"y":372295,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":242687,"y":130534,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":398855,"y":394748,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407681,"y":392114,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":402296,"y":395216,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404247,"y":392685,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":403993,"y":402742,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":417952,"y":385850,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405022,"y":396113,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":381360,"y":370711,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137010,"y":42023,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":105759,"y":68608,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":136683,"y":121828,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":194218,"y":85371,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":493243,"y":521524,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243216,"y":131946,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409021,"y":397645,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":294615,"y":300488,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412596,"y":397320,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":293526,"y":283936,"year":"2011","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406607,"y":403978,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":302509,"y":314565,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":155225,"y":246578,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":303843,"y":562060,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":310682,"y":366201,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":279187,"y":223443,"year":"2011","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415563,"y":397079,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":654898,"y":1087399,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638504,"y":1029677,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":743926,"y":893985,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641500,"y":1029767,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":626017,"y":968998,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641794,"y":1006234,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680348,"y":1028006,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638770,"y":1030567,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":682302,"y":1149786,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633446,"y":1074102,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700781,"y":1002237,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687385,"y":980165,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719679,"y":1044248,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":753577,"y":1022428,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715212,"y":1038386,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":708904,"y":937839,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692823,"y":1092812,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":588008,"y":1131610,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598313,"y":1123804,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":711654,"y":1031037,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595089,"y":1135878,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555400,"y":1259791,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593826,"y":1148253,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595230,"y":1131142,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":592566,"y":1144963,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600740,"y":1122727,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":597344,"y":1123889,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501366,"y":1291504,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589483,"y":1150280,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":440308,"y":1375331,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628248,"y":1056559,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575071,"y":1139037,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":483225,"y":1293679,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613334,"y":1129054,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":702515,"y":943965,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726298,"y":1038346,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":688173,"y":1111962,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633896,"y":1033528,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674564,"y":1134999,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638219,"y":1028731,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":655724,"y":1060010,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":665806,"y":1096925,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660762,"y":1107199,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672290,"y":1101518,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556224,"y":1262927,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593232,"y":1140547,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687099,"y":981752,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":687588,"y":981495,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":784784,"y":995625,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607565,"y":1086903,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612717,"y":1077002,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612045,"y":1125385,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":572812,"y":1201818,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593325,"y":1130729,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599139,"y":1123764,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613410,"y":1097620,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556304,"y":1265471,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":593912,"y":1130579,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605388,"y":1118461,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588627,"y":1128316,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581565,"y":1135804,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609445,"y":1131012,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602935,"y":1127696,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":616171,"y":1130105,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584847,"y":1135474,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704062,"y":1043853,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634755,"y":1032927,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":669010,"y":1099788,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689016,"y":1100926,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626853,"y":949869,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679445,"y":1071220,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687887,"y":1073752,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":738317,"y":1026339,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":673628,"y":864224,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":697234,"y":971308,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739028,"y":901591,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722347,"y":989793,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641452,"y":1030376,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729464,"y":1037221,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":718487,"y":1045662,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":614868,"y":1091873,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726497,"y":1038330,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":700271,"y":926720,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":716735,"y":1041687,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606224,"y":1130801,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":591175,"y":1161308,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587380,"y":1129175,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596778,"y":1131589,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":723140,"y":1031914,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":695486,"y":1060918,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592794,"y":1138441,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586234,"y":1154416,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554421,"y":1192106,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577381,"y":1143999,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":759391,"y":953413,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729610,"y":1037202,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601423,"y":1136215,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":586115,"y":1127986,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602152,"y":1130819,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":485207,"y":1343597,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612878,"y":1090432,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":610052,"y":1107408,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628652,"y":1094646,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589593,"y":1133723,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603923,"y":1124026,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":724892,"y":989136,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606635,"y":1105624,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":491758,"y":1309492,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590721,"y":1131444,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532185,"y":1320929,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":766057,"y":822168,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":754943,"y":869984,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591168,"y":657229,"year":"2012","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":599438,"y":652649,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":624324,"y":662029,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":384825,"y":589911,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587661,"y":641375,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613999,"y":797365,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555731,"y":898237,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":662147,"y":747227,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":422598,"y":589878,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767414,"y":832659,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631647,"y":717922,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595976,"y":671865,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537802,"y":894462,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657637,"y":743873,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586100,"y":642550,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":683219,"y":751190,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677836,"y":733997,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585905,"y":641650,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596816,"y":663758,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":801214,"y":880410,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":810901,"y":887296,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":526992,"y":600611,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594970,"y":664048,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":656690,"y":746097,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601008,"y":647821,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622681,"y":663611,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633338,"y":832153,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565668,"y":815266,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":680447,"y":813206,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613008,"y":795710,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625612,"y":734328,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630563,"y":716704,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":657866,"y":745126,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":900762,"y":954096,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643632,"y":870416,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638881,"y":755018,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":767178,"y":821131,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":665339,"y":698834,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":659643,"y":747746,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":456605,"y":642282,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":872112,"y":924031,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":625650,"y":607723,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":401204,"y":396622,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":24096,"y":137618,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405363,"y":398070,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":473360,"y":502953,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":131176,"y":257848,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":330096,"y":538283,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":458983,"y":484120,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":133831,"y":259625,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":186761,"y":65977,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241803,"y":435367,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":185788,"y":87315,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":189980,"y":72334,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":149072,"y":198973,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137911,"y":222192,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":324608,"y":380941,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":398914,"y":377382,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":124588,"y":103793,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":423967,"y":487698,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":73361,"y":245311,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":345574,"y":565612,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":343227,"y":552348,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":352666,"y":582139,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":138819,"y":225370,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":185360,"y":89645,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":474770,"y":506093,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81997,"y":65162,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":83457,"y":66736,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":137228,"y":222244,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":148976,"y":247983,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408059,"y":395187,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":319331,"y":467478,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":94778,"y":62268,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":133303,"y":369045,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413472,"y":401623,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":276386,"y":219658,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":271493,"y":309961,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":92863,"y":219275,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":325384,"y":345207,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":250169,"y":159993,"year":"2012","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":143000,"y":268766,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":287262,"y":240679,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404281,"y":393504,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":50196,"y":236827,"year":"2012","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":809261,"y":1002615,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":759262,"y":998371,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643011,"y":1061805,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676641,"y":1126867,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":646871,"y":1089676,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637068,"y":1030690,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696342,"y":1066150,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630393,"y":1091672,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460580,"y":1332722,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598071,"y":1122030,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589469,"y":1168982,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596126,"y":1128986,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612059,"y":1112802,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":609268,"y":1118183,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471908,"y":1283339,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606842,"y":1130762,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589415,"y":1141111,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":589882,"y":1150860,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":521929,"y":1314470,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654542,"y":1128327,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":560518,"y":1257622,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471780,"y":1301113,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":772918,"y":835415,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768704,"y":824381,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585922,"y":638554,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611391,"y":794468,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":595619,"y":652063,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587026,"y":646599,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593601,"y":650861,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":874922,"y":924298,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":647921,"y":768974,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516433,"y":620236,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":391524,"y":601044,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":285713,"y":235419,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":189211,"y":81658,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243511,"y":132610,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":130930,"y":259387,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412371,"y":397186,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79614,"y":65664,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":99429,"y":61659,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412646,"y":402987,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":246724,"y":132420,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":416482,"y":394971,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":76660,"y":69265,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407479,"y":399325,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":332359,"y":351448,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243538,"y":133934,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244263,"y":134531,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241964,"y":133886,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":154554,"y":199099,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":170746,"y":273344,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":79637,"y":65017,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":54780,"y":158164,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719733,"y":1042480,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415571,"y":699381,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600329,"y":648538,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":776893,"y":823455,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769408,"y":833968,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608264,"y":660808,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596879,"y":652121,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605172,"y":952284,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671659,"y":1013146,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585894,"y":1089450,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":107000,"y":93132,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601553,"y":1107600,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641060,"y":723599,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":523309,"y":613888,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606674,"y":1135409,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593966,"y":1160627,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":574705,"y":1196316,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602042,"y":1119356,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581148,"y":1137688,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":251034,"y":132218,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589858,"y":1134276,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":711517,"y":1036865,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608762,"y":1130391,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593640,"y":1144391,"year":"2013","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":633648,"y":1043009,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638692,"y":1032057,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":783135,"y":1008603,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":839882,"y":1013811,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718088,"y":1037431,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":632633,"y":1075933,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":722151,"y":990243,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":506559,"y":1307175,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":783135,"y":1008603,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460740,"y":1330867,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":555289,"y":1250750,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":564953,"y":1226802,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583640,"y":1125924,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604138,"y":1119735,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604918,"y":1102720,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603827,"y":1123814,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":574762,"y":1139760,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606667,"y":1130657,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604865,"y":1123742,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576366,"y":1199329,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605327,"y":1123871,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":705687,"y":927438,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":103417,"y":225450,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":95050,"y":220153,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":473203,"y":502943,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243810,"y":132899,"year":"2013","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":689483,"y":1073371,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":650895,"y":1027697,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":521408,"y":854586,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":75412,"y":63214,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":703767,"y":931949,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714026,"y":1033549,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407870,"y":395573,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409452,"y":382863,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599291,"y":1124502,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405873,"y":410139,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676054,"y":805774,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":873634,"y":926599,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596372,"y":1100264,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":301259,"y":516327,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590969,"y":1133059,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595290,"y":1125442,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598700,"y":1122955,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582413,"y":1135208,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658370,"y":1058165,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":296896,"y":300289,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":374241,"y":398971,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594396,"y":661909,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":414451,"y":400569,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586222,"y":645666,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":485920,"y":651329,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":512401,"y":1281166,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674040,"y":1020011,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534372,"y":837412,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598337,"y":647689,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":507723,"y":1307386,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":496501,"y":1291926,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":437877,"y":674456,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600851,"y":1123778,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":339902,"y":417726,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579296,"y":1134051,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":536780,"y":1305625,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625219,"y":1104836,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":299215,"y":551054,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":743759,"y":1021054,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":535274,"y":855208,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":371471,"y":590103,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":738691,"y":814785,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608060,"y":1129784,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":456047,"y":641819,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":373342,"y":586198,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595316,"y":1134452,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":859714,"y":901153,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":861422,"y":946320,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595336,"y":1134446,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81844,"y":66495,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":662002,"y":742822,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589772,"y":1134061,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":733913,"y":1027266,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592203,"y":1134485,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598428,"y":1136093,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588608,"y":640230,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585704,"y":639573,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591691,"y":1146880,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584827,"y":1178963,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459956,"y":645142,"year":"2013","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":658958,"y":746410,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576354,"y":1193968,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119297,"y":93811,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501151,"y":634586,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":492054,"y":1309833,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605992,"y":1120165,"year":"2013","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":814792,"y":1001809,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":560206,"y":1221303,"year":"2013","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":126838,"y":223685,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405903,"y":400632,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":278109,"y":222331,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694309,"y":1077772,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":627639,"y":1068670,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649396,"y":769581,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243223,"y":131334,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":847477,"y":883779,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":479698,"y":1343331,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593700,"y":1130843,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634650,"y":1033035,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":714678,"y":1039210,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":239696,"y":129972,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":295858,"y":299303,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":654802,"y":1019190,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":744658,"y":893179,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565833,"y":1220348,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":726586,"y":1038318,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609475,"y":793533,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":573367,"y":1272057,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578981,"y":1216970,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":608887,"y":1115063,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":653328,"y":681319,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601718,"y":1030358,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408168,"y":412330,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602536,"y":1121749,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":405750,"y":421689,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":247959,"y":151083,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":763191,"y":810996,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":501666,"y":643473,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589959,"y":653101,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567093,"y":1183905,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":133190,"y":262157,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":206644,"y":110121,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586304,"y":642784,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":728493,"y":1037866,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":392362,"y":500777,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412100,"y":397061,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403244,"y":402081,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406089,"y":391377,"year":"2014","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":604601,"y":1120956,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":724195,"y":978463,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640320,"y":907228,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":539089,"y":877857,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596133,"y":1127415,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607062,"y":1115405,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601373,"y":1096993,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586991,"y":1128321,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":700343,"y":927165,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714616,"y":1041785,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771634,"y":831659,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":743474,"y":787328,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613307,"y":663045,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":711582,"y":782981,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":614446,"y":1122177,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":171139,"y":273612,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":83409,"y":58186,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":122230,"y":93598,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":181559,"y":65924,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594539,"y":1136876,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597615,"y":1131295,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":33058,"y":99200,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592901,"y":1144581,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":120395,"y":236490,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766544,"y":821327,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661471,"y":1016515,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594649,"y":660510,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586192,"y":643405,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":315759,"y":339907,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":694939,"y":663526,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":148039,"y":205815,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638692,"y":1032057,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":630052,"y":1023680,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661779,"y":678695,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597590,"y":1129314,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":607693,"y":1125752,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605773,"y":1098617,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600717,"y":1135051,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590200,"y":1144681,"year":"2014","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":594605,"y":1136619,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":851792,"y":891673,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671376,"y":752485,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714042,"y":1042190,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569098,"y":1231786,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80669,"y":66111,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":652179,"y":1087297,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626629,"y":1055301,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":673201,"y":1076273,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":654313,"y":1016728,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626828,"y":955357,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766895,"y":821261,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":243947,"y":184764,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387036,"y":418516,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":385941,"y":524560,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80885,"y":147911,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716186,"y":1037218,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":616220,"y":697218,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606856,"y":1123184,"year":"2014","vehicles":"Vehicle(s)+multiple other types","severity":"Minor Injury","color":"#ffa500"},{"x":586942,"y":646996,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629388,"y":944769,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":619045,"y":978331,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407285,"y":468409,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":360394,"y":533507,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":418626,"y":1397881,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":549698,"y":1165495,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594330,"y":1136316,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":234223,"y":208449,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594366,"y":806533,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":629103,"y":714854,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":604138,"y":1119735,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636149,"y":1031204,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":562134,"y":1223674,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607061,"y":1115373,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412903,"y":393310,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408547,"y":387919,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":406937,"y":390985,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":494004,"y":1341396,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605810,"y":1131788,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":266441,"y":333245,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":693765,"y":1080481,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592823,"y":1136639,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":527571,"y":1299331,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":649193,"y":1025618,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":312233,"y":577894,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":486840,"y":1317389,"year":"2014","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612948,"y":796505,"year":"2014","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606225,"y":1094872,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":613218,"y":1104417,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592921,"y":1152118,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":202005,"y":103731,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":185304,"y":84310,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":139706,"y":221770,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":23252,"y":165636,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677955,"y":897584,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633454,"y":909767,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":674399,"y":829769,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762920,"y":776554,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404819,"y":401351,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":528615,"y":892052,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":142130,"y":269666,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597256,"y":653140,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576064,"y":1214292,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584717,"y":1144088,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675530,"y":1061438,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":241463,"y":129868,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":756978,"y":769694,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":131068,"y":259506,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713820,"y":1035427,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599282,"y":1131412,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":608456,"y":1114021,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":594479,"y":1132981,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600915,"y":1129594,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607050,"y":1115316,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":682327,"y":803787,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":564256,"y":1158936,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576202,"y":1144772,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":645387,"y":652628,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":849370,"y":885796,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":824047,"y":886866,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":398246,"y":599120,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":289271,"y":494585,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":456845,"y":1342637,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594621,"y":1137110,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":578980,"y":1222685,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":756345,"y":1021544,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":788494,"y":1008163,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":813384,"y":1000619,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516483,"y":1238926,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584007,"y":1158870,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586547,"y":643089,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":296960,"y":300338,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":402275,"y":396173,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":399513,"y":397317,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668243,"y":747040,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":105263,"y":224291,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":413787,"y":400173,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":595344,"y":1129453,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593424,"y":1140303,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":397836,"y":399039,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":259848,"y":334364,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768002,"y":973912,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":202446,"y":104333,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":717671,"y":1045861,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":763044,"y":1018110,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":403863,"y":421575,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599662,"y":1128792,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":600308,"y":1123947,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601960,"y":1126012,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":653796,"y":1131881,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":433790,"y":522053,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":446687,"y":643702,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609607,"y":1089145,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599917,"y":1136816,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":691140,"y":1092749,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594122,"y":1135281,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554592,"y":1271273,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":530600,"y":1221960,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":769569,"y":818012,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244368,"y":133375,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":509810,"y":1330663,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":455979,"y":1341751,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593627,"y":1140553,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605736,"y":1130468,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":131704,"y":260166,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":786361,"y":1006049,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":685070,"y":990999,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575239,"y":1274082,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716699,"y":996310,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":787007,"y":1007189,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":683471,"y":997162,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":564814,"y":1228146,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":712843,"y":1039338,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":752058,"y":813002,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600831,"y":644772,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516840,"y":619620,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":602977,"y":647815,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":614806,"y":664428,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":182916,"y":79838,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":135669,"y":257324,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":114927,"y":223629,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597897,"y":1130818,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603330,"y":1103595,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520940,"y":1319068,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":495777,"y":1291566,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554727,"y":1285656,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":219500,"y":107329,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":82866,"y":64077,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592378,"y":1092328,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":596789,"y":1122358,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605531,"y":1117840,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578053,"y":1216589,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593644,"y":1143033,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639586,"y":1032581,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":82004,"y":64174,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":157794,"y":93147,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713863,"y":1026730,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587880,"y":1162709,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592367,"y":1145508,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592057,"y":1134629,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579529,"y":1212930,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600358,"y":1127878,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":738314,"y":778202,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":100722,"y":222437,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":674630,"y":1077053,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":647635,"y":1085690,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687264,"y":1148555,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690101,"y":1103075,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704449,"y":924875,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":684868,"y":1006432,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":519321,"y":876235,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":687066,"y":1072976,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684055,"y":1026169,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637403,"y":758493,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515104,"y":861083,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":428627,"y":370145,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":292528,"y":483750,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612865,"y":791657,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598455,"y":1130485,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":322522,"y":342924,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408544,"y":395577,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460706,"y":647175,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586359,"y":640947,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":872208,"y":926020,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":870103,"y":924110,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":225676,"y":332892,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":412487,"y":406966,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":244137,"y":133462,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713370,"y":777223,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":277672,"y":220681,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615277,"y":677294,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":119448,"y":109998,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":94785,"y":73299,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677176,"y":820363,"year":"2015","vehicles":"Other","severity":"Minor Injury","color":"#ffa500"},{"x":664277,"y":750265,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660894,"y":761423,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692607,"y":1108188,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":635072,"y":1035985,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":685222,"y":1106675,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":455142,"y":1349568,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586717,"y":646141,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":670857,"y":751495,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":645799,"y":1035870,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":629880,"y":1012339,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":633845,"y":1033535,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516023,"y":618428,"year":"2015","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":395714,"y":393962,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588174,"y":1090742,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":386390,"y":397550,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":630548,"y":716748,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":335269,"y":359310,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":51521,"y":251952,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":653890,"y":744584,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":416103,"y":385808,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":729527,"y":996381,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611403,"y":794483,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":385941,"y":524560,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":457497,"y":644074,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567072,"y":1177402,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":320915,"y":592494,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":117093,"y":225870,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":745388,"y":788227,"year":"2015","vehicles":"Cyclists only","severity":"Minor Injury","color":"#ffa500"},{"x":691683,"y":1067960,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":562653,"y":1246779,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590259,"y":1153340,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634492,"y":1033285,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593852,"y":1140899,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696675,"y":1021502,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":458163,"y":646062,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":438114,"y":665209,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593575,"y":1143174,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677310,"y":678188,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516913,"y":619843,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595330,"y":1121942,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":57990,"y":79444,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589356,"y":648339,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":797883,"y":998759,"year":"2015","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592171,"y":1145404,"year":"2015","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579437,"y":1142730,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":707014,"y":936511,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":852363,"y":893849,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595311,"y":1136873,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":253979,"y":141818,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766674,"y":824882,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":232255,"y":130745,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591428,"y":1129398,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":905353,"y":1011384,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576932,"y":1146398,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":704136,"y":1027150,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":138621,"y":267002,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":733150,"y":1003940,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":149590,"y":163717,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583938,"y":1133611,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":87601,"y":69196,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":264233,"y":470102,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":713740,"y":1019632,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592028,"y":1134780,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":763502,"y":853591,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534585,"y":1299394,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":516346,"y":881499,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":120645,"y":237034,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":666775,"y":994795,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":641623,"y":1008360,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":684152,"y":1127279,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":635385,"y":954619,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":399355,"y":396079,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590672,"y":655347,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583080,"y":934359,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":864322,"y":912989,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":27161,"y":177023,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":401744,"y":388623,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590923,"y":1142160,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605713,"y":684339,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603975,"y":1123006,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":805974,"y":1002330,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601514,"y":654572,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717732,"y":1037065,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":844058,"y":884262,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":182261,"y":67177,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":191161,"y":71155,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":587692,"y":651832,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":661867,"y":679939,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":626713,"y":662630,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":725131,"y":1037717,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520934,"y":626698,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":593850,"y":1135929,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":446017,"y":1367008,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":844609,"y":947504,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":579917,"y":1134605,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":414232,"y":398387,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":657369,"y":745540,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":676619,"y":1072258,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":342939,"y":396698,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642984,"y":1002712,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":692757,"y":1005978,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":644052,"y":730597,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":583337,"y":1131719,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":183341,"y":75725,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":883561,"y":1045766,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":675489,"y":805272,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594936,"y":669801,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":565734,"y":1220682,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585399,"y":1177127,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":534524,"y":1299827,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461564,"y":1329918,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595067,"y":661636,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595607,"y":1133506,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625778,"y":1071188,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643081,"y":1028603,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":643410,"y":1061615,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637001,"y":1090282,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598920,"y":1122586,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":686484,"y":1124581,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":639118,"y":1029204,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588574,"y":1166507,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":243722,"y":130611,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":46039,"y":230380,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611179,"y":792227,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592670,"y":1134660,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":558745,"y":1267280,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":297613,"y":299262,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":772616,"y":837031,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":586187,"y":1187164,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":229013,"y":133286,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":256280,"y":138603,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591008,"y":1133091,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557881,"y":898560,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668827,"y":958504,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":708149,"y":937260,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":298849,"y":313275,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":720254,"y":991449,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591485,"y":1191777,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636433,"y":1031771,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532863,"y":892982,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628947,"y":722915,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":286855,"y":255698,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":377338,"y":366894,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":407812,"y":395785,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":711613,"y":1035164,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":682643,"y":947591,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607047,"y":688143,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715640,"y":1042006,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603572,"y":1122817,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":139706,"y":221770,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":335093,"y":352754,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":703667,"y":930257,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":739858,"y":1021751,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":533528,"y":886392,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":660241,"y":744794,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576562,"y":1196936,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":573979,"y":1198042,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556692,"y":1289572,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":772616,"y":837031,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":644690,"y":733269,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":84920,"y":95184,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":408137,"y":388792,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607060,"y":1115276,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":638019,"y":763088,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774042,"y":835482,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630582,"y":716728,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589221,"y":651974,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":631992,"y":1064439,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":637325,"y":819466,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":768083,"y":823911,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606353,"y":1117592,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":342939,"y":396698,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":576650,"y":1135215,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":555214,"y":1250820,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":567046,"y":1177326,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":672185,"y":1101041,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":715231,"y":1039123,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":515476,"y":1236071,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":569434,"y":1257140,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80881,"y":147872,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604119,"y":901644,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":658738,"y":744889,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":232927,"y":134838,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":344499,"y":388368,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":493203,"y":653622,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":518751,"y":1229706,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":171671,"y":387379,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":573864,"y":1272333,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":537312,"y":1289767,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":266014,"y":181934,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":557328,"y":898595,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":121013,"y":76728,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":124639,"y":77150,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":472131,"y":1326443,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":716473,"y":1040721,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":771009,"y":820221,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":139080,"y":272851,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":628192,"y":1058126,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604275,"y":1136399,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599595,"y":1124462,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":405579,"y":400170,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":718610,"y":1044768,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":609334,"y":1118469,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":540999,"y":881324,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":575530,"y":1135697,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":297411,"y":514287,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":729625,"y":1027690,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":521379,"y":1246277,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605167,"y":1116898,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597604,"y":1123057,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605421,"y":684184,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":337167,"y":353571,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":696334,"y":1063559,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598612,"y":1130252,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":718296,"y":1045105,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":407818,"y":394646,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":249055,"y":132646,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":766290,"y":821858,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":856587,"y":898877,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582862,"y":1131517,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":582234,"y":1133770,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459881,"y":646316,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":410747,"y":398757,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":595866,"y":1124566,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":640257,"y":765895,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":712389,"y":1035018,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":605296,"y":817886,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584748,"y":637113,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679844,"y":1022950,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":415771,"y":447527,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":634850,"y":1030532,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625944,"y":971330,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606211,"y":1127550,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":606918,"y":1130399,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":774579,"y":822329,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460018,"y":647380,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":671659,"y":1013146,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":357405,"y":588251,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601114,"y":1131230,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":526622,"y":890205,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":703733,"y":930207,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":48894,"y":233032,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601954,"y":1119725,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":457096,"y":1306506,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":601167,"y":1125988,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605625,"y":1120490,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":842807,"y":1018945,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81250,"y":66277,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":590373,"y":1149529,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636470,"y":1027342,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":874269,"y":924539,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":246565,"y":249329,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":889973,"y":937813,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":730741,"y":1028624,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":514102,"y":863929,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":425896,"y":624282,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636784,"y":1031691,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":872364,"y":926425,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":525844,"y":1215147,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":690615,"y":1116708,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":247773,"y":249130,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":817445,"y":885592,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":598498,"y":1130436,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":445300,"y":642739,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":615751,"y":1093943,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":589040,"y":1150685,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":612885,"y":691544,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592661,"y":1145119,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":341939,"y":561011,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588477,"y":1132139,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597324,"y":1132007,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":520940,"y":1319068,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":592452,"y":1131684,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":853349,"y":895426,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586136,"y":638318,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387719,"y":521765,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":554925,"y":1254642,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607131,"y":687863,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":683496,"y":1007027,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597966,"y":1122397,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":604451,"y":1120297,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":81997,"y":214492,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":387046,"y":594413,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602596,"y":657758,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":449333,"y":1323236,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":762051,"y":992035,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":232616,"y":134700,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":773490,"y":837074,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":677093,"y":1126101,"year":"2016","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":717971,"y":1045359,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":645280,"y":780706,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":636445,"y":1033392,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607033,"y":1130794,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":607063,"y":1115537,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":603083,"y":1123222,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594560,"y":1136440,"year":"2016","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":80690,"y":63933,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":532359,"y":893122,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577634,"y":1138643,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":460279,"y":646911,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":461189,"y":646462,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":714840,"y":1042507,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":611365,"y":1105024,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":755215,"y":864866,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":773568,"y":837217,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":688933,"y":905109,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":708707,"y":937642,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":594431,"y":1159844,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":853291,"y":895481,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":681147,"y":1001002,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":733619,"y":845631,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":171927,"y":275688,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577306,"y":1144217,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":417010,"y":697907,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":164089,"y":119251,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":614911,"y":1110704,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":599442,"y":1123081,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":409699,"y":396811,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":404730,"y":403710,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":622853,"y":663168,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":719532,"y":989823,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":668789,"y":997654,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":497677,"y":1291606,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":736656,"y":1026563,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":630501,"y":986381,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":597840,"y":1122290,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":685792,"y":979834,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":605957,"y":1121446,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":825404,"y":886753,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":735094,"y":774026,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586737,"y":1127534,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":133226,"y":92049,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":136326,"y":92172,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591509,"y":1143985,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":602849,"y":1115773,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591226,"y":654867,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":600428,"y":1123985,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":477582,"y":1328607,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625766,"y":662456,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":642498,"y":998893,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":459855,"y":1340067,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":578010,"y":1144533,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":679472,"y":882601,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585397,"y":1177147,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577819,"y":1127373,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588812,"y":1134092,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":156399,"y":84428,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":585526,"y":1198903,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":350998,"y":416732,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":426454,"y":693873,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":609732,"y":1112402,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588759,"y":640762,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Minor Injury","color":"#ffa500"},{"x":774188,"y":830244,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":581659,"y":643979,"year":"2017","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":711171,"y":997618,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":588615,"y":640551,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":471350,"y":1348354,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":673661,"y":864279,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":584106,"y":1188403,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":689429,"y":1092648,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":721715,"y":989178,"year":"2017","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Minor Injury","color":"#ffa500"},{"x":671618,"y":1100719,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":416726,"y":434389,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":732981,"y":1035477,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":850658,"y":882211,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":556616,"y":860933,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":625509,"y":1096298,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":467399,"y":655666,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":577864,"y":1127408,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":582687,"y":1141722,"year":"2017","vehicles":"Single vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":591897,"y":1131785,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":586056,"y":644905,"year":"2017","vehicles":"Multi vehicle","severity":"Minor Injury","color":"#ffa500"},{"x":620612,"y":1131599,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":592073,"y":1132419,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":643079,"y":1002256,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":432642,"y":672884,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":539512,"y":1288856,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":585808,"y":1176406,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":554001,"y":1253907,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":653023,"y":1023338,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":620053,"y":702740,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":619259,"y":1095074,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":414399,"y":392783,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":580869,"y":1138043,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671072,"y":1100362,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603196,"y":1116510,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":403265,"y":398970,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602342,"y":1126810,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":560809,"y":1278522,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":766935,"y":820404,"year":"2017","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":670053,"y":852218,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":350360,"y":581623,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408672,"y":408529,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":366065,"y":378320,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":122802,"y":240759,"year":"2015","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":530450,"y":850557,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":685236,"y":748546,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":556142,"y":826099,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":315370,"y":498451,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":369134,"y":379951,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":756615,"y":827096,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":578016,"y":1144514,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":638378,"y":1032741,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":452563,"y":1327192,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":566520,"y":1277257,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":813594,"y":972267,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":569904,"y":1160627,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":696213,"y":707038,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":404787,"y":469240,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":581947,"y":1133959,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":619573,"y":1027175,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":775644,"y":1001626,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":771721,"y":857219,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625264,"y":1021150,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":512749,"y":1282752,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":479363,"y":510434,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":405054,"y":418383,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":400375,"y":399912,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":459498,"y":480469,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":621494,"y":803492,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":719768,"y":1042467,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":712426,"y":1035012,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":275950,"y":219717,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":540238,"y":1189472,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":160607,"y":257101,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":248061,"y":147269,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":217461,"y":272091,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":181216,"y":89521,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":714461,"y":1038505,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":561825,"y":900250,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":757073,"y":997638,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":597731,"y":979926,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":405312,"y":394888,"year":"2014","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":542856,"y":853962,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":578789,"y":1134268,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":820601,"y":885996,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":717473,"y":941767,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":778672,"y":821407,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773168,"y":836215,"year":"2014","vehicles":"Vehicle(s)+multiple other types","severity":"Serious Injury","color":"#de3f53"},{"x":595937,"y":1127787,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":121585,"y":261488,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":315504,"y":383524,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":374197,"y":557207,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":258163,"y":233090,"year":"2014","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":757011,"y":860326,"year":"2014","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":525567,"y":661734,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":135275,"y":261563,"year":"2014","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":702573,"y":762913,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":564713,"y":1230593,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":564979,"y":1223258,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":611805,"y":693343,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598184,"y":651770,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":782216,"y":1007177,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":416351,"y":435524,"year":"2013","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":597073,"y":1124663,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":564461,"y":1202725,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":690414,"y":1115672,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":163002,"y":111397,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":538983,"y":839261,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":608916,"y":1126904,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":384874,"y":388243,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":515039,"y":1228557,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":212938,"y":302521,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":609787,"y":915632,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":301081,"y":338612,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":690147,"y":1119694,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":634945,"y":828368,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":721597,"y":985811,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":729089,"y":962091,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":739924,"y":965083,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586406,"y":640743,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":582413,"y":1135208,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407812,"y":395744,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":383917,"y":413602,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":402037,"y":391866,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":599128,"y":653978,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593615,"y":663497,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":770689,"y":839377,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":654432,"y":669962,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":485426,"y":517377,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":96179,"y":225492,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242412,"y":128623,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":492794,"y":526597,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":75645,"y":232201,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":777898,"y":801746,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":549376,"y":853147,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":521989,"y":1314476,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":609940,"y":1123399,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593552,"y":1091579,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":591760,"y":1134350,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592937,"y":1141630,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":555515,"y":1258908,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":699741,"y":966497,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":688379,"y":904841,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":763529,"y":995020,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":734073,"y":1029871,"year":"2013","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":739444,"y":965548,"year":"2013","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408303,"y":395188,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407209,"y":467421,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":400340,"y":386035,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":223336,"y":126134,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":67271,"y":100211,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":135751,"y":92066,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":172231,"y":64735,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242907,"y":330948,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":406880,"y":380091,"year":"2012","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":84986,"y":95163,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":157949,"y":151892,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":533501,"y":893336,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":594719,"y":651603,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":611454,"y":794545,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773639,"y":824547,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575271,"y":918948,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":820427,"y":885645,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602599,"y":657711,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":356199,"y":587867,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":464313,"y":654596,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":704483,"y":841096,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":458623,"y":643488,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":633357,"y":774264,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":902789,"y":1004321,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":655931,"y":749664,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":457635,"y":645810,"year":"2012","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":596970,"y":662436,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":687569,"y":981488,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":515859,"y":1223200,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575977,"y":1194442,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":614903,"y":1132090,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":687019,"y":1110267,"year":"2012","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":629075,"y":996334,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":641541,"y":1042879,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":690422,"y":1097478,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":882378,"y":1045506,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":641908,"y":1006835,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":647393,"y":1086200,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":667739,"y":1050163,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":535260,"y":1252272,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":645504,"y":762748,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":243969,"y":135603,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":630569,"y":716712,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":534778,"y":892734,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598152,"y":663440,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":447792,"y":633921,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773283,"y":833425,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":587294,"y":641068,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":544730,"y":835877,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":629058,"y":722750,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603090,"y":1094599,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658094,"y":1052819,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586016,"y":808012,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625784,"y":782121,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":756546,"y":786489,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":612378,"y":796080,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":772792,"y":866568,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":537454,"y":1242576,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":452432,"y":639587,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":377048,"y":589968,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":661546,"y":748039,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":98826,"y":177329,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":447880,"y":636144,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":661229,"y":746700,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":642713,"y":761611,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":544060,"y":899462,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":613950,"y":796836,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":538130,"y":851176,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":657815,"y":911381,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":160887,"y":254968,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":145480,"y":234103,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":851907,"y":890882,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":644423,"y":727571,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":618229,"y":633551,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586122,"y":643571,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":588781,"y":649901,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":617366,"y":665215,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":895788,"y":944977,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":483644,"y":655960,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586459,"y":644860,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":802050,"y":880869,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":674197,"y":827129,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":590297,"y":1132884,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":662266,"y":1104037,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":640756,"y":1018581,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":557665,"y":1265535,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":587350,"y":1149951,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":595282,"y":1131506,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":572798,"y":1201900,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":392203,"y":392217,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596106,"y":1120321,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":811976,"y":1000638,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":615824,"y":1129621,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":601081,"y":1124915,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":292385,"y":310538,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":241262,"y":362938,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":690101,"y":1103075,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":693947,"y":1019476,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":566613,"y":1214171,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599284,"y":1029219,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":573915,"y":1160488,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":597884,"y":1129104,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588449,"y":1171582,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":704208,"y":929634,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":578350,"y":1192137,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":574252,"y":1148622,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596022,"y":1196052,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":475740,"y":1341463,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":637908,"y":1029042,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":636545,"y":953379,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658639,"y":1054784,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":434452,"y":1381598,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625937,"y":1040214,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":715328,"y":979091,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":402822,"y":399397,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":651383,"y":1078447,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":581564,"y":1148068,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":718464,"y":998474,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":718445,"y":1044568,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":623209,"y":1095025,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":731527,"y":1027024,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":721763,"y":1040458,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":585594,"y":1177330,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588430,"y":1167017,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":606161,"y":1118649,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":591454,"y":1149990,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":610661,"y":1121412,"year":"2017","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":800294,"y":997715,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":589792,"y":1128542,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":608696,"y":1111061,"year":"2017","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408192,"y":395682,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":821688,"y":887473,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671366,"y":831197,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":438048,"y":665042,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":575837,"y":912472,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":436583,"y":659343,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":637596,"y":1035190,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607421,"y":687678,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":638088,"y":1035346,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":636968,"y":1030496,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":758796,"y":837074,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":624108,"y":705963,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773525,"y":834536,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588319,"y":1148149,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407515,"y":604390,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":445403,"y":642679,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598451,"y":1132732,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593532,"y":1079651,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":472320,"y":1358156,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":584390,"y":1135716,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":566596,"y":1233573,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":539314,"y":1313187,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":714222,"y":1038494,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":438181,"y":667061,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":544661,"y":1180774,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":841310,"y":1014814,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604967,"y":1120870,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":696824,"y":1021508,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":643504,"y":1087662,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":634954,"y":1032707,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592350,"y":1145999,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":595823,"y":1142229,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":686998,"y":1007359,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":530271,"y":891914,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":222382,"y":421083,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":677534,"y":897924,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":629882,"y":1012329,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":714757,"y":923069,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":722374,"y":1040011,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":778046,"y":1003390,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716157,"y":1037013,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":592807,"y":1142490,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":543458,"y":1286953,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":743265,"y":974332,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":682733,"y":946210,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":253554,"y":163714,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":601006,"y":1125472,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":771804,"y":834356,"year":"2016","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":590635,"y":655918,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":567001,"y":1213110,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":715998,"y":1037741,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":634421,"y":988428,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":576472,"y":1193697,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":86418,"y":160083,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":81901,"y":134548,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":194376,"y":285170,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":310658,"y":366256,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592388,"y":1130270,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":402847,"y":398560,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":52847,"y":70051,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":305881,"y":334733,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":335065,"y":358588,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":241123,"y":129080,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586852,"y":1153693,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":635005,"y":1121009,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":121540,"y":115592,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":256614,"y":464325,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":402585,"y":397721,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":769097,"y":817886,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":411831,"y":397003,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":272231,"y":222214,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":391144,"y":387122,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598219,"y":1131118,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626097,"y":1058372,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":27369,"y":176239,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":331846,"y":582129,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":78587,"y":106383,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242167,"y":134657,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":727885,"y":768459,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":585851,"y":1131029,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":589166,"y":648645,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":624450,"y":782842,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":636363,"y":825387,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":547233,"y":832854,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":652993,"y":674774,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":534155,"y":839683,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":474033,"y":658105,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":591138,"y":655581,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":634526,"y":845652,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":543580,"y":840479,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":657176,"y":738648,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":864654,"y":940737,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":539046,"y":833688,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":610031,"y":793832,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596622,"y":806461,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":646772,"y":737125,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":437145,"y":655028,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":825837,"y":886902,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":756526,"y":862280,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":610424,"y":688031,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":760550,"y":826334,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":632456,"y":1027857,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":411284,"y":724324,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":582904,"y":1133246,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":856345,"y":1035489,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":152190,"y":196498,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":507996,"y":1307265,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":616041,"y":1129915,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":660762,"y":1046136,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":589144,"y":1189672,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605583,"y":1124848,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":744466,"y":1024252,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607464,"y":1118844,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":709912,"y":1039050,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":416106,"y":1394704,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":642540,"y":1027953,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603045,"y":1132089,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":416817,"y":432797,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":394304,"y":434389,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":714612,"y":1039233,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":556458,"y":1303161,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":742768,"y":896668,"year":"2001","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":568614,"y":1142318,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":700234,"y":761522,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604084,"y":687278,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":594323,"y":1136297,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":641301,"y":1006734,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607264,"y":1121296,"year":"2001","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":149534,"y":164597,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":831572,"y":1006153,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":408792,"y":387141,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":400743,"y":401183,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":404501,"y":419816,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":772802,"y":834618,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":74972,"y":152749,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":376542,"y":479661,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":567370,"y":1172960,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":385106,"y":410028,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":294019,"y":336566,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":405267,"y":398536,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":182551,"y":117988,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":336914,"y":353316,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":252851,"y":141823,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":134114,"y":260170,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":196435,"y":285246,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":748473,"y":958434,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":214096,"y":297003,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":235325,"y":127054,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":583409,"y":1136239,"year":"2016","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":49578,"y":97687,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":409842,"y":415981,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":258891,"y":141539,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":415998,"y":392489,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":299625,"y":315698,"year":"2000","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":298528,"y":337772,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":530398,"y":891961,"year":"2016","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":642014,"y":858400,"year":"2000","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":614617,"y":664337,"year":"2000","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":460434,"y":1340022,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":578991,"y":1133445,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":610726,"y":1107867,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":611415,"y":1109965,"year":"2012","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":717711,"y":1045801,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":702592,"y":929402,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":594255,"y":1136555,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":575126,"y":1178597,"year":"2012","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":406694,"y":395835,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":359062,"y":371383,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":294278,"y":302874,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":287635,"y":251396,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":75613,"y":104636,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":25291,"y":83851,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":130479,"y":260758,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":403119,"y":395034,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":243166,"y":132181,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":83632,"y":66834,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":170920,"y":215560,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":386581,"y":389641,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":23950,"y":150865,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":292588,"y":517362,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":68082,"y":90261,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":133482,"y":219334,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":768541,"y":820092,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":645907,"y":759661,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":534883,"y":889924,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658162,"y":746822,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":770633,"y":818057,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":596935,"y":652319,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":569990,"y":867083,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":508388,"y":851307,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":557028,"y":824871,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":656682,"y":746106,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":624440,"y":707074,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":899764,"y":955933,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":897598,"y":966237,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":461221,"y":647347,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":629642,"y":662892,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":628270,"y":662626,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":745400,"y":860917,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604435,"y":686765,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":780489,"y":820703,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":653506,"y":843699,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":675673,"y":822516,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":898103,"y":961379,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":411917,"y":705368,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":546260,"y":831135,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":437489,"y":675071,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":591508,"y":1129170,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":485199,"y":1292138,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":512287,"y":1237744,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":590281,"y":1128602,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":562480,"y":1159297,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":520071,"y":1316980,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607261,"y":1116168,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":719213,"y":996459,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":694315,"y":1054268,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":690738,"y":1089552,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":718666,"y":990795,"year":"2011","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":508015,"y":1292323,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":589393,"y":1130668,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":559514,"y":1247635,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605173,"y":1124634,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671055,"y":1068439,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":675744,"y":988272,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":573085,"y":1145874,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":594022,"y":1188600,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":642502,"y":1028798,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":553830,"y":1311785,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":691600,"y":1104254,"year":"2011","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":692024,"y":1077387,"year":"2011","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":654672,"y":1018622,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":342892,"y":396684,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408928,"y":396064,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":402036,"y":397011,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":23796,"y":149831,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242103,"y":133799,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":413018,"y":387836,"year":"2010","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":428741,"y":377779,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":243910,"y":133543,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":72609,"y":151088,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":772634,"y":820342,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":850457,"y":882895,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599326,"y":652324,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":534511,"y":837392,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":580717,"y":635691,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":578225,"y":878445,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":576500,"y":924356,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":631453,"y":779635,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":623232,"y":930365,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":767103,"y":848739,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":617060,"y":799467,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":435888,"y":657903,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":702752,"y":678180,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":427624,"y":623582,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":884463,"y":925879,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":747379,"y":795086,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":742276,"y":851945,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":443480,"y":643776,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":517043,"y":619042,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":570033,"y":867016,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":483388,"y":1301588,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":638057,"y":1029261,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":567601,"y":1210513,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":583984,"y":1188572,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":568500,"y":1237796,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588793,"y":1132821,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":579891,"y":1128545,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596377,"y":1119450,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604729,"y":1123414,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603423,"y":1116799,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":579570,"y":1131430,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":747918,"y":1027653,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671315,"y":908934,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":727639,"y":946696,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":818679,"y":1002283,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":693773,"y":1080475,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":688158,"y":1074488,"year":"2010","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":639769,"y":1045371,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":585227,"y":1158962,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592088,"y":1132476,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599751,"y":1135942,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":571682,"y":1196993,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592827,"y":1135836,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":638587,"y":1037605,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588585,"y":1132279,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":730427,"y":1036954,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":813590,"y":1000162,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":668162,"y":1099307,"year":"2010","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":681562,"y":1127662,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":761935,"y":993033,"year":"2010","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":233925,"y":172030,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":306639,"y":335385,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":360316,"y":414703,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":214159,"y":321655,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":405888,"y":392878,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":252025,"y":135950,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":222618,"y":132926,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":162883,"y":270626,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":410370,"y":392908,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407806,"y":396662,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":493904,"y":531475,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":264564,"y":238862,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":311235,"y":326361,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":417634,"y":391998,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":245313,"y":130675,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":262401,"y":463638,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":458708,"y":646239,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":505935,"y":620557,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":457895,"y":646154,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":599311,"y":655845,"year":"2009","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":770149,"y":845645,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":520125,"y":642887,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":853096,"y":880591,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":511319,"y":848341,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":657835,"y":747740,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":648949,"y":758127,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":372475,"y":566969,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":386393,"y":592899,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":754730,"y":831196,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":767022,"y":821497,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":913705,"y":1019123,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":770495,"y":846509,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":587471,"y":641020,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":662955,"y":795249,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":541489,"y":881676,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":667082,"y":844116,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":741989,"y":784921,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":668764,"y":800026,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":519237,"y":1336490,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":475233,"y":1312893,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":543711,"y":1258529,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":639582,"y":1030746,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":765209,"y":997509,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":587183,"y":1131132,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":658259,"y":1050573,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":678251,"y":1009547,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":587514,"y":937796,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":767665,"y":1015936,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":621542,"y":1129760,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604275,"y":1117039,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":851814,"y":1030245,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":703717,"y":1026880,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":475932,"y":1331067,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":567550,"y":1235071,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":718858,"y":1004481,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626773,"y":1044329,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":786484,"y":1009764,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":802674,"y":1003146,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":522966,"y":1234317,"year":"2009","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592842,"y":1138489,"year":"2009","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":276593,"y":221402,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":136633,"y":63881,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242568,"y":130458,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":257840,"y":169306,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":120998,"y":156800,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408304,"y":395176,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":417412,"y":447807,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":410137,"y":417964,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":617422,"y":701635,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":752671,"y":871283,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626378,"y":733923,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":663436,"y":743307,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":536347,"y":894572,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671008,"y":725108,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599016,"y":666656,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599704,"y":654262,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":851468,"y":948900,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":660223,"y":745701,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588648,"y":649886,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":372810,"y":587107,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575978,"y":915457,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":521467,"y":644331,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":517524,"y":625676,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":484388,"y":658027,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625681,"y":710547,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":715539,"y":769607,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":439928,"y":631939,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":616448,"y":1130376,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":600866,"y":1124912,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607033,"y":1130794,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":447052,"y":1365443,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":533623,"y":1214749,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":564830,"y":1227069,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575977,"y":1194442,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":707950,"y":1032572,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":583429,"y":1089387,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":537010,"y":1252559,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604977,"y":1120093,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598616,"y":1133529,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":720397,"y":1042778,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":713647,"y":1030999,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":720675,"y":1042295,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":787883,"y":1006791,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":521654,"y":1246131,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":623608,"y":1077669,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":704657,"y":929514,"year":"2008","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":704885,"y":932091,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588559,"y":1165582,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":527020,"y":1310079,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":595112,"y":1143279,"year":"2008","vehicles":"Vehicle(s)+multiple other types","severity":"Serious Injury","color":"#de3f53"},{"x":634062,"y":1032134,"year":"2008","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":450713,"y":1324034,"year":"2008","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":182810,"y":124658,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":456463,"y":512386,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":79394,"y":69786,"year":"2007","vehicles":"Other","severity":"Serious Injury","color":"#de3f53"},{"x":121647,"y":261484,"year":"2007","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":242851,"y":131716,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":96038,"y":224810,"year":"2007","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":137955,"y":265835,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":233671,"y":340897,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":286262,"y":244175,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":331698,"y":350112,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":138874,"y":222197,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242047,"y":135009,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408055,"y":396058,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":900090,"y":954842,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603975,"y":658300,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":668600,"y":834359,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602113,"y":656567,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":648408,"y":730726,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":806764,"y":903152,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":648395,"y":730562,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":420160,"y":617485,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":518806,"y":856037,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603183,"y":657438,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":546078,"y":897386,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":601349,"y":656176,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":470211,"y":653760,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":553405,"y":898542,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":871219,"y":925707,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716273,"y":1041298,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":546770,"y":1259285,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":719249,"y":990840,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":675430,"y":875374,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":692191,"y":1093665,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593230,"y":1133472,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607482,"y":1125775,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598920,"y":1122586,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716670,"y":1031738,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626675,"y":978830,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":762593,"y":949187,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":614089,"y":956713,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":581362,"y":1130772,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602777,"y":1120781,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":556719,"y":1249272,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":666322,"y":1012770,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593296,"y":1139866,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":727665,"y":959956,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":719423,"y":1044512,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":563700,"y":1220349,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":582456,"y":1214759,"year":"2007","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":624787,"y":973999,"year":"2007","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":353714,"y":584432,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":399062,"y":396199,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":67263,"y":10670,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":243168,"y":133023,"year":"2006","vehicles":"Vehicle(s)+multiple other types","severity":"Serious Injury","color":"#de3f53"},{"x":245898,"y":129900,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":461866,"y":489671,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":243532,"y":132471,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":229729,"y":428055,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":298206,"y":482486,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":473670,"y":505552,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":300356,"y":316038,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":296908,"y":333692,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":320740,"y":593627,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":405747,"y":393049,"year":"2006","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":427484,"y":370919,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":409785,"y":395686,"year":"2006","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":407853,"y":392717,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":434627,"y":368235,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":385941,"y":524560,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":215790,"y":119794,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":297122,"y":304058,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":473924,"y":498623,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":876320,"y":923815,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":608182,"y":661646,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":515178,"y":616941,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":530892,"y":892468,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773843,"y":811662,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":614100,"y":791013,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":516942,"y":619624,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":744370,"y":790091,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":504191,"y":645635,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":519809,"y":886070,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":764467,"y":821151,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658311,"y":739759,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":420884,"y":693303,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":602371,"y":677381,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":549132,"y":854629,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":516782,"y":618810,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":766711,"y":849040,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":528630,"y":890373,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773326,"y":817973,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":898201,"y":950150,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":592816,"y":659991,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604992,"y":682035,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":662867,"y":792254,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625282,"y":808244,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":413542,"y":701963,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":744329,"y":789835,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602745,"y":1127491,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604599,"y":1123656,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":604766,"y":1123240,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":536291,"y":1302274,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":590117,"y":1132676,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":716978,"y":990725,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":467854,"y":1329314,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":581078,"y":1130977,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":703222,"y":961502,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605251,"y":1120387,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575278,"y":1260566,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":473532,"y":1360240,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":720037,"y":1042745,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588430,"y":1145231,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605251,"y":1120387,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586474,"y":1129935,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602353,"y":1120871,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":519958,"y":1322045,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":541045,"y":1311297,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603787,"y":1121343,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":633896,"y":997193,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":789798,"y":1007083,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":788427,"y":995420,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":794089,"y":1000555,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":720267,"y":1042397,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":731524,"y":951688,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":539853,"y":1278123,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":595113,"y":1095216,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":565845,"y":1232508,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":606489,"y":1123492,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603765,"y":1085708,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":546396,"y":1284567,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":611173,"y":1113624,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":589433,"y":1144477,"year":"2006","vehicles":"Others without non-parked veh","severity":"Serious Injury","color":"#de3f53"},{"x":718705,"y":1005049,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":678970,"y":1034715,"year":"2006","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":619516,"y":1141884,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":615894,"y":1131681,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":736809,"y":1023340,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586962,"y":1134054,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":512573,"y":1291084,"year":"2006","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":250653,"y":139510,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":373314,"y":382167,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":170164,"y":92563,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":232301,"y":125558,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":83966,"y":59865,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":78368,"y":64584,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":131772,"y":41538,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":411379,"y":395341,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":138421,"y":266717,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":263501,"y":330212,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":92310,"y":70809,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":248009,"y":147420,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":132264,"y":259955,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":444700,"y":463763,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":107717,"y":58569,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":197798,"y":102033,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":297235,"y":292398,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":102068,"y":223471,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":404930,"y":397947,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":595604,"y":642010,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":765088,"y":817792,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":696534,"y":757674,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":659729,"y":744536,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596083,"y":663799,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":494163,"y":608176,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599068,"y":654085,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":655499,"y":794961,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":623316,"y":662438,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":612619,"y":663005,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":816849,"y":894689,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":774910,"y":871541,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":654640,"y":743125,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":634650,"y":829303,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596441,"y":1126975,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605237,"y":1123832,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":696164,"y":1062920,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":566978,"y":1246562,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":692525,"y":1019256,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":671353,"y":1045506,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":627951,"y":1057539,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":565674,"y":1158122,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":729829,"y":959730,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626387,"y":1038565,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":570489,"y":1151292,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":812009,"y":999707,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":682927,"y":1071977,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":626624,"y":1045090,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":607910,"y":1113267,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593553,"y":1134972,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":594886,"y":1136853,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":583836,"y":1133877,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":635455,"y":989603,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":627201,"y":1094855,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":594662,"y":1143003,"year":"2005","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":645166,"y":1087806,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":593130,"y":1139051,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":631009,"y":963084,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":680276,"y":1008265,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716222,"y":1038675,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":553073,"y":1281810,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596877,"y":1127820,"year":"2005","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":676123,"y":964151,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":503463,"y":1331405,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":619785,"y":1095183,"year":"2005","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":273408,"y":218897,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":95704,"y":220288,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":77983,"y":81799,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":253675,"y":133553,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":401683,"y":378125,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":191314,"y":99017,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":240881,"y":132284,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":409715,"y":394191,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":298044,"y":298696,"year":"2004","vehicles":"Cyclists only","severity":"Serious Injury","color":"#de3f53"},{"x":400113,"y":400768,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":259959,"y":141517,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":211371,"y":415149,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":244352,"y":139687,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":241225,"y":131319,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":138919,"y":222074,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":415169,"y":438938,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407517,"y":385840,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":289277,"y":267125,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":236546,"y":317212,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":72405,"y":239662,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":114363,"y":225974,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":288646,"y":313202,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":763173,"y":820966,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":858267,"y":880147,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":584439,"y":644054,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":635245,"y":658674,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":657195,"y":678122,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":517114,"y":878113,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":437767,"y":646941,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":878970,"y":922627,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603755,"y":682463,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":875113,"y":923723,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":655931,"y":749664,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":682312,"y":725374,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":611985,"y":690076,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":708695,"y":746875,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603425,"y":647729,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":565924,"y":1216851,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598362,"y":944989,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":573625,"y":1145699,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":711909,"y":1023331,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":592542,"y":1194943,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":572761,"y":1202713,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":571077,"y":1205650,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":627766,"y":1055760,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":625966,"y":1095152,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":583527,"y":1156037,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":728980,"y":996691,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":590948,"y":1147300,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":556854,"y":1261708,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":536036,"y":1300808,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603533,"y":1115805,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":535729,"y":1217815,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":775810,"y":1004481,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":598396,"y":1132686,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599614,"y":1136713,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":574694,"y":1257573,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605248,"y":1097075,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":583780,"y":1088583,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":599246,"y":1083859,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":644181,"y":1025849,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":660812,"y":1057662,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":588251,"y":1131505,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":679895,"y":895999,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":738066,"y":968914,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716349,"y":1040495,"year":"2004","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":675958,"y":1060159,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":802998,"y":998331,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":814683,"y":998689,"year":"2004","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":476769,"y":1329636,"year":"2004","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":152913,"y":138860,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":192206,"y":109325,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":32492,"y":161845,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":138404,"y":266706,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":240849,"y":129782,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":142639,"y":102310,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":130864,"y":259632,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":130443,"y":261202,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":320300,"y":460032,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408538,"y":396425,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":256736,"y":139249,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":119097,"y":259750,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":403422,"y":398897,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":747305,"y":793516,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":643951,"y":755314,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":555478,"y":898613,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":594479,"y":660214,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":778256,"y":802426,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":773534,"y":836814,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":409896,"y":709659,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":428811,"y":645830,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":639730,"y":756313,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":770689,"y":839377,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658056,"y":696345,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":459547,"y":644558,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":746381,"y":800617,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":531033,"y":892520,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":745332,"y":956885,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":670682,"y":960176,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":559470,"y":1262090,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":469548,"y":1351564,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":506919,"y":1287456,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":580139,"y":1219822,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":634290,"y":1033591,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":704156,"y":929469,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":583633,"y":933746,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":692530,"y":1093063,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":708335,"y":927284,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":570491,"y":1214938,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":562028,"y":1258170,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":821354,"y":967623,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":584226,"y":1129866,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":716712,"y":1035667,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":722330,"y":989326,"year":"2003","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":859681,"y":1034779,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":643532,"y":1044199,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":575185,"y":1273472,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":662187,"y":1149606,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":559442,"y":1149670,"year":"2003","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":600268,"y":1129188,"year":"2003","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":257884,"y":170618,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":79491,"y":67638,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":238433,"y":129680,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":242974,"y":133289,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":155609,"y":199439,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":124471,"y":262961,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":131297,"y":261252,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":78968,"y":76454,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":397058,"y":379982,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":408080,"y":395176,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":412851,"y":396422,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":227393,"y":128723,"year":"2002","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Serious Injury","color":"#de3f53"},{"x":394338,"y":388196,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":212893,"y":98176,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":102853,"y":199642,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":297242,"y":301718,"year":"2002","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":123470,"y":102197,"year":"2002","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":99646,"y":128967,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":483032,"y":1298753,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":608749,"y":798602,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":658571,"y":1147788,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":596235,"y":1124941,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":594651,"y":1142760,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":572625,"y":1125848,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":407083,"y":395678,"year":"2015","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Serious Injury","color":"#de3f53"},{"x":591053,"y":1144860,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":654408,"y":1152432,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":677038,"y":1126167,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":529786,"y":1310267,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":451376,"y":1325254,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":711998,"y":1023931,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":616701,"y":1093965,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":639237,"y":1032995,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":680673,"y":785849,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":498126,"y":1261968,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":586200,"y":1188303,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":721682,"y":1040637,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":603456,"y":1120614,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":165270,"y":94121,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":319125,"y":468131,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":115326,"y":223656,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":166350,"y":58096,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":703809,"y":930160,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":602830,"y":1134010,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":717049,"y":941698,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":567849,"y":1209726,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":695471,"y":959054,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":719677,"y":994029,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":584388,"y":1135973,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":412998,"y":387768,"year":"2015","vehicles":"Single vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":605877,"y":1116084,"year":"2015","vehicles":"Multi vehicle","severity":"Serious Injury","color":"#de3f53"},{"x":499088,"y":1337001,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":140871,"y":365093,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":595801,"y":1135167,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":673924,"y":1016993,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":770785,"y":999379,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":635553,"y":1090641,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":294121,"y":339831,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":545077,"y":1261077,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":411828,"y":399616,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":886042,"y":926927,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":657729,"y":1087617,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":676139,"y":876753,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":647803,"y":1023415,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":525331,"y":1317388,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":685038,"y":902147,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":665631,"y":1012872,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":510969,"y":1295451,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":514585,"y":1222264,"year":"2007","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":472537,"y":1283971,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":575929,"y":1248507,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":643650,"y":1087698,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":479523,"y":1342652,"year":"2017","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":779702,"y":1010191,"year":"2017","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":523969,"y":611331,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":764645,"y":764160,"year":"2004","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":419449,"y":696783,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":137561,"y":222570,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":412065,"y":429323,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":618287,"y":801937,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":257831,"y":236743,"year":"2012","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":79878,"y":73079,"year":"2012","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":226404,"y":334305,"year":"2012","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":763595,"y":1017849,"year":"2009","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":732966,"y":783534,"year":"2002","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":604992,"y":682035,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":814595,"y":1001476,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":629301,"y":1048939,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":728922,"y":956926,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":629546,"y":1025146,"year":"2009","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":698611,"y":1046240,"year":"2009","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":704592,"y":765409,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":437833,"y":667248,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":510402,"y":621204,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":608975,"y":687204,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":670701,"y":853756,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":541830,"y":896666,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":493632,"y":644709,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":763069,"y":816831,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":730770,"y":1002122,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":743474,"y":787678,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":703529,"y":940265,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":594837,"y":1160310,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":594186,"y":1143190,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":862399,"y":903257,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":281935,"y":227540,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":470207,"y":522368,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":104712,"y":191532,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":184522,"y":67140,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":317014,"y":386408,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":402027,"y":377752,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":208130,"y":372710,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":346916,"y":575612,"year":"2008","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":628599,"y":716117,"year":"2013","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":266361,"y":210212,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":650893,"y":748095,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":225201,"y":332919,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":526560,"y":605086,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":441024,"y":656598,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":612276,"y":792840,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":357944,"y":383583,"year":"2015","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":551109,"y":1247634,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":690804,"y":976857,"year":"2002","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":675766,"y":1041171,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":592669,"y":1130160,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":593172,"y":1191511,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":588702,"y":1132325,"year":"2002","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":643442,"y":1087644,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":679971,"y":886047,"year":"2003","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":574055,"y":1198579,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":630937,"y":1041152,"year":"2011","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":722030,"y":1036583,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":596343,"y":1132854,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":662606,"y":1145532,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":631601,"y":1040495,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":805326,"y":1001624,"year":"2011","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":554897,"y":1254613,"year":"2003","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":631996,"y":1039660,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":690864,"y":1018917,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":580747,"y":1135404,"year":"2015","vehicles":"Cyclists only","severity":"Fatal","color":"#8b0000"},{"x":690340,"y":977713,"year":"2015","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":554831,"y":1251282,"year":"2015","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":413041,"y":401128,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":332808,"y":425772,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":389121,"y":375832,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":228506,"y":131301,"year":"2010","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":97947,"y":226193,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":767511,"y":820841,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":660271,"y":748961,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":896123,"y":1042478,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":644881,"y":657751,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":635052,"y":1030590,"year":"2015","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":395707,"y":398402,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":289235,"y":513173,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Fatal","color":"#8b0000"},{"x":465646,"y":495642,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":414192,"y":398723,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":725718,"y":1039531,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":603091,"y":1123889,"year":"2015","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":131941,"y":260014,"year":"2001","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":601429,"y":1030074,"year":"2014","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":243958,"y":435215,"year":"2014","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":445263,"y":464496,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":559476,"y":1296954,"year":"2004","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":587665,"y":938098,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":667756,"y":1099197,"year":"2004","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":633347,"y":1036596,"year":"2004","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":608430,"y":1090397,"year":"2004","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":585188,"y":643663,"year":"2006","vehicles":"Vehicle(s)+multiple other types","severity":"Fatal","color":"#8b0000"},{"x":537383,"y":895009,"year":"2006","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":604919,"y":1123096,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":605327,"y":1123871,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":493929,"y":1259761,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":667020,"y":1047879,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":773474,"y":851894,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":616574,"y":806829,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":792504,"y":887161,"year":"2010","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":515848,"y":625718,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":688482,"y":1073279,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":607055,"y":1115816,"year":"2004","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":418442,"y":495007,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":738516,"y":1026330,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":379414,"y":429485,"year":"2014","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":704391,"y":918343,"year":"2005","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":641191,"y":723881,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":622215,"y":785111,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":515889,"y":558963,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":629754,"y":779988,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":493156,"y":521267,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":533619,"y":1213411,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":444206,"y":1319937,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":699691,"y":1002476,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":673610,"y":1015812,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":704666,"y":928809,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":704566,"y":938782,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":576826,"y":1146827,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":641541,"y":1042879,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":651720,"y":1058956,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":602719,"y":1097838,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":743705,"y":959349,"year":"2008","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":815727,"y":1002434,"year":"2008","vehicles":"Vehicle(s)+multiple other types","severity":"Fatal","color":"#8b0000"},{"x":643080,"y":1002286,"year":"2008","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":694713,"y":960554,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":665480,"y":1097125,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":623078,"y":960353,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":587692,"y":1171566,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":852457,"y":1030879,"year":"2005","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":534440,"y":1295956,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":644893,"y":1087932,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":619850,"y":1085778,"year":"2005","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":83154,"y":153756,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":299889,"y":480889,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":293163,"y":283341,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":735097,"y":951726,"year":"2010","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":624368,"y":1074830,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":626840,"y":1074047,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":627783,"y":1094923,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Fatal","color":"#8b0000"},{"x":580032,"y":1142633,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":680767,"y":1025301,"year":"2001","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":605193,"y":1097158,"year":"2010","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":626960,"y":1042169,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":578764,"y":1192096,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":592699,"y":1140691,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":522687,"y":1312843,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":702940,"y":942386,"year":"2001","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":579559,"y":1146726,"year":"2001","vehicles":"Vehicle(s)+Cyclist(s) only","severity":"Fatal","color":"#8b0000"},{"x":589592,"y":1171113,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":475087,"y":1288287,"year":"2010","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":719260,"y":1038476,"year":"2010","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":805488,"y":998619,"year":"2010","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":705357,"y":1040244,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":685949,"y":835656,"year":"2014","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":348953,"y":417716,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":174827,"y":129354,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":629733,"y":663063,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":379486,"y":364705,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":627398,"y":1074187,"year":"2016","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":671568,"y":750676,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":136536,"y":103759,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":222059,"y":424933,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":464802,"y":495482,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":410106,"y":404419,"year":"2003","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":549673,"y":835471,"year":"2016","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":138110,"y":222613,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":207822,"y":372257,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":631117,"y":914169,"year":"2012","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":299091,"y":551873,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":663537,"y":795810,"year":"2012","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":677097,"y":703329,"year":"2012","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":641595,"y":767925,"year":"2013","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":582770,"y":822704,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":640742,"y":726763,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":51743,"y":92466,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":149446,"y":100307,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":374718,"y":382878,"year":"2000","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":744501,"y":837076,"year":"2007","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":644332,"y":772817,"year":"2007","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":636459,"y":1033374,"year":"2013","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":640778,"y":1058450,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":612557,"y":1112269,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":722631,"y":984034,"year":"2006","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":555666,"y":1256076,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":729290,"y":997777,"year":"2006","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":591338,"y":1134311,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":667872,"y":1083393,"year":"2006","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":553428,"y":1280137,"year":"2012","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":634241,"y":1035577,"year":"2012","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":597036,"y":1124761,"year":"2012","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":50615,"y":158820,"year":"2013","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":643421,"y":892582,"year":"2013","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":604877,"y":681760,"year":"2013","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":427470,"y":1389510,"year":"2013","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":492770,"y":1260615,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":457226,"y":481356,"year":"2016","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":754834,"y":870324,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":532449,"y":587346,"year":"2009","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":621220,"y":819533,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":652582,"y":878492,"year":"2009","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":632364,"y":715889,"year":"2009","vehicles":"Vehicle(s)+Pedestrian(s)","severity":"Fatal","color":"#8b0000"},{"x":623031,"y":704571,"year":"2003","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":744524,"y":790907,"year":"2003","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":573050,"y":812215,"year":"2000","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":295290,"y":529722,"year":"2002","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"},{"x":319665,"y":472297,"year":"2002","vehicles":"Multi vehicle","severity":"Fatal","color":"#8b0000"},{"x":410801,"y":394544,"year":"2011","vehicles":"Single vehicle","severity":"Fatal","color":"#8b0000"}]

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mark = exports.chuckCloseCanvasTransform = exports.Legend = exports.SparkXYFrame = exports.SparkNetworkFrame = exports.SparkOrdinalFrame = exports.ResponsiveXYFrame = exports.ResponsiveNetworkFrame = exports.ResponsiveORFrame = exports.ResponsiveOrdinalFrame = exports.ResponsiveMinimapXYFrame = exports.NetworkFrame = exports.Annotation = exports.calculateDataExtent = exports.funnelize = exports.ORFrame = exports.OrdinalFrame = exports.VisualizationLayer = exports.InteractionLayer = exports.Axis = exports.Brush = exports.MiniMap = exports.MinimapNetworkFrame = exports.MinimapXYFrame = exports.XYFrame = exports.DividedLine = exports.AnnotationLayer = undefined;

var _AnnotationLayer = __webpack_require__(114);

var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);

var _DividedLine = __webpack_require__(275);

var _DividedLine2 = _interopRequireDefault(_DividedLine);

var _XYFrame = __webpack_require__(34);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = __webpack_require__(105);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _MinimapXYFrame = __webpack_require__(204);

var _MinimapXYFrame2 = _interopRequireDefault(_MinimapXYFrame);

var _MinimapNetworkFrame = __webpack_require__(530);

var _MinimapNetworkFrame2 = _interopRequireDefault(_MinimapNetworkFrame);

var _MiniMap = __webpack_require__(108);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _Axis = __webpack_require__(54);

var _Axis2 = _interopRequireDefault(_Axis);

var _Legend = __webpack_require__(115);

var _Legend2 = _interopRequireDefault(_Legend);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _Brush = __webpack_require__(186);

var _Brush2 = _interopRequireDefault(_Brush);

var _InteractionLayer = __webpack_require__(181);

var _InteractionLayer2 = _interopRequireDefault(_InteractionLayer);

var _VisualizationLayer = __webpack_require__(187);

var _VisualizationLayer2 = _interopRequireDefault(_VisualizationLayer);

var _NetworkFrame = __webpack_require__(59);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _lineDrawing = __webpack_require__(46);

var _dataFunctions = __webpack_require__(58);

var _ResponsiveNetworkFrame = __webpack_require__(569);

var _ResponsiveNetworkFrame2 = _interopRequireDefault(_ResponsiveNetworkFrame);

var _ResponsiveMinimapXYFrame = __webpack_require__(571);

var _ResponsiveMinimapXYFrame2 = _interopRequireDefault(_ResponsiveMinimapXYFrame);

var _ResponsiveXYFrame = __webpack_require__(572);

var _ResponsiveXYFrame2 = _interopRequireDefault(_ResponsiveXYFrame);

var _ResponsiveOrdinalFrame = __webpack_require__(573);

var _ResponsiveOrdinalFrame2 = _interopRequireDefault(_ResponsiveOrdinalFrame);

var _SparkXYFrame = __webpack_require__(574);

var _SparkXYFrame2 = _interopRequireDefault(_SparkXYFrame);

var _SparkOrdinalFrame = __webpack_require__(575);

var _SparkOrdinalFrame2 = _interopRequireDefault(_SparkOrdinalFrame);

var _SparkNetworkFrame = __webpack_require__(576);

var _SparkNetworkFrame2 = _interopRequireDefault(_SparkNetworkFrame);

var _basicCanvasEffects = __webpack_require__(188);

var _semioticMark = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORFrame = _OrdinalFrame2.default;
var ResponsiveORFrame = _ResponsiveOrdinalFrame2.default;

exports.default = {
  AnnotationLayer: _AnnotationLayer2.default,
  DividedLine: _DividedLine2.default,
  XYFrame: _XYFrame2.default,
  MinimapXYFrame: _MinimapXYFrame2.default,
  MinimapNetworkFrame: _MinimapNetworkFrame2.default,
  MiniMap: _MiniMap2.default,
  Brush: _Brush2.default,
  Axis: _Axis2.default,
  InteractionLayer: _InteractionLayer2.default,
  VisualizationLayer: _VisualizationLayer2.default,
  OrdinalFrame: _OrdinalFrame2.default,
  ORFrame: ORFrame,
  funnelize: _lineDrawing.funnelize,
  calculateDataExtent: _dataFunctions.calculateDataExtent,
  Annotation: _Annotation2.default,
  NetworkFrame: _NetworkFrame2.default,
  ResponsiveMinimapXYFrame: _ResponsiveMinimapXYFrame2.default,
  ResponsiveOrdinalFrame: _ResponsiveOrdinalFrame2.default,
  ResponsiveORFrame: ResponsiveORFrame,
  ResponsiveNetworkFrame: _ResponsiveNetworkFrame2.default,
  ResponsiveXYFrame: _ResponsiveXYFrame2.default,
  SparkOrdinalFrame: _SparkOrdinalFrame2.default,
  SparkNetworkFrame: _SparkNetworkFrame2.default,
  SparkXYFrame: _SparkXYFrame2.default,
  Legend: _Legend2.default,
  chuckCloseCanvasTransform: _basicCanvasEffects.chuckCloseCanvasTransform,
  Mark: _semioticMark.Mark
};
exports.AnnotationLayer = _AnnotationLayer2.default;
exports.DividedLine = _DividedLine2.default;
exports.XYFrame = _XYFrame2.default;
exports.MinimapXYFrame = _MinimapXYFrame2.default;
exports.MinimapNetworkFrame = _MinimapNetworkFrame2.default;
exports.MiniMap = _MiniMap2.default;
exports.Brush = _Brush2.default;
exports.Axis = _Axis2.default;
exports.InteractionLayer = _InteractionLayer2.default;
exports.VisualizationLayer = _VisualizationLayer2.default;
exports.OrdinalFrame = _OrdinalFrame2.default;
exports.ORFrame = ORFrame;
exports.funnelize = _lineDrawing.funnelize;
exports.calculateDataExtent = _dataFunctions.calculateDataExtent;
exports.Annotation = _Annotation2.default;
exports.NetworkFrame = _NetworkFrame2.default;
exports.ResponsiveMinimapXYFrame = _ResponsiveMinimapXYFrame2.default;
exports.ResponsiveOrdinalFrame = _ResponsiveOrdinalFrame2.default;
exports.ResponsiveORFrame = ResponsiveORFrame;
exports.ResponsiveNetworkFrame = _ResponsiveNetworkFrame2.default;
exports.ResponsiveXYFrame = _ResponsiveXYFrame2.default;
exports.SparkOrdinalFrame = _SparkOrdinalFrame2.default;
exports.SparkNetworkFrame = _SparkNetworkFrame2.default;
exports.SparkXYFrame = _SparkXYFrame2.default;
exports.Legend = _Legend2.default;
exports.chuckCloseCanvasTransform = _basicCanvasEffects.chuckCloseCanvasTransform;
exports.Mark = _semioticMark.Mark;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.bumpAnnotations = bumpAnnotations;

var _d3labeler = __webpack_require__(236);

var _d3labeler2 = _interopRequireDefault(_d3labeler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basicPointSizeFunction = function basicPointSizeFunction() {
  return 5;
};
var basicLabelSizeFunction = function basicLabelSizeFunction(noteData, characterWidth, lineHeight, padding) {
  var text = noteData.note.label || noteData.note.title;

  var textLength = text.length;
  var wrap = noteData.note.wrap || 120;
  var width = Math.min(wrap, textLength * characterWidth) + padding * 2;
  var height = Math.ceil(textLength * characterWidth / 120) * lineHeight + padding * 2;
  return [width, height];
};

function bumpAnnotations(adjustableNotes, props, processor) {
  var size = props.size,
      propsPointSizeFunction = props.pointSizeFunction,
      propsLabelSizeFunction = props.labelSizeFunction;
  var _processor$padding = processor.padding,
      padding = _processor$padding === undefined ? 1 : _processor$padding,
      _processor$characterW = processor.characterWidth,
      characterWidth = _processor$characterW === undefined ? 8 : _processor$characterW,
      _processor$lineHeight = processor.lineHeight,
      lineHeight = _processor$lineHeight === undefined ? 20 : _processor$lineHeight,
      _processor$iterations = processor.iterations,
      iterations = _processor$iterations === undefined ? 500 : _processor$iterations,
      _processor$pointSizeF = processor.pointSizeFunction,
      pointSizeFunction = _processor$pointSizeF === undefined ? propsPointSizeFunction || basicPointSizeFunction : _processor$pointSizeF,
      _processor$labelSizeF = processor.labelSizeFunction,
      labelSizeFunction = _processor$labelSizeF === undefined ? propsLabelSizeFunction || basicLabelSizeFunction : _processor$labelSizeF;


  var labels = adjustableNotes.map(function (d, i) {
    var anchorX = d.props.noteData.x + (d.props.noteData.dx !== undefined ? d.props.noteData.dx : (i % 3 - 1) * -10);
    var anchorY = d.props.noteData.y + (d.props.noteData.dy !== undefined ? d.props.noteData.dy : (i % 3 - 1) * 10);

    var _labelSizeFunction = labelSizeFunction(d.props.noteData, characterWidth, lineHeight, padding),
        _labelSizeFunction2 = _slicedToArray(_labelSizeFunction, 2),
        labelWidth = _labelSizeFunction2[0],
        labelHeight = _labelSizeFunction2[1];

    return {
      x: anchorX,
      y: anchorY,
      above: anchorY < d.props.noteData.y,
      left: anchorX < d.props.noteData.x,
      width: labelWidth,
      height: labelHeight,
      type: "label",
      name: "",
      originalNote: d
    };
  });

  var points = adjustableNotes.map(function (d) {
    return {
      x: d.props.noteData.x,
      y: d.props.noteData.y,
      fx: d.props.noteData.x,
      fy: d.props.noteData.y,
      r: pointSizeFunction(d.props.noteData),
      type: "point",
      originalNote: d
    };
  });

  (0, _d3labeler2.default)().label(labels).anchor(points).width(size[0]).height(size[1]).start(iterations);

  labels.forEach(function (d) {
    if (d.type === "label") {
      var adjusted = adjustedXY(d.originalNote.props.noteData, d, padding);
      d.originalNote.props.noteData.nx = adjusted[0];
      d.originalNote.props.noteData.ny = adjusted[1];
    }
  });

  return adjustableNotes;
}

function adjustedXY(note, calculated /*, padding*/) {
  if (note.y > calculated.y) {
    //below
    return [calculated.x + calculated.width / 2, calculated.y - calculated.height];
  }
  return [calculated.x + calculated.width / 2, calculated.y];
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var lab = [],
      anc = [],
      w = 1,
      // box width
  h = 1,
      // box width
  labeler = {};

  var max_move = 5.0,
      max_angle = 0.5,
      acc = 0,
      rej = 0;

  // weights
  var w_len = 0.2,
      // leader line length
  w_inter = 1.0,
      // leader line intersection
  w_lab2 = 30.0,
      // label-label overlap
  w_lab_anc = 30.0,
      // label-anchor overlap
  w_orient = 3.0; // orientation bias

  // booleans for user defined functions
  var user_energy = false,
      user_schedule = false;

  var user_defined_energy = void 0,
      user_defined_schedule = void 0;

  var energy = function energy(index) {
    // energy function, tailored for label placement

    var m = lab.length,
        ener = 0,
        dx = lab[index].x - anc[index].x,
        dy = anc[index].y - lab[index].y,
        dist = Math.sqrt(dx * dx + dy * dy),
        overlap = true,
        amount = 0,
        theta = 0;

    // penalty for length of leader line
    if (dist > 0) ener += dist * w_len;

    // label orientation bias
    dx /= dist;
    dy /= dist;
    if (dx > 0 && dy > 0) {
      ener += 0 * w_orient;
    } else if (dx < 0 && dy > 0) {
      ener += 1 * w_orient;
    } else if (dx < 0 && dy < 0) {
      ener += 2 * w_orient;
    } else {
      ener += 3 * w_orient;
    }

    var x21 = lab[index].x,
        y21 = lab[index].y - lab[index].height + 2.0,
        x22 = lab[index].x + lab[index].width,
        y22 = lab[index].y + 2.0;
    var x11 = void 0,
        x12 = void 0,
        y11 = void 0,
        y12 = void 0,
        x_overlap = void 0,
        y_overlap = void 0,
        overlap_area = void 0;

    for (var i = 0; i < m; i++) {
      if (i !== index) {
        // penalty for intersection of leader lines
        var _overlap = intersect(anc[index].x, lab[index].x, anc[i].x, lab[i].x, anc[index].y, lab[index].y, anc[i].y, lab[i].y);
        if (_overlap) ener += w_inter;

        // penalty for label-label overlap
        x11 = lab[i].x;
        y11 = lab[i].y - lab[i].height + 2.0;
        x12 = lab[i].x + lab[i].width;
        y12 = lab[i].y + 2.0;
        x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
        y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
        overlap_area = x_overlap * y_overlap;
        ener += overlap_area * w_lab2;
      }

      // penalty for label-anchor overlap
      x11 = anc[i].x - anc[i].r;
      y11 = anc[i].y - anc[i].r;
      x12 = anc[i].x + anc[i].r;
      y12 = anc[i].y + anc[i].r;
      x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
      y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
      overlap_area = x_overlap * y_overlap;
      ener += overlap_area * w_lab_anc;
    }
    return ener;
  };

  var mcmove = function mcmove(currT) {
    // Monte Carlo translation move

    // select a random label
    var i = Math.floor(Math.random() * lab.length);

    // save old coordinates
    var x_old = lab[i].x;
    var y_old = lab[i].y;

    // old energy
    var old_energy = void 0;
    if (user_energy) {
      old_energy = user_defined_energy(i, lab, anc);
    } else {
      old_energy = energy(i);
    }

    // random translation
    lab[i].x += (Math.random() - 0.5) * max_move;
    lab[i].y += (Math.random() - 0.5) * max_move;

    // hard wall boundaries
    if (lab[i].x > w) lab[i].x = x_old;
    if (lab[i].x < 0) lab[i].x = x_old;
    if (lab[i].y > h) lab[i].y = y_old;
    if (lab[i].y < 0) lab[i].y = y_old;

    // new energy
    var new_energy = void 0;
    if (user_energy) {
      new_energy = user_defined_energy(i, lab, anc);
    } else {
      new_energy = energy(i);
    }

    // delta E
    var delta_energy = new_energy - old_energy;

    if (Math.random() < Math.exp(-delta_energy / currT)) {
      acc += 1;
    } else {
      // move back to old coordinates
      lab[i].x = x_old;
      lab[i].y = y_old;
      rej += 1;
    }
  };

  var mcrotate = function mcrotate(currT) {
    // Monte Carlo rotation move

    // select a random label
    var i = Math.floor(Math.random() * lab.length);

    // save old coordinates
    var x_old = lab[i].x;
    var y_old = lab[i].y;

    // old energy
    var old_energy = void 0;
    if (user_energy) {
      old_energy = user_defined_energy(i, lab, anc);
    } else {
      old_energy = energy(i);
    }

    // random angle
    var angle = (Math.random() - 0.5) * max_angle;

    var s = Math.sin(angle);
    var c = Math.cos(angle);

    // translate label (relative to anchor at origin):
    lab[i].x -= anc[i].x;
    lab[i].y -= anc[i].y;

    // rotate label
    var x_new = lab[i].x * c - lab[i].y * s,
        y_new = lab[i].x * s + lab[i].y * c;

    // translate label back
    lab[i].x = x_new + anc[i].x;
    lab[i].y = y_new + anc[i].y;

    // hard wall boundaries
    if (lab[i].x > w) lab[i].x = x_old;
    if (lab[i].x < 0) lab[i].x = x_old;
    if (lab[i].y > h) lab[i].y = y_old;
    if (lab[i].y < 0) lab[i].y = y_old;

    // new energy
    var new_energy = void 0;
    if (user_energy) {
      new_energy = user_defined_energy(i, lab, anc);
    } else {
      new_energy = energy(i);
    }

    // delta E
    var delta_energy = new_energy - old_energy;

    if (Math.random() < Math.exp(-delta_energy / currT)) {
      acc += 1;
    } else {
      // move back to old coordinates
      lab[i].x = x_old;
      lab[i].y = y_old;
      rej += 1;
    }
  };

  var intersect = function intersect(x1, x2, x3, x4, y1, y2, y3, y4) {
    // returns true if two lines intersect, else false
    // from http://paulbourke.net/geometry/lineline2d/

    var mua = void 0,
        mub = void 0;
    var denom = void 0,
        numera = void 0,
        numerb = void 0;

    denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
    numerb = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);

    /* Is the intersection along the the segments */
    mua = numera / denom;
    mub = numerb / denom;
    if (!(mua < 0 || mua > 1 || mub < 0 || mub > 1)) {
      return true;
    }
    return false;
  };

  var cooling_schedule = function cooling_schedule(currT, initialT, nsweeps) {
    // linear cooling
    return currT - initialT / nsweeps;
  };

  labeler.start = function (nsweeps) {
    // main simulated annealing function
    var m = lab.length,
        currT = 1.0,
        initialT = 1.0;

    for (var i = 0; i < nsweeps; i++) {
      for (var j = 0; j < m; j++) {
        if (Math.random() < 0.5) {
          mcmove(currT);
        } else {
          mcrotate(currT);
        }
      }
      currT = cooling_schedule(currT, initialT, nsweeps);
    }
  };

  labeler.width = function (x) {
    // users insert graph width
    if (!arguments.length) return w;
    w = x;
    return labeler;
  };

  labeler.height = function (x) {
    // users insert graph height
    if (!arguments.length) return h;
    h = x;
    return labeler;
  };

  labeler.label = function (x) {
    // users insert label positions
    if (!arguments.length) return lab;
    lab = x;
    return labeler;
  };

  labeler.anchor = function (x) {
    // users insert anchor positions
    if (!arguments.length) return anc;
    anc = x;
    return labeler;
  };

  labeler.alt_energy = function (x) {
    // user defined energy
    if (!arguments.length) return energy;
    user_defined_energy = x;
    user_energy = true;
    return labeler;
  };

  labeler.alt_schedule = function (x) {
    // user defined cooling_schedule
    if (!arguments.length) return cooling_schedule;
    user_defined_schedule = x;
    user_schedule = true;
    return labeler;
  };

  return labeler;
};

/*eslint-enable */
module.exports = exports['default']; // from Evan Wang's https://github.com/tinker10/D3-Labeler
/*eslint-disable */

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(40);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(238);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(117);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableAnnotation = function (_React$Component) {
  _inherits(EditableAnnotation, _React$Component);

  function EditableAnnotation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditableAnnotation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditableAnnotation.__proto__ || Object.getPrototypeOf(EditableAnnotation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      x: 0,
      y: 0,
      dx: 0,
      dy: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditableAnnotation, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        x: this.props.x,
        y: this.props.y,
        dx: this.props.dx,
        dy: this.props.dy
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      return Object.assign({}, this.props, this.state);
    }
  }, {
    key: "dragEnd",
    value: function dragEnd() {
      if (this.props.onDragEnd) {
        this.props.onDragEnd(this.getData());
      }
    }
  }, {
    key: "dragStart",
    value: function dragStart() {
      if (this.props.onDragStart) {
        this.props.onDragStart(this.getData());
      }
    }
  }, {
    key: "dragSubject",
    value: function dragSubject(event, data) {
      var _this2 = this;

      this.setState({
        x: this.state.x + data.deltaX,
        y: this.state.y + data.deltaY
      }, function () {
        if (_this2.props.onDrag) _this2.props.onDrag(_this2.getData());
      });
    }
  }, {
    key: "dragSubjectSettings",
    value: function dragSubjectSettings(event, data) {
      var _this3 = this;

      this.setState(data, function () {
        if (_this3.props.onDrag) _this3.props.onDrag(_this3.getData());
      });
    }
  }, {
    key: "dragNote",
    value: function dragNote(event, data) {
      var _this4 = this;

      this.setState({
        dx: this.state.dx + data.deltaX,
        dy: this.state.dy + data.deltaY
      }, function () {
        if (_this4.props.onDrag) _this4.props.onDrag(_this4.getData());
      });
    }
  }, {
    key: "render",
    value: function render() {
      var cleanedProps = Object.assign({}, this.props, _extends({}, this.state, {
        dragSubject: this.dragSubject.bind(this),
        dragNote: this.dragNote.bind(this),
        dragSubjectSettings: this.dragSubjectSettings.bind(this),
        dragEnd: this.dragEnd.bind(this),
        dragStart: this.dragStart.bind(this),
        editMode: true,
        className: (0, _classnames2.default)(this.props.className, "editable")
      }));

      return _react2.default.createElement(_Annotation2.default, cleanedProps);
    }
  }]);

  return EditableAnnotation;
}(_react2.default.Component);

exports.default = EditableAnnotation;

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(25);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(25);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(121);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(122);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(16);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(43);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(43);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(43);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(67);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(67);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(42);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(27);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(68);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

exports.default = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      radiusPadding = _ref.radiusPadding,
      width = _ref.width,
      height = _ref.height;

  var x1 = 0,
      x2 = dx,
      y1 = 0,
      y2 = dy;

  if (width && height) {
    if (width > 0 && dx > 0 || width < 0 && dx < 0) {
      if (Math.abs(width) > Math.abs(dx)) x1 = width / 2;else x1 = width;
    }
    if (height > 0 && dy > 0 || height < 0 && dy < 0) {
      if (Math.abs(height) > Math.abs(dy)) y1 = height / 2;else y1 = height;
    }
    if (x1 === width / 2 && y1 === height / 2) {
      x1 = x2;
      y1 = y2;
    }
  }

  var data = [[x1, y1], [x2, y2]];

  var diffY = y2 - y1;
  var diffX = x2 - x1;
  var xe = x2;
  var ye = y2;
  var opposite = y2 < y1 && x2 > x1 || x2 < x1 && y2 > y1 ? -1 : 1;

  if (Math.abs(diffX) < Math.abs(diffY)) {
    xe = x2;
    ye = y1 + diffX * opposite;
  } else {
    ye = y2;
    xe = x1 + diffY * opposite;
  }

  if (outerRadius || radius) {
    var r = (outerRadius || radius) + (radiusPadding || 0);
    var length = r / Math.sqrt(2);

    if (Math.abs(diffX) > length && Math.abs(diffY) > length) {
      x1 = length * (x2 < 0 ? -1 : 1);
      y1 = length * (y2 < 0 ? -1 : 1);
      data = [[x1, y1], [xe, ye], [x2, y2]];
    } else if (Math.abs(diffX) > Math.abs(diffY)) {
      var angle = Math.asin(-y2 / r);
      x1 = Math.abs(Math.cos(angle) * r) * (x2 < 0 ? -1 : 1);
      data = [[x1, y2], [x2, y2]];
    } else {
      var _angle = Math.acos(x2 / r);
      y1 = Math.abs(Math.sin(_angle) * r) * (y2 < 0 ? -1 : 1);
      data = [[x2, y1], [x2, y2]];
    }
  } else {
    data = [[x1, y1], [xe, ye], [x2, y2]];
  }

  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "connector" })] };
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeCurve = __webpack_require__(267);

var _typeCurve2 = _interopRequireDefault(_typeCurve);

var _Connector2 = __webpack_require__(69);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorCurve = function (_Connector) {
  _inherits(ConnectorCurve, _Connector);

  function ConnectorCurve() {
    _classCallCheck(this, ConnectorCurve);

    return _possibleConstructorReturn(this, (ConnectorCurve.__proto__ || Object.getPrototypeOf(ConnectorCurve)).apply(this, arguments));
  }

  _createClass(ConnectorCurve, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var curve = _ref.curve,
          points = _ref.points,
          x = _ref.x,
          y = _ref.y,
          dx = _ref.dx,
          dy = _ref.dy,
          radius = _ref.radius,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeCurve2.default)({
        curve: curve,
        points: points,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        radius: radius,
        outerRadius: outerRadius,
        width: width,
        height: height
      });
    }
  }]);

  return ConnectorCurve;
}(_Connector3.default);

exports.default = ConnectorCurve;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

var _typeLine = __webpack_require__(118);

var _d3Shape = __webpack_require__(7);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createPoints = function createPoints(offset) {
  var anchors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var diff = { x: offset.x / (anchors + 1), y: offset.y / (anchors + 1) };
  var p = [];

  var i = 1;
  for (; i <= anchors; i++) {
    p.push([diff.x * i + i % 2 * 20, diff.y * i - i % 2 * 20]);
  }
  return p;
};

exports.default = function (_ref) {
  var curve = _ref.curve,
      points = _ref.points,
      x = _ref.x,
      y = _ref.y,
      dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      width = _ref.width,
      height = _ref.height;

  if (!points || typeof points === "number") {
    points = createPoints({ x: dx, y: dy }, points);
  }
  if (!curve) {
    curve = _d3Shape.curveCatmullRom;
  }

  var handles = [];

  // if (type.editMode) {
  //   const cHandles = connectorData.points.map((c, i) => ({
  //     ...pointHandle({ cx: c[0], cy: c[1] }),
  //     index: i
  //   }))

  //   const updatePoint = index => {
  //     connectorData.points[index][0] += event.dx
  //     connectorData.points[index][1] += event.dy
  //     type.redrawConnector()
  //   }

  //   handles = type.mapHandles(
  //     cHandles.map(h => ({ ...h.move, drag: updatePoint.bind(type, h.index) }))
  //   )
  // }

  // let data = lineSetup({ type, subjectType })
  var data = (0, _typeLine.lineSetup)({ x: x, y: y, dx: dx, dy: dy, radius: radius, outerRadius: outerRadius, width: width, height: height });
  data = [data[0]].concat(_toConsumableArray(points), [data[1]]);
  var components = [(0, _Builder.lineBuilder)({ data: data, curve: curve, className: "connector" })];

  return { components: components, handles: handles };
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _endDot = __webpack_require__(269);

var _endDot2 = _interopRequireDefault(_endDot);

var _ConnectorEnd2 = __webpack_require__(133);

var _ConnectorEnd3 = _interopRequireDefault(_ConnectorEnd2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorEndDot = function (_ConnectorEnd) {
  _inherits(ConnectorEndDot, _ConnectorEnd);

  function ConnectorEndDot() {
    _classCallCheck(this, ConnectorEndDot);

    return _possibleConstructorReturn(this, (ConnectorEndDot.__proto__ || Object.getPrototypeOf(ConnectorEndDot)).apply(this, arguments));
  }

  _createClass(ConnectorEndDot, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          lineData = _ref.lineData,
          scale = _ref.scale;

      return (0, _endDot2.default)({ x: x, y: y, dx: dx, dy: dy, lineData: lineData, scale: scale });
    }
  }]);

  return ConnectorEndDot;
}(_ConnectorEnd3.default);

exports.default = ConnectorEndDot;


ConnectorEndDot.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  scale: _propTypes2.default.number,
  lineData: _propTypes2.default.array
  //array of arrays of x,y coordinates for the connector line
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

exports.default = function (_ref) {
  var lineData = _ref.lineData,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;

  var dot = (0, _Builder.arcBuilder)({
    className: "connector-end connector-dot",
    classID: "connector-end",
    data: { radius: 3 * Math.sqrt(scale) }
  });
  dot.attrs.transform = "translate(" + lineData[0][0] + ", " + lineData[0][1] + ")";

  return { components: [dot] };
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _endArrow = __webpack_require__(271);

var _endArrow2 = _interopRequireDefault(_endArrow);

var _ConnectorEnd2 = __webpack_require__(133);

var _ConnectorEnd3 = _interopRequireDefault(_ConnectorEnd2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorEndArrow = function (_ConnectorEnd) {
  _inherits(ConnectorEndArrow, _ConnectorEnd);

  function ConnectorEndArrow() {
    _classCallCheck(this, ConnectorEndArrow);

    return _possibleConstructorReturn(this, (ConnectorEndArrow.__proto__ || Object.getPrototypeOf(ConnectorEndArrow)).apply(this, arguments));
  }

  _createClass(ConnectorEndArrow, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          lineData = _ref.lineData,
          scale = _ref.scale;

      var start = lineData[1];
      var end = lineData[0];
      var distance = Math.sqrt(Math.pow(start[0] - end[0], 2) + Math.pow(start[1] - end[1], 2));
      if (distance < 5 && lineData[2]) {
        start = lineData[2];
      }

      return (0, _endArrow2.default)({ x: x, y: y, dx: dx, dy: dy, start: start, end: end, scale: scale });
    }
  }]);

  return ConnectorEndArrow;
}(_ConnectorEnd3.default);

exports.default = ConnectorEndArrow;


ConnectorEndArrow.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  scale: _propTypes2.default.number,
  lineData: _propTypes2.default.array
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

exports.default = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      start = _ref.start,
      end = _ref.end,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;

  if (!start) {
    start = [dx, dy];
  } else {
    start = [-end[0] + start[0], -end[1] + start[1]];
  }
  if (!end) {
    end = [0, 0];
  }

  var x1 = end[0],
      y1 = end[1];

  var size = 10 * scale;
  var angleOffset = 16 / 180 * Math.PI;
  var angle = Math.atan(start[1] / start[0]);

  if (start[0] < 0) {
    angle += Math.PI;
  }

  var data = [[x1, y1], [Math.cos(angle + angleOffset) * size + x1, Math.sin(angle + angleOffset) * size + y1], [Math.cos(angle - angleOffset) * size + x1, Math.sin(angle - angleOffset) * size + y1], [x1, y1]];

  //TODO add in reverse
  // if (canvasContext.arrowReverse){
  //   data = [[x1, y1],
  //   [Math.cos(angle + angleOffset)*size, Math.sin(angle + angleOffset)*size],
  //   [Math.cos(angle - angleOffset)*size, Math.sin(angle - angleOffset)*size],
  //   [x1, y1]
  //   ]
  // } else {
  //   data = [[x1, y1],
  //   [Math.cos(angle + angleOffset)*size, Math.sin(angle + angleOffset)*size],
  //   [Math.cos(angle - angleOffset)*size, Math.sin(angle - angleOffset)*size],
  //   [x1, y1]
  //   ]
  // }

  return {
    components: [(0, _Builder.lineBuilder)({
      data: data,
      className: "connector-end connector-arrow",
      classID: "connector-end"
    })]
  };
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

var _alignment = __webpack_require__(70);

exports.default = function (_ref) {
  var align = _ref.align,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? 0 : _ref$y,
      bbox = _ref.bbox,
      offset = _ref.offset;

  align = (0, _alignment.leftRightDynamic)(align, offset.y);

  if (align === "top") {
    y -= bbox.height;
  } else if (align === "middle") {
    y -= bbox.height / 2;
  }

  var data = [[x, y], [x, y + bbox.height]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "note-line" })] };
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

var _alignment = __webpack_require__(70);

exports.default = function (_ref) {
  var align = _ref.align,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? 0 : _ref$y,
      offset = _ref.offset,
      bbox = _ref.bbox;

  align = (0, _alignment.topBottomDynamic)(align, offset.x);

  if (align === "right") {
    x -= bbox.width;
  } else if (align === "middle") {
    x -= bbox.width / 2;
  }

  var data = [[x, y], [x + bbox.width, y]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "note-line" })] };
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.labella=e():t.labella=e()}(this,function(){return function(t){function e(n){if(r[n])return r[n].exports;var i=r[n]={exports:{},id:n,loaded:!1};return t[n].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){"use strict";t.exports={Node:r(1),Force:r(2),Distributor:r(3),Renderer:r(10)}},function(t,e){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=function(){function t(e,n,i){r(this,t),this.idealPos=e,this.currentPos=e,this.width=n,this.data=i,this.layerIndex=0}return n(t,[{key:"distanceFrom",value:function(t){var e=this.width/2,r=t.width/2;return Math.max(this.currentPos-e,t.currentPos-r)-Math.min(this.currentPos+e,t.currentPos+r)}},{key:"moveToIdealPosition",value:function(){return this.currentPos=this.idealPos,this}},{key:"displacement",value:function(){return this.idealPos-this.currentPos}},{key:"overlapWithNode",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.distanceFrom(t)-e<0}},{key:"overlapWithPoint",value:function(t){var e=this.width/2;return t>=this.currentPos-e&&t<=this.currentPos+e}},{key:"positionBefore",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.currentLeft()-this.width/2-e}},{key:"positionAfter",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.currentRight()+this.width/2+e}},{key:"currentRight",value:function(){return this.currentPos+this.width/2}},{key:"currentLeft",value:function(){return this.currentPos-this.width/2}},{key:"idealRight",value:function(){return this.idealPos+this.width/2}},{key:"idealLeft",value:function(){return this.idealPos-this.width/2}},{key:"createStub",value:function(e){var r=new t(this.idealPos,e,this.data);return r.currentPos=this.currentPos,r.child=this,this.parent=r,r}},{key:"removeStub",value:function(){return this.parent&&(this.parent.child=null,this.parent=null),this}},{key:"isStub",value:function(){return!!this.child}},{key:"getPathToRoot",value:function(){for(var t=[],e=this;e;)t.push(e),e=e.parent;return t}},{key:"getPathFromRoot",value:function(){return this.getPathToRoot().reverse()}},{key:"getPathToRootLength",value:function(){for(var t=0,e=this;e;){var r=e.parent?e.parent.currentPos:e.idealPos;t+=Math.abs(e.currentPos-r),e=e.parent}return t}},{key:"getRoot",value:function(){for(var t=this,e=this;e;)t=e,e=e.parent;return t}},{key:"getLayerIndex",value:function(){return this.layerIndex}},{key:"clone",value:function(){var e=new t(this.idealPos,this.width,this.data);return e.currentPos=this.currentPos,e.layerIndex=this.layerIndex,e}}]),t}();t.exports=i},function(t,e,r){"use strict";var n=r(3),i=r(4),o=r(8),s={nodeSpacing:3,minPos:0,maxPos:null,algorithm:"overlap",removeOverlap:!0,density:.85,stubWidth:1},u=function(t){var e={},r=i.extend({},s),u=new n,a=[],c=null;return e.nodes=function(t){return arguments.length?(a=t,c=[t.concat()],e):a},e.getLayers=function(){return c},e.options=function(t){if(!arguments.length)return r;r=i.extend(r,t);var o=i.pick(r,Object.keys(n.DEFAULT_OPTIONS));return i.isDefined(r.minPos)&&i.isDefined(r.maxPos)?o.layerWidth=r.maxPos-r.minPos:o.layerWidth=null,u.options(o),e},e.options(t),e.compute=function(){var t=i.pick(r,Object.keys(o.DEFAULT_OPTIONS));return a.forEach(function(t){t.removeStub()}),c=u.distribute(a),c.map(function(e,n){e.forEach(function(t){t.layerIndex=n}),r.removeOverlap&&o(e,t)}),e},e.start=function(){console.log("[warning] force.start() is deprecated. Please use force.compute() instead.")},e};u.DEFAULT_OPTIONS=s,t.exports=u},function(t,e,r){"use strict";var n=r(4),i=r(6),o={algorithm:"overlap",layerWidth:1e3,density:.75,nodeSpacing:3,stubWidth:1},s=function(t){var e={};t=n.extend({},o,t),e.options=function(r){return arguments.length?(t=n.extend(t,r),e):t},e.computeRequiredWidth=function(e){return n.sum(e,function(e){return e.width+t.nodeSpacing})-t.nodeSpacing},e.maxWidthPerLayer=function(){return t.density*t.layerWidth},e.needToSplit=function(t){return e.estimateRequiredLayers(t)>1},e.estimateRequiredLayers=function(r){return t.layerWidth?Math.ceil(e.computeRequiredWidth(r)/e.maxWidthPerLayer()):1};var r={simple:function(r){for(var n=e.estimateRequiredLayers(r),i=[],o=0;o<n;o++)i.push([]);return r.forEach(function(e,r){var o=r%n;i[o].push(e);for(var s=e,u=o-1;u>=0;u--)s=s.createStub(t.stubWidth),i[u].push(s)}),i},roundRobin:function(t){var e=[];return e},overlap:function(r){for(var n=[],i=e.maxWidthPerLayer(),o=r.concat(),s=e.computeRequiredWidth(o);s>i;){e.countIdealOverlaps(o);var u=o.concat(),a=s;for(o=[];u.length>2&&a>i;){u.sort(function(t,e){return e.overlapCount-t.overlapCount});var c=u.shift();a-=c.width,a+=t.stubWidth,c.overlaps.forEach(function(t){t.overlapCount--}),o.push(c)}n.push(u),s=e.computeRequiredWidth(o)}o.length>0&&n.push(o);for(var h=n.length-1;h>=1;h--)for(var l=n[h],f=0;f<l.length;f++){var p=l[f];if(!p.isStub())for(var d=p,v=h-1;v>=0;v--)d=d.createStub(t.stubWidth),n[v].push(d)}return n}};return e.countIdealOverlaps=function(e){var r=new i(t.layerWidth/2);return e.forEach(function(t){r.add([t.idealLeft(),t.idealRight(),t])}),e.forEach(function(t){var e=r.search(t.idealLeft(),t.idealRight());t.overlaps=e.map(function(t){return t.data[2]}),t.overlapCount=e.length}),e},e.distribute=function(i){if(!i||0===i.length)return[];if("none"==t.algorithm||!n.isDefined(t.algorithm))return[i];if(!e.needToSplit(i))return[i];var o=i.concat().sort(function(t,e){return t.idealPos-e.idealPos});if("function"==typeof t.algorithm)return t.algorithm(o,t);if(r.hasOwnProperty(t.algorithm))return r[t.algorithm](o);throw"Unknown algorithm: "+t.algorithm},e};s.DEFAULT_OPTIONS=o,t.exports=s},function(t,e,r){"use strict";var n={isDefined:function(t){return null!==t&&void 0!==t},last:function(t){return t.length>0?t[t.length-1]:null},pick:function(t,e){return e.reduce(function(e,r){return e[r]=t[r],e},{})},sum:function(t,e){return t.map(e).reduce(function(t,e){return t+e},0)}};n.extend=r(5),t.exports=n},function(t,e){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n=Object.prototype.hasOwnProperty,i=Object.prototype.toString,o=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===i.call(t)},s=function(t){if(!t||"[object Object]"!==i.call(t))return!1;var e=n.call(t,"constructor"),r=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!r)return!1;var o;for(o in t);return void 0===o||n.call(t,o)};t.exports=function u(){var t,e,n,i,a,c,h=arguments[0],l=1,f=arguments.length,p=!1;for("boolean"==typeof h?(p=h,h=arguments[1]||{},l=2):("object"!==("undefined"==typeof h?"undefined":r(h))&&"function"!=typeof h||null==h)&&(h={});l<f;++l)if(t=arguments[l],null!=t)for(e in t)n=h[e],i=t[e],h!==i&&(p&&i&&(s(i)||(a=o(i)))?(a?(a=!1,c=n&&o(n)?n:[]):c=n&&s(n)?n:{},h[e]=u(p,c,i)):void 0!==i&&(h[e]=i));return h}},function(t,e,r){"use strict";function n(t,e){if(e||(e={}),this.startKey=e.startKey||0,this.endKey=e.endKey||1,this.intervalHash={},this.pointTree=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t[0]-e[0];return r>0?1:0==r?0:-1}}),this._autoIncrement=0,!t||"number"!=typeof t)throw new Error("you must specify center index as the 2nd argument.");this.root=new u(t,this)}function i(t,e){return e.end<t.idx?(t.left||(t.left=new u(e.start+e.end>>1,this)),i.call(this,t.left,e)):t.idx<e.start?(t.right||(t.right=new u(e.start+e.end>>1,this)),i.call(this,t.right,e)):t.insert(e)}function o(t,e,r){if(t)return e<t.idx?(t.starts.every(function(t){var n=t.start<=e;return n&&r.push(t.result()),n}),o.call(this,t.left,e,r)):e>t.idx?(t.ends.every(function(t){var n=t.end>=e;return n&&r.push(t.result()),n}),o.call(this,t.right,e,r)):void t.starts.map(function(t){r.push(t.result())})}function s(t,e,r){if(e-t<=0)throw new Error("end must be greater than start. start: "+t+", end: "+e);var n={},i=[];o.call(this,this.root,t+e>>1,i,!0),i.forEach(function(t){n[t.id]=!0});for(var s=this.pointTree.bsearch([t,null]),u=this.pointTree;s>=0&&u[s][0]==t;)s--;var a=this.pointTree.bsearch([e,null]);if(a>=0){for(var c=u.length-1;a<=c&&u[a][0]<=e;)a++;u.slice(s+1,a).forEach(function(t){var e=t[1];n[e]=!0},this),Object.keys(n).forEach(function(n){var i=this.intervalHash[n];r.push(i.result(t,e))},this)}}function u(t){this.idx=t,this.starts=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t.start-e.start;return r>0?1:0==r?0:-1}}),this.ends=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t.end-e.end;return r<0?1:0==r?0:-1}})}function a(t,e,r,n){if(this.id=e,this.start=t[r],this.end=t[n],this.data=t,"number"!=typeof this.start||"number"!=typeof this.end)throw new Error("start, end must be number. start: "+this.start+", end: "+this.end);if(this.start>=this.end)throw new Error("start must be smaller than end. start: "+this.start+", end: "+this.end)}var c=r(7);n.prototype.add=function(t,e){if(this.intervalHash[e])throw new Error("id "+e+" is already registered.");if(void 0==e){for(;this.intervalHash[this._autoIncrement];)this._autoIncrement++;e=this._autoIncrement}var r=new a(t,e,this.startKey,this.endKey);this.pointTree.insert([r.start,e]),this.pointTree.insert([r.end,e]),this.intervalHash[e]=r,this._autoIncrement++,i.call(this,this.root,r)},n.prototype.search=function(t,e){var r=[];if("number"!=typeof t)throw new Error(t+": invalid input");if(void 0==e)o.call(this,this.root,t,r);else{if("number"!=typeof e)throw new Error(t+","+e+": invalid input");s.call(this,t,e,r)}return r},n.prototype.remove=function(t){},u.prototype.insert=function(t){this.starts.insert(t),this.ends.insert(t)},a.prototype.result=function(t,e){var r={id:this.id,data:this.data};if("number"==typeof t&&"number"==typeof e){var n=Math.max(this.start,t),i=Math.min(this.end,e),o=i-n;r.rate1=o/(e-t),r.rate2=o/(this.end-this.start)}return r},t.exports=n},function(t,e){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n=function i(){var t=null,e={},n=arguments;["0","1"].forEach(function(i){var o=n[i];Array.isArray(o)?t=o:o&&"object"==("undefined"==typeof o?"undefined":r(o))&&(e=o)}),"function"==typeof e.filter&&(this._filter=e.filter),"function"==typeof e.compare?this._compare=e.compare:"string"==typeof e.compare&&i.compares[e.compare]&&(this._compare=i.compares[e.compare]),this._unique=!!e.unique,e.resume&&t?t.forEach(function(t,e){this.push(t)},this):t&&this.insert.apply(this,t)};n.create=function(t,e){return new n(t,e)},n.prototype=new Array,n.prototype.constructor=Array.prototype.constructor,n.prototype.insertOne=function(t){var e=this.bsearch(t);return(!this._unique||null==this.key(t,e))&&(!!this._filter(t,e)&&(this.splice(e+1,0,t),e+1))},n.prototype.insert=function(){return Array.prototype.map.call(arguments,function(t){return this.insertOne(t)},this)},n.prototype.remove=function(t){return this.splice(t,1),this},n.prototype.bsearch=function(t){if(!this.length)return-1;for(var e,r=0,n=this.length;n-r>1;){e=Math.floor((r+n)/2);var i=this[e],o=this._compare(t,i);if(0==o)return e;o>0?r=e:n=e}return 0==r&&this._compare(this[0],t)>0?-1:r},n.prototype.key=function(t,e){null==e&&(e=this.bsearch(t));var r=e;if(r==-1||this._compare(this[r],t)<0)return r+1<this.length&&0==this._compare(this[r+1],t)?r+1:null;for(;r>=1&&0==this._compare(this[r-1],t);)r--;return r},n.prototype.keys=function(t,e){var r=[];null==e&&(e=this.bsearch(t));for(var n=e;n>=0&&0==this._compare(this[n],t);)r.push(n),n--;var i=this.length;for(n=e+1;n<i&&0==this._compare(this[n],t);)r.push(n),n++;return r.length?r:null},n.prototype.unique=function(t){if(t)return this.filter(function(t,e){return 0==e||0!=this._compare(this[e-1],t)},this);var e=0;return this.map(function(t,r){return 0==r||0!=this._compare(this[r-1],t)?null:r-e++},this).forEach(function(t){null!=t&&this.remove(t)},this),this},n.prototype.toArray=function(){return this.slice()},n.prototype._filter=function(t,e){return!0},n.compares={number:function(t,e){var r=t-e;return r>0?1:0==r?0:-1},string:function(t,e){return t>e?1:t==e?0:-1}},n.prototype._compare=n.compares.string,t.exports=n},function(t,e,r){"use strict";function n(t){var e=new s.Variable(t.targetPos);return e.node=t,e}function i(t,e){if(t.length>0){e=o.extend(u,e),t.forEach(function(t,e){t.targetPos=t.parent?t.parent.currentPos:t.idealPos,t.index=e});for(var r=t.concat().sort(function(t,e){var r=t.targetPos-e.targetPos;if(0!==r)return r;var n=t.isStub()-e.isStub();return 0!==n?n:t.index-e.index}).map(n),i=[],a=1;a<r.length;a++){var c=r[a-1],h=r[a],l=void 0;l=c.node.isStub()&&h.node.isStub()?(c.node.width+h.node.width)/2+e.lineSpacing:(c.node.width+h.node.width)/2+e.nodeSpacing,i.push(new s.Constraint(c,h,l))}if(o.isDefined(e.minPos)){var f=new s.Variable(e.minPos,1e10),p=r[0];i.push(new s.Constraint(f,p,p.node.width/2)),r.unshift(f)}if(o.isDefined(e.maxPos)){var d=new s.Variable(e.maxPos,1e10),v=o.last(r);i.push(new s.Constraint(v,d,v.node.width/2)),r.push(d)}new s.Solver(r,i).solve(),r.filter(function(t){return t.node}).map(function(t){return t.node.currentPos=Math.round(t.position()),t})}return t}var o=r(4),s=r(9),u={lineSpacing:2,nodeSpacing:3,minPos:0,maxPos:null};i.DEFAULT_OPTIONS=u,t.exports=i},function(t,e){"use strict";var r={},n=function(){function t(t){this.scale=t,this.AB=0,this.AD=0,this.A2=0}return t.prototype.addVariable=function(t){var e=this.scale/t.scale,r=t.offset/t.scale,n=t.weight;this.AB+=n*e*r,this.AD+=n*e*t.desiredPosition,this.A2+=n*e*e},t.prototype.getPosn=function(){return(this.AD-this.AB)/this.A2},t}();r.PositionStats=n;var i=function(){function t(t,e,r,n){void 0===n&&(n=!1),this.left=t,this.right=e,this.gap=r,this.equality=n,this.active=!1,this.unsatisfiable=!1,this.left=t,this.right=e,this.gap=r,this.equality=n}return t.prototype.slack=function(){return this.unsatisfiable?Number.MAX_VALUE:this.right.scale*this.right.position()-this.gap-this.left.scale*this.left.position()},t}();r.Constraint=i;var o=function(){function t(t,e,r){void 0===e&&(e=1),void 0===r&&(r=1),this.desiredPosition=t,this.weight=e,this.scale=r,this.offset=0}return t.prototype.dfdv=function(){return 2*this.weight*(this.position()-this.desiredPosition)},t.prototype.position=function(){return(this.block.ps.scale*this.block.posn+this.offset)/this.scale},t.prototype.visitNeighbours=function(t,e){var r=function(r,n){return r.active&&t!==n&&e(r,n)};this.cOut.forEach(function(t){return r(t,t.right)}),this.cIn.forEach(function(t){return r(t,t.left)})},t}();r.Variable=o;var s=function(){function t(t){this.vars=[],t.offset=0,this.ps=new n(t.scale),this.addVariable(t)}return t.prototype.addVariable=function(t){t.block=this,this.vars.push(t),this.ps.addVariable(t),this.posn=this.ps.getPosn()},t.prototype.updateWeightedPosition=function(){this.ps.AB=this.ps.AD=this.ps.A2=0;for(var t=0,e=this.vars.length;t<e;++t)this.ps.addVariable(this.vars[t]);this.posn=this.ps.getPosn()},t.prototype.compute_lm=function(t,e,r){var n=this,i=t.dfdv();return t.visitNeighbours(e,function(e,o){var s=n.compute_lm(o,t,r);o===e.right?(i+=s*e.left.scale,e.lm=s):(i+=s*e.right.scale,e.lm=-s),r(e)}),i/t.scale},t.prototype.populateSplitBlock=function(t,e){var r=this;t.visitNeighbours(e,function(e,n){n.offset=t.offset+(n===e.right?e.gap:-e.gap),r.addVariable(n),r.populateSplitBlock(n,t)})},t.prototype.traverse=function(t,e,r,n){var i=this;void 0===r&&(r=this.vars[0]),void 0===n&&(n=null),r.visitNeighbours(n,function(n,o){e.push(t(n)),i.traverse(t,e,o,r)})},t.prototype.findMinLM=function(){var t=null;return this.compute_lm(this.vars[0],null,function(e){!e.equality&&(null===t||e.lm<t.lm)&&(t=e)}),t},t.prototype.findMinLMBetween=function(t,e){this.compute_lm(t,null,function(){});var r=null;return this.findPath(t,null,e,function(t,e){!t.equality&&t.right===e&&(null===r||t.lm<r.lm)&&(r=t)}),r},t.prototype.findPath=function(t,e,r,n){var i=this,o=!1;return t.visitNeighbours(e,function(e,s){o||s!==r&&!i.findPath(s,t,r,n)||(o=!0,n(e,s))}),o},t.prototype.isActiveDirectedPathBetween=function(t,e){if(t===e)return!0;for(var r=t.cOut.length;r--;){var n=t.cOut[r];if(n.active&&this.isActiveDirectedPathBetween(n.right,e))return!0}return!1},t.split=function(e){return e.active=!1,[t.createSplitBlock(e.left),t.createSplitBlock(e.right)]},t.createSplitBlock=function(e){var r=new t(e);return r.populateSplitBlock(e,null),r},t.prototype.splitBetween=function(e,r){var n=this.findMinLMBetween(e,r);if(null!==n){var i=t.split(n);return{constraint:n,lb:i[0],rb:i[1]}}return null},t.prototype.mergeAcross=function(t,e,r){e.active=!0;for(var n=0,i=t.vars.length;n<i;++n){var o=t.vars[n];o.offset+=r,this.addVariable(o)}this.posn=this.ps.getPosn()},t.prototype.cost=function(){for(var t=0,e=this.vars.length;e--;){var r=this.vars[e],n=r.position()-r.desiredPosition;t+=n*n*r.weight}return t},t}();r.Block=s;var u=function(){function t(t){this.vs=t;var e=t.length;for(this.list=new Array(e);e--;){var r=new s(t[e]);this.list[e]=r,r.blockInd=e}}return t.prototype.cost=function(){for(var t=0,e=this.list.length;e--;)t+=this.list[e].cost();return t},t.prototype.insert=function(t){t.blockInd=this.list.length,this.list.push(t)},t.prototype.remove=function(t){var e=this.list.length-1,r=this.list[e];this.list.length=e,t!==r&&(this.list[t.blockInd]=r,r.blockInd=t.blockInd)},t.prototype.merge=function(t){var e=t.left.block,r=t.right.block,n=t.right.offset-t.left.offset-t.gap;e.vars.length<r.vars.length?(r.mergeAcross(e,t,n),this.remove(e)):(e.mergeAcross(r,t,-n),this.remove(r))},t.prototype.forEach=function(t){this.list.forEach(t)},t.prototype.updateBlockPositions=function(){this.list.forEach(function(t){return t.updateWeightedPosition()})},t.prototype.split=function(t){var e=this;this.updateBlockPositions(),this.list.forEach(function(r){var n=r.findMinLM();null!==n&&n.lm<a.LAGRANGIAN_TOLERANCE&&(r=n.left.block,s.split(n).forEach(function(t){return e.insert(t)}),e.remove(r),t.push(n))})},t}();r.Blocks=u;var a=function(){function t(t,e){this.vs=t,this.cs=e,this.vs=t,t.forEach(function(t){t.cIn=[],t.cOut=[]}),this.cs=e,e.forEach(function(t){t.left.cOut.push(t),t.right.cIn.push(t)}),this.inactive=e.map(function(t){return t.active=!1,t}),this.bs=null}return t.prototype.cost=function(){return this.bs.cost()},t.prototype.setStartingPositions=function(t){this.inactive=this.cs.map(function(t){return t.active=!1,t}),this.bs=new u(this.vs),this.bs.forEach(function(e,r){return e.posn=t[r]})},t.prototype.setDesiredPositions=function(t){this.vs.forEach(function(e,r){return e.desiredPosition=t[r]})},t.prototype.mostViolated=function(){for(var e=Number.MAX_VALUE,r=null,n=this.inactive,i=n.length,o=i,s=0;s<i;++s){var u=n[s];if(!u.unsatisfiable){var a=u.slack();if((u.equality||a<e)&&(e=a,r=u,o=s,u.equality))break}}return o!==i&&(e<t.ZERO_UPPERBOUND&&!r.active||r.equality)&&(n[o]=n[i-1],n.length=i-1),r},t.prototype.satisfy=function(){null==this.bs&&(this.bs=new u(this.vs)),this.bs.split(this.inactive);for(var e=null;(e=this.mostViolated())&&(e.equality||e.slack()<t.ZERO_UPPERBOUND&&!e.active);){var r=e.left.block,n=e.right.block;if(r!==n)this.bs.merge(e);else{if(r.isActiveDirectedPathBetween(e.right,e.left)){e.unsatisfiable=!0;continue}var i=r.splitBetween(e.left,e.right);if(null===i){e.unsatisfiable=!0;continue}this.bs.insert(i.lb),this.bs.insert(i.rb),this.bs.remove(r),this.inactive.push(i.constraint),e.slack()>=0?this.inactive.push(e):this.bs.merge(e)}}},t.prototype.solve=function(){this.satisfy();for(var t=Number.MAX_VALUE,e=this.bs.cost();Math.abs(t-e)>1e-4;)this.satisfy(),t=e,e=this.bs.cost();return e},t.LAGRANGIAN_TOLERANCE=-1e-4,t.ZERO_UPPERBOUND=-1e-10,t}();r.Solver=a,t.exports=r},function(t,e,r){"use strict";function n(t){this.options=c.extend({layerGap:60,nodeHeight:10,direction:"down"},t)}function i(t){return"L "+t.join(" ")}function o(t){return"M "+t.join(" ")}function s(t,e,r){return"C "+t.join(" ")+" "+e.join(" ")+" "+r.join(" ")}function u(t,e){var r=(t[1]+e[1])/2;return s([t[0],r],[e[0],r],e)}function a(t,e){var r=(t[0]+e[0])/2;return s([r,t[1]],[r,e[1]],e)}var c=r(4);n.lineTo=i,n.moveTo=o,n.curveTo=s,n.vCurveBetween=u,n.hCurveBetween=a,n.prototype.getWaypoints=function(t){var e=this.options,r=e.direction,n=t.getPathFromRoot(),i=e.nodeHeight+e.layerGap;return"left"===r?[[[0,n[0].idealPos]]].concat(n.map(function(t,r){var n=i*(r+1)*-1;return[[n+e.nodeHeight,t.currentPos],[n,t.currentPos]]})):"right"===r?[[[0,n[0].idealPos]]].concat(n.map(function(t,r){var n=i*(r+1);return[[n-e.nodeHeight,t.currentPos],[n,t.currentPos]]})):"up"===r?[[[n[0].idealPos,0]]].concat(n.map(function(t,r){var n=i*(r+1)*-1;return[[t.currentPos,n+e.nodeHeight],[t.currentPos,n]]})):[[[n[0].idealPos,0]]].concat(n.map(function(t,r){var n=i*(r+1);return[[t.currentPos,n-e.nodeHeight],[t.currentPos,n]]}))},n.prototype.layout=function(t){var e=this.options,r=e.layerGap+e.nodeHeight;switch(e.direction){case"left":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=-n-e.nodeHeight,t.y=t.currentPos,t.dx=e.nodeHeight,t.dy=t.width});break;case"right":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=n,t.y=t.currentPos,t.dx=e.nodeHeight,t.dy=t.width});break;case"up":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=t.currentPos,t.y=-n-e.nodeHeight,t.dx=t.width,t.dy=e.nodeHeight});break;default:case"down":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=t.currentPos,t.y=n,t.dx=t.width,t.dy=e.nodeHeight})}return t},n.prototype.generatePath=function(t){var e=this.options,r=e.direction,n=this.getWaypoints(t,r),s=[o(n[0][0])];return"left"===r||"right"===r?n.reduce(function(t,e,r){return s.push(a(t[t.length-1],e[0])),r<n.length-1&&s.push(i(e[1])),e}):n.reduce(function(t,e,r){return s.push(u(t[t.length-1],e[0])),r<n.length-1&&s.push(i(e[1])),e}),s.join(" ")},t.exports=n}])});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Shape = __webpack_require__(7);

var _lineDrawing = __webpack_require__(46);

var _semioticMark = __webpack_require__(6);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var DividedLine = function (_React$Component) {
  _inherits(DividedLine, _React$Component);

  function DividedLine(props) {
    _classCallCheck(this, DividedLine);

    var _this = _possibleConstructorReturn(this, (DividedLine.__proto__ || Object.getPrototypeOf(DividedLine)).call(this, props));

    _this.createLineSegments = _this.createLineSegments.bind(_this);
    return _this;
  }

  _createClass(DividedLine, [{
    key: "createLineSegments",
    value: function createLineSegments() {
      var _this2 = this;

      var params = this.props.parameters;
      var className = this.props.className;
      var interpolate = this.props.interpolate || _d3Shape.curveLinear;

      var data = (0, _lineDrawing.projectLineData)({
        data: this.props.data,
        lineDataAccessor: this.props.lineDataAccessor,
        xProp: "_x",
        yProp: "_y",
        xAccessor: this.props.customAccessors.x,
        yAccessor: this.props.customAccessors.y
      });

      //Compatibility before Semiotic 2
      data.forEach(function (projectedD) {
        projectedD.data = projectedD.data.map(function (d) {
          return _extends({}, d.data, d);
        });
      });

      var lines = (0, _lineDrawing.dividedLine)(params, data[0].data, this.props.searchIterations);

      var lineRender = (0, _d3Shape.line)().curve(interpolate).x(function (d) {
        return d._x;
      }).y(function (d) {
        return d._y;
      });

      return lines.map(function (d, i) {
        return _react2.default.createElement(_semioticMark.Mark, _extends({}, _this2.props, {
          className: className,
          markType: "path",
          key: "DividedLine-" + i,
          style: d.key,
          d: lineRender(d.points)
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var lines = this.createLineSegments();

      return _react2.default.createElement(
        "g",
        null,
        lines
      );
    }
  }]);

  return DividedLine;
}(_react2.default.Component);

DividedLine.propTypes = {
  parameters: _propTypes2.default.func,
  className: _propTypes2.default.string,
  interpolate: _propTypes2.default.func,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  lineDataAccessor: _propTypes2.default.func,
  customAccessors: _propTypes2.default.object,
  searchIterations: _propTypes2.default.number
};

exports.default = DividedLine;
module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(138);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(145);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(139);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(29);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(71);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(147);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(39),n=__webpack_require__(63),p=__webpack_require__(40),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(48);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(150);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(149);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(300);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(73);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(72);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(77);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(78);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(48);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(48);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(331);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(155);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(80);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(80);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(79);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(164);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["namespace"])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["h" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(156);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(156);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(337);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(338);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(30);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(30);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(30);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(30);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["namespace"])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(10);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(10);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(10);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(15);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["matcher"])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(10);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selector"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selectorAll"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(164);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["g" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(51);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(361);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(362);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(363);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(364);
/* unused harmony reexport easePoly */
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(365);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(366);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(367);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(368);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(369);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(370);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* unused harmony export polyInOut */
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(10);



var root = [null];

/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.areaLineGenerator = areaLineGenerator;
exports.areaLine = areaLine;
exports.verticalbar = verticalbar;
exports.horizontalbar = horizontalbar;
exports.pathStr = pathStr;
exports.circlePath = circlePath;
exports.rectPath = rectPath;
exports.linePath = linePath;
exports.jitterLine = jitterLine;
exports.cheapSketchy = cheapSketchy;
exports.cheapPopArtsy = cheapPopArtsy;
exports.randomColor = randomColor;
exports.painty = painty;
exports.generateSVG = generateSVG;

var _react = __webpack_require__(47);

var _react2 = _interopRequireDefault(_react);

var _d3Shape = __webpack_require__(7);

var _d3Color = __webpack_require__(4);

var _d3Selection = __webpack_require__(3);

var _d3Scale = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//All generic line constructors expect a projected coordinates array with x & y coordinates, if there are no y1 & x1 coordinates then it defaults to 0-width
function roundToTenth(number) {
  return Math.round(number * 10) / 10;
}

function areaLineGenerator(customAccessors, interpolator) {
  var lineGenerator = (0, _d3Shape.area)().x0(customAccessors.x).y0(customAccessors.y).x1(customAccessors.x1).y1(customAccessors.y1).interpolate(interpolator || "linear");
  return lineGenerator;
}

function areaLine(props) {
  var lineGenerator = areaLineGenerator(props.customAccessors, props.interpolate);
  props.d = lineGenerator(props.coordinates);

  return props;
}

function verticalbar(props) {
  props.y = props.y - props.height;
  return props;
}

function horizontalbar(props) {
  //just flips height for width
  var originalHeight = props.height;
  var originalWidth = props.width;
  props.width = originalHeight;
  props.height = originalWidth;

  return props;
}

function pathStr(_ref) {
  var x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      cx = _ref.cx,
      cy = _ref.cy,
      r = _ref.r;

  if (cx !== undefined) {
    return ["M", roundToTenth(cx - r), roundToTenth(cy), "a", r, r, 0, 1, 0, r * 2, 0, "a", r, r, 0, 1, 0, -(r * 2), 0].join(" ") + "Z";
  }
  return ["M", roundToTenth(x), roundToTenth(y), "h", width, "v", height, "h", -width, "v", -height].join(" ") + "Z";
}

function circlePath(cx, cy, r) {
  return pathStr({ cx: cx, cy: cy, r: r });
}

function rectPath(x, y, width, height) {
  return pathStr({ x: x, y: y, width: width, height: height });
}

function linePath(x1, x2, y1, y2) {
  return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "L";
}

function jitterLine(pathNode) {
  var length = pathNode.getTotalLength();
  var j = 2;
  var x = j + Math.random() * j * 5;
  var jitteredPoints = [];
  var lineGen = (0, _d3Shape.line)().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).curve(_d3Shape.curveBasis);

  var newPoint = pathNode.getPointAtLength(0);
  jitteredPoints.push(newPoint);

  while (x < length) {
    newPoint = pathNode.getPointAtLength(x);
    var newX = newPoint.x + (Math.random() * j - j / 2);
    var newY = newPoint.y + (Math.random() * j - j / 2);
    jitteredPoints.push({ x: newX, y: newY });
    x += j + Math.random() * j * 5;
  }
  newPoint = pathNode.getPointAtLength(length);
  jitteredPoints.push(newPoint);

  return lineGen(jitteredPoints);
}

function cheapSketchy(path) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (opacity === 0) {
    //no fill
    return "";
  }
  var opacitySketchyScale = (0, _d3Scale.scaleLinear)().domain([0, 1]).range([10, 1]).clamp(true);
  var length = path.getTotalLength();
  var drawCode = "";
  var x = 0;
  var step = opacitySketchyScale(opacity);

  while (x < length / 2) {
    var start = path.getPointAtLength(x);
    var end = path.getPointAtLength(length - x);

    drawCode += " M" + (start.x + (Math.random() * step - step / 2)) + " " + (start.y + (Math.random() * step - step / 2)) + "L" + (end.x + (Math.random() * step - step / 2)) + " " + (end.y + (Math.random() * step - step / 2));

    x += step + Math.random() * step;
  }

  return drawCode;
}

function cheapPopArtsy(path, size) {
  var length = path.getTotalLength();
  var circles = [];
  var x = 0;
  var step = size * 3;

  while (x < length / 2) {
    var start = path.getPointAtLength(x);
    var end = path.getPointAtLength(length - x);
    var distance = Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2));
    var begin = size / 2;
    while (begin < distance - size / 2) {
      var percent = begin / distance;
      var circleXa = percent * start.x;
      var circleXb = (1 - percent) * end.x;
      var circleYa = percent * start.y;
      var circleYb = (1 - percent) * end.y;
      circles.push([circleXa + circleXb, circleYa + circleYb]);
      begin = begin + (step + Math.random());
    }
    x = x + step;
  }

  return circles;
}

function randomColor(baseColor, range) {
  var hslBase = (0, _d3Color.hsl)(baseColor);
  hslBase.h = hslBase.h + (Math.floor(Math.random() * (range * 255)) - Math.floor(range / 2));
  hslBase.s = hslBase.s + (Math.floor(Math.random() * range) - Math.floor(range / 2));
  hslBase.l = hslBase.l + (Math.floor(Math.random() * range) - Math.floor(range / 2));
  return hslBase.toString();
}

function painty(markType, cloneProps) {
  delete cloneProps.markType;
  if ((markType === "path" || markType === "circle" || markType === "line" || markType === "rect") && cloneProps.style && (cloneProps.style.stroke || cloneProps.style.fill)) {
    if (markType === "circle") {
      cloneProps.d = circlePath(cloneProps.cx || 0, cloneProps.cy || 0, cloneProps.r);
    }

    if (markType === "rect") {
      cloneProps.d = rectPath(cloneProps.x || 0, cloneProps.y || 0, cloneProps.width, cloneProps.height);
    }

    if (markType === "line") {
      cloneProps.d = linePath(cloneProps.x1, cloneProps.x2, cloneProps.y1, cloneProps.y2);
    }

    (0, _d3Selection.select)("body").append("svg").attr("id", "sketchyTempSVG");

    var fills = [];
    var outlines = [];

    cloneProps.d.split("M").filter(function (d, i) {
      return i !== 0;
    }).forEach(function (pathD, i) {
      var pathDummy = (0, _d3Selection.select)("#sketchyTempSVG").append("path").attr("class", cloneProps.className).attr("d", "M" + pathD);

      var pathNode = pathDummy.node();

      if (cloneProps.style && cloneProps.style.fill !== "none") {
        var sketchyFill = cheapPopArtsy(pathNode, 4);
        var fillProps = _extends({}, cloneProps);
        var fillStyle = _extends({}, cloneProps.style);
        var fillValue = fillStyle.fill;
        fillProps.style = fillStyle;
        delete fillProps.d;
        delete fillProps.style.fillOpacity;
        delete fillProps.style.stroke;
        delete fillProps.style.strokeWidth;

        fills.push(sketchyFill.map(function (circle, ci) {
          fillProps.key = "painty-fill-" + i + "-" + ci;
          fillProps.cx = circle[0];
          fillProps.cy = circle[1];
          fillProps.style = _extends({}, fillProps.style);
          fillProps.style.fill = fillProps.style.fill.substr(0, 3) === "url" ? fillProps.style.fill : randomColor(fillValue, 0.05);
          fillProps.r = Math.random() * 2 + 3;
          return _react2.default.createElement("circle", fillProps);
        }));
      }

      if (cloneProps.style && cloneProps.style.stroke !== "none" && cloneProps.style.strokeWidth !== 0) {
        var sketchyOutline = jitterLine(pathNode);

        var outlineProps = _extends({}, cloneProps);
        var outlineStyle = _extends({}, cloneProps.style);
        outlineProps.style = outlineStyle;
        outlineProps.d = sketchyOutline;
        outlineProps.key = "painty-outline-" + i;
        outlineProps.style.fill = "none";

        outlines.push(_react2.default.createElement("path", outlineProps));
      }
    });

    (0, _d3Selection.select)("#sketchyTempSVG").remove();

    return [_react2.default.createElement("path", {
      key: "painty-interaction-overlay",
      d: cloneProps.d,
      style: { opacity: 0 }
    }), _react2.default.createElement(
      "g",
      { key: "painty-fill", style: { filter: "url(#paintyFilterHeavy)" } },
      fills
    ), outlines];
  }

  return _react2.default.createElement(markType, cloneProps);
}

function generateSVG(props, className) {
  var markType = props.markType;
  var renderMode = props.renderMode;

  var cloneProps = _extends({}, props);
  delete cloneProps.markType;
  delete cloneProps.renderMode;
  delete cloneProps.resetAfter;
  delete cloneProps.droppable;
  delete cloneProps.nid;
  delete cloneProps.dropFunction;
  delete cloneProps.context;
  delete cloneProps.updateContext;
  delete cloneProps.parameters;
  delete cloneProps.lineDataAccessor;
  delete cloneProps.customAccessors;
  delete cloneProps.interpolate;
  delete cloneProps.forceUpdate;
  delete cloneProps.searchIterations;
  delete cloneProps.simpleInterpolate;
  delete cloneProps.transitionDuration;
  delete cloneProps.tx;
  delete cloneProps.ty;

  if (markType === "verticalbar") {
    markType = "rect";
    cloneProps = verticalbar(cloneProps);
  } else if (markType === "horizontalbar") {
    markType = "rect";
    cloneProps = horizontalbar(cloneProps);
  } else if (markType === "simpleline") {
    markType = "path";
    cloneProps = areaLine(cloneProps);
  }

  //        let transform = cloneProps['transform'];
  if (props.draggable) {
    delete cloneProps.transform;
  }

  cloneProps.className = className;

  var actualSVG = null;

  if (renderMode === "painty") {
    actualSVG = painty(markType, cloneProps);
  } else if (renderMode === "forcePath" && markType === "circle") {
    cloneProps.d = circlePath(cloneProps.cx || 0, cloneProps.cy || 0, cloneProps.r);
    markType = "path";
    actualSVG = _react2.default.createElement(markType, cloneProps);
  } else if (renderMode === "forcePath" && markType === "rect") {
    cloneProps.d = rectPath(cloneProps.x || 0, cloneProps.y || 0, cloneProps.width, cloneProps.height);
    markType = "path";
    actualSVG = _react2.default.createElement(markType, cloneProps);
  } else {
    if (props.markType === "text" && _typeof(cloneProps.children) !== "object") {
      cloneProps.children = _react2.default.createElement(
        "tspan",
        null,
        cloneProps.children
      );
    }
    actualSVG = _react2.default.createElement(markType, cloneProps);
  }
  return actualSVG;
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(165);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(85);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(166);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(167);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(168);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(87);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(53);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(53);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(53);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(52);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(52);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(19);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(32);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(19);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(5);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(89);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(88);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(12);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(32);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(420);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoughHachureIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _segment = __webpack_require__(180);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoughHachureIterator = exports.RoughHachureIterator = function () {
  function RoughHachureIterator(top, bottom, left, right, gap, sinAngle, cosAngle, tanAngle) {
    _classCallCheck(this, RoughHachureIterator);

    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
    this.gap = gap;
    this.sinAngle = sinAngle;
    this.tanAngle = tanAngle;

    if (Math.abs(sinAngle) < 0.0001) {
      this.pos = left + gap;
    } else if (Math.abs(sinAngle) > 0.9999) {
      this.pos = top + gap;
    } else {
      this.deltaX = (bottom - top) * Math.abs(tanAngle);
      this.pos = left - Math.abs(this.deltaX);
      this.hGap = Math.abs(gap / cosAngle);
      this.sLeft = new _segment.RoughSegment(left, bottom, left, top);
      this.sRight = new _segment.RoughSegment(right, bottom, right, top);
    }
  }

  _createClass(RoughHachureIterator, [{
    key: "getNextLine",
    value: function getNextLine() {
      if (Math.abs(this.sinAngle) < 0.0001) {
        if (this.pos < this.right) {
          var line = [this.pos, this.top, this.pos, this.bottom];
          this.pos += this.gap;
          return line;
        }
      } else if (Math.abs(this.sinAngle) > 0.9999) {
        if (this.pos < this.bottom) {
          var _line = [this.left, this.pos, this.right, this.pos];
          this.pos += this.gap;
          return _line;
        }
      } else {
        var xLower = this.pos - this.deltaX / 2;
        var xUpper = this.pos + this.deltaX / 2;
        var yLower = this.bottom;
        var yUpper = this.top;
        if (this.pos < this.right + this.deltaX) {
          while (xLower < this.left && xUpper < this.left || xLower > this.right && xUpper > this.right) {
            this.pos += this.hGap;
            xLower = this.pos - this.deltaX / 2;
            xUpper = this.pos + this.deltaX / 2;
            if (this.pos > this.right + this.deltaX) {
              return null;
            }
          }
          var s = new _segment.RoughSegment(xLower, yLower, xUpper, yUpper);
          if (s.compare(this.sLeft) == (0, _segment.RoughSegmentRelation)().INTERSECTS) {
            xLower = s.xi;
            yLower = s.yi;
          }
          if (s.compare(this.sRight) == (0, _segment.RoughSegmentRelation)().INTERSECTS) {
            xUpper = s.xi;
            yUpper = s.yi;
          }
          if (this.tanAngle > 0) {
            xLower = this.right - (xLower - this.left);
            xUpper = this.right - (xUpper - this.left);
          }
          var _line2 = [xLower, yLower, xUpper, yUpper];
          this.pos += this.hGap;
          return _line2;
        }
      }
      return null;
    }
  }]);

  return RoughHachureIterator;
}();

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PathToken = function () {
  function PathToken(type, text) {
    _classCallCheck(this, PathToken);

    this.type = type;
    this.text = text;
  }

  _createClass(PathToken, [{
    key: "isType",
    value: function isType(type) {
      return this.type === type;
    }
  }]);

  return PathToken;
}();

var ParsedPath = function () {
  function ParsedPath(d) {
    _classCallCheck(this, ParsedPath);

    this.PARAMS = {
      A: ["rx", "ry", "x-axis-rotation", "large-arc-flag", "sweep-flag", "x", "y"],
      a: ["rx", "ry", "x-axis-rotation", "large-arc-flag", "sweep-flag", "x", "y"],
      C: ["x1", "y1", "x2", "y2", "x", "y"],
      c: ["x1", "y1", "x2", "y2", "x", "y"],
      H: ["x"],
      h: ["x"],
      L: ["x", "y"],
      l: ["x", "y"],
      M: ["x", "y"],
      m: ["x", "y"],
      Q: ["x1", "y1", "x", "y"],
      q: ["x1", "y1", "x", "y"],
      S: ["x2", "y2", "x", "y"],
      s: ["x2", "y2", "x", "y"],
      T: ["x", "y"],
      t: ["x", "y"],
      V: ["y"],
      v: ["y"],
      Z: [],
      z: []
    };
    this.COMMAND = 0;
    this.NUMBER = 1;
    this.EOD = 2;
    this.segments = [];
    this.d = d || "";
    this.parseData(d);
    this.processPoints();
  }

  _createClass(ParsedPath, [{
    key: "loadFromSegments",
    value: function loadFromSegments(segments) {
      this.segments = segments;
      this.processPoints();
    }
  }, {
    key: "processPoints",
    value: function processPoints() {
      var first = null,
          prev = null,
          currentPoint = [0, 0];
      for (var i = 0; i < this.segments.length; i++) {
        var s = this.segments[i];
        switch (s.key) {
          case 'M':
          case 'L':
          case 'T':
            s.point = [s.data[0], s.data[1]];
            break;
          case 'm':
          case 'l':
          case 't':
            s.point = [s.data[0] + currentPoint[0], s.data[1] + currentPoint[1]];
            break;
          case 'H':
            s.point = [s.data[0], currentPoint[1]];
            break;
          case 'h':
            s.point = [s.data[0] + currentPoint[0], currentPoint[1]];
            break;
          case 'V':
            s.point = [currentPoint[0], s.data[0]];
            break;
          case 'v':
            s.point = [currentPoint[0], s.data[0] + currentPoint[1]];
            break;
          case 'z':
          case 'Z':
            if (first) {
              s.point = [first[0], first[1]];
            }
            break;
          case 'C':
            s.point = [s.data[4], s.data[5]];
            break;
          case 'c':
            s.point = [s.data[4] + currentPoint[0], s.data[5] + currentPoint[1]];
            break;
          case 'S':
            s.point = [s.data[2], s.data[3]];
            break;
          case 's':
            s.point = [s.data[2] + currentPoint[0], s.data[3] + currentPoint[1]];
            break;
          case 'Q':
            s.point = [s.data[2], s.data[3]];
            break;
          case 'q':
            s.point = [s.data[2] + currentPoint[0], s.data[3] + currentPoint[1]];
            break;
          case 'A':
            s.point = [s.data[5], s.data[6]];
            break;
          case 'a':
            s.point = [s.data[5] + currentPoint[0], s.data[6] + currentPoint[1]];
            break;
        }
        if (s.key === 'm' || s.key === 'M') {
          first = null;
        }
        if (s.point) {
          currentPoint = s.point;
          if (!first) {
            first = s.point;
          }
        }
        if (s.key === 'z' || s.key === 'Z') {
          first = null;
        }
        prev = s;
      }
    }
  }, {
    key: "parseData",
    value: function parseData(d) {
      var tokens = this.tokenize(d);
      var index = 0;
      var token = tokens[index];
      var mode = "BOD";
      this.segments = new Array();
      while (!token.isType(this.EOD)) {
        var param_length;
        var params = new Array();
        if (mode == "BOD") {
          if (token.text == "M" || token.text == "m") {
            index++;
            param_length = this.PARAMS[token.text].length;
            mode = token.text;
          } else {
            return this.parseData('M0,0' + d);
          }
        } else {
          if (token.isType(this.NUMBER)) {
            param_length = this.PARAMS[mode].length;
          } else {
            index++;
            param_length = this.PARAMS[token.text].length;
            mode = token.text;
          }
        }

        if (index + param_length < tokens.length) {
          for (var i = index; i < index + param_length; i++) {
            var number = tokens[i];
            if (number.isType(this.NUMBER)) {
              params[params.length] = number.text;
            } else {
              console.error("Parameter type is not a number: " + mode + "," + number.text);
              return;
            }
          }
          var segment;
          if (this.PARAMS[mode]) {
            segment = { key: mode, data: params };
          } else {
            console.error("Unsupported segment type: " + mode);
            return;
          }
          this.segments.push(segment);
          index += param_length;
          token = tokens[index];
          if (mode == "M") mode = "L";
          if (mode == "m") mode = "l";
        } else {
          console.error("Path data ended before all parameters were found");
        }
      }
    }
  }, {
    key: "tokenize",
    value: function tokenize(d) {
      var tokens = new Array();
      while (d != "") {
        if (d.match(/^([ \t\r\n,]+)/)) {
          d = d.substr(RegExp.$1.length);
        } else if (d.match(/^([aAcChHlLmMqQsStTvVzZ])/)) {
          tokens[tokens.length] = new PathToken(this.COMMAND, RegExp.$1);
          d = d.substr(RegExp.$1.length);
        } else if (d.match(/^(([-+]?[0-9]+(\.[0-9]*)?|[-+]?\.[0-9]+)([eE][-+]?[0-9]+)?)/)) {
          tokens[tokens.length] = new PathToken(this.NUMBER, parseFloat(RegExp.$1));
          d = d.substr(RegExp.$1.length);
        } else {
          console.error("Unrecognized segment command: " + d);
          return null;
        }
      }
      tokens[tokens.length] = new PathToken(this.EOD, null);
      return tokens;
    }
  }, {
    key: "closed",
    get: function get() {
      if (typeof this._closed === 'undefined') {
        this._closed = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var s = _step.value;

            if (s.key.toLowerCase() === 'z') {
              this._closed = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return this._closed;
    }
  }]);

  return ParsedPath;
}();

var RoughPath = exports.RoughPath = function () {
  function RoughPath(d) {
    _classCallCheck(this, RoughPath);

    this.d = d;
    this.parsed = new ParsedPath(d);
    this._position = [0, 0];
    this.bezierReflectionPoint = null;
    this.quadReflectionPoint = null;
    this._first = null;
  }

  _createClass(RoughPath, [{
    key: "setPosition",
    value: function setPosition(x, y) {
      this._position = [x, y];
      if (!this._first) {
        this._first = [x, y];
      }
    }
  }, {
    key: "segments",
    get: function get() {
      return this.parsed.segments;
    }
  }, {
    key: "closed",
    get: function get() {
      return this.parsed.closed;
    }
  }, {
    key: "linearPoints",
    get: function get() {
      if (!this._linearPoints) {
        var lp = [];
        var points = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.parsed.segments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var s = _step2.value;

            var key = s.key.toLowerCase();
            if (key === 'm' || key === 'z') {
              if (points.length) {
                lp.push(points);
                points = [];
              }
              if (key === 'z') {
                continue;
              }
            }
            if (s.point) {
              points.push(s.point);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (points.length) {
          lp.push(points);
          points = [];
        }
        this._linearPoints = lp;
      }
      return this._linearPoints;
    }
  }, {
    key: "first",
    get: function get() {
      return this._first;
    },
    set: function set(v) {
      this._first = v;
    }
  }, {
    key: "position",
    get: function get() {
      return this._position;
    }
  }, {
    key: "x",
    get: function get() {
      return this._position[0];
    }
  }, {
    key: "y",
    get: function get() {
      return this._position[1];
    }
  }]);

  return RoughPath;
}();

var RoughArcConverter = exports.RoughArcConverter = function () {
  // Algorithm as described in https://www.w3.org/TR/SVG/implnote.html
  // Code adapted from nsSVGPathDataParser.cpp in Mozilla 
  // https://hg.mozilla.org/mozilla-central/file/17156fbebbc8/content/svg/content/src/nsSVGPathDataParser.cpp#l887
  function RoughArcConverter(from, to, radii, angle, largeArcFlag, sweepFlag) {
    _classCallCheck(this, RoughArcConverter);

    var radPerDeg = Math.PI / 180;
    this._segIndex = 0;
    this._numSegs = 0;
    if (from[0] == to[0] && from[1] == to[1]) {
      return;
    }
    this._rx = Math.abs(radii[0]);
    this._ry = Math.abs(radii[1]);
    this._sinPhi = Math.sin(angle * radPerDeg);
    this._cosPhi = Math.cos(angle * radPerDeg);
    var x1dash = this._cosPhi * (from[0] - to[0]) / 2.0 + this._sinPhi * (from[1] - to[1]) / 2.0;
    var y1dash = -this._sinPhi * (from[0] - to[0]) / 2.0 + this._cosPhi * (from[1] - to[1]) / 2.0;
    var root;
    var numerator = this._rx * this._rx * this._ry * this._ry - this._rx * this._rx * y1dash * y1dash - this._ry * this._ry * x1dash * x1dash;
    if (numerator < 0) {
      var s = Math.sqrt(1 - numerator / (this._rx * this._rx * this._ry * this._ry));
      this._rx = s;
      this._ry = s;
      root = 0;
    } else {
      root = (largeArcFlag == sweepFlag ? -1.0 : 1.0) * Math.sqrt(numerator / (this._rx * this._rx * y1dash * y1dash + this._ry * this._ry * x1dash * x1dash));
    }
    var cxdash = root * this._rx * y1dash / this._ry;
    var cydash = -root * this._ry * x1dash / this._rx;
    this._C = [0, 0];
    this._C[0] = this._cosPhi * cxdash - this._sinPhi * cydash + (from[0] + to[0]) / 2.0;
    this._C[1] = this._sinPhi * cxdash + this._cosPhi * cydash + (from[1] + to[1]) / 2.0;
    this._theta = this.calculateVectorAngle(1.0, 0.0, (x1dash - cxdash) / this._rx, (y1dash - cydash) / this._ry);
    var dtheta = this.calculateVectorAngle((x1dash - cxdash) / this._rx, (y1dash - cydash) / this._ry, (-x1dash - cxdash) / this._rx, (-y1dash - cydash) / this._ry);
    if (!sweepFlag && dtheta > 0) {
      dtheta -= 2 * Math.PI;
    } else if (sweepFlag && dtheta < 0) {
      dtheta += 2 * Math.PI;
    }
    this._numSegs = Math.ceil(Math.abs(dtheta / (Math.PI / 2)));
    this._delta = dtheta / this._numSegs;
    this._T = 8 / 3 * Math.sin(this._delta / 4) * Math.sin(this._delta / 4) / Math.sin(this._delta / 2);
    this._from = from;
  }

  _createClass(RoughArcConverter, [{
    key: "getNextSegment",
    value: function getNextSegment() {
      var cp1, cp2, to;
      if (this._segIndex == this._numSegs) {
        return null;
      }
      var cosTheta1 = Math.cos(this._theta);
      var sinTheta1 = Math.sin(this._theta);
      var theta2 = this._theta + this._delta;
      var cosTheta2 = Math.cos(theta2);
      var sinTheta2 = Math.sin(theta2);

      to = [this._cosPhi * this._rx * cosTheta2 - this._sinPhi * this._ry * sinTheta2 + this._C[0], this._sinPhi * this._rx * cosTheta2 + this._cosPhi * this._ry * sinTheta2 + this._C[1]];
      cp1 = [this._from[0] + this._T * (-this._cosPhi * this._rx * sinTheta1 - this._sinPhi * this._ry * cosTheta1), this._from[1] + this._T * (-this._sinPhi * this._rx * sinTheta1 + this._cosPhi * this._ry * cosTheta1)];
      cp2 = [to[0] + this._T * (this._cosPhi * this._rx * sinTheta2 + this._sinPhi * this._ry * cosTheta2), to[1] + this._T * (this._sinPhi * this._rx * sinTheta2 - this._cosPhi * this._ry * cosTheta2)];

      this._theta = theta2;
      this._from = [to[0], to[1]];
      this._segIndex++;

      return {
        cp1: cp1,
        cp2: cp2,
        to: to
      };
    }
  }, {
    key: "calculateVectorAngle",
    value: function calculateVectorAngle(ux, uy, vx, vy) {
      var ta = Math.atan2(uy, ux);
      var tb = Math.atan2(vy, vx);
      if (tb >= ta) return tb - ta;
      return 2 * Math.PI - (ta - tb);
    }
  }]);

  return RoughArcConverter;
}();

var PathFitter = exports.PathFitter = function () {
  function PathFitter(sets, closed) {
    _classCallCheck(this, PathFitter);

    this.sets = sets;
    this.closed = closed;
  }

  _createClass(PathFitter, [{
    key: "fit",
    value: function fit(simplification) {
      var outSets = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sets[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var set = _step3.value;

          var length = set.length;
          var estLength = Math.floor(simplification * length);
          if (estLength < 5) {
            if (length <= 5) {
              continue;
            }
            estLength = 5;
          }
          outSets.push(this.reduce(set, estLength));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var d = '';
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = outSets[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _set = _step4.value;

          for (var i = 0; i < _set.length; i++) {
            var point = _set[i];
            if (i === 0) {
              d += 'M' + point[0] + "," + point[1];
            } else {
              d += 'L' + point[0] + "," + point[1];
            }
          }
          if (this.closed) {
            d += 'z ';
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return d;
    }
  }, {
    key: "distance",
    value: function distance(p1, p2) {
      return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2));
    }
  }, {
    key: "reduce",
    value: function reduce(set, count) {
      if (set.length <= count) {
        return set;
      }
      var points = set.slice(0);
      while (points.length > count) {
        var areas = [];
        var minArea = -1;
        var minIndex = -1;
        for (var i = 1; i < points.length - 1; i++) {
          var a = this.distance(points[i - 1], points[i]);
          var b = this.distance(points[i], points[i + 1]);
          var c = this.distance(points[i - 1], points[i + 1]);
          var s = (a + b + c) / 2.0;
          var area = Math.sqrt(s * (s - a) * (s - b) * (s - c));
          areas.push(area);
          if (minArea < 0 || area < minArea) {
            minArea = area;
            minIndex = i;
          }
        }
        if (minIndex > 0) {
          points.splice(minIndex, 1);
        } else {
          break;
        }
      }
      return points;
    }
  }]);

  return PathFitter;
}();

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var styleTransitionWhitelist = exports.styleTransitionWhitelist = ["strokeOpacity", "fillOpacity", "strokeWidth", "fill", "stroke", "opacity", "strokeDasharray"];

var redrawSketchyList = exports.redrawSketchyList = ["fill", "stroke", "cx", "cy", "x", "y", "d", "height", "width", "x1", "x2", "y1", "y2", "rx", "ry", "r"];

var attributeTransitionWhitelist = exports.attributeTransitionWhitelist = ["transform"].concat(redrawSketchyList, styleTransitionWhitelist);

//TODO find React Everything to everything translater
var reactCSSNameStyleHash = exports.reactCSSNameStyleHash = {
  strokeWidth: "stroke-width",
  fillOpacity: "fill-opacity",
  strokeOpacity: "stroke-opacity",
  strokeDasharray: "stroke-dasharray"
};

var differentD = exports.differentD = function differentD(d, newD) {
  if (!d || !newD) {
    return true;
  }
  var lowerD = d.toLowerCase();
  var lowerNewD = newD.toLowerCase();

  if ((lowerD.match(/m/g) || []).length !== (lowerNewD.match(/m/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/l/g) || []).length !== (lowerNewD.match(/l/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/c/g) || []).length !== (lowerNewD.match(/c/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/a/g) || []).length !== (lowerNewD.match(/a/g) || []).length) {
    return true;
  }

  return false;
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(47);

var _react2 = _interopRequireDefault(_react);

var _Mark = __webpack_require__(148);

var _Mark2 = _interopRequireDefault(_Mark);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraggableMark = function (_React$Component) {
  _inherits(DraggableMark, _React$Component);

  function DraggableMark() {
    _classCallCheck(this, DraggableMark);

    return _possibleConstructorReturn(this, (DraggableMark.__proto__ || Object.getPrototypeOf(DraggableMark)).apply(this, arguments));
  }

  _createClass(DraggableMark, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(_Mark2.default, _extends({
        draggable: true,
        resetAfter: true,
        droppable: true
      }, this.props));
    }
  }]);

  return DraggableMark;
}(_react2.default.Component);

DraggableMark.propTypes = {
  draggable: _propTypes2.default.bool,
  resetAfter: _propTypes2.default.bool,
  droppable: _propTypes2.default.bool
};

exports.default = DraggableMark;
module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(47);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var MarkContext = function (_React$Component) {
  _inherits(MarkContext, _React$Component);

  function MarkContext(props) {
    _classCallCheck(this, MarkContext);

    var _this = _possibleConstructorReturn(this, (MarkContext.__proto__ || Object.getPrototypeOf(MarkContext)).call(this, props));

    _this.mapElements = _this.mapElements.bind(_this);
    _this.shouldComponentUpdate = _this.shouldComponentUpdate.bind(_this);
    _this.updateContext = _this.updateContext.bind(_this);
    _this.state = { context: {} };
    return _this;
  }

  _createClass(MarkContext, [{
    key: "mapElements",
    value: function mapElements(element, ei) {
      if (!element) return null;

      var props = {
        key: "mc-mark-" + ei
      };

      if (typeof element.type !== "string") {
        props.context = this.state.context;
        props.updateContext = this.updateContext;
      }
      if (Array.isArray(element)) return element.map(this.mapElements);

      return _react2.default.cloneElement(element, props);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.xyFrameChildren && this.props.renderNumber === nextProps.renderNumber) {
        return false;
      }
      return true;
    }
  }, {
    key: "updateContext",
    value: function updateContext(prop, value) {
      var currentContext = this.state.context;
      currentContext[prop] = value;
      this.setState({ context: currentContext });
    }
  }, {
    key: "render",
    value: function render() {
      var elements = null;

      if (Array.isArray(this.props.children)) elements = this.props.children.map(this.mapElements);else if (_typeof(this.props.children) === "object") elements = this.mapElements(this.props.children);

      var transform = [0, 0];

      transform[0] = this.props.position ? this.props.position[0] : 0;
      transform[1] = this.props.position ? this.props.position[1] : 0;

      return _react2.default.createElement(
        "g",
        { transform: "translate(" + transform.toString() + ")" },
        elements
      );
    }
  }]);

  return MarkContext;
}(_react2.default.Component);

MarkContext.propTypes = {
  position: _propTypes2.default.array,
  xyFrameChildren: _propTypes2.default.bool,
  renderNumber: _propTypes2.default.number
};
exports.default = MarkContext;
module.exports = exports['default'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Module dependencies.
 */
var os = __webpack_require__(428);
var lodashGet = __webpack_require__(429);
var lodashFlatten = __webpack_require__(430);
var lodashUniq = __webpack_require__(431);
var lodashSet = __webpack_require__(432);
var lodashCloneDeep = __webpack_require__(433);
var flatten = __webpack_require__(435);

/**
 * @name Json2CsvParams
 * @typedef {Object}
 * @property {Array} data - array of JSON objects
 * @property {Array} [fields] - see documentation for details
 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
 * @property {String} [del=","] - delimiter of columns
 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
 * @property {String} [quotes='"'] - quotes around cell values and column names
 * @property {String} [doubleQuotes='""'] - the value to replace double quotes in strings
 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
 * @property {String} [eol=''] - it gets added to each row of data
 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
 * @property {String[]} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
 * @property {Boolean} [withBOM=false] - includes BOM character at the beginning of the csv
 */

/**
 * Main function that converts json to csv.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter (default is ','), hasCSVColumnTitle (default is true)
 * and default value (default is '')
 * @param {Function} [callback] Callback function
 *   if error, returning error in call back.
 *   if csv is created successfully, returning csv output to callback.
 */
module.exports = function (params, callback) {
  var hasCallback = typeof callback === 'function';
  var err;

  try {
    checkParams(params);
  } catch (err) {
    if (hasCallback) {
      return process.nextTick(function () {
        callback(err);
      });
    } else {
      throw err;
    }
  }

  var titles = createColumnTitles(params);
  var csv = createColumnContent(params, titles);

  if (hasCallback) {
    return process.nextTick(function () {
      callback(null, csv);
    });
  } else {
    return csv;
  }
};


/**
 * Check passing params.
 *
 * Note that this modifies params.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter, default value, mark quotes and hasCSVColumnTitle
 */
function checkParams(params) {
  params.data = params.data || [];

  // if data is an Object, not in array [{}], then just create 1 item array.
  // So from now all data in array of object format.
  if (!Array.isArray(params.data)) {
    params.data = [params.data];
  }

  if (params.flatten) {
    params.data = params.data.map(flatten);
  }

  // Set params.fields default to first data element's keys
  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
  }

  if (!params.fields) {
    var dataFields = params.data.map(function (item) {
      return Object.keys(item);
    });

    dataFields = lodashFlatten(dataFields);
    params.fields = lodashUniq(dataFields);
  }


  //#check fieldNames
  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
  }

  // Get fieldNames from fields
  params.fieldNames = params.fields.map(function (field, i) {
    if (params.fieldNames && typeof field === 'string') {
      return params.fieldNames[i];
    }
    return (typeof field === 'string') ? field : (field.label || field.value);
  });

  //#check delimiter
  params.del = params.del || ',';

  //#check end of line character
  params.eol = params.eol || '';

  //#check quotation mark
  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';

  //#check double quotes
  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);

  //#check default value
  params.defaultValue = params.defaultValue;

  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;

  //#check include empty rows, defaults to false
  params.includeEmptyRows = params.includeEmptyRows || false;

  //#check with BOM, defaults to false
  params.withBOM = params.withBOM || false;

  //#check unwindPath, defaults to empty array
  params.unwindPath = params.unwindPath || [];

  // if unwindPath is not in array [{}], then just create 1 item array.
  if (!Array.isArray(params.unwindPath)) {
    params.unwindPath = [params.unwindPath];
  }
}

/**
 * Create the title row with all the provided fields as column headings
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
 * @returns {String} titles as a string
 */
function createColumnTitles(params) {
  var str = '';

  //if CSV has column title, then create it
  if (params.hasCSVColumnTitle) {
    params.fieldNames.forEach(function (element) {
      if (str !== '') {
        str += params.del;
      }
      str += JSON.stringify(element).replace(/\"/g, params.quotes);
    });
  }

  return str;
}

/**
 * Replace the quotation marks of the field element if needed (can be a not string-like item)
 *
 * @param {string} stringifiedElement The field element after JSON.stringify()
 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
 */
function replaceQuotationMarks(stringifiedElement, quotes) {
  var lastCharIndex = stringifiedElement.length - 1;

  //check if it's an string-like element
  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
    //split the stringified field element because Strings are immutable
    var splitElement = stringifiedElement.split('');

    //replace the quotation marks
    splitElement[0] = quotes;
    splitElement[lastCharIndex] = quotes;

    //join again
    stringifiedElement = splitElement.join('');
  }

  return stringifiedElement;
}

/**
 * Create the content column by column and row by row below the title
 *
 * @param {Object} params Function parameters containing data, fields and delimiter
 * @param {String} str Title row as a string
 * @returns {String} csv string
 */
function createColumnContent(params, str) {
  createDataRows(params.data, params.unwindPath).forEach(function (dataElement) {
    //if null do nothing, if empty object without includeEmptyRows do nothing
    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
      var line = '';
      var eol = params.newLine || os.EOL || '\n';

      params.fields.forEach(function (fieldElement) {
        var val;
        var defaultValue = params.defaultValue;
        var stringify = true;
        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
          defaultValue = fieldElement.default;
        }

        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
          val = lodashGet(dataElement, path, defaultValue);
        } else if (fieldElement && typeof fieldElement.value === 'function') {
          var field = {
            label: fieldElement.label,
            default: fieldElement.default
          };
          val = fieldElement.value(dataElement, field, params.data);
          if (fieldElement.stringify !== undefined) {
            stringify = fieldElement.stringify;
          }
        }

        if (val === null || val === undefined){
          val = defaultValue;
        }

        if (val !== undefined) {
          if (params.preserveNewLinesInValues && typeof val === 'string') {
            val = val
              .replace(/\n/g, '\u2028')
              .replace(/\r/g, '\u2029');
          }

          var stringifiedElement = val;
          if (stringify) {
            stringifiedElement = JSON.stringify(val);
          }

          if (params.preserveNewLinesInValues && typeof val === 'string') {
            stringifiedElement = stringifiedElement
              .replace(/\u2028/g, '\n')
              .replace(/\u2029/g, '\r');
          }

          if (typeof val === 'object') {
            // In some cases (e.g. val is a Date), stringifiedElement is already a quoted string.
            // Strip the leading and trailing quotes if so, so we don't end up double-quoting it
            stringifiedElement = replaceQuotationMarks(stringifiedElement, '');

            // If val is a normal object, we want to escape its JSON so any commas etc
            // don't get interpreted as field separators
            stringifiedElement = JSON.stringify(stringifiedElement);
          }

          if (params.quotes !== '"') {
            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
          }

          //JSON.stringify('\\') results in a string with two backslash
          //characters in it. I.e. '\\\\'.
          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');

          if (params.excelStrings && typeof val === 'string') {
            stringifiedElement = '"="' + stringifiedElement + '""';
          }

          //Replace single quotes with double quotes.  Single quotes are preceeded by
          //a backslash,  and it's not at the end of the stringifiedElement.
          stringifiedElement = stringifiedElement.replace(/(\\")(?=.)/g, params.doubleQuotes);

          line += stringifiedElement;
        }

        line += params.del;
      });

      //remove last delimeter by its length
      line = line.substring(0, line.length - params.del.length);

      //Remove the final excess backslashes from the stringified value.
      line = line.replace(/\\\\/g,'\\');

      //If header exists, add it, otherwise, print only content
      if (str !== '') {
        str += eol + line + params.eol;
      } else {
        str = line + params.eol;
      }
    }
  });
  // Add BOM character if required
  if (params.withBOM) {
    str = '\ufeff' + str;
  }

  return str;
}

/**
 * Performs the unwind recursively in specified sequence
 *
 * @param {Array} originalData The params.data value. Original array of JSON objects
 * @param {String[]} unwindPaths The params.unwindPath value. Unwind strings to be used to deconstruct array
 * @returns {Array} Array of objects containing all rows after unwind of chosen paths
 */
function createDataRows(originalData, unwindPaths) {
  var dataRows = [];
  if (unwindPaths.length) {
    originalData.forEach(function(dataElement) {
      var dataRow = [dataElement];

      unwindPaths.forEach(function(unwindPath) {
        dataRow = unwindRows(dataRow, unwindPath);
      });

      Array.prototype.push.apply(dataRows, dataRow);
    });
  } else {
    dataRows = originalData;
  }

  return dataRows;
}

/**
 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
 *
 * @param {Array} inputRows Array contaning single or multiple rows to unwind
 * @param {String} unwindPath Single path to do unwind
 * @returns {Array} Array of rows processed
 */
function unwindRows(inputRows, unwindPath) {
  var outputRows = [];
  inputRows.forEach(function(dataEl) {
    var unwindArray = lodashGet(dataEl, unwindPath);
    var isArr = Array.isArray(unwindArray);

    if (isArr && unwindArray.length) {
      unwindArray.forEach(function(unwindEl) {
        var dataCopy = lodashCloneDeep(dataEl);
        lodashSet(dataCopy, unwindPath, unwindEl);
        outputRows.push(dataCopy);
      });
    } else if (isArr && !unwindArray.length) {
      var dataCopy = lodashCloneDeep(dataEl);
      lodashSet(dataCopy, unwindPath, undefined);
      outputRows.push(dataCopy);
    } else {
      outputRows.push(dataEl);
    }
  });
  return outputRows;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(427)))

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 428 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(434)(module)))

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(436)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["a"]; });



/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = brushX;
/* harmony export (immutable) */ __webpack_exports__["c"] = brushY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(445);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* harmony default export */ __webpack_exports__["d"] = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["interrupt"])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["mouse"])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["interrupt"])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["mouse"])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(440);
/* unused harmony reexport drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(442);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["mouse"], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["touch"], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(3);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
});


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "voronoi", function() { return __WEBPACK_IMPORTED_MODULE_0__src_voronoi__["a"]; });



/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(35);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoughCanvasAsync = exports.RoughCanvas = undefined;

var _regenerator = __webpack_require__(178);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _generator = __webpack_require__(177);

var _renderer = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoughCanvas = exports.RoughCanvas = function () {
  function RoughCanvas(canvas, config) {
    _classCallCheck(this, RoughCanvas);

    this.canvas = canvas;
    this.ctx = this.canvas.getContext("2d");
    this._init(config);
  }

  _createClass(RoughCanvas, [{
    key: '_init',
    value: function _init(config) {
      this.gen = new _generator.RoughGenerator(config, this.canvas);
    }
  }, {
    key: 'line',
    value: function line(x1, y1, x2, y2, options) {
      var d = this.gen.line(x1, y1, x2, y2, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'rectangle',
    value: function rectangle(x, y, width, height, options) {
      var d = this.gen.rectangle(x, y, width, height, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'ellipse',
    value: function ellipse(x, y, width, height, options) {
      var d = this.gen.ellipse(x, y, width, height, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'circle',
    value: function circle(x, y, diameter, options) {
      var d = this.gen.circle(x, y, diameter, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'linearPath',
    value: function linearPath(points, options) {
      var d = this.gen.linearPath(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'polygon',
    value: function polygon(points, options) {
      var d = this.gen.polygon(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'arc',
    value: function arc(x, y, width, height, start, stop, closed, options) {
      var d = this.gen.arc(x, y, width, height, start, stop, closed, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'curve',
    value: function curve(points, options) {
      var d = this.gen.curve(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: 'path',
    value: function path(d, options) {
      var drawing = this.gen.path(d, options);
      this.draw(drawing);
      return drawing;
    }
  }, {
    key: 'draw',
    value: function draw(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.gen.defaultOptions;
      var ctx = this.ctx;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var drawing = _step.value;

          switch (drawing.type) {
            case 'path':
              ctx.save();
              ctx.strokeStyle = o.stroke;
              ctx.lineWidth = o.strokeWidth;
              this._drawToContext(ctx, drawing);
              ctx.restore();
              break;
            case 'fillPath':
              ctx.save();
              ctx.fillStyle = o.fill;
              this._drawToContext(ctx, drawing, o);
              ctx.restore();
              break;
            case 'fillSketch':
              this._fillSketch(ctx, drawing, o);
              break;
            case 'path2Dfill':
              {
                this.ctx.save();
                this.ctx.fillStyle = o.fill;
                var p2d = new Path2D(drawing.path);
                this.ctx.fill(p2d);
                this.ctx.restore();
                break;
              }
            case 'path2Dpattern':
              {
                var size = drawing.size;
                var hcanvas = document.createElement('canvas');
                var hcontext = hcanvas.getContext("2d");
                var bbox = this._computeBBox(drawing.path);
                if (bbox && (bbox.width || bbox.height)) {
                  hcanvas.width = this.canvas.width;
                  hcanvas.height = this.canvas.height;
                  hcontext.translate(bbox.x || 0, bbox.y || 0);
                } else {
                  hcanvas.width = size[0];
                  hcanvas.height = size[1];
                }
                this._fillSketch(hcontext, drawing, o);
                this.ctx.save();
                this.ctx.fillStyle = this.ctx.createPattern(hcanvas, 'repeat');
                var _p2d = new Path2D(drawing.path);
                this.ctx.fill(_p2d);
                this.ctx.restore();
                break;
              }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: '_computeBBox',
    value: function _computeBBox(d) {
      if (self.document) {
        try {
          var ns = "http://www.w3.org/2000/svg";
          var svg = self.document.createElementNS(ns, "svg");
          svg.setAttribute("width", "0");
          svg.setAttribute("height", "0");
          var pathNode = self.document.createElementNS(ns, "path");
          pathNode.setAttribute('d', d);
          svg.appendChild(pathNode);
          self.document.body.appendChild(svg);
          var bbox = pathNode.getBBox();
          self.document.body.removeChild(svg);
          return bbox;
        } catch (err) {}
      }
      return null;
    }
  }, {
    key: '_fillSketch',
    value: function _fillSketch(ctx, drawing, o) {
      var fweight = o.fillWeight;
      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }
      ctx.save();
      ctx.strokeStyle = o.fill;
      ctx.lineWidth = fweight;
      this._drawToContext(ctx, drawing);
      ctx.restore();
    }
  }, {
    key: '_drawToContext',
    value: function _drawToContext(ctx, drawing) {
      ctx.beginPath();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = drawing.ops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var data = item.data;
          switch (item.op) {
            case 'move':
              ctx.moveTo(data[0], data[1]);
              break;
            case 'bcurveTo':
              ctx.bezierCurveTo(data[0], data[1], data[2], data[3], data[4], data[5]);
              break;
            case 'qcurveTo':
              ctx.quadraticCurveTo(data[0], data[1], data[2], data[3]);
              break;
            case 'lineTo':
              ctx.lineTo(data[0], data[1]);
              break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (drawing.type === 'fillPath') {
        ctx.fill();
      } else {
        ctx.stroke();
      }
    }
  }, {
    key: 'generator',
    get: function get() {
      return this.gen;
    }
  }], [{
    key: 'createRenderer',
    value: function createRenderer() {
      return new _renderer.RoughRenderer();
    }
  }]);

  return RoughCanvas;
}();

var RoughCanvasAsync = exports.RoughCanvasAsync = function (_RoughCanvas) {
  _inherits(RoughCanvasAsync, _RoughCanvas);

  function RoughCanvasAsync() {
    _classCallCheck(this, RoughCanvasAsync);

    return _possibleConstructorReturn(this, (RoughCanvasAsync.__proto__ || Object.getPrototypeOf(RoughCanvasAsync)).apply(this, arguments));
  }

  _createClass(RoughCanvasAsync, [{
    key: '_init',
    value: function _init(config) {
      this.gen = new _generator.RoughGeneratorAsync(config, this.canvas);
    }
  }, {
    key: 'line',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(x1, y1, x2, y2, options) {
        var d;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.gen.line(x1, y1, x2, y2, options);

              case 2:
                d = _context.sent;

                this.draw(d);
                return _context.abrupt('return', d);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function line(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return line;
    }()
  }, {
    key: 'rectangle',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(x, y, width, height, options) {
        var d;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.gen.rectangle(x, y, width, height, options);

              case 2:
                d = _context2.sent;

                this.draw(d);
                return _context2.abrupt('return', d);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function rectangle(_x6, _x7, _x8, _x9, _x10) {
        return _ref2.apply(this, arguments);
      }

      return rectangle;
    }()
  }, {
    key: 'ellipse',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(x, y, width, height, options) {
        var d;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.gen.ellipse(x, y, width, height, options);

              case 2:
                d = _context3.sent;

                this.draw(d);
                return _context3.abrupt('return', d);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ellipse(_x11, _x12, _x13, _x14, _x15) {
        return _ref3.apply(this, arguments);
      }

      return ellipse;
    }()
  }, {
    key: 'circle',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4(x, y, diameter, options) {
        var d;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.gen.circle(x, y, diameter, options);

              case 2:
                d = _context4.sent;

                this.draw(d);
                return _context4.abrupt('return', d);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function circle(_x16, _x17, _x18, _x19) {
        return _ref4.apply(this, arguments);
      }

      return circle;
    }()
  }, {
    key: 'linearPath',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee5(points, options) {
        var d;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.gen.linearPath(points, options);

              case 2:
                d = _context5.sent;

                this.draw(d);
                return _context5.abrupt('return', d);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function linearPath(_x20, _x21) {
        return _ref5.apply(this, arguments);
      }

      return linearPath;
    }()
  }, {
    key: 'polygon',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee6(points, options) {
        var d;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.gen.polygon(points, options);

              case 2:
                d = _context6.sent;

                this.draw(d);
                return _context6.abrupt('return', d);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function polygon(_x22, _x23) {
        return _ref6.apply(this, arguments);
      }

      return polygon;
    }()
  }, {
    key: 'arc',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee7(x, y, width, height, start, stop, closed, options) {
        var d;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.gen.arc(x, y, width, height, start, stop, closed, options);

              case 2:
                d = _context7.sent;

                this.draw(d);
                return _context7.abrupt('return', d);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function arc(_x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31) {
        return _ref7.apply(this, arguments);
      }

      return arc;
    }()
  }, {
    key: 'curve',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee8(points, options) {
        var d;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.gen.curve(points, options);

              case 2:
                d = _context8.sent;

                this.draw(d);
                return _context8.abrupt('return', d);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function curve(_x32, _x33) {
        return _ref8.apply(this, arguments);
      }

      return curve;
    }()
  }, {
    key: 'path',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee9(d, options) {
        var drawing;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.gen.path(d, options);

              case 2:
                drawing = _context9.sent;

                this.draw(drawing);
                return _context9.abrupt('return', drawing);

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function path(_x34, _x35) {
        return _ref9.apply(this, arguments);
      }

      return path;
    }()
  }]);

  return RoughCanvasAsync;
}(RoughCanvas);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_contours__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contours", function() { return __WEBPACK_IMPORTED_MODULE_0__src_contours__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_density__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contourDensity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_density__["a"]; });




/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a - b;
});


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blur__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contours__ = __webpack_require__(190);






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = defaultX,
      y = defaultY,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (x(d, i, data) + o) >> k,
          yi = (y(d, i, data) + o) >> k;
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        ++values0[xi + yi * n];
      }
    });

    // TODO Optimize.
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["max"])(values0);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(0, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4__contours__["a" /* default */])()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : y;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blurX;
/* harmony export (immutable) */ __webpack_exports__["b"] = blurY;
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Queue = __webpack_require__(460);

module.exports = polylabel;
module.exports.default = polylabel;

function polylabel(polygon, precision, debug) {
    precision = precision || 1.0;

    // find the bounding box of the outer ring
    var minX, minY, maxX, maxY;
    for (var i = 0; i < polygon[0].length; i++) {
        var p = polygon[0][i];
        if (!i || p[0] < minX) minX = p[0];
        if (!i || p[1] < minY) minY = p[1];
        if (!i || p[0] > maxX) maxX = p[0];
        if (!i || p[1] > maxY) maxY = p[1];
    }

    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.min(width, height);
    var h = cellSize / 2;

    // a priority queue of cells in order of their "potential" (max distance to polygon)
    var cellQueue = new Queue(null, compareMax);

    if (cellSize === 0) return [minX, minY];

    // cover polygon with initial cells
    for (var x = minX; x < maxX; x += cellSize) {
        for (var y = minY; y < maxY; y += cellSize) {
            cellQueue.push(new Cell(x + h, y + h, h, polygon));
        }
    }

    // take centroid as the first best guess
    var bestCell = getCentroidCell(polygon);

    // special case for rectangular polygons
    var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;

    var numProbes = cellQueue.length;

    while (cellQueue.length) {
        // pick the most promising cell from the queue
        var cell = cellQueue.pop();

        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log('found best %d after %d probes', Math.round(1e4 * cell.d) / 1e4, numProbes);
        }

        // do not drill down further if there's no chance of a better solution
        if (cell.max - bestCell.d <= precision) continue;

        // split the cell into four cells
        h = cell.h / 2;
        cellQueue.push(new Cell(cell.x - h, cell.y - h, h, polygon));
        cellQueue.push(new Cell(cell.x + h, cell.y - h, h, polygon));
        cellQueue.push(new Cell(cell.x - h, cell.y + h, h, polygon));
        cellQueue.push(new Cell(cell.x + h, cell.y + h, h, polygon));
        numProbes += 4;
    }

    if (debug) {
        console.log('num probes: ' + numProbes);
        console.log('best distance: ' + bestCell.d);
    }

    return [bestCell.x, bestCell.y];
}

function compareMax(a, b) {
    return b.max - a.max;
}

function Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}

// signed distance from point to polygon outline (negative if point is outside)
function pointToPolygonDist(x, y, polygon) {
    var inside = false;
    var minDistSq = Infinity;

    for (var k = 0; k < polygon.length; k++) {
        var ring = polygon[k];

        for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
            var a = ring[i];
            var b = ring[j];

            if ((a[1] > y !== b[1] > y) &&
                (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;

            minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
        }
    }

    return (inside ? 1 : -1) * Math.sqrt(minDistSq);
}

// get polygon centroid
function getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];

    for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        var a = points[i];
        var b = points[j];
        var f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    if (area === 0) return new Cell(points[0][0], points[0][1], 0, polygon);
    return new Cell(x / area, y / area, 0, polygon);
}

// get squared distance from a point to a segment
function getSegDistSq(px, py, a, b) {

    var x = a[0];
    var y = a[1];
    var dx = b[0] - x;
    var dy = b[1] - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = b[0];
            y = b[1];

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = px - x;
    dy = py - y;

    return dx * dx + dy * dy;
}


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = TinyQueue;
module.exports.default = TinyQueue;

function TinyQueue(data, compare) {
    if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);

    this.data = data || [];
    this.length = this.data.length;
    this.compare = compare || defaultCompare;

    if (this.length > 0) {
        for (var i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
    }
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

TinyQueue.prototype = {

    push: function (item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    },

    pop: function () {
        if (this.length === 0) return undefined;

        var top = this.data[0];
        this.length--;

        if (this.length > 0) {
            this.data[0] = this.data[this.length];
            this._down(0);
        }
        this.data.pop();

        return top;
    },

    peek: function () {
        return this.data[0];
    },

    _up: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var item = data[pos];

        while (pos > 0) {
            var parent = (pos - 1) >> 1;
            var current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    },

    _down: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var halfLength = this.length >> 1;
        var item = data[pos];

        while (pos < halfLength) {
            var left = (pos << 1) + 1;
            var right = left + 1;
            var best = data[left];

            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;

            data[pos] = best;
            pos = left;
        }

        data[pos] = item;
    }
};


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_hexbin__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hexbin", function() { return __WEBPACK_IMPORTED_MODULE_0__src_hexbin__["a"]; });



/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var thirdPi = Math.PI / 3,
    angles = [0, thirdPi, 2 * thirdPi, 3 * thirdPi, 4 * thirdPi, 5 * thirdPi];

function pointX(d) {
  return d[0];
}

function pointY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 1,
      y1 = 1,
      x = pointX,
      y = pointY,
      r,
      dx,
      dy;

  function hexbin(points) {
    var binsById = {}, bins = [], i, n = points.length;

    for (i = 0; i < n; ++i) {
      if (isNaN(px = +x.call(null, point = points[i], i, points))
          || isNaN(py = +y.call(null, point, i, points))) continue;

      var point,
          px,
          py,
          pj = Math.round(py = py / dy),
          pi = Math.round(px = px / dx - (pj & 1) / 2),
          py1 = py - pj;

      if (Math.abs(py1) * 3 > 1) {
        var px1 = px - pi,
            pi2 = pi + (px < pi ? -1 : 1) / 2,
            pj2 = pj + (py < pj ? -1 : 1),
            px2 = px - pi2,
            py2 = py - pj2;
        if (px1 * px1 + py1 * py1 > px2 * px2 + py2 * py2) pi = pi2 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
      }

      var id = pi + "-" + pj, bin = binsById[id];
      if (bin) bin.push(point);
      else {
        bins.push(bin = binsById[id] = [point]);
        bin.x = (pi + (pj & 1) / 2) * dx;
        bin.y = pj * dy;
      }
    }

    return bins;
  }

  function hexagon(radius) {
    var x0 = 0, y0 = 0;
    return angles.map(function(angle) {
      var x1 = Math.sin(angle) * radius,
          y1 = -Math.cos(angle) * radius,
          dx = x1 - x0,
          dy = y1 - y0;
      x0 = x1, y0 = y1;
      return [dx, dy];
    });
  }

  hexbin.hexagon = function(radius) {
    return "m" + hexagon(radius == null ? r : +radius).join("l") + "z";
  };

  hexbin.centers = function() {
    var centers = [],
        j = Math.round(y0 / dy),
        i = Math.round(x0 / dx);
    for (var y = j * dy; y < y1 + r; y += dy, ++j) {
      for (var x = i * dx + (j & 1) * dx / 2; x < x1 + dx / 2; x += dx) {
        centers.push([x, y]);
      }
    }
    return centers;
  };

  hexbin.mesh = function() {
    var fragment = hexagon(r).slice(0, 4).join("l");
    return hexbin.centers().map(function(p) { return "M" + p + "m" + fragment; }).join("");
  };

  hexbin.x = function(_) {
    return arguments.length ? (x = _, hexbin) : x;
  };

  hexbin.y = function(_) {
    return arguments.length ? (y = _, hexbin) : y;
  };

  hexbin.radius = function(_) {
    return arguments.length ? (r = +_, dx = r * 2 * Math.sin(thirdPi), dy = r * 1.5, hexbin) : r;
  };

  hexbin.size = function(_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], hexbin) : [x1 - x0, y1 - y0];
  };

  hexbin.extent = function(_) {
    return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], hexbin) : [[x0, y0], [x1, y1]];
  };

  return hexbin.radius(1);
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgEncloseAnnotation = exports.svgRectEncloseRule = exports.htmlTooltipAnnotation = exports.svgAreaAnnotation = exports.svgLineAnnotation = exports.svgBoundsAnnotation = exports.svgYAnnotation = exports.svgXAnnotation = exports.basicReactAnnotation = exports.svgXYAnnotation = exports.svgHighlight = exports.svgVerticalPointsAnnotation = exports.svgHorizontalPointsAnnotation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _AnnotationCalloutRect = __webpack_require__(193);

var _AnnotationCalloutRect2 = _interopRequireDefault(_AnnotationCalloutRect);

var _AnnotationXYThreshold = __webpack_require__(194);

var _AnnotationXYThreshold2 = _interopRequireDefault(_AnnotationXYThreshold);

var _d3Shape = __webpack_require__(7);

var _d3Hierarchy = __webpack_require__(56);

var _d3Array = __webpack_require__(2);

var _baseRules = __webpack_require__(100);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var pointsAlong = function pointsAlong(along) {
  return function (_ref) {
    var d = _ref.d,
        lines = _ref.lines,
        points = _ref.points,
        xScale = _ref.xScale,
        yScale = _ref.yScale,
        pointStyle = _ref.pointStyle;

    var alongScale = along === "x" ? xScale : yScale;
    along = along === "yTop" && d.yMiddle ? "yMiddle" : along;
    if (d && d[along]) {
      var _d$threshold = d.threshold,
          threshold = _d$threshold === undefined ? 1 : _d$threshold,
          _d$r = d.r,
          r = _d$r === undefined ? function () {
        return 4;
      } : _d$r,
          _d$styleFn = d.styleFn,
          styleFn = _d$styleFn === undefined ? pointStyle : _d$styleFn;

      var foundPoints = [];

      var halfThreshold = threshold / 2;

      if (lines && lines.length > 0) {
        lines.forEach(function (linedata) {
          var linePoints = linedata.data.filter(function (p) {
            var pAlong = alongScale(p[along]);
            var dAlong = alongScale(d[along]);

            return pAlong <= dAlong + halfThreshold && pAlong >= dAlong - halfThreshold;
          });
          foundPoints.push.apply(foundPoints, _toConsumableArray(linePoints));
        });
      }

      if (points && points.length > 0) {
        var pointPoints = points.filter(function (p) {
          var pAlong = alongScale(p[along]);
          var dAlong = alongScale(d[along]);

          return pAlong <= dAlong + halfThreshold && pAlong >= dAlong - halfThreshold;
        });
        foundPoints.push.apply(foundPoints, _toConsumableArray(pointPoints));
      }

      return foundPoints.map(function (p, i) {
        return _react2.default.createElement("circle", {
          key: "found-circle-" + i,
          r: r(p, i),
          style: styleFn(p, i),
          cx: xScale(p.x),
          cy: yScale(p.yMiddle || p.yTop)
        });
      });
    }
    return null;
  };
};

var svgHorizontalPointsAnnotation = exports.svgHorizontalPointsAnnotation = pointsAlong("yTop");
var svgVerticalPointsAnnotation = exports.svgVerticalPointsAnnotation = pointsAlong("x");

var svgHighlight = exports.svgHighlight = function svgHighlight(_ref2) {
  var d = _ref2.d,
      i = _ref2.i,
      _ref2$points = _ref2.points,
      points = _ref2$points === undefined ? { data: [] } : _ref2$points,
      _ref2$lines = _ref2.lines,
      lines = _ref2$lines === undefined ? { data: [] } : _ref2$lines,
      _ref2$areas = _ref2.areas,
      areas = _ref2$areas === undefined ? { data: [] } : _ref2$areas,
      idAccessor = _ref2.idAccessor,
      xScale = _ref2.xScale,
      yScale = _ref2.yScale;

  var dID = void 0;
  var baseID = idAccessor(_extends({}, d, d.data), i);
  if (baseID !== undefined) {
    dID = baseID;
  } else if (d.parentLine && idAccessor(d.parentLine, i) !== undefined) {
    dID = idAccessor(d.parentLine, i);
  } else if (d.parentArea && idAccessor(d.parentArea, i) !== undefined) {
    dID = idAccessor(d.parentArea, i);
  }

  var foundPoints = points.data.filter(function (p, q) {
    return idAccessor(_extends({}, p, p.data), q) === dID;
  }).map(function (p, q) {
    return _react2.default.createElement("circle", {
      key: "highlight-point-" + q,
      cx: xScale(p.x),
      cy: yScale(p.y),
      r: 5,
      fill: "none",
      stroke: "black",
      strokeWidth: 2,
      style: typeof d.style === "function" ? d.style(p.data, q) : d.style,
      className: "highlight-annotation " + (d.class && typeof d.class === "function" && d.class(p.data, q) || d.class && d.class || "")
    });
  });

  var lineGenerator = (0, _d3Shape.area)().x(function (p) {
    return xScale(p.x);
  }).y0(function (p) {
    return yScale(p.yBottom);
  }).y1(function (p) {
    return yScale(p.yTop);
  });

  if (lines.type.interpolator) {
    lineGenerator.curve(lines.type.interpolator);
  }

  var foundLines = lines.data.filter(function (p, q) {
    return idAccessor(p, q) === dID;
  }).map(function (p, q) {
    return _react2.default.createElement("path", {
      className: "highlight-annotation " + (d.class && typeof d.class === "function" && d.class(p, q) || d.class && d.class || ""),
      key: "highlight-area-" + q,
      d: lineGenerator(p.data),
      fill: "none",
      stroke: "black",
      strokeWidth: 1,
      style: typeof d.style === "function" ? d.style(p, q) : d.style
    });
  });

  var foundAreas = areas.data.filter(function (p, q) {
    return idAccessor(p, q) === dID;
  }).map(function (p, q) {
    return _react2.default.createElement("path", {
      className: "highlight-annotation " + (d.class && typeof d.class === "function" && d.class(p, q) || d.class && d.class || ""),
      key: "highlight-area-" + q,
      d: "M" + p.coordinates.join("L"),
      fill: "none",
      stroke: "black",
      strokeWidth: 1,
      style: typeof d.style === "function" ? d.style(p, q) : d.style
    });
  });

  return [].concat(_toConsumableArray(foundAreas), _toConsumableArray(foundLines), _toConsumableArray(foundPoints));
};

var svgXYAnnotation = exports.svgXYAnnotation = function svgXYAnnotation(_ref3) {
  var screenCoordinates = _ref3.screenCoordinates,
      i = _ref3.i,
      d = _ref3.d;

  var inlineStyle = void 0;
  if (d.color) inlineStyle = { fill: d.color };
  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    className: "annotation " + d.type + " " + (d.className || "") + " ",
    key: "annotationpoint" + i,
    markType: "circle",
    cx: screenCoordinates[0],
    cy: screenCoordinates[1],
    forceUpdate: true,
    style: inlineStyle,
    r: 5
  });
  var laLabel = void 0;
  if (d.type === "xy") {
    laLabel = _react2.default.createElement(
      _semioticMark.Mark,
      {
        markType: "text",
        key: d.label + "annotationtext" + i,
        forceUpdate: true,
        x: screenCoordinates[0],
        y: 10 + screenCoordinates[1],
        className: "annotation annotation-xy-label " + (d.className || "") + " "
      },
      d.label
    );
  }

  return [laLine, laLabel];
};

var basicReactAnnotation = exports.basicReactAnnotation = function basicReactAnnotation(_ref4) {
  var screenCoordinates = _ref4.screenCoordinates,
      d = _ref4.d,
      i = _ref4.i;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: d.type,
    screenCoordinates: screenCoordinates
  });

  noteData.x = noteData.fixedX ? noteData.fixedX : screenCoordinates[0];
  noteData.y = noteData.fixedY ? noteData.fixedY : screenCoordinates[1];

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgXAnnotation = exports.svgXAnnotation = function svgXAnnotation(_ref5) {
  var screenCoordinates = _ref5.screenCoordinates,
      d = _ref5.d,
      i = _ref5.i,
      adjustedSize = _ref5.adjustedSize;

  var noteData = _extends({
    dx: 50,
    dy: 20,
    y: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationXYThreshold2.default,
    x: screenCoordinates[0],
    subject: {
      x: screenCoordinates[0],
      y1: 0,
      y2: adjustedSize[1]
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgYAnnotation = exports.svgYAnnotation = function svgYAnnotation(_ref6) {
  var screenCoordinates = _ref6.screenCoordinates,
      d = _ref6.d,
      i = _ref6.i,
      adjustedSize = _ref6.adjustedSize,
      adjustedPosition = _ref6.adjustedPosition;

  var xPosition = i * 25;

  var noteData = _extends({
    dx: 50,
    dy: -20,
    x: xPosition,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationXYThreshold2.default,
    y: screenCoordinates[1],
    subject: {
      y: screenCoordinates[1],
      x1: 0,
      x2: adjustedSize[0] + adjustedPosition[0]
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgBoundsAnnotation = exports.svgBoundsAnnotation = function svgBoundsAnnotation(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      adjustedSize = _ref7.adjustedSize,
      xAccessor = _ref7.xAccessor,
      yAccessor = _ref7.yAccessor,
      xScale = _ref7.xScale,
      yScale = _ref7.yScale;

  var startXValue = xAccessor(d.bounds[0]);
  var startYValue = yAccessor(d.bounds[0]);
  var endXValue = xAccessor(d.bounds[1]);
  var endYValue = yAccessor(d.bounds[1]);

  var x0Position = startXValue ? xScale(startXValue) : 0;
  var y0Position = startYValue ? yScale(startYValue) : adjustedSize[1];
  var x1Position = endXValue ? xScale(endXValue) : adjustedSize[0];
  var y1Position = endYValue ? yScale(endYValue) : 0;

  var noteData = _extends({
    dx: 250,
    dy: -20,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationCalloutRect2.default,
    x: Math.min(x0Position, x1Position),
    y: Math.min(y0Position, y1Position),
    subject: {
      width: Math.abs(x1Position - x0Position),
      height: Math.abs(y0Position - y1Position)
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgLineAnnotation = exports.svgLineAnnotation = function svgLineAnnotation(_ref8) {
  var d = _ref8.d,
      i = _ref8.i,
      screenCoordinates = _ref8.screenCoordinates;

  var lineGenerator = (0, _d3Shape.line)().x(function (p) {
    return p[0];
  }).y(function (p) {
    return p[1];
  });
  var lineD = lineGenerator(screenCoordinates);
  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    key: d.label + "annotationline" + i,
    markType: "path",
    d: lineD,
    className: "annotation annotation-line " + (d.className || "") + " "
  });

  var laLabel = _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "annotationlinetext" + i,
      x: (screenCoordinates[0][0] + screenCoordinates[1][0]) / 2,
      y: (screenCoordinates[0][1] + screenCoordinates[1][1]) / 2,
      className: "annotation annotation-line-label " + (d.className || "") + " "
    },
    d.label
  );

  return [laLine, laLabel];
};

var svgAreaAnnotation = exports.svgAreaAnnotation = function svgAreaAnnotation(_ref9) {
  var d = _ref9.d,
      i = _ref9.i,
      xScale = _ref9.xScale,
      xAccessor = _ref9.xAccessor,
      yScale = _ref9.yScale,
      yAccessor = _ref9.yAccessor,
      annotationLayer = _ref9.annotationLayer;

  var mappedCoordinates = "M" + d.coordinates.map(function (p) {
    return [xScale(xAccessor(p)), yScale(yAccessor(p))];
  }).join("L") + "Z";
  var xBounds = (0, _d3Array.extent)(d.coordinates.map(function (p) {
    return xScale(xAccessor(p));
  }));
  var yBounds = (0, _d3Array.extent)(d.coordinates.map(function (p) {
    return yScale(yAccessor(p));
  }));
  var xCenter = (xBounds[0] + xBounds[1]) / 2;
  var yCenter = (yBounds[0] + yBounds[1]) / 2;

  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    key: d.label + "-annotationarea-" + i,
    markType: "path",
    transform: "translate(" + annotationLayer.position + ")",
    d: mappedCoordinates,
    className: "annotation annotation-area " + (d.className || "") + " "
  });

  var laLabel = _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "-annotationtext-" + i,
      forceUpdate: true,
      x: xCenter,
      y: yCenter,
      transform: "translate(" + annotationLayer.position + ")",
      className: "annotation annotation-area-label " + (d.className || "") + " ",
      style: { textAnchor: "middle" }
    },
    d.label
  );

  return [laLine, laLabel];
};

var htmlTooltipAnnotation = exports.htmlTooltipAnnotation = function htmlTooltipAnnotation(_ref10) {
  var content = _ref10.content,
      screenCoordinates = _ref10.screenCoordinates,
      i = _ref10.i,
      d = _ref10.d,
      useSpans = _ref10.useSpans;

  //To string because React gives a DOM error if it gets a date

  return _react2.default.createElement(
    _SpanOrDiv2.default,
    {
      span: useSpans,
      key: "xylabel-" + i,
      className: "annotation annotation-xy-label " + (d.className || "") + " ",
      style: {
        position: "absolute",
        top: screenCoordinates[1] + "px",
        left: screenCoordinates[0] + "px"
      }
    },
    content
  );
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref11) {
  var d = _ref11.d,
      i = _ref11.i,
      screenCoordinates = _ref11.screenCoordinates;

  var bboxNodes = screenCoordinates.map(function (p) {
    return {
      x0: p.x0 = p[0],
      x1: p.x1 = p[0],
      y0: p.y0 = p[1],
      y1: p.y1 = p[1]
    };
  });

  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

var svgEncloseAnnotation = exports.svgEncloseAnnotation = function svgEncloseAnnotation(_ref12) {
  var screenCoordinates = _ref12.screenCoordinates,
      d = _ref12.d;

  var circle = (0, _d3Hierarchy.packEnclose)(screenCoordinates.map(function (p) {
    return { x: p[0], y: p[1], r: 2 };
  }));

  return (0, _baseRules.circleEnclosure)({ d: d, circle: circle });
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rect = __webpack_require__(465);

var _rect2 = _interopRequireDefault(_rect);

var _Subject2 = __webpack_require__(28);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectRect = function (_Subject) {
  _inherits(SubjectRect, _Subject);

  function SubjectRect() {
    _classCallCheck(this, SubjectRect);

    return _possibleConstructorReturn(this, (SubjectRect.__proto__ || Object.getPrototypeOf(SubjectRect)).apply(this, arguments));
  }

  _createClass(SubjectRect, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var _ref$width = _ref.width,
          width = _ref$width === undefined ? 100 : _ref$width,
          _ref$height = _ref.height,
          height = _ref$height === undefined ? 100 : _ref$height,
          editMode = _ref.editMode;

      var components = (0, _rect2.default)({ width: width, height: height, editMode: editMode });
      components.handleKeys = { width: width, height: height };

      components.handleFunction = function (h, data) {
        return _defineProperty({}, h.key, h.key === "width" ? width + data.oDeltaX : height + data.oDeltaY);
      };

      return components;
    }
  }]);

  return SubjectRect;
}(_Subject3.default);

exports.default = SubjectRect;


SubjectRect.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

exports.default = function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? 100 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 100 : _ref$height,
      editMode = _ref.editMode;

  var handles = [];

  var data = [[0, 0], [width, 0], [width, height], [0, height], [0, 0]];
  var rect = (0, _Builder.lineBuilder)({ data: data, className: "subject" });

  if (editMode) {
    handles = [{ x: width, y: height / 2, key: "width" }, { x: width / 2, y: height, key: "height" }];
  }
  rect.attrs["fill-opacity"] = 0.1;
  return { components: [rect], handles: handles };
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _threshold = __webpack_require__(467);

var _threshold2 = _interopRequireDefault(_threshold);

var _Subject2 = __webpack_require__(28);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectThreshold = function (_Subject) {
  _inherits(SubjectThreshold, _Subject);

  function SubjectThreshold() {
    _classCallCheck(this, SubjectThreshold);

    return _possibleConstructorReturn(this, (SubjectThreshold.__proto__ || Object.getPrototypeOf(SubjectThreshold)).apply(this, arguments));
  }

  _createClass(SubjectThreshold, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x1 = _ref.x1,
          x2 = _ref.x2,
          y1 = _ref.y1,
          y2 = _ref.y2,
          x = _ref.x,
          y = _ref.y,
          editMode = _ref.editMode;

      return (0, _threshold2.default)({ x1: x1, x2: x2, y1: y1, y2: y2, x: x, y: y, editMode: editMode });
    }
  }]);

  return SubjectThreshold;
}(_Subject3.default);

exports.default = SubjectThreshold;


SubjectThreshold.propTypes = {
  x: _propTypes2.default.number,
  x1: _propTypes2.default.number,
  x2: _propTypes2.default.number,
  y: _propTypes2.default.number,
  y1: _propTypes2.default.number,
  y2: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

exports.default = function (_ref) {
  var x1 = _ref.x1,
      x2 = _ref.x2,
      y1 = _ref.y1,
      y2 = _ref.y2,
      x = _ref.x,
      y = _ref.y;

  x1 = (x1 !== undefined ? x1 : x) - x;
  x2 = (x2 !== undefined ? x2 : x) - x;
  y1 = (y1 !== undefined ? y1 : y) - y;
  y2 = (y2 !== undefined ? y2 : y) - y;

  var data = [[x1, y1], [x2, y2]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "subject" })] };
};

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(197);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(97);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(97);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(197);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(99);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _circle = __webpack_require__(490);

var _circle2 = _interopRequireDefault(_circle);

var _Subject2 = __webpack_require__(28);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectCircle = function (_Subject) {
  _inherits(SubjectCircle, _Subject);

  function SubjectCircle() {
    _classCallCheck(this, SubjectCircle);

    return _possibleConstructorReturn(this, (SubjectCircle.__proto__ || Object.getPrototypeOf(SubjectCircle)).apply(this, arguments));
  }

  _createClass(SubjectCircle, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var _ref$radius = _ref.radius,
          radius = _ref$radius === undefined ? 20 : _ref$radius,
          innerRadius = _ref.innerRadius,
          outerRadius = _ref.outerRadius,
          radiusPadding = _ref.radiusPadding,
          editMode = _ref.editMode;

      var components = (0, _circle2.default)({
        radius: radius,
        radiusPadding: radiusPadding,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        editMode: editMode
      });

      components.handleKeys = { radius: radius, innerRadius: innerRadius, outerRadius: outerRadius };
      components.handleFunction = function (h, data) {
        return _defineProperty({}, h.key, components.handleKeys[h.key] + data.oDeltaX * Math.sqrt(2));
      };
      return components;
    }
  }]);

  return SubjectCircle;
}(_Subject3.default);

exports.default = SubjectCircle;


SubjectCircle.propTypes = {
  radius: _propTypes2.default.number,
  innerRadius: _propTypes2.default.number,
  outerRadius: _propTypes2.default.number,
  radiusPadding: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circleHandles = undefined;

var _Builder = __webpack_require__(8);

var circleHandles = exports.circleHandles = function circleHandles(_ref) {
  var _ref$cx = _ref.cx,
      cx = _ref$cx === undefined ? 0 : _ref$cx,
      _ref$cy = _ref.cy,
      cy = _ref$cy === undefined ? 0 : _ref$cy,
      r1 = _ref.r1,
      r2 = _ref.r2,
      padding = _ref.padding;

  var h = { move: { x: cx, y: cy } };

  if (r1 !== undefined) {
    h.r1 = { x: cx + r1 / Math.sqrt(2), y: cy + r1 / Math.sqrt(2) };
  }

  if (r2 !== undefined) {
    h.r2 = { x: cx + r2 / Math.sqrt(2), y: cy + r2 / Math.sqrt(2) };
  }

  if (padding !== undefined) {
    h.padding = { x: cx + r1 + padding, y: cy };
  }

  return h;
};

exports.default = function (_ref2) {
  var radius = _ref2.radius,
      radiusPadding = _ref2.radiusPadding,
      outerRadius = _ref2.outerRadius,
      innerRadius = _ref2.innerRadius,
      editMode = _ref2.editMode;

  var handles = [];
  var c = (0, _Builder.arcBuilder)({
    data: { radius: radius, outerRadius: outerRadius, innerRadius: innerRadius },
    className: "subject"
  });

  if (editMode) {
    var h = circleHandles({
      r1: c.data.outerRadius || c.data.radius,
      r2: c.data.innerRadius,
      padding: radiusPadding
    });

    var cHandles = [{
      x: h.r1.x,
      y: h.r1.y,
      key: c.data.outerRadius ? "outerRadius" : "radius"
    }];

    if (innerRadius) {
      cHandles.push({ x: h.r2.x, y: h.r2.y, key: "innerRadius" });
    }
    handles = cHandles;
  }

  c.attrs["fill-opacity"] = 0;

  return { components: [c], handles: handles };
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.lineGeneratorDecorator = lineGeneratorDecorator;
exports.createPoints = createPoints;
exports.createLines = createLines;
exports.createAreas = createAreas;
exports.clonedAppliedElement = clonedAppliedElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

var _d3Shape = __webpack_require__(7);

var _areaDrawing = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function lineGeneratorDecorator(_ref) {
  var generator = _ref.generator,
      projectedCoordinateNames = _ref.projectedCoordinateNames,
      defined = _ref.defined,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      interpolator = _ref.interpolator,
      simpleLine = _ref.simpleLine;
  var x = projectedCoordinateNames.x,
      y = projectedCoordinateNames.y,
      yTop = projectedCoordinateNames.yTop,
      yBottom = projectedCoordinateNames.yBottom;


  generator.x(function (d) {
    return xScale(d[x]);
  }).curve(interpolator);

  if (simpleLine) {
    generator.y(function (d) {
      return yScale(d[y]);
    });
  } else {
    generator.y0(function (d) {
      return yScale(d[yBottom]);
    }).y1(function (d) {
      return yScale(d[yTop]);
    });
  }

  if (defined) {
    generator.defined(function (p, q) {
      return defined(p, q);
    });
  } else {
    generator.defined(function (p) {
      return !p._xyFrameUndefined;
    });
  }
}

function createPoints(_ref2) {
  var xScale = _ref2.xScale,
      yScale = _ref2.yScale,
      canvasDrawing = _ref2.canvasDrawing,
      data = _ref2.data,
      projectedCoordinateNames = _ref2.projectedCoordinateNames,
      customMark = _ref2.customMark,
      canvasRender = _ref2.canvasRender,
      styleFn = _ref2.styleFn,
      classFn = _ref2.classFn,
      renderKeyFn = _ref2.renderKeyFn,
      renderMode = _ref2.renderMode,
      baseMarkProps = _ref2.baseMarkProps;
  var y = projectedCoordinateNames.y,
      x = projectedCoordinateNames.x;

  var mappedPoints = [];
  data.forEach(function (d, i) {
    var dX = xScale(d[x]);
    var dY = yScale(d[y]);
    var pointAriaLabel = "Point at x " + d.x + " and y " + d.y;
    var renderedCustomMark = customMark && customMark({ d: d.data, i: i, xScale: xScale, yScale: yScale });
    var markProps = customMark ? _extends(baseMarkProps, renderedCustomMark.props, {
      "aria-label": pointAriaLabel
    }) : _extends({}, baseMarkProps, {
      "key": "piece-" + i,
      "markType": "circle",
      "r": 2,
      "aria-label": pointAriaLabel
    });

    if (renderedCustomMark && !renderedCustomMark.props.markType && (!canvasRender || canvasRender(d.data, i) !== true)) {
      mappedPoints.push(_react2.default.createElement(
        "g",
        {
          transform: "translate(" + dX + "," + dY + ")",
          key: renderKeyFn ? renderKeyFn(d.data, i) : "custom-point-mark-" + i,
          style: styleFn ? styleFn(d.data, i) : {},
          className: classFn ? classFn(d.data, i) : ""
        },
        renderedCustomMark
      ));
    } else {
      if (canvasRender && canvasRender(d.data, i) === true) {
        var canvasPoint = {
          type: "point",
          baseClass: "frame-piece",
          tx: dX,
          ty: dY,
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasPoint);
      } else {
        mappedPoints.push(clonedAppliedElement({
          baseClass: "frame-piece",
          tx: dX,
          ty: dY,
          d: d.data && _extends({}, d, d.data) || d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          renderKeyFn: renderKeyFn,
          classFn: classFn
        }));
      }
    }
  });
  return mappedPoints;
}

function createLines(_ref3) {
  var xScale = _ref3.xScale,
      yScale = _ref3.yScale,
      canvasDrawing = _ref3.canvasDrawing,
      data = _ref3.data,
      projectedCoordinateNames = _ref3.projectedCoordinateNames,
      customMark = _ref3.customMark,
      canvasRender = _ref3.canvasRender,
      styleFn = _ref3.styleFn,
      classFn = _ref3.classFn,
      renderMode = _ref3.renderMode,
      renderKeyFn = _ref3.renderKeyFn,
      type = _ref3.type,
      defined = _ref3.defined,
      baseMarkProps = _ref3.baseMarkProps,
      ariaLabel = _ref3.ariaLabel,
      _ref3$axesData = _ref3.axesData,
      axesData = _ref3$axesData === undefined ? [] : _ref3$axesData;

  var xAxis = axesData.find(function (d) {
    return d.orient === "bottom" || d.orient === "top";
  });
  var yAxis = axesData.find(function (d) {
    return d.orient === "left" || d.orient === "right";
  });

  var xAxisFormatter = xAxis && xAxis.tickFormat || function (d) {
    return d;
  };
  var yAxisFormatter = yAxis && yAxis.tickFormat || function (d) {
    return d;
  };

  var customLine = (typeof type === "undefined" ? "undefined" : _typeof(type)) === "object" ? type : { type: type };
  var interpolator = customLine.interpolator ? customLine.interpolator : _d3Shape.curveLinear;
  var lineGenerator = (0, _d3Shape.area)();

  lineGeneratorDecorator({
    projectedCoordinateNames: projectedCoordinateNames,
    defined: defined,
    interpolator: interpolator,
    generator: lineGenerator,
    xScale: xScale,
    yScale: yScale,
    simpleLine: customLine.simpleLine
  });

  var dynamicLineGenerator = interpolator.dynamicInterpolator && function (d, i) {
    var dynLineGenerator = (0, _d3Shape.area)();

    lineGeneratorDecorator({
      projectedCoordinateNames: projectedCoordinateNames,
      defined: defined,
      interpolator: interpolator.dynamicInterpolator(d, i),
      generator: dynLineGenerator,
      xScale: xScale,
      yScale: yScale,
      simpleLine: customLine.simpleLine
    });
    return dynLineGenerator;
  } || function () {
    return lineGenerator;
  };

  var mappedLines = [];
  data.forEach(function (d, i) {
    if (customMark && typeof customMark === "function") {
      //shim to make customLineMark work until Semiotic 2
      var compatibleData = _extends({}, d, {
        data: d.data.map(function (p) {
          return _extends({}, p.data, p);
        })
      });
      mappedLines.push(customMark({ d: compatibleData, i: i, xScale: xScale, yScale: yScale, canvasDrawing: canvasDrawing }));
    } else {
      var markProps = _extends({}, baseMarkProps, {
        "markType": "path",
        "d": dynamicLineGenerator(d, i)(d.data.map(function (p) {
          return _extends({}, p.data, p);
        })),
        "aria-label": d.data && d.data.length > 0 && d.data.length + " point " + ariaLabel.items + " starting value " + yAxisFormatter(d.data[0].y) + " at " + xAxisFormatter(d.data[0].x) + " ending value " + yAxisFormatter(d.data[d.data.length - 1].y) + " at " + xAxisFormatter(d.data[d.data.length - 1].x)
      });
      if (canvasRender && canvasRender(d, i) === true) {
        var canvasLine = {
          type: "line",
          baseClass: "xyframe-line",
          tx: 0,
          ty: 0,
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasLine);
      } else {
        mappedLines.push(clonedAppliedElement({
          baseClass: "xyframe-line",
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          renderKeyFn: renderKeyFn,
          classFn: classFn
        }));
      }
    }
  });

  if (customLine.type === "difference" && data.length === 2) {
    //Create the overlay line for the difference chart

    var diffdataA = data[0].data.map(function (basedata, baseI) {
      var linePoint = basedata.yTop > data[1].data[baseI].yTop ? basedata.yTop : basedata.yBottom;
      return {
        x: basedata.x,
        y: linePoint,
        yBottom: linePoint,
        yTop: linePoint
      };
    });

    var diffdataB = data[0].data.map(function (basedata, baseI) {
      var linePoint = data[1].data[baseI].yTop > basedata.yTop ? data[1].data[baseI].yTop : data[1].data[baseI].yBottom;
      return {
        x: basedata.x,
        y: linePoint,
        yBottom: linePoint,
        yTop: linePoint
      };
    });

    var doClassname = classFn ? "xyframe-line " + classFn(diffdataA) : "xyframe-line";

    var overLine = (0, _d3Shape.line)();

    lineGeneratorDecorator({
      projectedCoordinateNames: projectedCoordinateNames,
      defined: defined,
      interpolator: interpolator,
      generator: overLine,
      xScale: xScale,
      yScale: yScale,
      simpleLine: true
    });

    //      let baseStyle = props.lineStyle ? props.lineStyle(diffdata, 0) : {}
    var diffOverlayA = _react2.default.createElement(_semioticMark.Mark, {
      key: "xyline-diff-a",
      className: doClassname + " difference-overlay-a",
      markType: "path",
      d: overLine(diffdataA),
      style: { fill: "none", pointerEvents: "none" }
    });
    mappedLines.push(diffOverlayA);

    var diffOverlayB = _react2.default.createElement(_semioticMark.Mark, {
      key: "xyline-diff-b",
      className: doClassname + " difference-overlay-b",
      markType: "path",
      d: overLine(diffdataB),
      style: { fill: "none", pointerEvents: "none" }
    });
    mappedLines.push(diffOverlayB);
  }

  return mappedLines;
}

function createAreas(_ref4) {
  var xScale = _ref4.xScale,
      yScale = _ref4.yScale,
      canvasDrawing = _ref4.canvasDrawing,
      data = _ref4.data,
      canvasRender = _ref4.canvasRender,
      styleFn = _ref4.styleFn,
      classFn = _ref4.classFn,
      renderKeyFn = _ref4.renderKeyFn,
      renderMode = _ref4.renderMode,
      baseMarkProps = _ref4.baseMarkProps,
      customMark = _ref4.customMark;

  var areaClass = classFn || function () {
    return "";
  };
  var areaStyle = styleFn || function () {
    return {};
  };

  var renderFn = renderMode;

  if (!Array.isArray(data)) {
    data = [data];
  }

  var renderedAreas = [];

  data.forEach(function (d, i) {
    var className = "xyframe-area";
    if (areaClass) {
      className = "xyframe-area " + areaClass(d);
    }
    var drawD = "";
    if (d.customMark) {
      drawD = d.customMark;
    } else if (d.type === "MultiPolygon") {
      d.coordinates.forEach(function (coord) {
        coord.forEach(function (c) {
          drawD += "M" + c.map(function (p) {
            return xScale(p[0]) + "," + yScale(p[1]);
          }).join("L") + "Z ";
        });
      });
    } else if (customMark) {
      var projectedCoordinates = d._xyfCoordinates.map(function (p) {
        return [xScale(p[0]), yScale(p[1])];
      });
      drawD = customMark({
        d: d,
        projectedCoordinates: projectedCoordinates,
        xScale: xScale,
        yScale: yScale,
        bounds: (0, _areaDrawing.shapeBounds)(projectedCoordinates)
      });
    } else {
      drawD = "M" + d._xyfCoordinates.map(function (p) {
        return xScale(p[0]) + "," + yScale(p[1]);
      }).join("L") + "Z";
    }

    var renderKey = renderKeyFn ? renderKeyFn(d, i) : "area-" + i;

    if (_react2.default.isValidElement(drawD)) {
      renderedAreas.push(drawD);
    } else if (canvasRender && canvasRender(d, i) === true) {
      var canvasArea = {
        type: "area",
        baseClass: "xyframe-area",
        tx: 0,
        ty: 0,
        d: d,
        i: i,
        markProps: { markType: "path", d: drawD },
        styleFn: areaStyle,
        renderFn: renderFn,
        classFn: function classFn() {
          return className;
        }
      };
      canvasDrawing.push(canvasArea);
    } else {
      renderedAreas.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        key: renderKey,
        forceUpdate: true,
        renderMode: renderFn ? renderFn(d, i) : undefined,
        className: className,
        markType: "path",
        d: drawD,
        style: areaStyle(d, i)
      })));
    }
  });
  return renderedAreas;
}

function clonedAppliedElement(_ref5) {
  var tx = _ref5.tx,
      ty = _ref5.ty,
      d = _ref5.d,
      i = _ref5.i,
      markProps = _ref5.markProps,
      styleFn = _ref5.styleFn,
      renderFn = _ref5.renderFn,
      classFn = _ref5.classFn,
      renderKeyFn = _ref5.renderKeyFn,
      baseClass = _ref5.baseClass;

  markProps.style = styleFn ? styleFn(d, i) : {};

  markProps.className = baseClass;

  markProps.key = renderKeyFn ? renderKeyFn(d, i) : baseClass + "-" + (d.key === undefined ? i : d.key);

  if (tx || ty) {
    markProps.transform = "translate(" + (tx || 0) + "," + (ty || 0) + ")";
  }

  if (classFn) {
    markProps.className = baseClass + " " + classFn(d, i);
  }

  if (!markProps.markType) {
    return _react2.default.createElement("markProps", null);
  }

  markProps.renderMode = renderFn ? renderFn(d, i) : undefined;

  return _react2.default.createElement(_semioticMark.Mark, markProps);
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationCallout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

var _ConnectorLine = __webpack_require__(64);

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationCallout(props) {
  var className = (0, _classnames2.default)("callout", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorLine2.default, {
    lineType: "horizontal"
  });
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgRectEncloseRule = exports.htmlColumnHoverRule = exports.htmlFrameHoverRule = exports.svgCategoryRule = exports.svgRRule = exports.svgEncloseRule = exports.basicReactAnnotationRule = exports.svgORRule = exports.svgHighlightRule = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _AnnotationCalloutCircle = __webpack_require__(101);

var _AnnotationCalloutCircle2 = _interopRequireDefault(_AnnotationCalloutCircle);

var _AnnotationBracket = __webpack_require__(494);

var _AnnotationBracket2 = _interopRequireDefault(_AnnotationBracket);

var _AnnotationXYThreshold = __webpack_require__(194);

var _AnnotationXYThreshold2 = _interopRequireDefault(_AnnotationXYThreshold);

var _d3Hierarchy = __webpack_require__(56);

var _d3Array = __webpack_require__(2);

var _pieceDrawing = __webpack_require__(55);

var _baseRules = __webpack_require__(100);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

function pieContentGenerator(_ref) {
  var pieces = _ref.pieces,
      column = _ref.column,
      oAccessor = _ref.oAccessor,
      useSpans = _ref.useSpans;

  return _react2.default.createElement(
    _SpanOrDiv2.default,
    { span: useSpans, className: "tooltip-content" },
    oAccessor(pieces[0]) && _react2.default.createElement(
      "p",
      { key: "or-annotation-1" },
      oAccessor(pieces[0]).toString()
    ),
    _react2.default.createElement(
      "p",
      { key: "or-annotation-2" },
      (column.pct * 100).toFixed(0) + "%"
    )
  );
}

function arcBracket(_ref2) {
  var x = _ref2.x,
      y = _ref2.y,
      radius = _ref2.radius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle,
      inset = _ref2.inset,
      outset = _ref2.outset,
      _ref2$curly = _ref2.curly,
      curly = _ref2$curly === undefined ? true : _ref2$curly;

  var start = polarToCartesian(x, y, radius + outset, endAngle);
  var end = polarToCartesian(x, y, radius + outset, startAngle);

  var innerStart = polarToCartesian(x, y, radius + outset - inset, endAngle);
  var innerEnd = polarToCartesian(x, y, radius + outset - inset, startAngle);

  var angleSize = endAngle - startAngle;
  var largeArcFlag = angleSize <= 180 ? "0" : "1";
  var d = void 0;
  if (curly) {
    var curlyOffset = Math.min(10, angleSize / 4);

    var middleLeft = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 + curlyOffset);

    var middle = polarToCartesian(x, y, radius + outset + 10, (startAngle + endAngle) / 2);
    var middleRight = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 - curlyOffset);

    d = ["M", innerStart.x, innerStart.y, "L", start.x, start.y, "A", radius + outset, radius + outset, 0, 0, 0, middleLeft.x, middleLeft.y, "A", radius + outset, radius + outset, 1, 0, 1, middle.x, middle.y, "A", radius + outset, radius + outset, 1, 0, 1, middleRight.x, middleRight.y, "A", radius + outset, radius + outset, 0, 0, 0, end.x, end.y, "L", innerEnd.x, innerEnd.y].join(" ");
  } else {
    d = ["M", innerStart.x, innerStart.y, "L", start.x, start.y, "A", radius + outset, radius + outset, 0, largeArcFlag, 0, end.x, end.y, "L", innerEnd.x, innerEnd.y].join(" ");
  }

  var midAngle = (startAngle + endAngle) / 2;
  var textOffset = void 0,
      largeTextArcFlag = void 0,
      finalTextEnd = void 0,
      finalTextStart = void 0,
      arcFlip = void 0;
  var lowerArc = midAngle > 90 && midAngle < 270;
  if (lowerArc) {
    textOffset = 12;
    largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    arcFlip = 0;
  } else {
    largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    textOffset = 5;
    arcFlip = 1;
  }
  textOffset += curly ? 10 : 0;
  var textStart = polarToCartesian(x, y, radius + outset + textOffset, endAngle);
  var textEnd = polarToCartesian(x, y, radius + outset + textOffset, startAngle);
  if (lowerArc) {
    finalTextStart = textStart;
    finalTextEnd = textEnd;
  } else {
    finalTextStart = textEnd;
    finalTextEnd = textStart;
  }

  var textD = ["M", finalTextStart.x, finalTextStart.y, "A", radius + outset + textOffset, radius + outset + textOffset, arcFlip, largeTextArcFlag, arcFlip, finalTextEnd.x, finalTextEnd.y].join(" ");

  return { arcPath: d, textArcPath: textD };
}

var svgHighlightRule = exports.svgHighlightRule = function svgHighlightRule(_ref3) {
  var d = _ref3.d,
      pieceIDAccessor = _ref3.pieceIDAccessor,
      orFrameRender = _ref3.orFrameRender,
      oAccessor = _ref3.oAccessor;

  var thisID = pieceIDAccessor(d);
  var thisO = oAccessor(d);

  var foundPieces = orFrameRender.pieces && orFrameRender.pieces.data.filter(function (p) {
    return (thisID === undefined || pieceIDAccessor(p.piece.data) === thisID) && (thisO === undefined || oAccessor(p.piece.data) === thisO);
  }).map(function (p, q) {
    if (_react2.default.isValidElement(p.renderElement)) {
      console.error("OrdinalFrame highlighting currently only works with built-in pieces and not custom pieces");
      return null;
    }
    var styleObject = {
      style: {}
    };
    if (d.style && typeof d.style === "function") {
      styleObject = { style: d.style(p.piece.data) };
    } else if (d.style) {
      styleObject = { style: d.style };
    }
    var styledD = _extends({}, p.renderElement, styleObject);
    var className = "highlight-annotation " + (d.class && typeof d.class === "function" && d.class(p.piece.data, q) || d.class && d.class || "");

    return _react2.default.createElement(_semioticMark.Mark, _extends({
      fill: "none",
      stroke: "black",
      strokeWidth: "2px",
      key: "highlight-piece-" + q
    }, styledD, {
      className: className
    }));
  }) || [];
  /*
  const foundSummaries =
    (orFrameRender.summaries &&
      orFrameRender.summaries.data
        .filter(p => {
          return oAccessor(p.piece.data) === thisID
        })
        .map(p => {
          if (React.isValidElement(p.renderElement)) {
            console.error(
              "OrdinalFrame highlighting currently only works with built-in pieces and not custom pieces"
            )
            return null
          }
          let styleObject = {
            style: { fill: "none", stroke: "black", strokeWidth: "2px" }
          }
          if (d.style && typeof d.style === "function") {
            styleObject = { style: d.style(p.piece.data) }
          } else if (d.style) {
            styleObject = { style: d.style }
          }
          const styledD = { ...p.renderElement, ...styleObject }
           return <Mark {...styledD} />
        })) ||
    []
  */

  return [].concat(_toConsumableArray(foundPieces));
};

var svgORRule = exports.svgORRule = function svgORRule(_ref4) {
  var d = _ref4.d,
      i = _ref4.i,
      screenCoordinates = _ref4.screenCoordinates,
      projection = _ref4.projection;

  return _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "annotationtext" + i,
      forceUpdate: true,
      x: screenCoordinates[0] + (projection === "horizontal" ? 10 : 0),
      y: screenCoordinates[1] + (projection === "vertical" ? 10 : 0),
      className: "annotation annotation-or-label " + (d.className || ""),
      textAnchor: "middle"
    },
    d.label
  );
};

var basicReactAnnotationRule = exports.basicReactAnnotationRule = function basicReactAnnotationRule(_ref5) {
  var d = _ref5.d,
      i = _ref5.i,
      screenCoordinates = _ref5.screenCoordinates;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    x: screenCoordinates[0],
    y: screenCoordinates[1],
    type: typeof d.type === "function" ? d.type : undefined,
    screenCoordinates: screenCoordinates
  });
  if (d.fixedX) noteData.x = d.fixedX;
  if (d.fixedY) noteData.y = d.fixedY;
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgEncloseRule = exports.svgEncloseRule = function svgEncloseRule(_ref6) {
  var d = _ref6.d,
      i = _ref6.i,
      screenCoordinates = _ref6.screenCoordinates;

  var circle = (0, _d3Hierarchy.packEnclose)(screenCoordinates.map(function (p) {
    return { x: p[0], y: p[1], r: 2 };
  }));

  return (0, _baseRules.circleEnclosure)({ d: d, i: i, circle: circle });
};

var svgRRule = exports.svgRRule = function svgRRule(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      screenCoordinates = _ref7.screenCoordinates,
      rScale = _ref7.rScale,
      rAccessor = _ref7.rAccessor,
      adjustedSize = _ref7.adjustedSize,
      adjustedPosition = _ref7.adjustedPosition,
      projection = _ref7.projection;

  var x = void 0,
      y = void 0,
      xPosition = void 0,
      yPosition = void 0,
      subject = void 0,
      dx = void 0,
      dy = void 0;
  if (projection === "radial") {
    return _react2.default.createElement(_Annotation2.default, {
      key: d.key || "annotation-" + i,
      noteData: _extends({
        dx: 50,
        dy: 50,
        note: { label: d.label },
        connector: { end: "arrow" }
      }, d, {
        type: _AnnotationCalloutCircle2.default,
        subject: {
          radius: rScale(rAccessor(d)) / 2,
          radiusPadding: 0
        },
        x: adjustedSize[0] / 2,
        y: adjustedSize[1] / 2
      })
    });
  } else if (projection === "horizontal") {
    dx = 50;
    dy = 50;
    yPosition = d.offset || i * 25;
    x = screenCoordinates[0];
    y = yPosition;
    subject = {
      x: x,
      y1: 0,
      y2: adjustedSize[1] + adjustedPosition[1]
    };
  } else {
    dx = 50;
    dy = -20;
    xPosition = d.offset || i * 25;
    y = screenCoordinates[1];
    x = xPosition;
    subject = {
      y: y,
      x1: 0,
      x2: adjustedSize[0] + adjustedPosition[0]
    };
  }

  var noteData = _extends({
    dx: dx,
    dy: dy,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationXYThreshold2.default,
    x: x,
    y: y,
    subject: subject
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgCategoryRule = exports.svgCategoryRule = function svgCategoryRule(_ref8) {
  var projection = _ref8.projection,
      d = _ref8.d,
      i = _ref8.i,
      categories = _ref8.categories,
      adjustedSize = _ref8.adjustedSize;
  var _d$bracketType = d.bracketType,
      bracketType = _d$bracketType === undefined ? "curly" : _d$bracketType,
      _d$position = d.position,
      position = _d$position === undefined ? projection === "vertical" ? "top" : "left" : _d$position,
      _d$depth = d.depth,
      depth = _d$depth === undefined ? 30 : _d$depth,
      _d$offset = d.offset,
      offset = _d$offset === undefined ? 0 : _d$offset,
      _d$padding = d.padding,
      padding = _d$padding === undefined ? 0 : _d$padding;

  var actualCategories = Array.isArray(d.categories) ? d.categories : [d.categories];
  var cats = actualCategories.map(function (c) {
    return categories[c];
  });

  if (projection === "radial") {
    var arcPadding = padding / adjustedSize[1];
    var leftX = (0, _d3Array.min)(cats.map(function (p) {
      return p.pct_start + p.pct_padding / 2 + arcPadding / 2;
    }));
    var rightX = (0, _d3Array.max)(cats.map(function (p) {
      return p.pct_start + p.pct - p.pct_padding / 2 - arcPadding / 2;
    }));

    var chartSize = Math.min(adjustedSize[0], adjustedSize[1]) / 2;
    var centerX = adjustedSize[0] / 2;
    var centerY = adjustedSize[1] / 2;

    var _arcBracket = arcBracket({
      x: 0,
      y: 0,
      radius: chartSize,
      startAngle: leftX * 360,
      endAngle: rightX * 360,
      inset: depth,
      outset: offset,
      curly: bracketType === "curly"
    }),
        arcPath = _arcBracket.arcPath,
        textArcPath = _arcBracket.textArcPath;

    var textPathID = "text-path-" + i + "-" + Math.random();
    return _react2.default.createElement(
      "g",
      {
        className: "category-annotation annotation",
        transform: "translate(" + centerX + "," + centerY + ")"
      },
      _react2.default.createElement("path", { d: arcPath, fill: "none" }),
      _react2.default.createElement("path", { id: textPathID, d: textArcPath, style: { display: "none" } }),
      _react2.default.createElement(
        "text",
        { "font-size": "12.5" },
        _react2.default.createElement(
          "textPath",
          {
            startOffset: "50%",
            textAnchor: "middle",
            xlinkHref: "#" + textPathID
          },
          d.label
        )
      )
    );
  } else {
    var _leftX = (0, _d3Array.min)(cats.map(function (p) {
      return p.x;
    }));
    var _rightX = (0, _d3Array.max)(cats.map(function (p) {
      return p.x + p.width;
    }));

    if (projection === "vertical") {
      var yPosition = position === "top" ? 0 : adjustedSize[1];
      yPosition += position === "top" ? -offset : offset;
      var noteData = {
        type: _AnnotationBracket2.default,
        y: yPosition,
        x: _leftX - padding,
        note: {
          title: d.title || d.label,
          label: d.title ? d.label : undefined
        },
        subject: {
          type: bracketType,
          width: _rightX - _leftX + padding * 2,
          depth: position === "top" ? -depth : depth
        }
      };
      return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
    } else if (projection === "horizontal") {
      var _yPosition = position === "left" ? 0 : adjustedSize[0];
      _yPosition += position === "left" ? -offset : offset;
      var _noteData = {
        type: _AnnotationBracket2.default,
        x: _yPosition,
        y: _leftX - padding,
        note: {
          title: d.title || d.label,
          label: d.title ? d.label : undefined
        },
        subject: {
          type: bracketType,
          height: _rightX - _leftX + padding * 2,
          depth: position === "left" ? -depth : depth
        }
      };
      return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: _noteData });
    }
  }
};

var htmlFrameHoverRule = exports.htmlFrameHoverRule = function htmlFrameHoverRule(_ref9) {
  var d = _ref9.d,
      i = _ref9.i,
      rAccessor = _ref9.rAccessor,
      oAccessor = _ref9.oAccessor,
      projection = _ref9.projection,
      tooltipContent = _ref9.tooltipContent,
      projectedColumns = _ref9.projectedColumns,
      useSpans = _ref9.useSpans;

  tooltipContent = tooltipContent === "pie" ? function (p) {
    return pieContentGenerator({
      pieces: [p],
      column: projectedColumns[oAccessor(p)],
      oAccessor: oAccessor,
      useSpans: useSpans
    });
  } : tooltipContent;
  //To string because React gives a DOM error if it gets a date
  var contentFill = void 0;
  if (d.isSummaryData) {
    var summaryLabel = _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      d.label
    );
    if (d.pieces && d.pieces.length !== 0) {
      if (d.pieces.length === 1) {
        summaryLabel = _react2.default.createElement(
          "p",
          { key: "html-annotation-content-2" },
          rAccessor(d.pieces[0].data)
        );
      } else {
        var pieceData = (0, _d3Array.extent)(d.pieces.map(function (p) {
          return p.data;
        }).map(rAccessor));
        summaryLabel = _react2.default.createElement(
          "p",
          { key: "html-annotation-content-2" },
          "From ",
          pieceData[0],
          " to ",
          pieceData[1]
        );
      }
    }
    contentFill = [_react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.key
    ), summaryLabel, _react2.default.createElement(
      "p",
      { key: "html-annotation-content-3" },
      d.value
    )];
  } else {
    contentFill = [oAccessor(d.data) && _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      oAccessor(d.data).toString()
    ), rAccessor(d.data) && _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      rAccessor(d.data).toString()
    )];
  }
  var content = _react2.default.createElement(
    _SpanOrDiv2.default,
    { span: useSpans, className: "tooltip-content" },
    contentFill
  );

  if (d.type === "frame-hover" && tooltipContent) {
    content = tooltipContent(d);
  }

  return _react2.default.createElement(
    _SpanOrDiv2.default,
    {
      span: useSpans,
      key: "xylabel-" + i,
      className: "annotation annotation-or-label tooltip " + projection + " " + (d.className || ""),
      style: {
        position: "absolute",
        top: d.y + "px",
        left: d.x + "px"
      }
    },
    content
  );
};

var htmlColumnHoverRule = exports.htmlColumnHoverRule = function htmlColumnHoverRule(_ref10) {
  var d = _ref10.d,
      i = _ref10.i,
      summaryType = _ref10.summaryType,
      oAccessor = _ref10.oAccessor,
      projectedColumns = _ref10.projectedColumns,
      type = _ref10.type,
      adjustedPosition = _ref10.adjustedPosition,
      adjustedSize = _ref10.adjustedSize,
      projection = _ref10.projection,
      tooltipContent = _ref10.tooltipContent,
      useSpans = _ref10.useSpans;

  //we need to ignore negative pieces to make sure the hover behavior populates on top of the positive bar
  var positionValue = summaryType.type || ["swarm", "point", "clusterbar"].find(function (p) {
    return p === type.type;
  }) ? (0, _d3Array.max)(d.pieces.map(function (p) {
    return p.scaledValue;
  })) : (0, _d3Array.sum)(d.pieces.map(function (p) {
    return p.scaledValue;
  }).filter(function (p) {
    return p > 0;
  }));

  var column = projectedColumns[oAccessor(d.pieces[0].data)];

  var xPosition = column.middle + adjustedPosition[0];
  var yPosition = adjustedSize[1] - positionValue;
  yPosition += 10;

  if (projection === "horizontal") {
    yPosition = projectedColumns[oAccessor(d.pieces[0].data)].middle;
    xPosition = positionValue + adjustedPosition[0];
  } else if (projection === "radial") {
    ;
    var _pointOnArcAtAngle = (0, _pieceDrawing.pointOnArcAtAngle)([d.arcAngles.translate[0], d.arcAngles.translate[1]], d.arcAngles.midAngle, d.arcAngles.length);

    var _pointOnArcAtAngle2 = _slicedToArray(_pointOnArcAtAngle, 2);

    xPosition = _pointOnArcAtAngle2[0];
    yPosition = _pointOnArcAtAngle2[1];

    yPosition += 10;
  }

  //To string because React gives a DOM error if it gets a date
  var content = _react2.default.createElement(
    _SpanOrDiv2.default,
    { span: useSpans, className: "tooltip-content" },
    oAccessor(d.pieces[0].data) && _react2.default.createElement(
      "p",
      { key: "or-annotation-1" },
      oAccessor(d.pieces[0].data).toString()
    ),
    _react2.default.createElement(
      "p",
      { key: "or-annotation-2" },
      (0, _d3Array.sum)(d.pieces.map(function (p) {
        return p.value;
      }).filter(function (p) {
        return p > 0;
      }))
    )
  );

  if (d.type === "column-hover" && tooltipContent) {
    if (tooltipContent === "pie") {
      tooltipContent = pieContentGenerator;
    }

    content = tooltipContent(_extends({}, d, {
      pieces: d.pieces.map(function (p) {
        return p.data;
      }),
      column: column,
      oAccessor: oAccessor
    }));
  }

  if (d.type === "xy") {
    content = d.label;
  }

  return _react2.default.createElement(
    _SpanOrDiv2.default,
    {
      span: useSpans,
      key: "orlabel-" + i,
      className: "annotation annotation-or-label tooltip " + projection + " " + (d.className || ""),
      style: {
        position: "absolute",
        top: yPosition + "px",
        left: xPosition + "px"
      }
    },
    content
  );
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref11) {
  var d = _ref11.d,
      i = _ref11.i,
      screenCoordinates = _ref11.screenCoordinates;

  var bboxNodes = screenCoordinates.map(function (p) {
    return {
      x0: p.x0 = p[0],
      x1: p.x1 = p[0],
      y0: p.y0 = p[1],
      y1: p.y1 = p[1]
    };
  });

  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationBracket;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubjectBracket = __webpack_require__(495);

var _SubjectBracket2 = _interopRequireDefault(_SubjectBracket);

var _BracketNote = __webpack_require__(497);

var _BracketNote2 = _interopRequireDefault(_BracketNote);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = __webpack_require__(21);

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationBracket(props) {
  var className = (0, _classnames2.default)("bracket", props.className);
  return (0, _Type2.default)(_extends({ disable: ["connector"] }, props, { className: className }), null, null, _SubjectBracket2.default, { depth: 20 }, _BracketNote2.default);
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bracket = __webpack_require__(496);

var _bracket2 = _interopRequireDefault(_bracket);

var _Subject2 = __webpack_require__(28);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectBracket = function (_Subject) {
  _inherits(SubjectBracket, _Subject);

  function SubjectBracket() {
    _classCallCheck(this, SubjectBracket);

    return _possibleConstructorReturn(this, (SubjectBracket.__proto__ || Object.getPrototypeOf(SubjectBracket)).apply(this, arguments));
  }

  _createClass(SubjectBracket, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var height = _ref.height,
          width = _ref.width,
          _ref$depth = _ref.depth,
          depth = _ref$depth === undefined ? 20 : _ref$depth,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? "square" : _ref$type,
          editMode = _ref.editMode;

      var components = (0, _bracket2.default)({ height: height, width: width, depth: depth, type: type, editMode: editMode });

      var handleKeys = { height: height, width: width, depth: depth };
      components.handleFunction = function (h, data) {
        if (h.key === "depth") {
          return {
            depth: depth + data["oDelta" + h.type]
          };
        } else {
          return _defineProperty({}, h.key, handleKeys[h.key] + data[h.key === "width" ? "oDeltaX" : "oDeltaY"]);
        }
      };

      return components;
    }
  }]);

  return SubjectBracket;
}(_Subject3.default);

exports.default = SubjectBracket;


SubjectBracket.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  depth: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(8);

//This curly brace function was
//made by Alex Hornbake
//http://bl.ocks.org/alexhornbake/6005176
function makeCurlyBrace(x1, y1, x2, y2, w, q) {
  //Calculate unit vector
  var dx = x1 - x2;
  var dy = y1 - y2;
  var len = Math.sqrt(dx * dx + dy * dy);
  dx = dx / len;
  dy = dy / len;

  //Calculate Control Points of path,
  var qx1 = x1 + q * w * dy;
  var qy1 = y1 - q * w * dx;
  var qx2 = x1 - 0.25 * len * dx + (1 - q) * w * dy;
  var qy2 = y1 - 0.25 * len * dy - (1 - q) * w * dx;
  var tx1 = x1 - 0.5 * len * dx + w * dy;
  var ty1 = y1 - 0.5 * len * dy - w * dx;
  var qx3 = x2 + q * w * dy;
  var qy3 = y2 - q * w * dx;
  var qx4 = x1 - 0.75 * len * dx + (1 - q) * w * dy;
  var qy4 = y1 - 0.75 * len * dy - (1 - q) * w * dx;

  return "M " + x1 + " " + y1 + " Q " + qx1 + " " + qy1 + " " + qx2 + " " + qy2 + " T " + tx1 + " " + ty1 + " M " + x2 + " " + y2 + " Q " + qx3 + " " + qy3 + " " + qx4 + " " + qy4 + " T " + tx1 + " " + ty1;
}

exports.default = function (_ref) {
  var height = _ref.height,
      width = _ref.width,
      depth = _ref.depth,
      type = _ref.type,
      editMode = _ref.editMode;

  var handles = [];
  var data = void 0;
  var bracket = void 0;
  if (type === "square") {
    if (height) {
      data = [[0, 0], [depth, 0], [depth, height], [0, height]];
    } else if (width) {
      data = [[0, 0], [0, depth], [width, depth], [width, 0]];
    }
    bracket = (0, _Builder.lineBuilder)({ data: data, className: "subject" });
  } else if (type === "curly") {
    bracket = (0, _Builder.pathBuilder)({
      d: makeCurlyBrace(0, 0, width || 0, height || 0, height && height > 0 || width && width < 0 ? -depth : depth, 0.55),
      className: "subject"
    });
  }

  if (editMode) {
    handles = [{
      x: height ? depth : width / 2,
      y: height ? height / 2 : depth,
      key: "depth",
      type: height ? "X" : "Y"
    }, {
      x: width || 0,
      y: height || 0,
      key: height ? "height" : "width"
    }];
  }

  bracket.attrs["fill-opacity"] = 0.1;
  return { components: [bracket], handles: handles };
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = BracketNote;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Note = __webpack_require__(135);

var _Note2 = _interopRequireDefault(_Note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

function BracketNote(_ref) {
  var width = _ref.width,
      height = _ref.height,
      depth = _ref.depth,
      rest = _objectWithoutProperties(_ref, ["width", "height", "depth"]);

  var dx = rest.dx,
      orientation = void 0,
      align = "middle",
      dy = rest.dy;

  if (height) {
    if (!dy) dy = height / 2;
    if (!dx) dx = depth;
    orientation = "leftRight";
  } else if (width) {
    if (!dx) dx = width / 2;
    if (!dy) dy = depth;
    orientation = "topBottom";
  }

  return _react2.default.createElement(_Note2.default, _extends({
    align: align,
    orientation: orientation,
    padding: 10
  }, rest, {
    editMode: false,
    dx: dx,
    dy: dy
  }));
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pointOnArcAtAngle = pointOnArcAtAngle;
exports.clusterBarLayout = clusterBarLayout;
exports.barLayout = barLayout;
exports.timelineLayout = timelineLayout;
exports.pointLayout = pointLayout;
exports.swarmLayout = swarmLayout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Force = __webpack_require__(200);

var _d3Shape = __webpack_require__(7);

var _svgPathBoundingBox = __webpack_require__(519);

var _svgPathBoundingBox2 = _interopRequireDefault(_svgPathBoundingBox);

var _semioticMark = __webpack_require__(6);

var _d3Scale = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var twoPI = Math.PI * 2;

var radialBarFeatureGenerator = function radialBarFeatureGenerator(_ref) {
  var type = _ref.type,
      ordset = _ref.ordset,
      adjustedSize = _ref.adjustedSize,
      piece = _ref.piece,
      i = _ref.i;
  var innerRadius = type.innerRadius;
  var _type$offsetAngle = type.offsetAngle,
      offsetAngle = _type$offsetAngle === undefined ? 0 : _type$offsetAngle,
      _type$angleRange = type.angleRange,
      angleRange = _type$angleRange === undefined ? [0, 360] : _type$angleRange;

  var offsetPct = offsetAngle / 360;
  var rangePct = angleRange.map(function (d) {
    return d / 360;
  });
  var rangeMod = rangePct[1] - rangePct[0];

  var adjustedPct = rangeMod < 1 ? (0, _d3Scale.scaleLinear)().domain([0, 1]).range(rangePct) : function (d) {
    return d;
  };

  var innerSize = type.type === "clusterbar" ? 0 : type.type === "timeline" ? piece.scaledValue / 2 : piece.bottom / 2;
  var outerSize = type.type === "clusterbar" ? piece.scaledValue / 2 : type.type === "timeline" ? piece.scaledEndValue / 2 : piece.scaledValue / 2 + piece.bottom / 2;

  if (innerRadius) {
    innerRadius = parseInt(innerRadius, 10);
    var canvasRadius = adjustedSize[0] / 2;
    var donutMod = (canvasRadius - innerRadius) / canvasRadius;
    innerSize = innerSize * donutMod + innerRadius;
    outerSize = outerSize * donutMod + innerRadius;
  }

  var arcGenerator = (0, _d3Shape.arc)().innerRadius(innerSize).outerRadius(outerSize);

  var angle = (type.type === "clusterbar" ? (ordset.pct - ordset.pct_padding) / ordset.pieceData.length : ordset.pct) * rangeMod;

  var startAngle = adjustedPct(type.type === "clusterbar" ? ordset.pct_start + i / ordset.pieceData.length * (ordset.pct - ordset.pct_padding) : ordset.pct === 1 ? 0 : ordset.pct_start + offsetPct);

  var endAngle = ordset.pct === 1 ? rangePct[1] : Math.max(startAngle, startAngle + angle - ordset.pct_padding / 2);

  var startAngleFinal = startAngle * twoPI;

  var endAngleFinal = endAngle * twoPI;

  var markD = arcGenerator({
    startAngle: startAngleFinal,
    endAngle: endAngleFinal
  });

  var centroid = arcGenerator.centroid({
    startAngle: startAngleFinal,
    endAngle: endAngleFinal
  });

  var xOffset = adjustedSize[0] / 2;
  var yOffset = adjustedSize[1] / 2;
  var xPosition = centroid[0] + xOffset;
  var yPosition = centroid[1] + yOffset;

  var outerPoint = pointOnArcAtAngle([0, 0], (startAngle + endAngle) / 2, piece.scaledValue / 2);

  var xy = {
    arcGenerator: arcGenerator,
    startAngle: startAngleFinal,
    endAngle: endAngleFinal,
    dx: outerPoint[0],
    dy: outerPoint[1]
  };
  var translate = "translate(" + xOffset + "," + yOffset + ")";

  return {
    xPosition: xPosition,
    yPosition: yPosition,
    xy: xy,
    translate: translate,
    markProps: {
      markType: "path",
      d: markD,
      tx: xOffset,
      ty: yOffset,
      transform: translate
    } };
};

var iconBarCustomMark = function iconBarCustomMark(_ref2) {
  var type = _ref2.type,
      projection = _ref2.projection,
      finalHeight = _ref2.finalHeight,
      finalWidth = _ref2.finalWidth,
      styleFn = _ref2.styleFn,
      renderValue = _ref2.renderValue,
      classFn = _ref2.classFn;
  return function (piece, i, xy) {
    var iconD = typeof type.icon === "string" ? type.icon : type.icon(piece.data, i);
    var _type$iconPadding = type.iconPadding,
        iconPadding = _type$iconPadding === undefined ? 1 : _type$iconPadding,
        _type$resize = type.resize,
        resize = _type$resize === undefined ? "auto" : _type$resize;


    var iconBounds = (0, _svgPathBoundingBox2.default)(iconD);
    var iconTranslate = [0 - iconBounds.x1 + iconPadding, 0 - iconBounds.y1 + iconPadding];
    iconBounds.height += iconPadding * 2;
    iconBounds.width += iconPadding * 2;

    var icons = [];

    var stackedIconSize = iconBounds.height;
    var stackedIconNumber = 1;
    var iconScale = 1;
    var spaceToUse = projection === "horizontal" ? finalHeight : finalWidth;
    var sizeToFit = projection === "horizontal" ? iconBounds.height : iconBounds.width;
    var sizeToPad = projection === "horizontal" ? iconBounds.width : iconBounds.height;
    var spaceToFill = projection === "horizontal" ? xy.width : xy.height;
    var spaceToStackFill = projection === "horizontal" ? xy.height : xy.width;
    if (resize === "auto") {
      stackedIconSize = spaceToUse / sizeToFit;
      if (stackedIconSize < 1) {
        iconScale = stackedIconSize;
      } else {
        stackedIconNumber = Math.floor(stackedIconSize);
        iconScale = 1 + (stackedIconSize - stackedIconNumber) / stackedIconNumber;
      }
    } else if (resize === "fixed") {
      iconScale = spaceToUse / sizeToFit;
    }

    //  const finalIconWidth = iconBounds.width * iconScale;
    var finalIconHeight = iconBounds.height * iconScale;

    var spaceToStep = sizeToPad * iconScale;
    var spaceToStackStep = sizeToFit * iconScale;

    iconTranslate[0] = iconTranslate[0] * iconScale;
    iconTranslate[1] = iconTranslate[1] * iconScale;

    var randoClipID = "iso-clip-" + i + "-" + Math.random();
    var clipPath = "url(#" + randoClipID + ")";
    if (xy.width > 0) {
      icons.push(_react2.default.createElement(
        "clipPath",
        { key: randoClipID, id: randoClipID },
        _react2.default.createElement("rect", { x: 0, y: 0, width: xy.width, height: xy.height })
      ));
      var iconPieces = [];
      var stepStart = projection === "horizontal" ? 0 : xy.height - finalIconHeight;
      var stepper = projection === "horizontal" ? spaceToStep : -spaceToStep;
      var stepTest = projection === "horizontal" ? function (step, spaceToFillValue) {
        return step < spaceToFillValue;
      } : function (step, spaceToFillValue, stepperValue) {
        return step > 0 + stepperValue;
      };

      for (var step = stepStart; stepTest(step, spaceToFill, stepper); step += stepper) {
        for (var stack = 0; stack < spaceToStackFill; stack += spaceToStackStep) {
          var stepX = projection === "horizontal" ? step : stack;
          var stepY = projection === "horizontal" ? stack : step;
          var paddedX = stepX + iconTranslate[0];
          var paddedY = stepY + iconTranslate[1];
          iconPieces.push(_react2.default.createElement(_semioticMark.Mark, {
            forceUpdate: true,
            markType: "path",
            key: "icon-" + step + "-" + stack,
            transform: "translate(" + paddedX + "," + paddedY + ") scale(" + iconScale + ")",
            vectorEffect: "non-scaling-stroke",
            d: iconD,
            style: styleFn(piece.data, i),
            renderMode: renderValue,
            className: classFn(piece.data, i)
          }));
        }
      }
      icons.push(_react2.default.createElement(
        "g",
        { key: "clipped-region-" + i, clipPath: clipPath },
        iconPieces
      ));
    }
    return icons;
  };
};

function pointOnArcAtAngle(center, angle, distance) {
  var radians = Math.PI * (angle + 0.75) * 2;

  var xPosition = center[0] + distance * Math.cos(radians);
  var yPosition = center[1] + distance * Math.sin(radians);

  return [xPosition, yPosition];
}

function clusterBarLayout(_ref3) {
  var type = _ref3.type,
      data = _ref3.data,
      renderMode = _ref3.renderMode,
      eventListenersGenerator = _ref3.eventListenersGenerator,
      styleFn = _ref3.styleFn,
      projection = _ref3.projection,
      classFn = _ref3.classFn,
      adjustedSize = _ref3.adjustedSize;

  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];

    var barColumnWidth = ordset.width;
    var clusterWidth = barColumnWidth / ordset.pieceData.length;

    var currentX = 0;
    var currentY = 0;

    var calculatedPieces = ordset.pieceData.map(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.base;
      var finalWidth = clusterWidth;
      var finalHeight = piece.scaledValue;
      var xy = {};
      if (!piece.negative) {
        yPosition -= piece.scaledValue;
      }

      if (projection === "horizontal") {
        //TODO: NEGATIVE FOR HORIZONTAL
        yPosition = piece.x;
        xPosition = piece.base;
        finalHeight = clusterWidth;
        finalWidth = piece.scaledValue;
        if (piece.negative) {
          xPosition -= piece.scaledValue;
        }
      }

      var translate = void 0,
          markProps = {};

      if (projection === "radial") {
        var _radialBarFeatureGene = radialBarFeatureGenerator({ type: type, ordset: ordset, adjustedSize: adjustedSize, piece: piece, i: i, translate: translate });

        xPosition = _radialBarFeatureGene.xPosition;
        yPosition = _radialBarFeatureGene.yPosition;
        markProps = _radialBarFeatureGene.markProps;
        xy = _radialBarFeatureGene.xy;
      } else {
        xPosition += currentX;
        yPosition += currentY;
        markProps = {
          markType: "rect",
          x: xPosition,
          y: yPosition,
          width: Math.max(1, finalWidth),
          height: Math.max(1, finalHeight),
          rx: 0,
          ry: 0
        };
      }

      var eventListeners = eventListenersGenerator(piece, i);

      xy.x = xPosition;
      xy.y = yPosition;
      xy.middle = clusterWidth / 2;
      xy.height = finalHeight;
      xy.width = finalWidth;

      if (type.icon && projection !== "radial") {
        type.customMark = iconBarCustomMark({
          type: type,
          projection: projection,
          finalHeight: finalHeight,
          finalWidth: finalWidth,
          styleFn: styleFn,
          renderValue: renderValue,
          classFn: classFn
        });
      } else if (type.icon && projection === "radial") {
        console.error("Icons are currently unsupported on radial charts");
      }

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: translate ? translate : "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        transform: translate,
        style: styleFn(piece.data, ordsetI)
      }, markProps, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };
      if (projection === "horizontal") {
        currentY += finalHeight;
      } else {
        currentX += finalWidth;
      }

      //        currentOffset += pieceSize
      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });
  return allCalculatedPieces;
}

function barLayout(_ref4) {
  var type = _ref4.type,
      data = _ref4.data,
      renderMode = _ref4.renderMode,
      eventListenersGenerator = _ref4.eventListenersGenerator,
      styleFn = _ref4.styleFn,
      projection = _ref4.projection,
      classFn = _ref4.classFn,
      adjustedSize = _ref4.adjustedSize;

  var keys = Object.keys(data);
  var allCalculatedPieces = [];
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var barColumnWidth = ordset.width;

    var calculatedPieces = ordset.pieceData.map(function (piece, i) {
      var pieceSize = piece.scaledValue;
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.bottom;
      var finalWidth = barColumnWidth;
      var finalHeight = pieceSize;

      if (!piece.negative) {
        yPosition -= piece.scaledValue;
      }

      if (projection === "horizontal") {
        yPosition = piece.x;
        xPosition = piece.bottom;
        finalHeight = barColumnWidth;
        finalWidth = pieceSize;
        if (piece.negative) {
          xPosition = piece.bottom - piece.scaledValue;
        }
      }

      var markProps = void 0;

      if (projection === "radial") {
        var _radialBarFeatureGene2 = radialBarFeatureGenerator({ type: type, ordset: ordset, adjustedSize: adjustedSize, piece: piece });

        markProps = _radialBarFeatureGene2.markProps;
        xPosition = _radialBarFeatureGene2.xPosition;
        yPosition = _radialBarFeatureGene2.yPosition;

        finalHeight = undefined;
        finalWidth = undefined;
      } else {
        markProps = {
          markType: "rect",
          x: xPosition,
          y: yPosition,
          width: Math.max(1, finalWidth),
          height: Math.max(1, finalHeight),
          rx: 0,
          ry: 0
        };
      }

      var eventListeners = eventListenersGenerator(piece, i);

      var xy = {
        x: xPosition,
        y: yPosition,
        middle: barColumnWidth / 2,
        height: finalHeight,
        width: finalWidth
      };

      if (type.icon && projection !== "radial") {
        type.customMark = iconBarCustomMark({
          type: type,
          projection: projection,
          finalHeight: finalHeight,
          finalWidth: finalWidth,
          styleFn: styleFn,
          renderValue: renderValue,
          classFn: classFn
        });
      } else if (type.icon && projection !== "horizontal") {
        console.error("Icons are currently unsupported in radial charts");
      }

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")",
          role: "img",
          tabIndex: "-1"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners, markProps);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };
      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });

  return allCalculatedPieces;
}

function timelineLayout(_ref5) {
  var type = _ref5.type,
      data = _ref5.data,
      renderMode = _ref5.renderMode,
      eventListenersGenerator = _ref5.eventListenersGenerator,
      styleFn = _ref5.styleFn,
      projection = _ref5.projection,
      classFn = _ref5.classFn,
      adjustedSize = _ref5.adjustedSize;

  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var calculatedPieces = [];

    ordset.pieceData.forEach(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);
      var xPosition = ordset.x;
      var height = piece.scaledEndValue - piece.scaledValue;
      var yPosition = piece.scaledVerticalValue - height;
      var width = ordset.width;
      var markProps = {
        markType: "rect",
        height: height < 0 ? -height : height,
        width: width,
        x: xPosition,
        y: height < 0 ? yPosition + height : yPosition
      };

      if (projection === "horizontal") {
        yPosition = ordset.x;
        xPosition = piece.scaledValue;
        width = piece.scaledEndValue - piece.scaledValue;
        height = ordset.width;
        markProps = {
          markType: "rect",
          height: height,
          width: width < 0 ? -width : width,
          x: width < 0 ? xPosition + width : xPosition,
          y: yPosition
        };
      } else if (projection === "radial") {
        var _radialBarFeatureGene3 = radialBarFeatureGenerator({ piece: piece, type: type, ordset: ordset, adjustedSize: adjustedSize });

        markProps = _radialBarFeatureGene3.markProps;
      }

      //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type

      var eventListeners = eventListenersGenerator(piece, i);
      var xy = {
        x: xPosition,
        y: yPosition,
        height: height
      };

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + (yPosition + height) + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        style: styleFn(piece.data, ordsetI)
      }, markProps, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };

      calculatedPieces.push(calculatedPiece);
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), calculatedPieces);
  });

  return allCalculatedPieces;
}

function pointLayout(_ref6) {
  var type = _ref6.type,
      data = _ref6.data,
      renderMode = _ref6.renderMode,
      eventListenersGenerator = _ref6.eventListenersGenerator,
      styleFn = _ref6.styleFn,
      projection = _ref6.projection,
      classFn = _ref6.classFn,
      adjustedSize = _ref6.adjustedSize;

  var circleRadius = type.r || 3;
  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];

    var calculatedPieces = [];

    ordset.pieceData.forEach(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = ordset.middle;
      var yPosition = piece.scaledVerticalValue;

      if (projection === "horizontal") {
        yPosition = ordset.middle;
        xPosition = piece.scaledValue;
      } else if (projection === "radial") {
        var angle = ordset.pct_middle;

        var rPosition = piece.scaledValue / 2;
        var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], angle, rPosition);
        xPosition = baseCentroid[0];
        yPosition = baseCentroid[1];
      }

      //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type
      var actualCircleRadius = typeof circleRadius === "function" ? circleRadius(piece, i) : circleRadius;
      var eventListeners = eventListenersGenerator(piece, i);

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i)
      ) : _extends({
        className: classFn(piece.data, i),
        markType: "rect",
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        height: actualCircleRadius * 2,
        width: actualCircleRadius * 2,
        x: xPosition - actualCircleRadius,
        y: yPosition - actualCircleRadius,
        rx: actualCircleRadius,
        ry: actualCircleRadius,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: {
          x: xPosition,
          y: yPosition
        },
        piece: piece,
        renderElement: renderElementObject
      };

      calculatedPieces.push(calculatedPiece);
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), calculatedPieces);
  });

  return allCalculatedPieces;
}

function swarmLayout(_ref7) {
  var type = _ref7.type,
      data = _ref7.data,
      renderMode = _ref7.renderMode,
      eventListenersGenerator = _ref7.eventListenersGenerator,
      styleFn = _ref7.styleFn,
      projection = _ref7.projection,
      classFn = _ref7.classFn,
      adjustedSize = _ref7.adjustedSize;

  var allCalculatedPieces = [];
  var iterations = type.iterations || 120;

  var columnKeys = Object.keys(data);

  columnKeys.forEach(function (key, ordsetI) {
    var oColumn = data[key];
    var anglePiece = 1 / columnKeys.length;
    var oData = oColumn.pieceData;
    var adjustedColumnWidth = oColumn.width;

    var circleRadius = type.r || Math.max(2, Math.min(5, 4 * adjustedColumnWidth / oData.length));

    var simulation = (0, _d3Force.forceSimulation)(oData).force("y", (0, _d3Force.forceY)(function (d) {
      return d.scaledValue;
    }).strength(type.strength || 2)).force("x", (0, _d3Force.forceX)(oColumn.middle)).force("collide", (0, _d3Force.forceCollide)(circleRadius)).stop();

    if (projection === "vertical") {
      simulation.force("y", (0, _d3Force.forceY)(function (d) {
        return d.scaledVerticalValue;
      }).strength(type.strength || 2));
    }

    for (var i = 0; i < iterations; ++i) {
      simulation.tick();
    }var calculatedPieces = oData.map(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.y;

      if (projection === "horizontal") {
        yPosition = piece.x;
        xPosition = piece.y;
      } else if (projection === "radial") {
        var angle = oColumn.pct_middle;
        xPosition = (piece.x - oColumn.middle) / adjustedColumnWidth * anglePiece;
        var rPosition = piece.scaledValue / 2;
        var xAngle = angle + xPosition;
        var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], xAngle, rPosition);
        xPosition = baseCentroid[0];
        yPosition = baseCentroid[1];
      }

      var actualCircleRadius = typeof circleRadius === "function" ? circleRadius(piece, i) : circleRadius;

      var eventListeners = eventListenersGenerator(piece, i);

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i)
      ) : _extends({
        className: classFn(piece.data, i),
        markType: "rect",
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        height: actualCircleRadius * 2,
        width: actualCircleRadius * 2,
        x: xPosition - actualCircleRadius,
        y: yPosition - actualCircleRadius,
        rx: actualCircleRadius,
        ry: actualCircleRadius,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: {
          x: xPosition,
          y: yPosition
        },
        piece: piece,
        renderElement: renderElementObject
      };

      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });

  return allCalculatedPieces;
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(201);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(513);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(107);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(107);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(107);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(31);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["map"])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(202);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["c" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(520);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var
  Path = __webpack_require__(521);

module.exports = caster;

function caster(path) {
  return new Path(path).getBoundingBox();
}

caster.Path = Path;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var
  BoundingBox = __webpack_require__(522),
  BoundingBoxView = __webpack_require__(523),
  SvgPath = __webpack_require__(524);

module.exports = Path;

function Path(d) {
  this.d = d;
}

Path.prototype = {

  getBoundingBox: function() {
    var
      pathDriver,
      boundingBox;

    pathDriver = new SvgPath(this.d);
    boundingBox = new BoundingBox();

    pathDriver
      .abs()
      .unarc()
      .unshort()
      .iterate(function(seg, index, x, y) {

        switch(seg[0]) {
          case 'M':
          case 'L':
            boundingBox.addPoint(
              seg[1],
              seg[2]
            );
            break;
          case 'H':
            boundingBox.addX(seg[1]);
            break;
          case 'V':
            boundingBox.addY(seg[1]);
            break;
          case 'Q':
            boundingBox.addQuadraticCurve(
              x,
              y,
              seg[1],
              seg[2],
              seg[3],
              seg[4]
            );
            break;
          case 'C':
            boundingBox.addBezierCurve(
              x,
              y,
              seg[1],
              seg[2],
              seg[3],
              seg[4],
              seg[5],
              seg[6]
            );
            break;
        }

      });

    return new BoundingBoxView(boundingBox);
  }

};


/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = BoundingBox;

// from https://github.com/gabelerner/canvg/blob/860e418aca67b9a41e858a223d74d375793ec364/canvg.js#L449

function BoundingBox(x1, y1, x2, y2) { // pass in initial points if you want
  this.x1 = Number.NaN;
  this.y1 = Number.NaN;
  this.x2 = Number.NaN;
  this.y2 = Number.NaN;

  this.addPoint(x1, y1);
  this.addPoint(x2, y2);
}

BoundingBox.prototype = {

  width: function () {
    return this.x2 - this.x1;
  },

  height: function () {
    return this.y2 - this.y1;
  },

  addPoint: function (x, y) {
    if (x != null) {
      if (isNaN(this.x1) || isNaN(this.x2)) {
        this.x1 = x;
        this.x2 = x;
      }
      if (x < this.x1) this.x1 = x;
      if (x > this.x2) this.x2 = x;
    }

    if (y != null) {
      if (isNaN(this.y1) || isNaN(this.y2)) {
        this.y1 = y;
        this.y2 = y;
      }
      if (y < this.y1) this.y1 = y;
      if (y > this.y2) this.y2 = y;
    }
  },

  addX: function (x) {
    this.addPoint(x, null);
  },

  addY: function (y) {
    this.addPoint(null, y);
  },

  addQuadraticCurve: function (p0x, p0y, p1x, p1y, p2x, p2y) {
    var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
    var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
    var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
    var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
    this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
  },

  addBezierCurve: function (p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
    // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    var
      i,
      p0 = [p0x, p0y],
      p1 = [p1x, p1y],
      p2 = [p2x, p2y],
      p3 = [p3x, p3y];

    this.addPoint(p0[0], p0[1]);
    this.addPoint(p3[0], p3[1]);

    for (i = 0; i <= 1; i++) {
      var f = function (t) {
        return Math.pow(1 - t, 3) * p0[i]
          + 3 * Math.pow(1 - t, 2) * t * p1[i]
          + 3 * (1 - t) * Math.pow(t, 2) * p2[i]
          + Math.pow(t, 3) * p3[i];
      };

      var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
      var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
      var c = 3 * p1[i] - 3 * p0[i];

      if (a == 0) {
        if (b == 0) continue;
        var t = -c / b;
        if (0 < t && t < 1) {
          if (i == 0) this.addX(f(t));
          if (i == 1) this.addY(f(t));
        }
        continue;
      }

      var b2ac = Math.pow(b, 2) - 4 * c * a;
      if (b2ac < 0) continue;
      var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
      if (0 < t1 && t1 < 1) {
        if (i == 0) this.addX(f(t1));
        if (i == 1) this.addY(f(t1));
      }
      var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
      if (0 < t2 && t2 < 1) {
        if (i == 0) this.addX(f(t2));
        if (i == 1) this.addY(f(t2));
      }
    }
  }

};



/***/ }),
/* 523 */
/***/ (function(module, exports) {


module.exports = BoundingBoxView;

function BoundingBoxView(boundingBox) {

  this.x1 = this.minX = boundingBox.x1 || 0;
  this.y1 = this.minY = boundingBox.y1 || 0;
  this.x2 = this.maxX = boundingBox.x2 || 0;
  this.y2 = this.maxY = boundingBox.y2 || 0;
  this.width = boundingBox.width() || 0;
  this.height = boundingBox.height() || 0;

}

BoundingBoxView.prototype = {

  round: function(precision) {
    precision = precision || 0;

    this.x1 = this.minX = +this.x1.toFixed(precision);
    this.y1 = this.minY = +this.y1.toFixed(precision);
    this.x2 = this.maxX = +this.x2.toFixed(precision);
    this.y2 = this.maxY = +this.y2.toFixed(precision);
    this.width = +this.width.toFixed(precision);
    this.height = +this.height.toFixed(precision);

    return this;
  },

  scale: function(scale) {
    var
      self = this;

    scale = scale || 1;

    [
      'x1',
      'minX',
      'y1',
      'minY',
      'x2',
      'maxX',
      'y2',
      'maxY',
      'width',
      'height'
    ]
      .forEach(function(name) {
        self[name] = self[name] * scale;
      });

    return this;
  },

  toString: function() {
    return [
      this.minX,
      this.minY,
      this.width,
      this.height
    ]
      .join(' ');
  }

};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(525);


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// SVG Path transformations library
//
// Usage:
//
//    SvgPath('...')
//      .translate(-150, -100)
//      .scale(0.5)
//      .translate(-150, -100)
//      .toFixed(1)
//      .toString()
//




var pathParse      = __webpack_require__(526);
var transformParse = __webpack_require__(527);
var matrix         = __webpack_require__(203);
var a2c            = __webpack_require__(528);
var ellipse        = __webpack_require__(529);


// Class constructor
//
function SvgPath(path) {
  if (!(this instanceof SvgPath)) { return new SvgPath(path); }

  var pstate = pathParse(path);

  // Array of path segments.
  // Each segment is array [command, param1, param2, ...]
  this.segments = pstate.segments;

  // Error message on parse error.
  this.err      = pstate.err;

  // Transforms stack for lazy evaluation
  this.__stack    = [];
}


SvgPath.prototype.__matrix = function (m) {
  var self = this, i;

  // Quick leave for empty matrix
  if (!m.queue.length) { return; }

  this.iterate(function (s, index, x, y) {
    var p, result, name, isRelative;

    switch (s[0]) {

      // Process 'assymetric' commands separately
      case 'v':
        p      = m.calc(0, s[1], true);
        result = (p[0] === 0) ? [ 'v', p[1] ] : [ 'l', p[0], p[1] ];
        break;

      case 'V':
        p      = m.calc(x, s[1], false);
        result = (p[0] === m.calc(x, y, false)[0]) ? [ 'V', p[1] ] : [ 'L', p[0], p[1] ];
        break;

      case 'h':
        p      = m.calc(s[1], 0, true);
        result = (p[1] === 0) ? [ 'h', p[0] ] : [ 'l', p[0], p[1] ];
        break;

      case 'H':
        p      = m.calc(s[1], y, false);
        result = (p[1] === m.calc(x, y, false)[1]) ? [ 'H', p[0] ] : [ 'L', p[0], p[1] ];
        break;

      case 'a':
      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]

        // Drop segment if arc is empty (end point === start point)
        /*if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          return [];
        }*/

        // Transform rx, ry and the x-axis-rotation
        var ma = m.toArray();
        var e = ellipse(s[1], s[2], s[3]).transform(ma);

        // flip sweep-flag if matrix is not orientation-preserving
        if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
          s[5] = s[5] ? '0' : '1';
        }

        // Transform end point as usual (without translation for relative notation)
        p = m.calc(s[6], s[7], s[0] === 'a');

        // Empty arcs can be ignored by renderer, but should not be dropped
        // to avoid collisions with `S A S` and so on. Replace with empty line.
        if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
          break;
        }

        // if the resulting ellipse is (almost) a segment ...
        if (e.isDegenerate()) {
          // replace the arc by a line
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
        } else {
          // if it is a real ellipse
          // s[0], s[4] and s[5] are not modified
          result = [ s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1] ];
        }

        break;

      case 'm':
        // Edge case. The very first `m` should be processed as absolute, if happens.
        // Make sense for coord shift transforms.
        isRelative = index > 0;

        p = m.calc(s[1], s[2], isRelative);
        result = [ 'm', p[0], p[1] ];
        break;

      default:
        name       = s[0];
        result     = [ name ];
        isRelative = (name.toLowerCase() === name);

        // Apply transformations to the segment
        for (i = 1; i < s.length; i += 2) {
          p = m.calc(s[i], s[i + 1], isRelative);
          result.push(p[0], p[1]);
        }
    }

    self.segments[index] = result;
  }, true);
};


// Apply stacked commands
//
SvgPath.prototype.__evaluateStack = function () {
  var m, i;

  if (!this.__stack.length) { return; }

  if (this.__stack.length === 1) {
    this.__matrix(this.__stack[0]);
    this.__stack = [];
    return;
  }

  m = matrix();
  i = this.__stack.length;

  while (--i >= 0) {
    m.matrix(this.__stack[i].toArray());
  }

  this.__matrix(m);
  this.__stack = [];
};


// Convert processed SVG Path back to string
//
SvgPath.prototype.toString = function () {
  var elements = [], skipCmd, cmd;

  this.__evaluateStack();

  for (var i = 0; i < this.segments.length; i++) {
    // remove repeating commands names
    cmd = this.segments[i][0];
    skipCmd = i > 0 && cmd !== 'm' && cmd !== 'M' && cmd === this.segments[i - 1][0];
    elements = elements.concat(skipCmd ? this.segments[i].slice(1) : this.segments[i]);
  }

  return elements.join(' ')
            // Optimizations: remove spaces around commands & before `-`
            //
            // We could also remove leading zeros for `0.5`-like values,
            // but their count is too small to spend time for.
            .replace(/ ?([achlmqrstvz]) ?/gi, '$1')
            .replace(/ \-/g, '-')
            // workaround for FontForge SVG importing bug
            .replace(/zm/g, 'z m');
};


// Translate path to (x [, y])
//
SvgPath.prototype.translate = function (x, y) {
  this.__stack.push(matrix().translate(x, y || 0));
  return this;
};


// Scale path to (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.scale = function (sx, sy) {
  this.__stack.push(matrix().scale(sx, (!sy && (sy !== 0)) ? sx : sy));
  return this;
};


// Rotate path around point (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.rotate = function (angle, rx, ry) {
  this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
  return this;
};


// Skew path along the X axis by `degrees` angle
//
SvgPath.prototype.skewX = function (degrees) {
  this.__stack.push(matrix().skewX(degrees));
  return this;
};


// Skew path along the Y axis by `degrees` angle
//
SvgPath.prototype.skewY = function (degrees) {
  this.__stack.push(matrix().skewY(degrees));
  return this;
};


// Apply matrix transform (array of 6 elements)
//
SvgPath.prototype.matrix = function (m) {
  this.__stack.push(matrix().matrix(m));
  return this;
};


// Transform path according to "transform" attr of SVG spec
//
SvgPath.prototype.transform = function (transformString) {
  if (!transformString.trim()) {
    return this;
  }
  this.__stack.push(transformParse(transformString));
  return this;
};


// Round coords with given decimal precition.
// 0 by default (to integers)
//
SvgPath.prototype.round = function (d) {
  var contourStartDeltaX = 0, contourStartDeltaY = 0, deltaX = 0, deltaY = 0, l;

  d = d || 0;

  this.__evaluateStack();

  this.segments.forEach(function (s) {
    var isRelative = (s[0].toLowerCase() === s[0]);

    switch (s[0]) {
      case 'H':
      case 'h':
        if (isRelative) { s[1] += deltaX; }
        deltaX = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'V':
      case 'v':
        if (isRelative) { s[1] += deltaY; }
        deltaY = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'Z':
      case 'z':
        deltaX = contourStartDeltaX;
        deltaY = contourStartDeltaY;
        return;

      case 'M':
      case 'm':
        if (isRelative) {
          s[1] += deltaX;
          s[2] += deltaY;
        }

        deltaX = s[1] - s[1].toFixed(d);
        deltaY = s[2] - s[2].toFixed(d);

        contourStartDeltaX = deltaX;
        contourStartDeltaY = deltaY;

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        return;

      case 'A':
      case 'a':
        // [cmd, rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        if (isRelative) {
          s[6] += deltaX;
          s[7] += deltaY;
        }

        deltaX = s[6] - s[6].toFixed(d);
        deltaY = s[7] - s[7].toFixed(d);

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        s[3] = +s[3].toFixed(d + 2); // better precision for rotation
        s[6] = +s[6].toFixed(d);
        s[7] = +s[7].toFixed(d);
        return;

      default:
        // a c l q s t
        l = s.length;

        if (isRelative) {
          s[l - 2] += deltaX;
          s[l - 1] += deltaY;
        }

        deltaX = s[l - 2] - s[l - 2].toFixed(d);
        deltaY = s[l - 1] - s[l - 1].toFixed(d);

        s.forEach(function (val, i) {
          if (!i) { return; }
          s[i] = +s[i].toFixed(d);
        });
        return;
    }
  });

  return this;
};


// Apply iterator function to all segments. If function returns result,
// current segment will be replaced to array of returned segments.
// If empty array is returned, current regment will be deleted.
//
SvgPath.prototype.iterate = function (iterator, keepLazyStack) {
  var segments = this.segments,
      replacements = {},
      needReplace = false,
      lastX = 0,
      lastY = 0,
      countourStartX = 0,
      countourStartY = 0;
  var i, j, newSegments;

  if (!keepLazyStack) {
    this.__evaluateStack();
  }

  segments.forEach(function (s, index) {

    var res = iterator(s, index, lastX, lastY);

    if (Array.isArray(res)) {
      replacements[index] = res;
      needReplace = true;
    }

    var isRelative = (s[0] === s[0].toLowerCase());

    // calculate absolute X and Y
    switch (s[0]) {
      case 'm':
      case 'M':
        lastX = s[1] + (isRelative ? lastX : 0);
        lastY = s[2] + (isRelative ? lastY : 0);
        countourStartX = lastX;
        countourStartY = lastY;
        return;

      case 'h':
      case 'H':
        lastX = s[1] + (isRelative ? lastX : 0);
        return;

      case 'v':
      case 'V':
        lastY = s[1] + (isRelative ? lastY : 0);
        return;

      case 'z':
      case 'Z':
        // That make sence for multiple contours
        lastX = countourStartX;
        lastY = countourStartY;
        return;

      default:
        lastX = s[s.length - 2] + (isRelative ? lastX : 0);
        lastY = s[s.length - 1] + (isRelative ? lastY : 0);
    }
  });

  // Replace segments if iterator return results

  if (!needReplace) { return this; }

  newSegments = [];

  for (i = 0; i < segments.length; i++) {
    if (typeof replacements[i] !== 'undefined') {
      for (j = 0; j < replacements[i].length; j++) {
        newSegments.push(replacements[i][j]);
      }
    } else {
      newSegments.push(segments[i]);
    }
  }

  this.segments = newSegments;

  return this;
};


// Converts segments from relative to absolute
//
SvgPath.prototype.abs = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameUC = name.toUpperCase(),
        i;

    // Skip absolute commands
    if (name === nameUC) { return; }

    s[0] = nameUC;

    switch (name) {
      case 'v':
        // v has shifted coords parity
        s[1] += y;
        return;

      case 'a':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] += x;
        s[7] += y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] += i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts segments from absolute to relative
//
SvgPath.prototype.rel = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameLC = name.toLowerCase(),
        i;

    // Skip relative commands
    if (name === nameLC) { return; }

    // Don't touch the first M to avoid potential confusions.
    if (index === 0 && name === 'M') { return; }

    s[0] = nameLC;

    switch (name) {
      case 'V':
        // V has shifted coords parity
        s[1] -= y;
        return;

      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] -= x;
        s[7] -= y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] -= i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts arcs to cubic bézier curves
//
SvgPath.prototype.unarc = function () {
  this.iterate(function (s, index, x, y) {
    var new_segments, nextX, nextY, result = [], name = s[0];

    // Skip anything except arcs
    if (name !== 'A' && name !== 'a') { return null; }

    if (name === 'a') {
      // convert relative arc coordinates to absolute
      nextX = x + s[6];
      nextY = y + s[7];
    } else {
      nextX = s[6];
      nextY = s[7];
    }

    new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);

    // Degenerated arcs can be ignored by renderer, but should not be dropped
    // to avoid collisions with `S A S` and so on. Replace with empty line.
    if (new_segments.length === 0) {
      return [ [ s[0] === 'a' ? 'l' : 'L', s[6], s[7] ] ];
    }

    new_segments.forEach(function (s) {
      result.push([ 'C', s[2], s[3], s[4], s[5], s[6], s[7] ]);
    });

    return result;
  });

  return this;
};


// Converts smooth curves (with missed control point) to generic curves
//
SvgPath.prototype.unshort = function () {
  var segments = this.segments;
  var prevControlX, prevControlY, prevSegment;
  var curControlX, curControlY;

  // TODO: add lazy evaluation flag when relative commands supported

  this.iterate(function (s, idx, x, y) {
    var name = s[0], nameUC = name.toUpperCase(), isRelative;

    // First command MUST be M|m, it's safe to skip.
    // Protect from access to [-1] for sure.
    if (!idx) { return; }

    if (nameUC === 'T') { // quadratic curve
      isRelative = (name === 't');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'Q') {
        prevControlX = prevSegment[1] - x;
        prevControlY = prevSegment[2] - y;
      } else if (prevSegment[0] === 'q') {
        prevControlX = prevSegment[1] - prevSegment[3];
        prevControlY = prevSegment[2] - prevSegment[4];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'q' : 'Q',
        curControlX, curControlY,
        s[1], s[2]
      ];

    } else if (nameUC === 'S') { // cubic curve
      isRelative = (name === 's');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'C') {
        prevControlX = prevSegment[3] - x;
        prevControlY = prevSegment[4] - y;
      } else if (prevSegment[0] === 'c') {
        prevControlX = prevSegment[3] - prevSegment[5];
        prevControlY = prevSegment[4] - prevSegment[6];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'c' : 'C',
        curControlX, curControlY,
        s[1], s[2], s[3], s[4]
      ];
    }
  });

  return this;
};


module.exports = SvgPath;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var paramCounts = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 };

var SPECIAL_SPACES = [
  0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006,
  0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF
];

function isSpace(ch) {
  return (ch === 0x0A) || (ch === 0x0D) || (ch === 0x2028) || (ch === 0x2029) || // Line terminators
    // White spaces
    (ch === 0x20) || (ch === 0x09) || (ch === 0x0B) || (ch === 0x0C) || (ch === 0xA0) ||
    (ch >= 0x1680 && SPECIAL_SPACES.indexOf(ch) >= 0);
}

function isCommand(code) {
  /*eslint-disable no-bitwise*/
  switch (code | 0x20) {
    case 0x6D/* m */:
    case 0x7A/* z */:
    case 0x6C/* l */:
    case 0x68/* h */:
    case 0x76/* v */:
    case 0x63/* c */:
    case 0x73/* s */:
    case 0x71/* q */:
    case 0x74/* t */:
    case 0x61/* a */:
    case 0x72/* r */:
      return true;
  }
  return false;
}

function isDigit(code) {
  return (code >= 48 && code <= 57);   // 0..9
}

function isDigitStart(code) {
  return (code >= 48 && code <= 57) || /* 0..9 */
          code === 0x2B || /* + */
          code === 0x2D || /* - */
          code === 0x2E;   /* . */
}


function State(path) {
  this.index  = 0;
  this.path   = path;
  this.max    = path.length;
  this.result = [];
  this.param  = 0.0;
  this.err    = '';
  this.segmentStart = 0;
  this.data   = [];
}

function skipSpaces(state) {
  while (state.index < state.max && isSpace(state.path.charCodeAt(state.index))) {
    state.index++;
  }
}


function scanParam(state) {
  var start = state.index,
      index = start,
      max = state.max,
      zeroFirst = false,
      hasCeiling = false,
      hasDecimal = false,
      hasDot = false,
      ch;

  if (index >= max) {
    state.err = 'SvgPath: missed param (at pos ' + index + ')';
    return;
  }
  ch = state.path.charCodeAt(index);

  if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
    index++;
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  // This logic is shamelessly borrowed from Esprima
  // https://github.com/ariya/esprimas
  //
  if (!isDigit(ch) && ch !== 0x2E/* . */) {
    state.err = 'SvgPath: param should start with 0..9 or `.` (at pos ' + index + ')';
    return;
  }

  if (ch !== 0x2E/* . */) {
    zeroFirst = (ch === 0x30/* 0 */);
    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;

    if (zeroFirst && index < max) {
      // decimal number starts with '0' such as '09' is illegal.
      if (ch && isDigit(ch)) {
        state.err = 'SvgPath: numbers started with `0` such as `09` are ilegal (at pos ' + start + ')';
        return;
      }
    }

    while (index < max && isDigit(state.path.charCodeAt(index))) {
      index++;
      hasCeiling = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x2E/* . */) {
    hasDot = true;
    index++;
    while (isDigit(state.path.charCodeAt(index))) {
      index++;
      hasDecimal = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x65/* e */ || ch === 0x45/* E */) {
    if (hasDot && !hasCeiling && !hasDecimal) {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }

    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;
    if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
      index++;
    }
    if (index < max && isDigit(state.path.charCodeAt(index))) {
      while (index < max && isDigit(state.path.charCodeAt(index))) {
        index++;
      }
    } else {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }
  }

  state.index = index;
  state.param = parseFloat(state.path.slice(start, index)) + 0.0;
}


function finalizeSegment(state) {
  var cmd, cmdLC;

  // Process duplicated commands (without comand name)

  // This logic is shamelessly borrowed from Raphael
  // https://github.com/DmitryBaranovskiy/raphael/
  //
  cmd   = state.path[state.segmentStart];
  cmdLC = cmd.toLowerCase();

  var params = state.data;

  if (cmdLC === 'm' && params.length > 2) {
    state.result.push([ cmd, params[0], params[1] ]);
    params = params.slice(2);
    cmdLC = 'l';
    cmd = (cmd === 'm') ? 'l' : 'L';
  }

  if (cmdLC === 'r') {
    state.result.push([ cmd ].concat(params));
  } else {

    while (params.length >= paramCounts[cmdLC]) {
      state.result.push([ cmd ].concat(params.splice(0, paramCounts[cmdLC])));
      if (!paramCounts[cmdLC]) {
        break;
      }
    }
  }
}


function scanSegment(state) {
  var max = state.max,
      cmdCode, comma_found, need_params, i;

  state.segmentStart = state.index;
  cmdCode = state.path.charCodeAt(state.index);

  if (!isCommand(cmdCode)) {
    state.err = 'SvgPath: bad command ' + state.path[state.index] + ' (at pos ' + state.index + ')';
    return;
  }

  need_params = paramCounts[state.path[state.index].toLowerCase()];

  state.index++;
  skipSpaces(state);

  state.data = [];

  if (!need_params) {
    // Z
    finalizeSegment(state);
    return;
  }

  comma_found = false;

  for (;;) {
    for (i = need_params; i > 0; i--) {
      scanParam(state);
      if (state.err.length) {
        return;
      }
      state.data.push(state.param);

      skipSpaces(state);
      comma_found = false;

      if (state.index < max && state.path.charCodeAt(state.index) === 0x2C/* , */) {
        state.index++;
        skipSpaces(state);
        comma_found = true;
      }
    }

    // after ',' param is mandatory
    if (comma_found) {
      continue;
    }

    if (state.index >= state.max) {
      break;
    }

    // Stop on next segment
    if (!isDigitStart(state.path.charCodeAt(state.index))) {
      break;
    }
  }

  finalizeSegment(state);
}


/* Returns array of segments:
 *
 * [
 *   [ command, coord1, coord2, ... ]
 * ]
 */
module.exports = function pathParse(svgPath) {
  var state = new State(svgPath);
  var max = state.max;

  skipSpaces(state);

  while (state.index < max && !state.err.length) {
    scanSegment(state);
  }

  if (state.err.length) {
    state.result = [];

  } else if (state.result.length) {

    if ('mM'.indexOf(state.result[0][0]) < 0) {
      state.err = 'SvgPath: string should start with `M` or `m`';
      state.result = [];
    } else {
      state.result[0][0] = 'M';
    }
  }

  return {
    err: state.err,
    segments: state.result
  };
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Matrix = __webpack_require__(203);

var operations = {
  matrix: true,
  scale: true,
  rotate: true,
  translate: true,
  skewX: true,
  skewY: true
};

var CMD_SPLIT_RE    = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
var PARAMS_SPLIT_RE = /[\s,]+/;


module.exports = function transformParse(transformString) {
  var matrix = new Matrix();
  var cmd, params;

  // Split value into ['', 'translate', '10 50', '', 'scale', '2', '', 'rotate',  '-45', '']
  transformString.split(CMD_SPLIT_RE).forEach(function (item) {

    // Skip empty elements
    if (!item.length) { return; }

    // remember operation
    if (typeof operations[item] !== 'undefined') {
      cmd = item;
      return;
    }

    // extract params & att operation to matrix
    params = item.split(PARAMS_SPLIT_RE).map(function (i) {
      return +i || 0;
    });

    // If params count is not correct - ignore command
    switch (cmd) {
      case 'matrix':
        if (params.length === 6) {
          matrix.matrix(params);
        }
        return;

      case 'scale':
        if (params.length === 1) {
          matrix.scale(params[0], params[0]);
        } else if (params.length === 2) {
          matrix.scale(params[0], params[1]);
        }
        return;

      case 'rotate':
        if (params.length === 1) {
          matrix.rotate(params[0], 0, 0);
        } else if (params.length === 3) {
          matrix.rotate(params[0], params[1], params[2]);
        }
        return;

      case 'translate':
        if (params.length === 1) {
          matrix.translate(params[0], 0);
        } else if (params.length === 2) {
          matrix.translate(params[0], params[1]);
        }
        return;

      case 'skewX':
        if (params.length === 1) {
          matrix.skewX(params[0]);
        }
        return;

      case 'skewY':
        if (params.length === 1) {
          matrix.skewY(params[0]);
        }
        return;
    }
  });

  return matrix;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert an arc to a sequence of cubic bézier curves
//



var TAU = Math.PI * 2;


/* eslint-disable space-infix-ops */

// Calculate an angle between two vectors
//
function vector_angle(ux, uy, vx, vy) {
  var sign = (ux * vy - uy * vx < 0) ? -1 : 1;
  var umag = Math.sqrt(ux * ux + uy * uy);
  var vmag = Math.sqrt(ux * ux + uy * uy);
  var dot  = ux * vx + uy * vy;
  var div  = dot / (umag * vmag);

  // rounding errors, e.g. -1.0000000000000002 can screw up this
  if (div >  1.0) { div =  1.0; }
  if (div < -1.0) { div = -1.0; }

  return sign * Math.acos(div);
}


// Convert from endpoint to center parameterization,
// see http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
//
// Return [cx, cy, theta1, delta_theta]
//
function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi) {
  // Step 1.
  //
  // Moving an ellipse so origin will be the middlepoint between our two
  // points. After that, rotate it to line up ellipse axes with coordinate
  // axes.
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  var rx_sq  =  rx * rx;
  var ry_sq  =  ry * ry;
  var x1p_sq = x1p * x1p;
  var y1p_sq = y1p * y1p;

  // Step 2.
  //
  // Compute coordinates of the centre of this ellipse (cx', cy')
  // in the new coordinate system.
  //
  var radicant = (rx_sq * ry_sq) - (rx_sq * y1p_sq) - (ry_sq * x1p_sq);

  if (radicant < 0) {
    // due to rounding errors it might be e.g. -1.3877787807814457e-17
    radicant = 0;
  }

  radicant /=   (rx_sq * y1p_sq) + (ry_sq * x1p_sq);
  radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);

  var cxp = radicant *  rx/ry * y1p;
  var cyp = radicant * -ry/rx * x1p;

  // Step 3.
  //
  // Transform back to get centre coordinates (cx, cy) in the original
  // coordinate system.
  //
  var cx = cos_phi*cxp - sin_phi*cyp + (x1+x2)/2;
  var cy = sin_phi*cxp + cos_phi*cyp + (y1+y2)/2;

  // Step 4.
  //
  // Compute angles (theta1, delta_theta).
  //
  var v1x =  (x1p - cxp) / rx;
  var v1y =  (y1p - cyp) / ry;
  var v2x = (-x1p - cxp) / rx;
  var v2y = (-y1p - cyp) / ry;

  var theta1 = vector_angle(1, 0, v1x, v1y);
  var delta_theta = vector_angle(v1x, v1y, v2x, v2y);

  if (fs === 0 && delta_theta > 0) {
    delta_theta -= TAU;
  }
  if (fs === 1 && delta_theta < 0) {
    delta_theta += TAU;
  }

  return [ cx, cy, theta1, delta_theta ];
}

//
// Approximate one unit arc segment with bézier curves,
// see http://math.stackexchange.com/questions/873224
//
function approximate_unit_arc(theta1, delta_theta) {
  var alpha = 4/3 * Math.tan(delta_theta/4);

  var x1 = Math.cos(theta1);
  var y1 = Math.sin(theta1);
  var x2 = Math.cos(theta1 + delta_theta);
  var y2 = Math.sin(theta1 + delta_theta);

  return [ x1, y1, x1 - y1*alpha, y1 + x1*alpha, x2 + y2*alpha, y2 - x2*alpha, x2, y2 ];
}

module.exports = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, phi) {
  var sin_phi = Math.sin(phi * TAU / 360);
  var cos_phi = Math.cos(phi * TAU / 360);

  // Make sure radii are valid
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  if (x1p === 0 && y1p === 0) {
    // we're asked to draw line to itself
    return [];
  }

  if (rx === 0 || ry === 0) {
    // one of the radii is zero
    return [];
  }


  // Compensate out-of-range radii
  //
  rx = Math.abs(rx);
  ry = Math.abs(ry);

  var lambda = (x1p * x1p) / (rx * rx) + (y1p * y1p) / (ry * ry);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }


  // Get center parameters (cx, cy, theta1, delta_theta)
  //
  var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi);

  var result = [];
  var theta1 = cc[2];
  var delta_theta = cc[3];

  // Split an arc to multiple segments, so each segment
  // will be less than τ/4 (= 90°)
  //
  var segments = Math.max(Math.ceil(Math.abs(delta_theta) / (TAU / 4)), 1);
  delta_theta /= segments;

  for (var i = 0; i < segments; i++) {
    result.push(approximate_unit_arc(theta1, delta_theta));
    theta1 += delta_theta;
  }

  // We have a bezier approximation of a unit circle,
  // now need to transform back to the original ellipse
  //
  return result.map(function (curve) {
    for (var i = 0; i < curve.length; i += 2) {
      var x = curve[i + 0];
      var y = curve[i + 1];

      // scale
      x *= rx;
      y *= ry;

      // rotate
      var xp = cos_phi*x - sin_phi*y;
      var yp = sin_phi*x + cos_phi*y;

      // translate
      curve[i + 0] = xp + cc[0];
      curve[i + 1] = yp + cc[1];
    }

    return curve;
  });
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable space-infix-ops */

// The precision used to consider an ellipse as a circle
//
var epsilon = 0.0000000001;

// To convert degree in radians
//
var torad = Math.PI / 180;

// Class constructor :
//  an ellipse centred at 0 with radii rx,ry and x - axis - angle ax.
//
function Ellipse(rx, ry, ax) {
  if (!(this instanceof Ellipse)) { return new Ellipse(rx, ry, ax); }
  this.rx = rx;
  this.ry = ry;
  this.ax = ax;
}

// Apply a linear transform m to the ellipse
// m is an array representing a matrix :
//    -         -
//   | m[0] m[2] |
//   | m[1] m[3] |
//    -         -
//
Ellipse.prototype.transform = function (m) {
  // We consider the current ellipse as image of the unit circle
  // by first scale(rx,ry) and then rotate(ax) ...
  // So we apply ma =  m x rotate(ax) x scale(rx,ry) to the unit circle.
  var c = Math.cos(this.ax * torad), s = Math.sin(this.ax * torad);
  var ma = [
    this.rx * (m[0]*c + m[2]*s),
    this.rx * (m[1]*c + m[3]*s),
    this.ry * (-m[0]*s + m[2]*c),
    this.ry * (-m[1]*s + m[3]*c)
  ];

  // ma * transpose(ma) = [ J L ]
  //                      [ L K ]
  // L is calculated later (if the image is not a circle)
  var J = ma[0]*ma[0] + ma[2]*ma[2],
      K = ma[1]*ma[1] + ma[3]*ma[3];

  // the discriminant of the characteristic polynomial of ma * transpose(ma)
  var D = ((ma[0]-ma[3])*(ma[0]-ma[3]) + (ma[2]+ma[1])*(ma[2]+ma[1])) *
          ((ma[0]+ma[3])*(ma[0]+ma[3]) + (ma[2]-ma[1])*(ma[2]-ma[1]));

  // the "mean eigenvalue"
  var JK = (J + K) / 2;

  // check if the image is (almost) a circle
  if (D < epsilon * JK) {
    // if it is
    this.rx = this.ry = Math.sqrt(JK);
    this.ax = 0;
    return this;
  }

  // if it is not a circle
  var L = ma[0]*ma[1] + ma[2]*ma[3];

  D = Math.sqrt(D);

  // {l1,l2} = the two eigen values of ma * transpose(ma)
  var l1 = JK + D/2,
      l2 = JK - D/2;
  // the x - axis - rotation angle is the argument of the l1 - eigenvector
  this.ax = (Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon) ?
    90
  :
    Math.atan(Math.abs(L) > Math.abs(l1 - K) ?
      (l1 - J) / L
    :
      L / (l1 - K)
    ) * 180 / Math.PI;

  // if ax > 0 => rx = sqrt(l1), ry = sqrt(l2), else exchange axes and ax += 90
  if (this.ax >= 0) {
    // if ax in [0,90]
    this.rx = Math.sqrt(l1);
    this.ry = Math.sqrt(l2);
  } else {
    // if ax in ]-90,0[ => exchange axes
    this.ax += 90;
    this.rx = Math.sqrt(l2);
    this.ry = Math.sqrt(l1);
  }

  return this;
};

// Check if the ellipse is (almost) degenerate, i.e. rx = 0 or ry = 0
//
Ellipse.prototype.isDegenerate = function () {
  return (this.rx < epsilon * this.ry || this.ry < epsilon * this.rx);
};

module.exports = Ellipse;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NetworkFrame2 = __webpack_require__(59);

var _NetworkFrame3 = _interopRequireDefault(_NetworkFrame2);

var _MiniMap = __webpack_require__(108);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var MinimapNetworkFrame = function (_NetworkFrame) {
  _inherits(MinimapNetworkFrame, _NetworkFrame);

  function MinimapNetworkFrame(props) {
    _classCallCheck(this, MinimapNetworkFrame);

    var _this = _possibleConstructorReturn(this, (MinimapNetworkFrame.__proto__ || Object.getPrototypeOf(MinimapNetworkFrame)).call(this, props));

    _this.generateMinimap = _this.generateMinimap.bind(_this);
    return _this;
  }

  _createClass(MinimapNetworkFrame, [{
    key: "generateMinimap",
    value: function generateMinimap() {
      var miniDefaults = {
        title: "",
        position: [0, 0],
        size: [this.props.size[0] * 5, this.props.size[1] * 5],
        edges: this.props.edges,
        nodes: this.props.nodes,
        xBrushable: true,
        yBrushable: true,
        brushStart: function brushStart() {},
        brush: function brush() {},
        brushEnd: function brushEnd() {}
      };

      var combinedOptions = _extends(miniDefaults, this.props.minimap);

      combinedOptions.hoverAnnotation = false;

      return _react2.default.createElement(_MiniMap2.default, combinedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var miniMap = this.generateMinimap();
      var options = {};
      if (this.props.renderBefore) {
        options.beforeElements = miniMap;
      } else {
        options.afterElements = miniMap;
      }

      return this.renderBody(options);
    }
  }]);

  return MinimapNetworkFrame;
}(_NetworkFrame3.default);

MinimapNetworkFrame.propTypes = {
  size: _propTypes2.default.array,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  points: _propTypes2.default.array,
  lines: _propTypes2.default.array,
  areas: _propTypes2.default.array,
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minimap: _propTypes2.default.object,
  renderBefore: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = MinimapNetworkFrame;
module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(532)) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree'], factory) :
  (factory((global.d3 = global.d3 || {}),global.d3));
}(this, function (exports,d3Quadtree) { 'use strict';

  function bboxCollide (bbox) {

    function x (d) {
      return d.x + d.vx;
    }

    function y (d) {
      return d.y + d.vy;
    }

    function constant (x) {
      return function () {
        return x;
      };
    }

    var nodes,
        boundingBoxes,
        strength = 1,
        iterations = 1;

        if (typeof bbox !== "function") {
          bbox = constant(bbox === null ? [[0,0][1,1]] : bbox)
        }

        function force () {
          var i,
              tree,
              node,
              xi,
              yi,
              bbi,
              nx1,
              ny1,
              nx2,
              ny2

              var cornerNodes = []
              nodes.forEach(function (d, i) {
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + (boundingBoxes[i][1][0] + boundingBoxes[i][0][0]) / 2, y: d.y + (boundingBoxes[i][0][1] + boundingBoxes[i][1][1]) / 2})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][0][0], y: d.y + boundingBoxes[i][0][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][0][0], y: d.y + boundingBoxes[i][1][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][1][0], y: d.y + boundingBoxes[i][0][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][1][0], y: d.y + boundingBoxes[i][1][1]})
              })
              var cn = cornerNodes.length

          for (var k = 0; k < iterations; ++k) {
            tree = d3Quadtree.quadtree(cornerNodes, x, y).visitAfter(prepareCorners);

            for (i = 0; i < cn; ++i) {
              var nodeI = ~~(i / 5);
              node = nodes[nodeI]
              bbi = boundingBoxes[nodeI]
              xi = node.x + node.vx
              yi = node.y + node.vy
              nx1 = xi + bbi[0][0]
              ny1 = yi + bbi[0][1]
              nx2 = xi + bbi[1][0]
              ny2 = yi + bbi[1][1]
              tree.visit(apply);
            }
          }

          function apply (quad, x0, y0, x1, y1) {
              var data = quad.data
              if (data) {
                var bWidth = bbLength(bbi, 0),
                bHeight = bbLength(bbi, 1);

                if (data.node.index !== nodeI) {
                  var dataNode = data.node
                  var bbj = boundingBoxes[dataNode.index],
                    dnx1 = dataNode.x + dataNode.vx + bbj[0][0],
                    dny1 = dataNode.y + dataNode.vy + bbj[0][1],
                    dnx2 = dataNode.x + dataNode.vx + bbj[1][0],
                    dny2 = dataNode.y + dataNode.vy + bbj[1][1],
                    dWidth = bbLength(bbj, 0),
                    dHeight = bbLength(bbj, 1)

                  if (nx1 <= dnx2 && dnx1 <= nx2 && ny1 <= dny2 && dny1 <= ny2) {

                    var xSize = [Math.min.apply(null, [dnx1, dnx2, nx1, nx2]), Math.max.apply(null, [dnx1, dnx2, nx1, nx2])]
                    var ySize = [Math.min.apply(null, [dny1, dny2, ny1, ny2]), Math.max.apply(null, [dny1, dny2, ny1, ny2])]

                    var xOverlap = bWidth + dWidth - (xSize[1] - xSize[0])
                    var yOverlap = bHeight + dHeight - (ySize[1] - ySize[0])

                    var xBPush = xOverlap * strength * (yOverlap / bHeight)
                    var yBPush = yOverlap * strength * (xOverlap / bWidth)

                    var xDPush = xOverlap * strength * (yOverlap / dHeight)
                    var yDPush = yOverlap * strength * (xOverlap / dWidth)

                    if ((nx1 + nx2) / 2 < (dnx1 + dnx2) / 2) {
                      node.vx -= xBPush
                      dataNode.vx += xDPush
                    }
                    else {
                      node.vx += xBPush
                      dataNode.vx -= xDPush
                    }
                    if ((ny1 + ny2) / 2 < (dny1 + dny2) / 2) {
                      node.vy -= yBPush
                      dataNode.vy += yDPush
                    }
                    else {
                      node.vy += yBPush
                      dataNode.vy -= yDPush
                    }
                  }

                }
                return;
              }

              return x0 > nx2 || x1 < nx1 || y0 > ny2 || y1 < ny1;
          }

        }

        function prepareCorners (quad) {

          if (quad.data) {
            return quad.bb = boundingBoxes[quad.data.node.index]
          }
            quad.bb = [[0,0],[0,0]]
            for (var i = 0; i < 4; ++i) {
              if (quad[i] && quad[i].bb[0][0] < quad.bb[0][0]) {
                quad.bb[0][0] = quad[i].bb[0][0]
              }
              if (quad[i] && quad[i].bb[0][1] < quad.bb[0][1]) {
                quad.bb[0][1] = quad[i].bb[0][1]
              }
              if (quad[i] && quad[i].bb[1][0] > quad.bb[1][0]) {
                quad.bb[1][0] = quad[i].bb[1][0]
              }
              if (quad[i] && quad[i].bb[1][1] > quad.bb[1][1]) {
                quad.bb[1][1] = quad[i].bb[1][1]
              }
          }
        }

        function bbLength (bbox, heightWidth) {
          return bbox[1][heightWidth] - bbox[0][heightWidth]
        }

        force.initialize = function (_) {
          var i, n = (nodes = _).length; boundingBoxes = new Array(n);
          for (i = 0; i < n; ++i) boundingBoxes[i] = bbox(nodes[i], i, nodes);
        };

        force.iterations = function (_) {
          return arguments.length ? (iterations = +_, force) : iterations;
        };

        force.strength = function (_) {
          return arguments.length ? (strength = +_, force) : strength;
        };

        force.bbox = function (_) {
          return arguments.length ? (bbox = typeof _ === "function" ? _ : constant(+_), force) : bbox;
        };

        return force;
  }

  exports.bboxCollide = bboxCollide;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quadtree", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(545);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(109);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(109);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(109);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areaLink = exports.ribbonLink = exports.drawEdges = exports.drawNodes = exports.hierarchicalRectNodeGenerator = exports.radialRectNodeGenerator = exports.chordNodeGenerator = exports.sankeyNodeGenerator = exports.wordcloudNodeGenerator = exports.chordEdgeGenerator = exports.circleNodeGenerator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.topologicalSort = topologicalSort;
exports.circularAreaLink = circularAreaLink;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(6);

var _d3Glyphedge = __webpack_require__(547);

var _d3Shape = __webpack_require__(7);

var _SvgHelper = __webpack_require__(95);

var _d3Interpolate = __webpack_require__(548);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sankeyEdgeSort(a, b, direction) {
  if (a.circular && !b.circular) return -1;
  if (b.circular && !a.circular) return 1;
  var first = direction === "down" ? "y" : "x";
  var second = direction === "down" ? "x" : "y";

  return a.source[first] === b.source[first] ? a.sankeyWidth === b.sankeyWidth ? a.source[second] - b.source[second] : b.sankeyWidth - a.sankeyWidth : a.source[first] - b.source[first];
}

var customEdgeHashD = {
  linearc: function linearc(d) {
    return _d3Glyphedge.d.lineArc(d);
  },
  ribbon: function ribbon(d) {
    return _d3Glyphedge.d.ribbon(d, d.width);
  },
  arrowhead: function arrowhead(d) {
    return _d3Glyphedge.d.arrowHead(d, d.target.nodeSize, d.width, d.width * 1.5);
  },
  halfarrow: function halfarrow(d) {
    return _d3Glyphedge.d.halfArrow(d, d.target.nodeSize, d.width, d.width * 1.5);
  },
  nail: function nail(d) {
    return _d3Glyphedge.d.nail(d, d.source.nodeSize);
  },
  comet: function comet(d) {
    return _d3Glyphedge.d.comet(d, d.target.nodeSize);
  },
  taffy: function taffy(d) {
    return _d3Glyphedge.d.taffy(d, d.source.nodeSize / 2, d.target.nodeSize / 2, (d.source.nodeSize + d.target.nodeSize) / 4);
  }
};

var circleNodeGenerator = exports.circleNodeGenerator = function circleNodeGenerator(_ref) {
  var d = _ref.d,
      i = _ref.i,
      styleFn = _ref.styleFn,
      renderMode = _ref.renderMode,
      key = _ref.key,
      className = _ref.className,
      transform = _ref.transform,
      baseMarkProps = _ref.baseMarkProps;

  //this is repetitious

  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    key: key,
    transform: transform,
    markType: "rect",
    width: d.nodeSize * 2,
    height: d.nodeSize * 2,
    ry: d.nodeSize * 2,
    rx: d.nodeSize * 2,
    x: -d.nodeSize,
    y: -d.nodeSize,
    style: styleFn(d, i),
    renderMode: renderMode ? renderMode(d, i) : undefined,
    className: className,
    "aria-label": "Node " + d.id,
    tabIndex: -1
  }));
};

var chordEdgeGenerator = exports.chordEdgeGenerator = function chordEdgeGenerator(size) {
  return function (_ref2) {
    var d = _ref2.d,
        i = _ref2.i,
        styleFn = _ref2.styleFn,
        renderMode = _ref2.renderMode,
        key = _ref2.key,
        className = _ref2.className,
        baseMarkProps = _ref2.baseMarkProps;
    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      renderMode: renderMode ? renderMode(d, i) : undefined,
      key: key,
      className: className,
      simpleInterpolate: true,
      transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")",
      markType: "path",
      d: d.d,
      style: styleFn(d, i),
      "aria-label": "Connection from " + d.source.id + " to " + d.target.id,
      tabIndex: -1
    }));
  };
};

var wordcloudNodeGenerator = exports.wordcloudNodeGenerator = function wordcloudNodeGenerator(_ref3) {
  var d = _ref3.d,
      i = _ref3.i,
      styleFn = _ref3.styleFn,
      key = _ref3.key,
      className = _ref3.className,
      transform = _ref3.transform;

  var textStyle = styleFn(d, i);
  textStyle.fontSize = d.fontSize + "px";
  textStyle.fontWeight = d.fontWeight;
  textStyle.textAnchor = "middle";
  var textTransform = void 0,
      textY = void 0,
      textX = void 0;
  textTransform = "scale(" + d.scale + ")";

  if (!d.rotate) {
    textY = d.textHeight / 4;
    textTransform = "scale(" + d.scale + ")";
  } else {
    textTransform = "rotate(90) scale(" + d.scale + ")";
    textY = d.textHeight / 4;
  }

  return _react2.default.createElement(
    "g",
    { key: key, transform: transform },
    _react2.default.createElement(
      "text",
      {
        style: textStyle,
        y: textY,
        x: textX,
        transform: textTransform,
        className: className + " wordcloud",
        "aria-label": d._NWFText,
        role: "img",
        tabIndex: -1
      },
      d._NWFText
    )
  );
};

var sankeyNodeGenerator = exports.sankeyNodeGenerator = function sankeyNodeGenerator(_ref4) {
  var d = _ref4.d,
      i = _ref4.i,
      styleFn = _ref4.styleFn,
      renderMode = _ref4.renderMode,
      key = _ref4.key,
      className = _ref4.className,
      transform = _ref4.transform,
      baseMarkProps = _ref4.baseMarkProps;

  var height = d.direction !== "down" ? d.height : d.width;
  var width = d.direction !== "down" ? d.width : d.height;
  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    renderMode: renderMode ? renderMode(d, i) : undefined,
    key: key,
    className: className,
    transform: transform,
    markType: "rect",
    height: height,
    width: width,
    x: -width / 2,
    y: -height / 2,
    rx: 0,
    ry: 0,
    style: styleFn(d),
    "aria-label": "Node " + d.id,
    tabIndex: -1
  }));
};

var chordNodeGenerator = exports.chordNodeGenerator = function chordNodeGenerator(size) {
  return function (_ref5) {
    var d = _ref5.d,
        i = _ref5.i,
        styleFn = _ref5.styleFn,
        renderMode = _ref5.renderMode,
        key = _ref5.key,
        className = _ref5.className,
        baseMarkProps = _ref5.baseMarkProps;
    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      renderMode: renderMode ? renderMode(d, i) : undefined,
      key: key,
      className: className,
      transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")",
      markType: "path",
      d: d.d,
      style: styleFn(d, i),
      "aria-label": "Node " + d.id,
      tabIndex: -1
    }));
  };
};

var radialRectNodeGenerator = exports.radialRectNodeGenerator = function radialRectNodeGenerator(size, center) {
  var radialArc = (0, _d3Shape.arc)();
  return function (_ref6) {
    var d = _ref6.d,
        i = _ref6.i,
        styleFn = _ref6.styleFn,
        renderMode = _ref6.renderMode,
        key = _ref6.key,
        className = _ref6.className,
        baseMarkProps = _ref6.baseMarkProps;

    radialArc.innerRadius(d.y0 / 2).outerRadius(d.y1 / 2);

    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      key: key,
      transform: "translate(" + center + ")",
      markType: "path",
      d: radialArc({
        startAngle: d.x0 / size[0] * Math.PI * 2,
        endAngle: d.x1 / size[0] * Math.PI * 2
      }),
      style: styleFn(d, i),
      renderMode: renderMode ? renderMode(d, i) : undefined,
      className: className,
      "aria-label": "Node " + d.id,
      tabIndex: -1
    }));
  };
};

var hierarchicalRectNodeGenerator = exports.hierarchicalRectNodeGenerator = function hierarchicalRectNodeGenerator(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      styleFn = _ref7.styleFn,
      renderMode = _ref7.renderMode,
      key = _ref7.key,
      className = _ref7.className,
      baseMarkProps = _ref7.baseMarkProps;

  //this is repetitious
  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    key: key,
    transform: "translate(0,0)",
    markType: "rect",
    width: d.x1 - d.x0,
    height: d.y1 - d.y0,
    x: d.x0,
    y: d.y0,
    rx: 0,
    ry: 0,
    style: styleFn(d, i),
    renderMode: renderMode ? renderMode(d, i) : undefined,
    className: className,
    "aria-label": "Node " + d.id,
    tabIndex: -1
  }));
};

var genericLineGenerator = function genericLineGenerator(d) {
  return "M" + d.source.x + "," + d.source.y + "L" + d.target.x + "," + d.target.y;
};

var drawNodes = exports.drawNodes = function drawNodes(_ref8) {
  var data = _ref8.data,
      renderKeyFn = _ref8.renderKeyFn,
      customMark = _ref8.customMark,
      styleFn = _ref8.styleFn,
      classFn = _ref8.classFn,
      renderMode = _ref8.renderMode,
      canvasDrawing = _ref8.canvasDrawing,
      canvasRenderFn = _ref8.canvasRenderFn,
      baseMarkProps = _ref8.baseMarkProps;

  var markGenerator = customMark;
  var renderedData = [];

  if (customMark && canvasRenderFn) {
    console.error("canvas rendering currently only supports generic circle nodes based on nodeSize");
  }

  data.forEach(function (d, i) {
    if (canvasRenderFn && canvasRenderFn(d, i) === true) {
      var canvasNode = {
        baseClass: "frame-piece",
        tx: d.x,
        ty: d.y,
        d: d,
        i: i,
        markProps: { markType: "circle", r: d.nodeSize },
        styleFn: styleFn,
        renderFn: renderMode,
        classFn: classFn
      };
      canvasDrawing.push(canvasNode);
    } else {
      renderedData.push(markGenerator({
        d: d,
        i: i,
        renderKeyFn: renderKeyFn,
        styleFn: styleFn,
        classFn: classFn,
        renderMode: renderMode,
        key: renderKeyFn ? renderKeyFn(d, i) : d.id || "node-" + i,
        className: "node " + classFn(d, i),
        transform: "translate(" + d.x + "," + d.y + ")",
        baseMarkProps: baseMarkProps
      }));
    }
  });
  return renderedData;
};

var drawEdges = exports.drawEdges = function drawEdges(_ref9) {
  var baseData = _ref9.data,
      renderKeyFn = _ref9.renderKeyFn,
      customMark = _ref9.customMark,
      styleFn = _ref9.styleFn,
      classFn = _ref9.classFn,
      renderMode = _ref9.renderMode,
      canvasRenderFn = _ref9.canvasRenderFn,
      canvasDrawing = _ref9.canvasDrawing,
      type = _ref9.type,
      baseMarkProps = _ref9.baseMarkProps,
      networkType = _ref9.networkType,
      direction = _ref9.direction;

  var data = networkType === "sankey" ? baseData.sort(function (a, b) {
    return sankeyEdgeSort(a, b, direction);
  }) : baseData;

  var dGenerator = genericLineGenerator;
  var renderedData = [];
  if (customMark) {
    data.forEach(function (d, i) {
      renderedData.push(customMark({
        d: d,
        i: i,
        renderKeyFn: renderKeyFn,
        styleFn: styleFn,
        classFn: classFn,
        renderMode: renderMode,
        key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i,
        className: classFn(d, i) + " edge",
        transform: "translate(" + d.x + "," + d.y + ")",
        baseMarkProps: baseMarkProps
      }));
    });
  } else {
    if (type) {
      if (typeof type === "function") {
        dGenerator = type;
      } else if (customEdgeHashD[type]) {
        dGenerator = function dGenerator(d) {
          return customEdgeHashD[type](d);
        };
      }
    }
    data.forEach(function (d, i) {
      if (canvasRenderFn && canvasRenderFn(d, i) === true) {
        var canvasNode = {
          baseClass: "frame-piece",
          tx: d.x,
          ty: d.y,
          d: d,
          i: i,
          markProps: { markType: "path", d: dGenerator(d) },
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasNode);
      } else {
        renderedData.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i,
          markType: "path",
          renderMode: renderMode ? renderMode(d, i) : undefined,
          className: classFn(d) + " edge",
          d: dGenerator(d),
          style: styleFn(d, i),
          tabIndex: -1,
          role: "img",
          "aria-label": "connection from " + d.source.id + " to " + d.target.id
        })));
      }
    });
  }

  return renderedData;
};

function topologicalSort(nodesArray, edgesArray) {
  // adapted from https://simplapi.wordpress.com/2015/08/19/detect-graph-cycle-in-javascript/
  var nodes = [];
  var nodeHash = {};
  edgesArray.forEach(function (edge) {
    if (!edge.source.id || !edge.target.id) {
      return false;
    }
    if (!nodeHash[edge.source.id]) {
      nodeHash[edge.source.id] = { _id: edge.source.id, links: [] };
      nodes.push(nodeHash[edge.source.id]);
    }
    if (!nodeHash[edge.target.id]) {
      nodeHash[edge.target.id] = { _id: edge.target.id, links: [] };
      nodes.push(nodeHash[edge.target.id]);
    }
    nodeHash[edge.source.id].links.push(edge.target.id);
  });

  // Test if a node got any icoming edge
  function hasIncomingEdge(list, node) {
    for (var i = 0, l = list.length; i < l; ++i) {
      if (list[i].links.indexOf(node._id) !== -1) {
        return true;
      }
    }
    return false;
  }

  // Kahn Algorithm
  var L = [],
      S = nodes.filter(function (node) {
    return !hasIncomingEdge(nodes, node);
  });

  var n = null;

  while (S.length) {
    // Remove a node n from S
    n = S.pop();
    // Add n to tail of L
    L.push(n);

    var i = n.links.length;
    while (i--) {
      // Getting the node associated to the current stored id in links
      var m = nodes[nodes.map(function (d) {
        return d._id;
      }).indexOf(n.links[i])];

      // Remove edge e from the graph
      n.links.pop();

      if (!hasIncomingEdge(nodes, m)) {
        S.push(m);
      }
    }
  }

  // If any of them still got links, there is cycle somewhere
  var nodeWithEdge = nodes.find(function (node) {
    return node.links.length !== 0;
  });

  return nodeWithEdge ? null : L;
}
var curvature = 0.5;

var ribbonLink = exports.ribbonLink = function ribbonLink(d) {
  var diff = d.direction === "down" ? Math.abs(d.target.y - d.source.y) : Math.abs(d.source.x - d.target.x);
  // const halfWidth = d.width / 2
  var testCoordinates = d.direction === "down" ? [{
    x: d.y0,
    y: d.source.y
  }, {
    x: d.y0,
    y: d.source.y + diff / 3
  }, {
    x: d.y1,
    y: d.target.y - diff / 3
  }, {
    x: d.y1,
    y: d.target.y
  }] : [{
    x: d.source.x0,
    y: d.y0
  }, {
    x: d.source.x0 + diff / 3,
    y: d.y0
  }, {
    x: d.target.x0 - diff / 3,
    y: d.y1
  }, {
    x: d.target.x0,
    y: d.y1
  }];

  var linkGenerator = (0, _SvgHelper.linearRibbon)().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).r(function () {
    return d.sankeyWidth / 2;
  });

  return linkGenerator(testCoordinates);
};

var areaLink = exports.areaLink = function areaLink(d) {
  var x0 = void 0,
      x1 = void 0,
      x2 = void 0,
      x3 = void 0,
      y0 = void 0,
      y1 = void 0,
      xi = void 0,
      y2 = void 0,
      y3 = void 0;

  if (d.direction === "down") {
    x0 = d.y0 - d.sankeyWidth / 2;
    x1 = d.y1 - d.sankeyWidth / 2;
    x2 = d.y1 + d.sankeyWidth / 2;
    x3 = d.y0 + d.sankeyWidth / 2;
    y0 = d.source.y1;
    y1 = d.target.y0;
    xi = (0, _d3Interpolate.interpolateNumber)(y0, y1);
    y2 = xi(curvature);
    y3 = xi(1 - curvature);

    return "M" + x0 + "," + y0 + "C" + x0 + "," + y2 + " " + x1 + "," + y3 + " " + x1 + "," + y1 + "L" + x2 + "," + y1 + "C" + x2 + "," + y3 + " " + x3 + "," + y2 + " " + x3 + "," + y0 + "Z";
  }
  ;x0 = d.source.x1, // eslint-disable-line no-sequences
  x1 = d.target.x0, xi = (0, _d3Interpolate.interpolateNumber)(x0, x1), x2 = xi(curvature), x3 = xi(1 - curvature), y0 = d.y0 - d.sankeyWidth / 2, y1 = d.y1 - d.sankeyWidth / 2, y2 = d.y1 + d.sankeyWidth / 2, y3 = d.y0 + d.sankeyWidth / 2;

  return "M" + x0 + "," + y0 + "C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1 + "L" + x1 + "," + y2 + "C" + x3 + "," + y2 + " " + x2 + "," + y3 + " " + x0 + "," + y3 + "Z";
};

function circularAreaLink(link) {
  var linkGenerator = (0, _SvgHelper.linearRibbon)().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).r(function () {
    return link.sankeyWidth / 2;
  });

  var xyForLink = link.direction === "down" ? [{
    x: link.circularPathData.sourceY,
    y: link.circularPathData.sourceX
  }, {
    x: link.circularPathData.sourceY,
    y: link.circularPathData.leftFullExtent
  }, {
    x: link.circularPathData.verticalFullExtent,
    y: link.circularPathData.leftFullExtent
  }, {
    x: link.circularPathData.verticalFullExtent,
    y: link.circularPathData.rightFullExtent
  }, {
    x: link.circularPathData.targetY,
    y: link.circularPathData.rightFullExtent
  }, {
    x: link.circularPathData.targetY,
    y: link.circularPathData.targetX
  }] : [{
    x: link.circularPathData.sourceX,
    y: link.circularPathData.sourceY
  }, {
    x: link.circularPathData.leftFullExtent,
    y: link.circularPathData.sourceY
  }, {
    x: link.circularPathData.leftFullExtent,
    y: link.circularPathData.verticalFullExtent
  }, {
    x: link.circularPathData.rightFullExtent,
    y: link.circularPathData.verticalFullExtent
  }, {
    x: link.circularPathData.rightFullExtent,
    y: link.circularPathData.targetY
  }, {
    x: link.circularPathData.targetX,
    y: link.circularPathData.targetY
  }];

  return linkGenerator(xyForLink);
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
         true ? factory(exports) :
        typeof define === 'function' && define.amd ? define('d3-glyphEdge', ['exports'], factory) :
        factory((global.d3_glyphEdge = {}));
}(this, function (exports) { 'use strict';

        function halfArrow(d, nodeTargetSize, bodySize, headSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var headDistance = headSize * 3;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (headSize * Math.cos(angle1));
            var y1 = d.source.y - (headSize * Math.sin(angle1));
            var x2 = d.source.x + (headSize * Math.cos(angle2));
            var y2 = d.source.y - (headSize * Math.sin(angle2));
            var x3 = d.target.x - (headSize * Math.cos(angle1));
            var y3 = d.target.y + (headSize * Math.sin(angle1));

            var mx1 = d.source.x + (bodySize * Math.cos(angle1));
            var my1 = d.source.y - (bodySize * Math.sin(angle1));
            var mx2 = d.source.x + (bodySize * Math.cos(angle2));
            var my2 = d.source.y - (bodySize * Math.sin(angle2));

            var mx3 = d.target.x + (bodySize * Math.cos(angle1));
            var my3 = d.target.y - (bodySize * Math.sin(angle1));

            var dY = d.source.y - d.target.y;
            var dX = d.source.x - d.target.x;

            var midDiffY1 = my1 - my3;
            var midDiffX1 = mx1 - mx3;

            var diffY1 = y1 - y3;
            var diffX1 = x1 - x3;

            var pythag = Math.sqrt((midDiffX1 * midDiffX1) + (midDiffY1 * midDiffY1));
            var pythag2 = Math.sqrt((dX * dX) + (dY * dY));

            var adjX1 = mx2 - ((midDiffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY1 = my2 - ((midDiffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var headX1 = x2 - ((diffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY1 = y2 - ((diffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var tipX = d.source.x - ((dX * (pythag2 - nodeTargetSize)) / pythag2);
            var tipY = d.source.y - ((dY * (pythag2 - nodeTargetSize)) / pythag2);

            return "M" + d.source.x + "," + d.source.y + "L" + mx2 + "," + my2 + "L" + adjX1 + "," + adjY1 + "L" + headX1 + "," + headY1 + "L" + tipX + "," + tipY + "L" + d.source.x + "," + d.source.y + "z";
        };

        function lineArc(d) {
          var dx = d.target.x - d.source.x,
              dy = d.target.y - d.source.y,
              dr = Math.sqrt(dx * dx + dy * dy);
          return "M" + d.source.x + "," + d.source.y + "A" + dr + "," + dr + " 0 0,1 " + d.target.x + "," + d.target.y;
        };

        function ribbon(d, bodySize) {
                var diffX = d.target.y - d.source.y;
                var diffY = d.target.x - d.source.x;

                var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
                var angle1 = angle0 - ( Math.PI / 2 );
                var angle2 = angle0 + ( Math.PI / 2 );

                var mx1 = d.source.x + (bodySize * Math.cos(angle1));
                var my1 = d.source.y - (bodySize * Math.sin(angle1));
                var mx2 = d.source.x + (bodySize * Math.cos(angle2));
                var my2 = d.source.y - (bodySize * Math.sin(angle2));

                var mx3 = d.target.x - (bodySize * Math.cos(angle1));
                var my3 = d.target.y + (bodySize * Math.sin(angle1));
                var mx4 = d.target.x - (bodySize * Math.cos(angle2));
                var my4 = d.target.y + (bodySize * Math.sin(angle2));

                return "M" + mx1 + "," + my1 + "L" + mx2 + "," + my2 + "L" + mx3 + "," + my3 + "L" + mx4 + "," + my4 + "z";
        }

        function taffy(d, nodeSourceSize, nodeTargetSize, midpointSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (nodeSourceSize * Math.cos(angle1));
            var y1 = d.source.y - (nodeSourceSize * Math.sin(angle1));
            var x2 = d.source.x + (nodeSourceSize * Math.cos(angle2));
            var y2 = d.source.y - (nodeSourceSize * Math.sin(angle2));

            var x3 = d.target.x + (nodeTargetSize * Math.cos(angle2));
            var y3 = d.target.y - (nodeTargetSize * Math.sin(angle2));
            var x4 = d.target.x + (nodeTargetSize * Math.cos(angle1));
            var y4 = d.target.y - (nodeTargetSize * Math.sin(angle1));

            var mx1 = d.source.x + (midpointSize * Math.cos(angle1));
            var my1 = d.source.y - (midpointSize * Math.sin(angle1));
            var mx2 = d.source.x + (midpointSize * Math.cos(angle2));
            var my2 = d.source.y - (midpointSize * Math.sin(angle2));

            var mx3 = d.target.x + (midpointSize * Math.cos(angle1));
            var my3 = d.target.y - (midpointSize * Math.sin(angle1));
            var mx4 = d.target.x + (midpointSize * Math.cos(angle2));
            var my4 = d.target.y - (midpointSize * Math.sin(angle2));

            var midY2 = (my1 + my3) / 2;
            var midX2 = (mx1 + mx3) / 2;
            var midY1 = (my2 + my4) / 2;
            var midX1 = (mx2 + mx4) / 2;

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + midX1 + "," + midY1 + " L " + x3 + "," + y3 + " L " + x4 + "," + y4 + " L " + midX2 + "," + midY2 + "z";
        };

        function nail(d, nodeSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (nodeSize * Math.cos(angle1));
            var y1 = d.source.y - (nodeSize * Math.sin(angle1));
            var x2 = d.source.x + (nodeSize * Math.cos(angle2));
            var y2 = d.source.y - (nodeSize * Math.sin(angle2));

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + d.target.x + "," + d.target.y + "z";
        };

        function comet(d, nodeSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.target.x + (nodeSize * Math.cos(angle1));
            var y1 = d.target.y - (nodeSize * Math.sin(angle1));
            var x2 = d.target.x + (nodeSize * Math.cos(angle2));
            var y2 = d.target.y - (nodeSize * Math.sin(angle2));

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + d.source.x + "," + d.source.y + "z";
        };

        function arrowHead(d, nodeTargetSize, bodySize, headSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var headDistance = headSize * 3;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (headSize * Math.cos(angle1));
            var y1 = d.source.y - (headSize * Math.sin(angle1));
            var x2 = d.source.x + (headSize * Math.cos(angle2));
            var y2 = d.source.y - (headSize * Math.sin(angle2));

            var x3 = d.target.x - (headSize * Math.cos(angle1));
            var y3 = d.target.y + (headSize * Math.sin(angle1));
            var x4 = d.target.x - (headSize * Math.cos(angle2));
            var y4 = d.target.y + (headSize * Math.sin(angle2));

            var mx1 = d.source.x + (bodySize * Math.cos(angle1));
            var my1 = d.source.y - (bodySize * Math.sin(angle1));
            var mx2 = d.source.x + (bodySize * Math.cos(angle2));
            var my2 = d.source.y - (bodySize * Math.sin(angle2));

            var mx3 = d.target.x + (bodySize * Math.cos(angle1));
            var my3 = d.target.y - (bodySize * Math.sin(angle1));
            var mx4 = d.target.x + (bodySize * Math.cos(angle2));
            var my4 = d.target.y - (bodySize * Math.sin(angle2));

            var dY = d.source.y - d.target.y;
            var dX = d.source.x - d.target.x;

            var midDiffY1 = my1 - my3;
            var midDiffX1 = mx1 - mx3;
            var midDiffY2 = my2 - my4;
            var midDiffX2 = mx2 - mx4;

            var diffY1 = y1 - y3;
            var diffX1 = x1 - x3;
            var diffY2 = y2 - y4;
            var diffX2 = x2 - x4;

            var pythag = Math.sqrt((midDiffX1 * midDiffX1) + (midDiffY1 * midDiffY1));
            var pythag2 = Math.sqrt((dX * dX) + (dY * dY));

            var adjX1 = mx2 - ((midDiffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY1 = my2 - ((midDiffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjX2 = mx1 - ((midDiffX2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY2 = my1 - ((midDiffY2 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var headX2 = x1 - ((diffX2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY2 = y1 - ((diffY2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headX1 = x2 - ((diffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY1 = y2 - ((diffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var tipX = d.source.x - ((dX * (pythag2 - nodeTargetSize)) / pythag2);
            var tipY = d.source.y - ((dY * (pythag2 - nodeTargetSize)) / pythag2);

            return "M" + mx2 + "," + my2 + "L" + adjX1 + "," + adjY1 + "L" + headX1 + "," + headY1 + "L" + tipX + "," + tipY + "L" + headX2 + "," + headY2 + "L" + adjX2 + "," + adjY2 + "L" + mx1 + "," + my1 + "z";
        };

        function parallel(d, sourceSize, targetSize, edgeNumber) {

          var diffX = d.target.y - d.source.y;
          var diffY = d.target.x - d.source.x;

          var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
          var angle1 = angle0 + ( (Math.PI * 0.75) + (edgeNumber * 0.25) );
          var angle2 = angle0 + ( (Math.PI * 0.25) - (edgeNumber * 0.25) );

          var x1 = d.source.x + (sourceSize * Math.cos(angle1));
          var y1 = d.source.y - (sourceSize * Math.sin(angle1));
          var x2 = d.target.x + (targetSize * Math.cos(angle2));
          var y2 = d.target.y - (targetSize * Math.sin(angle2));

          return {source: {x: x1, y: y1}, target: {x: x2, y: y2}};

        }

        function offset(d, nodeSize) {
          var diffX = d.target.y - d.source.y;
          var diffY = d.target.x - d.source.x;

          var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
          var angle1 = angle0 + ( Math.PI * 0.75 );
          var angle2 = angle0 + ( Math.PI * 0.25 );

          var x1 = d.source.x + (nodeSize * Math.cos(angle1));
          var y1 = d.source.y - (nodeSize * Math.sin(angle1));
          var x2 = d.target.x + (nodeSize * Math.cos(angle2));
          var y2 = d.target.y - (nodeSize * Math.sin(angle2));

          return {source: {x: x1, y: y1}, target: {x: x2, y: y2}};

        }

        function particle(d, path, pathWidth, speed) {
            pathWidth = pathWidth / 2;

            d.particles = d.particles.filter(function (d) {return d.current < path.getTotalLength()});

            if (d.frequency < 1) {
                if (Math.random() < d.frequency) {
                    pushParticle();
                }
            } else {
                for (var x = 0; x < d.frequency; x++) {
                    pushParticle();
                }
            }

            function pushParticle() {
                d.particles.push({current: 0, xOffset: pathWidth - (pathWidth * Math.random() * 2), yOffset: pathWidth - (pathWidth * Math.random() * 2)});
            }

            d.particles.forEach(function (particle) {
                particle.current = particle.current + speed;
                var currentPosition = path.getPointAtLength(particle.current);
                particle.x = currentPosition.x + particle.xOffset;
                particle.y = currentPosition.y + particle.yOffset;
            });
        };

        var d = {
          arrowHead: arrowHead,
          comet: comet,
          nail: nail,
          taffy: taffy,
          ribbon: ribbon,
          lineArc: lineArc,
          halfArrow: halfArrow
        };

        var project = {
          offset: offset,
          parallel: parallel
        };

        var mutate = {
          particle: particle
        };

        var version = "1.2.0";

        exports.version = version;
        exports.d = d;
        exports.project = project;
        exports.mutate = mutate;

}));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_piecewise__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_16__src_piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_quantize__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_17__src_quantize__["a"]; });




















/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(551);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(552);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(38);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(38);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(38);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(38);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sankeyCircular = __webpack_require__(561);

Object.defineProperty(exports, "sankeyCircular", {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_sankeyCircular).default;
  }
});

var _align = __webpack_require__(212);

Object.defineProperty(exports, "sankeyCenter", {
  enumerable: true,
  get: function () {
    return _align.center;
  }
});
Object.defineProperty(exports, "sankeyLeft", {
  enumerable: true,
  get: function () {
    return _align.left;
  }
});
Object.defineProperty(exports, "sankeyRight", {
  enumerable: true,
  get: function () {
    return _align.right;
  }
});
Object.defineProperty(exports, "sankeyJustify", {
  enumerable: true,
  get: function () {
    return _align.justify;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // Set the default values
  var x0 = 0,
      y0 = 0,
      x1 = 1,
      y1 = 1,
      // extent
  dx = 24,
      // nodeWidth
  py,
      // nodePadding, for vertical postioning
  id = defaultId,
      align = _align.justify,
      nodes = defaultNodes,
      links = defaultLinks,
      iterations = 32,
      circularLinkGap = 2,
      paddingRatio;

  function sankeyCircular() {
    var graph = {
      nodes: nodes.apply(null, arguments),
      links: links.apply(null, arguments)

      // Process the graph's nodes and links, setting their positions

      // 1.  Associate the nodes with their respective links, and vice versa
    };computeNodeLinks(graph);

    // 2.  Determine which links result in a circular path in the graph
    identifyCircles(graph, id);

    // 3.  Determine how the circular links will be drawn,
    //     either travelling back above the main chart ("top")
    //     or below the main chart ("bottom")
    selectCircularLinkTypes(graph, id);

    // 4. Calculate the nodes' values, based on the values of the incoming and outgoing links
    computeNodeValues(graph);

    // 5.  Calculate the nodes' depth based on the incoming and outgoing links
    //     Sets the nodes':
    //     - depth:  the depth in the graph
    //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
    //     - x0, x1: the x coordinates, as is relates to visual position from left to right
    computeNodeDepths(graph);

    // 6.  Calculate the nodes' and links' vertical position within their respective column
    //     Also readjusts sankeyCircular size if circular links are needed, and node x's
    computeNodeBreadths(graph, iterations, id);
    computeLinkBreadths(graph);

    // 7.  Sort links per node, based on the links' source/target nodes' breadths
    // 8.  Adjust nodes that overlap links that span 2+ columns

    var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
    for (var iteration = 0; iteration < linkSortingIterations; iteration++) {

      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
      resolveNodeLinkOverlaps(graph, y0, y1, id);
      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
    }

    // 9. Calculate visually appealling path for the circular paths, and create the "d" string
    addCircularPathData(graph, circularLinkGap, y1, id);

    return graph;
  } // end of sankeyCircular function

  // TODO - update this function to take into account circular changes
  /*sankeyCircular.update = function (graph) {
    computeLinkBreadths(graph)
    return graph
  }*/

  // Set the sankeyCircular parameters
  // nodeID, nodeAlign, nodeWidth, nodePadding, nodes, links, size, extent, iterations, nodePaddingRatio, circularLinkGap
  sankeyCircular.nodeId = function (_) {
    return arguments.length ? (id = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : id;
  };

  sankeyCircular.nodeAlign = function (_) {
    return arguments.length ? (align = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : align;
  };

  sankeyCircular.nodeWidth = function (_) {
    return arguments.length ? (dx = +_, sankeyCircular) : dx;
  };

  sankeyCircular.nodePadding = function (_) {
    return arguments.length ? (py = +_, sankeyCircular) : py;
  };

  sankeyCircular.nodes = function (_) {
    return arguments.length ? (nodes = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : nodes;
  };

  sankeyCircular.links = function (_) {
    return arguments.length ? (links = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : links;
  };

  sankeyCircular.size = function (_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular) : [x1 - x0, y1 - y0];
  };

  sankeyCircular.extent = function (_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular) : [[x0, y0], [x1, y1]];
  };

  sankeyCircular.iterations = function (_) {
    return arguments.length ? (iterations = +_, sankeyCircular) : iterations;
  };

  sankeyCircular.circularLinkGap = function (_) {
    return arguments.length ? (circularLinkGap = +_, sankeyCircular) : circularLinkGap;
  };

  sankeyCircular.nodePaddingRatio = function (_) {
    return arguments.length ? (paddingRatio = +_, sankeyCircular) : paddingRatio;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks(graph) {
    graph.nodes.forEach(function (node, i) {
      node.index = i;
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    var nodeById = (0, _d3Collection.map)(graph.nodes, id);
    graph.links.forEach(function (link, i) {
      link.index = i;
      var source = link.source;
      var target = link.target;
      if (typeof source !== 'object') {
        source = link.source = find(nodeById, source);
      }
      if (typeof target !== 'object') {
        target = link.target = find(nodeById, target);
      }
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) and cycleness of each node by summing the associated links.
  function computeNodeValues(graph) {
    graph.nodes.forEach(function (node) {
      node.partOfCycle = false;
      node.value = Math.max((0, _d3Array.sum)(node.sourceLinks, value), (0, _d3Array.sum)(node.targetLinks, value));
      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
    });
  }

  function getCircleMargins(graph) {
    var totalTopLinksWidth = 0,
        totalBottomLinksWidth = 0,
        totalRightLinksWidth = 0,
        totalLeftLinksWidth = 0;

    var maxColumn = (0, _d3Array.max)(graph.nodes, function (node) {
      return node.column;
    });

    graph.links.forEach(function (link) {
      if (link.circular) {
        if (link.circularLinkType == 'top') {
          totalTopLinksWidth = totalTopLinksWidth + link.width;
        } else {
          totalBottomLinksWidth = totalBottomLinksWidth + link.width;
        }

        if (link.target.column == 0) {
          totalLeftLinksWidth = totalLeftLinksWidth + link.width;
        }

        if (link.source.column == maxColumn) {
          totalRightLinksWidth = totalRightLinksWidth + link.width;
        }
      }
    });

    //account for radius of curves and padding between links
    totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
    totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
    totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
    totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;

    return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
  }

  // Update the x0, y0, x1 and y1 for the sankeyCircular, to allow space for any circular links
  function scaleSankeySize(graph, margin) {

    var maxColumn = (0, _d3Array.max)(graph.nodes, function (node) {
      return node.column;
    });

    var currentWidth = x1 - x0;
    var currentHeight = y1 - y0;

    var newWidth = currentWidth + margin.right + margin.left;
    var newHeight = currentHeight + margin.top + margin.bottom;

    var scaleX = currentWidth / newWidth;
    var scaleY = currentHeight / newHeight;

    x0 = x0 * scaleX + margin.left;
    x1 = margin.right == 0 ? x1 : x1 * scaleX;
    y0 = y0 * scaleY + margin.top;
    y1 = y1 * scaleY;

    graph.nodes.forEach(function (node) {
      node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
      node.x1 = node.x0 + dx;
    });

    return scaleY;
  }

  // Iteratively assign the depth for each node.
  // Nodes are assigned the maximum depth of incoming neighbors plus one;
  // nodes with no incoming links are assigned depth zero, while
  // nodes with no outgoing links are assigned the maximum depth.
  function computeNodeDepths(graph) {
    var nodes, next, x;

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.depth = x;
        node.sourceLinks.forEach(function (link) {
          if (next.indexOf(link.target) < 0 && !link.circular) {
            next.push(link.target);
          }
        });
      });
    }

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.height = x;
        node.targetLinks.forEach(function (link) {
          if (next.indexOf(link.source) < 0 && !link.circular) {
            next.push(link.source);
          }
        });
      });
    }

    // assign column numbers, and get max value
    graph.nodes.forEach(function (node) {
      node.column = Math.floor(align.call(null, node, x));
    });
  }

  // Assign nodes' breadths, and then shift nodes that overlap (resolveCollisions)
  function computeNodeBreadths(graph, iterations, id) {
    var columns = (0, _d3Collection.nest)().key(function (d) {
      return d.column;
    }).sortKeys(_d3Array.ascending).entries(graph.nodes).map(function (d) {
      return d.values;
    });

    initializeNodeBreadth(id);
    resolveCollisions();

    for (var alpha = 1, n = iterations; n > 0; --n) {
      relaxLeftAndRight(alpha *= 0.99, id);
      resolveCollisions();
    }

    function initializeNodeBreadth(id) {

      //override py if nodePadding has been set
      if (paddingRatio) {
        var padding = Infinity;
        columns.forEach(function (nodes) {
          var thisPadding = y1 * paddingRatio / (nodes.length + 1);
          padding = thisPadding < padding ? thisPadding : padding;
        });
        py = padding;
      }

      var ky = (0, _d3Array.min)(columns, function (nodes) {
        return (y1 - y0 - (nodes.length - 1) * py) / (0, _d3Array.sum)(nodes, value);
      });

      //calculate the widths of the links
      ky = ky * scale;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      //determine how much to scale down the chart, based on circular links
      var margin = getCircleMargins(graph);
      var ratio = scaleSankeySize(graph, margin);

      //re-calculate widths
      ky = ky * ratio;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      columns.forEach(function (nodes) {
        var nodesLength = nodes.length;
        nodes.forEach(function (node, i) {
          if (node.partOfCycle) {
            if (numberOfNonSelfLinkingCycles(node, id) == 0) {
              node.y0 = y1 / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            } else if (node.circularLinkType == 'top') {
              node.y0 = y0 + i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = y1 - node.value * ky - i;
              node.y1 = node.y0 + node.value * ky;
            }
          } else {
            if (margin.top == 0 || margin.bottom == 0) {
              node.y0 = (y1 - y0) / nodesLength * i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            }
          }
        });
      });
    }

    // For each node in each column, check the node's vertical position in relation to its targets and sources vertical position
    // and shift up/down to be closer to the vertical middle of those targets and sources
    function relaxLeftAndRight(alpha, id) {
      var columnsLength = columns.length;

      columns.forEach(function (nodes, i) {
        var n = nodes.length;
        var depth = nodes[0].depth;

        nodes.forEach(function (node) {
          // check the node is not an orphan
          if (node.sourceLinks.length || node.targetLinks.length) {
            if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id) > 0) {} else if (depth == 0 && n == 1) {
              var nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else if (depth == columnsLength - 1 && n == 1) {
              var nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else {
              var avg = 0;

              var avgTargetY = (0, _d3Array.mean)(node.sourceLinks, linkTargetCenter);
              var avgSourceY = (0, _d3Array.mean)(node.targetLinks, linkSourceCenter);

              if (avgTargetY && avgSourceY) {
                avg = (avgTargetY + avgSourceY) / 2;
              } else {
                avg = avgTargetY || avgSourceY;
              }

              var dy = (avg - nodeCenter(node)) * alpha;
              // positive if it node needs to move down
              node.y0 += dy;
              node.y1 += dy;
            }
          }
        });
      });
    }

    // For each column, check if nodes are overlapping, and if so, shift up/down
    function resolveCollisions() {
      columns.forEach(function (nodes) {
        var node,
            dy,
            y = y0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingBreadth);

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y - node.y0;

          if (dy > 0) {
            node.y0 += dy;
            node.y1 += dy;
          }
          y = node.y1 + py;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y - py - y1;
        if (dy > 0) {
          ;y = node.y0 -= dy, node.y1 -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y1 + py - y;
            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
            y = node.y0;
          }
        }
      });
    }
  }

  // Assign the links y0 and y1 based on source/target nodes position,
  // plus the link's relative position to other links to the same node
  function computeLinkBreadths(graph) {
    graph.nodes.forEach(function (node) {
      node.sourceLinks.sort(ascendingTargetBreadth);
      node.targetLinks.sort(ascendingSourceBreadth);
    });
    graph.nodes.forEach(function (node) {
      var y0 = node.y0;
      var y1 = y0;

      // start from the bottom of the node for cycle links
      var y0cycle = node.y1;
      var y1cycle = y0cycle;

      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          link.y0 = y0cycle - link.width / 2;
          y0cycle = y0cycle - link.width;
        } else {
          link.y0 = y0 + link.width / 2;
          y0 += link.width;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          link.y1 = y1cycle - link.width / 2;
          y1cycle = y1cycle - link.width;
        } else {
          link.y1 = y1 + link.width / 2;
          y1 += link.width;
        }
      });
    });
  }

  return sankeyCircular;
};

var _d3Array = __webpack_require__(2);

var _d3Collection = __webpack_require__(31);

var _align = __webpack_require__(212);

var _constant = __webpack_require__(562);

var _constant2 = _interopRequireDefault(_constant);

var _d3Shape = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// sort links' breadth (ie top to bottom in a column), based on their source nodes' breadths
function ascendingSourceBreadth(a, b) {
  return ascendingBreadth(a.source, b.source) || a.index - b.index;
}

// sort links' breadth (ie top to bottom in a column), based on their target nodes' breadths
// https://github.com/tomshanley/d3-sankeyCircular-circular
// fork of https://github.com/d3/d3-sankeyCircular copyright Mike Bostock
function ascendingTargetBreadth(a, b) {
  return ascendingBreadth(a.target, b.target) || a.index - b.index;
}

// sort nodes' breadth (ie top to bottom in a column)
// if both nodes have circular links, or both don't have circular links, then sort by the top (y0) of the node
// else push nodes that have top circular links to the top, and nodes that have bottom circular links to the bottom
function ascendingBreadth(a, b) {
  if (a.partOfCycle === b.partOfCycle) {
    return a.y0 - b.y0;
  } else {
    if (a.circularLinkType === 'top' || b.circularLinkType === 'bottom') {
      return -1;
    } else {
      return 1;
    }
  }
}

// return the value of a node or link
function value(d) {
  return d.value;
}

// return the vertical center of a node
function nodeCenter(node) {
  return (node.y0 + node.y1) / 2;
}

// return the vertical center of a link's source node
function linkSourceCenter(link) {
  return nodeCenter(link.source);
}

// return the vertical center of a link's target node
function linkTargetCenter(link) {
  return nodeCenter(link.target);
}

/* function weightedSource (link) {
  return nodeCenter(link.source) * link.value
} */

/* function weightedTarget (link) {
  return nodeCenter(link.target) * link.value
} */

// Return the default value for ID for node, d.index
function defaultId(d) {
  return d.index;
}

// Return the default object the graph's nodes, graph.nodes
function defaultNodes(graph) {
  return graph.nodes;
}

// Return the default object the graph's nodes, graph.links
function defaultLinks(graph) {
  return graph.links;
}

// Return the node from the collection that matches the provided ID, or throw an error if no match
function find(nodeById, id) {
  var node = nodeById.get(id);
  if (!node) throw new Error('missing: ' + id);
  return node;
}

function getNodeID(node, id) {
  return id(node);
}

// The main sankeyCircular functions

// Some constants for circular link calculations
var verticalMargin = 25;
var baseRadius = 10;
var scale = 0.3; //Possibly let user control this, although anything over 0.5 starts to get too cramped

/// /////////////////////////////////////////////////////////////////////////////////
// Cycle functions
// portion of code to detect circular links based on Colin Fergus' bl.ock https://gist.github.com/cfergus/3956043

// Identify circles in the link objects
function identifyCircles(graph, id) {
  var addedLinks = [];
  var circularLinkID = 0;
  graph.links.forEach(function (link) {
    if (createsCycle(link.source, link.target, addedLinks, id)) {
      link.circular = true;
      link.circularLinkID = circularLinkID;
      circularLinkID = circularLinkID + 1;
    } else {
      link.circular = false;
      addedLinks.push(link);
    }
  });
}

// Assign a circular link type (top or bottom), based on:
// - if the source/target node already has circular links, then use the same type
// - if not, choose the type with fewer links
function selectCircularLinkTypes(graph, id) {
  var numberOfTops = 0;
  var numberOfBottoms = 0;
  graph.links.forEach(function (link) {
    if (link.circular) {
      // if either souce or target has type already use that
      if (link.source.circularLinkType || link.target.circularLinkType) {
        // default to source type if available
        link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
      } else {
        link.circularLinkType = numberOfTops < numberOfBottoms ? 'top' : 'bottom';
      }

      if (link.circularLinkType == 'top') {
        numberOfTops = numberOfTops + 1;
      } else {
        numberOfBottoms = numberOfBottoms + 1;
      }

      graph.nodes.forEach(function (node) {
        if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
          node.circularLinkType = link.circularLinkType;
        }
      });
    }
  });

  //correct self-linking links to be same direction as node
  graph.links.forEach(function (link) {
    if (link.circular) {
      //if both source and target node are same type, then link should have same type
      if (link.source.circularLinkType == link.target.circularLinkType) {
        link.circularLinkType = link.source.circularLinkType;
      }
      //if link is selflinking, then link should have same type as node
      if (selfLinking(link, id)) {
        link.circularLinkType = link.source.circularLinkType;
      }
    }
  });
}

// Checks if link creates a cycle
function createsCycle(originalSource, nodeToCheck, graph, id) {

  // Check for self linking nodes
  if (getNodeID(originalSource, id) == getNodeID(nodeToCheck, id)) {
    return true;
  }

  if (graph.length == 0) {
    return false;
  }

  var nextLinks = findLinksOutward(nodeToCheck, graph);
  // leaf node check
  if (nextLinks.length == 0) {
    return false;
  }

  // cycle check
  for (var i = 0; i < nextLinks.length; i++) {
    var nextLink = nextLinks[i];

    if (nextLink.target === originalSource) {
      return true;
    }

    // Recurse
    if (createsCycle(originalSource, nextLink.target, graph, id)) {
      return true;
    }
  }

  // Exhausted all links
  return false;
}

// Given a node, find all links for which this is a source in the current 'known' graph
function findLinksOutward(node, graph) {
  var children = [];

  for (var i = 0; i < graph.length; i++) {
    if (node == graph[i].source) {
      children.push(graph[i]);
    }
  }

  return children;
}

// Return the angle between a straight line between the source and target of the link, and the vertical plane of the node
function linkAngle(link) {
  var adjacent = Math.abs(link.y1 - link.y0);
  var opposite = Math.abs(link.target.x0 - link.source.x1);

  return Math.atan(opposite / adjacent);
}

// Check if two circular links potentially overlap
function circularLinksCross(link1, link2) {
  if (link1.source.column < link2.target.column) {
    return false;
  } else if (link1.target.column > link2.source.column) {
    return false;
  } else {
    return true;
  }
}

// Return the number of circular links for node, not including self linking links
function numberOfNonSelfLinkingCycles(node, id) {
  var sourceCount = 0;
  node.sourceLinks.forEach(function (l) {
    sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
  });

  var targetCount = 0;
  node.targetLinks.forEach(function (l) {
    targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
  });

  return sourceCount + targetCount;
}

// Check if a circular link is the only circular link for both its source and target node
function onlyCircularLink(link) {
  var nodeSourceLinks = link.source.sourceLinks;
  var sourceCount = 0;
  nodeSourceLinks.forEach(function (l) {
    sourceCount = l.circular ? sourceCount + 1 : sourceCount;
  });

  var nodeTargetLinks = link.target.targetLinks;
  var targetCount = 0;
  nodeTargetLinks.forEach(function (l) {
    targetCount = l.circular ? targetCount + 1 : targetCount;
  });

  if (sourceCount > 1 || targetCount > 1) {
    return false;
  } else {
    return true;
  }
}

// creates vertical buffer values per set of top/bottom links
function calcVerticalBuffer(links, circularLinkGap, id) {
  links.sort(sortLinkColumnAscending);
  links.forEach(function (link, i) {
    var buffer = 0;

    if (selfLinking(link, id) && onlyCircularLink(link)) {
      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    } else {
      var j = 0;
      for (j; j < i; j++) {
        if (circularLinksCross(links[i], links[j])) {
          var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
          buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
        }
      }

      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    }
  });

  return links;
}

// calculate the optimum path for a link to reduce overlaps
function addCircularPathData(graph, circularLinkGap, y1, id) {
  //var baseRadius = 10
  var buffer = 5;
  //var verticalMargin = 25

  var minY = (0, _d3Array.min)(graph.links, function (link) {
    return link.source.y0;
  });

  // create object for circular Path Data
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData = {};
    }
  });

  // calc vertical offsets per top/bottom links
  var topLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'top';
  });
  topLinks = calcVerticalBuffer(topLinks, circularLinkGap, id);

  var bottomLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'bottom';
  });
  bottomLinks = calcVerticalBuffer(bottomLinks, circularLinkGap, id);

  // add the base data for each link
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData.arcRadius = link.width + baseRadius;
      link.circularPathData.leftNodeBuffer = buffer;
      link.circularPathData.rightNodeBuffer = buffer;
      link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
      link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
      link.circularPathData.targetX = link.target.x0;
      link.circularPathData.sourceY = link.y0;
      link.circularPathData.targetY = link.y1;

      // for self linking paths, and that the only circular link in/out of that node
      if (selfLinking(link, id) && onlyCircularLink(link)) {
        link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;

        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      } else {
        // else calculate normally
        // add left extent coordinates, based on links with same source column and circularLink type
        var thisColumn = link.source.column;
        var thisCircularLinkType = link.circularLinkType;
        var sameColumnLinks = graph.links.filter(function (l) {
          return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });

        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkSourceYDescending);
        } else {
          sameColumnLinks.sort(sortLinkSourceYAscending);
        }

        var radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // add right extent coordinates, based on links with same target column and circularLink type
        thisColumn = link.target.column;
        sameColumnLinks = graph.links.filter(function (l) {
          return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });
        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkTargetYDescending);
        } else {
          sameColumnLinks.sort(sortLinkTargetYAscending);
        }

        radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // bottom links
        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = y1 + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      }

      // all links
      link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
      link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
    }

    if (link.circular) {
      link.path = createCircularPathString(link);
    } else {
      var normalPath = (0, _d3Shape.linkHorizontal)().source(function (d) {
        var x = d.source.x0 + (d.source.x1 - d.source.x0);
        var y = d.y0;
        return [x, y];
      }).target(function (d) {
        var x = d.target.x0;
        var y = d.y1;
        return [x, y];
      });
      link.path = normalPath(link);
    }
  });
}

// create a d path using the addCircularPathData
function createCircularPathString(link) {
  var pathString = '';
  var pathData = {};

  if (link.circularLinkType == 'top') {
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line up to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line down
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  } else {
    // bottom path
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line down to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line up
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  }

  return pathString;
}

// sort links based on the distance between the source and tartget node columns
// if the same, then use Y position of the source node
function sortLinkColumnAscending(link1, link2) {
  if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
    return link1.circularLinkType == 'bottom' ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
  } else {
    return linkColumnDistance(link2) - linkColumnDistance(link1);
  }
}

// sort ascending links by their source vertical position, y0
function sortLinkSourceYAscending(link1, link2) {
  return link1.y0 - link2.y0;
}

// sort descending links by their source vertical position, y0
function sortLinkSourceYDescending(link1, link2) {
  return link2.y0 - link1.y0;
}

// sort ascending links by their target vertical position, y1
function sortLinkTargetYAscending(link1, link2) {
  return link1.y1 - link2.y1;
}

// sort descending links by their target vertical position, y1
function sortLinkTargetYDescending(link1, link2) {
  return link2.y1 - link1.y1;
}

// return the distance between the link's target and source node, in terms of the nodes' column
function linkColumnDistance(link) {
  return link.target.column - link.source.column;
}

// return the distance between the link's target and source node, in terms of the nodes' X coordinate
function linkXLength(link) {
  return link.target.x0 - link.source.x1;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link1's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;

  return yPerpendicular;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;

  return yPerpendicular;
}

// Move any nodes that overlap links which span 2+ columns
function resolveNodeLinkOverlaps(graph, y0, y1, id) {

  graph.links.forEach(function (link) {
    if (link.circular) {
      return;
    }

    if (link.target.column - link.source.column > 1) {
      var columnToTest = link.source.column + 1;
      var maxColumnToTest = link.target.column - 1;

      var i = 1;
      var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;

      for (columnToTest, i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
        graph.nodes.forEach(function (node) {
          if (node.column == columnToTest) {
            var t = i / (numberOfColumnsToTest + 1);

            // Find all the points of a cubic bezier curve in javascript
            // https://stackoverflow.com/questions/15397596/find-all-the-points-of-a-cubic-bezier-curve-in-javascript

            var B0_t = Math.pow(1 - t, 3);
            var B1_t = 3 * t * Math.pow(1 - t, 2);
            var B2_t = 3 * Math.pow(t, 2) * (1 - t);
            var B3_t = Math.pow(t, 3);

            var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;

            var linkY0AtColumn = py_t - link.width / 2;
            var linkY1AtColumn = py_t + link.width / 2;

            // If top of link overlaps node, push node up
            if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {

              var dy = node.y1 - linkY0AtColumn + 10;
              dy = node.circularLinkType == 'bottom' ? dy : -dy;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move up too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (nodesOverlap(node, otherNode)) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
              // If bottom of link overlaps node, push node down
              var dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move down too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
              // if link completely overlaps node
              var dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            }
          }
        });
      }
    }
  });
}

// check if two nodes overlap
function nodesOverlap(nodeA, nodeB) {
  // test if nodeA top partially overlaps nodeB
  if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
    return true;
  } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
    // test if nodeA bottom partially overlaps nodeB
    return true;
  } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
    // test if nodeA covers nodeB
    return true;
  } else {
    return false;
  }
}

// update a node, and its associated links, vertical positions (y0, y1)
function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
  if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
    node.y0 = node.y0 + dy;
    node.y1 = node.y1 + dy;

    node.targetLinks.forEach(function (l) {
      l.y1 = l.y1 + dy;
    });

    node.sourceLinks.forEach(function (l) {
      l.y0 = l.y0 + dy;
    });
  }
  return node;
}

// sort and set the links' y0 for each node
function sortSourceLinks(graph, y1, id) {
  graph.nodes.forEach(function (node) {
    // move any nodes up which are off the bottom
    if (node.y + (node.y1 - node.y0) > y1) {
      node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
    }

    var nodesSourceLinks = graph.links.filter(function (l) {
      return getNodeID(l.source, id) == getNodeID(node, id);
    });

    var nodeSourceLinksLength = nodesSourceLinks.length;

    // if more than 1 link then sort
    if (nodeSourceLinksLength > 1) {
      nodesSourceLinks.sort(function (link1, link2) {
        // if both are not circular...
        if (!link1.circular && !link2.circular) {
          // if the target nodes are the same column, then sort by the link's target y
          if (link1.target.column == link2.target.column) {
            return link1.y1 - link2.y1;
          } else if (!sameInclines(link1, link2)) {
            // if the links slope in different directions, then sort by the link's target y
            return link1.y1 - link2.y1;

            // if the links slope in same directions, then sort by any overlap
          } else {
            if (link1.target.column > link2.target.column) {
              var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
              return link1.y1 - link2Adj;
            }
            if (link2.target.column > link1.target.column) {
              var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
              return link1Adj - link2.y1;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link1.target.y1 - link2.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.target.column - link1.target.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link2.target.y1 - link1.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.target.column - link2.target.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y0 for links
    var ySourceOffset = node.y0;

    nodesSourceLinks.forEach(function (link) {
      link.y0 = ySourceOffset + link.width / 2;
      ySourceOffset = ySourceOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesSourceLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodeSourceLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
        }
        link.y0 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// sort and set the links' y1 for each node
function sortTargetLinks(graph, y1, id) {
  graph.nodes.forEach(function (node) {
    var nodesTargetLinks = graph.links.filter(function (l) {
      return getNodeID(l.target, id) == getNodeID(node, id);
    });

    var nodesTargetLinksLength = nodesTargetLinks.length;

    if (nodesTargetLinksLength > 1) {
      nodesTargetLinks.sort(function (link1, link2) {
        // if both are not circular, the base on the source y position
        if (!link1.circular && !link2.circular) {
          if (link1.source.column == link2.source.column) {
            return link1.y0 - link2.y0;
          } else if (!sameInclines(link1, link2)) {
            return link1.y0 - link2.y0;
          } else {
            // get the angle of the link to the further source node (ie the smaller column)
            if (link2.source.column < link1.source.column) {
              var link2Adj = linkPerpendicularYToLinkSource(link2, link1);

              return link1.y0 - link2Adj;
            }
            if (link1.source.column < link2.source.column) {
              var link1Adj = linkPerpendicularYToLinkSource(link1, link2);

              return link1Adj - link2.y0;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.source.column - link2.source.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.source.column - link1.source.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y1 for links
    var yTargetOffset = node.y0;

    nodesTargetLinks.forEach(function (link) {
      link.y1 = yTargetOffset + link.width / 2;
      yTargetOffset = yTargetOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesTargetLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodesTargetLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
        }
        link.y1 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// test if links both slope up, or both slope down
function sameInclines(link1, link2) {
  return incline(link1) == incline(link2);
}

// returns the slope of a link, from source to target
// up => slopes up from source to target
// down => slopes down from source to target
function incline(link) {
  return link.y0 - link.y1 > 0 ? 'up' : 'down';
}

// check if link is self linking, ie links a node to the same node
function selfLinking(link, id) {
  return getNodeID(link.source, id) == getNodeID(link.target, id);
}

/// ////////////////////////////////////////////////////////////////////////////

/*exports.sankeyCircular = sankeyCircular
exports.sankeyCenter = center
exports.sankeyLeft = left
exports.sankeyRight = right
exports.sankeyJustify = justify
  Object.defineProperty(exports, '__esModule', { value: true })*/

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constant;
// returns a function, using the parameter given to the sankey setting
function constant(x) {
  return function () {
    return x;
  };
}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chord", function() { return __WEBPACK_IMPORTED_MODULE_0__src_chord__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ribbon", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ribbon__["a"]; });




/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(213);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(22);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgRectEncloseRule = exports.svgEncloseRule = exports.svgReactAnnotationRule = exports.svgNodeRule = exports.htmlFrameHoverRule = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(20);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _AnnotationCalloutCircle = __webpack_require__(101);

var _AnnotationCalloutCircle2 = _interopRequireDefault(_AnnotationCalloutCircle);

var _d3Hierarchy = __webpack_require__(56);

var _baseRules = __webpack_require__(100);

var _SpanOrDiv = __webpack_require__(17);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlFrameHoverRule = exports.htmlFrameHoverRule = function htmlFrameHoverRule(_ref) {
  var d = _ref.d,
      i = _ref.i,
      tooltipContent = _ref.tooltipContent,
      useSpans = _ref.useSpans;

  var content = d.edge ? _react2.default.createElement(
    _SpanOrDiv2.default,
    { span: useSpans, className: "tooltip-content" },
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.edge.source.id,
      " to ",
      d.edge.target.id
    )
  ) : _react2.default.createElement(
    _SpanOrDiv2.default,
    { span: useSpans, className: "tooltip-content" },
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.id
    ),
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      "Degree: ",
      d.degree
    )
  );

  if (d.type === "frame-hover" && tooltipContent) {
    content = tooltipContent(d);
  }

  return _react2.default.createElement(
    _SpanOrDiv2.default,
    {
      span: useSpans,
      key: "xylabel" + i,
      className: "annotation annotation-network-label " + (d.className || ""),
      style: {
        position: "absolute",
        top: d.y + "px",
        left: d.x + "px"
      }
    },
    content
  );
};

var svgNodeRule = exports.svgNodeRule = function svgNodeRule(_ref2) {
  var d = _ref2.d,
      i = _ref2.i,
      projectedNodes = _ref2.projectedNodes,
      nodeIDAccessor = _ref2.nodeIDAccessor,
      nodeSizeAccessor = _ref2.nodeSizeAccessor;

  var selectedNode = d.x && d.y ? d : projectedNodes.find(function (p) {
    return nodeIDAccessor(p) === d.id;
  });
  if (!selectedNode) {
    return null;
  }
  var noteData = _extends({
    dx: d.dx || -25,
    dy: d.dy || -25,
    x: selectedNode.x,
    y: selectedNode.y,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _AnnotationCalloutCircle2.default,
    subject: {
      radius: d.radius || selectedNode.radius || nodeSizeAccessor(d)
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgReactAnnotationRule = exports.svgReactAnnotationRule = function svgReactAnnotationRule(_ref3) {
  var d = _ref3.d,
      i = _ref3.i,
      projectedNodes = _ref3.projectedNodes,
      nodeIDAccessor = _ref3.nodeIDAccessor;

  var selectedNode = d.x && d.y ? d : projectedNodes.find(function (p) {
    return nodeIDAccessor(p) === d.id;
  });
  if (!selectedNode) {
    return null;
  }
  var noteData = _extends({
    dx: 0,
    dy: 0,
    x: selectedNode.x,
    y: selectedNode.y,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, { type: typeof d.type === "function" ? d.type : undefined });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgEncloseRule = exports.svgEncloseRule = function svgEncloseRule(_ref4) {
  var d = _ref4.d,
      projectedNodes = _ref4.projectedNodes,
      nodeIDAccessor = _ref4.nodeIDAccessor,
      nodeSizeAccessor = _ref4.nodeSizeAccessor;

  var selectedNodes = projectedNodes.filter(function (p) {
    return d.ids.indexOf(nodeIDAccessor(p)) !== -1;
  });
  if (selectedNodes.length === 0) {
    return null;
  }
  var circle = (0, _d3Hierarchy.packEnclose)(selectedNodes.map(function (p) {
    return { x: p.x, y: p.y, r: nodeSizeAccessor(p) };
  }));
  return (0, _baseRules.circleEnclosure)({ circle: circle, d: d });
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref5) {
  var d = _ref5.d,
      i = _ref5.i,
      projectedNodes = _ref5.projectedNodes,
      nodeIDAccessor = _ref5.nodeIDAccessor,
      nodeSizeAccessor = _ref5.nodeSizeAccessor;

  var selectedNodes = projectedNodes.filter(function (p) {
    return d.ids.indexOf(nodeIDAccessor(p)) !== -1;
  });
  if (selectedNodes.length === 0) {
    return null;
  }

  var bboxNodes = selectedNodes.map(function (p) {
    var nodeSize = nodeSizeAccessor(p);
    return {
      x0: p.x0 === undefined ? p.x - nodeSize : p.x0,
      x1: p.x1 === undefined ? p.x + nodeSize : p.x1,
      y0: p.y0 === undefined ? p.y - nodeSize : p.y0,
      y1: p.y1 === undefined ? p.y + nodeSize : p.y1
    };
  });
  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NetworkFrame = __webpack_require__(59);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _ResponsiveFrame = __webpack_require__(61);

var _ResponsiveFrame2 = _interopRequireDefault(_ResponsiveFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ResponsiveFrame2.default)(_NetworkFrame2.default);
module.exports = exports['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports) {

var exports = function exports(element, fn) {
  var window = this
  var document = window.document
  var isIE
  var requestFrame

  var attachEvent = document.attachEvent
  if (typeof navigator !== 'undefined') {
    isIE = navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/Edge/)
  }

  requestFrame = (function () {
    var raf = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
          function fallbackRAF(func) {
            return window.setTimeout(func, 20)
          }
    return function requestFrameFunction(func) {
      return raf(func)
    }
  })()

  var cancelFrame = (function () {
    var cancel = window.cancelAnimationFrame ||
      window.mozCancelAnimationFrame ||
        window.webkitCancelAnimationFrame ||
          window.clearTimeout
    return function cancelFrameFunction(id) {
      return cancel(id)
    }
  })()

  function resizeListener(e) {
    var win = e.target || e.srcElement
    if (win.__resizeRAF__) {
      cancelFrame(win.__resizeRAF__)
    }
    win.__resizeRAF__ = requestFrame(function () {
      var trigger = win.__resizeTrigger__
      if(trigger !== undefined) {
        trigger.__resizeListeners__.forEach(function (fn) {
          fn.call(trigger, e)
        })
      }
    })
  }

  function objectLoad() {
    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
  }

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = []
    if (attachEvent) {
      element.__resizeTrigger__ = element
      element.attachEvent('onresize', resizeListener)
    } else {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative'
      }
      var obj = element.__resizeTrigger__ = document.createElement('object')
      obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;')
      obj.setAttribute('class', 'resize-sensor')
      obj.setAttribute('tabIndex', '-1')
      obj.__resizeElement__ = element
      obj.onload = objectLoad
      obj.type = 'text/html'
      if (isIE) {
        element.appendChild(obj)
      }
      obj.data = 'about:blank'
      if (!isIE) {
        element.appendChild(obj)
      }
    }
  }
  element.__resizeListeners__.push(fn)
}

exports.unbind = function(element, fn){
  var attachEvent = document.attachEvent;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    if (attachEvent) {
      element.detachEvent('onresize', resizeListener);
    } else {
      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', resizeListener);
      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
    }
  }
}

module.exports = (typeof window === 'undefined') ? exports : exports.bind(window)


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MinimapXYFrame = __webpack_require__(204);

var _MinimapXYFrame2 = _interopRequireDefault(_MinimapXYFrame);

var _ResponsiveFrame = __webpack_require__(61);

var _ResponsiveFrame2 = _interopRequireDefault(_ResponsiveFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ResponsiveFrame2.default)(_MinimapXYFrame2.default);
module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _XYFrame = __webpack_require__(34);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _ResponsiveFrame = __webpack_require__(61);

var _ResponsiveFrame2 = _interopRequireDefault(_ResponsiveFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ResponsiveFrame2.default)(_XYFrame2.default);
module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OrdinalFrame = __webpack_require__(105);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _ResponsiveFrame = __webpack_require__(61);

var _ResponsiveFrame2 = _interopRequireDefault(_ResponsiveFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ResponsiveFrame2.default)(_OrdinalFrame2.default);
module.exports = exports['default'];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _XYFrame = __webpack_require__(34);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _SparkFrame = __webpack_require__(112);

var _SparkFrame2 = _interopRequireDefault(_SparkFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _SparkFrame2.default)(_XYFrame2.default, _SparkFrame.xyFrameDefaults);
module.exports = exports['default'];

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OrdinalFrame = __webpack_require__(105);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _SparkFrame = __webpack_require__(112);

var _SparkFrame2 = _interopRequireDefault(_SparkFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _SparkFrame2.default)(_OrdinalFrame2.default, _SparkFrame.ordinalFrameDefaults);
module.exports = exports['default'];

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NetworkFrame = __webpack_require__(59);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _SparkFrame = __webpack_require__(112);

var _SparkFrame2 = _interopRequireDefault(_SparkFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _SparkFrame2.default)(_NetworkFrame2.default, _SparkFrame.networkFrameDefaults);
module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(579);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(580);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _lodash = __webpack_require__(581);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(582);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };

var styles = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  display: 'none'
};

var ResizeDetector = function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));

    _this.createResizeObserver = function (entries) {
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight,
          onResize = _this$props.onResize;

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;

        var notifyWidth = handleWidth && _this.width !== width;
        var notifyHeight = handleHeight && _this.height !== height;
        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
          onResize(width, height);
        }
        _this.width = width;
        _this.height = height;
        _this.skipOnMount = false;
      });
    };

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate;


    _this.width = undefined;
    _this.height = undefined;
    _this.skipOnMount = skipOnMount;

    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;

    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.observe(resizableElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.unobserve(resizableElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        style: styles,
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }]);

  return ResizeDetector;
}(_react.PureComponent);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  skipOnMount: _propTypes2.default.bool,
  refreshRate: _propTypes2.default.number,
  refreshMode: _propTypes2.default.string,
  resizableElementId: _propTypes2.default.string,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  resizableElementId: '',
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! pym.js - v1.3.2 - 2018-02-13 */
/*
* Pym.js is library that resizes an iframe based on the width of the parent and the resulting height of the child.
* Check out the docs at http://blog.apps.npr.org/pym.js/ or the readme at README.md for usage.
*/

/** @module pym */
(function(factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory();
    } else {
        window.pym = factory.call(this);
    }
})(function() {
    var MESSAGE_DELIMITER = 'xPYMx';

    var lib = {};

    /**
    * Create and dispatch a custom pym event
    *
    * @method _raiseCustomEvent
    * @inner
    *
    * @param {String} eventName
    */
   var _raiseCustomEvent = function(eventName) {
     var event = document.createEvent('Event');
     event.initEvent('pym:' + eventName, true, true);
     document.dispatchEvent(event);
   };

    /**
    * Generic function for parsing URL params.
    * Via http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    *
    * @method _getParameterByName
    * @inner
    *
    * @param {String} name The name of the paramter to get from the URL.
    */
    var _getParameterByName = function(name) {
        var regex = new RegExp("[\\?&]" + name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') + '=([^&#]*)');
        var results = regex.exec(location.search);

        if (results === null) {
            return '';
        }

        return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    /**
     * Check the message to make sure it comes from an acceptable xdomain.
     * Defaults to '*' but can be overriden in config.
     *
     * @method _isSafeMessage
     * @inner
     *
     * @param {Event} e The message event.
     * @param {Object} settings Configuration.
     */
    var _isSafeMessage = function(e, settings) {
        if (settings.xdomain !== '*') {
            // If origin doesn't match our xdomain, return.
            if (!e.origin.match(new RegExp(settings.xdomain + '$'))) { return; }
        }

        // Ignore events that do not carry string data #151
        if (typeof e.data !== 'string') { return; }

        return true;
    };

    var _isSafeUrl = function(url) {
        // Adapted from angular 2 url sanitizer
        var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/gi;
        if (!url.match(SAFE_URL_PATTERN)) { return; }
        
        return true;
    };

    /**
     * Construct a message to send between frames.
     *
     * NB: We use string-building here because JSON message passing is
     * not supported in all browsers.
     *
     * @method _makeMessage
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     * @param {String} messageType The type of message to send.
     * @param {String} message The message to send.
     */
    var _makeMessage = function(id, messageType, message) {
        var bits = ['pym', id, messageType, message];

        return bits.join(MESSAGE_DELIMITER);
    };

    /**
     * Construct a regex to validate and parse messages.
     *
     * @method _makeMessageRegex
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     */
    var _makeMessageRegex = function(id) {
        var bits = ['pym', id, '(\\S+)', '(.*)'];

        return new RegExp('^' + bits.join(MESSAGE_DELIMITER) + '$');
    };

    /**
    * Underscore implementation of getNow
    *
    * @method _getNow
    * @inner
    *
    */
    var _getNow = Date.now || function() {
        return new Date().getTime();
    };

    /**
    * Underscore implementation of throttle
    *
    * @method _throttle
    * @inner
    *
    * @param {function} func Throttled function
    * @param {number} wait Throttle wait time
    * @param {object} options Throttle settings
    */

    var _throttle = function(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) {options = {};}
        var later = function() {
            previous = options.leading === false ? 0 : _getNow();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {context = args = null;}
        };
        return function() {
            var now = _getNow();
            if (!previous && options.leading === false) {previous = now;}
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {context = args = null;}
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    /**
     * Clean autoInit Instances: those that point to contentless iframes
     * @method _cleanAutoInitInstances
     * @inner
     */
    var _cleanAutoInitInstances = function() {
        var length = lib.autoInitInstances.length;

        // Loop backwards to avoid index issues
        for (var idx = length - 1; idx >= 0; idx--) {
            var instance = lib.autoInitInstances[idx];
            // If instance has been removed or is contentless then remove it
            if (instance.el.getElementsByTagName('iframe').length &&
                instance.el.getElementsByTagName('iframe')[0].contentWindow) {
                continue;
            }
            else {
                // Remove the reference to the removed or orphan instance
                lib.autoInitInstances.splice(idx,1);
            }
        }
    };

    /**
     * Store auto initialized Pym instances for further reference
     * @name module:pym#autoInitInstances
     * @type Array
     * @default []
     */
    lib.autoInitInstances = [];

    /**
     * Initialize Pym for elements on page that have data-pym attributes.
     * Expose autoinit in case we need to call it from the outside
     * @instance
     * @method autoInit
     * @param {Boolean} doNotRaiseEvents flag to avoid sending custom events
     */
    lib.autoInit = function(doNotRaiseEvents) {
        var elements = document.querySelectorAll('[data-pym-src]:not([data-pym-auto-initialized])');
        var length = elements.length;

        // Clean stored instances in case needed
        _cleanAutoInitInstances();
        for (var idx = 0; idx < length; ++idx) {
            var element = elements[idx];
            /*
            * Mark automatically-initialized elements so they are not
            * re-initialized if the user includes pym.js more than once in the
            * same document.
            */
            element.setAttribute('data-pym-auto-initialized', '');

            // Ensure elements have an id
            if (element.id === '') {
                element.id = 'pym-' + idx + "-" + Math.random().toString(36).substr(2,5);
            }

            var src = element.getAttribute('data-pym-src');

            // List of data attributes to configure the component
            // structure: {'attribute name': 'type'}
            var settings = {'xdomain': 'string', 'title': 'string', 'name': 'string', 'id': 'string',
                            'sandbox': 'string', 'allowfullscreen': 'boolean',
                            'parenturlparam': 'string', 'parenturlvalue': 'string',
                            'optionalparams': 'boolean', 'trackscroll': 'boolean',
                            'scrollwait': 'number'};

            var config = {};

            for (var attribute in settings) {
                // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute#Notes
               if (element.getAttribute('data-pym-'+attribute) !== null) {
                  switch (settings[attribute]) {
                    case 'boolean':
                       config[attribute] = !(element.getAttribute('data-pym-'+attribute) === 'false'); // jshint ignore:line
                       break;
                    case 'string':
                       config[attribute] = element.getAttribute('data-pym-'+attribute);
                       break;
                    case 'number':
                        var n = Number(element.getAttribute('data-pym-'+attribute));
                        if (!isNaN(n)) {
                            config[attribute] = n;
                        }
                        break;
                    default:
                       console.err('unrecognized attribute type');
                  }
               }
            }

            // Store references to autoinitialized pym instances
            var parent = new lib.Parent(element.id, src, config);
            lib.autoInitInstances.push(parent);
        }

        // Fire customEvent
        if (!doNotRaiseEvents) {
            _raiseCustomEvent("pym-initialized");
        }
        // Return stored autoinitalized pym instances
        return lib.autoInitInstances;
    };

    /**
     * The Parent half of a response iframe.
     *
     * @memberof module:pym
     * @class Parent
     * @param {String} id The id of the div into which the iframe will be rendered. sets {@link module:pym.Parent~id}
     * @param {String} url The url of the iframe source. sets {@link module:pym.Parent~url}
     * @param {Object} [config] Configuration for the parent instance. sets {@link module:pym.Parent~settings}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {string} [config.title] - if passed it will be assigned to the iframe title attribute
     * @param {string} [config.name] - if passed it will be assigned to the iframe name attribute
     * @param {string} [config.id] - if passed it will be assigned to the iframe id attribute
     * @param {boolean} [config.allowfullscreen] - if passed and different than false it will be assigned to the iframe allowfullscreen attribute
     * @param {string} [config.sandbox] - if passed it will be assigned to the iframe sandbox attribute (we do not validate the syntax so be careful!!)
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name passed to the iframe src
     * @param {string} [config.parenturlvalue] - if passed it will be override the default parentUrl query string parameter value passed to the iframe src
     * @param {string} [config.optionalparams] - if passed and different than false it will strip the querystring params parentUrl and parentTitle passed to the iframe src
     * @param {boolean} [config.trackscroll] - if passed it will activate scroll tracking on the parent
     * @param {number} [config.scrollwait] - if passed it will set the throttle wait in order to fire scroll messaging. Defaults to 100 ms.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe iFrame}
     */
    lib.Parent = function(id, url, config) {
        /**
         * The id of the container element
         *
         * @memberof module:pym.Parent
         * @member {string} id
         * @inner
         */
        this.id = id;
        /**
         * The url that will be set as the iframe's src
         *
         * @memberof module:pym.Parent
         * @member {String} url
         * @inner
         */
        this.url = url;

        /**
         * The container DOM object
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} el
         * @inner
         */
        this.el = document.getElementById(id);
        /**
         * The contained child iframe
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} iframe
         * @inner
         * @default null
         */
        this.iframe = null;
        /**
         * The parent instance settings, updated by the values passed in the config object
         *
         * @memberof module:pym.Parent
         * @member {Object} settings
         * @inner
         */
        this.settings = {
            xdomain: '*',
            optionalparams: true,
            parenturlparam: 'parentUrl',
            parenturlvalue: window.location.href,
            trackscroll: false,
            scrollwait: 100,
        };
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Parent
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = _makeMessageRegex(this.id);
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Parent
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // ensure a config object
        config = (config || {});

        /**
         * Construct the iframe.
         *
         * @memberof module:pym.Parent
         * @method _constructIframe
         * @inner
         */
        this._constructIframe = function() {
            // Calculate the width of this element.
            var width = this.el.offsetWidth.toString();

            // Create an iframe element attached to the document.
            this.iframe = document.createElement('iframe');

            // Save fragment id
            var hash = '';
            var hashIndex = this.url.indexOf('#');

            if (hashIndex > -1) {
                hash = this.url.substring(hashIndex, this.url.length);
                this.url = this.url.substring(0, hashIndex);
            }

            // If the URL contains querystring bits, use them.
            // Otherwise, just create a set of valid params.
            if (this.url.indexOf('?') < 0) {
                this.url += '?';
            } else {
                this.url += '&';
            }

            // Append the initial width as a querystring parameter
            // and optional params if configured to do so
            this.iframe.src = this.url + 'initialWidth=' + width +
                                         '&childId=' + this.id;

            if (this.settings.optionalparams) {
                this.iframe.src += '&parentTitle=' + encodeURIComponent(document.title);
                this.iframe.src += '&'+ this.settings.parenturlparam + '=' + encodeURIComponent(this.settings.parenturlvalue);
            }
            this.iframe.src +=hash;

            // Set some attributes to this proto-iframe.
            this.iframe.setAttribute('width', '100%');
            this.iframe.setAttribute('scrolling', 'no');
            this.iframe.setAttribute('marginheight', '0');
            this.iframe.setAttribute('frameborder', '0');

            if (this.settings.title) {
                this.iframe.setAttribute('title', this.settings.title);
            }

            if (this.settings.allowfullscreen !== undefined && this.settings.allowfullscreen !== false) {
                this.iframe.setAttribute('allowfullscreen','');
            }

            if (this.settings.sandbox !== undefined && typeof this.settings.sandbox === 'string') {
                this.iframe.setAttribute('sandbox', this.settings.sandbox);
            }

            if (this.settings.id) {
                if (!document.getElementById(this.settings.id)) {
                    this.iframe.setAttribute('id', this.settings.id);
                }
            }

            if (this.settings.name) {
                this.iframe.setAttribute('name', this.settings.name);
            }

            // Replace the child content if needed
            // (some CMSs might strip out empty elements)
            while(this.el.firstChild) { this.el.removeChild(this.el.firstChild); }
            // Append the iframe to our element.
            this.el.appendChild(this.iframe);

            // Add an event listener that will handle redrawing the child on resize.
            window.addEventListener('resize', this._onResize);

            // Add an event listener that will send the child the viewport.
            if (this.settings.trackscroll) {
                window.addEventListener('scroll', this._throttleOnScroll);
            }
        };

        /**
         * Send width on resize.
         *
         * @memberof module:pym.Parent
         * @method _onResize
         * @inner
         */
        this._onResize = function() {
            this.sendWidth();
            if (this.settings.trackscroll) {
                this.sendViewportAndIFramePosition();
            }
        }.bind(this);

        /**
         * Send viewport and iframe info on scroll.
         *
         * @memberof module:pym.Parent
         * @method _onScroll
         * @inner
         */
        this._onScroll = function() {
            this.sendViewportAndIFramePosition();
        }.bind(this);

        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Parent
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Remove this parent from the page and unbind it's event handlers.
         *
         * @memberof module:pym.Parent
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            window.removeEventListener('resize', this._onResize);

            this.el.removeChild(this.iframe);
            // _cleanAutoInitInstances in case this parent was autoInitialized
            _cleanAutoInitInstances();
        };

        /**
         * Process a new message from the child.
         *
         * @memberof module:pym.Parent
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Grab the message from the child and parse it.
            var match = e.data.match(this.messageRegex);

            // If there's no match or too many matches in the message, punt.
            if (!match || match.length !== 3) {
                return false;
            }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new height message from child.
         *
         * @memberof module:pym.Parent
         * @method _onHeightMessage
         * @inner
         *
         * @param {String} message The new height.
         */
        this._onHeightMessage = function(message) {
            /*
             * Handle parent height message from child.
             */
            var height = parseInt(message);

            this.iframe.setAttribute('height', height + 'px');
        };

        /**
         * Navigate parent to a new url.
         *
         * @memberof module:pym.Parent
         * @method _onNavigateToMessage
         * @inner
         *
         * @param {String} message The url to navigate to.
         */
        this._onNavigateToMessage = function(message) {
            /*
             * Handle parent scroll message from child.
             */
             if (!_isSafeUrl(message)) {return;}
            document.location.href = message;
        };

        /**
         * Scroll parent to a given child position.
         *
         * @memberof module:pym.Parent
         * @method _onScrollToChildPosMessage
         * @inner
         *
         * @param {String} message The offset inside the child page.
         */
        this._onScrollToChildPosMessage = function(message) {
            // Get the child container position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var iframePos = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset;

            var totalOffset = iframePos + parseInt(message);
            window.scrollTo(0, totalOffset);
        };

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "height", "scrollTo" and "navigateTo".
         *
         * @memberof module:pym.Parent
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Parent~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {
            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Parent~onMessageCallback
         * @param {String} message The message data.
         */

        /**
         * Send a message to the the child.
         *
         * @memberof module:pym.Parent
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            // When used alongside with pjax some references are lost
            if (this.el.getElementsByTagName('iframe').length) {
                if (this.el.getElementsByTagName('iframe')[0].contentWindow) {
                    this.el.getElementsByTagName('iframe')[0].contentWindow
                        .postMessage(_makeMessage(this.id, messageType, message), '*');
                }
                else {
                    // Contentless child detected remove listeners and iframe
                    this.remove();
                }
            }
        };

        /**
         * Transmit the current iframe width to the child.
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendWidth
         * @instance
         */
        this.sendWidth = function() {
            var width = this.el.offsetWidth.toString();
            this.sendMessage('width', width);
        };

        /**
         * Transmit the current viewport and iframe position to the child.
         * Sends viewport width, viewport height
         * and iframe bounding rect top-left-bottom-right
         * all separated by spaces
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendViewportAndIFramePosition
         * @instance
         */
        this.sendViewportAndIFramePosition = function() {
            var iframeRect = this.iframe.getBoundingClientRect();
            var vWidth   = window.innerWidth || document.documentElement.clientWidth;
            var vHeight  = window.innerHeight || document.documentElement.clientHeight;
            var payload = vWidth + ' ' + vHeight;
            payload += ' ' + iframeRect.top + ' ' + iframeRect.left;
            payload += ' ' + iframeRect.bottom + ' ' + iframeRect.right;
            this.sendMessage('viewport-iframe-position', payload);
        };

        // Add any overrides to settings coming from config.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        /**
         * Throttled scroll function.
         *
         * @memberof module:pym.Parent
         * @method _throttleOnScroll
         * @inner
         */
        this._throttleOnScroll = _throttle(this._onScroll.bind(this), this.settings.scrollwait);

        // Bind required message handlers
        this.onMessage('height', this._onHeightMessage);
        this.onMessage('navigateTo', this._onNavigateToMessage);
        this.onMessage('scrollToChildPos', this._onScrollToChildPosMessage);
        this.onMessage('parentPositionInfo', this.sendViewportAndIFramePosition);

        // Add a listener for processing messages from the child.
        window.addEventListener('message', this._processMessage, false);

        // Construct the iframe in the container element.
        this._constructIframe();

        return this;
    };

    /**
     * The Child half of a responsive iframe.
     *
     * @memberof module:pym
     * @class Child
     * @param {Object} [config] Configuration for the child instance. sets {@link module:pym.Child~settings}
     * @param {function} [config.renderCallback=null] Callback invoked after receiving a resize event from the parent, sets {@link module:pym.Child#settings.renderCallback}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {number} [config.polling=0] - polling frequency in milliseconds to send height to parent
     * @param {number} [config.id] - parent container id used when navigating the child iframe to a new page but we want to keep it responsive.
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name expected on the iframe src
     */
    lib.Child = function(config) {
        /**
         * The initial width of the parent page
         *
         * @memberof module:pym.Child
         * @member {string} parentWidth
         * @inner
         */
        this.parentWidth = null;
        /**
         * The id of the parent container
         *
         * @memberof module:pym.Child
         * @member {String} id
         * @inner
         */
        this.id = null;
        /**
         * The title of the parent page from document.title.
         *
         * @memberof module:pym.Child
         * @member {String} parentTitle
         * @inner
         */
        this.parentTitle = null;
        /**
         * The URL of the parent page from window.location.href.
         *
         * @memberof module:pym.Child
         * @member {String} parentUrl
         * @inner
         */
        this.parentUrl = null;
        /**
         * The settings for the child instance. Can be overriden by passing a config object to the child constructor
         * i.e.: var pymChild = new pym.Child({renderCallback: render, xdomain: "\\*\.npr\.org"})
         *
         * @memberof module:pym.Child.settings
         * @member {Object} settings - default settings for the child instance
         * @inner
         */
        this.settings = {
            renderCallback: null,
            xdomain: '*',
            polling: 0,
            parenturlparam: 'parentUrl'
        };

        /**
         * The timerId in order to be able to stop when polling is enabled
         *
         * @memberof module:pym.Child
         * @member {String} timerId
         * @inner
         */
        this.timerId = null;
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Child
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = null;
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Child
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // Ensure a config object
        config = (config || {});

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "width".
         *
         * @memberof module:pym.Child
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Child~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {

            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Child~onMessageCallback
         * @param {String} message The message data.
         */


        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Child
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            /*
             * Fire all event handlers for a given message type.
             */
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Process a new message from the parent.
         *
         * @memberof module:pym.Child
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            /*
            * Process a new message from parent frame.
            */
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Get the message from the parent.
            var match = e.data.match(this.messageRegex);

            // If there's no match or it's a bad format, punt.
            if (!match || match.length !== 3) { return; }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new width message from parent.
         *
         * @memberof module:pym.Child
         * @method _onWidthMessage
         * @inner
         *
         * @param {String} message The new width.
         */
        this._onWidthMessage = function(message) {
            /*
             * Handle width message from the child.
             */
            var width = parseInt(message);

            // Change the width if it's different.
            if (width !== this.parentWidth) {
                this.parentWidth = width;

                // Call the callback function if it exists.
                if (this.settings.renderCallback) {
                    this.settings.renderCallback(width);
                }

                // Send the height back to the parent.
                this.sendHeight();
            }
        };

        /**
         * Send a message to the the Parent.
         *
         * @memberof module:pym.Child
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            /*
             * Send a message to the parent.
             */
            window.parent.postMessage(_makeMessage(this.id, messageType, message), '*');
        };

        /**
         * Transmit the current iframe height to the parent.
         *
         * Call this directly in cases where you manually alter the height of the iframe contents.
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.sendHeight = function() {
            // Get the child's height.
            var height = document.getElementsByTagName('body')[0].offsetHeight.toString();

            // Send the height to the parent.
            this.sendMessage('height', height);

            return height;
        }.bind(this);

        /**
         * Ask parent to send the current viewport and iframe position information
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.getParentPositionInfo = function() {
            // Send the height to the parent.
            this.sendMessage('parentPositionInfo');
        };

        /**
         * Scroll parent to a given element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentTo
         * @instance
         *
         * @param {String} hash The id of the element to scroll to.
         */
        this.scrollParentTo = function(hash) {
            this.sendMessage('navigateTo', '#' + hash);
        };

        /**
         * Navigate parent to a given url.
         *
         * @memberof module:pym.Child
         * @method navigateParentTo
         * @instance
         *
         * @param {String} url The url to navigate to.
         */
        this.navigateParentTo = function(url) {
            this.sendMessage('navigateTo', url);
        };

        /**
         * Scroll parent to a given child element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildEl
         * @instance
         *
         * @param {String} id The id of the child element to scroll to.
         */
        this.scrollParentToChildEl = function(id) {
            // Get the child element position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var topPos = document.getElementById(id).getBoundingClientRect().top + window.pageYOffset;
            this.scrollParentToChildPos(topPos);
        };

        /**
         * Scroll parent to a particular child offset.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildPos
         * @instance
         *
         * @param {Number} pos The offset of the child element to scroll to.
         */
        this.scrollParentToChildPos = function(pos) {
            this.sendMessage('scrollToChildPos', pos.toString());
        };

        /**
         * Mark Whether the child is embedded or not
         * executes a callback in case it was passed to the config
         *
         * @memberof module:pym.Child
         * @method _markWhetherEmbedded
         * @inner
         *
         * @param {module:pym.Child~onMarkedEmbeddedStatus} The callback to execute after determining whether embedded or not.
         */
        var _markWhetherEmbedded = function(onMarkedEmbeddedStatus) {
          var htmlElement = document.getElementsByTagName('html')[0],
              newClassForHtml,
              originalHtmlClasses = htmlElement.className;
          try {
            if(window.self !== window.top) {
              newClassForHtml = "embedded";
            }else{
              newClassForHtml = "not-embedded";
            }
          }catch(e) {
            newClassForHtml = "embedded";
          }
          if(originalHtmlClasses.indexOf(newClassForHtml) < 0) {
            htmlElement.className = originalHtmlClasses ? originalHtmlClasses + ' ' + newClassForHtml : newClassForHtml;
            if(onMarkedEmbeddedStatus){
              onMarkedEmbeddedStatus(newClassForHtml);
            }
            _raiseCustomEvent("marked-embedded");
          }
        };

        /**
         * @callback module:pym.Child~onMarkedEmbeddedStatus
         * @param {String} classname "embedded" or "not-embedded".
         */

        /**
         * Unbind child event handlers and timers.
         *
         * @memberof module:pym.Child
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            if (this.timerId) {
                clearInterval(this.timerId);
            }
        };

        // Initialize settings with overrides.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        // Identify what ID the parent knows this child as.
        this.id = _getParameterByName('childId') || config.id;
        this.messageRegex = new RegExp('^pym' + MESSAGE_DELIMITER + this.id + MESSAGE_DELIMITER + '(\\S+)' + MESSAGE_DELIMITER + '(.*)$');

        // Get the initial width from a URL parameter.
        var width = parseInt(_getParameterByName('initialWidth'));

        // Get the url of the parent frame
        this.parentUrl = _getParameterByName(this.settings.parenturlparam);

        // Get the title of the parent frame
        this.parentTitle = _getParameterByName('parentTitle');

        // Bind the required message handlers
        this.onMessage('width', this._onWidthMessage);

        // Set up a listener to handle any incoming messages.
        window.addEventListener('message', this._processMessage, false);

        // If there's a callback function, call it.
        if (this.settings.renderCallback) {
            this.settings.renderCallback(width);
        }

        // Send the initial height to the parent.
        this.sendHeight();

        // If we're configured to poll, create a setInterval to handle that.
        if (this.settings.polling) {
            this.timerId = window.setInterval(this.sendHeight, this.settings.polling);
        }

        _markWhetherEmbedded(config.onMarkedEmbeddedStatus);

        return this;
    };

    // Initialize elements with pym data attributes
    // if we are not in server configuration
    if(typeof document !== "undefined") {
        lib.autoInit(true);
    }

    return lib;
});



/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e15218ce.js